/*!
 * @maptalks/vt v0.124.4
 * LICENSE : undefined
 * (c) 2016-2026 maptalks.org
 */
import * as e from "maptalks";

import { Util as t, formatResourceUrl as n, Marker as i, Browser as r, MapStateCache as s, Coordinate as o, Polygon as a, MultiPolygon as l, Point as h, Circle as c, Ellipse as u, Sector as f, Rectangle as d } from "maptalks";

import * as p from "@maptalks/gl";

import { reshader as g, vec3 as m, mat4 as y, CanvasCompatible as x, GroundPainter as _, vec4 as v, HighlightUtil as b, getWGSLSource as A, vec2 as T, mat2 as w, quat as S, mat3 as M, HeatmapProcess as P } from "@maptalks/gl";

import I from "color";

import C from "fast-deep-equal";

import { isFunctionDefinition as k, interpolated as F, piecewiseConstant as O, loadFunctionTypes as R } from "@maptalks/function-type";

import E from "animation-easings";

import { createFilter as D } from "@maptalks/feature-filter";

import L from "@maptalks/vt-plugin";

import { vec2 as H, vec3 as z, vec4 as N } from "gl-matrix";

import V from "earcut";

import { buildNormals as B, buildTangents as U, packTangentFrame as G } from "@maptalks/tbn-packer";

import j from "rbush";

const W = "${", X = `function(t){let e;const n={width:100,height:10};let r=!1;try{const t=new OffscreenCanvas(1,1);t.getContext("2d").fillText("hello",0,0),r=!0}catch(t){r=!1}function i(){if(!e){const{width:t,height:i}=n;r?e=new OffscreenCanvas(t,i):(e=document.createElement("canvas"),e.width=t,e.height=i)}return e}class o{constructor(t,e={}){if(!Array.isArray(t))return void console.error("colors is not array");if(t.length<2)return void console.error("colors.length should >1");this.colors=t;let r=1/0,i=-1/0;for(let e=0,n=t.length;e<n;e++){const n=t[e][0];r=Math.min(n,r),i=Math.max(n,i)}this.min=r,this.max=i,this.valueOffset=this.max-this.min,this.options=Object.assign({},n,e),this._initImgData()}getImageData(){return this.imgData}_initImgData(){const t=i(),{width:e,height:n}=this.options;t.width=e,t.height=n;const r=t.getContext("2d");r.clearRect(0,0,t.width,t.height);const o=r.createLinearGradient(0,0,t.width,0),{colors:s,valueOffset:a}=this;for(let t=0,e=s.length;t<e;t++){const[e,n]=s[t],r=(e-this.min)/a;o.addColorStop(r,n)}r.fillStyle=o,r.fillRect(0,0,t.width,t.height),this.imgData=r.getImageData(0,0,t.width,t.height)}getColor(t){t=Math.max(this.min,t);const e=((t=Math.min(t,this.max))-this.min)/this.valueOffset;let n=Math.round(e*this.imgData.width);n=Math.min(n,this.imgData.width-1);const r=4*n;return[this.imgData.data[r],this.imgData.data[r+1],this.imgData.data[r+2],this.imgData.data[r+3]]}}var s;function a(t){return null==t}function l(t){return!a(t)}function u(t){return""===t}function h(t,e){var n,r,i;if(w(t)){var o,s=t.stops&&"object"==typeof t.stops[0][0],a=s||l(t.property),u=s||!a,d=t.type||e||"exponential";if("exponential"===d)o=p;else if("interval"===d)o=f;else if("categorical"===d)o=c;else if("identity"===d)o=y;else if("color-interpolate"===d)o=g;else{if("calculate-expression"!==d)throw new Error('Unknown function type "'+d+'"');o=x}if(s){var m={},v=[];for(let e=0;e<t.stops.length;e++){var b=t.stops[e];void 0===m[b[0].zoom]&&(m[b[0].zoom]={zoom:b[0].zoom,type:t.type,property:t.property,default:t.default,stops:[]}),m[b[0].zoom].stops.push([b[0].value,b[1]])}for(let t in m)v.push([m[t].zoom,h(m[t])]);n=function(e,n){const r=p({stops:v,base:t.base},e)(e,n);return"function"==typeof r?r(e,n):r},r=!1,i=!1}else u?(n=function(e){const n=o(t,e);return"function"==typeof n?n(e):n},r=!0,i=!1):(n=function(e,n){const r=o(t,n?n[t.property]:null);return"function"==typeof r?r(e,n):r},r=!1,i=!0)}else n=function(){return t},r=!0,i=!0;return n.isZoomConstant=i,n.isFeatureConstant=r,n}function c(t,e){for(let n=0;n<t.stops.length;n++)if(e===t.stops[n][0])return t.stops[n][1];return t.default}function f(t,e){for(var n=0;n<t.stops.length&&!(e<t.stops[n][0]);n++);return t.stops[Math.max(n-1,0)][1]}function p(t,e){for(var n=l(t.base)&&!u(t.base)?t.base:1,r=0;!(r>=t.stops.length||e<=t.stops[r][0]);)r++;return 0===r?t.stops[r][1]:r===t.stops.length?t.stops[r-1][1]:m(e,n,t.stops[r-1][0],t.stops[r][0],t.stops[r-1][1],t.stops[r][1])}"function"==typeof Map&&(s=new Map);const d={width:100,height:1};function g(t,e){const n=t.stops;if(n&&n.length>1){let t;if(s){const e=JSON.stringify(n);if(!s.has(e)){const t=new o(n,d);s.set(e,t)}t=s.get(e)}else t=new o(n,d);const[r,i,a,l]=t.getColor(e);return[r/255,i/255,a/255,l/255]}return n&&1===n.length?n[0][1]:null}function y(t,e){return n=e,r=t.default,l(n)?n:l(r)?r:l(i)?i:null;var n,r,i}function x(t,e){const n=String(t.property),r=t.expression,i=e;function o(e){return a(e)||u(e)||isNaN(e)?t.default:e}if(!l(e)||u(e)||isNaN(e)||e<0)return o(t.default);{const e=function t(e,n,r){const i=Number(r),o=String(n);return Array.isArray(e)?e.map((e=>t(e,o,i))):e===o?i:e}(r,n,i);return o(function e(n){if(!Array.isArray(n)){if("number"==typeof n)return n;throw new Error("Invalid expression format")}{const r=n[0];if(!["+","-","*","/"].includes(r))throw new Error(\`Unknown operator: ${W}r}\`);const i=n.slice(1).map((t=>e(t)));switch(r){case"+":return i.reduce(((t,e)=>t+e),0);case"-":return i.reduce(((t,e)=>t-e));case"*":return i.reduce(((t,e)=>t*e),1);case"/":return i.some((t=>0===t))?t.default:i.reduce(((t,e)=>t/e));default:throw new Error(\`Unsupported operator: ${W}r}\`)}}}(e))}}function m(t,e,n,r,i,o){return"function"==typeof i?function(){var s=i.apply(void 0,arguments),a=o.apply(void 0,arguments);return m(t,e,n,r,s,a)}:i.length?function(t,e,n,r,i,o){var s=[];for(let a=0;a<i.length;a++)s[a]=v(t,e,n,r,i[a],o[a]);return s}(t,e,n,r,i,o):v(t,e,n,r,i,o)}function v(t,e,n,r,i,o){var s,a=r-n,l=t-n;return i*(1-(s=1===e?l/a:(Math.pow(e,l)-1)/(Math.pow(e,a)-1)))+o*s}function w(t){return t&&"object"==typeof t&&(t.stops||t.property&&"identity"===t.type||t.expression&&"calculate-expression"===t.type)}function b(t){return M(t,"interval")}function M(t,e){if(!w(t))return function(){return t};let n=!0,r=!0;const i=(t=JSON.parse(JSON.stringify(t))).stops;if(i)for(let t=0;t<i.length;t++)if(w(i[t][1])){const o=M(i[t][1],e);n=n&&o.isZoomConstant,r=r&&o.isFeatureConstant,i[t]=[i[t][0],o]}const o=h(t,e);return o.isZoomConstant=n&&o.isZoomConstant,o.isFeatureConstant=r&&o.isFeatureConstant,o}let P=0;const _="function"==typeof Object.assign;function A(t,...e){if(_)return Object.assign(t,...e),t;for(let n=0;n<e.length;n++){const r=e[n];for(const e in r)t[e]=r[e]}return t}function I(t){return!k(t)&&("string"==typeof t||null!==t.constructor&&t.constructor===String)}function S(t){return"number"==typeof t&&!isNaN(t)}function T(t){return!k(t)&&("function"==typeof t||null!==t.constructor&&t.constructor===Function)}function F(t){return!Array.isArray(t)&&"object"==typeof t&&!!t}function k(t){return null==t}function L(t){return w(t)&&t.property}const C=new TextEncoder;new TextDecoder;const B="function"==typeof fetch&&"function"==typeof AbortController,O={jsonp:function(t,e){const n="_maptalks_jsonp_"+P++;t.match(/\\?/)?t+="&callback="+n:t+="?callback="+n;let r=document.createElement("script");return r.type="text/javascript",r.src=t,window[n]=function(t){e(null,t),document.getElementsByTagName("head")[0].removeChild(r),r=null,delete window[n]},document.getElementsByTagName("head")[0].appendChild(r),this},get:function(t,e,n){if(T(e)){const t=n;n=e,e=t}let r=(e=e||{}).errorLog;k(r)&&(r=!0),e.method&&(e.method=e.method.toUpperCase());const i="POST"===e.method;if(B){const i=new AbortController,o=e;o.signal=i.signal,o.referrerPolicy=o.referrerPolicy||"origin",o.method=o.method||"GET";const s=new Request(t,o);return e.returnJSON&&s.headers.set("Accept","application/json"),fetch(s).then((i=>{const o=this._parseResponse(i,e.returnJSON,e.responseType);o.message?(o.url=t,n(o)):o.then((t=>{"arraybuffer"===e.responseType?n(null,{data:t,cacheControl:i.headers.get("Cache-Control"),expires:i.headers.get("Expires"),contentType:i.headers.get("Content-Type")}):n(null,t)})).catch((e=>{e.code&&e.code===DOMException.ABORT_ERR||(r&&console.error("Fetch error:",t,e),n(e))}))})).catch((e=>{e.code&&e.code===DOMException.ABORT_ERR||(r&&console.error("Fetch error:",t,e),n(e))})),i}{const r=O._getClient(n);if(r.open(e.method||"GET",t,!0),e){for(const t in e.headers)r.setRequestHeader(t,e.headers[t]);r.withCredentials="include"===e.credentials,e.responseType&&(r.responseType=e.responseType)}return r.send(i?e.body:null),r}},_parseResponse:(t,e,n)=>200!==t.status?{status:t.status,statusText:t.statusText,message:\`incorrect http request with status code(${W}t.status}): ${W}t.statusText}\`}:"arraybuffer"===n?t.arrayBuffer():e?t.json():t.text(),_wrapCallback:function(t,e){return function(){if(4===t.readyState)if(200===t.status)if("arraybuffer"===t.responseType){0===t.response.byteLength?e({status:200,statusText:t.statusText,message:"http status 200 returned without content."}):e(null,{data:t.response,cacheControl:t.getResponseHeader("Cache-Control"),expires:t.getResponseHeader("Expires"),contentType:t.getResponseHeader("Content-Type")})}else e(null,t.responseText);else e({status:t.status,statusText:t.statusText,message:\`incorrect http request with status code(${W}t.status}): ${W}t.statusText}\`})}},_getClient:function(t){let e;try{e=new XMLHttpRequest}catch(t){try{e=new ActiveXObject("Msxml2.XMLHTTP")}catch(t){try{e=new ActiveXObject("Microsoft.XMLHTTP")}catch(t){}}}return e.onreadystatechange=O._wrapCallback(e,t),e},getArrayBuffer(t,e,n){if(T(e)){const t=n;n=e,e=t}return e||(e={}),e.responseType="arraybuffer",O.get(t,e,n)}};function Y(t,e,n,r,i=3){let o=r;const s=n-e>>1;let a,l=n-e;const u=t[e],h=t[e+1],c=t[n],f=t[n+1];for(let r=e+i;r<n;r+=i){const e=V(t[r],t[r+1],u,h,c,f);if(e>o)a=r,o=e;else if(e===o){const t=Math.abs(r-s);t<l&&(a=r,l=t)}}o>r&&(a-e>i&&Y(t,e,a,r,i),t[a+2]=o,n-a>i&&Y(t,a,n,r,i))}function V(t,e,n,r,i,o){let s=i-n,a=o-r;if(0!==s||0!==a){const l=((t-n)*s+(e-r)*a)/(s*s+a*a);l>1?(n=i,r=o):l>0&&(n+=s*l,r+=a*l)}return s=t-n,a=e-r,s*s+a*a}function X(t,e,n,r,i,o){const s={id:null==t?null:t,type:e,geometry:n,tags:r,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0};i&&(s.layer=i);return function(t,e){const n=t.geometry,r=t.type;if("Point"===r||"MultiPoint"===r||"LineString"===r)N(t,n,e);else if("Polygon"===r)N(t,n[0],e);else if("MultiLineString"===r)for(const r of n)N(t,r,e);else if("MultiPolygon"===r)for(const r of n)N(t,r[0],e)}(s,o?4:3),s}function N(t,e,n){for(let r=0;r<e.length;r+=n)t.minX=Math.min(t.minX,e[r]),t.minY=Math.min(t.minY,e[r+1]),t.maxX=Math.max(t.maxX,e[r]),t.maxY=Math.max(t.maxY,e[r+1])}function E(t,e,n,r){if(r.layer=e,"FeatureCollection"===n.type)for(let e=0;e<n.features.length;e++)z(t,n.features[e],r,e);else"Feature"===n.type?z(t,n,r):z(t,{geometry:n},r)}function z(t,e,n,r){if(!e.geometry)return;const i=e.geometry.coordinates,o=e.geometry.type,s=Math.pow(n.tolerance/((1<<n.maxZoom)*n.extent),2);let a=[],l=e.id;if(n.promoteId?l=e.properties[n.promoteId]:n.generateId&&(l=r||0),"Point"===o)D(i,a,n);else if("MultiPoint"===o)for(const t of i)D(t,a,n);else if("LineString"===o)$(i,a,s,!1,n);else if("MultiLineString"===o){if(n.lineMetrics){for(const r of i)a=[],$(r,a,s,!1,n),t.push(X(l,"LineString",a,e.properties,n.layer,n.hasAltitude));return}q(i,a,s,!1,n)}else if("Polygon"===o)q(i,a,s,!0,n);else{if("MultiPolygon"!==o){if("GeometryCollection"===o){for(const i of e.geometry.geometries)z(t,{id:l,geometry:i,properties:e.properties},n,r);return}throw new Error("Input data is not a valid GeoJSON object.")}for(const t of i){const e=[];q(t,e,s,!0,n),a.push(e)}}t.push(X(l,o,a,e.properties,n.layer,n.hasAltitude))}function D(t,e,n){e.push(G(t[0]),j(t[1],n.projection),0),n.hasAltitude&&(t.length>2?e.push(t[2]):e.push(0))}function $(t,e,n,r,i){let o,s,a=0;for(let n=0;n<t.length;n++){const l=G(t[n][0]),u=j(t[n][1],i.projection);e.push(l,u,0),i.hasAltitude&&(t[n].length>2?e.push(t[n][2]):e.push(0)),n>0&&(a+=r?(o*u-l*s)/2:Math.sqrt(Math.pow(l-o,2)+Math.pow(u-s,2))),o=l,s=u}const l=i.hasAltitude?4:3,u=e.length-l;e[2]=1,Y(e,0,u,n,l),e[u+2]=1,e.size=Math.abs(a),e.start=0,e.end=e.size}function q(t,e,n,r,i){for(let o=0;o<t.length;o++){const s=[];$(t[o],s,n,r,i),e.push(s)}}function G(t){return t/360+.5}function j(t,e){if("EPSG:4326"===e)return(90-t)/360;const n=Math.sin(t*Math.PI/180),r=.5-.25*Math.log((1+n)/(1-n))/Math.PI;return r<0?0:r>1?1:r}function U(t,e,n,r,i,o,s,a){if(r/=e,o>=(n/=e)&&s<r)return t;if(s<n||o>=r)return null;const l=[];for(const e of t){const t=e.geometry;let o=e.type;const s=0===i?e.minX:e.minY,u=0===i?e.maxX:e.maxY;if(s>=n&&u<r){l.push(e);continue}if(u<n||s>=r)continue;let h=[];if("Point"===o||"MultiPoint"===o)Z(t,h,n,r,i,a.hasAltitude);else if("LineString"===o)R(t,h,n,r,i,!1,a.lineMetrics,a.hasAltitude);else if("MultiLineString"===o)H(t,h,n,r,i,!1,a.hasAltitude);else if("Polygon"===o)H(t,h,n,r,i,!0,a.hasAltitude);else if("MultiPolygon"===o)for(const e of t){const t=[];H(e,t,n,r,i,!0,a.hasAltitude),t.length&&h.push(t)}if(h.length){if(a.lineMetrics&&"LineString"===o){for(const t of h)l.push(X(e.id,o,t,e.tags,e.layer,a.hasAltitude));continue}"LineString"!==o&&"MultiLineString"!==o||(1===h.length?(o="LineString",h=h[0]):o="MultiLineString"),"Point"!==o&&"MultiPoint"!==o||(o=3===h.length?"Point":"MultiPoint"),l.push(X(e.id,o,h,e.tags,e.layer,a.hasAltitude))}}return l.length?l:null}function Z(t,e,n,r,i,o){const s=o?4:3;for(let a=0;a<t.length;a+=s){const s=t[a+i];s>=n&&s<=r&&(W(e,t[a],t[a+1],t[a+2]),o&&e.push(t[a+3]))}}function R(t,e,n,r,i,o,s,a){let l=J(t);const u=0===i?K:Q;let h,c,f=t.start;const p=a?4:3,d=o?t.length:t.length-p;for(let g=0;g<d;g+=p){const y=t[g],x=t[g+1],m=t[g+2];let v,w,b,M;o&&g===d-p?(v=t[0],w=t[1]):(v=t[g+p],w=t[g+p+1]),a&&(b=t[g+3],M=o&&g===d-p?t[3]:t[g+p+3]);const P=0===i?y:x,_=0===i?v:w;let A=!1;s&&(h=Math.sqrt(Math.pow(y-v,2)+Math.pow(x-w,2))),P<n?_>n&&(c=u(l,y,x,v,w,n),a&&l.push(tt(b,M,c)),s&&(l.start=f+h*c)):P>r?_<r&&(c=u(l,y,x,v,w,r),a&&l.push(tt(b,M,c)),s&&(l.start=f+h*c)):(W(l,y,x,m),a&&l.push(b)),_<n&&P>=n&&(c=u(l,y,x,v,w,n),a&&l.push(tt(b,M,c)),A=!0),_>r&&P<=r&&(c=u(l,y,x,v,w,r),a&&l.push(tt(b,M,c)),A=!0),!o&&A&&(s&&(l.end=f+h*c),e.push(l),l=J(t)),s&&(f+=h)}let g=t.length-p;if(!o){const e=t[g],o=t[g+1],s=t[g+2],u=0===i?e:o;if(u>=n&&u<=r&&W(l,e,o,s),u>=n&&u<=r&&a){const e=t[g+3];l.push(e)}}g=l.length-p,o&&g>=p&&(l[g]!==l[0]||l[g+1]!==l[1])&&(W(l,l[0],l[1],l[2]),a&&l.push(l[3])),l.length&&e.push(l)}function J(t){const e=[];return e.size=t.size,e.start=t.start,e.end=t.end,e}function H(t,e,n,r,i,o,s){for(const a of t)R(a,e,n,r,i,o,!1,s)}function W(t,e,n,r){t.push(e,n,r)}function K(t,e,n,r,i,o){const s=(o-e)/(r-e);return W(t,o,n+(i-n)*s,1),s}function Q(t,e,n,r,i,o){const s=(o-n)/(i-n);return W(t,e+(r-e)*s,o,1),s}function tt(t,e,n){return t+(e-t)*n}function et(t,e,n){const r=[];for(let i=0;i<t.length;i++){const o=t[i],s=o.type;let a;if("Point"===s||"MultiPoint"===s||"LineString"===s)a=nt(o.geometry,e,n);else if("MultiLineString"===s||"Polygon"===s){a=[];for(const t of o.geometry)a.push(nt(t,e,n))}else if("MultiPolygon"===s){a=[];for(const t of o.geometry){const r=[];for(const i of t)r.push(nt(i,e,n));a.push(r)}}r.push(X(o.id,s,a,o.tags,o.layer,n))}return r}function nt(t,e,n){const r=[];r.size=t.size,void 0!==t.start&&(r.start=t.start,r.end=t.end);const i=n?4:3;for(let o=0;o<t.length;o+=i)r.push(t[o]+e,t[o+1],t[o+2]),n&&r.push(t[o+3]);return r}function rt(t,e,n){if(t.transformed)return t;const r=1<<t.z,i=t.x,o=t.y,s=n?3:2;for(const a of t.features){const t=a.geometry,l=a.type;if(a.geometry=[],1===l)for(let l=0;l<t.length;l+=s)a.geometry.push(it(t[l],t[l+1],e,r,i,o)),n&&a.geometry[a.geometry.length-1].push(t[l+2]);else for(let l=0;l<t.length;l++){const u=[];for(let a=0;a<t[l].length;a+=s)u.push(it(t[l][a],t[l][a+1],e,r,i,o)),n&&u[u.length-1].push(t[l][a+2]);a.geometry.push(u)}}return t.transformed=!0,t}function it(t,e,n,r,i,o){return[Math.round(n*(t*r-i)),Math.round(n*(e*r-o))]}function ot(t,e,n,r,i){const o=e===i.maxZoom?0:i.tolerance/((1<<e)*i.extent),s={features:[],numPoints:0,numSimplified:0,numFeatures:t.length,source:null,x:n,y:r,z:e,transformed:!1,minX:2,minY:1,maxX:-1,maxY:0};for(const e of t)st(s,e,o,i);return s}function st(t,e,n,r){const i=e.geometry,o=e.type,s=[],a=r.hasAltitude?4:3;if(t.minX=Math.min(t.minX,e.minX),t.minY=Math.min(t.minY,e.minY),t.maxX=Math.max(t.maxX,e.maxX),t.maxY=Math.max(t.maxY,e.maxY),"Point"===o||"MultiPoint"===o)for(let e=0;e<i.length;e+=a)s.push(i[e],i[e+1]),r.hasAltitude&&s.push(i[e+3]),t.numPoints++,t.numSimplified++;else if("LineString"===o)lt(s,i,t,n,!1,!1,r);else if("MultiLineString"===o||"Polygon"===o)for(let e=0;e<i.length;e++)lt(s,i[e],t,n,"Polygon"===o,0===e,r);else if("MultiPolygon"===o)for(let e=0;e<i.length;e++){const o=i[e];for(let e=0;e<o.length;e++)lt(s,o[e],t,n,!0,0===e,r)}if(s.length){let n=e.tags||null;if("LineString"===o&&r.lineMetrics){n={};for(const t in e.tags)n[t]=e.tags[t];n.mapbox_clip_start=i.start/i.size,n.mapbox_clip_end=i.end/i.size}const a={geometry:s,type:"Polygon"===o||"MultiPolygon"===o?3:"LineString"===o||"MultiLineString"===o?2:1,tags:n};e.layer&&(a.layer=e.layer),null!==e.id&&(a.id=e.id),t.features.push(a)}}function at(t,e,n){return 0===t[e+2]&&t[e+3]>0&&n}function lt(t,e,n,r,i,o,s){const a=r*r,{hasAltitude:l,disableFilter:u}=s,h=l?4:3;if(!u&&r>0&&e.size<(i?a:r))return void(n.numPoints+=e.length/h);const c=[];for(let t=0;t<e.length;t+=h)(0===r||e[t+2]>a||at(e,t,l))&&(n.numSimplified++,c.push(e[t],e[t+1]),l&&c.push(e[t+3])),n.numPoints++;i&&function(t,e,n){const r=n?3:2;let i=0;for(let e=0,n=t.length,o=n-r;e<n;o=e,e+=r)i+=(t[e]-t[o])*(t[e+1]+t[o+1]);if(i>0===e){const e=r,i=r-1,o=r-2;for(let s=0,a=t.length;s<a/2;s+=r){const r=t[s],l=t[s+1];let u;n&&(u=t[s+2]),t[s]=t[a-e-s],t[s+1]=t[a-i-s],n&&(t[s+2]=t[a-o-s]),t[a-e-s]=r,t[a-i-s]=l,n&&(t[a-o-s]=u)}}}(c,o,l),t.push(c)}O.getJSON=function(t,e,n){if(T(e)){const t=n;n=e,e=t}const r=function(t,e){const r="string"==typeof e?JSON.parse(e):e||null;n(t,r)};return e&&e.jsonp?O.jsonp(t,r):((e=e||{}).returnJSON=!0,O.get(t,e,r))};const ut={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,tolerance:3,extent:4096,buffer:64,lineMetrics:!1,promoteId:null,generateId:!1,hasAltitude:!1,disableFilter:!1,debug:0};class ht{constructor(t,e){const n=(e=this.options=function(t,e){for(const n in e)t[n]=e[n];return t}(Object.create(ut),e)).debug;if(n&&console.time("preprocess data"),e.maxZoom<0||e.maxZoom>24)throw new Error("maxZoom should be in the 0-24 range");if(e.promoteId&&e.generateId)throw new Error("promoteId and generateId cannot be used together.");let r=function(t,e){const n=[];if(Array.isArray(t)){for(let r=0;r<t.length;r++)E(n,t[r].layer,t[r].data,e);return n}if("FeatureCollection"===t.type)for(let r=0;r<t.features.length;r++)z(n,t.features[r],e,r);else"Feature"===t.type?z(n,t,e):z(n,{geometry:t},e);return n}(t,e);this.tiles={},this.tileCoords=[],n&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",e.indexMaxZoom,e.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),r=function(t,e){const n=e.buffer/e.extent;let r=t;const i=U(t,1,-1-n,n,0,-1,2,e),o=U(t,1,1-n,2+n,0,-1,2,e);return(i||o)&&(r=U(t,1,-n,1+n,0,-1,2,e)||[],i&&(r=et(i,1,e.hasAltitude).concat(r)),o&&(r=r.concat(et(o,-1,e.hasAltitude)))),r}(r,e),r.length&&this.splitTile(r,0,0,0),n&&(r.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)))}splitTile(t,e,n,r,i,o,s){const a=[t,e,n,r],l=this.options,u=l.debug;for(;a.length;){r=a.pop(),n=a.pop(),e=a.pop(),t=a.pop();const h=1<<e,c=ct(e,n,r);let f=this.tiles[c];if(!f&&(u>1&&console.time("creation"),f=this.tiles[c]=ot(t,e,n,r,l),this.tileCoords.push({z:e,x:n,y:r}),u)){u>1&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",e,n,r,f.numFeatures,f.numPoints,f.numSimplified),console.timeEnd("creation"));const t=\`z${W}e}\`;this.stats[t]=(this.stats[t]||0)+1,this.total++}if(f.source=t,null==i){if(e===l.indexMaxZoom||f.numPoints<=l.indexMaxPoints)continue}else{if(e===l.maxZoom||e===i)continue;if(null!=i){const t=i-e;if(n!==o>>t||r!==s>>t)continue}}if(f.source=null,0===t.length)continue;u>1&&console.time("clipping");const p=.5*l.buffer/l.extent,d=.5-p,g=.5+p,y=1+p;let x=null,m=null,v=null,w=null,b=U(t,h,n-p,n+g,0,f.minX,f.maxX,l),M=U(t,h,n+d,n+y,0,f.minX,f.maxX,l);t=null,b&&(x=U(b,h,r-p,r+g,1,f.minY,f.maxY,l),m=U(b,h,r+d,r+y,1,f.minY,f.maxY,l),b=null),M&&(v=U(M,h,r-p,r+g,1,f.minY,f.maxY,l),w=U(M,h,r+d,r+y,1,f.minY,f.maxY,l),M=null),u>1&&console.timeEnd("clipping"),a.push(x||[],e+1,2*n,2*r),a.push(m||[],e+1,2*n,2*r+1),a.push(v||[],e+1,2*n+1,2*r),a.push(w||[],e+1,2*n+1,2*r+1)}}getTile(t,e,n){t=+t,e=+e,n=+n;const r=this.options,{extent:i,debug:o}=r,{hasAltitude:s,wrapX:a}=r;if(t<0||t>24)return null;if(a){const n=1<<t;e=e+n&n-1}const l=ct(t,e,n);if(this.tiles[l])return rt(this.tiles[l],i,s);o>1&&console.log("drilling down to z%d-%d-%d",t,e,n);let u,h=t,c=e,f=n;for(;!u&&h>0;)h--,c>>=1,f>>=1,u=this.tiles[ct(h,c,f)];return u&&u.source?(o>1&&(console.log("found parent tile z%d-%d-%d",h,c,f),console.time("drilling down")),this.splitTile(u.source,h,c,f,t,e,n),o>1&&console.timeEnd("drilling down"),this.tiles[l]?rt(this.tiles[l],i,s):null):null}}function ct(t,e,n){return 32*((1<<t)*n+e)+t}function ft(t,e,n,r,i,o,s){const a=n&&Array.isArray(n[0]);for(let l=0,u=n.length;l<u;l++){t[e]=(a?n[l][0]:n[l].x)*r,t[e+1]=(a?n[l][1]:n[l].y)*r,s!==Float32Array&&(t[e]=Math.round(t[e]),t[e+1]=Math.round(t[e+1]));let h=i||0;Array.isArray(i)&&(h=i[l]),h=h?Math.round(r*h):0,t[e+2]=h,e+=3,o&&0!==l&&l!==u-1&&(t[e]=t[e-3],t[e+1]=t[e-2],t[e+2]=t[e-1],e+=3)}return t.trySetLength&&t.trySetLength(e),e}function pt(t,e,n,r){const i=t[3*e],o=t[3*e+1],s=t[3*n],a=t[3*n+1];return i===s&&(i<0||i>r)||o===a&&(o<0||o>r)}var dt="undefined"!=typeof Float32Array?Float32Array:Array;function gt(t,e,n,r){return t[0]=e,t[1]=n,t[2]=r,t}function yt(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t}function xt(t,e,n,r,i){return t[0]=e,t[1]=n,t[2]=r,t[3]=i,t}function mt(t,e,n){return t[0]=e[0]/n[0],t[1]=e[1]/n[1],t[2]=e[2]/n[2],t[3]=e[3]/n[3],t}function vt(t,e,n){return t[0]=e,t[1]=n,t}function wt(t,e){var n=e[0]-t[0],r=e[1]-t[1];return Math.hypot(n,r)}Math.hypot||(Math.hypot=function(){for(var t=0,e=arguments.length;e--;)t+=arguments[e]*arguments[e];return Math.sqrt(t)}),function(){var t,e=(t=new dt(3),dt!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t)}(),function(){var t,e=(t=new dt(4),dt!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0,t[3]=0),t)}(),function(){var t,e=(t=new dt(2),dt!=Float32Array&&(t[0]=0,t[1]=0),t)}();const bt=Math.PI/180,Mt=6378137*Math.PI/180,Pt=85.0511287798;function _t(t,e,n){if("EPSG:3857"===n)return function(t,e){const n=Pt,r=e[0],i=Math.max(Math.min(n,e[1]),-n);let o;o=0===i?0:Math.log(Math.tan((90+i)*bt/2))/bt;return t[0]=r*Mt,t[1]=o*Mt,t}(t,e);if("EPSG:4326"===n||"EPSG:4490"===n||"identity"===n)return At(t,e);if("baidu"===n)return At(t,e);throw new Error("unsupported projection:"+n)}function At(t,e){return t[0]=e[0],t[1]=e[1],t}function It(t,e,n,r,i,o,s,a,l,u,h,c,f,p,d){0===t?function(t,e,n,r,i,o,s,a,l,u){const h=1/(100*o[0]),c=1/(100*o[1]),f=u&&u[0]||0,p=u&&u[1]||0,d=[0,0];for(let i=t;i<e;i+=3){const t=i/3*2,e=r[i]-f,o=r[i+1]-p;n[t]=d[0]+e/s*h/a,n[t+1]=d[1]-o/s*c/l}}(e,n,r,i,0,s,a,l,u,d):1===t&&function(t,e,n,r,i,o,s,a,l,u,h){if(!t)return;let c,f,p,d;0===t[4]?(c=t[0],f=t[1],p=t[2],d=t[3]):(c=t[1],f=t[2],p=t[3],d=t[0]);const g=wt(c,f),y=wt(f,p),x=[],m=[],v=[];for(let t=e;t<n;t+=3){const e=t/3*2;vt(x,(o.x/l+i[t]/s)*a,o.y/l*a+(h?i[t+1]:-i[t+1])/s*a),"EPSG:4326"!==u&&"EPSG:4490"!==u||_t(x,x,"EPSG:3857"),St(m,x,c,f),St(v,x,d,c),r[e]=wt(c,m)/g,r[e+1]=wt(c,v)/y}}(h,e,n,r,i,o,a,c,f,p,!!d)}function St(t,e,n,r){const i=n[0]-r[0],o=n[1]-r[1];let s=(e[0]-n[0])*(n[0]-r[0])+(e[1]-n[1])*(n[1]-r[1]);return s/=i*i+o*o,t[0]=n[0]+s*i,t[1]=n[1]+s*o,t}function Tt(t,e,n,r,i){const o=3*e[n-1],s=3*e[n-1]+1,a=t[o],l=t[s];return u=r,h=i,c=a,f=l,Math.sqrt((c-u)*(c-u)+(f-h)*(f-h));var u,h,c,f}function Ft(t,e,n=2){const r=e&&e.length,i=r?e[0]*n:t.length;let o=kt(t,0,i,n,!0);const s=[];if(!o||o.next===o.prev)return s;let a,l,u;if(r&&(o=function(t,e,n,r){const i=[];for(let n=0,o=e.length;n<o;n++){const s=kt(t,e[n]*r,n<o-1?e[n+1]*r:t.length,r,!1);s===s.next&&(s.steiner=!0),i.push(Dt(s))}i.sort(Xt);for(let t=0;t<i.length;t++)n=Nt(i[t],n);return n}(t,e,o,n)),t.length>80*n){a=1/0,l=1/0;let e=-1/0,r=-1/0;for(let o=n;o<i;o+=n){const n=t[o],i=t[o+1];n<a&&(a=n),i<l&&(l=i),n>e&&(e=n),i>r&&(r=i)}u=Math.max(e-a,r-l),u=0!==u?32767/u:0}return Ct(o,s,n,a,l,u,0),s}function kt(t,e,n,r,i){let o;if(i===function(t,e,n,r){let i=0;for(let o=e,s=n-r;o<n;o+=r)i+=(t[s]-t[o])*(t[o+1]+t[s+1]),s=o;return i}(t,e,n,r)>0)for(let i=e;i<n;i+=r)o=Kt(i/r|0,t[i],t[i+1],o);else for(let i=n-r;i>=e;i-=r)o=Kt(i/r|0,t[i],t[i+1],o);return o&&Ut(o,o.next)&&(Qt(o),o=o.next),o}function Lt(t,e){if(!t)return t;e||(e=t);let n,r=t;do{if(n=!1,r.steiner||!Ut(r,r.next)&&0!==jt(r.prev,r,r.next))r=r.next;else{if(Qt(r),r=e=r.prev,r===r.next)break;n=!0}}while(n||r!==e);return e}function Ct(t,e,n,r,i,o,s){if(!t)return;!s&&o&&function(t,e,n,r){let i=t;do{0===i.z&&(i.z=zt(i.x,i.y,e,n,r)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next}while(i!==t);i.prevZ.nextZ=null,i.prevZ=null,function(t){let e,n=1;do{let r,i=t;t=null;let o=null;for(e=0;i;){e++;let s=i,a=0;for(let t=0;t<n&&(a++,s=s.nextZ,s);t++);let l=n;for(;a>0||l>0&&s;)0!==a&&(0===l||!s||i.z<=s.z)?(r=i,i=i.nextZ,a--):(r=s,s=s.nextZ,l--),o?o.nextZ=r:t=r,r.prevZ=o,o=r;i=s}o.nextZ=null,n*=2}while(e>1)}(i)}(t,r,i,o);let a=t;for(;t.prev!==t.next;){const l=t.prev,u=t.next;if(o?Ot(t,r,i,o):Bt(t))e.push(l.i,t.i,u.i),Qt(t),t=u.next,a=u.next;else if((t=u)===a){s?1===s?Ct(t=Yt(Lt(t),e),e,n,r,i,o,2):2===s&&Vt(t,e,n,r,i,o):Ct(Lt(t),e,n,r,i,o,1);break}}}function Bt(t){const e=t.prev,n=t,r=t.next;if(jt(e,n,r)>=0)return!1;const i=e.x,o=n.x,s=r.x,a=e.y,l=n.y,u=r.y,h=Math.min(i,o,s),c=Math.min(a,l,u),f=Math.max(i,o,s),p=Math.max(a,l,u);let d=r.next;for(;d!==e;){if(d.x>=h&&d.x<=f&&d.y>=c&&d.y<=p&&qt(i,a,o,l,s,u,d.x,d.y)&&jt(d.prev,d,d.next)>=0)return!1;d=d.next}return!0}function Ot(t,e,n,r){const i=t.prev,o=t,s=t.next;if(jt(i,o,s)>=0)return!1;const a=i.x,l=o.x,u=s.x,h=i.y,c=o.y,f=s.y,p=Math.min(a,l,u),d=Math.min(h,c,f),g=Math.max(a,l,u),y=Math.max(h,c,f),x=zt(p,d,e,n,r),m=zt(g,y,e,n,r);let v=t.prevZ,w=t.nextZ;for(;v&&v.z>=x&&w&&w.z<=m;){if(v.x>=p&&v.x<=g&&v.y>=d&&v.y<=y&&v!==i&&v!==s&&qt(a,h,l,c,u,f,v.x,v.y)&&jt(v.prev,v,v.next)>=0)return!1;if(v=v.prevZ,w.x>=p&&w.x<=g&&w.y>=d&&w.y<=y&&w!==i&&w!==s&&qt(a,h,l,c,u,f,w.x,w.y)&&jt(w.prev,w,w.next)>=0)return!1;w=w.nextZ}for(;v&&v.z>=x;){if(v.x>=p&&v.x<=g&&v.y>=d&&v.y<=y&&v!==i&&v!==s&&qt(a,h,l,c,u,f,v.x,v.y)&&jt(v.prev,v,v.next)>=0)return!1;v=v.prevZ}for(;w&&w.z<=m;){if(w.x>=p&&w.x<=g&&w.y>=d&&w.y<=y&&w!==i&&w!==s&&qt(a,h,l,c,u,f,w.x,w.y)&&jt(w.prev,w,w.next)>=0)return!1;w=w.nextZ}return!0}function Yt(t,e){let n=t;do{const r=n.prev,i=n.next.next;!Ut(r,i)&&Zt(r,n,n.next,i)&&Ht(r,i)&&Ht(i,r)&&(e.push(r.i,n.i,i.i),Qt(n),Qt(n.next),n=t=i),n=n.next}while(n!==t);return Lt(n)}function Vt(t,e,n,r,i,o){let s=t;do{let t=s.next.next;for(;t!==s.prev;){if(s.i!==t.i&&Gt(s,t)){let a=Wt(s,t);return s=Lt(s,s.next),a=Lt(a,a.next),Ct(s,e,n,r,i,o,0),void Ct(a,e,n,r,i,o,0)}t=t.next}s=s.next}while(s!==t)}function Xt(t,e){let n=t.x-e.x;if(0===n&&(n=t.y-e.y,0===n)){n=(t.next.y-t.y)/(t.next.x-t.x)-(e.next.y-e.y)/(e.next.x-e.x)}return n}function Nt(t,e){const n=function(t,e){let n=e;const r=t.x,i=t.y;let o,s=-1/0;if(Ut(t,n))return n;do{if(Ut(t,n.next))return n.next;if(i<=n.y&&i>=n.next.y&&n.next.y!==n.y){const t=n.x+(i-n.y)*(n.next.x-n.x)/(n.next.y-n.y);if(t<=r&&t>s&&(s=t,o=n.x<n.next.x?n:n.next,t===r))return o}n=n.next}while(n!==e);if(!o)return null;const a=o,l=o.x,u=o.y;let h=1/0;n=o;do{if(r>=n.x&&n.x>=l&&r!==n.x&&$t(i<u?r:s,i,l,u,i<u?s:r,i,n.x,n.y)){const e=Math.abs(i-n.y)/(r-n.x);Ht(n,t)&&(e<h||e===h&&(n.x>o.x||n.x===o.x&&Et(o,n)))&&(o=n,h=e)}n=n.next}while(n!==a);return o}(t,e);if(!n)return e;const r=Wt(n,t);return Lt(r,r.next),Lt(n,n.next)}function Et(t,e){return jt(t.prev,t,e.prev)<0&&jt(e.next,t,t.next)<0}function zt(t,e,n,r,i){return(t=1431655765&((t=858993459&((t=252645135&((t=16711935&((t=(t-n)*i|0)|t<<8))|t<<4))|t<<2))|t<<1))|(e=1431655765&((e=858993459&((e=252645135&((e=16711935&((e=(e-r)*i|0)|e<<8))|e<<4))|e<<2))|e<<1))<<1}function Dt(t){let e=t,n=t;do{(e.x<n.x||e.x===n.x&&e.y<n.y)&&(n=e),e=e.next}while(e!==t);return n}function $t(t,e,n,r,i,o,s,a){return(i-s)*(e-a)>=(t-s)*(o-a)&&(t-s)*(r-a)>=(n-s)*(e-a)&&(n-s)*(o-a)>=(i-s)*(r-a)}function qt(t,e,n,r,i,o,s,a){return!(t===s&&e===a)&&$t(t,e,n,r,i,o,s,a)}function Gt(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!function(t,e){let n=t;do{if(n.i!==t.i&&n.next.i!==t.i&&n.i!==e.i&&n.next.i!==e.i&&Zt(n,n.next,t,e))return!0;n=n.next}while(n!==t);return!1}(t,e)&&(Ht(t,e)&&Ht(e,t)&&function(t,e){let n=t,r=!1;const i=(t.x+e.x)/2,o=(t.y+e.y)/2;do{n.y>o!=n.next.y>o&&n.next.y!==n.y&&i<(n.next.x-n.x)*(o-n.y)/(n.next.y-n.y)+n.x&&(r=!r),n=n.next}while(n!==t);return r}(t,e)&&(jt(t.prev,t,e.prev)||jt(t,e.prev,e))||Ut(t,e)&&jt(t.prev,t,t.next)>0&&jt(e.prev,e,e.next)>0)}function jt(t,e,n){return(e.y-t.y)*(n.x-e.x)-(e.x-t.x)*(n.y-e.y)}function Ut(t,e){return t.x===e.x&&t.y===e.y}function Zt(t,e,n,r){const i=Jt(jt(t,e,n)),o=Jt(jt(t,e,r)),s=Jt(jt(n,r,t)),a=Jt(jt(n,r,e));return i!==o&&s!==a||(!(0!==i||!Rt(t,n,e))||(!(0!==o||!Rt(t,r,e))||(!(0!==s||!Rt(n,t,r))||!(0!==a||!Rt(n,e,r)))))}function Rt(t,e,n){return e.x<=Math.max(t.x,n.x)&&e.x>=Math.min(t.x,n.x)&&e.y<=Math.max(t.y,n.y)&&e.y>=Math.min(t.y,n.y)}function Jt(t){return t>0?1:t<0?-1:0}function Ht(t,e){return jt(t.prev,t,t.next)<0?jt(t,e,t.next)>=0&&jt(t,t.prev,e)>=0:jt(t,e,t.prev)<0||jt(t,t.next,e)<0}function Wt(t,e){const n=te(t.i,t.x,t.y),r=te(e.i,e.x,e.y),i=t.next,o=e.prev;return t.next=e,e.prev=t,n.next=i,i.prev=n,r.next=n,n.prev=r,o.next=r,r.prev=o,r}function Kt(t,e,n,r){const i=te(t,e,n);return r?(i.next=r.next,i.prev=r,r.next.prev=i,r.next=i):(i.prev=i,i.next=i),i}function Qt(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ)}function te(t,e,n){return{i:t,x:e,y:n,prev:null,next:null,z:0,prevZ:null,nextZ:null,steiner:!1}}const ee="__fea_idx";new Float32Array([-1e12])[0];const ne="maptalks_ombb";function re(){return function(){if("undefined"!=typeof undefinedThis)return globalThis;if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof undefined)return global;throw new Error("unable to locate global object")}().maptalks_vt_packers}const{PackUtil:ie,ArrayPool:oe}=re();function se(t,e,n,r,i,o,s,a,l,u,h,c,f,p,d,g,y){const x=e.getLength(),m=i/3;for(let n=2,r=x;n<r;n+=3)t[i+n-2]=e[n-2],t[i+n-1]=e[n-1],t[i+n-0]=e[n]-s;i+=x;for(let n=2,r=x;n<r;n+=3)t[i+n-2]=e[n-2],t[i+n-1]=e[n-1],t[i+n-0]=e[n]-a;i+=x,t.trySetLength(i+x),t.copyWithin(i,i-2*x,i-x),i+=x,t.trySetLength(i+x),t.copyWithin(i,i-2*x,i-x),i+=x,(n=n||[]).push(x/3);const v=n.getLength();for(let e=0;e<v;e++){ae(m+(n[e-1]||0),m+n[e],t,x/3,l,r,u,h,c,f,o,p,d,g,y)}return i}function ae(t,e,n,r,i,o,s,a,l,u,h,c,f,p,d){const g=o.getLength();let y,x;for(let s=t,a=e;s<a-1;s++)if(y=s,x=s+1,i===1/0||!pt(n,y,x,i))if((s-t)%2==1&&(y+=2*r,x+=2*r),d){let t=o.currentIndex;o[t++]=y+r,o[t++]=x,o[t++]=y,o[t++]=x+r,o[t++]=x,o[t++]=y+r,o.currentIndex=t}else{let t=o.currentIndex;o[t++]=y+r,o[t++]=y,o[t++]=x,o[t++]=x,o[t++]=x+r,o[t++]=y+r,o.currentIndex=t}s&&function(t,e,n,r,i,o,s,a,l,u,h,c){let f,p=0,d=0,g=0,y=0;const x=c?[1,3,4]:[2,3,4];for(let c=o.getLength()-1;c>=s;c--){const s=o[c],m=3*s+1,v=3*s+2,w=i[3*s],b=i[m],M=i[v];p||d||(p=Math.max(i[v],i[3*o[c-3]+2]),d=Math.min(i[v],i[3*o[c-3]+2]),f=p-d);let P=g;const _=c%6;0===t?(5===_&&(y=Tt(i,o,c,w,b)),P=_===x[0]||_===x[1]||_===x[2]?g:g+y):1===t&&(_===x[0]||_===x[1]||_===x[2]?P=0:5===_?(y=Tt(i,o,c,w,b),P=y):P=y);const A=P/u*(1/(100*h))/a;let I;I=1===e?M===p?1:0:"bottom"===n?M===p?f/100/l:0:M===p?0:-f/100/l,r[2*s]=A,r[2*s+1]=I,0===_&&(g+=y)}}(a,l,u,h,n,o,g,c[0],c[1],f,p,d)}function le(t){const e=[t[0]];let n=t[0];for(let r=1;r<t.length;r++)Array.isArray(t[r])?t[r][0]===n[0]&&t[r][1]===n[1]&&t[r][2]===n[2]||e.push(t[r]):t[r].x===n.x&&t[r].y===n.y&&t[r].z===n.z||e.push(t[r]),n=t[r];return e}var ue="undefined"!=typeof Float32Array?Float32Array:Array;function he(){var t=new ue(3);return ue!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t}function ce(t,e,n){var r=new ue(3);return r[0]=t,r[1]=e,r[2]=n,r}function fe(t,e){return t[0]=e[0],t[1]=e[1],t[2]=e[2],t}function pe(t,e,n,r){return t[0]=e,t[1]=n,t[2]=r,t}function de(t,e,n){return t[0]=e[0]+n[0],t[1]=e[1]+n[1],t[2]=e[2]+n[2],t}function ge(t,e){var n=e[0],r=e[1],i=e[2],o=n*n+r*r+i*i;return o>0&&(o=1/Math.sqrt(o),t[0]=e[0]*o,t[1]=e[1]*o,t[2]=e[2]*o),t}function ye(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]}function xe(t,e,n){var r=e[0],i=e[1],o=e[2],s=n[0],a=n[1],l=n[2];return t[0]=i*l-o*a,t[1]=o*s-r*l,t[2]=r*a-i*s,t}var me=function(t,e,n){return t[0]=e[0]-n[0],t[1]=e[1]-n[1],t[2]=e[2]-n[2],t};function ve(){var t=new ue(4);return ue!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0),t[3]=1,t}function we(t,e){var n=e[0]+e[4]+e[8],r=void 0;if(n>0)r=Math.sqrt(n+1),t[3]=.5*r,r=.5/r,t[0]=(e[5]-e[7])*r,t[1]=(e[6]-e[2])*r,t[2]=(e[1]-e[3])*r;else{var i=0;e[4]>e[0]&&(i=1),e[8]>e[3*i+i]&&(i=2);var o=(i+1)%3,s=(i+2)%3;r=Math.sqrt(e[3*i+i]-e[3*o+o]-e[3*s+s]+1),t[i]=.5*r,r=.5/r,t[3]=(e[3*o+s]-e[3*s+o])*r,t[o]=(e[3*o+i]+e[3*i+o])*r,t[s]=(e[3*s+i]+e[3*i+s])*r}return t}!function(){var t=he()}(),function(){var t,e=(t=new ue(4),ue!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0,t[3]=0),t)}();var be,Me=function(t,e,n){return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t[3]=e[3]*n,t},Pe=function(t,e){var n=e[0],r=e[1],i=e[2],o=e[3],s=n*n+r*r+i*i+o*o;return s>0&&(s=1/Math.sqrt(s),t[0]=n*s,t[1]=r*s,t[2]=i*s,t[3]=o*s),t};he(),ce(1,0,0),ce(0,1,0),ve(),ve(),be=new ue(9),ue!=Float32Array&&(be[1]=0,be[2]=0,be[3]=0,be[5]=0,be[6]=0,be[7]=0),be[0]=1,be[4]=1,be[8]=1;\n/*!\n     * Contains code from google filament\n     * https://github.com/google/filament/\n     * License Apache-2.0\n     */\nconst _e=8,Ae=[],Ie=[],Se=[],Te=[];function Fe(t,e,n){const r=xe(Ie,e,n),i=function(t,e,n,r,i,o,s,a,l,u){return t[0]=e,t[1]=n,t[2]=r,t[3]=i,t[4]=o,t[5]=s,t[6]=a,t[7]=l,t[8]=u,t}(Ae,n[0],n[1],n[2],...r,...e);t=we(t,i),t=function(t){return t[3]<0?Me(t,t,-1):t}(t=Pe(t,t));const o=1/((1<<2*_e-1)-1);if(t[3]<o){t[3]=o;const e=Math.sqrt(1-o*o);t[0]*=e,t[1]*=e,t[2]*=e}const s=n[3]>0?xe(Se,n,e):xe(Se,e,n);return ye(xe(Te,n,e),s)<0&&Me(t,t,-1),t}const ke=[];const Le=[],Ce=[],Be=[],Oe=[],Ye=[],Ve=[],Xe=[];function Ne(t,e,n,r,i,o){pe(Oe,t[3*e],t[3*e+1],t[3*e+2]),pe(Ye,t[3*n],t[3*n+1],t[3*n+2]),pe(Ve,t[3*r],t[3*r+1],t[3*r+2]);const s=me(Le,Ve,Ye),a=me(Ce,Oe,Ye),l=xe(Be,s,a);ge(Xe,l),i[3*e]=i[3*e]||0,i[3*n]=i[3*n]||0,i[3*r]=i[3*r]||0,i[3*e+1]=i[3*e+1]||0,i[3*n+1]=i[3*n+1]||0,i[3*r+1]=i[3*r+1]||0,i[3*e+2]=i[3*e+2]||0,i[3*n+2]=i[3*n+2]||0,i[3*r+2]=i[3*r+2]||0,i[3*e]+=Xe[0],i[3*n]+=Xe[0],i[3*r]+=Xe[0],i[3*e+1]+=Xe[1],i[3*n+1]+=Xe[1],i[3*r+1]+=Xe[1],i[3*e+2]+=Xe[2],i[3*n+2]+=Xe[2],i[3*r+2]+=Xe[2],o[e]+=1,o[n]+=1,o[r]+=1}\n/*!\n     * Contains code from THREE.JS\n     * https://github.com/mrdoob/three.js/\n     * License MIT\n     * \n     * Generate tangents per vertex.\n     */function Ee(t,e,n){return t[0]=e[n],t[1]=e[n+1],t[2]=e[n+2],t}function ze(t,e,n){return t[0]=e[n],t[1]=e[n+1],t}const{StyleUtil:De,PackUtil:$e,ArrayPool:qe}=re(),Ge=qe.getInstance();function je(t,e,n,r,i,o,s,a,l,u,h,c,f,p,d,g){void 0===e.top&&(e.top=!0),void 0===e.side&&(e.side=!0),Ge.reset();const{altitudeScale:y,altitudeProperty:x,defaultAltitude:m,heightProperty:v,minHeightProperty:P,defaultHeight:_,tangent:A,uv:I,topUVMode:T,sideUVMode:F,sideVerticalUVMode:k,top:C,side:B,textureYOrigin:O,topThickness:Y}=e,V=function(t,e,{altitudeScale:n,altitudeProperty:r,defaultAltitude:i,heightProperty:o,minHeightProperty:s,defaultHeight:a},{center:l,side:u,top:h,topThickness:c,uvOrigin:f,uv:p,uvSize:d,topUVMode:g,sideUVMode:y,sideVerticalUVMode:x,textureYOrigin:m,tileRatio:v,centimeterToPoint:w,verticalCentimeterToPoint:b,positionType:M,res:P,glScale:_,projectionCode:A},I,T){let F=e/t[0].extent;e===1/0&&(F=1);const k=e===1/0,L=T.get(),C=T.get(),B=T.get(),O=T.getProxy(),Y=T.get(),V=T.get(),X=T.get(),N=!!p,E=!!h,z=!!u,D=N?T.get():null;function $(t,n,r,i,o,s){let a=n;if(E){const u=Ft(O,r,3);if(0===u.length)return n;let h=O.getLength(),p=Y.currentIndex;for(let t=0;t<h;t++)Y[p++]=O[t];if(Y.currentIndex=p,n+=O.getLength(),s)for(let e=2,n=u.length;e<n;e+=3)u[e]+=t/3,u[e-1]+=t/3,u[e-2]+=t/3;else{let e;for(let n=2,r=u.length;n<r;n+=3)e=u[n-1],u[n-1]=u[n]+t/3,u[n]=e+t/3,u[n-2]+=t/3}h=u.length,p=V.currentIndex;for(let t=0;t<h;t++)V[p++]=u[t];V.currentIndex=p,N&&It(g||0,t,n,D,Y,f,w,v,d[0],d[1],o,P,_,A,l),c>0&&!z&&(n=se(Y,O,r,V,n,D,0,c,e,N,y||0,x||0,m,d,v,b,i<0?!s:s)),X.setLength(n/3),X.fill(1,a/3,n/3)}if(z){E&&(c=0),a=n,n=se(Y,O,r,V,n,D,c,i,e,N,y||0,x||0,m,d,v,b,i<0?!s:s),X.setLength(n/3);const t=O.getLength()/3;X.fill(1,a/3,a/3+t),X.fill(0,a/3+t,a/3+2*t),X.fill(1,a/3+2*t,a/3+3*t),X.fill(0,a/3+3*t,n/3)}return n}let q=-1/0,G=1/0,j=0;const U=[-1,-1,e+1,e+1];let Z=0,R=t.length;S(I)&&(Z=I,R=I+1);let J=0,H=!1;const W=T.getProxy();let K,Q=!1;for(;Z<R;Z++){const l=t[Z],u=l.id;S(u)&&(Math.abs(u)>J&&(J=Math.abs(u)),u<0&&(H=!0));const h=l.geometry,c=l.properties[ne];let f=Array.isArray(c&&c[0]&&c[0][0])?c[0]:c;const{altitude:p,height:d}=ie.getFeaAltitudeAndHeight(l,n,r,i,o,a,s);d<0?(Q=!0,G=Math.min(p,G),q=Math.max(p-d,q)):(q=Math.max(p,q),G=Math.min(p-d,G));const g=Y.getLength();let y=0,x=j;W.setLength(0),O.setLength(0);const m=ie.calculateSignedArea(h[0])<0;for(let t=0,n=h.length;t<n;t++){let r=h[t];m&&(r=r.reverse()),r=le(r);const i=ie.calculateSignedArea(r)<0;if(!i&&t>0&&(y++,f=c&&c[y],j=$(x,j,W,d*F,f,k),O.setLength(0),W.setLength(0),x=j),e!==1/0&&(r=ie.clipPolygon(r,U)),!r.length){t===n-1&&(j=$(x,j,W,d*F,f,k));continue}const o=r.length;if(Array.isArray(r[0])?r[0][0]===r[o-1][0]&&r[0][1]===r[o-1][1]||r.push([r[0][0],r[0][1]]):r[0].x===r[o-1].x&&r[0].y===r[o-1].y||r.push(r[0]),i){let t=W.currentIndex;W[t++]=O.getLength()/3,W.currentIndex=t}ft(O,O.getLength(),r,F,p,!1,M),t===n-1&&(j=$(x,j,W,d*F,f,k))}const v=Y.getLength()-g,w=(ee+"").trim();for(let t=0;t<v/3;t++){let t=C.currentIndex;C[t++]=void 0===l[w]?Z:l[w],C.currentIndex=t,t=L.currentIndex,L[t++]=Z,L.currentIndex=t,S(u)&&(t=B.currentIndex,B[t++]=u,B.currentIndex=t)}}K=l?Float32Array:ie.getUnsignedArrayType(C.getLength()?C[C.getLength()-1]:0);const tt={hasNegativeHeight:Q,maxAltitude:q===-1/0?0:q,minAltitude:G===1/0?0:G,vertices:Y,verticeTypes:X,indices:V,pickingIds:oe.createTypedArray(C,K),featureIndexes:L};if(B.getLength()){const t=H?ie.getPosArrayType(J):ie.getUnsignedArrayType(J);tt.featureIds=oe.createTypedArray(B,t)}else tt.featureIds=[];return D&&(D.setLength(Y.getLength()/3*2),tt.uvs=D),tt}(t,n,{altitudeScale:y,altitudeProperty:x,defaultAltitude:m||0,heightProperty:v,minHeightProperty:P,defaultHeight:_||0},{center:g,top:C,side:B,topThickness:10*Y||0,uv:I||A,uvSize:[i,i],uvOrigin:r,topUVMode:T,sideUVMode:F,sideVerticalUVMode:k,textureYOrigin:O,tileRatio:a,centimeterToPoint:l,verticalCentimeterToPoint:u,positionType:d,res:o,glScale:s,projectionCode:f},p,Ge),X=[],N=V.vertices.getLength()/3,E=$e.getIndexArrayType(N),z=qe.createTypedArray(V.indices,E);delete V.indices,X.push(z.buffer,V.pickingIds.buffer);const D=Math.max(Math.abs(V.maxAltitude),Math.abs(V.minAltitude)),$=$e.getPosArrayType(Math.max(512,D));V.vertices=qe.createTypedArray(V.vertices,$);const q=A?Ge.getProxy():new Float32Array(3*N);q.setLength&&q.setLength(3*N);const G=function(t,e,n){const r=n||[];r.setLength&&r.setLength(t.length);const i=ke;i.length<t.length/3&&(i.length=t.length/3),i.fill(0,0,t.length/3);const o=void 0===e.length?e:e.length;for(let n=0;n<o/3;n++)void 0===e.length?Ne(t,3*n,3*n+1,3*n+2,r,i):Ne(t,e[3*n],e[3*n+1],e[3*n+2],r,i);for(let t=0;t<r.length;t+=3){const e=i[t/3];0!==e?(r[t]/=e,r[t+1]/=e,r[t+2]/=e):(r[t]=0,r[t+1]=0,r[t+2]=0)}return r}(V.vertices,z,q);let j=!0;const U=G.getLength?G.getLength():G.length;for(let t=0;t<U;t++){G[t]=-G[t];const e=G[t]%1;1-Math.abs(e)>1e-6?j=!1:0!==e&&(G[t]=Math.round(G[t]))}if(V.normals=G,A){let t=Ge.get();t.setLength(4*N),t=function(t,e,n,r,i){const o=t.length/3,s=i||new Array(4*o),a=[],l=[];for(let t=0;t<o;t++)a[t]=[0,0,0],l[t]=[0,0,0];const u=[0,0,0],h=[0,0,0],c=[0,0,0],f=[0,0],p=[0,0],d=[0,0],g=[0,0,0],y=[0,0,0];function x(e,r,i){Ee(u,t,3*e),Ee(h,t,3*r),Ee(c,t,3*i),ze(f,n,2*e),ze(p,n,2*r),ze(d,n,2*i);const o=h[0]-u[0],s=c[0]-u[0],x=h[1]-u[1],m=c[1]-u[1],v=h[2]-u[2],w=c[2]-u[2],b=p[0]-f[0],M=d[0]-f[0],P=p[1]-f[1],_=d[1]-f[1],A=1/(b*_-M*P);pe(g,(_*o-P*s)*A,(_*x-P*m)*A,(_*v-P*w)*A),pe(y,(b*s-M*o)*A,(b*m-M*x)*A,(b*w-M*v)*A),de(a[e],a[e],g),de(a[r],a[r],g),de(a[i],a[i],g),de(l[e],l[e],y),de(l[r],l[r],y),de(l[i],l[i],y)}for(let t=0,e=r.length;t<e;t+=3)x(r[t+0],r[t+1],r[t+2]);const m=[],v=[],w=[],b=[];let M,P,_;function A(t){Ee(w,e,3*t),fe(b,w),P=a[t],fe(m,P),me(m,m,function(t,e,n){return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t}(w,w,ye(w,P))),ge(m,m),xe(v,b,P),_=ye(v,l[t]),M=_<0?-1:1,s[4*t]=m[0],s[4*t+1]=m[1],s[4*t+2]=m[2],s[4*t+3]=M}for(let t=0,e=r.length;t<e;t+=3)A(r[t+0]),A(r[t+1]),A(r[t+2]);return s}(V.vertices,V.normals,V.uvs,z,t),t=function(t,e){const n=e.getLength(),r=new Float32Array(n),i=[],o=[],s=[];for(let a=0;a<n;a+=4){const n=a/4*3;gt(o,t[n]||0,t[n+1]||0,t[n+2]||0),xt(i,e[a]||0,e[a+1]||0,e[a+2]||0,e[a+3]||0),Fe(s,o,i),yt(r.subarray(a,a+4),s)}return r}(V.normals,t),V.tangents=t,X.push(t.buffer),delete V.normals}if(V.normals&&(j&&(V.normals=qe.createTypedArray(V.normals,Int8Array)),X.push(V.normals.buffer)),V.uvs){const t=V.uvs;V.uvs=qe.createTypedArray(t,Float32Array),X.push(V.uvs.buffer)}const Z=function(t,e,n,r){const i={},o={},s=r.getLength();if(L(e.polygonFill)){let a=b(e.polygonFill);const l=new Uint8Array(4*s);l.fill(255);for(let e=0;e<s;e++){const o=t[r[e]],s=o.properties||{};s.$layer=o.layer,s.$type=o.type;let u=a(n,s);w(u)&&(i.aColor=1,a=b(u),u=a(n,s)),delete s.$layer,delete s.$type,De.normalizeColor(Ue,u),l[4*e]=Ue[0],l[4*e+1]=Ue[1],l[4*e+2]=Ue[2],l[4*e+3]=Ue[3]}o.aColor=l}if(L(e.polygonOpacity)){let a=M(e.polygonOpacity,"exponential");const l=new Uint8Array(s);l.fill(255);for(let e=0;e<s;e++){const o=t[r[e]],s=o.properties||{};s.$layer=o.layer,s.$type=o.type;let u=a(n,s);w(u)&&(i.aOpacity=1,a=b(u),u=a(n,s)),delete s.$layer,delete s.$type,l[e]=255*u}o.aOpacity=l}return o.dynamicAttributes=i,o}(t,h,c,V.featureIndexes),R=function(t,e,n,r,i){const o=[[],[]],s=L(r.topPolygonFill),a=L(r.bottomPolygonFill),l=[255,255,255,255],u=e.getLength();if(s||a){let h=s&&b(r.topPolygonFill),c=a&&b(r.bottomPolygonFill),f=null,p=null,d=null,g=null;for(let r=0;r<u;r++){if(1===t[r]&&!s||0===t[r]&&!a)continue;const u=1===t[r];if(u&&e[r]===f){t[r]=d;continue}if(!u&&e[r]===p){t[r]=g;continue}const y=n[e[r]],x=y.properties||{};x.$layer=y.layer,x.$type=y.type;let m=u?h:c,v=m(i,x);w(v)&&(m=b(v),v=m(i,x)),delete x.$layer,delete x.$type,De.normalizeColor(Ue,v),mt(Ue,Ue,l);let M=Ze(o,Ue);M<0&&(M=o.length,o.push(yt([],Ue))),t[r]=M,u?(f=e[r],d=M):(p=e[r],g=M)}}return o.slice(2)}(V.verticeTypes,V.featureIndexes,t,h,c),J={data:{data:{aVertexColorType:R.length<=252?qe.createTypedArray(V.verticeTypes,Uint8Array):qe.createTypedArray(V.verticeTypes,Uint16Array),aPosition:V.vertices,aNormal:V.normals,aTexCoord0:V.uvs,aTangent:V.tangents,aPickingId:V.pickingIds},indices:z,properties:{maxAltitude:V.maxAltitude/100,minAltitude:V.minAltitude/100,hasNegativeHeight:V.hasNegativeHeight},dynamicAttributes:Z.dynamicAttributes,vertexColors:R},buffers:X};return V.featureIds.length?(J.data.featureIds=V.featureIds,X.push(J.data.featureIds.buffer)):J.data.featureIds=[],Z.aColor&&(J.data.data.aColor=Z.aColor,J.buffers.push(Z.aColor.buffer)),Z.aOpacity&&(J.data.data.aOpacity=Z.aOpacity,J.buffers.push(Z.aOpacity.buffer)),J.buffers.push(J.data.data.aPosition.buffer),J.data.pickingIdIndiceMap=$e.generatePickingIndiceIndex(J.data.data.aPickingId,J.data.indices),J}const Ue=[];function Ze(t,e){for(let i=0;i<t.length;i++)if(n=e,r=t[i],n[0]===r[0]&&n[1]===r[1]&&n[2]===r[2]&&n[3]===r[3])return i;var n,r;return-1}const{PackUtil:Re,StyleUtil:Je,FilterUtil:He}=re();function We(t,e,n,r,{altitudeScale:i,altitudeProperty:o,defaultAltitude:s,heightProperty:a,minHeightProperty:l,defaultHeight:u,bottom:h}){const c=h,f=e/t[0].extent,p=2*function(t,e){let n=0;for(let e=0,r=t.length;e<r;e++){const r=t[e];if(S(r.geometry[0][0]))n+=3*r.geometry.length;else for(let t=0,e=r.geometry.length;t<e;t++){let e=3*r.geometry[t].length;3===r.type&&(e-=3),n+=e}}return n}(t)+3*t.length*2,d=[],g=new Int16Array(p),y=new Uint8Array(g.length/3*4);w(n)&&(n=He.compileFilter(n));const x=[];function m(t,n,r){const i=n-t,o=g.subarray(t,n),s=g.subarray(n,n+i);s.set(o);for(let t=2,e=s.length;t<e;t+=3)s[t]=o[t]-r;const a=t/3,l=i/3;let u,h;for(let t=a,n=l+a;t<n;t++)t<n-1?(u=t,h=t+1):(u=t,h=a),pt(g,u,h,e)||(x.push(u,h),c&&x.push(u+l,h+l),Ke(g,u,e)||x.push(u,u+l));return n+i}let v=0,b=-1/0,M=1/0;const P=(ee+"").trim(),_=[];for(let e=0,h=t.length;e<h;e++){const h=t[e],c=h.geometry;if(n){let t;t="function"==typeof n?n(h&&h.properties):n,Je.normalizeColor(_,t)}else gt(_,255,255,255);const p=v/3*4,{altitude:w,height:A}=Re.getFeaAltitudeAndHeight(h,i,o,s,a,u,l);A<0?(M=Math.min(w,M),b=Math.max(w-A,b)):(M=Math.min(w-A,M),b=Math.max(w,b));let I=v;for(let t=0,e=c.length;t<e;t++){let e=c[t];const n=e.length;e[0][0]===e[n-1][0]&&e[0][1]===e[n-1][1]&&(e=e.slice(0,n-1)),v=ft(g,I,e,f,w),v=m(I,v,A*f),I=v}const S=I/3*4;for(let t=p;t<S;t+=4)y[t]=_[0],y[t+1]=_[1],y[t+2]=_[2],y[t+3]=255*(r||1);const T=x.length-d.length;for(let t=0;t<T;t++)d.push(h[P])}const A=x.reduce(((t,e)=>Math.max(t,e)),0),I=new(Re.getIndexArrayType(A))(x),T=Math.max(Math.abs(b,Math.abs(M)));return{aPosition:new(Re.getPosArrayType(Math.max(512,T)))(g),indices:I,aPickingId:new Float32Array(d),aColor:y,maxAltitude:b===-1/0?0:b/100,minAltitude:M===1/0?0:M/100}}function Ke(t,e,n){const r=t[3*e],i=t[3*e+1];return r<0||r>n||i<0||i>n}function Qe(t,e,n,r){const i=We(t,e,n.lineColor,n.lineOpacity,r),{minAltitude:o,maxAltitude:s}=i;delete i.minAltitude,delete i.maxAltitude;const a=[i.aPosition.buffer,i.indices.buffer,i.aPickingId.buffer],l=i.indices;return delete i.indices,{data:{data:i,properties:{minAltitude:o,maxAltitude:s},indices:l},buffers:a}}\n/*!\n        Feature Filter by\n\n        (c) mapbox 2016 and maptalks 2018\n        www.mapbox.com | www.maptalks.org\n        License: MIT, header required.\n    */const tn=["Unknown","Point","LineString","Polygon","MultiPoint","MultiLineString","MultiPolygon","GeometryCollection"];function en(t){if(!t)return"true";const e=t[0];if(t.length<=1)return"any"===e?"false":"true";return\`(${W}"=="===e?rn(t[1],t[2],"===",!1):"!="===e?rn(t[1],t[2],"!==",!1):"<"===e||">"===e||"<="===e||">="===e?rn(t[1],t[2],e,!0):"any"===e?sn(t.slice(1),"||"):"all"===e?sn(t.slice(1),"&&"):"none"===e?un(sn(t.slice(1),"||")):"in"===e?an(t[1],t.slice(2)):"!in"===e?un(an(t[1],t.slice(2))):"has"===e?ln(t[1]):"!has"===e?un(ln(t[1])):"contains"===e?function(t,e,n){const r=nn(t);return void 0!==n?\`(${W}r} + '').indexOf("${W}e}") === ${W}n}\`:\`(${W}r} + '').indexOf("${W}e}") >= 0\`}(t[1],t[2],t[3]):"true"})\`}function nn(t){return"$"===t[0]?"f."+t.substring(1):"p["+JSON.stringify(t)+"]"}function rn(t,e,n,r){if("object"==typeof(i=t)&&i&&t.op)return function(t,e,n,r){const i=t.property,o=t.op;let s=nn(i);return"length"!==o?(console.error(\`not support ${W}o} op\`),"false"):(s=\`((${W}s}+='').length)\`,on(s,i,e,n,r))}(t,e,n,r);var i;return on(nn(t),t,e,n,r)}function on(t,e,n,r,i){const o="$type"===e?tn.indexOf(n):JSON.stringify(n);return(i?\`typeof ${W}t}=== typeof ${W}o}&&\`:"")+t+r+o}function sn(t,e){return t.map(en).join(e)}function an(t,e){"$type"===t&&(e=e.map((t=>tn.indexOf(t))));const n=JSON.stringify(e.sort(hn)),r=nn(t);return e.length<=200?\`${W}n}.indexOf(${W}r}) !== -1\`:\`function(v, a, i, j) {\\n        while (i <= j) { var m = (i + j) >> 1;\\n            if (a[m] === v) return true; if (a[m] > v) j = m - 1; else i = m + 1;\\n        }\\n    return false; }(${W}r}, ${W}n},0,${W}e.length-1})\`}function ln(t){return"$id"===t?'"id" in f':\`${W}JSON.stringify(t)} in p\`}function un(t){return\`!(${W}t})\`}function hn(t,e){return t<e?-1:t>e?1:0}let cn=!1;try{const t=new OffscreenCanvas(1,1);t.getContext("2d").fillText("hello",0,0),cn=!0}catch(t){cn=!1}var fn=cn;const{VectorPack:pn,PolygonPack:dn,NativeLinePack:gn,LinePack:yn,PointPack:xn,NativePointPack:mn,LineExtrusionPack:vn,CirclePack:wn,RoundTubePack:bn,SquareTubePack:Mn,FilterUtil:Pn,PackUtil:_n,StyleUtil:An,TextUtil:In,DEFAULT_TEX_WIDTH:Sn,GlyphRequestor:Tn}=re(),Fn="__original_properties",kn="__fn-type_properties";class Ln{constructor(t,e,n,r,i){this.id=t,this.options=e,this.upload=n,this._compileStyle(e.style),this.requests={},this._cache=r,this._styleCounter=1,this.loadings=i}updateStyle(t,e){this.options.style=t,this._styleCounter=t.styleCounter,this._compileStyle(t),e()}updateOptions(t,e){this.options=A(this.options,t),e()}loadTile(t,e){const n=this.loadings,r=t.tileInfo.url,i=this.options.debugTile;if(i){const{x:n,y:r,z:o}=t.tileInfo;let s=!1;for(let t=0;t<i.length;t++)if(n===i[t].x&&r===i[t].y&&o===i[t].z){s=!0;break}if(!s)return void e()}if(n[r])return void n[r].push({context:t,callback:e,ref:this});n[r]=[{context:t,callback:e,ref:this}];const o=this.options.featureIdProperty;this.requests[r]=this.getTileFeatures(t,((e,i,s,a)=>{const l=n[r];if(delete n[r],this.checkIfCanceled(r))return delete this.requests[r],void this._callWaitings(l,null,{canceled:!0});if(delete this.requests[r],(this.options.debug||o)&&i)for(let e=0;e<i.length;e++)if(this.options.debug&&(i[e]._debug_info={index:e,id:i[e].id,tileId:t.tileInfo.id}),o){const t=F(o)?o[i[e].layer]:o,n=i[e].properties;i[e].id=n&&n[t]||null}if(e)this._callWaitings(l,e);else if(i&&i.length){if(l)for(let t=0;t<l.length;t++)this._onTileLoad.call(l[t].ref,l[t].context,l[t].callback,r,s,i,a)}else this._callWaitings(l)}))}_onTileLoad(t,e,n,r,i,o){this._createTileData(r,i,t).then((n=>{if(n.canceled)return void e(null,{canceled:!0});n.data.styleCounter=t.styleCounter,o&&A(n.data,o);const r=n.data.features;if(r){const t={};for(const e in r){const n=r[e];t[n.id]=n}const e=function(t){try{const e=JSON.stringify(t);return C.encode(e)}catch(t){console.error("encode JSON to Uint8Array error:",t)}}(t);e&&(n.data.featuresTypeArray=e,n.buffers=n.buffer||[],n.buffers.push(e.buffer));const i="id"===this.options.features;for(const t in r){const n=r[t];e&&delete n.geometry,i&&(r[t]=n.id)}}e(null,n.data,n.buffers)})).catch((t=>{e(t)}))}abortTile(t,e){delete this.requests[t],this._cancelLoadings(t),e()}_cancelLoadings(t){const e=this.loadings[t];if(e)for(let t=0;t<e.length;t++)e[t].callback(null,{canceled:!0});delete this.loadings[t]}_callWaitings(t,e,n){if(t)for(let r=0;r<t.length;r++)t[r].callback(e,n)}checkIfCanceled(t){return!this.requests[t]}onRemove(){this.loadings={},this.clearCache(),delete this._cache,this.requests={}}clearCache(){this._cache&&this._cache.reset()}fetchIconGlyphs(t,e,n){if(this.options.workerGlyph&&fn){const r=[];if(t&&Object.keys(t).length){const e=new Promise((e=>{this.upload("fetchIconGlyphs",{icons:t},null,((t,n)=>{e({err:t,iconData:n})}))}));r.push(e)}if(e&&Object.keys(e).length){const t=new Promise((t=>{if(!this._glyphRequestor){const t=this.options.sdfURL;this._glyphRequestor=new Tn(null,null,null,t)}this._glyphRequestor.getGlyphs(e,((e,n)=>{t({err:e,glyphData:n})}))}));r.push(t)}Promise.all(r).then((t=>{const e={icons:null,glyphs:null};for(let r=0;r<t.length;r++){if(t[r].err)return void n(t[r].err);t[r].iconData?e.icons=t[r].iconData.icons:t[r].glyphData&&(e.glyphs=t[r].glyphData.glyphs)}return e})).then((t=>{n(null,t)}))}else this.upload("fetchIconGlyphs",{icons:t,glyphs:e},null,n)}_createTileData(t,e,n){if(!e.length)return Promise.resolve({data:null,buffers:[]});const{glScale:r,tileInfo:i}=n,o=!this.options.style.style.length&&!this.options.style.featureStyle.length;let s=this.pluginConfig.slice(0);o&&(s=this._updateLayerPluginConfig(t)),this.featurePlugins&&function(t){for(let e=1;e<arguments.length;e++){const n=arguments[e];if(n)for(let e=0,r=n.length;e<r;e++)t.push(n[e])}t.length}(s,this.featurePlugins);const a={};for(let t=0;t<s.length;t++)Nn(e,n.tileInfo.z,s[t],a);const l=[],u=[];for(let t=0;t<e.length;t++){const n=e[t],r=a[t];if(r){u.fill(null);let t=0;for(const e in r){let i=0;const o=r[e].values();for(const t of o){let r=u[i];r||(r=$n(n),u[i]=r),r.properties[e]=t,i++}i>t&&(t=i)}for(let e=0;e<t;e++)l.push(u[e])}else l.push(n)}const h=(e=l)[0].extent,c=i.z,f={x:i.extent2d.xmin*r,y:i.extent2d.ymax*r},p=[],d=[],g=[],y=this.options,x=[],m={},v=[Promise.resolve(n.styleCounter)];let w=0,b=-1;const M=[];let P=!1;for(let t=0;t<s.length;t++){b++;const r=s[t];r.type!==w&&(b=0,w=r.type);const a=0===r.type?p:d;jn(r.symbol,M,t),P=P||M[t]&&M[t].size>0;const{tileFeatures:l,tileFeaIndexes:u}=this._filterFeatures(c,r.type,r.filter,e,m,t);if(!l.length){a[b]=null;continue}const y=u[u.length-1],_=_n.getIndexArrayType(y);a[b]={styledFeatures:new _(u)},g.push({idx:t,typeIdx:b}),x.push(a[b].styledFeatures.buffer);const I=A({},n,{extent:h,zoom:c,tilePoint:f});if(this.options.debugTile){const t=this.options.debugTile;for(let e=0;e<t.length;e++){const{x:n,y:r,z:o}=t[e];if(i.x===n&&i.y===r&&i.z===o){I.debugIndex=t[e].index;break}}}let S=this._createTileGeometry(l,r,I);o&&(S=S.then((t=>{if(!t)return null;if(t.data)t.data.layer=l[0].layer;else if(Array.isArray(t))for(let e=0;e<t.length;e++)t[e]&&t[e].data&&(t[e].data.layer=l[0].layer);return t}))),v.push(S)}return Promise.all(v).then((([n,...r])=>{if(n!==this._styleCounter)return{canceled:!0};function i(t,e){if(void 0!==t.data.ref)return;const n=s[g[e].idx],r=n.renderPlugin.dataConfig;if(t.data.type=r.type,t.data.filter=n.filter.def,r.altitudeOffset&&(t.data.properties.minAltitude+=r.altitudeOffset,t.data.properties.maxAltitude+=r.altitudeOffset),t.buffers&&t.buffers.length)for(let e=0;e<t.buffers.length;e++)x.push(t.buffers[e])}for(let t=0;t<r.length;t++){if(!r[t])continue;const e=r[t],n=0===s[g[t].idx].type?p:d;if(Array.isArray(e)){const r=[];for(let n=0;n<e.length;n++)e[n]&&(i(e[n],t),(void 0===e[n].data.ref||e[e[n].data.ref])&&r.push(e[n].data));r.length&&(n[g[t].typeIdx].data=r)}else i(e,t),n[g[t].typeIdx].data=e.data}const o={},a=t;if(y.features||y.schema||P){let t,n=!1;for(let r=0,i=e.length;r<i;r++)if(t=e[r],a[t.layer].properties||(a[t.layer].properties=On(t.properties)),t&&(y.features||P&&m[r])){delete t.extent,delete t.properties.$layer,delete t.properties.$type,delete t.__index;const e=t.originalFeature;if(e){const e=t.properties,n=A({},t.originalFeature);delete e[Fn],n.customProps=A({},e),t=n}const i=A({},t);if(P&&m[r]&&(!y.features||"transient"===y.features)){const i=m[r];for(let r=0;r<i.length;r++){const i=M[r];i&&i.forEach((r=>{const i=e?e.properties:t.properties;i[kn]||(i[kn]=new Set),i[kn].add(r),n=!0}))}}o[r]=i}if(n)for(const t in o){const e=o[t],n=e.properties[kn];if(n){delete e.properties[kn],"transient"===y.features&&(e.fnTypeProps=A({},e.properties));for(const t in e.properties)n.has(t)||("transient"===y.features?delete e.fnTypeProps[t]:delete e.properties[t])}}}return{data:{styleCounter:n,schema:a,data:p,featureData:d,extent:h,features:o},buffers:x}})).catch((t=>{console.error(t)}))}_createTileGeometry(t,e,n){let r=t;const i=e.renderPlugin.dataConfig,o=e.symbol,s=this.options.tileSize,{extent:a,glScale:l,zScale:u,zoom:h,tilePoint:c,centimeterToPoint:f,verticalCentimeterToPoint:p}=n,d=a/s,g=i.type,y=n.debugIndex;let x=A({},i,{EXTENT:a,zoom:h,debugIndex:y,features:this.options.features,isWebGPU:this.options.isWebGPU,isWebGL1:this.options.isWebGL1});if("3d-extrusion"===g){Yn(o)&&(i.uv=1);const t=this.options.projectionCode,e=o.material&&o.material.textureWidth||Sn;return Promise.all([Promise.resolve(je(r,i,a,c,e,n.tileInfo.res,l,a/this.options.tileSize,f,p,o,h,t,y))])}if("3d-wireframe"===g)return Promise.all([Promise.resolve(Qe(r,a,o,i))]);if("point"===g){x=A(x,{requestor:this.fetchIconGlyphs.bind(this),altitudeToTileScale:u*a/this.options.tileSize/l,pluginType:e.renderPlugin.type});let t=o;return Array.isArray(o)||(t=[o]),t=t.map(((t,e)=>(t&&(t.index={index:e},t.isIconText=function(t){return t.markerType||t.markerFile}(t)),t))).filter((t=>!!t)),Promise.all(t.map((t=>{x.defaultMarkerVerticalAlignment="middle";const e=pn.genFnTypes(t);let n=r;return xn.needMerge(t,e,h)&&(n=xn.mergeLineFeatures(r,t,e,h)),new xn(n,t,x).load(d)})))}if("native-point"===g){const t=u*a/this.options.tileSize/l;return x.altitudeToTileScale=t,Vn(r,o,x,mn,d)}if("line"===g)return x=A(x,{requestor:this.fetchIconGlyphs.bind(this),tileRatio:d}),Vn(r,o,x,yn,1,!0);if("native-line"===g)return Vn(r,o,x,gn,1,!0);if("fill"===g)return x=A(x,{requestor:this.fetchIconGlyphs.bind(this)}),Vn(r,o,x,dn);if("line-extrusion"===g){delete o.lineGradientProperty,o.lineJoin="miter",o.lineCap="butt";const t=Yn(o);if(t&&(i.uv=1),x=A(x,{tileSize:s,zScale:u,glScale:l}),o.mergeOnProperty){const t=pn.genFnTypes(o);r=yn.mergeLineFeatures(r,o,t,x.zoom)}if(t){const t=[];if(!1!==i.top){const e=A({},x);e.side=!1,t.push(new vn(r,o,e))}return!1!==i.side&&(x.side=!0,x.top=!1,t.push(new vn(r,o,x))),Promise.all(t.map((t=>t.load())))}return Promise.all([new vn(r,o,x).load()])}if("circle"===g)return Vn(r,o,x,wn);if("round-tube"===g||"square-tube"===g){const t="round-tube"===g?bn:Mn;return x=A(x,{requestor:this.fetchIconGlyphs.bind(this),radialSegments:"round-tube"===g?i.radialSegments||8:4,centimeterToPoint:f,verticalCentimeterToPoint:p,tileRatio:d,isTube:!0}),Vn(r,o,x,t)}return Promise.resolve([])}_filterFeatures(t,e,n,r,i,o){const s=(ee+"").trim(),a=[],l=[],u=r.length;for(let h=0;h<u;h++)if((1===e||void 0===r[h].id||!this.styledFeatures[r[h].id])&&((!n.def||"default"===n.def)&&!i[h]||!0===n.def||n.def&&(void 0!==n.def.condition||Array.isArray(n.def))&&n(r[h],t))){const t=r[h];if(void 0===t[s]&&(t[s]=h),i[h]||(i[h]=[]),i[h].push(o),l.push(t),a.push(h),1===e)break}return{tileFeatures:l,tileFeaIndexes:a}}_compileStyle(t){const{style:e,featureStyle:n}=t,r={};n.forEach((t=>{Array.isArray(t.id)?(t.id.forEach((t=>{r[t]=1})),t.filter=["in","$id",...t.id]):(r[t.id]=1,t.filter=["==","$id",t.id])}));const i=Pn.compileStyle(e);for(let t=0;t<e.length;t++)i[t].filter&&(i[t].filter.def=e[t].filter?e[t].filter.value||e[t].filter:void 0),i[t].type=0;const o=[],s=Pn.compileStyle(n);for(let t=0;t<n.length;t++)s[t].type=1,s[t].filter.def=n[t].filter?n[t].filter.value||n[t].filter:void 0,s[t].renderPlugin&&o.push(s[t]);this.pluginConfig=i,this.featurePlugins=o,this.styledFeatures=r}_updateLayerPluginConfig(t){let e=this._layerPlugins;this._layerPlugins||(e=this._layerPlugins={});const n=["","Point","LineString","Polygon","MultiPoint","MultiLineString","MultiPolygon"],r=[];for(const o in t){const s=o;if(!e[o]){const r=[];for(let e=0;e<t[o].types.length;e++){const a=t[o].types[e],l=["all",["==","$layer",s],["==","$type",n[a]]],u={filter:(i=l,new Function("f",\`var p = (f && f.properties || {}); return ${W}en(i)}\`)),renderPlugin:Cn(a),symbol:Bn(a)};u.filter.def=l,u.type=0,r.push(u)}e[s]=r}r.push(...e[s])}var i;return r}}function Cn(t){switch(t){case 1:return{type:"native-point",dataConfig:{type:"native-point",only2D:!0}};case 2:return{type:"native-line",dataConfig:{type:"native-line",only2D:!0}};case 3:return{type:"fill",dataConfig:{type:"fill",only2D:!0}}}return null}function Bn(t){switch(t){case 1:return{markerFill:"#f00",markerSize:10};case 2:return{lineColor:"#fff"};case 3:return{polygonFill:"#00f",polygonOpacity:.4}}return null}function On(t){if(Array.isArray(t)||!F(t))return{};const e={};for(const n in t){const r=t[n];I(r)?e[n]="string":S(r)?e[n]="number":!0===r||!1===r?e[n]="boolean":Array.isArray(r)?e[n]="array":e[n]="object"}return e}function Yn(t){if(!t)return 0;let e=0;for(const n in t){if(("normalTexture"===n||"bumpTexture"===n)&&t[n])return 2;if(n.indexOf("Texture")>0&&t[n])e=1;else if(F(t[n])){const r=Yn(t[n]);if(2===r)return r;1===r&&(e=1)}}return e}function Vn(t,e,n,r,i,o){const s={},a=Array.isArray(e)?e:[e];let l=-1;for(let t=0;t<a.length;t++)s[t]=Xn(a[t]),!s[t]&&a[t]&&-1===l&&(l=t);const u=[];for(let e=0;e<a.length;e++){if(!a[e])continue;a[e].index={index:e};let h=t;if(o&&a[e].mergeOnProperty){const r=pn.genFnTypes(a[e]);h=yn.mergeLineFeatures(t,a[0],r,n.zoom)}s[e]||e===l?u.push(new r(h,a[e],n).load(i)):u.push({data:{ref:l,symbolIndex:{index:e}}})}return Promise.all(u)}function Xn(t){if(!t)return 0;for(const e in t)if(L(t[e]))return 1;return 0}function Nn(t,e,n,r){const i=n.customProperties;if(!i)return t;if(i)for(let t=0;t<i.length;t++)i[t].fn=Pn.compileFilter(i[t].filter);for(let n=0;n<i.length;n++)for(let o=0,s=t.length;o<s;o++)if(i[n].fn(t[o],e))for(const t in i[n].properties){const e=i[n].properties[t];k(e)||(r[o]||(r[o]={}),r[o][t]||(r[o][t]=new Set),r[o][t].add(e))}}const En={get:(t,e)=>e in t?t[e]:t.originalFeature[e],has:(t,e)=>e in t||e in t.originalFeature},zn={get:function(t,e){return e in t?t[e]:t[Fn][e]},has:(t,e)=>e in t||e in t[Fn]},Dn={};function $n(t){const e={};e.originalFeature=t;const n=new Proxy(e,En);return n.properties=new Proxy({},zn),n.properties[Fn]=t.properties||Dn,n}function qn(t,e,n){t[e]||(t[e]=new Set),t[e].add(n)}const Gn=[];function jn(t,e,n){if(!t)return Gn;for(const r in t){if(!t[r]||!An.checkIfZoomFnTypeSymbol(r))continue;if(L(t[r]))qn(e,n,t[r].property);else{if("lineGradientProperty"===r){qn(e,n,t[r]);continue}if("textName"===r)if(I(t[r])){const i=In.resolveVarNames(t[r]);if(i)for(let t=0;t<i.length;t++)qn(e,n,i[t])}else if(Pn.isExpression(t[r])){const i=[];In.resolveExpVarNames(i,t[r]);for(let t=0;t<i.length;t++)qn(e,n,i[t])}}const i=t[r].stops;if(i&&i.length)for(let t=0;t<i.length;t++)L(i[t][1])&&qn(e,t,i[t][1].property)}return e[n]}function Un(t,e){Zn(t.geometry,e)}function Zn(t,e){if(t)switch(t.type){case"Point":Rn(t.coordinates,e);break;case"MultiPoint":case"LineString":Jn(t.coordinates,e);break;case"MultiLineString":!function(t,e){for(let n=0,r=t.length;n<r;n++)Jn(t[n],e)}(t.coordinates,e);break;case"Polygon":Hn(t.coordinates,e);break;case"MultiPolygon":!function(t,e){for(let n=0,r=t.length;n<r;n++)Hn(t[n],e)}(t.coordinates,e);break;case"GeometryCollection":const n=t.geometries.length;for(let r=0;r<n;r++)Zn(t.geometries[r],e)}}function Rn(t,e){e[0]=Math.min(e[0],t[0]),e[1]=Math.min(e[1],t[1]),e[2]=Math.max(e[2],t[0]),e[3]=Math.max(e[3],t[1])}function Jn(t,e){for(let n=0,r=t.length;n<r;n++)Rn(t[n],e)}function Hn(t,e){t.length&&Jn(t[0],e)}function Wn(t,e,n,r,i){Kn(t,e,n||0,r||t.length-1,i||tr)}function Kn(t,e,n,r,i){for(;r>n;){if(r-n>600){var o=r-n+1,s=e-n+1,a=Math.log(o),l=.5*Math.exp(2*a/3),u=.5*Math.sqrt(a*l*(o-l)/o)*(s-o/2<0?-1:1);Kn(t,e,Math.max(n,Math.floor(e-s*l/o+u)),Math.min(r,Math.floor(e+(o-s)*l/o+u)),i)}var h=t[e],c=n,f=r;for(Qn(t,n,e),i(t[r],h)>0&&Qn(t,n,r);c<f;){for(Qn(t,c,f),c++,f--;i(t[c],h)<0;)c++;for(;i(t[f],h)>0;)f--}0===i(t[n],h)?Qn(t,n,f):Qn(t,++f,r),f<=e&&(n=f+1),e<=f&&(r=f-1)}}function Qn(t,e,n){var r=t[e];t[e]=t[n],t[n]=r}function tr(t,e){return t<e?-1:t>e?1:0}class er{constructor(t=9){this._maxEntries=Math.max(4,t),this._minEntries=Math.max(2,Math.ceil(.4*this._maxEntries)),this.clear()}all(){return this._all(this.data,[])}search(t){let e=this.data;const n=[];if(!fr(t,e))return n;const r=this.toBBox,i=[];for(;e;){for(let o=0;o<e.children.length;o++){const s=e.children[o],a=e.leaf?r(s):s;fr(t,a)&&(e.leaf?n.push(s):cr(t,a)?this._all(s,n):i.push(s))}e=i.pop()}return n}collides(t){let e=this.data;if(!fr(t,e))return!1;const n=[];for(;e;){for(let r=0;r<e.children.length;r++){const i=e.children[r],o=e.leaf?this.toBBox(i):i;if(fr(t,o)){if(e.leaf||cr(t,o))return!0;n.push(i)}}e=n.pop()}return!1}load(t){if(!t||!t.length)return this;if(t.length<this._minEntries){for(let e=0;e<t.length;e++)this.insert(t[e]);return this}let e=this._build(t.slice(),0,t.length-1,0);if(this.data.children.length)if(this.data.height===e.height)this._splitRoot(this.data,e);else{if(this.data.height<e.height){const t=this.data;this.data=e,e=t}this._insert(e,this.data.height-e.height-1,!0)}else this.data=e;return this}insert(t){return t&&this._insert(t,this.data.height-1),this}clear(){return this.data=pr([]),this}remove(t,e){if(!t)return this;let n=this.data;const r=this.toBBox(t),i=[],o=[];let s,a,l;for(;n||i.length;){if(n||(n=i.pop(),a=i[i.length-1],s=o.pop(),l=!0),n.leaf){const r=nr(t,n.children,e);if(-1!==r)return n.children.splice(r,1),i.push(n),this._condense(i),this}l||n.leaf||!cr(n,r)?a?(s++,n=a.children[s],l=!1):n=null:(i.push(n),o.push(s),s=0,a=n,n=n.children[0])}return this}toBBox(t){return t}compareMinX(t,e){return t.minX-e.minX}compareMinY(t,e){return t.minY-e.minY}toJSON(){return this.data}fromJSON(t){return this.data=t,this}_all(t,e){const n=[];for(;t;)t.leaf?e.push(...t.children):n.push(...t.children),t=n.pop();return e}_build(t,e,n,r){const i=n-e+1;let o,s=this._maxEntries;if(i<=s)return o=pr(t.slice(e,n+1)),rr(o,this.toBBox),o;r||(r=Math.ceil(Math.log(i)/Math.log(s)),s=Math.ceil(i/Math.pow(s,r-1))),o=pr([]),o.leaf=!1,o.height=r;const a=Math.ceil(i/s),l=a*Math.ceil(Math.sqrt(s));dr(t,e,n,l,this.compareMinX);for(let i=e;i<=n;i+=l){const e=Math.min(i+l-1,n);dr(t,i,e,a,this.compareMinY);for(let n=i;n<=e;n+=a){const i=Math.min(n+a-1,e);o.children.push(this._build(t,n,i,r-1))}}return rr(o,this.toBBox),o}_chooseSubtree(t,e,n,r){for(;r.push(e),!e.leaf&&r.length-1!==n;){let n,r=1/0,s=1/0;for(let a=0;a<e.children.length;a++){const l=e.children[a],u=lr(l),h=(i=t,o=l,(Math.max(o.maxX,i.maxX)-Math.min(o.minX,i.minX))*(Math.max(o.maxY,i.maxY)-Math.min(o.minY,i.minY))-u);h<s?(s=h,r=u<r?u:r,n=l):h===s&&u<r&&(r=u,n=l)}e=n||e.children[0]}var i,o;return e}_insert(t,e,n){const r=n?t:this.toBBox(t),i=[],o=this._chooseSubtree(r,this.data,e,i);for(o.children.push(t),or(o,r);e>=0&&i[e].children.length>this._maxEntries;)this._split(i,e),e--;this._adjustParentBBoxes(r,i,e)}_split(t,e){const n=t[e],r=n.children.length,i=this._minEntries;this._chooseSplitAxis(n,i,r);const o=this._chooseSplitIndex(n,i,r),s=pr(n.children.splice(o,n.children.length-o));s.height=n.height,s.leaf=n.leaf,rr(n,this.toBBox),rr(s,this.toBBox),e?t[e-1].children.push(s):this._splitRoot(n,s)}_splitRoot(t,e){this.data=pr([t,e]),this.data.height=t.height+1,this.data.leaf=!1,rr(this.data,this.toBBox)}_chooseSplitIndex(t,e,n){let r,i=1/0,o=1/0;for(let s=e;s<=n-e;s++){const e=ir(t,0,s,this.toBBox),a=ir(t,s,n,this.toBBox),l=hr(e,a),u=lr(e)+lr(a);l<i?(i=l,r=s,o=u<o?u:o):l===i&&u<o&&(o=u,r=s)}return r||n-e}_chooseSplitAxis(t,e,n){const r=t.leaf?this.compareMinX:sr,i=t.leaf?this.compareMinY:ar;this._allDistMargin(t,e,n,r)<this._allDistMargin(t,e,n,i)&&t.children.sort(r)}_allDistMargin(t,e,n,r){t.children.sort(r);const i=this.toBBox,o=ir(t,0,e,i),s=ir(t,n-e,n,i);let a=ur(o)+ur(s);for(let r=e;r<n-e;r++){const e=t.children[r];or(o,t.leaf?i(e):e),a+=ur(o)}for(let r=n-e-1;r>=e;r--){const e=t.children[r];or(s,t.leaf?i(e):e),a+=ur(s)}return a}_adjustParentBBoxes(t,e,n){for(let r=n;r>=0;r--)or(e[r],t)}_condense(t){for(let e,n=t.length-1;n>=0;n--)0===t[n].children.length?n>0?(e=t[n-1].children,e.splice(e.indexOf(t[n]),1)):this.clear():rr(t[n],this.toBBox)}}function nr(t,e,n){if(!n)return e.indexOf(t);for(let r=0;r<e.length;r++)if(n(t,e[r]))return r;return-1}function rr(t,e){ir(t,0,t.children.length,e,t)}function ir(t,e,n,r,i){i||(i=pr(null)),i.minX=1/0,i.minY=1/0,i.maxX=-1/0,i.maxY=-1/0;for(let o=e;o<n;o++){const e=t.children[o];or(i,t.leaf?r(e):e)}return i}function or(t,e){return t.minX=Math.min(t.minX,e.minX),t.minY=Math.min(t.minY,e.minY),t.maxX=Math.max(t.maxX,e.maxX),t.maxY=Math.max(t.maxY,e.maxY),t}function sr(t,e){return t.minX-e.minX}function ar(t,e){return t.minY-e.minY}function lr(t){return(t.maxX-t.minX)*(t.maxY-t.minY)}function ur(t){return t.maxX-t.minX+(t.maxY-t.minY)}function hr(t,e){const n=Math.max(t.minX,e.minX),r=Math.max(t.minY,e.minY),i=Math.min(t.maxX,e.maxX),o=Math.min(t.maxY,e.maxY);return Math.max(0,i-n)*Math.max(0,o-r)}function cr(t,e){return t.minX<=e.minX&&t.minY<=e.minY&&e.maxX<=t.maxX&&e.maxY<=t.maxY}function fr(t,e){return e.minX<=t.maxX&&e.minY<=t.maxY&&e.maxX>=t.minX&&e.maxY>=t.minY}function pr(t){return{children:t,height:1,leaf:!0,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0}}function dr(t,e,n,r,i){const o=[e,n];for(;o.length;){if((n=o.pop())-(e=o.pop())<=r)continue;const s=e+Math.ceil((n-e)/r/2)*r;Wn(t,s,e,n,i),o.push(e,s,s,n)}}class gr{constructor(t=[],e=yr){if(this.data=t,this.length=this.data.length,this.compare=e,this.length>0)for(let t=(this.length>>1)-1;t>=0;t--)this._down(t)}push(t){this.data.push(t),this.length++,this._up(this.length-1)}pop(){if(0===this.length)return;const t=this.data[0],e=this.data.pop();return this.length--,this.length>0&&(this.data[0]=e,this._down(0)),t}peek(){return this.data[0]}_up(t){const{data:e,compare:n}=this,r=e[t];for(;t>0;){const i=t-1>>1,o=e[i];if(n(r,o)>=0)break;e[t]=o,t=i}e[t]=r}_down(t){const{data:e,compare:n}=this,r=this.length>>1,i=e[t];for(;t<r;){let r=1+(t<<1),o=e[r];const s=r+1;if(s<this.length&&n(e[s],o)<0&&(r=s,o=e[s]),n(o,i)>=0)break;e[t]=o,t=r}e[t]=i}}function yr(t,e){return t<e?-1:t>e?1:0}function xr(t){return t&&t.__esModule&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t}var mr={exports:{}},vr=function(t,e,n,r){var i=t[0],o=t[1],s=!1;void 0===n&&(n=0),void 0===r&&(r=e.length);for(var a=(r-n)/2,l=0,u=a-1;l<a;u=l++){var h=e[n+2*l+0],c=e[n+2*l+1],f=e[n+2*u+0],p=e[n+2*u+1];c>o!=p>o&&i<(f-h)*(o-c)/(p-c)+h&&(s=!s)}return s},wr=function(t,e,n,r){var i=t[0],o=t[1],s=!1;void 0===n&&(n=0),void 0===r&&(r=e.length);for(var a=r-n,l=0,u=a-1;l<a;u=l++){var h=e[l+n][0],c=e[l+n][1],f=e[u+n][0],p=e[u+n][1];c>o!=p>o&&i<(f-h)*(o-c)/(p-c)+h&&(s=!s)}return s};mr.exports=function(t,e,n,r){return e.length>0&&Array.isArray(e[0])?wr(t,e,n,r):vr(t,e,n,r)};var br=mr.exports.nested=wr;mr.exports.flat=vr;const Mr=11102230246251565e-32,Pr=134217729,_r=(3+8*Mr)*Mr;function Ar(t,e,n,r,i){let o,s,a,l,u=e[0],h=r[0],c=0,f=0;h>u==h>-u?(o=u,u=e[++c]):(o=h,h=r[++f]);let p=0;if(c<t&&f<n)for(h>u==h>-u?(s=u+o,a=o-(s-u),u=e[++c]):(s=h+o,a=o-(s-h),h=r[++f]),o=s,0!==a&&(i[p++]=a);c<t&&f<n;)h>u==h>-u?(s=o+u,l=s-o,a=o-(s-l)+(u-l),u=e[++c]):(s=o+h,l=s-o,a=o-(s-l)+(h-l),h=r[++f]),o=s,0!==a&&(i[p++]=a);for(;c<t;)s=o+u,l=s-o,a=o-(s-l)+(u-l),u=e[++c],o=s,0!==a&&(i[p++]=a);for(;f<n;)s=o+h,l=s-o,a=o-(s-l)+(h-l),h=r[++f],o=s,0!==a&&(i[p++]=a);return 0===o&&0!==p||(i[p++]=o),p}function Ir(t){return new Float64Array(t)}const Sr=33306690738754716e-32,Tr=22204460492503146e-32,Fr=11093356479670487e-47,kr=Ir(4),Lr=Ir(8),Cr=Ir(12),Br=Ir(16),Or=Ir(4);function Yr(t,e,n,r,i,o){const s=(e-o)*(n-i),a=(t-i)*(r-o),l=s-a;if(0===s||0===a||s>0!=a>0)return l;const u=Math.abs(s+a);return Math.abs(l)>=Sr*u?l:-function(t,e,n,r,i,o,s){let a,l,u,h,c,f,p,d,g,y,x,m,v,w,b,M,P,_;const A=t-i,I=n-i,S=e-o,T=r-o;w=A*T,f=Pr*A,p=f-(f-A),d=A-p,f=Pr*T,g=f-(f-T),y=T-g,b=d*y-(w-p*g-d*g-p*y),M=S*I,f=Pr*S,p=f-(f-S),d=S-p,f=Pr*I,g=f-(f-I),y=I-g,P=d*y-(M-p*g-d*g-p*y),x=b-P,c=b-x,kr[0]=b-(x+c)+(c-P),m=w+x,c=m-w,v=w-(m-c)+(x-c),x=v-M,c=v-x,kr[1]=v-(x+c)+(c-M),_=m+x,c=_-m,kr[2]=m-(_-c)+(x-c),kr[3]=_;let F=function(t,e){let n=e[0];for(let r=1;r<t;r++)n+=e[r];return n}(4,kr),k=Tr*s;if(F>=k||-F>=k)return F;if(c=t-A,a=t-(A+c)+(c-i),c=n-I,u=n-(I+c)+(c-i),c=e-S,l=e-(S+c)+(c-o),c=r-T,h=r-(T+c)+(c-o),0===a&&0===l&&0===u&&0===h)return F;if(k=Fr*s+_r*Math.abs(F),F+=A*h+T*a-(S*u+I*l),F>=k||-F>=k)return F;w=a*T,f=Pr*a,p=f-(f-a),d=a-p,f=Pr*T,g=f-(f-T),y=T-g,b=d*y-(w-p*g-d*g-p*y),M=l*I,f=Pr*l,p=f-(f-l),d=l-p,f=Pr*I,g=f-(f-I),y=I-g,P=d*y-(M-p*g-d*g-p*y),x=b-P,c=b-x,Or[0]=b-(x+c)+(c-P),m=w+x,c=m-w,v=w-(m-c)+(x-c),x=v-M,c=v-x,Or[1]=v-(x+c)+(c-M),_=m+x,c=_-m,Or[2]=m-(_-c)+(x-c),Or[3]=_;const L=Ar(4,kr,4,Or,Lr);w=A*h,f=Pr*A,p=f-(f-A),d=A-p,f=Pr*h,g=f-(f-h),y=h-g,b=d*y-(w-p*g-d*g-p*y),M=S*u,f=Pr*S,p=f-(f-S),d=S-p,f=Pr*u,g=f-(f-u),y=u-g,P=d*y-(M-p*g-d*g-p*y),x=b-P,c=b-x,Or[0]=b-(x+c)+(c-P),m=w+x,c=m-w,v=w-(m-c)+(x-c),x=v-M,c=v-x,Or[1]=v-(x+c)+(c-M),_=m+x,c=_-m,Or[2]=m-(_-c)+(x-c),Or[3]=_;const C=Ar(L,Lr,4,Or,Cr);w=a*h,f=Pr*a,p=f-(f-a),d=a-p,f=Pr*h,g=f-(f-h),y=h-g,b=d*y-(w-p*g-d*g-p*y),M=l*u,f=Pr*l,p=f-(f-l),d=l-p,f=Pr*u,g=f-(f-u),y=u-g,P=d*y-(M-p*g-d*g-p*y),x=b-P,c=b-x,Or[0]=b-(x+c)+(c-P),m=w+x,c=m-w,v=w-(m-c)+(x-c),x=v-M,c=v-x,Or[1]=v-(x+c)+(c-M),_=m+x,c=_-m,Or[2]=m-(_-c)+(x-c),Or[3]=_;const B=Ar(C,Cr,4,Or,Br);return Br[B-1]}(t,e,n,r,i,o,u)}function Vr(t,e,n){e=Math.max(0,void 0===e?2:e),n=n||0;var r=function(t){for(var e=t[0],n=t[0],r=t[0],i=t[0],o=0;o<t.length;o++){var s=t[o];s[0]<e[0]&&(e=s),s[0]>r[0]&&(r=s),s[1]<n[1]&&(n=s),s[1]>i[1]&&(i=s)}var a=[e,n,r,i],l=a.slice();for(o=0;o<t.length;o++)br(t[o],a)||l.push(t[o]);return function(t){t.sort(Rr);for(var e=[],n=0;n<t.length;n++){for(;e.length>=2&&$r(e[e.length-2],e[e.length-1],t[n])<=0;)e.pop();e.push(t[n])}for(var r=[],i=t.length-1;i>=0;i--){for(;r.length>=2&&$r(r[r.length-2],r[r.length-1],t[i])<=0;)r.pop();r.push(t[i])}return r.pop(),e.pop(),e.concat(r)}(l)}(t),i=new er(16);i.toBBox=function(t){return{minX:t[0],minY:t[1],maxX:t[0],maxY:t[1]}},i.compareMinX=function(t,e){return t[0]-e[0]},i.compareMinY=function(t,e){return t[1]-e[1]},i.load(t);for(var o,s=[],a=0;a<r.length;a++){var l=r[a];i.remove(l),o=Gr(l,o),s.push(o)}var u=new er(16);for(a=0;a<s.length;a++)u.insert(qr(s[a]));for(var h=e*e,c=n*n;s.length;){var f=s.shift(),p=f.p,d=f.next.p,g=jr(p,d);if(!(g<c)){var y=g/h;(l=Xr(i,f.prev.p,p,d,f.next.next.p,y,u))&&Math.min(jr(l,p),jr(l,d))<=y&&(s.push(f),s.push(Gr(l,f)),i.remove(l),u.remove(f),u.insert(qr(f)),u.insert(qr(f.next)))}}f=o;var x=[];do{x.push(f.p),f=f.next}while(f!==o);return x.push(f.p),x}function Xr(t,e,n,r,i,o,s){for(var a=new gr([],Nr),l=t.data;l;){for(var u=0;u<l.children.length;u++){var h=l.children[u],c=l.leaf?Ur(h,n,r):Er(n,r,h);c>o||a.push({node:h,dist:c})}for(;a.length&&!a.peek().node.children;){var f=a.pop(),p=f.node,d=Ur(p,e,n),g=Ur(p,r,i);if(f.dist<d&&f.dist<g&&Dr(n,p,s)&&Dr(r,p,s))return p}(l=a.pop())&&(l=l.node)}return null}function Nr(t,e){return t.dist-e.dist}function Er(t,e,n){if(zr(t,n)||zr(e,n))return 0;var r=Zr(t[0],t[1],e[0],e[1],n.minX,n.minY,n.maxX,n.minY);if(0===r)return 0;var i=Zr(t[0],t[1],e[0],e[1],n.minX,n.minY,n.minX,n.maxY);if(0===i)return 0;var o=Zr(t[0],t[1],e[0],e[1],n.maxX,n.minY,n.maxX,n.maxY);if(0===o)return 0;var s=Zr(t[0],t[1],e[0],e[1],n.minX,n.maxY,n.maxX,n.maxY);return 0===s?0:Math.min(r,i,o,s)}function zr(t,e){return t[0]>=e.minX&&t[0]<=e.maxX&&t[1]>=e.minY&&t[1]<=e.maxY}function Dr(t,e,n){for(var r,i,o,s,a=Math.min(t[0],e[0]),l=Math.min(t[1],e[1]),u=Math.max(t[0],e[0]),h=Math.max(t[1],e[1]),c=n.search({minX:a,minY:l,maxX:u,maxY:h}),f=0;f<c.length;f++)if(r=c[f].p,i=c[f].next.p,o=t,r!==(s=e)&&i!==o&&$r(r,i,o)>0!=$r(r,i,s)>0&&$r(o,s,r)>0!=$r(o,s,i)>0)return!1;return!0}function $r(t,e,n){return Yr(t[0],t[1],e[0],e[1],n[0],n[1])}function qr(t){var e=t.p,n=t.next.p;return t.minX=Math.min(e[0],n[0]),t.minY=Math.min(e[1],n[1]),t.maxX=Math.max(e[0],n[0]),t.maxY=Math.max(e[1],n[1]),t}function Gr(t,e){var n={p:t,prev:null,next:null,minX:0,minY:0,maxX:0,maxY:0};return e?(n.next=e.next,n.prev=e,e.next.prev=n,e.next=n):(n.prev=n,n.next=n),n}function jr(t,e){var n=t[0]-e[0],r=t[1]-e[1];return n*n+r*r}function Ur(t,e,n){var r=e[0],i=e[1],o=n[0]-r,s=n[1]-i;if(0!==o||0!==s){var a=((t[0]-r)*o+(t[1]-i)*s)/(o*o+s*s);a>1?(r=n[0],i=n[1]):a>0&&(r+=o*a,i+=s*a)}return(o=t[0]-r)*o+(s=t[1]-i)*s}function Zr(t,e,n,r,i,o,s,a){var l,u,h,c,f=n-t,p=r-e,d=s-i,g=a-o,y=t-i,x=e-o,m=f*f+p*p,v=f*d+p*g,w=d*d+g*g,b=f*y+p*x,M=d*y+g*x,P=m*w-v*v,_=P,A=P;0===P?(u=0,_=1,c=M,A=w):(c=m*M-v*b,(u=v*M-w*b)<0?(u=0,c=M,A=w):u>_&&(u=_,c=M+v,A=w)),c<0?(c=0,-b<0?u=0:-b>m?u=_:(u=-b,_=m)):c>A&&(c=A,-b+v<0?u=0:-b+v>m?u=_:(u=-b+v,_=m));var I=(1-(h=0===c?0:c/A))*i+h*s-((1-(l=0===u?0:u/_))*t+l*n),S=(1-h)*o+h*a-((1-l)*e+l*r);return I*I+S*S}function Rr(t,e){return t[0]===e[0]?t[1]-e[1]:t[0]-e[0]}const{PackUtil:Jr}=re();class Hr{constructor(t,e){this.x=t,this.y=e}clone(){return new Hr(this.x,this.y)}normalize(){const t=this.length();this.x/=t,this.y/=t}negate(){this.x=-this.x,this.y=-this.y}length(){return Math.sqrt(this.x*this.x+this.y*this.y)}diff(t){return new Hr(this.x-t.x,this.y-t.y)}distance(t){const e=this.x-t.x,n=this.y-t.y;return Math.sqrt(e*e+n*n)}dot(t){return this.x*t.x+this.y*t.y}equals(t){return this.x===t.x&&this.y===t.y}orthogonal(){return new Hr(this.y,-this.x)}}function Wr(t,e,n,r){const i=e.x*r.y-e.y*r.x,o=n.x-t.x,s=n.y-t.y,a=(o*r.y-s*r.x)/i;return new Hr(t.x+a*e.x,t.y+a*e.y)}const Kr=[],Qr=[];function ti(t){if(S(t[0]&&t[0].x)){const e=[];let n=0;for(let r=0;r<t.length;r++)Qr[n]?(Qr[n][0]=t[r].x,Qr[n][1]=t[r].y):Qr[n]=[t[r].x,t[r].y],e.push(Qr[n]),n++;t=e}try{const e=Vr(t,1/0);let n=[1/0,1/0],r=[-1/0,-1/0];for(let t=0;t<e.length;t++)e[t][0]<n[0]&&(n[0]=e[t][0]),e[t][0]>r[0]&&(r[0]=e[t][0]),e[t][1]<n[1]&&(n[1]=e[t][1]),e[t][1]>r[1]&&(r[1]=e[t][1]);const i=[];let o=[],s=0;for(let t=0;t<e.length;t++)t===e.length-1&&e[t][0]===e[0][0]&&e[t][1]===e[0][1]||(_t(i,e[t],"EPSG:3857"),Kr[s]?(Kr[s].x=i[0],Kr[s].y=i[1]):Kr[s]=new Hr(i[0],i[1]),o.push(Kr[s]),s++);Jr.calculateSignedArea(o)<0&&(o=o.reverse());const a=function(t){let e,n=Number.MAX_VALUE;const r=function(t,r,i,o,s,a,l,u){var h=Wr(t,r,s,a),c=Wr(i,o,s,a),f=Wr(l,u,t,r),p=Wr(l,u,i,o),d=h.distance(c)*h.distance(f);0!==d&&d<n&&(e=[h,f,p,c],n=d)};var i=[];for(let e=0;e<t.length;e++)i.push(t[(e+1)%t.length].diff(t[e])),i[e].normalize();var o,s,a,l,u=new Hr(Number.POSITIVE_INFINITY,Number.POSITIVE_INFINITY),h=new Hr(Number.NEGATIVE_INFINITY,Number.NEGATIVE_INFINITY);for(let e=0;e<t.length;e++){var c=t[e];c.x<u.x&&(u.x=c.x,o=e),c.x>h.x&&(h.x=c.x,s=e),c.y<u.y&&(u.y=c.y,l=e),c.y>h.y&&(h.y=c.y,a=e)}var f=new Hr(0,-1),p=new Hr(0,1),d=new Hr(-1,0),g=new Hr(1,0);for(let e=0;e<t.length;e++){var y=[Math.acos(f.dot(i[o])),Math.acos(p.dot(i[s])),Math.acos(d.dot(i[a])),Math.acos(g.dot(i[l]))];switch(y.indexOf(Math.min.apply(Math,y))){case 0:(p=(f=i[o].clone()).clone()).negate(),(g=(d=f.orthogonal()).clone()).negate(),o=(o+1)%t.length;break;case 1:(f=(p=i[s].clone()).clone()).negate(),(g=(d=f.orthogonal()).clone()).negate(),s=(s+1)%t.length;break;case 2:(g=(d=i[a].clone()).clone()).negate(),(p=(f=g.orthogonal()).clone()).negate(),a=(a+1)%t.length;break;case 3:(d=(g=i[l].clone()).clone()).negate(),(p=(f=g.orthogonal()).clone()).negate(),l=(l+1)%t.length}r(t[o],f,t[s],p,t[a],d,t[l],g)}return e}(o);if(!a||4!==a.length)return null;const l=a[0].distance(a[1]),u=a[1].distance(a[2]),h=a.map((t=>[t.x,t.y]));return h.push(+(u>l)),h}catch(t){return null}}const ei=[];function ni(t,e){const n=Array.isArray(t&&t[0]&&t[0][0]);for(let r=0;r<t.length;r++)n?t[r]=ni(t[r]):(_t(ei,t[r],e),t[r][0]=ei[0],t[r][1]=ei[1]);return t}const{PackUtil:ri}=re();class ii extends Ln{constructor(t,e,n,r,i,o){super(t,e,n,r,i),(e=e||{}).extent||(e.extent=8192),this.setData(e.data,o)}clearData(){delete this.index,this.clearCache()}setData(t,e){if(delete this.index,function(t){if(!t)return!0;if(Array.isArray(t)&&!t.length)return!0;if(t.features&&!t.features.length)return!0;return!1}(t))return this.empty=!0,void e();this.empty=!1;const n={maxZoom:24,tolerance:this.options.simplifyTolerance,extent:this.options.extent,buffer:S(this.options.tileBuffer)?this.options.tileBuffer:64,hasAltitude:!!this.options.hasAltitude,debug:0,lineMetrics:!0,indexMaxZoom:5,indexMaxPoints:1e5,disableFilter:!0};if(this.options.projection&&(n.projection=this.options.projection,"EPSG:4490"===n.projection&&(n.projection="EPSG:4326")),I(t)&&"{"!=t.substring(0,1)||t.url){const r=t.url?t.url:t;O.getJSON(r,t.url?t:{},((t,i)=>{if(t&&(console.error("Failed to fetch geojson:"+r),e(t)),!i)return void e(null,{extent:null,idMap:new Map});let o=i;if(this.options.convertFn){o=new Function("data",this.options.convertFn+"\\nreturn convert(data)")(o)}const s=Array.isArray(o)?o:o.features;this._genOMBB(s);const{sample1000:a,idMap:l}=this._generateId(s);this.clearCache(),this._generate(a,l,o,n,e)}))}else{"string"==typeof t&&(t=JSON.parse(t));const r=Array.isArray(t)?t:t.features;this._genOMBB(r);let i=r;this.clearCache(),this._generate(i,null,t,n,e)}}_genOMBB(t){if(this.options.generateOMBB&&t)for(let e=0;e<t.length;e++){const n=t[e];if(n&&n.geometry&&n.geometry.coordinates)if("Polygon"===n.geometry.type){const t=n.geometry.coordinates[0];if(!t)continue;const e=ti(t,t.length);n.properties=n.properties||{},n.properties[ne]=e}else if("MultiPolygon"===n.geometry.type){const t=n.geometry.coordinates;for(let e=0;e<t.length;e++){if(!t[e])continue;const r=t[e][0];if(!r)continue;const i=ti(r,r.length);n.properties=n.properties||{},n.properties[ne]=n.properties[ne]||[],n.properties[ne][e]=i}}}}_generate(t,e,n,r,i){try{const o=t&&t.length?function(t){let e=[Number.POSITIVE_INFINITY,Number.POSITIVE_INFINITY,Number.NEGATIVE_INFINITY,Number.NEGATIVE_INFINITY];switch(t.type){case"FeatureCollection":const n=t.features.length;for(let r=0;r<n;r++)Un(t.features[r],e);break;case"Feature":Un(t,e);break;default:Zn(t,e)}return e}({type:"FeatureCollection",features:t}):null;this.index=function(t,e){return new ht(t,e)}(n,this.options.geojsonvt||r),i(null,{extent:o,idMap:e})}catch(t){console.warn(t),i({error:t.message})}}_generateId(t){const e=[],n=new Map;let r=0;const i=this.options.featureIdProperty;return t&&(t.length,t.forEach(((t,o)=>{!function(t,o,s){if(!t)return;if("Feature"===t.type&&!t.geometry)return;if(S(t.id)||(t.id=r++),i){let e=i;F(i)&&(e=i[t.layer||"0"]),t.id=t.properties[e]}const a=A({},t);t.geometry?(a.geometry=A({},t.geometry),a.geometry.coordinates=null):t.coordinates&&(a.coordinates=null),n.set(t.id,a),e.push(t)}(t)}))),{sample1000:e,idMap:n}}getTileFeatures(t,e){const n=t.tileInfo,r=[];if(!this.index)return this.empty?(setTimeout((function(){e(null,r,[])}),1),1):(setTimeout((function(){e({loading:!0})}),1),1);const i=this.index.getTile(n.z,n.x,n.y);if(!i||0===i.features.length)return setTimeout((function(){e(null,r,[])}),1),1;const o=[];for(let t=0,e=i.features.length;t<e;t++){const e=i.features[t];let n=e.layer;void 0===n&&(n="0"),o[n]={types:{}};o[n].types[e.type]=1,e.tags=e.tags||{},e.geometry.converted||(ri.convertGeometry(e),e.geometry.converted=1),r.push({type:e.type,layer:n,id:e.id,geometry:e.geometry,properties:e.tags,extent:this.options.extent})}for(const t in o)o[t].types=Object.keys(o[t].types).map((t=>+t));return setTimeout((function(){e(null,r,o)}),1),1}onRemove(){super.onRemove(),delete this.index}}var oi={\n/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */\nread:function(t,e,n,r,i){var o,s,a=8*i-r-1,l=(1<<a)-1,u=l>>1,h=-7,c=n?i-1:0,f=n?-1:1,p=t[e+c];for(c+=f,o=p&(1<<-h)-1,p>>=-h,h+=a;h>0;o=256*o+t[e+c],c+=f,h-=8);for(s=o&(1<<-h)-1,o>>=-h,h+=r;h>0;s=256*s+t[e+c],c+=f,h-=8);if(0===o)o=1-u;else{if(o===l)return s?NaN:1/0*(p?-1:1);s+=Math.pow(2,r),o-=u}return(p?-1:1)*s*Math.pow(2,o-r)},write:function(t,e,n,r,i,o){var s,a,l,u=8*o-i-1,h=(1<<u)-1,c=h>>1,f=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,p=r?0:o-1,d=r?1:-1,g=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(a=isNaN(e)?1:0,s=h):(s=Math.floor(Math.log(e)/Math.LN2),e*(l=Math.pow(2,-s))<1&&(s--,l*=2),(e+=s+c>=1?f/l:f*Math.pow(2,1-c))*l>=2&&(s++,l/=2),s+c>=h?(a=0,s=h):s+c>=1?(a=(e*l-1)*Math.pow(2,i),s+=c):(a=e*Math.pow(2,c-1)*Math.pow(2,i),s=0));i>=8;t[n+p]=255&a,p+=d,a/=256,i-=8);for(s=s<<i|a,u+=i;u>0;t[n+p]=255&s,p+=d,s/=256,u-=8);t[n+p-d]|=128*g}},si=li,ai=oi;function li(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length}li.Varint=0,li.Fixed64=1,li.Bytes=2,li.Fixed32=5;var ui=4294967296,hi=1/ui,ci="undefined"==typeof TextDecoder?null:new TextDecoder("utf8");function fi(t){return t.type===li.Bytes?t.readVarint()+t.pos:t.pos+1}function pi(t,e,n){return n?4294967296*e+(t>>>0):4294967296*(e>>>0)+(t>>>0)}function di(t,e,n){var r=e<=16383?1:e<=2097151?2:e<=268435455?3:Math.floor(Math.log(e)/(7*Math.LN2));n.realloc(r);for(var i=n.pos-1;i>=t;i--)n.buf[i+r]=n.buf[i]}function gi(t,e){for(var n=0;n<t.length;n++)e.writeVarint(t[n])}function yi(t,e){for(var n=0;n<t.length;n++)e.writeSVarint(t[n])}function xi(t,e){for(var n=0;n<t.length;n++)e.writeFloat(t[n])}function mi(t,e){for(var n=0;n<t.length;n++)e.writeDouble(t[n])}function vi(t,e){for(var n=0;n<t.length;n++)e.writeBoolean(t[n])}function wi(t,e){for(var n=0;n<t.length;n++)e.writeFixed32(t[n])}function bi(t,e){for(var n=0;n<t.length;n++)e.writeSFixed32(t[n])}function Mi(t,e){for(var n=0;n<t.length;n++)e.writeFixed64(t[n])}function Pi(t,e){for(var n=0;n<t.length;n++)e.writeSFixed64(t[n])}function _i(t,e){return(t[e]|t[e+1]<<8|t[e+2]<<16)+16777216*t[e+3]}function Ai(t,e,n){t[n]=e,t[n+1]=e>>>8,t[n+2]=e>>>16,t[n+3]=e>>>24}function Ii(t,e){return(t[e]|t[e+1]<<8|t[e+2]<<16)+(t[e+3]<<24)}li.prototype={destroy:function(){this.buf=null},readFields:function(t,e,n){for(n=n||this.length;this.pos<n;){var r=this.readVarint(),i=r>>3,o=this.pos;this.type=7&r,t(i,e,this),this.pos===o&&this.skip(r)}return e},readMessage:function(t,e){return this.readFields(t,e,this.readVarint()+this.pos)},readFixed32:function(){var t=_i(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=Ii(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=_i(this.buf,this.pos)+_i(this.buf,this.pos+4)*ui;return this.pos+=8,t},readSFixed64:function(){var t=_i(this.buf,this.pos)+Ii(this.buf,this.pos+4)*ui;return this.pos+=8,t},readFloat:function(){var t=ai.read(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=ai.read(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var e,n,r=this.buf;return e=127&(n=r[this.pos++]),n<128?e:(e|=(127&(n=r[this.pos++]))<<7,n<128?e:(e|=(127&(n=r[this.pos++]))<<14,n<128?e:(e|=(127&(n=r[this.pos++]))<<21,n<128?e:function(t,e,n){var r,i,o=n.buf;if(i=o[n.pos++],r=(112&i)>>4,i<128)return pi(t,r,e);if(i=o[n.pos++],r|=(127&i)<<3,i<128)return pi(t,r,e);if(i=o[n.pos++],r|=(127&i)<<10,i<128)return pi(t,r,e);if(i=o[n.pos++],r|=(127&i)<<17,i<128)return pi(t,r,e);if(i=o[n.pos++],r|=(127&i)<<24,i<128)return pi(t,r,e);if(i=o[n.pos++],r|=(1&i)<<31,i<128)return pi(t,r,e);throw new Error("Expected varint not more than 10 bytes")}(e|=(15&(n=r[this.pos]))<<28,t,this))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,e=this.pos;return this.pos=t,t-e>=12&&ci?function(t,e,n){return ci.decode(t.subarray(e,n))}(this.buf,e,t):function(t,e,n){var r="",i=e;for(;i<n;){var o,s,a,l=t[i],u=null,h=l>239?4:l>223?3:l>191?2:1;if(i+h>n)break;1===h?l<128&&(u=l):2===h?128==(192&(o=t[i+1]))&&(u=(31&l)<<6|63&o)<=127&&(u=null):3===h?(o=t[i+1],s=t[i+2],128==(192&o)&&128==(192&s)&&((u=(15&l)<<12|(63&o)<<6|63&s)<=2047||u>=55296&&u<=57343)&&(u=null)):4===h&&(o=t[i+1],s=t[i+2],a=t[i+3],128==(192&o)&&128==(192&s)&&128==(192&a)&&((u=(15&l)<<18|(63&o)<<12|(63&s)<<6|63&a)<=65535||u>=1114112)&&(u=null)),null===u?(u=65533,h=1):u>65535&&(u-=65536,r+=String.fromCharCode(u>>>10&1023|55296),u=56320|1023&u),r+=String.fromCharCode(u),i+=h}return r}(this.buf,e,t)},readBytes:function(){var t=this.readVarint()+this.pos,e=this.buf.subarray(this.pos,t);return this.pos=t,e},readPackedVarint:function(t,e){if(this.type!==li.Bytes)return t.push(this.readVarint(e));var n=fi(this);for(t=t||[];this.pos<n;)t.push(this.readVarint(e));return t},readPackedSVarint:function(t){if(this.type!==li.Bytes)return t.push(this.readSVarint());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){if(this.type!==li.Bytes)return t.push(this.readBoolean());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readBoolean());return t},readPackedFloat:function(t){if(this.type!==li.Bytes)return t.push(this.readFloat());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readFloat());return t},readPackedDouble:function(t){if(this.type!==li.Bytes)return t.push(this.readDouble());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readDouble());return t},readPackedFixed32:function(t){if(this.type!==li.Bytes)return t.push(this.readFixed32());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){if(this.type!==li.Bytes)return t.push(this.readSFixed32());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){if(this.type!==li.Bytes)return t.push(this.readFixed64());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){if(this.type!==li.Bytes)return t.push(this.readSFixed64());var e=fi(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed64());return t},skip:function(t){var e=7&t;if(e===li.Varint)for(;this.buf[this.pos++]>127;);else if(e===li.Bytes)this.pos=this.readVarint()+this.pos;else if(e===li.Fixed32)this.pos+=4;else{if(e!==li.Fixed64)throw new Error("Unimplemented type: "+e);this.pos+=8}},writeTag:function(t,e){this.writeVarint(t<<3|e)},realloc:function(t){for(var e=this.length||16;e<this.pos+t;)e*=2;if(e!==this.length){var n=new Uint8Array(e);n.set(this.buf),this.buf=n,this.length=e}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),Ai(this.buf,t,this.pos),this.pos+=4},writeSFixed32:function(t){this.realloc(4),Ai(this.buf,t,this.pos),this.pos+=4},writeFixed64:function(t){this.realloc(8),Ai(this.buf,-1&t,this.pos),Ai(this.buf,Math.floor(t*hi),this.pos+4),this.pos+=8},writeSFixed64:function(t){this.realloc(8),Ai(this.buf,-1&t,this.pos),Ai(this.buf,Math.floor(t*hi),this.pos+4),this.pos+=8},writeVarint:function(t){(t=+t||0)>268435455||t<0?function(t,e){var n,r;t>=0?(n=t%4294967296|0,r=t/4294967296|0):(r=~(-t/4294967296),4294967295^(n=~(-t%4294967296))?n=n+1|0:(n=0,r=r+1|0));if(t>=0x10000000000000000||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");e.realloc(10),function(t,e,n){n.buf[n.pos++]=127&t|128,t>>>=7,n.buf[n.pos++]=127&t|128,t>>>=7,n.buf[n.pos++]=127&t|128,t>>>=7,n.buf[n.pos++]=127&t|128,t>>>=7,n.buf[n.pos]=127&t}(n,0,e),function(t,e){var n=(7&t)<<4;if(e.buf[e.pos++]|=n|((t>>>=3)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;e.buf[e.pos++]=127&t}(r,e)}(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127))))},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t)},writeBoolean:function(t){this.writeVarint(Boolean(t))},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var e=this.pos;this.pos=function(t,e,n){for(var r,i,o=0;o<e.length;o++){if((r=e.charCodeAt(o))>55295&&r<57344){if(!i){r>56319||o+1===e.length?(t[n++]=239,t[n++]=191,t[n++]=189):i=r;continue}if(r<56320){t[n++]=239,t[n++]=191,t[n++]=189,i=r;continue}r=i-55296<<10|r-56320|65536,i=null}else i&&(t[n++]=239,t[n++]=191,t[n++]=189,i=null);r<128?t[n++]=r:(r<2048?t[n++]=r>>6|192:(r<65536?t[n++]=r>>12|224:(t[n++]=r>>18|240,t[n++]=r>>12&63|128),t[n++]=r>>6&63|128),t[n++]=63&r|128)}return n}(this.buf,t,this.pos);var n=this.pos-e;n>=128&&di(e,n,this),this.pos=e-1,this.writeVarint(n),this.pos+=n},writeFloat:function(t){this.realloc(4),ai.write(this.buf,t,this.pos,!0,23,4),this.pos+=4},writeDouble:function(t){this.realloc(8),ai.write(this.buf,t,this.pos,!0,52,8),this.pos+=8},writeBytes:function(t){var e=t.length;this.writeVarint(e),this.realloc(e);for(var n=0;n<e;n++)this.buf[this.pos++]=t[n]},writeRawMessage:function(t,e){this.pos++;var n=this.pos;t(e,this);var r=this.pos-n;r>=128&&di(n,r,this),this.pos=n-1,this.writeVarint(r),this.pos+=r},writeMessage:function(t,e,n){this.writeTag(t,li.Bytes),this.writeRawMessage(e,n)},writePackedVarint:function(t,e){e.length&&this.writeMessage(t,gi,e)},writePackedSVarint:function(t,e){e.length&&this.writeMessage(t,yi,e)},writePackedBoolean:function(t,e){e.length&&this.writeMessage(t,vi,e)},writePackedFloat:function(t,e){e.length&&this.writeMessage(t,xi,e)},writePackedDouble:function(t,e){e.length&&this.writeMessage(t,mi,e)},writePackedFixed32:function(t,e){e.length&&this.writeMessage(t,wi,e)},writePackedSFixed32:function(t,e){e.length&&this.writeMessage(t,bi,e)},writePackedFixed64:function(t,e){e.length&&this.writeMessage(t,Mi,e)},writePackedSFixed64:function(t,e){e.length&&this.writeMessage(t,Pi,e)},writeBytesField:function(t,e){this.writeTag(t,li.Bytes),this.writeBytes(e)},writeFixed32Field:function(t,e){this.writeTag(t,li.Fixed32),this.writeFixed32(e)},writeSFixed32Field:function(t,e){this.writeTag(t,li.Fixed32),this.writeSFixed32(e)},writeFixed64Field:function(t,e){this.writeTag(t,li.Fixed64),this.writeFixed64(e)},writeSFixed64Field:function(t,e){this.writeTag(t,li.Fixed64),this.writeSFixed64(e)},writeVarintField:function(t,e){this.writeTag(t,li.Varint),this.writeVarint(e)},writeSVarintField:function(t,e){this.writeTag(t,li.Varint),this.writeSVarint(e)},writeStringField:function(t,e){this.writeTag(t,li.Bytes),this.writeString(e)},writeFloatField:function(t,e){this.writeTag(t,li.Fixed32),this.writeFloat(e)},writeDoubleField:function(t,e){this.writeTag(t,li.Fixed64),this.writeDouble(e)},writeBooleanField:function(t,e){this.writeVarintField(t,Boolean(e))}};var Si=xr(si),Ti=Fi;function Fi(t,e){this.x=t,this.y=e}Fi.prototype={clone:function(){return new Fi(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,e){return this.clone()._rotateAround(t,e)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var e=t.x-this.x,n=t.y-this.y;return e*e+n*n},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,e){return Math.atan2(this.x*e-this.y*t,this.x*t+this.y*e)},_matMult:function(t){var e=t[0]*this.x+t[1]*this.y,n=t[2]*this.x+t[3]*this.y;return this.x=e,this.y=n,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var e=Math.cos(t),n=Math.sin(t),r=e*this.x-n*this.y,i=n*this.x+e*this.y;return this.x=r,this.y=i,this},_rotateAround:function(t,e){var n=Math.cos(t),r=Math.sin(t),i=e.x+n*(this.x-e.x)-r*(this.y-e.y),o=e.y+r*(this.x-e.x)+n*(this.y-e.y);return this.x=i,this.y=o,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},Fi.convert=function(t){return t instanceof Fi?t:Array.isArray(t)?new Fi(t[0],t[1]):t};var ki=Ti,Li=Ci;function Ci(t,e,n,r,i){this.properties={},this.extent=n,this.type=0,this._pbf=t,this._geometry=-1,this._keys=r,this._values=i,t.readFields(Bi,this,e)}function Bi(t,e,n){1==t?e.id=n.readVarint():2==t?function(t,e){var n=t.readVarint()+t.pos;for(;t.pos<n;){var r=e._keys[t.readVarint()],i=e._values[t.readVarint()];e.properties[r]=i}}(n,e):3==t?e.type=n.readVarint():4==t&&(e._geometry=n.pos)}function Oi(t){for(var e,n,r=0,i=0,o=t.length,s=o-1;i<o;s=i++)e=t[i],r+=((n=t[s]).x-e.x)*(e.y+n.y);return r}Ci.types=["Unknown","Point","LineString","Polygon"],Ci.prototype.loadGeometry=function(){var t=this._pbf;t.pos=this._geometry;for(var e,n=t.readVarint()+t.pos,r=1,i=0,o=0,s=0,a=[];t.pos<n;){if(i<=0){var l=t.readVarint();r=7&l,i=l>>3}if(i--,1===r||2===r)o+=t.readSVarint(),s+=t.readSVarint(),1===r&&(e&&a.push(e),e=[]),e.push(new ki(o,s));else{if(7!==r)throw new Error("unknown command "+r);e&&e.push(e[0].clone())}}return e&&a.push(e),a},Ci.prototype.bbox=function(){var t=this._pbf;t.pos=this._geometry;for(var e=t.readVarint()+t.pos,n=1,r=0,i=0,o=0,s=1/0,a=-1/0,l=1/0,u=-1/0;t.pos<e;){if(r<=0){var h=t.readVarint();n=7&h,r=h>>3}if(r--,1===n||2===n)(i+=t.readSVarint())<s&&(s=i),i>a&&(a=i),(o+=t.readSVarint())<l&&(l=o),o>u&&(u=o);else if(7!==n)throw new Error("unknown command "+n)}return[s,l,a,u]},Ci.prototype.toGeoJSON=function(t,e,n){var r,i,o=this.extent*Math.pow(2,n),s=this.extent*t,a=this.extent*e,l=this.loadGeometry(),u=Ci.types[this.type];function h(t){for(var e=0;e<t.length;e++){var n=t[e],r=180-360*(n.y+a)/o;t[e]=[360*(n.x+s)/o-180,360/Math.PI*Math.atan(Math.exp(r*Math.PI/180))-90]}}switch(this.type){case 1:var c=[];for(r=0;r<l.length;r++)c[r]=l[r][0];h(l=c);break;case 2:for(r=0;r<l.length;r++)h(l[r]);break;case 3:for(l=function(t){var e=t.length;if(e<=1)return[t];for(var n,r,i=[],o=0;o<e;o++){var s=Oi(t[o]);0!==s&&(void 0===r&&(r=s<0),r===s<0?(n&&i.push(n),n=[t[o]]):n.push(t[o]))}n&&i.push(n);return i}(l),r=0;r<l.length;r++)for(i=0;i<l[r].length;i++)h(l[r][i])}1===l.length?l=l[0]:u="Multi"+u;var f={type:"Feature",geometry:{type:u,coordinates:l},properties:this.properties};return"id"in this&&(f.id=this.id),f};var Yi=Li,Vi=Xi;function Xi(t,e){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=t,this._keys=[],this._values=[],this._features=[],t.readFields(Ni,this,e),this.length=this._features.length}function Ni(t,e,n){15===t?e.version=n.readVarint():1===t?e.name=n.readString():5===t?e.extent=n.readVarint():2===t?e._features.push(n.pos):3===t?e._keys.push(n.readString()):4===t&&e._values.push(function(t){var e=null,n=t.readVarint()+t.pos;for(;t.pos<n;){var r=t.readVarint()>>3;e=1===r?t.readString():2===r?t.readFloat():3===r?t.readDouble():4===r?t.readVarint64():5===r?t.readVarint():6===r?t.readSVarint():7===r?t.readBoolean():null}return e}(n))}Xi.prototype.feature=function(t){if(t<0||t>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[t];var e=this._pbf.readVarint()+this._pbf.pos;return new Yi(this._pbf,e,this.extent,this._keys,this._values)};var Ei=Vi,zi=function(t,e){this.layers=t.readFields(Di,{},e)};function Di(t,e,n){if(3===t){var r=new Ei(n,n.readVarint()+n.pos);r.length&&(e[r.name]=r)}}var $i=zi;const qi=2,Gi=new TextDecoder("utf-8");class ji extends Ln{constructor(t,e,n,r,i,o){super(t,e,n,r,i),e=e||{},o()}clearData(){this._abortRequests()}getTileFeatures(t,e){const n=t.tileInfo.url,r=t.fetchOptions||{},{altitudePropertyName:i,disableAltitudeWarning:o}=t,s=this._cache.get(n);if(s&&s.cacheIndex===t.workerCacheIndex){const{err:t,data:r}=s;return setTimeout((()=>{this._readTile(n,i,o,t,r,e)}),1)}const{tileArrayBuffer:a}=t;if(a)return setTimeout((()=>{this._readTile(n,i,o,null,a,e)}),1);r.referrer=t.referrer,r.errorLog=t.loadTileErrorLog;const{loadTileCachMaxSize:l,loadTileCacheLog:u}=t;return O.getArrayBuffer(n,r,((r,s)=>{if(!this._cache)return;let a,h=!1;const c=()=>{this._readTile(n,i,o,r,a,e)};if(r)r.loading||this._cache.add(n,{err:r,data:s&&s.data,cacheIndex:t.workerCacheIndex});else if(s&&s.data){h=!0,a=s.data;const e=function(t){if(!t)return!1;if(!(t instanceof ArrayBuffer))return!1;try{const e=new Uint8Array(t),n=e[0],r=e[1];return 31===n&&139===r}catch(t){console.error("arraybufferIsGZip read buffer error:",t)}return!1}(a),r=()=>{let e=!0;if(a&&("number"==typeof(i=l)&&!isNaN(i))&&l>0){const t=(r=a)&&r instanceof ArrayBuffer?r.byteLength/1048576:0;t>l&&(e=!1,u&&console.warn(\`url:${W}n},loadTileCachMaxSize exceeded: ${W}t} > ${W}l},the tile will not be cached.\`))}var r,i;e&&a&&this._cache.add(n,{err:null,data:a,cacheIndex:t.workerCacheIndex}),c()};e?function(t,e){try{const n=new DecompressionStream("gzip"),r=new Blob([t]).stream().pipeThrough(n);new Response(r).arrayBuffer().then((t=>{e(t)})).catch((t=>{console.error("decompressGzipWithBlob:",t),e()}))}catch(t){console.error("decompressGzipWithBlob:",t),e()}}(a,(t=>{t&&(a=t),r()})):r()}h||c()}))}_readTile(t,e,n,r,i,o){if(r)return void o(r);let s;try{s=new $i(new Si(i))}catch(r){const e=Gi.decode(i);return r.message+="\\n"+t+"\\n"+e,void o(r.message,[],[])}const a=[];if(!s.layers)return void o(null,a,[]);const l={};let u;for(const t in s.layers)if(h=s.layers,c=t,Object.prototype.hasOwnProperty.call(h,c)){l[t]={types:{}};const i=l[t].types;for(let o=0,l=s.layers[t].length;o<l;o++)try{u=s.layers[t].feature(o),i[u.type]=1;const r={type:u.type,layer:t,geometry:u.loadGeometry(),properties:u.properties,extent:u.extent};void 0!==u.id&&(r.id=u.id);let l=r.properties[ne];l&&(I(l)&&(l=JSON.parse(l)),r.properties[ne]=ni(l,"EPSG:3857"));const h=e&&r.properties[e];if(h){const t=Ui(h),e=[];Zi(r.geometry,t,e),e.length&&!n&&(console.warn("feature.geometry is not consistent with altitude values:"),console.warn(JSON.stringify(r,null,2)))}a.push(r)}catch(r){console.warn("error when load vt geometry:",r)}}var h,c;for(const t in l)l[t].types=Object.keys(l[t].types).map((t=>+t));o(null,a,l,{byteLength:i.byteLength})}abortTile(t,e){const n=this.requests[t];delete this.requests[t],n&&n.abort&&n.abort(),this._cancelLoadings(t),e()}onRemove(){super.onRemove(),this._abortRequests()}_abortRequests(){for(const t in this.requests){const e=this.requests[t];e&&e.abort&&e.abort()}this.requests={}}}function Ui(t){const e=atob(t),n=new Uint8Array(e.length);for(let t=0;t<e.length;t++)n[t]=e.charCodeAt(t);return new Float32Array(n.buffer)}function Zi(t,e,n,r){r||(r={index:0});for(let i=0;i<t.length;i++)if(Array.isArray(t[i]))Zi(t[i],e,n,r);else{const o=r.index;k(e[o])?n.push(qi):t[i].z=100*e[o],r.index++}}const{LRUCache:Ri}=re();let Ji=0;const Hi=new Ri(128);class Wi{constructor(t){this._layers={},this._callbacks={},this.workerId=t}addLayer({actorId:t,mapId:e,layerId:n,params:r},i){if(this._getLayerById(e,n))return;const o=this._genKey(e,n),s=r.type,a=r.options,l=this.send.bind(this,t);this._layers[o]="GeoJSONVectorTileLayer"===s?new ii(n,a,l,Hi,{},i):new ji(n,a,l,Hi,{},i)}removeLayer({mapId:t,layerId:e},n){const r=this._getLayerById(t,e),i=this._genKey(t,e);delete this._layers[i],r&&r.onRemove(n)}loadTile({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.loadTile(n,r)}abortTile({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.abortTile&&i.abortTile(n.url,r)}removeTile({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.removeTile(n,r)}updateStyle({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.updateStyle(n,r)}updateOptions({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.updateOptions(n,r)}setData({mapId:t,layerId:e,params:n},r){const i=this._getLayerById(t,e);i&&i.setData(n.data,r)}clearData({mapId:t,layerId:e},n){const r=this._getLayerById(t,e);r&&(r.clearData(n),this._resetCache())}receive(t){const e=t.callback,n=this._callbacks[e];delete this._callbacks[e],n&&t.error?n(new Error(t.error)):n&&n(null,t.data)}send(t,e,n,r,i){const o=i?\`${W}t}-${W}Ji++}\`:null;i&&(this._callbacks[o]=i),postMessage({type:"<request>",workerId:this.workerId,actorId:t,command:e,params:n,callback:String(o)},r||[])}_genKey(t,e){return\`${W}t}-${W}e}\`}_getLayerById(t,e){const n=this._genKey(t,e);return this._layers[n]}_resetCache(){Hi.reset()}}t.initialize=function(){},t.onmessage=function(t,e){const n=t.data;if(this.dispatcher||(this.dispatcher=new Wi(t.workerId)),"<response>"===t.type)this.dispatcher.workerId===t.workerId&&this.dispatcher.receive(t);else{const r=n.command,i=(n.params||{}).loadTileErrorLog,o=(n.params||{}).loadTileErrorLogIgnoreCodes||[];this.dispatcher[r]({actorId:t.actorId,mapId:n.mapId,layerId:n.layerId,params:n.params},((t,n,s)=>{if(i&&t&&!t.loading){const e=t.status;S(e)&&-1===o.indexOf(e)&&console.error(r,t)}e(t,n,s)}))}}}`;

function Y(e) {
    const t = function() {
        return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : void 0;
    };
    if (t().maptalks_vt_packers) return;
    function n(e) {
        return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
    }
    var i = r;
    function r(e, t) {
        this.x = e, this.y = t;
    }
    r.prototype = {
        clone: function() {
            return new r(this.x, this.y);
        },
        add: function(e) {
            return this.clone()._add(e);
        },
        sub: function(e) {
            return this.clone()._sub(e);
        },
        multByPoint: function(e) {
            return this.clone()._multByPoint(e);
        },
        divByPoint: function(e) {
            return this.clone()._divByPoint(e);
        },
        mult: function(e) {
            return this.clone()._mult(e);
        },
        div: function(e) {
            return this.clone()._div(e);
        },
        rotate: function(e) {
            return this.clone()._rotate(e);
        },
        rotateAround: function(e, t) {
            return this.clone()._rotateAround(e, t);
        },
        matMult: function(e) {
            return this.clone()._matMult(e);
        },
        unit: function() {
            return this.clone()._unit();
        },
        perp: function() {
            return this.clone()._perp();
        },
        round: function() {
            return this.clone()._round();
        },
        mag: function() {
            return Math.sqrt(this.x * this.x + this.y * this.y);
        },
        equals: function(e) {
            return this.x === e.x && this.y === e.y;
        },
        dist: function(e) {
            return Math.sqrt(this.distSqr(e));
        },
        distSqr: function(e) {
            var t = e.x - this.x, n = e.y - this.y;
            return t * t + n * n;
        },
        angle: function() {
            return Math.atan2(this.y, this.x);
        },
        angleTo: function(e) {
            return Math.atan2(this.y - e.y, this.x - e.x);
        },
        angleWith: function(e) {
            return this.angleWithSep(e.x, e.y);
        },
        angleWithSep: function(e, t) {
            return Math.atan2(this.x * t - this.y * e, this.x * e + this.y * t);
        },
        _matMult: function(e) {
            var t = e[0] * this.x + e[1] * this.y, n = e[2] * this.x + e[3] * this.y;
            return this.x = t, this.y = n, this;
        },
        _add: function(e) {
            return this.x += e.x, this.y += e.y, this;
        },
        _sub: function(e) {
            return this.x -= e.x, this.y -= e.y, this;
        },
        _mult: function(e) {
            return this.x *= e, this.y *= e, this;
        },
        _div: function(e) {
            return this.x /= e, this.y /= e, this;
        },
        _multByPoint: function(e) {
            return this.x *= e.x, this.y *= e.y, this;
        },
        _divByPoint: function(e) {
            return this.x /= e.x, this.y /= e.y, this;
        },
        _unit: function() {
            return this._div(this.mag()), this;
        },
        _perp: function() {
            var e = this.y;
            return this.y = this.x, this.x = -e, this;
        },
        _rotate: function(e) {
            var t = Math.cos(e), n = Math.sin(e), i = t * this.x - n * this.y, r = n * this.x + t * this.y;
            return this.x = i, this.y = r, this;
        },
        _rotateAround: function(e, t) {
            var n = Math.cos(e), i = Math.sin(e), r = t.x + n * (this.x - t.x) - i * (this.y - t.y), s = t.y + i * (this.x - t.x) + n * (this.y - t.y);
            return this.x = r, this.y = s, this;
        },
        _round: function() {
            return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
        }
    }, r.convert = function(e) {
        return e instanceof r ? e : Array.isArray(e) ? new r(e[0], e[1]) : e;
    };
    var s = n(i);
    const o = {
        Point: 1,
        LineString: 2,
        Polygon: 3,
        MultiPoint: 4,
        MultiLineString: 5,
        MultiPolygon: 6
    };
    function a(e, t = {}) {
        var n = [];
        if ("FeatureCollection" === e.type) for (var i = 0; i < e.features.length; i++) l(n, e.features[i], t, i); else "Feature" === e.type ? l(n, e, t) : l(n, {
            geometry: e
        }, t);
        return n;
    }
    function l(e, t, n, i) {
        if (t.geometry && t.geometry.geometry) {
            var r = t.geometry.coordinates, s = t.geometry.type, o = [], a = t.id;
            if (n.promoteId ? a = t.properties[n.promoteId] : n.generateId && (a = i || 0), 
            "Point" === s) h(r, o); else if ("MultiPoint" === s) for (var d = 0; d < r.length; d++) h(r[d], o); else if ("LineString" === s) u([ r ], o); else if ("MultiLineString" === s) {
                if (n.lineMetrics) {
                    for (d = 0; d < r.length; d++) o = [], c(r[d], o), e.push(f(a, "LineString", o, t.properties));
                    return;
                }
                u(r, o);
            } else if ("Polygon" === s) u(r, o); else {
                if ("MultiPolygon" !== s) {
                    if ("GeometryCollection" === s) {
                        for (d = 0; d < t.geometry.geometries.length; d++) l(e, {
                            id: a,
                            geometry: t.geometry.geometries[d],
                            properties: t.properties
                        }, n, i);
                        return;
                    }
                    return void console.warn(`Input data type(${s}) is not a valid GeoJSON geometry type.`);
                }
                for (d = 0; d < r.length; d++) {
                    var p = [];
                    u(r[d], p), o.push(p);
                }
            }
            e.push(f(a, s, o, t.properties));
        }
    }
    function h(e, t) {
        const n = new s(e[0], e[1]);
        n.z = 100 * (e[2] || 0), t.push([ n ]);
    }
    function c(e, t) {
        for (let n = 0; n < e.length; n++) {
            const i = e[n][0], r = e[n][1], o = new s(i, r);
            o.z = 100 * (e[n][2] || 0), t.push(o);
        }
    }
    function u(e, t, n, i) {
        for (var r = 0; r < e.length; r++) {
            var s = [];
            c(e[r], s), t.push(s);
        }
    }
    function f(e, t, n, i) {
        return {
            id: void 0 === e ? null : e,
            type: o[t],
            geometry: n,
            properties: i
        };
    }
    function d(e, t, n) {
        n = n || {}, this.w = e || 64, this.h = t || 64, this.autoResize = !!n.autoResize, 
        this.shelves = [], this.freebins = [], this.stats = {}, this.bins = {}, this.maxId = 0;
    }
    function p(e, t, n) {
        this.x = 0, this.y = e, this.w = this.free = t, this.h = n;
    }
    function g(e, t, n, i, r, s, o) {
        this.id = e, this.x = t, this.y = n, this.w = i, this.h = r, this.maxw = s || i, 
        this.maxh = o || r, this.refcount = 0
        /*!
	 * Codes from mapbox-gl-js
	 * github.com/mapbox/mapbox-gl-js
	 * MIT License
	 */;
    }
    function m(e, {width: t, height: n}, i, r) {
        if (r) {
            if (r.length !== t * n * i) throw new RangeError("mismatched image size");
        } else r = new Uint8Array(t * n * i);
        return e.width = t, e.height = n, e.data = r, e;
    }
    function y(e, {width: t, height: n}, i) {
        if (t === e.width && n === e.height) return;
        const r = m({}, {
            width: t,
            height: n
        }, i);
        x(e, r, {
            x: 0,
            y: 0
        }, {
            x: 0,
            y: 0
        }, {
            width: Math.min(e.width, t),
            height: Math.min(e.height, n)
        }, i), e.width = t, e.height = n, e.data = r.data;
    }
    function x(e, t, n, i, r, s) {
        if (0 === r.width || 0 === r.height) return t;
        if (r.width > e.width || r.height > e.height || n.x > e.width - r.width || n.y > e.height - r.height) throw new RangeError("out of range source coordinates for image copy");
        if (r.width > t.width || r.height > t.height || i.x > t.width - r.width || i.y > t.height - r.height) throw new RangeError("out of range destination coordinates for image copy");
        const o = e.data, a = t.data;
        if (o === a) return t;
        for (let l = 0; l < r.height; l++) {
            const h = ((n.y + l) * e.width + n.x) * s, c = ((i.y + l) * t.width + i.x) * s;
            for (let e = 0; e < r.width * s; e++) a[c + e] = o[h + e];
        }
        return t;
    }
    d.prototype.pack = function(e, t) {
        e = [].concat(e), t = t || {};
        for (var n, i, r, s, o = [], a = 0; a < e.length; a++) if (n = e[a].w || e[a].width, 
        i = e[a].h || e[a].height, r = e[a].id, n && i) {
            if (!(s = this.packOne(n, i, r))) continue;
            t.inPlace && (e[a].x = s.x, e[a].y = s.y, e[a].id = s.id), o.push(s);
        }
        return this.shrink(), o;
    }, d.prototype.packOne = function(e, t, n) {
        var i, r, s, o, a, l, h, c, u = {
            freebin: -1,
            shelf: -1,
            waste: 1 / 0
        }, f = 0;
        if ("string" == typeof n || "number" == typeof n) {
            if (i = this.getBin(n)) return this.ref(i), i;
            "number" == typeof n && (this.maxId = Math.max(n, this.maxId));
        } else n = ++this.maxId;
        for (o = 0; o < this.freebins.length; o++) {
            if (t === (i = this.freebins[o]).maxh && e === i.maxw) return this.allocFreebin(o, e, t, n);
            t > i.maxh || e > i.maxw || t <= i.maxh && e <= i.maxw && (s = i.maxw * i.maxh - e * t) < u.waste && (u.waste = s, 
            u.freebin = o);
        }
        for (o = 0; o < this.shelves.length; o++) if (f += (r = this.shelves[o]).h, !(e > r.free)) {
            if (t === r.h) return this.allocShelf(o, e, t, n);
            t > r.h || t < r.h && (s = (r.h - t) * e) < u.waste && (u.freebin = -1, u.waste = s, 
            u.shelf = o);
        }
        return -1 !== u.freebin ? this.allocFreebin(u.freebin, e, t, n) : -1 !== u.shelf ? this.allocShelf(u.shelf, e, t, n) : t <= this.h - f && e <= this.w ? (r = new p(f, this.w, t), 
        this.allocShelf(this.shelves.push(r) - 1, e, t, n)) : this.autoResize ? (a = l = this.h, 
        ((h = c = this.w) <= a || e > h) && (c = 2 * Math.max(e, h)), (a < h || t > a) && (l = 2 * Math.max(t, a)), 
        this.resize(c, l), this.packOne(e, t, n)) : null;
    }, d.prototype.allocFreebin = function(e, t, n, i) {
        var r = this.freebins.splice(e, 1)[0];
        return r.id = i, r.w = t, r.h = n, r.refcount = 0, this.bins[i] = r, this.ref(r), 
        r;
    }, d.prototype.allocShelf = function(e, t, n, i) {
        var r = this.shelves[e].alloc(t, n, i);
        return this.bins[i] = r, this.ref(r), r;
    }, d.prototype.shrink = function() {
        if (this.shelves.length > 0) {
            for (var e = 0, t = 0, n = 0; n < this.shelves.length; n++) {
                var i = this.shelves[n];
                t += i.h, e = Math.max(i.w - i.free, e);
            }
            this.resize(e, t);
        }
    }, d.prototype.getBin = function(e) {
        return this.bins[e];
    }, d.prototype.ref = function(e) {
        if (1 == ++e.refcount) {
            var t = e.h;
            this.stats[t] = 1 + (0 | this.stats[t]);
        }
        return e.refcount;
    }, d.prototype.unref = function(e) {
        return 0 === e.refcount ? 0 : (0 == --e.refcount && (this.stats[e.h]--, delete this.bins[e.id], 
        this.freebins.push(e)), e.refcount);
    }, d.prototype.clear = function() {
        this.shelves = [], this.freebins = [], this.stats = {}, this.bins = {}, this.maxId = 0;
    }, d.prototype.resize = function(e, t) {
        this.w = e, this.h = t;
        for (var n = 0; n < this.shelves.length; n++) this.shelves[n].resize(e);
        return !0;
    }, p.prototype.alloc = function(e, t, n) {
        if (e > this.free || t > this.h) return null;
        var i = this.x;
        return this.x += e, this.free -= e, new g(n, i, this.y, e, t, e, this.h);
    }, p.prototype.resize = function(e) {
        return this.free += e - this.w, this.w = e, !0;
    };
    class _ {
        constructor(e, t) {
            m(this, e, 1, t);
        }
        resize(e) {
            y(this, e, 1);
        }
        clone() {
            return new _({
                width: this.width,
                height: this.height
            }, new Uint8Array(this.data));
        }
        static copy(e, t, n, i, r) {
            x(e, t, n, i, r, 1);
        }
    }
    class v {
        constructor(e, t) {
            m(this, e, 4, t);
        }
        resize(e) {
            y(this, e, 4);
        }
        clone() {
            return new v({
                width: this.width,
                height: this.height
            }, new Uint8Array(this.data));
        }
        static copy(e, t, n, i, r) {
            x(e, t, n, i, r, 4);
        }
    }
    function b(e) {
        let t = 0;
        for (let n, i, r = 0, s = e.length, o = s - 1; r < s; o = r++) if (n = e[r], i = e[o], 
        void 0 !== n.x) t += (i.x - n.x) * (n.y + i.y); else {
            if (n[2] || i[2]) return 1;
            t += (i[0] - n[0]) * (n[1] + i[1]);
        }
        return t;
    }
    function A(e, t, n, i, r) {
        const s = e[t * i], o = e[t * i + 1], a = e[n * i], l = e[n * i + 1];
        return s === a && (s < 0 || s > r) && o !== l || o === l && (o < 0 || o > r) && s !== a;
    }
    function T(e, t, n) {
        let i = n;
        return t && e && (i = +e[t]), isNaN(i) && (i = n || 0), 100 * i;
    }
    function w(e, t, n, i, r, s, o) {
        t || 0 === t || (t = 1);
        const a = T(e.properties, n, i), l = a * t;
        let h = (s ? 100 * s : 0) || a;
        return r ? h = T(e.properties, r, s) : o && (h = a - T(e.properties, o, s)), h *= t, 
        {
            altitude: l,
            height: h
        };
    }
    function S(e, t) {
        return t < 1 / 0 && (e.x < 0 || e.x > t || e.y < 0 || e.y > t);
    }
    function M(e) {
        return null == e;
    }
    function P(e, t, n) {
        if (e === n || e === t) return e;
        const i = n - t;
        return ((e - t) % i + i) % i + t;
    }
    function I(e, t) {
        if (!t) return null;
        const n = new Map;
        for (let i = 0; i < t.length; i++) {
            const r = t[i], s = e[r];
            let o = n.get(s);
            o || (o = [], n.set(s, o)), o.push(r);
        }
        return n;
    }
    function C(e) {
        return !(e & e - 1) && 0 !== e;
    }
    /*!
	 * Codes from mapbox-gl-js
	 * github.com/mapbox/mapbox-gl-js
	 * MIT License
	 */    class k {
        constructor(e, t, {pixelRatio: n}) {
            this.paddedRect = e, this.pixelRatio = n || 1, this.padding = t;
        }
        get tl() {
            return [ this.paddedRect.x + this.padding, this.paddedRect.y + this.padding ];
        }
        get br() {
            return [ this.paddedRect.x + this.paddedRect.w - this.padding, this.paddedRect.y + this.paddedRect.h - this.padding ];
        }
        get displaySize() {
            return [ (this.paddedRect.w - 2 * this.padding) / this.pixelRatio, (this.paddedRect.h - 2 * this.padding) / this.pixelRatio ];
        }
    }
    class F {
        constructor(e, t) {
            this.iconMap = e, this.options = t || {}, this.build();
        }
        build() {
            const e = this.iconMap, t = Object.keys(e).length, n = {}, i = new d(0, 0, {
                autoResize: !0
            }), r = [], s = t > 1 ? 1 : 0;
            for (const t in e) {
                const i = e[t], o = {
                    x: 0,
                    y: 0,
                    w: i.data.width + 2 * s,
                    h: i.data.height + 2 * s
                };
                r.push(o), n[t] = new k(o, s, i);
            }
            if (i.pack(r, {
                inPlace: !0
            }), !(this.options.nonPowerOfTwo || C(i.w) && C(i.h))) {
                const e = O(i.w), t = O(i.h);
                i.resize(e, t);
            }
            const o = new v({
                width: i.w,
                height: i.h
            });
            for (const t in e) {
                const i = e[t], r = n[t].paddedRect;
                v.copy(i.data, o, {
                    x: 0,
                    y: 0
                }, {
                    x: r.x + s,
                    y: r.y + s
                }, i.data);
            }
            this.image = o, this.positions = n;
        }
    }
    function O(e) {
        return Math.pow(2, Math.ceil(Math.log(e) / Math.LN2));
    }
    /*!
	 * Codes from mapbox-gl-js
	 * github.com/mapbox/mapbox-gl-js
	 * MIT License
	 * TODO 升级为potpack
	 */    class R {
        constructor(e) {
            this.glyphMap = e, this.build();
        }
        build() {
            const e = this.glyphMap, t = {}, n = new d(0, 0, {
                autoResize: !0
            }), i = [];
            for (const n in e) {
                const r = e[n], s = t[n] = {};
                for (const e in r) {
                    const t = r[+e];
                    if (!t || 0 === t.bitmap.width || 0 === t.bitmap.height) continue;
                    const n = {
                        x: 0,
                        y: 0,
                        w: t.bitmap.width + 2,
                        h: t.bitmap.height + 2
                    };
                    i.push(n), s[e] = {
                        rect: n,
                        metrics: t.metrics
                    };
                }
            }
            n.pack(i, {
                inPlace: !0
            });
            const r = new _({
                width: n.w,
                height: n.h
            });
            for (const n in e) {
                const i = e[n];
                for (const e in i) {
                    const s = i[+e];
                    if (!s || 0 === s.bitmap.width || 0 === s.bitmap.height) continue;
                    const o = t[n][e].rect;
                    _.copy(s.bitmap, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: o.x + 1,
                        y: o.y + 1
                    }, s.bitmap);
                }
            }
            this.image = r, this.positions = t;
        }
    }
    function E(e) {
        return e < 65536 ? Uint16Array : Uint32Array;
    }
    function D(e) {
        return (e = Math.abs(e)) < 32768 ? Int16Array : Float32Array;
    }
    function L(e) {
        return e < 65536 ? Uint16Array : Float32Array;
    }
    function H(e, t) {
        const n = e.getLength ? e.getLength() : e.length;
        if (e instanceof t) return e.slice(0, n);
        const i = new t(n);
        e = e._origin || e;
        for (let t = 0; t < n; t++) i[t] = e[t] || 0;
        return i;
    }
    function z(e) {
        const t = e.type, n = [];
        if (1 === t || 4 === t) for (let t = 0; t < e.geometry.length; t++) h(e.geometry[t], n); else if (2 === t) u(e.geometry, n); else if (3 === t) u(e.geometry, n); else if (5 === t) u(e.geometry, n); else if (6 === t) for (let t = 0; t < e.geometry.length; t++) {
            const i = [];
            u(e.geometry[t], i), n.push(i);
        }
        return e.geometry = n, e;
    }
    let N;
    const V = {
        width: 100,
        height: 10
    };
    let B = !1;
    try {
        new OffscreenCanvas(1, 1).getContext("2d").fillText("hello", 0, 0), B = !0;
    } catch (e) {
        B = !1;
    }
    class U {
        constructor(e, t = {}) {
            if (!Array.isArray(e)) return void console.error("colors is not array");
            if (e.length < 2) return void console.error("colors.length should >1");
            this.colors = e;
            let n = 1 / 0, i = -1 / 0;
            for (let t = 0, r = e.length; t < r; t++) {
                const r = e[t][0];
                n = Math.min(r, n), i = Math.max(r, i);
            }
            this.min = n, this.max = i, this.valueOffset = this.max - this.min, this.options = Object.assign({}, V, t), 
            this._initImgData();
        }
        getImageData() {
            return this.imgData;
        }
        _initImgData() {
            const e = function() {
                if (!N) {
                    const {width: e, height: t} = V;
                    B ? N = new OffscreenCanvas(e, t) : (N = document.createElement("canvas"), N.width = e, 
                    N.height = t);
                }
                return N;
            }(), {width: t, height: n} = this.options;
            e.width = t, e.height = n;
            const i = e.getContext("2d");
            i.clearRect(0, 0, e.width, e.height);
            const r = i.createLinearGradient(0, 0, e.width, 0), {colors: s, valueOffset: o} = this;
            for (let e = 0, t = s.length; e < t; e++) {
                const [t, n] = s[e], i = (t - this.min) / o;
                r.addColorStop(i, n);
            }
            i.fillStyle = r, i.fillRect(0, 0, e.width, e.height), this.imgData = i.getImageData(0, 0, e.width, e.height);
        }
        getColor(e) {
            e = Math.max(this.min, e);
            const t = ((e = Math.min(e, this.max)) - this.min) / this.valueOffset;
            let n = Math.round(t * this.imgData.width);
            n = Math.min(n, this.imgData.width - 1);
            const i = 4 * n;
            return [ this.imgData.data[i], this.imgData.data[i + 1], this.imgData.data[i + 2], this.imgData.data[i + 3] ];
        }
    }
    var G;
    function j(e) {
        return null == e;
    }
    function W(e) {
        return !j(e);
    }
    function X(e) {
        return "" === e;
    }
    function Y(e, t) {
        var n, i, r;
        if (ie(e)) {
            var s, o = e.stops && "object" == typeof e.stops[0][0], a = o || W(e.property), l = o || !a, h = e.type || t || "exponential";
            if ("exponential" === h) s = $; else if ("interval" === h) s = Z; else if ("categorical" === h) s = q; else if ("identity" === h) s = Q; else if ("color-interpolate" === h) s = K; else {
                if ("calculate-expression" !== h) throw new Error('Unknown function type "' + h + '"');
                s = ee;
            }
            if (o) {
                var c = {}, u = [];
                for (let t = 0; t < e.stops.length; t++) {
                    var f = e.stops[t];
                    void 0 === c[f[0].zoom] && (c[f[0].zoom] = {
                        zoom: f[0].zoom,
                        type: e.type,
                        property: e.property,
                        default: e.default,
                        stops: []
                    }), c[f[0].zoom].stops.push([ f[0].value, f[1] ]);
                }
                for (let e in c) u.push([ c[e].zoom, Y(c[e]) ]);
                n = function(t, n) {
                    const i = $({
                        stops: u,
                        base: e.base
                    }, t)(t, n);
                    return "function" == typeof i ? i(t, n) : i;
                }, i = !1, r = !1;
            } else l ? (n = function(t) {
                const n = s(e, t);
                return "function" == typeof n ? n(t) : n;
            }, i = !0, r = !1) : (n = function(t, n) {
                const i = s(e, n ? n[e.property] : null);
                return "function" == typeof i ? i(t, n) : i;
            }, i = !1, r = !0);
        } else n = function() {
            return e;
        }, i = !0, r = !0;
        return n.isZoomConstant = r, n.isFeatureConstant = i, n;
    }
    function q(e, t) {
        for (let n = 0; n < e.stops.length; n++) if (t === e.stops[n][0]) return e.stops[n][1];
        return e.default;
    }
    function Z(e, t) {
        for (var n = 0; n < e.stops.length && !(t < e.stops[n][0]); n++) ;
        return e.stops[Math.max(n - 1, 0)][1];
    }
    function $(e, t) {
        for (var n = W(e.base) && !X(e.base) ? e.base : 1, i = 0; !(i >= e.stops.length || t <= e.stops[i][0]); ) i++;
        return 0 === i ? e.stops[i][1] : i === e.stops.length ? e.stops[i - 1][1] : te(t, n, e.stops[i - 1][0], e.stops[i][0], e.stops[i - 1][1], e.stops[i][1]);
    }
    "function" == typeof Map && (G = new Map);
    const J = {
        width: 100,
        height: 1
    };
    function K(e, t) {
        const n = e.stops;
        if (n && n.length > 1) {
            let e;
            if (G) {
                const t = JSON.stringify(n);
                if (!G.has(t)) {
                    const e = new U(n, J);
                    G.set(t, e);
                }
                e = G.get(t);
            } else e = new U(n, J);
            const [i, r, s, o] = e.getColor(t);
            return [ i / 255, r / 255, s / 255, o / 255 ];
        }
        return n && 1 === n.length ? n[0][1] : null;
    }
    function Q(e, t) {
        return n = t, i = e.default, W(n) ? n : W(i) ? i : W(r) ? r : null;
        var n, i, r;
    }
    function ee(e, t) {
        const n = String(e.property), i = e.expression, r = t;
        function s(t) {
            return j(t) || X(t) || isNaN(t) ? e.default : t;
        }
        if (!W(t) || X(t) || isNaN(t) || t < 0) return s(e.default);
        {
            const t = function e(t, n, i) {
                const r = Number(i), s = String(n);
                return Array.isArray(t) ? t.map((t => e(t, s, r))) : t === s ? r : t;
            }(i, n, r);
            return s(function t(n) {
                if (!Array.isArray(n)) {
                    if ("number" == typeof n) return n;
                    throw new Error("Invalid expression format");
                }
                {
                    const i = n[0];
                    if (![ "+", "-", "*", "/" ].includes(i)) throw new Error(`Unknown operator: ${i}`);
                    const r = n.slice(1).map((e => t(e)));
                    switch (i) {
                      case "+":
                        return r.reduce(((e, t) => e + t), 0);

                      case "-":
                        return r.reduce(((e, t) => e - t));

                      case "*":
                        return r.reduce(((e, t) => e * t), 1);

                      case "/":
                        return r.some((e => 0 === e)) ? e.default : r.reduce(((e, t) => e / t));

                      default:
                        throw new Error(`Unsupported operator: ${i}`);
                    }
                }
            }(t));
        }
    }
    function te(e, t, n, i, r, s) {
        return "function" == typeof r ? function() {
            var o = r.apply(void 0, arguments), a = s.apply(void 0, arguments);
            return te(e, t, n, i, o, a);
        } : r.length ? function(e, t, n, i, r, s) {
            var o = [];
            for (let a = 0; a < r.length; a++) o[a] = ne(e, t, n, i, r[a], s[a]);
            return o;
        }(e, t, n, i, r, s) : ne(e, t, n, i, r, s);
    }
    function ne(e, t, n, i, r, s) {
        var o, a = i - n, l = e - n;
        return r * (1 - (o = 1 === t ? l / a : (Math.pow(t, l) - 1) / (Math.pow(t, a) - 1))) + s * o;
    }
    function ie(e) {
        return e && "object" == typeof e && (e.stops || e.property && "identity" === e.type || e.expression && "calculate-expression" === e.type);
    }
    function re(e) {
        return ae(e, "exponential");
    }
    function se(e) {
        return ae(e, "interval");
    }
    function oe(e, t) {
        if (!e) return null;
        var n = !1;
        if (Array.isArray(e)) {
            var i, r = [];
            for (let s = 0; s < e.length; s++) (i = oe(e[s], t)) ? (r.push(i), n = !0) : r.push(e[s]);
            return n ? r : e;
        }
        var s, o = {
            __fn_types_loaded: !0
        }, a = [];
        for (s in e) e.hasOwnProperty(s) && a.push(s);
        const l = function(e) {
            Object.defineProperty(o, e, {
                get: function() {
                    return this["__fn_" + e] || (this["__fn_" + e] = re(this["_" + e])), this["__fn_" + e].apply(this, t());
                },
                set: function(t) {
                    this["_" + e] = t;
                },
                configurable: !0,
                enumerable: !0
            });
        };
        for (let t = 0, i = a.length; t < i; t++) ie(e[s = a[t]]) ? (n = !0, o["_" + s] = e[s], 
        l(s)) : o[s] = e[s];
        return n ? o : e;
    }
    function ae(e, t) {
        if (!ie(e)) return function() {
            return e;
        };
        let n = !0, i = !0;
        const r = (e = JSON.parse(JSON.stringify(e))).stops;
        if (r) for (let e = 0; e < r.length; e++) if (ie(r[e][1])) {
            const s = ae(r[e][1], t);
            n = n && s.isZoomConstant, i = i && s.isFeatureConstant, r[e] = [ r[e][0], s ];
        }
        const s = Y(e, t);
        return s.isZoomConstant = n && s.isZoomConstant, s.isFeatureConstant = i && s.isFeatureConstant, 
        s;
    }
    var le = {
        exports: {}
    }, he = {
        exports: {}
    }, ce = function(e) {
        return !(!e || "string" == typeof e) && (e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && "String" !== e.constructor.name));
    }, ue = Array.prototype.concat, fe = Array.prototype.slice, de = he.exports = function(e) {
        for (var t = [], n = 0, i = e.length; n < i; n++) {
            var r = e[n];
            ce(r) ? t = ue.call(t, fe.call(r)) : t.push(r);
        }
        return t;
    };
    de.wrap = function(e) {
        return function() {
            return e(de(arguments));
        };
    };
    var pe = he.exports, ge = {
        aliceblue: [ 240, 248, 255 ],
        antiquewhite: [ 250, 235, 215 ],
        aqua: [ 0, 255, 255 ],
        aquamarine: [ 127, 255, 212 ],
        azure: [ 240, 255, 255 ],
        beige: [ 245, 245, 220 ],
        bisque: [ 255, 228, 196 ],
        black: [ 0, 0, 0 ],
        blanchedalmond: [ 255, 235, 205 ],
        blue: [ 0, 0, 255 ],
        blueviolet: [ 138, 43, 226 ],
        brown: [ 165, 42, 42 ],
        burlywood: [ 222, 184, 135 ],
        cadetblue: [ 95, 158, 160 ],
        chartreuse: [ 127, 255, 0 ],
        chocolate: [ 210, 105, 30 ],
        coral: [ 255, 127, 80 ],
        cornflowerblue: [ 100, 149, 237 ],
        cornsilk: [ 255, 248, 220 ],
        crimson: [ 220, 20, 60 ],
        cyan: [ 0, 255, 255 ],
        darkblue: [ 0, 0, 139 ],
        darkcyan: [ 0, 139, 139 ],
        darkgoldenrod: [ 184, 134, 11 ],
        darkgray: [ 169, 169, 169 ],
        darkgreen: [ 0, 100, 0 ],
        darkgrey: [ 169, 169, 169 ],
        darkkhaki: [ 189, 183, 107 ],
        darkmagenta: [ 139, 0, 139 ],
        darkolivegreen: [ 85, 107, 47 ],
        darkorange: [ 255, 140, 0 ],
        darkorchid: [ 153, 50, 204 ],
        darkred: [ 139, 0, 0 ],
        darksalmon: [ 233, 150, 122 ],
        darkseagreen: [ 143, 188, 143 ],
        darkslateblue: [ 72, 61, 139 ],
        darkslategray: [ 47, 79, 79 ],
        darkslategrey: [ 47, 79, 79 ],
        darkturquoise: [ 0, 206, 209 ],
        darkviolet: [ 148, 0, 211 ],
        deeppink: [ 255, 20, 147 ],
        deepskyblue: [ 0, 191, 255 ],
        dimgray: [ 105, 105, 105 ],
        dimgrey: [ 105, 105, 105 ],
        dodgerblue: [ 30, 144, 255 ],
        firebrick: [ 178, 34, 34 ],
        floralwhite: [ 255, 250, 240 ],
        forestgreen: [ 34, 139, 34 ],
        fuchsia: [ 255, 0, 255 ],
        gainsboro: [ 220, 220, 220 ],
        ghostwhite: [ 248, 248, 255 ],
        gold: [ 255, 215, 0 ],
        goldenrod: [ 218, 165, 32 ],
        gray: [ 128, 128, 128 ],
        green: [ 0, 128, 0 ],
        greenyellow: [ 173, 255, 47 ],
        grey: [ 128, 128, 128 ],
        honeydew: [ 240, 255, 240 ],
        hotpink: [ 255, 105, 180 ],
        indianred: [ 205, 92, 92 ],
        indigo: [ 75, 0, 130 ],
        ivory: [ 255, 255, 240 ],
        khaki: [ 240, 230, 140 ],
        lavender: [ 230, 230, 250 ],
        lavenderblush: [ 255, 240, 245 ],
        lawngreen: [ 124, 252, 0 ],
        lemonchiffon: [ 255, 250, 205 ],
        lightblue: [ 173, 216, 230 ],
        lightcoral: [ 240, 128, 128 ],
        lightcyan: [ 224, 255, 255 ],
        lightgoldenrodyellow: [ 250, 250, 210 ],
        lightgray: [ 211, 211, 211 ],
        lightgreen: [ 144, 238, 144 ],
        lightgrey: [ 211, 211, 211 ],
        lightpink: [ 255, 182, 193 ],
        lightsalmon: [ 255, 160, 122 ],
        lightseagreen: [ 32, 178, 170 ],
        lightskyblue: [ 135, 206, 250 ],
        lightslategray: [ 119, 136, 153 ],
        lightslategrey: [ 119, 136, 153 ],
        lightsteelblue: [ 176, 196, 222 ],
        lightyellow: [ 255, 255, 224 ],
        lime: [ 0, 255, 0 ],
        limegreen: [ 50, 205, 50 ],
        linen: [ 250, 240, 230 ],
        magenta: [ 255, 0, 255 ],
        maroon: [ 128, 0, 0 ],
        mediumaquamarine: [ 102, 205, 170 ],
        mediumblue: [ 0, 0, 205 ],
        mediumorchid: [ 186, 85, 211 ],
        mediumpurple: [ 147, 112, 219 ],
        mediumseagreen: [ 60, 179, 113 ],
        mediumslateblue: [ 123, 104, 238 ],
        mediumspringgreen: [ 0, 250, 154 ],
        mediumturquoise: [ 72, 209, 204 ],
        mediumvioletred: [ 199, 21, 133 ],
        midnightblue: [ 25, 25, 112 ],
        mintcream: [ 245, 255, 250 ],
        mistyrose: [ 255, 228, 225 ],
        moccasin: [ 255, 228, 181 ],
        navajowhite: [ 255, 222, 173 ],
        navy: [ 0, 0, 128 ],
        oldlace: [ 253, 245, 230 ],
        olive: [ 128, 128, 0 ],
        olivedrab: [ 107, 142, 35 ],
        orange: [ 255, 165, 0 ],
        orangered: [ 255, 69, 0 ],
        orchid: [ 218, 112, 214 ],
        palegoldenrod: [ 238, 232, 170 ],
        palegreen: [ 152, 251, 152 ],
        paleturquoise: [ 175, 238, 238 ],
        palevioletred: [ 219, 112, 147 ],
        papayawhip: [ 255, 239, 213 ],
        peachpuff: [ 255, 218, 185 ],
        peru: [ 205, 133, 63 ],
        pink: [ 255, 192, 203 ],
        plum: [ 221, 160, 221 ],
        powderblue: [ 176, 224, 230 ],
        purple: [ 128, 0, 128 ],
        rebeccapurple: [ 102, 51, 153 ],
        red: [ 255, 0, 0 ],
        rosybrown: [ 188, 143, 143 ],
        royalblue: [ 65, 105, 225 ],
        saddlebrown: [ 139, 69, 19 ],
        salmon: [ 250, 128, 114 ],
        sandybrown: [ 244, 164, 96 ],
        seagreen: [ 46, 139, 87 ],
        seashell: [ 255, 245, 238 ],
        sienna: [ 160, 82, 45 ],
        silver: [ 192, 192, 192 ],
        skyblue: [ 135, 206, 235 ],
        slateblue: [ 106, 90, 205 ],
        slategray: [ 112, 128, 144 ],
        slategrey: [ 112, 128, 144 ],
        snow: [ 255, 250, 250 ],
        springgreen: [ 0, 255, 127 ],
        steelblue: [ 70, 130, 180 ],
        tan: [ 210, 180, 140 ],
        teal: [ 0, 128, 128 ],
        thistle: [ 216, 191, 216 ],
        tomato: [ 255, 99, 71 ],
        turquoise: [ 64, 224, 208 ],
        violet: [ 238, 130, 238 ],
        wheat: [ 245, 222, 179 ],
        white: [ 255, 255, 255 ],
        whitesmoke: [ 245, 245, 245 ],
        yellow: [ 255, 255, 0 ],
        yellowgreen: [ 154, 205, 50 ]
    }, me = pe, ye = Object.hasOwnProperty, xe = Object.create(null);
    for (var _e in ge) ye.call(ge, _e) && (xe[ge[_e]] = _e);
    var ve = le.exports = {
        to: {},
        get: {}
    };
    function be(e, t, n) {
        return Math.min(Math.max(t, e), n);
    }
    function Ae(e) {
        var t = Math.round(e).toString(16).toUpperCase();
        return t.length < 2 ? "0" + t : t;
    }
    ve.get = function(e) {
        var t, n;
        switch (e.substring(0, 3).toLowerCase()) {
          case "hsl":
            t = ve.get.hsl(e), n = "hsl";
            break;

          case "hwb":
            t = ve.get.hwb(e), n = "hwb";
            break;

          default:
            t = ve.get.rgb(e), n = "rgb";
        }
        return t ? {
            model: n,
            value: t
        } : null;
    }, ve.get.rgb = function(e) {
        if (!e) return null;
        var t, n, i, r = [ 0, 0, 0, 1 ];
        if (t = e.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
            for (i = t[2], t = t[1], n = 0; n < 3; n++) {
                var s = 2 * n;
                r[n] = parseInt(t.slice(s, s + 2), 16);
            }
            i && (r[3] = parseInt(i, 16) / 255);
        } else if (t = e.match(/^#([a-f0-9]{3,4})$/i)) {
            for (i = (t = t[1])[3], n = 0; n < 3; n++) r[n] = parseInt(t[n] + t[n], 16);
            i && (r[3] = parseInt(i + i, 16) / 255);
        } else if (t = e.match(/^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/)) {
            for (n = 0; n < 3; n++) r[n] = parseInt(t[n + 1], 0);
            t[4] && (t[5] ? r[3] = .01 * parseFloat(t[4]) : r[3] = parseFloat(t[4]));
        } else {
            if (!(t = e.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/))) return (t = e.match(/^(\w+)$/)) ? "transparent" === t[1] ? [ 0, 0, 0, 0 ] : ye.call(ge, t[1]) ? ((r = ge[t[1]])[3] = 1, 
            r) : null : null;
            for (n = 0; n < 3; n++) r[n] = Math.round(2.55 * parseFloat(t[n + 1]));
            t[4] && (t[5] ? r[3] = .01 * parseFloat(t[4]) : r[3] = parseFloat(t[4]));
        }
        for (n = 0; n < 3; n++) r[n] = be(r[n], 0, 255);
        return r[3] = be(r[3], 0, 1), r;
    }, ve.get.hsl = function(e) {
        if (!e) return null;
        var t = e.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
        if (t) {
            var n = parseFloat(t[4]);
            return [ (parseFloat(t[1]) % 360 + 360) % 360, be(parseFloat(t[2]), 0, 100), be(parseFloat(t[3]), 0, 100), be(isNaN(n) ? 1 : n, 0, 1) ];
        }
        return null;
    }, ve.get.hwb = function(e) {
        if (!e) return null;
        var t = e.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
        if (t) {
            var n = parseFloat(t[4]);
            return [ (parseFloat(t[1]) % 360 + 360) % 360, be(parseFloat(t[2]), 0, 100), be(parseFloat(t[3]), 0, 100), be(isNaN(n) ? 1 : n, 0, 1) ];
        }
        return null;
    }, ve.to.hex = function() {
        var e = me(arguments);
        return "#" + Ae(e[0]) + Ae(e[1]) + Ae(e[2]) + (e[3] < 1 ? Ae(Math.round(255 * e[3])) : "");
    }, ve.to.rgb = function() {
        var e = me(arguments);
        return e.length < 4 || 1 === e[3] ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
    }, ve.to.rgb.percent = function() {
        var e = me(arguments), t = Math.round(e[0] / 255 * 100), n = Math.round(e[1] / 255 * 100), i = Math.round(e[2] / 255 * 100);
        return e.length < 4 || 1 === e[3] ? "rgb(" + t + "%, " + n + "%, " + i + "%)" : "rgba(" + t + "%, " + n + "%, " + i + "%, " + e[3] + ")";
    }, ve.to.hsl = function() {
        var e = me(arguments);
        return e.length < 4 || 1 === e[3] ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
    }, ve.to.hwb = function() {
        var e = me(arguments), t = "";
        return e.length >= 4 && 1 !== e[3] && (t = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + t + ")";
    }, ve.to.keyword = function(e) {
        return xe[e.slice(0, 3)];
    };
    var Te = le.exports, we = {
        exports: {}
    }, Se = {
        aliceblue: [ 240, 248, 255 ],
        antiquewhite: [ 250, 235, 215 ],
        aqua: [ 0, 255, 255 ],
        aquamarine: [ 127, 255, 212 ],
        azure: [ 240, 255, 255 ],
        beige: [ 245, 245, 220 ],
        bisque: [ 255, 228, 196 ],
        black: [ 0, 0, 0 ],
        blanchedalmond: [ 255, 235, 205 ],
        blue: [ 0, 0, 255 ],
        blueviolet: [ 138, 43, 226 ],
        brown: [ 165, 42, 42 ],
        burlywood: [ 222, 184, 135 ],
        cadetblue: [ 95, 158, 160 ],
        chartreuse: [ 127, 255, 0 ],
        chocolate: [ 210, 105, 30 ],
        coral: [ 255, 127, 80 ],
        cornflowerblue: [ 100, 149, 237 ],
        cornsilk: [ 255, 248, 220 ],
        crimson: [ 220, 20, 60 ],
        cyan: [ 0, 255, 255 ],
        darkblue: [ 0, 0, 139 ],
        darkcyan: [ 0, 139, 139 ],
        darkgoldenrod: [ 184, 134, 11 ],
        darkgray: [ 169, 169, 169 ],
        darkgreen: [ 0, 100, 0 ],
        darkgrey: [ 169, 169, 169 ],
        darkkhaki: [ 189, 183, 107 ],
        darkmagenta: [ 139, 0, 139 ],
        darkolivegreen: [ 85, 107, 47 ],
        darkorange: [ 255, 140, 0 ],
        darkorchid: [ 153, 50, 204 ],
        darkred: [ 139, 0, 0 ],
        darksalmon: [ 233, 150, 122 ],
        darkseagreen: [ 143, 188, 143 ],
        darkslateblue: [ 72, 61, 139 ],
        darkslategray: [ 47, 79, 79 ],
        darkslategrey: [ 47, 79, 79 ],
        darkturquoise: [ 0, 206, 209 ],
        darkviolet: [ 148, 0, 211 ],
        deeppink: [ 255, 20, 147 ],
        deepskyblue: [ 0, 191, 255 ],
        dimgray: [ 105, 105, 105 ],
        dimgrey: [ 105, 105, 105 ],
        dodgerblue: [ 30, 144, 255 ],
        firebrick: [ 178, 34, 34 ],
        floralwhite: [ 255, 250, 240 ],
        forestgreen: [ 34, 139, 34 ],
        fuchsia: [ 255, 0, 255 ],
        gainsboro: [ 220, 220, 220 ],
        ghostwhite: [ 248, 248, 255 ],
        gold: [ 255, 215, 0 ],
        goldenrod: [ 218, 165, 32 ],
        gray: [ 128, 128, 128 ],
        green: [ 0, 128, 0 ],
        greenyellow: [ 173, 255, 47 ],
        grey: [ 128, 128, 128 ],
        honeydew: [ 240, 255, 240 ],
        hotpink: [ 255, 105, 180 ],
        indianred: [ 205, 92, 92 ],
        indigo: [ 75, 0, 130 ],
        ivory: [ 255, 255, 240 ],
        khaki: [ 240, 230, 140 ],
        lavender: [ 230, 230, 250 ],
        lavenderblush: [ 255, 240, 245 ],
        lawngreen: [ 124, 252, 0 ],
        lemonchiffon: [ 255, 250, 205 ],
        lightblue: [ 173, 216, 230 ],
        lightcoral: [ 240, 128, 128 ],
        lightcyan: [ 224, 255, 255 ],
        lightgoldenrodyellow: [ 250, 250, 210 ],
        lightgray: [ 211, 211, 211 ],
        lightgreen: [ 144, 238, 144 ],
        lightgrey: [ 211, 211, 211 ],
        lightpink: [ 255, 182, 193 ],
        lightsalmon: [ 255, 160, 122 ],
        lightseagreen: [ 32, 178, 170 ],
        lightskyblue: [ 135, 206, 250 ],
        lightslategray: [ 119, 136, 153 ],
        lightslategrey: [ 119, 136, 153 ],
        lightsteelblue: [ 176, 196, 222 ],
        lightyellow: [ 255, 255, 224 ],
        lime: [ 0, 255, 0 ],
        limegreen: [ 50, 205, 50 ],
        linen: [ 250, 240, 230 ],
        magenta: [ 255, 0, 255 ],
        maroon: [ 128, 0, 0 ],
        mediumaquamarine: [ 102, 205, 170 ],
        mediumblue: [ 0, 0, 205 ],
        mediumorchid: [ 186, 85, 211 ],
        mediumpurple: [ 147, 112, 219 ],
        mediumseagreen: [ 60, 179, 113 ],
        mediumslateblue: [ 123, 104, 238 ],
        mediumspringgreen: [ 0, 250, 154 ],
        mediumturquoise: [ 72, 209, 204 ],
        mediumvioletred: [ 199, 21, 133 ],
        midnightblue: [ 25, 25, 112 ],
        mintcream: [ 245, 255, 250 ],
        mistyrose: [ 255, 228, 225 ],
        moccasin: [ 255, 228, 181 ],
        navajowhite: [ 255, 222, 173 ],
        navy: [ 0, 0, 128 ],
        oldlace: [ 253, 245, 230 ],
        olive: [ 128, 128, 0 ],
        olivedrab: [ 107, 142, 35 ],
        orange: [ 255, 165, 0 ],
        orangered: [ 255, 69, 0 ],
        orchid: [ 218, 112, 214 ],
        palegoldenrod: [ 238, 232, 170 ],
        palegreen: [ 152, 251, 152 ],
        paleturquoise: [ 175, 238, 238 ],
        palevioletred: [ 219, 112, 147 ],
        papayawhip: [ 255, 239, 213 ],
        peachpuff: [ 255, 218, 185 ],
        peru: [ 205, 133, 63 ],
        pink: [ 255, 192, 203 ],
        plum: [ 221, 160, 221 ],
        powderblue: [ 176, 224, 230 ],
        purple: [ 128, 0, 128 ],
        rebeccapurple: [ 102, 51, 153 ],
        red: [ 255, 0, 0 ],
        rosybrown: [ 188, 143, 143 ],
        royalblue: [ 65, 105, 225 ],
        saddlebrown: [ 139, 69, 19 ],
        salmon: [ 250, 128, 114 ],
        sandybrown: [ 244, 164, 96 ],
        seagreen: [ 46, 139, 87 ],
        seashell: [ 255, 245, 238 ],
        sienna: [ 160, 82, 45 ],
        silver: [ 192, 192, 192 ],
        skyblue: [ 135, 206, 235 ],
        slateblue: [ 106, 90, 205 ],
        slategray: [ 112, 128, 144 ],
        slategrey: [ 112, 128, 144 ],
        snow: [ 255, 250, 250 ],
        springgreen: [ 0, 255, 127 ],
        steelblue: [ 70, 130, 180 ],
        tan: [ 210, 180, 140 ],
        teal: [ 0, 128, 128 ],
        thistle: [ 216, 191, 216 ],
        tomato: [ 255, 99, 71 ],
        turquoise: [ 64, 224, 208 ],
        violet: [ 238, 130, 238 ],
        wheat: [ 245, 222, 179 ],
        white: [ 255, 255, 255 ],
        whitesmoke: [ 245, 245, 245 ],
        yellow: [ 255, 255, 0 ],
        yellowgreen: [ 154, 205, 50 ]
    }, Me = {};
    for (var Pe in Se) Se.hasOwnProperty(Pe) && (Me[Se[Pe]] = Pe);
    var Ie = we.exports = {
        rgb: {
            channels: 3,
            labels: "rgb"
        },
        hsl: {
            channels: 3,
            labels: "hsl"
        },
        hsv: {
            channels: 3,
            labels: "hsv"
        },
        hwb: {
            channels: 3,
            labels: "hwb"
        },
        cmyk: {
            channels: 4,
            labels: "cmyk"
        },
        xyz: {
            channels: 3,
            labels: "xyz"
        },
        lab: {
            channels: 3,
            labels: "lab"
        },
        lch: {
            channels: 3,
            labels: "lch"
        },
        hex: {
            channels: 1,
            labels: [ "hex" ]
        },
        keyword: {
            channels: 1,
            labels: [ "keyword" ]
        },
        ansi16: {
            channels: 1,
            labels: [ "ansi16" ]
        },
        ansi256: {
            channels: 1,
            labels: [ "ansi256" ]
        },
        hcg: {
            channels: 3,
            labels: [ "h", "c", "g" ]
        },
        apple: {
            channels: 3,
            labels: [ "r16", "g16", "b16" ]
        },
        gray: {
            channels: 1,
            labels: [ "gray" ]
        }
    };
    for (var Ce in Ie) if (Ie.hasOwnProperty(Ce)) {
        if (!("channels" in Ie[Ce])) throw new Error("missing channels property: " + Ce);
        if (!("labels" in Ie[Ce])) throw new Error("missing channel labels property: " + Ce);
        if (Ie[Ce].labels.length !== Ie[Ce].channels) throw new Error("channel and label counts mismatch: " + Ce);
        var ke = Ie[Ce].channels, Fe = Ie[Ce].labels;
        delete Ie[Ce].channels, delete Ie[Ce].labels, Object.defineProperty(Ie[Ce], "channels", {
            value: ke
        }), Object.defineProperty(Ie[Ce], "labels", {
            value: Fe
        });
    }
    Ie.rgb.hsl = function(e) {
        var t, n, i = e[0] / 255, r = e[1] / 255, s = e[2] / 255, o = Math.min(i, r, s), a = Math.max(i, r, s), l = a - o;
        return a === o ? t = 0 : i === a ? t = (r - s) / l : r === a ? t = 2 + (s - i) / l : s === a && (t = 4 + (i - r) / l), 
        (t = Math.min(60 * t, 360)) < 0 && (t += 360), n = (o + a) / 2, [ t, 100 * (a === o ? 0 : n <= .5 ? l / (a + o) : l / (2 - a - o)), 100 * n ];
    }, Ie.rgb.hsv = function(e) {
        var t, n, i, r, s, o = e[0] / 255, a = e[1] / 255, l = e[2] / 255, h = Math.max(o, a, l), c = h - Math.min(o, a, l), u = function(e) {
            return (h - e) / 6 / c + .5;
        };
        return 0 === c ? r = s = 0 : (s = c / h, t = u(o), n = u(a), i = u(l), o === h ? r = i - n : a === h ? r = 1 / 3 + t - i : l === h && (r = 2 / 3 + n - t), 
        r < 0 ? r += 1 : r > 1 && (r -= 1)), [ 360 * r, 100 * s, 100 * h ];
    }, Ie.rgb.hwb = function(e) {
        var t = e[0], n = e[1], i = e[2];
        return [ Ie.rgb.hsl(e)[0], 1 / 255 * Math.min(t, Math.min(n, i)) * 100, 100 * (i = 1 - 1 / 255 * Math.max(t, Math.max(n, i))) ];
    }, Ie.rgb.cmyk = function(e) {
        var t, n = e[0] / 255, i = e[1] / 255, r = e[2] / 255;
        return [ 100 * ((1 - n - (t = Math.min(1 - n, 1 - i, 1 - r))) / (1 - t) || 0), 100 * ((1 - i - t) / (1 - t) || 0), 100 * ((1 - r - t) / (1 - t) || 0), 100 * t ];
    }, Ie.rgb.keyword = function(e) {
        var t = Me[e];
        if (t) return t;
        var n, i, r, s = 1 / 0;
        for (var o in Se) if (Se.hasOwnProperty(o)) {
            var a = (i = e, r = Se[o], Math.pow(i[0] - r[0], 2) + Math.pow(i[1] - r[1], 2) + Math.pow(i[2] - r[2], 2));
            a < s && (s = a, n = o);
        }
        return n;
    }, Ie.keyword.rgb = function(e) {
        return Se[e];
    }, Ie.rgb.xyz = function(e) {
        var t = e[0] / 255, n = e[1] / 255, i = e[2] / 255;
        return [ 100 * (.4124 * (t = t > .04045 ? Math.pow((t + .055) / 1.055, 2.4) : t / 12.92) + .3576 * (n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92) + .1805 * (i = i > .04045 ? Math.pow((i + .055) / 1.055, 2.4) : i / 12.92)), 100 * (.2126 * t + .7152 * n + .0722 * i), 100 * (.0193 * t + .1192 * n + .9505 * i) ];
    }, Ie.rgb.lab = function(e) {
        var t = Ie.rgb.xyz(e), n = t[0], i = t[1], r = t[2];
        return i /= 100, r /= 108.883, n = (n /= 95.047) > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, 
        [ 116 * (i = i > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116) - 16, 500 * (n - i), 200 * (i - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116)) ];
    }, Ie.hsl.rgb = function(e) {
        var t, n, i, r, s, o = e[0] / 360, a = e[1] / 100, l = e[2] / 100;
        if (0 === a) return [ s = 255 * l, s, s ];
        t = 2 * l - (n = l < .5 ? l * (1 + a) : l + a - l * a), r = [ 0, 0, 0 ];
        for (var h = 0; h < 3; h++) (i = o + 1 / 3 * -(h - 1)) < 0 && i++, i > 1 && i--, 
        s = 6 * i < 1 ? t + 6 * (n - t) * i : 2 * i < 1 ? n : 3 * i < 2 ? t + (n - t) * (2 / 3 - i) * 6 : t, 
        r[h] = 255 * s;
        return r;
    }, Ie.hsl.hsv = function(e) {
        var t = e[0], n = e[1] / 100, i = e[2] / 100, r = n, s = Math.max(i, .01);
        return n *= (i *= 2) <= 1 ? i : 2 - i, r *= s <= 1 ? s : 2 - s, [ t, 100 * (0 === i ? 2 * r / (s + r) : 2 * n / (i + n)), (i + n) / 2 * 100 ];
    }, Ie.hsv.rgb = function(e) {
        var t = e[0] / 60, n = e[1] / 100, i = e[2] / 100, r = Math.floor(t) % 6, s = t - Math.floor(t), o = 255 * i * (1 - n), a = 255 * i * (1 - n * s), l = 255 * i * (1 - n * (1 - s));
        switch (i *= 255, r) {
          case 0:
            return [ i, l, o ];

          case 1:
            return [ a, i, o ];

          case 2:
            return [ o, i, l ];

          case 3:
            return [ o, a, i ];

          case 4:
            return [ l, o, i ];

          case 5:
            return [ i, o, a ];
        }
    }, Ie.hsv.hsl = function(e) {
        var t, n, i, r = e[0], s = e[1] / 100, o = e[2] / 100, a = Math.max(o, .01);
        return i = (2 - s) * o, n = s * a, [ r, 100 * (n = (n /= (t = (2 - s) * a) <= 1 ? t : 2 - t) || 0), 100 * (i /= 2) ];
    }, Ie.hwb.rgb = function(e) {
        var t, n, i, r, s, o, a, l = e[0] / 360, h = e[1] / 100, c = e[2] / 100, u = h + c;
        switch (u > 1 && (h /= u, c /= u), i = 6 * l - (t = Math.floor(6 * l)), 1 & t && (i = 1 - i), 
        r = h + i * ((n = 1 - c) - h), t) {
          default:
          case 6:
          case 0:
            s = n, o = r, a = h;
            break;

          case 1:
            s = r, o = n, a = h;
            break;

          case 2:
            s = h, o = n, a = r;
            break;

          case 3:
            s = h, o = r, a = n;
            break;

          case 4:
            s = r, o = h, a = n;
            break;

          case 5:
            s = n, o = h, a = r;
        }
        return [ 255 * s, 255 * o, 255 * a ];
    }, Ie.cmyk.rgb = function(e) {
        var t = e[0] / 100, n = e[1] / 100, i = e[2] / 100, r = e[3] / 100;
        return [ 255 * (1 - Math.min(1, t * (1 - r) + r)), 255 * (1 - Math.min(1, n * (1 - r) + r)), 255 * (1 - Math.min(1, i * (1 - r) + r)) ];
    }, Ie.xyz.rgb = function(e) {
        var t, n, i, r = e[0] / 100, s = e[1] / 100, o = e[2] / 100;
        return n = -.9689 * r + 1.8758 * s + .0415 * o, i = .0557 * r + -.204 * s + 1.057 * o, 
        t = (t = 3.2406 * r + -1.5372 * s + -.4986 * o) > .0031308 ? 1.055 * Math.pow(t, 1 / 2.4) - .055 : 12.92 * t, 
        n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : 12.92 * n, i = i > .0031308 ? 1.055 * Math.pow(i, 1 / 2.4) - .055 : 12.92 * i, 
        [ 255 * (t = Math.min(Math.max(0, t), 1)), 255 * (n = Math.min(Math.max(0, n), 1)), 255 * (i = Math.min(Math.max(0, i), 1)) ];
    }, Ie.xyz.lab = function(e) {
        var t = e[0], n = e[1], i = e[2];
        return n /= 100, i /= 108.883, t = (t /= 95.047) > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, 
        [ 116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16, 500 * (t - n), 200 * (n - (i = i > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116)) ];
    }, Ie.lab.xyz = function(e) {
        var t, n, i, r = e[0];
        t = e[1] / 500 + (n = (r + 16) / 116), i = n - e[2] / 200;
        var s = Math.pow(n, 3), o = Math.pow(t, 3), a = Math.pow(i, 3);
        return n = s > .008856 ? s : (n - 16 / 116) / 7.787, t = o > .008856 ? o : (t - 16 / 116) / 7.787, 
        i = a > .008856 ? a : (i - 16 / 116) / 7.787, [ t *= 95.047, n *= 100, i *= 108.883 ];
    }, Ie.lab.lch = function(e) {
        var t, n = e[0], i = e[1], r = e[2];
        return (t = 360 * Math.atan2(r, i) / 2 / Math.PI) < 0 && (t += 360), [ n, Math.sqrt(i * i + r * r), t ];
    }, Ie.lch.lab = function(e) {
        var t, n = e[0], i = e[1];
        return t = e[2] / 360 * 2 * Math.PI, [ n, i * Math.cos(t), i * Math.sin(t) ];
    }, Ie.rgb.ansi16 = function(e) {
        var t = e[0], n = e[1], i = e[2], r = 1 in arguments ? arguments[1] : Ie.rgb.hsv(e)[2];
        if (0 === (r = Math.round(r / 50))) return 30;
        var s = 30 + (Math.round(i / 255) << 2 | Math.round(n / 255) << 1 | Math.round(t / 255));
        return 2 === r && (s += 60), s;
    }, Ie.hsv.ansi16 = function(e) {
        return Ie.rgb.ansi16(Ie.hsv.rgb(e), e[2]);
    }, Ie.rgb.ansi256 = function(e) {
        var t = e[0], n = e[1], i = e[2];
        return t === n && n === i ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(i / 255 * 5);
    }, Ie.ansi16.rgb = function(e) {
        var t = e % 10;
        if (0 === t || 7 === t) return e > 50 && (t += 3.5), [ t = t / 10.5 * 255, t, t ];
        var n = .5 * (1 + ~~(e > 50));
        return [ (1 & t) * n * 255, (t >> 1 & 1) * n * 255, (t >> 2 & 1) * n * 255 ];
    }, Ie.ansi256.rgb = function(e) {
        if (e >= 232) {
            var t = 10 * (e - 232) + 8;
            return [ t, t, t ];
        }
        var n;
        return e -= 16, [ Math.floor(e / 36) / 5 * 255, Math.floor((n = e % 36) / 6) / 5 * 255, n % 6 / 5 * 255 ];
    }, Ie.rgb.hex = function(e) {
        var t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
        return "000000".substring(t.length) + t;
    }, Ie.hex.rgb = function(e) {
        var t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
        if (!t) return [ 0, 0, 0 ];
        var n = t[0];
        3 === t[0].length && (n = n.split("").map((function(e) {
            return e + e;
        })).join(""));
        var i = parseInt(n, 16);
        return [ i >> 16 & 255, i >> 8 & 255, 255 & i ];
    }, Ie.rgb.hcg = function(e) {
        var t, n = e[0] / 255, i = e[1] / 255, r = e[2] / 255, s = Math.max(Math.max(n, i), r), o = Math.min(Math.min(n, i), r), a = s - o;
        return t = a <= 0 ? 0 : s === n ? (i - r) / a % 6 : s === i ? 2 + (r - n) / a : 4 + (n - i) / a + 4, 
        t /= 6, [ 360 * (t %= 1), 100 * a, 100 * (a < 1 ? o / (1 - a) : 0) ];
    }, Ie.hsl.hcg = function(e) {
        var t, n = e[1] / 100, i = e[2] / 100, r = 0;
        return (t = i < .5 ? 2 * n * i : 2 * n * (1 - i)) < 1 && (r = (i - .5 * t) / (1 - t)), 
        [ e[0], 100 * t, 100 * r ];
    }, Ie.hsv.hcg = function(e) {
        var t = e[1] / 100, n = e[2] / 100, i = t * n, r = 0;
        return i < 1 && (r = (n - i) / (1 - i)), [ e[0], 100 * i, 100 * r ];
    }, Ie.hcg.rgb = function(e) {
        var t = e[0] / 360, n = e[1] / 100, i = e[2] / 100;
        if (0 === n) return [ 255 * i, 255 * i, 255 * i ];
        var r, s = [ 0, 0, 0 ], o = t % 1 * 6, a = o % 1, l = 1 - a;
        switch (Math.floor(o)) {
          case 0:
            s[0] = 1, s[1] = a, s[2] = 0;
            break;

          case 1:
            s[0] = l, s[1] = 1, s[2] = 0;
            break;

          case 2:
            s[0] = 0, s[1] = 1, s[2] = a;
            break;

          case 3:
            s[0] = 0, s[1] = l, s[2] = 1;
            break;

          case 4:
            s[0] = a, s[1] = 0, s[2] = 1;
            break;

          default:
            s[0] = 1, s[1] = 0, s[2] = l;
        }
        return r = (1 - n) * i, [ 255 * (n * s[0] + r), 255 * (n * s[1] + r), 255 * (n * s[2] + r) ];
    }, Ie.hcg.hsv = function(e) {
        var t = e[1] / 100, n = t + e[2] / 100 * (1 - t), i = 0;
        return n > 0 && (i = t / n), [ e[0], 100 * i, 100 * n ];
    }, Ie.hcg.hsl = function(e) {
        var t = e[1] / 100, n = e[2] / 100 * (1 - t) + .5 * t, i = 0;
        return n > 0 && n < .5 ? i = t / (2 * n) : n >= .5 && n < 1 && (i = t / (2 * (1 - n))), 
        [ e[0], 100 * i, 100 * n ];
    }, Ie.hcg.hwb = function(e) {
        var t = e[1] / 100, n = t + e[2] / 100 * (1 - t);
        return [ e[0], 100 * (n - t), 100 * (1 - n) ];
    }, Ie.hwb.hcg = function(e) {
        var t = e[1] / 100, n = 1 - e[2] / 100, i = n - t, r = 0;
        return i < 1 && (r = (n - i) / (1 - i)), [ e[0], 100 * i, 100 * r ];
    }, Ie.apple.rgb = function(e) {
        return [ e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255 ];
    }, Ie.rgb.apple = function(e) {
        return [ e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535 ];
    }, Ie.gray.rgb = function(e) {
        return [ e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255 ];
    }, Ie.gray.hsl = Ie.gray.hsv = function(e) {
        return [ 0, 0, e[0] ];
    }, Ie.gray.hwb = function(e) {
        return [ 0, 100, e[0] ];
    }, Ie.gray.cmyk = function(e) {
        return [ 0, 0, 0, e[0] ];
    }, Ie.gray.lab = function(e) {
        return [ e[0], 0, 0 ];
    }, Ie.gray.hex = function(e) {
        var t = 255 & Math.round(e[0] / 100 * 255), n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
        return "000000".substring(n.length) + n;
    }, Ie.rgb.gray = function(e) {
        return [ (e[0] + e[1] + e[2]) / 3 / 255 * 100 ];
    };
    var Oe = we.exports, Re = Oe;
    function Ee(e, t) {
        return function(n) {
            return t(e(n));
        };
    }
    function De(e, t) {
        for (var n = [ t[e].parent, e ], i = Re[t[e].parent][e], r = t[e].parent; t[r].parent; ) n.unshift(t[r].parent), 
        i = Ee(Re[t[r].parent][r], i), r = t[r].parent;
        return i.conversion = n, i;
    }
    var Le = Oe, He = function(e) {
        for (var t = function(e) {
            var t = function() {
                for (var e = {}, t = Object.keys(Re), n = t.length, i = 0; i < n; i++) e[t[i]] = {
                    distance: -1,
                    parent: null
                };
                return e;
            }(), n = [ e ];
            for (t[e].distance = 0; n.length; ) for (var i = n.pop(), r = Object.keys(Re[i]), s = r.length, o = 0; o < s; o++) {
                var a = r[o], l = t[a];
                -1 === l.distance && (l.distance = t[i].distance + 1, l.parent = i, n.unshift(a));
            }
            return t;
        }(e), n = {}, i = Object.keys(t), r = i.length, s = 0; s < r; s++) {
            var o = i[s];
            null !== t[o].parent && (n[o] = De(o, t));
        }
        return n;
    }, ze = {};
    Object.keys(Le).forEach((function(e) {
        ze[e] = {}, Object.defineProperty(ze[e], "channels", {
            value: Le[e].channels
        }), Object.defineProperty(ze[e], "labels", {
            value: Le[e].labels
        });
        var t = He(e);
        Object.keys(t).forEach((function(n) {
            var i = t[n];
            ze[e][n] = function(e) {
                var t = function(t) {
                    if (null == t) return t;
                    arguments.length > 1 && (t = Array.prototype.slice.call(arguments));
                    var n = e(t);
                    if ("object" == typeof n) for (var i = n.length, r = 0; r < i; r++) n[r] = Math.round(n[r]);
                    return n;
                };
                return "conversion" in e && (t.conversion = e.conversion), t;
            }(i), ze[e][n].raw = function(e) {
                var t = function(t) {
                    return null == t ? t : (arguments.length > 1 && (t = Array.prototype.slice.call(arguments)), 
                    e(t));
                };
                return "conversion" in e && (t.conversion = e.conversion), t;
            }(i);
        }));
    }));
    var Ne = Te, Ve = ze, Be = [].slice, Ue = [ "keyword", "gray", "hex" ], Ge = {};
    Object.keys(Ve).forEach((function(e) {
        Ge[Be.call(Ve[e].labels).sort().join("")] = e;
    }));
    var je = {};
    function We(e, t) {
        if (!(this instanceof We)) return new We(e, t);
        if (t && t in Ue && (t = null), t && !(t in Ve)) throw new Error("Unknown model: " + t);
        var n, i;
        if (null == e) this.model = "rgb", this.color = [ 0, 0, 0 ], this.valpha = 1; else if (e instanceof We) this.model = e.model, 
        this.color = e.color.slice(), this.valpha = e.valpha; else if ("string" == typeof e) {
            var r = Ne.get(e);
            if (null === r) throw new Error("Unable to parse color from string: " + e);
            this.model = r.model, i = Ve[this.model].channels, this.color = r.value.slice(0, i), 
            this.valpha = "number" == typeof r.value[i] ? r.value[i] : 1;
        } else if (e.length) {
            this.model = t || "rgb", i = Ve[this.model].channels;
            var s = Be.call(e, 0, i);
            this.color = qe(s, i), this.valpha = "number" == typeof e[i] ? e[i] : 1;
        } else if ("number" == typeof e) e &= 16777215, this.model = "rgb", this.color = [ e >> 16 & 255, e >> 8 & 255, 255 & e ], 
        this.valpha = 1; else {
            this.valpha = 1;
            var o = Object.keys(e);
            "alpha" in e && (o.splice(o.indexOf("alpha"), 1), this.valpha = "number" == typeof e.alpha ? e.alpha : 0);
            var a = o.sort().join("");
            if (!(a in Ge)) throw new Error("Unable to parse color from object: " + JSON.stringify(e));
            this.model = Ge[a];
            var l = Ve[this.model].labels, h = [];
            for (n = 0; n < l.length; n++) h.push(e[l[n]]);
            this.color = qe(h);
        }
        if (je[this.model]) for (i = Ve[this.model].channels, n = 0; n < i; n++) {
            var c = je[this.model][n];
            c && (this.color[n] = c(this.color[n]));
        }
        this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
    }
    function Xe(e, t, n) {
        return (e = Array.isArray(e) ? e : [ e ]).forEach((function(e) {
            (je[e] || (je[e] = []))[t] = n;
        })), e = e[0], function(i) {
            var r;
            return arguments.length ? (n && (i = n(i)), (r = this[e]()).color[t] = i, r) : (r = this[e]().color[t], 
            n && (r = n(r)), r);
        };
    }
    function Ye(e) {
        return function(t) {
            return Math.max(0, Math.min(e, t));
        };
    }
    function qe(e, t) {
        for (var n = 0; n < t; n++) "number" != typeof e[n] && (e[n] = 0);
        return e;
    }
    We.prototype = {
        toString: function() {
            return this.string();
        },
        toJSON: function() {
            return this[this.model]();
        },
        string: function(e) {
            var t = this.model in Ne.to ? this : this.rgb(), n = 1 === (t = t.round("number" == typeof e ? e : 1)).valpha ? t.color : t.color.concat(this.valpha);
            return Ne.to[t.model](n);
        },
        percentString: function(e) {
            var t = this.rgb().round("number" == typeof e ? e : 1), n = 1 === t.valpha ? t.color : t.color.concat(this.valpha);
            return Ne.to.rgb.percent(n);
        },
        array: function() {
            return 1 === this.valpha ? this.color.slice() : this.color.concat(this.valpha);
        },
        object: function() {
            for (var e = {}, t = Ve[this.model].channels, n = Ve[this.model].labels, i = 0; i < t; i++) e[n[i]] = this.color[i];
            return 1 !== this.valpha && (e.alpha = this.valpha), e;
        },
        unitArray: function() {
            var e = this.rgb().color;
            return e[0] /= 255, e[1] /= 255, e[2] /= 255, 1 !== this.valpha && e.push(this.valpha), 
            e;
        },
        unitObject: function() {
            var e = this.rgb().object();
            return e.r /= 255, e.g /= 255, e.b /= 255, 1 !== this.valpha && (e.alpha = this.valpha), 
            e;
        },
        round: function(e) {
            return e = Math.max(e || 0, 0), new We(this.color.map(function(e) {
                return function(t) {
                    return function(e, t) {
                        return Number(e.toFixed(t));
                    }(t, e);
                };
            }(e)).concat(this.valpha), this.model);
        },
        alpha: function(e) {
            return arguments.length ? new We(this.color.concat(Math.max(0, Math.min(1, e))), this.model) : this.valpha;
        },
        red: Xe("rgb", 0, Ye(255)),
        green: Xe("rgb", 1, Ye(255)),
        blue: Xe("rgb", 2, Ye(255)),
        hue: Xe([ "hsl", "hsv", "hsl", "hwb", "hcg" ], 0, (function(e) {
            return (e % 360 + 360) % 360;
        })),
        saturationl: Xe("hsl", 1, Ye(100)),
        lightness: Xe("hsl", 2, Ye(100)),
        saturationv: Xe("hsv", 1, Ye(100)),
        value: Xe("hsv", 2, Ye(100)),
        chroma: Xe("hcg", 1, Ye(100)),
        gray: Xe("hcg", 2, Ye(100)),
        white: Xe("hwb", 1, Ye(100)),
        wblack: Xe("hwb", 2, Ye(100)),
        cyan: Xe("cmyk", 0, Ye(100)),
        magenta: Xe("cmyk", 1, Ye(100)),
        yellow: Xe("cmyk", 2, Ye(100)),
        black: Xe("cmyk", 3, Ye(100)),
        x: Xe("xyz", 0, Ye(100)),
        y: Xe("xyz", 1, Ye(100)),
        z: Xe("xyz", 2, Ye(100)),
        l: Xe("lab", 0, Ye(100)),
        a: Xe("lab", 1),
        b: Xe("lab", 2),
        keyword: function(e) {
            return arguments.length ? new We(e) : Ve[this.model].keyword(this.color);
        },
        hex: function(e) {
            return arguments.length ? new We(e) : Ne.to.hex(this.rgb().round().color);
        },
        rgbNumber: function() {
            var e = this.rgb().color;
            return (255 & e[0]) << 16 | (255 & e[1]) << 8 | 255 & e[2];
        },
        luminosity: function() {
            for (var e = this.rgb().color, t = [], n = 0; n < e.length; n++) {
                var i = e[n] / 255;
                t[n] = i <= .03928 ? i / 12.92 : Math.pow((i + .055) / 1.055, 2.4);
            }
            return .2126 * t[0] + .7152 * t[1] + .0722 * t[2];
        },
        contrast: function(e) {
            var t = this.luminosity(), n = e.luminosity();
            return t > n ? (t + .05) / (n + .05) : (n + .05) / (t + .05);
        },
        level: function(e) {
            var t = this.contrast(e);
            return t >= 7.1 ? "AAA" : t >= 4.5 ? "AA" : "";
        },
        isDark: function() {
            var e = this.rgb().color;
            return (299 * e[0] + 587 * e[1] + 114 * e[2]) / 1e3 < 128;
        },
        isLight: function() {
            return !this.isDark();
        },
        negate: function() {
            for (var e = this.rgb(), t = 0; t < 3; t++) e.color[t] = 255 - e.color[t];
            return e;
        },
        lighten: function(e) {
            var t = this.hsl();
            return t.color[2] += t.color[2] * e, t;
        },
        darken: function(e) {
            var t = this.hsl();
            return t.color[2] -= t.color[2] * e, t;
        },
        saturate: function(e) {
            var t = this.hsl();
            return t.color[1] += t.color[1] * e, t;
        },
        desaturate: function(e) {
            var t = this.hsl();
            return t.color[1] -= t.color[1] * e, t;
        },
        whiten: function(e) {
            var t = this.hwb();
            return t.color[1] += t.color[1] * e, t;
        },
        blacken: function(e) {
            var t = this.hwb();
            return t.color[2] += t.color[2] * e, t;
        },
        grayscale: function() {
            var e = this.rgb().color, t = .3 * e[0] + .59 * e[1] + .11 * e[2];
            return We.rgb(t, t, t);
        },
        fade: function(e) {
            return this.alpha(this.valpha - this.valpha * e);
        },
        opaquer: function(e) {
            return this.alpha(this.valpha + this.valpha * e);
        },
        rotate: function(e) {
            var t = this.hsl(), n = t.color[0];
            return n = (n = (n + e) % 360) < 0 ? 360 + n : n, t.color[0] = n, t;
        },
        mix: function(e, t) {
            if (!e || !e.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof e);
            var n = e.rgb(), i = this.rgb(), r = void 0 === t ? .5 : t, s = 2 * r - 1, o = n.alpha() - i.alpha(), a = ((s * o == -1 ? s : (s + o) / (1 + s * o)) + 1) / 2, l = 1 - a;
            return We.rgb(a * n.red() + l * i.red(), a * n.green() + l * i.green(), a * n.blue() + l * i.blue(), n.alpha() * r + i.alpha() * (1 - r));
        }
    }, Object.keys(Ve).forEach((function(e) {
        if (-1 === Ue.indexOf(e)) {
            var t = Ve[e].channels;
            We.prototype[e] = function() {
                if (this.model === e) return new We(this);
                if (arguments.length) return new We(arguments, e);
                var n, i = "number" == typeof arguments[t] ? t : this.valpha;
                return new We((n = Ve[this.model][e].raw(this.color), Array.isArray(n) ? n : [ n ]).concat(i), e);
            }, We[e] = function(n) {
                return "number" == typeof n && (n = qe(Be.call(arguments), t)), new We(n, e);
            };
        }
    }));
    var Ze = n(We);
    function $e(e) {
        for (let t = 1; t < arguments.length; t++) {
            const n = arguments[t];
            for (const t in n) e[t] = n[t];
        }
        return e;
    }
    function Je(e) {
        return null == e;
    }
    function Ke(e) {
        return "number" == typeof e && !isNaN(e);
    }
    function Qe(e) {
        return "object" == typeof e && !!e;
    }
    function et(e) {
        return !Je(e) && ("string" == typeof e || null !== e.constructor && e.constructor === String);
    }
    function tt(e) {
        return !Je(e) && ("function" == typeof e || null !== e.constructor && e.constructor === Function);
    }
    const nt = Object.prototype.hasOwnProperty;
    function it(e, t) {
        return nt.call(e, t);
    }
    const rt = Math.PI / 180;
    function st(e) {
        return e && ie(e) && e.property;
    }
    function ot(e) {
        const {verticalCentimeterToPoint: t, tileRatio: n} = e;
        return t * n;
    }
    function at(e) {
        return "centimeter" === e || "cm" === e ? 1 : "millimeter" === e || "mm" === e ? .1 : 100;
    }
    const lt = {};
    function ht(e, t) {
        if (!Array.isArray(t)) {
            if (t && void 0 !== t.r && void 0 !== t.g && void 0 !== t.b) return e[0] = 255 * t.r, 
            e[1] = 255 * t.g, e[2] = 255 * t.b, void 0 !== t.a ? e[3] = 255 * t.a : e[3] = 255, 
            e;
            const n = t;
            t = lt[n] = lt[n] || Ze(t).unitArray();
        }
        for (let n = 0; n < t.length; n++) e[n] = 255 * t[n];
        return 3 === t.length && (e[3] = 255), e;
    }
    const ct = {
        textFill: 1,
        textSize: 1,
        textOpacity: 1,
        textDx: 1,
        textDy: 1,
        markerWidth: 1,
        markerHeight: 1,
        markerOpacity: 1,
        markerDx: 1,
        markerDy: 1,
        lineWidth: 1,
        lineColor: 1,
        lineOpacity: 1,
        polygonFill: 1,
        polygonOpacity: 1,
        polygonPatternFileWidth: 1,
        polygonPatternFileOrigin: 1,
        rotationX: 1,
        rotationY: 1,
        rotationZ: 1,
        scaleX: 1,
        scaleY: 1,
        scaleZ: 1,
        translationX: 1,
        translationY: 1,
        translationZ: 1
    }, ut = {
        textName: 1,
        markerTextFitPadding: 1,
        markerTextFit: 1,
        lineGradientProperty: 1
    };
    var ft = Object.freeze({
        __proto__: null,
        checkIfIdentityZoomDependent: function(e, t, n) {
            if (Array.isArray(n) || (n = Object.values(n)), !n || !n.length) return !1;
            if (!ct[e]) return !1;
            for (let e = 0; e < n.length; e++) {
                const i = n[e] && (n[e].feature || n[e]);
                if (!i) continue;
                const r = i.properties && i.properties[t];
                if (r && ie(r) && !re(r).isZoomConstant) return !0;
            }
            return !1;
        },
        checkIfZoomFnTypeSymbol: function(e) {
            return !!ct[e] || !!ut[e];
        },
        evaluate: function(e, t, n) {
            return tt(e) ? e(void 0 !== n ? n : null, t) : e;
        },
        extend: $e,
        getAltitudeToLocal: ot,
        getTubeSizeScale: at,
        hasOwn: it,
        isFnTypeSymbol: st,
        isFunction: tt,
        isInteger: function(e) {
            return (0 | e) === e;
        },
        isNil: Je,
        isNumber: Ke,
        isObject: Qe,
        isString: et,
        join: function(e, t) {
            return e.join ? e.join(t || ",") : Array.prototype.join.call(e, t || ",");
        },
        normalizeColor: ht,
        now: function() {
            return Date.now();
        },
        toDegree: function(e) {
            return e / rt;
        },
        toRadian: function(e) {
            return e * rt;
        }
    });
    class dt {
        constructor(e, t, n, i) {
            this.feature = e, this.symbol = t, this.fnTypes = n, this.options = i;
        }
        getPolygonResource() {
            let e = this.symbol.polygonPatternFile;
            const {polygonPatternFileFn: t} = this.fnTypes, n = t;
            return this._getResource(e, n);
        }
        getLineResource() {
            let e = this.symbol.linePatternFile;
            const {linePatternFileFn: t} = this.fnTypes, n = t;
            return this._getResource(e, n);
        }
        _getResource(e, t) {
            if (t) {
                const n = this.feature.properties;
                e = t(this.options.zoom, n);
            }
            return e;
        }
    }
    function pt(e, t, n, i) {
        const r = Math.abs(i) >> 15, s = r >> 1, o = r % 2;
        let a = i % Math.pow(2, 15);
        const l = t + (s << 14) * Math.sign(t), h = n + (o << 14) * Math.sign(n);
        return e[0] = l, e[1] = h, a = Math.round(a), e[2] = 0 === a ? i < 0 ? -1 : 0 : a, 
        e;
    }
    const gt = Math.pow(2, 14), mt = Math.pow(2, 15), yt = [ "Unknown", "Point", "LineString", "Polygon", "MultiPoint", "MultiLineString", "MultiPolygon", "GeometryCollection" ];
    /*!
	    Feature Filter by

	    (c) mapbox 2016 and maptalks 2018
	    www.mapbox.com | www.maptalks.org
	    License: MIT, header required.
	*/    function xt(e) {
        if (!0 === e || !1 === e) return !0;
        if (!Array.isArray(e) || 0 === e.length) return !1;
        switch (e[0]) {
          case "has":
          case "!has":
            return 2 === e.length && ("string" == typeof e[1] || e[1].property && e[1].op);

          case "in":
          case "!in":
            return e.length >= 2 && ("string" == typeof e[1] || e[1].property && e[1].op);

          case "==":
          case "!=":
          case ">":
          case ">=":
          case "<":
          case "<=":
            return 3 === e.length && ("string" == typeof e[1] || e[1].property && e[1].op);

          case "none":
          case "any":
          case "all":
            for (const t of e.slice(1)) if (!xt(t) && "boolean" != typeof t) return !1;
            return !0;

          case "contains":
            return !0;

          default:
            return !1;
        }
    }
    function _t(e) {
        if (!e) return "true";
        const t = e[0];
        if (e.length <= 1) return "any" === t ? "false" : "true";
        const n = "==" === t ? bt(e[1], e[2], "===", !1) : "!=" === t ? bt(e[1], e[2], "!==", !1) : "<" === t || ">" === t || "<=" === t || ">=" === t ? bt(e[1], e[2], t, !0) : "any" === t ? Tt(e.slice(1), "||") : "all" === t ? Tt(e.slice(1), "&&") : "none" === t ? Mt(Tt(e.slice(1), "||")) : "in" === t ? wt(e[1], e.slice(2)) : "!in" === t ? Mt(wt(e[1], e.slice(2))) : "has" === t ? St(e[1]) : "!has" === t ? Mt(St(e[1])) : "contains" === t ? function(e, t, n) {
            const i = vt(e);
            return void 0 !== n ? `(${i} + '').indexOf("${t}") === ${n}` : `(${i} + '').indexOf("${t}") >= 0`;
        }(e[1], e[2], e[3]) : "true";
        return `(${n})`;
    }
    function vt(e) {
        return "$" === e[0] ? "f." + e.substring(1) : "p[" + JSON.stringify(e) + "]";
    }
    function bt(e, t, n, i) {
        return "object" == typeof (r = e) && r && e.op ? function(e, t, n, i) {
            const r = e.property, s = e.op;
            let o = vt(r);
            return "length" !== s ? (console.error(`not support ${s} op`), "false") : (o = `((${o}+='').length)`, 
            At(o, r, t, n, i));
        }(e, t, n, i) : At(vt(e), e, t, n, i);
        var r;
    }
    function At(e, t, n, i, r) {
        const s = "$type" === t ? yt.indexOf(n) : JSON.stringify(n);
        return (r ? `typeof ${e}=== typeof ${s}&&` : "") + e + i + s;
    }
    function Tt(e, t) {
        return e.map(_t).join(t);
    }
    function wt(e, t) {
        "$type" === e && (t = t.map((e => yt.indexOf(e))));
        const n = JSON.stringify(t.sort(Pt)), i = vt(e);
        return t.length <= 200 ? `${n}.indexOf(${i}) !== -1` : `function(v, a, i, j) {\n        while (i <= j) { var m = (i + j) >> 1;\n            if (a[m] === v) return true; if (a[m] > v) j = m - 1; else i = m + 1;\n        }\n    return false; }(${i}, ${n},0,${t.length - 1})`;
    }
    function St(e) {
        return "$id" === e ? '"id" in f' : `${JSON.stringify(e)} in p`;
    }
    function Mt(e) {
        return `!(${e})`;
    }
    function Pt(e, t) {
        return e < t ? -1 : e > t ? 1 : 0;
    }
    /*!
	 * a compact version of mapbox-gl-style-spec
	 * based on mapbox-gl-style-spec@13.28.0
	 * https://github.com/mapbox/mapbox-gl-js/tree/main/src/style-spec
	 * LICENSE : ISC
	 */    var It = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {}, Ct = {
        exports: {}
    };
    function kt(e, ...t) {
        for (const n of t) for (const t in n) e[t] = n[t];
        return e;
    }
    /*! https://mths.be/punycode v1.3.2 by @mathias */    !function(e, t) {
        !function(n) {
            var i = t && !t.nodeType && t, r = e && !e.nodeType && e, s = "object" == typeof It && It;
            s.global !== s && s.window !== s && s.self !== s || (n = s);
            var o, a, l = 2147483647, h = 36, c = 26, u = 38, f = 700, d = /^xn--/, p = /[^\x20-\x7E]/, g = /[\x2E\u3002\uFF0E\uFF61]/g, m = {
                overflow: "Overflow: input needs wider integers to process",
                "not-basic": "Illegal input >= 0x80 (not a basic code point)",
                "invalid-input": "Invalid input"
            }, y = h - 1, x = Math.floor, _ = String.fromCharCode;
            function v(e) {
                throw RangeError(m[e]);
            }
            function b(e, t) {
                for (var n = e.length, i = []; n--; ) i[n] = t(e[n]);
                return i;
            }
            function A(e, t) {
                var n = e.split("@"), i = "";
                return n.length > 1 && (i = n[0] + "@", e = n[1]), i + b((e = e.replace(g, ".")).split("."), t).join(".");
            }
            function T(e) {
                for (var t, n, i = [], r = 0, s = e.length; r < s; ) (t = e.charCodeAt(r++)) >= 55296 && t <= 56319 && r < s ? 56320 == (64512 & (n = e.charCodeAt(r++))) ? i.push(((1023 & t) << 10) + (1023 & n) + 65536) : (i.push(t), 
                r--) : i.push(t);
                return i;
            }
            function w(e) {
                return b(e, (function(e) {
                    var t = "";
                    return e > 65535 && (t += _((e -= 65536) >>> 10 & 1023 | 55296), e = 56320 | 1023 & e), 
                    t + _(e);
                })).join("");
            }
            function S(e, t) {
                return e + 22 + 75 * (e < 26) - ((0 != t) << 5);
            }
            function M(e, t, n) {
                var i = 0;
                for (e = n ? x(e / f) : e >> 1, e += x(e / t); e > y * c >> 1; i += h) e = x(e / y);
                return x(i + (y + 1) * e / (e + u));
            }
            function P(e) {
                var t, n, i, r, s, o, a, u, f, d, p, g = [], m = e.length, y = 0, _ = 128, b = 72;
                for ((n = e.lastIndexOf("-")) < 0 && (n = 0), i = 0; i < n; ++i) e.charCodeAt(i) >= 128 && v("not-basic"), 
                g.push(e.charCodeAt(i));
                for (r = n > 0 ? n + 1 : 0; r < m; ) {
                    for (s = y, o = 1, a = h; r >= m && v("invalid-input"), ((u = (p = e.charCodeAt(r++)) - 48 < 10 ? p - 22 : p - 65 < 26 ? p - 65 : p - 97 < 26 ? p - 97 : h) >= h || u > x((l - y) / o)) && v("overflow"), 
                    y += u * o, !(u < (f = a <= b ? 1 : a >= b + c ? c : a - b)); a += h) o > x(l / (d = h - f)) && v("overflow"), 
                    o *= d;
                    b = M(y - s, t = g.length + 1, 0 == s), x(y / t) > l - _ && v("overflow"), _ += x(y / t), 
                    y %= t, g.splice(y++, 0, _);
                }
                return w(g);
            }
            function I(e) {
                var t, n, i, r, s, o, a, u, f, d, p, g, m, y, b, A = [];
                for (g = (e = T(e)).length, t = 128, n = 0, s = 72, o = 0; o < g; ++o) (p = e[o]) < 128 && A.push(_(p));
                for (i = r = A.length, r && A.push("-"); i < g; ) {
                    for (a = l, o = 0; o < g; ++o) (p = e[o]) >= t && p < a && (a = p);
                    for (a - t > x((l - n) / (m = i + 1)) && v("overflow"), n += (a - t) * m, t = a, 
                    o = 0; o < g; ++o) if ((p = e[o]) < t && ++n > l && v("overflow"), p == t) {
                        for (u = n, f = h; !(u < (d = f <= s ? 1 : f >= s + c ? c : f - s)); f += h) b = u - d, 
                        y = h - d, A.push(_(S(d + b % y, 0))), u = x(b / y);
                        A.push(_(S(u, 0))), s = M(n, m, i == r), n = 0, ++i;
                    }
                    ++n, ++t;
                }
                return A.join("");
            }
            if (o = {
                version: "1.3.2",
                ucs2: {
                    decode: T,
                    encode: w
                },
                decode: P,
                encode: I,
                toASCII: function(e) {
                    return A(e, (function(e) {
                        return p.test(e) ? "xn--" + I(e) : e;
                    }));
                },
                toUnicode: function(e) {
                    return A(e, (function(e) {
                        return d.test(e) ? P(e.slice(4).toLowerCase()) : e;
                    }));
                }
            }, i && r) if (e.exports == i) r.exports = o; else for (a in o) o.hasOwnProperty(a) && (i[a] = o[a]); else n.punycode = o;
        }(It);
    }(Ct, Ct.exports);
    class Ft extends Error {
        constructor(e, t) {
            super(t), this.message = t, this.key = e;
        }
    }
    var Ot = Ft;
    class Rt {
        constructor(e, t = []) {
            this.parent = e, this.bindings = {};
            for (const [e, n] of t) this.bindings[e] = n;
        }
        concat(e) {
            return new Rt(this, e);
        }
        get(e) {
            if (this.bindings[e]) return this.bindings[e];
            if (this.parent) return this.parent.get(e);
            throw new Error(`${e} not found in scope.`);
        }
        has(e) {
            return !!this.bindings[e] || !!this.parent && this.parent.has(e);
        }
    }
    var Et = Rt;
    const Dt = {
        kind: "null"
    }, Lt = {
        kind: "number"
    }, Ht = {
        kind: "string"
    }, zt = {
        kind: "boolean"
    }, Nt = {
        kind: "color"
    }, Vt = {
        kind: "object"
    }, Bt = {
        kind: "value"
    }, Ut = {
        kind: "collator"
    }, Gt = {
        kind: "formatted"
    }, jt = {
        kind: "resolvedImage"
    };
    function Wt(e, t) {
        return {
            kind: "array",
            itemType: e,
            N: t
        };
    }
    function Xt(e) {
        if ("array" === e.kind) {
            const t = Xt(e.itemType);
            return "number" == typeof e.N ? `array<${t}, ${e.N}>` : "value" === e.itemType.kind ? "array" : `array<${t}>`;
        }
        return e.kind;
    }
    const Yt = [ Dt, Lt, Ht, zt, Nt, Gt, Vt, Wt(Bt), jt ];
    function qt(e, t) {
        if ("error" === t.kind) return null;
        if ("array" === e.kind) {
            if ("array" === t.kind && (0 === t.N && "value" === t.itemType.kind || !qt(e.itemType, t.itemType)) && ("number" != typeof e.N || e.N === t.N)) return null;
        } else {
            if (e.kind === t.kind) return null;
            if ("value" === e.kind) for (const e of Yt) if (!qt(e, t)) return null;
        }
        return `Expected ${Xt(e)} but found ${Xt(t)} instead.`;
    }
    function Zt(e, t) {
        return t.some((t => t.kind === e.kind));
    }
    function $t(e, t) {
        return t.some((t => "null" === t ? null === e : "array" === t ? Array.isArray(e) : "object" === t ? e && !Array.isArray(e) && "object" == typeof e : t === typeof e));
    }
    var Jt, Kt = {
        transparent: [ 0, 0, 0, 0 ],
        aliceblue: [ 240, 248, 255, 1 ],
        antiquewhite: [ 250, 235, 215, 1 ],
        aqua: [ 0, 255, 255, 1 ],
        aquamarine: [ 127, 255, 212, 1 ],
        azure: [ 240, 255, 255, 1 ],
        beige: [ 245, 245, 220, 1 ],
        bisque: [ 255, 228, 196, 1 ],
        black: [ 0, 0, 0, 1 ],
        blanchedalmond: [ 255, 235, 205, 1 ],
        blue: [ 0, 0, 255, 1 ],
        blueviolet: [ 138, 43, 226, 1 ],
        brown: [ 165, 42, 42, 1 ],
        burlywood: [ 222, 184, 135, 1 ],
        cadetblue: [ 95, 158, 160, 1 ],
        chartreuse: [ 127, 255, 0, 1 ],
        chocolate: [ 210, 105, 30, 1 ],
        coral: [ 255, 127, 80, 1 ],
        cornflowerblue: [ 100, 149, 237, 1 ],
        cornsilk: [ 255, 248, 220, 1 ],
        crimson: [ 220, 20, 60, 1 ],
        cyan: [ 0, 255, 255, 1 ],
        darkblue: [ 0, 0, 139, 1 ],
        darkcyan: [ 0, 139, 139, 1 ],
        darkgoldenrod: [ 184, 134, 11, 1 ],
        darkgray: [ 169, 169, 169, 1 ],
        darkgreen: [ 0, 100, 0, 1 ],
        darkgrey: [ 169, 169, 169, 1 ],
        darkkhaki: [ 189, 183, 107, 1 ],
        darkmagenta: [ 139, 0, 139, 1 ],
        darkolivegreen: [ 85, 107, 47, 1 ],
        darkorange: [ 255, 140, 0, 1 ],
        darkorchid: [ 153, 50, 204, 1 ],
        darkred: [ 139, 0, 0, 1 ],
        darksalmon: [ 233, 150, 122, 1 ],
        darkseagreen: [ 143, 188, 143, 1 ],
        darkslateblue: [ 72, 61, 139, 1 ],
        darkslategray: [ 47, 79, 79, 1 ],
        darkslategrey: [ 47, 79, 79, 1 ],
        darkturquoise: [ 0, 206, 209, 1 ],
        darkviolet: [ 148, 0, 211, 1 ],
        deeppink: [ 255, 20, 147, 1 ],
        deepskyblue: [ 0, 191, 255, 1 ],
        dimgray: [ 105, 105, 105, 1 ],
        dimgrey: [ 105, 105, 105, 1 ],
        dodgerblue: [ 30, 144, 255, 1 ],
        firebrick: [ 178, 34, 34, 1 ],
        floralwhite: [ 255, 250, 240, 1 ],
        forestgreen: [ 34, 139, 34, 1 ],
        fuchsia: [ 255, 0, 255, 1 ],
        gainsboro: [ 220, 220, 220, 1 ],
        ghostwhite: [ 248, 248, 255, 1 ],
        gold: [ 255, 215, 0, 1 ],
        goldenrod: [ 218, 165, 32, 1 ],
        gray: [ 128, 128, 128, 1 ],
        green: [ 0, 128, 0, 1 ],
        greenyellow: [ 173, 255, 47, 1 ],
        grey: [ 128, 128, 128, 1 ],
        honeydew: [ 240, 255, 240, 1 ],
        hotpink: [ 255, 105, 180, 1 ],
        indianred: [ 205, 92, 92, 1 ],
        indigo: [ 75, 0, 130, 1 ],
        ivory: [ 255, 255, 240, 1 ],
        khaki: [ 240, 230, 140, 1 ],
        lavender: [ 230, 230, 250, 1 ],
        lavenderblush: [ 255, 240, 245, 1 ],
        lawngreen: [ 124, 252, 0, 1 ],
        lemonchiffon: [ 255, 250, 205, 1 ],
        lightblue: [ 173, 216, 230, 1 ],
        lightcoral: [ 240, 128, 128, 1 ],
        lightcyan: [ 224, 255, 255, 1 ],
        lightgoldenrodyellow: [ 250, 250, 210, 1 ],
        lightgray: [ 211, 211, 211, 1 ],
        lightgreen: [ 144, 238, 144, 1 ],
        lightgrey: [ 211, 211, 211, 1 ],
        lightpink: [ 255, 182, 193, 1 ],
        lightsalmon: [ 255, 160, 122, 1 ],
        lightseagreen: [ 32, 178, 170, 1 ],
        lightskyblue: [ 135, 206, 250, 1 ],
        lightslategray: [ 119, 136, 153, 1 ],
        lightslategrey: [ 119, 136, 153, 1 ],
        lightsteelblue: [ 176, 196, 222, 1 ],
        lightyellow: [ 255, 255, 224, 1 ],
        lime: [ 0, 255, 0, 1 ],
        limegreen: [ 50, 205, 50, 1 ],
        linen: [ 250, 240, 230, 1 ],
        magenta: [ 255, 0, 255, 1 ],
        maroon: [ 128, 0, 0, 1 ],
        mediumaquamarine: [ 102, 205, 170, 1 ],
        mediumblue: [ 0, 0, 205, 1 ],
        mediumorchid: [ 186, 85, 211, 1 ],
        mediumpurple: [ 147, 112, 219, 1 ],
        mediumseagreen: [ 60, 179, 113, 1 ],
        mediumslateblue: [ 123, 104, 238, 1 ],
        mediumspringgreen: [ 0, 250, 154, 1 ],
        mediumturquoise: [ 72, 209, 204, 1 ],
        mediumvioletred: [ 199, 21, 133, 1 ],
        midnightblue: [ 25, 25, 112, 1 ],
        mintcream: [ 245, 255, 250, 1 ],
        mistyrose: [ 255, 228, 225, 1 ],
        moccasin: [ 255, 228, 181, 1 ],
        navajowhite: [ 255, 222, 173, 1 ],
        navy: [ 0, 0, 128, 1 ],
        oldlace: [ 253, 245, 230, 1 ],
        olive: [ 128, 128, 0, 1 ],
        olivedrab: [ 107, 142, 35, 1 ],
        orange: [ 255, 165, 0, 1 ],
        orangered: [ 255, 69, 0, 1 ],
        orchid: [ 218, 112, 214, 1 ],
        palegoldenrod: [ 238, 232, 170, 1 ],
        palegreen: [ 152, 251, 152, 1 ],
        paleturquoise: [ 175, 238, 238, 1 ],
        palevioletred: [ 219, 112, 147, 1 ],
        papayawhip: [ 255, 239, 213, 1 ],
        peachpuff: [ 255, 218, 185, 1 ],
        peru: [ 205, 133, 63, 1 ],
        pink: [ 255, 192, 203, 1 ],
        plum: [ 221, 160, 221, 1 ],
        powderblue: [ 176, 224, 230, 1 ],
        purple: [ 128, 0, 128, 1 ],
        rebeccapurple: [ 102, 51, 153, 1 ],
        red: [ 255, 0, 0, 1 ],
        rosybrown: [ 188, 143, 143, 1 ],
        royalblue: [ 65, 105, 225, 1 ],
        saddlebrown: [ 139, 69, 19, 1 ],
        salmon: [ 250, 128, 114, 1 ],
        sandybrown: [ 244, 164, 96, 1 ],
        seagreen: [ 46, 139, 87, 1 ],
        seashell: [ 255, 245, 238, 1 ],
        sienna: [ 160, 82, 45, 1 ],
        silver: [ 192, 192, 192, 1 ],
        skyblue: [ 135, 206, 235, 1 ],
        slateblue: [ 106, 90, 205, 1 ],
        slategray: [ 112, 128, 144, 1 ],
        slategrey: [ 112, 128, 144, 1 ],
        snow: [ 255, 250, 250, 1 ],
        springgreen: [ 0, 255, 127, 1 ],
        steelblue: [ 70, 130, 180, 1 ],
        tan: [ 210, 180, 140, 1 ],
        teal: [ 0, 128, 128, 1 ],
        thistle: [ 216, 191, 216, 1 ],
        tomato: [ 255, 99, 71, 1 ],
        turquoise: [ 64, 224, 208, 1 ],
        violet: [ 238, 130, 238, 1 ],
        wheat: [ 245, 222, 179, 1 ],
        white: [ 255, 255, 255, 1 ],
        whitesmoke: [ 245, 245, 245, 1 ],
        yellow: [ 255, 255, 0, 1 ],
        yellowgreen: [ 154, 205, 50, 1 ]
    };
    function Qt(e) {
        return (e = Math.round(e)) < 0 ? 0 : e > 255 ? 255 : e;
    }
    function en(e) {
        return e < 0 ? 0 : e > 1 ? 1 : e;
    }
    function tn(e) {
        return "%" === e[e.length - 1] ? Qt(parseFloat(e) / 100 * 255) : Qt(parseInt(e));
    }
    function nn(e) {
        return "%" === e[e.length - 1] ? en(parseFloat(e) / 100) : en(parseFloat(e));
    }
    function rn(e, t, n) {
        return n < 0 ? n += 1 : n > 1 && (n -= 1), 6 * n < 1 ? e + (t - e) * n * 6 : 2 * n < 1 ? t : 3 * n < 2 ? e + (t - e) * (2 / 3 - n) * 6 : e;
    }
    try {
        Jt = {}.parseCSSColor = function(e) {
            var t, n = e.replace(/ /g, "").toLowerCase();
            if (n in Kt) return Kt[n].slice();
            if ("#" === n[0]) return 4 === n.length ? (t = parseInt(n.substr(1), 16)) >= 0 && t <= 4095 ? [ (3840 & t) >> 4 | (3840 & t) >> 8, 240 & t | (240 & t) >> 4, 15 & t | (15 & t) << 4, 1 ] : null : 7 === n.length && (t = parseInt(n.substr(1), 16)) >= 0 && t <= 16777215 ? [ (16711680 & t) >> 16, (65280 & t) >> 8, 255 & t, 1 ] : null;
            var i = n.indexOf("("), r = n.indexOf(")");
            if (-1 !== i && r + 1 === n.length) {
                var s = n.substr(0, i), o = n.substr(i + 1, r - (i + 1)).split(","), a = 1;
                switch (s) {
                  case "rgba":
                    if (4 !== o.length) return null;
                    a = nn(o.pop());

                  case "rgb":
                    return 3 !== o.length ? null : [ tn(o[0]), tn(o[1]), tn(o[2]), a ];

                  case "hsla":
                    if (4 !== o.length) return null;
                    a = nn(o.pop());

                  case "hsl":
                    if (3 !== o.length) return null;
                    var l = (parseFloat(o[0]) % 360 + 360) % 360 / 360, h = nn(o[1]), c = nn(o[2]), u = c <= .5 ? c * (h + 1) : c + h - c * h, f = 2 * c - u;
                    return [ Qt(255 * rn(f, u, l + 1 / 3)), Qt(255 * rn(f, u, l)), Qt(255 * rn(f, u, l - 1 / 3)), a ];

                  default:
                    return null;
                }
            }
            return null;
        };
    } catch (e) {}
    class sn {
        constructor(e, t, n, i = 1) {
            this.r = e, this.g = t, this.b = n, this.a = i;
        }
        static parse(e) {
            if (!e) return;
            if (e instanceof sn) return e;
            if ("string" != typeof e) return;
            const t = Jt(e);
            return t ? new sn(t[0] / 255 * t[3], t[1] / 255 * t[3], t[2] / 255 * t[3], t[3]) : void 0;
        }
        toString() {
            const [e, t, n, i] = this.toArray();
            return `rgba(${Math.round(e)},${Math.round(t)},${Math.round(n)},${i})`;
        }
        toArray() {
            const {r: e, g: t, b: n, a: i} = this;
            return 0 === i ? [ 0, 0, 0, 0 ] : [ 255 * e / i, 255 * t / i, 255 * n / i, i ];
        }
        toArray01() {
            const {r: e, g: t, b: n, a: i} = this;
            return 0 === i ? [ 0, 0, 0, 0 ] : [ e / i, t / i, n / i, i ];
        }
        toArray01PremultipliedAlpha() {
            const {r: e, g: t, b: n, a: i} = this;
            return [ e, t, n, i ];
        }
    }
    sn.black = new sn(0, 0, 0, 1), sn.white = new sn(1, 1, 1, 1), sn.transparent = new sn(0, 0, 0, 0), 
    sn.red = new sn(1, 0, 0, 1), sn.blue = new sn(0, 0, 1, 1);
    var on = sn;
    class an {
        constructor(e, t, n) {
            this.sensitivity = e ? t ? "variant" : "case" : t ? "accent" : "base", this.locale = n, 
            this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                sensitivity: this.sensitivity,
                usage: "search"
            });
        }
        compare(e, t) {
            return this.collator.compare(e, t);
        }
        resolvedLocale() {
            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
        }
    }
    class ln {
        constructor(e, t, n, i, r) {
            this.text = e.normalize ? e.normalize() : e, this.image = t, this.scale = n, this.fontStack = i, 
            this.textColor = r;
        }
    }
    class hn {
        constructor(e) {
            this.sections = e;
        }
        static fromString(e) {
            return new hn([ new ln(e, null, null, null, null) ]);
        }
        isEmpty() {
            return 0 === this.sections.length || !this.sections.some((e => 0 !== e.text.length || e.image && 0 !== e.image.name.length));
        }
        static factory(e) {
            return e instanceof hn ? e : hn.fromString(e);
        }
        toString() {
            return 0 === this.sections.length ? "" : this.sections.map((e => e.text)).join("");
        }
        serialize() {
            const e = [ "format" ];
            for (const t of this.sections) {
                if (t.image) {
                    e.push([ "image", t.image.name ]);
                    continue;
                }
                e.push(t.text);
                const n = {};
                t.fontStack && (n["text-font"] = [ "literal", t.fontStack.split(",") ]), t.scale && (n["font-scale"] = t.scale), 
                t.textColor && (n["text-color"] = [ "rgba" ].concat(t.textColor.toArray())), e.push(n);
            }
            return e;
        }
    }
    class cn {
        constructor(e) {
            this.name = e.name, this.available = e.available;
        }
        toString() {
            return this.name;
        }
        static fromString(e) {
            return e ? new cn({
                name: e,
                available: !1
            }) : null;
        }
        serialize() {
            return [ "image", this.name ];
        }
    }
    function un(e, t, n, i) {
        return "number" == typeof e && e >= 0 && e <= 255 && "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof n && n >= 0 && n <= 255 ? void 0 === i || "number" == typeof i && i >= 0 && i <= 1 ? null : `Invalid rgba value [${[ e, t, n, i ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof i ? [ e, t, n, i ] : [ e, t, n ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
    }
    function fn(e) {
        if (null === e) return !0;
        if ("string" == typeof e) return !0;
        if ("boolean" == typeof e) return !0;
        if ("number" == typeof e) return !0;
        if (e instanceof on) return !0;
        if (e instanceof an) return !0;
        if (e instanceof hn) return !0;
        if (e instanceof cn) return !0;
        if (Array.isArray(e)) {
            for (const t of e) if (!fn(t)) return !1;
            return !0;
        }
        if ("object" == typeof e) {
            for (const t in e) if (!fn(e[t])) return !1;
            return !0;
        }
        return !1;
    }
    function dn(e) {
        if (null === e) return Dt;
        if ("string" == typeof e) return Ht;
        if ("boolean" == typeof e) return zt;
        if ("number" == typeof e) return Lt;
        if (e instanceof on) return Nt;
        if (e instanceof an) return Ut;
        if (e instanceof hn) return Gt;
        if (e instanceof cn) return jt;
        if (Array.isArray(e)) {
            const t = e.length;
            let n;
            for (const t of e) {
                const e = dn(t);
                if (n) {
                    if (n === e) continue;
                    n = Bt;
                    break;
                }
                n = e;
            }
            return Wt(n || Bt, t);
        }
        return Vt;
    }
    function pn(e) {
        const t = typeof e;
        return null === e ? "" : "string" === t || "number" === t || "boolean" === t ? String(e) : e instanceof on || e instanceof hn || e instanceof cn ? e.toString() : JSON.stringify(e);
    }
    class gn {
        constructor(e, t) {
            this.type = e, this.value = t;
        }
        static parse(e, t) {
            if (2 !== e.length) return t.error(`'literal' expression requires exactly one argument, but found ${e.length - 1} instead.`);
            if (!fn(e[1])) return t.error("invalid value");
            const n = e[1];
            let i = dn(n);
            const r = t.expectedType;
            return "array" !== i.kind || 0 !== i.N || !r || "array" !== r.kind || "number" == typeof r.N && 0 !== r.N || (i = r), 
            new gn(i, n);
        }
        evaluate() {
            return this.value;
        }
        eachChild() {}
        outputDefined() {
            return !0;
        }
        serialize() {
            return "array" === this.type.kind || "object" === this.type.kind ? [ "literal", this.value ] : this.value instanceof on ? [ "rgba" ].concat(this.value.toArray()) : this.value instanceof hn ? this.value.serialize() : this.value;
        }
    }
    var mn = gn, yn = class {
        constructor(e) {
            this.name = "ExpressionEvaluationError", this.message = e;
        }
        toJSON() {
            return this.message;
        }
    };
    const xn = {
        string: Ht,
        number: Lt,
        boolean: zt,
        object: Vt
    };
    class _n {
        constructor(e, t) {
            this.type = e, this.args = t;
        }
        static parse(e, t) {
            if (e.length < 2) return t.error("Expected at least one argument.");
            let n, i = 1;
            const r = e[0];
            if ("array" === r) {
                let r, s;
                if (e.length > 2) {
                    const n = e[1];
                    if ("string" != typeof n || !(n in xn) || "object" === n) return t.error('The item type argument of "array" must be one of string, number, boolean', 1);
                    r = xn[n], i++;
                } else r = Bt;
                if (e.length > 3) {
                    if (null !== e[2] && ("number" != typeof e[2] || e[2] < 0 || e[2] !== Math.floor(e[2]))) return t.error('The length argument to "array" must be a positive integer literal', 2);
                    s = e[2], i++;
                }
                n = Wt(r, s);
            } else n = xn[r];
            const s = [];
            for (;i < e.length; i++) {
                const n = t.parse(e[i], i, Bt);
                if (!n) return null;
                s.push(n);
            }
            return new _n(n, s);
        }
        evaluate(e) {
            for (let t = 0; t < this.args.length; t++) {
                const n = this.args[t].evaluate(e);
                if (!qt(this.type, dn(n))) return n;
                if (t === this.args.length - 1) throw new yn(`Expected value to be of type ${Xt(this.type)}, but found ${Xt(dn(n))} instead.`);
            }
            return null;
        }
        eachChild(e) {
            this.args.forEach(e);
        }
        outputDefined() {
            return this.args.every((e => e.outputDefined()));
        }
        serialize() {
            const e = this.type, t = [ e.kind ];
            if ("array" === e.kind) {
                const n = e.itemType;
                if ("string" === n.kind || "number" === n.kind || "boolean" === n.kind) {
                    t.push(n.kind);
                    const i = e.N;
                    ("number" == typeof i || this.args.length > 1) && t.push(i);
                }
            }
            return t.concat(this.args.map((e => e.serialize())));
        }
    }
    var vn = _n;
    class bn {
        constructor(e) {
            this.type = Gt, this.sections = e;
        }
        static parse(e, t) {
            if (e.length < 2) return t.error("Expected at least one argument.");
            const n = e[1];
            if (!Array.isArray(n) && "object" == typeof n) return t.error("First argument must be an image or text section.");
            const i = [];
            let r = !1;
            for (let n = 1; n <= e.length - 1; ++n) {
                const s = e[n];
                if (r && "object" == typeof s && !Array.isArray(s)) {
                    r = !1;
                    let e = null;
                    if (s["font-scale"] && (e = t.parse(s["font-scale"], 1, Lt), !e)) return null;
                    let n = null;
                    if (s["text-font"] && (n = t.parse(s["text-font"], 1, Wt(Ht)), !n)) return null;
                    let o = null;
                    if (s["text-color"] && (o = t.parse(s["text-color"], 1, Nt), !o)) return null;
                    const a = i[i.length - 1];
                    a.scale = e, a.font = n, a.textColor = o;
                } else {
                    const s = t.parse(e[n], 1, Bt);
                    if (!s) return null;
                    const o = s.type.kind;
                    if ("string" !== o && "value" !== o && "null" !== o && "resolvedImage" !== o) return t.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                    r = !0, i.push({
                        content: s,
                        scale: null,
                        font: null,
                        textColor: null
                    });
                }
            }
            return new bn(i);
        }
        evaluate(e) {
            return new hn(this.sections.map((t => {
                const n = t.content.evaluate(e);
                return dn(n) === jt ? new ln("", n, null, null, null) : new ln(pn(n), null, t.scale ? t.scale.evaluate(e) : null, t.font ? t.font.evaluate(e).join(",") : null, t.textColor ? t.textColor.evaluate(e) : null);
            })));
        }
        eachChild(e) {
            for (const t of this.sections) e(t.content), t.scale && e(t.scale), t.font && e(t.font), 
            t.textColor && e(t.textColor);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            const e = [ "format" ];
            for (const t of this.sections) {
                e.push(t.content.serialize());
                const n = {};
                t.scale && (n["font-scale"] = t.scale.serialize()), t.font && (n["text-font"] = t.font.serialize()), 
                t.textColor && (n["text-color"] = t.textColor.serialize()), e.push(n);
            }
            return e;
        }
    }
    class An {
        constructor(e) {
            this.type = jt, this.input = e;
        }
        static parse(e, t) {
            if (2 !== e.length) return t.error("Expected two arguments.");
            const n = t.parse(e[1], 1, Ht);
            return n ? new An(n) : t.error("No image name provided.");
        }
        evaluate(e) {
            const t = this.input.evaluate(e), n = cn.fromString(t);
            return n && e.availableImages && (n.available = e.availableImages.indexOf(t) > -1), 
            n;
        }
        eachChild(e) {
            e(this.input);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            return [ "image", this.input.serialize() ];
        }
    }
    const Tn = {
        "to-boolean": zt,
        "to-color": Nt,
        "to-number": Lt,
        "to-string": Ht
    };
    class wn {
        constructor(e, t) {
            this.type = e, this.args = t;
        }
        static parse(e, t) {
            if (e.length < 2) return t.error("Expected at least one argument.");
            const n = e[0];
            if (("to-boolean" === n || "to-string" === n) && 2 !== e.length) return t.error("Expected one argument.");
            const i = Tn[n], r = [];
            for (let n = 1; n < e.length; n++) {
                const i = t.parse(e[n], n, Bt);
                if (!i) return null;
                r.push(i);
            }
            return new wn(i, r);
        }
        evaluate(e) {
            if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(e));
            if ("color" === this.type.kind) {
                let t, n;
                for (const i of this.args) {
                    if (t = i.evaluate(e), n = null, t instanceof on) return t;
                    if ("string" == typeof t) {
                        const n = e.parseColor(t);
                        if (n) return n;
                    } else if (Array.isArray(t) && (n = t.length < 3 || t.length > 4 ? `Invalid rbga value ${JSON.stringify(t)}: expected an array containing either three or four numeric values.` : un(t[0], t[1], t[2], t[3]), 
                    !n)) return new on(t[0] / 255, t[1] / 255, t[2] / 255, t[3]);
                }
                throw new yn(n || `Could not parse color from value '${"string" == typeof t ? t : String(JSON.stringify(t))}'`);
            }
            if ("number" === this.type.kind) {
                let t = null;
                for (const n of this.args) {
                    if (t = n.evaluate(e), null === t) return 0;
                    const i = Number(t);
                    if (!isNaN(i)) return i;
                }
                throw new yn(`Could not convert ${JSON.stringify(t)} to number.`);
            }
            return "formatted" === this.type.kind ? hn.fromString(pn(this.args[0].evaluate(e))) : "resolvedImage" === this.type.kind ? cn.fromString(pn(this.args[0].evaluate(e))) : pn(this.args[0].evaluate(e));
        }
        eachChild(e) {
            this.args.forEach(e);
        }
        outputDefined() {
            return this.args.every((e => e.outputDefined()));
        }
        serialize() {
            if ("formatted" === this.type.kind) return new bn([ {
                content: this.args[0],
                scale: null,
                font: null,
                textColor: null
            } ]).serialize();
            if ("resolvedImage" === this.type.kind) return new An(this.args[0]).serialize();
            const e = [ `to-${this.type.kind}` ];
            return this.eachChild((t => {
                e.push(t.serialize());
            })), e;
        }
    }
    var Sn = wn;
    const Mn = [ "Unknown", "Point", "LineString", "Polygon" ];
    var Pn = class {
        constructor() {
            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, 
            this._parseColorCache = {}, this.availableImages = null, this.canonical = null, 
            this.featureTileCoord = null, this.featureDistanceData = null;
        }
        id() {
            return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
        }
        geometryType() {
            return this.feature ? "number" == typeof this.feature.type ? Mn[this.feature.type] : this.feature.type : null;
        }
        geometry() {
            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
        }
        canonicalID() {
            return this.canonical;
        }
        properties() {
            return this.feature && this.feature.properties || {};
        }
        distanceFromCenter() {
            if (this.featureTileCoord && this.featureDistanceData) {
                const e = this.featureDistanceData.center, t = this.featureDistanceData.scale, {x: n, y: i} = this.featureTileCoord, r = n * t - e[0], s = i * t - e[1];
                return this.featureDistanceData.bearing[0] * r + this.featureDistanceData.bearing[1] * s;
            }
            return 0;
        }
        parseColor(e) {
            let t = this._parseColorCache[e];
            return t || (t = this._parseColorCache[e] = on.parse(e)), t;
        }
    };
    class In {
        constructor(e, t, n, i) {
            this.name = e, this.type = t, this._evaluate = n, this.args = i;
        }
        evaluate(e) {
            return this._evaluate(e, this.args);
        }
        eachChild(e) {
            this.args.forEach(e);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            return [ this.name ].concat(this.args.map((e => e.serialize())));
        }
        static parse(e, t) {
            const n = e[0], i = In.definitions[n];
            if (!i) return t.error(`Unknown expression "${n}". If you wanted a literal array, use ["literal", [...]].`, 0);
            const r = Array.isArray(i) ? i[0] : i.type, s = Array.isArray(i) ? [ [ i[1], i[2] ] ] : i.overloads, o = s.filter((([t]) => !Array.isArray(t) || t.length === e.length - 1));
            let a = null;
            for (const [i, s] of o) {
                a = new ni(t.registry, t.path, null, t.scope);
                const o = [];
                let l = !1;
                for (let t = 1; t < e.length; t++) {
                    const n = e[t], r = Array.isArray(i) ? i[t - 1] : i.type, s = a.parse(n, 1 + o.length, r);
                    if (!s) {
                        l = !0;
                        break;
                    }
                    o.push(s);
                }
                if (!l) if (Array.isArray(i) && i.length !== o.length) a.error(`Expected ${i.length} arguments, but found ${o.length} instead.`); else {
                    for (let e = 0; e < o.length; e++) {
                        const t = Array.isArray(i) ? i[e] : i.type, n = o[e];
                        a.concat(e + 1).checkSubtype(t, n.type);
                    }
                    if (0 === a.errors.length) return new In(n, r, s, o);
                }
            }
            if (1 === o.length) t.errors.push(...a.errors); else {
                const n = (o.length ? o : s).map((([e]) => {
                    return t = e, Array.isArray(t) ? `(${t.map(Xt).join(", ")})` : `(${Xt(t.type)}...)`;
                    var t;
                })).join(" | "), i = [];
                for (let n = 1; n < e.length; n++) {
                    const r = t.parse(e[n], 1 + i.length);
                    if (!r) return null;
                    i.push(Xt(r.type));
                }
                t.error(`Expected arguments of type ${n}, but found (${i.join(", ")}) instead.`);
            }
            return null;
        }
        static register(e, t) {
            In.definitions = t;
            for (const n in t) e[n] = In;
        }
    }
    var Cn = In;
    class kn {
        constructor(e, t, n) {
            this.type = Ut, this.locale = n, this.caseSensitive = e, this.diacriticSensitive = t;
        }
        static parse(e, t) {
            if (2 !== e.length) return t.error("Expected one argument.");
            const n = e[1];
            if ("object" != typeof n || Array.isArray(n)) return t.error("Collator options argument must be an object.");
            const i = t.parse(void 0 !== n["case-sensitive"] && n["case-sensitive"], 1, zt);
            if (!i) return null;
            const r = t.parse(void 0 !== n["diacritic-sensitive"] && n["diacritic-sensitive"], 1, zt);
            if (!r) return null;
            let s = null;
            return n.locale && (s = t.parse(n.locale, 1, Ht), !s) ? null : new kn(i, r, s);
        }
        evaluate(e) {
            return new an(this.caseSensitive.evaluate(e), this.diacriticSensitive.evaluate(e), this.locale ? this.locale.evaluate(e) : null);
        }
        eachChild(e) {
            e(this.caseSensitive), e(this.diacriticSensitive), this.locale && e(this.locale);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            const e = {};
            return e["case-sensitive"] = this.caseSensitive.serialize(), e["diacritic-sensitive"] = this.diacriticSensitive.serialize(), 
            this.locale && (e.locale = this.locale.serialize()), [ "collator", e ];
        }
    }
    const Fn = 8192;
    function On(e, t) {
        e[0] = Math.min(e[0], t[0]), e[1] = Math.min(e[1], t[1]), e[2] = Math.max(e[2], t[0]), 
        e[3] = Math.max(e[3], t[1]);
    }
    function Rn(e, t) {
        return !(e[0] <= t[0] || e[2] >= t[2] || e[1] <= t[1] || e[3] >= t[3]);
    }
    function En(e, t) {
        const n = (180 + e[0]) / 360, i = (r = e[1], (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + r * Math.PI / 360))) / 360);
        var r;
        const s = Math.pow(2, t.z);
        return [ Math.round(n * s * Fn), Math.round(i * s * Fn) ];
    }
    function Dn(e, t, n) {
        const i = e[0] - t[0], r = e[1] - t[1], s = e[0] - n[0], o = e[1] - n[1];
        return i * o - s * r == 0 && i * s <= 0 && r * o <= 0;
    }
    function Ln(e, t) {
        let n = !1;
        for (let o = 0, a = t.length; o < a; o++) {
            const a = t[o];
            for (let t = 0, o = a.length; t < o - 1; t++) {
                if (Dn(e, a[t], a[t + 1])) return !1;
                i = e, r = a[t], s = a[t + 1], r[1] > i[1] != s[1] > i[1] && i[0] < (s[0] - r[0]) * (i[1] - r[1]) / (s[1] - r[1]) + r[0] && (n = !n);
            }
        }
        var i, r, s;
        return n;
    }
    function Hn(e, t) {
        for (let n = 0; n < t.length; n++) if (Ln(e, t[n])) return !0;
        return !1;
    }
    function zn(e, t, n, i) {
        const r = e[0] - n[0], s = e[1] - n[1], o = t[0] - n[0], a = t[1] - n[1], l = i[0] - n[0], h = i[1] - n[1], c = r * h - l * s, u = o * h - l * a;
        return c > 0 && u < 0 || c < 0 && u > 0;
    }
    function Nn(e, t, n, i) {
        const r = [ t[0] - e[0], t[1] - e[1] ];
        return 0 != (s = [ i[0] - n[0], i[1] - n[1] ])[0] * (o = r)[1] - s[1] * o[0] && !(!zn(e, t, n, i) || !zn(n, i, e, t));
        var s, o;
    }
    function Vn(e, t, n) {
        for (const i of n) for (let n = 0; n < i.length - 1; ++n) if (Nn(e, t, i[n], i[n + 1])) return !0;
        return !1;
    }
    function Bn(e, t) {
        for (let n = 0; n < e.length; ++n) if (!Ln(e[n], t)) return !1;
        for (let n = 0; n < e.length - 1; ++n) if (Vn(e[n], e[n + 1], t)) return !1;
        return !0;
    }
    function Un(e, t) {
        for (let n = 0; n < t.length; n++) if (Bn(e, t[n])) return !0;
        return !1;
    }
    function Gn(e, t, n) {
        const i = [];
        for (let r = 0; r < e.length; r++) {
            const s = [];
            for (let i = 0; i < e[r].length; i++) {
                const o = En(e[r][i], n);
                On(t, o), s.push(o);
            }
            i.push(s);
        }
        return i;
    }
    function jn(e, t, n) {
        const i = [];
        for (let r = 0; r < e.length; r++) {
            const s = Gn(e[r], t, n);
            i.push(s);
        }
        return i;
    }
    function Wn(e, t, n, i) {
        if (e[0] < n[0] || e[0] > n[2]) {
            const t = .5 * i;
            let r = e[0] - n[0] > t ? -i : n[0] - e[0] > t ? i : 0;
            0 === r && (r = e[0] - n[2] > t ? -i : n[2] - e[0] > t ? i : 0), e[0] += r;
        }
        On(t, e);
    }
    function Xn(e, t, n, i) {
        const r = Math.pow(2, i.z) * Fn, s = [ i.x * Fn, i.y * Fn ], o = [];
        if (!e) return o;
        for (const i of e) for (const e of i) {
            const i = [ e.x + s[0], e.y + s[1] ];
            Wn(i, t, n, r), o.push(i);
        }
        return o;
    }
    function Yn(e, t, n, i) {
        const r = Math.pow(2, i.z) * Fn, s = [ i.x * Fn, i.y * Fn ], o = [];
        if (!e) return o;
        for (const n of e) {
            const e = [];
            for (const i of n) {
                const n = [ i.x + s[0], i.y + s[1] ];
                On(t, n), e.push(n);
            }
            o.push(e);
        }
        if (t[2] - t[0] <= r / 2) {
            (a = t)[0] = a[1] = 1 / 0, a[2] = a[3] = -1 / 0;
            for (const e of o) for (const i of e) Wn(i, t, n, r);
        }
        var a;
        return o;
    }
    class qn {
        constructor(e, t) {
            this.type = zt, this.geojson = e, this.geometries = t;
        }
        static parse(e, t) {
            if (2 !== e.length) return t.error(`'within' expression requires exactly one argument, but found ${e.length - 1} instead.`);
            if (fn(e[1])) {
                const t = e[1];
                if ("FeatureCollection" === t.type) for (let e = 0; e < t.features.length; ++e) {
                    const n = t.features[e].geometry.type;
                    if ("Polygon" === n || "MultiPolygon" === n) return new qn(t, t.features[e].geometry);
                } else if ("Feature" === t.type) {
                    const e = t.geometry.type;
                    if ("Polygon" === e || "MultiPolygon" === e) return new qn(t, t.geometry);
                } else if ("Polygon" === t.type || "MultiPolygon" === t.type) return new qn(t, t);
            }
            return t.error("'within' expression requires valid geojson object that contains polygon geometry type.");
        }
        evaluate(e) {
            if (null != e.geometry() && null != e.canonicalID()) {
                if ("Point" === e.geometryType()) return function(e, t) {
                    const n = [ 1 / 0, 1 / 0, -1 / 0, -1 / 0 ], i = [ 1 / 0, 1 / 0, -1 / 0, -1 / 0 ], r = e.canonicalID();
                    if (!r) return !1;
                    if ("Polygon" === t.type) {
                        const s = Gn(t.coordinates, i, r), o = Xn(e.geometry(), n, i, r);
                        if (!Rn(n, i)) return !1;
                        for (const e of o) if (!Ln(e, s)) return !1;
                    }
                    if ("MultiPolygon" === t.type) {
                        const s = jn(t.coordinates, i, r), o = Xn(e.geometry(), n, i, r);
                        if (!Rn(n, i)) return !1;
                        for (const e of o) if (!Hn(e, s)) return !1;
                    }
                    return !0;
                }(e, this.geometries);
                if ("LineString" === e.geometryType()) return function(e, t) {
                    const n = [ 1 / 0, 1 / 0, -1 / 0, -1 / 0 ], i = [ 1 / 0, 1 / 0, -1 / 0, -1 / 0 ], r = e.canonicalID();
                    if (!r) return !1;
                    if ("Polygon" === t.type) {
                        const s = Gn(t.coordinates, i, r), o = Yn(e.geometry(), n, i, r);
                        if (!Rn(n, i)) return !1;
                        for (const e of o) if (!Bn(e, s)) return !1;
                    }
                    if ("MultiPolygon" === t.type) {
                        const s = jn(t.coordinates, i, r), o = Yn(e.geometry(), n, i, r);
                        if (!Rn(n, i)) return !1;
                        for (const e of o) if (!Un(e, s)) return !1;
                    }
                    return !0;
                }(e, this.geometries);
            }
            return !1;
        }
        eachChild() {}
        outputDefined() {
            return !0;
        }
        serialize() {
            return [ "within", this.geojson ];
        }
    }
    var Zn = qn;
    function $n(e) {
        if (e instanceof Cn) {
            if ("get" === e.name && 1 === e.args.length) return !1;
            if ("feature-state" === e.name) return !1;
            if ("has" === e.name && 1 === e.args.length) return !1;
            if ("properties" === e.name || "geometry-type" === e.name || "id" === e.name) return !1;
            if (/^filter-/.test(e.name)) return !1;
        }
        if (e instanceof Zn) return !1;
        let t = !0;
        return e.eachChild((e => {
            t && !$n(e) && (t = !1);
        })), t;
    }
    function Jn(e) {
        if (e instanceof Cn && "feature-state" === e.name) return !1;
        let t = !0;
        return e.eachChild((e => {
            t && !Jn(e) && (t = !1);
        })), t;
    }
    function Kn(e, t) {
        if (e instanceof Cn && t.indexOf(e.name) >= 0) return !1;
        let n = !0;
        return e.eachChild((e => {
            n && !Kn(e, t) && (n = !1);
        })), n;
    }
    class Qn {
        constructor(e, t) {
            this.type = t.type, this.name = e, this.boundExpression = t;
        }
        static parse(e, t) {
            if (2 !== e.length || "string" != typeof e[1]) return t.error("'var' expression requires exactly one string literal argument.");
            const n = e[1];
            return t.scope.has(n) ? new Qn(n, t.scope.get(n)) : t.error(`Unknown variable "${n}". Make sure "${n}" has been bound in an enclosing "let" expression before using it.`, 1);
        }
        evaluate(e) {
            return this.boundExpression.evaluate(e);
        }
        eachChild() {}
        outputDefined() {
            return !1;
        }
        serialize() {
            return [ "var", this.name ];
        }
    }
    var ei = Qn;
    class ti {
        constructor(e, t = [], n, i = new Et, r = []) {
            this.registry = e, this.path = t, this.key = t.map((e => `[${e}]`)).join(""), this.scope = i, 
            this.errors = r, this.expectedType = n;
        }
        parse(e, t, n, i, r = {}) {
            return t ? this.concat(t, n, i)._parse(e, r) : this._parse(e, r);
        }
        _parse(e, t) {
            function n(e, t, n) {
                return "assert" === n ? new vn(t, [ e ]) : "coerce" === n ? new Sn(t, [ e ]) : e;
            }
            if (null !== e && "string" != typeof e && "boolean" != typeof e && "number" != typeof e || (e = [ "literal", e ]), 
            Array.isArray(e)) {
                if (0 === e.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                const i = e[0];
                if ("string" != typeof i) return this.error(`Expression name must be a string, but found ${typeof i} instead. If you wanted a literal array, use ["literal", [...]].`, 0), 
                null;
                const r = this.registry[i];
                if (r) {
                    let i = r.parse(e, this);
                    if (!i) return null;
                    if (this.expectedType) {
                        const e = this.expectedType, r = i.type;
                        if ("string" !== e.kind && "number" !== e.kind && "boolean" !== e.kind && "object" !== e.kind && "array" !== e.kind || "value" !== r.kind) if ("color" !== e.kind && "formatted" !== e.kind && "resolvedImage" !== e.kind || "value" !== r.kind && "string" !== r.kind) {
                            if (this.checkSubtype(e, r)) return null;
                        } else i = n(i, e, t.typeAnnotation || "coerce"); else i = n(i, e, t.typeAnnotation || "assert");
                    }
                    if (!(i instanceof mn) && "resolvedImage" !== i.type.kind && ii(i)) {
                        const t = new Pn;
                        try {
                            i = new mn(i.type, i.evaluate(t));
                        } catch (e) {
                            return this.error(e.message), null;
                        }
                    }
                    return i;
                }
                return this.error(`Unknown expression "${i}". If you wanted a literal array, use ["literal", [...]].`, 0);
            }
            return void 0 === e ? this.error("'undefined' value invalid. Use null instead.") : "object" == typeof e ? this.error('Bare objects invalid. Use ["literal", {...}] instead.') : this.error(`Expected an array, but found ${typeof e} instead.`);
        }
        concat(e, t, n) {
            const i = "number" == typeof e ? this.path.concat(e) : this.path, r = n ? this.scope.concat(n) : this.scope;
            return new ti(this.registry, i, t || null, r, this.errors);
        }
        error(e, ...t) {
            const n = `${this.key}${t.map((e => `[${e}]`)).join("")}`;
            this.errors.push(new Ot(n, e));
        }
        checkSubtype(e, t) {
            const n = qt(e, t);
            return n && this.error(n), n;
        }
    }
    var ni = ti;
    function ii(e) {
        if (e instanceof ei) return ii(e.boundExpression);
        if (e instanceof Cn && "error" === e.name) return !1;
        if (e instanceof kn) return !1;
        if (e instanceof Zn) return !1;
        const t = e instanceof Sn || e instanceof vn;
        let n = !0;
        return e.eachChild((e => {
            n = t ? n && ii(e) : n && e instanceof mn;
        })), !!n && $n(e) && Kn(e, [ "zoom", "heatmap-density", "line-progress", "sky-radial-progress", "accumulated", "is-supported-script", "pitch", "distance-from-center" ]);
    }
    function ri(e, t) {
        const n = e.length - 1;
        let i, r, s = 0, o = n, a = 0;
        for (;s <= o; ) if (a = Math.floor((s + o) / 2), i = e[a], r = e[a + 1], i <= t) {
            if (a === n || t < r) return a;
            s = a + 1;
        } else {
            if (!(i > t)) throw new yn("Input is not a number.");
            o = a - 1;
        }
        return 0;
    }
    class si {
        constructor(e, t, n) {
            this.type = e, this.input = t, this.labels = [], this.outputs = [];
            for (const [e, t] of n) this.labels.push(e), this.outputs.push(t);
        }
        static parse(e, t) {
            if (e.length - 1 < 4) return t.error(`Expected at least 4 arguments, but found only ${e.length - 1}.`);
            if ((e.length - 1) % 2 != 0) return t.error("Expected an even number of arguments.");
            const n = t.parse(e[1], 1, Lt);
            if (!n) return null;
            const i = [];
            let r = null;
            t.expectedType && "value" !== t.expectedType.kind && (r = t.expectedType);
            for (let n = 1; n < e.length; n += 2) {
                const s = 1 === n ? -1 / 0 : e[n], o = e[n + 1], a = n, l = n + 1;
                if ("number" != typeof s) return t.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', a);
                if (i.length && i[i.length - 1][0] >= s) return t.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', a);
                const h = t.parse(o, l, r);
                if (!h) return null;
                r = r || h.type, i.push([ s, h ]);
            }
            return new si(r, n, i);
        }
        evaluate(e) {
            const t = this.labels, n = this.outputs;
            if (1 === t.length) return n[0].evaluate(e);
            const i = this.input.evaluate(e);
            if (i <= t[0]) return n[0].evaluate(e);
            const r = t.length;
            return i >= t[r - 1] ? n[r - 1].evaluate(e) : n[ri(t, i)].evaluate(e);
        }
        eachChild(e) {
            e(this.input);
            for (const t of this.outputs) e(t);
        }
        outputDefined() {
            return this.outputs.every((e => e.outputDefined()));
        }
        serialize() {
            const e = [ "step", this.input.serialize() ];
            for (let t = 0; t < this.labels.length; t++) t > 0 && e.push(this.labels[t]), e.push(this.outputs[t].serialize());
            return e;
        }
    }
    var oi = si, ai = li;
    function li(e, t, n, i) {
        this.cx = 3 * e, this.bx = 3 * (n - e) - this.cx, this.ax = 1 - this.cx - this.bx, 
        this.cy = 3 * t, this.by = 3 * (i - t) - this.cy, this.ay = 1 - this.cy - this.by, 
        this.p1x = e, this.p1y = t, this.p2x = n, this.p2y = i;
    }
    function hi(e, t, n) {
        return e * (1 - n) + t * n;
    }
    li.prototype = {
        sampleCurveX: function(e) {
            return ((this.ax * e + this.bx) * e + this.cx) * e;
        },
        sampleCurveY: function(e) {
            return ((this.ay * e + this.by) * e + this.cy) * e;
        },
        sampleCurveDerivativeX: function(e) {
            return (3 * this.ax * e + 2 * this.bx) * e + this.cx;
        },
        solveCurveX: function(e, t) {
            if (void 0 === t && (t = 1e-6), e < 0) return 0;
            if (e > 1) return 1;
            for (var n = e, i = 0; i < 8; i++) {
                var r = this.sampleCurveX(n) - e;
                if (Math.abs(r) < t) return n;
                var s = this.sampleCurveDerivativeX(n);
                if (Math.abs(s) < 1e-6) break;
                n -= r / s;
            }
            var o = 0, a = 1;
            for (n = e, i = 0; i < 20 && (r = this.sampleCurveX(n), !(Math.abs(r - e) < t)); i++) e > r ? o = n : a = n, 
            n = .5 * (a - o) + o;
            return n;
        },
        solve: function(e, t) {
            return this.sampleCurveY(this.solveCurveX(e, t));
        }
    };
    var ci = Object.freeze({
        __proto__: null,
        number: hi,
        color: function(e, t, n) {
            return new on(hi(e.r, t.r, n), hi(e.g, t.g, n), hi(e.b, t.b, n), hi(e.a, t.a, n));
        },
        array: function(e, t, n) {
            return e.map(((e, i) => hi(e, t[i], n)));
        }
    });
    const ui = .95047, fi = 1.08883, di = 4 / 29, pi = 6 / 29, gi = 3 * pi * pi, mi = pi * pi * pi, yi = Math.PI / 180, xi = 180 / Math.PI;
    function _i(e) {
        return e > mi ? Math.pow(e, 1 / 3) : e / gi + di;
    }
    function vi(e) {
        return e > pi ? e * e * e : gi * (e - di);
    }
    function bi(e) {
        return 255 * (e <= .0031308 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - .055);
    }
    function Ai(e) {
        return (e /= 255) <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
    }
    function Ti(e) {
        const t = Ai(e.r), n = Ai(e.g), i = Ai(e.b), r = _i((.4124564 * t + .3575761 * n + .1804375 * i) / ui), s = _i((.2126729 * t + .7151522 * n + .072175 * i) / 1);
        return {
            l: 116 * s - 16,
            a: 500 * (r - s),
            b: 200 * (s - _i((.0193339 * t + .119192 * n + .9503041 * i) / fi)),
            alpha: e.a
        };
    }
    function wi(e) {
        let t = (e.l + 16) / 116, n = isNaN(e.a) ? t : t + e.a / 500, i = isNaN(e.b) ? t : t - e.b / 200;
        return t = 1 * vi(t), n = ui * vi(n), i = fi * vi(i), new on(bi(3.2404542 * n - 1.5371385 * t - .4985314 * i), bi(-.969266 * n + 1.8760108 * t + .041556 * i), bi(.0556434 * n - .2040259 * t + 1.0572252 * i), e.alpha);
    }
    function Si(e, t, n) {
        const i = t - e;
        return e + n * (i > 180 || i < -180 ? i - 360 * Math.round(i / 360) : i);
    }
    const Mi = {
        forward: Ti,
        reverse: wi,
        interpolate: function(e, t, n) {
            return {
                l: hi(e.l, t.l, n),
                a: hi(e.a, t.a, n),
                b: hi(e.b, t.b, n),
                alpha: hi(e.alpha, t.alpha, n)
            };
        }
    }, Pi = {
        forward: function(e) {
            const {l: t, a: n, b: i} = Ti(e), r = Math.atan2(i, n) * xi;
            return {
                h: r < 0 ? r + 360 : r,
                c: Math.sqrt(n * n + i * i),
                l: t,
                alpha: e.a
            };
        },
        reverse: function(e) {
            const t = e.h * yi, n = e.c;
            return wi({
                l: e.l,
                a: Math.cos(t) * n,
                b: Math.sin(t) * n,
                alpha: e.alpha
            });
        },
        interpolate: function(e, t, n) {
            return {
                h: Si(e.h, t.h, n),
                c: hi(e.c, t.c, n),
                l: hi(e.l, t.l, n),
                alpha: hi(e.alpha, t.alpha, n)
            };
        }
    };
    var Ii = Object.freeze({
        __proto__: null,
        lab: Mi,
        hcl: Pi
    });
    class Ci {
        constructor(e, t, n, i, r) {
            this.type = e, this.operator = t, this.interpolation = n, this.input = i, this.labels = [], 
            this.outputs = [];
            for (const [e, t] of r) this.labels.push(e), this.outputs.push(t);
        }
        static interpolationFactor(e, t, n, i) {
            let r = 0;
            if ("exponential" === e.name) r = ki(t, e.base, n, i); else if ("linear" === e.name) r = ki(t, 1, n, i); else if ("cubic-bezier" === e.name) {
                const s = e.controlPoints;
                r = new ai(s[0], s[1], s[2], s[3]).solve(ki(t, 1, n, i));
            }
            return r;
        }
        static parse(e, t) {
            let [n, i, r, ...s] = e;
            if (!Array.isArray(i) || 0 === i.length) return t.error("Expected an interpolation type expression.", 1);
            if ("linear" === i[0]) i = {
                name: "linear"
            }; else if ("exponential" === i[0]) {
                const e = i[1];
                if ("number" != typeof e) return t.error("Exponential interpolation requires a numeric base.", 1, 1);
                i = {
                    name: "exponential",
                    base: e
                };
            } else {
                if ("cubic-bezier" !== i[0]) return t.error(`Unknown interpolation type ${String(i[0])}`, 1, 0);
                {
                    const e = i.slice(1);
                    if (4 !== e.length || e.some((e => "number" != typeof e || e < 0 || e > 1))) return t.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                    i = {
                        name: "cubic-bezier",
                        controlPoints: e
                    };
                }
            }
            if (e.length - 1 < 4) return t.error(`Expected at least 4 arguments, but found only ${e.length - 1}.`);
            if ((e.length - 1) % 2 != 0) return t.error("Expected an even number of arguments.");
            if (r = t.parse(r, 2, Lt), !r) return null;
            const o = [];
            let a = null;
            "interpolate-hcl" === n || "interpolate-lab" === n ? a = Nt : t.expectedType && "value" !== t.expectedType.kind && (a = t.expectedType);
            for (let e = 0; e < s.length; e += 2) {
                const n = s[e], i = s[e + 1], r = e + 3, l = e + 4;
                if ("number" != typeof n) return t.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', r);
                if (o.length && o[o.length - 1][0] >= n) return t.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', r);
                const h = t.parse(i, l, a);
                if (!h) return null;
                a = a || h.type, o.push([ n, h ]);
            }
            return "number" === a.kind || "color" === a.kind || "array" === a.kind && "number" === a.itemType.kind && "number" == typeof a.N ? new Ci(a, n, i, r, o) : t.error(`Type ${Xt(a)} is not interpolatable.`);
        }
        evaluate(e) {
            const t = this.labels, n = this.outputs;
            if (1 === t.length) return n[0].evaluate(e);
            const i = this.input.evaluate(e);
            if (i <= t[0]) return n[0].evaluate(e);
            const r = t.length;
            if (i >= t[r - 1]) return n[r - 1].evaluate(e);
            const s = ri(t, i), o = t[s], a = t[s + 1], l = Ci.interpolationFactor(this.interpolation, i, o, a), h = n[s].evaluate(e), c = n[s + 1].evaluate(e);
            return "interpolate" === this.operator ? ci[this.type.kind.toLowerCase()](h, c, l) : "interpolate-hcl" === this.operator ? Pi.reverse(Pi.interpolate(Pi.forward(h), Pi.forward(c), l)) : Mi.reverse(Mi.interpolate(Mi.forward(h), Mi.forward(c), l));
        }
        eachChild(e) {
            e(this.input);
            for (const t of this.outputs) e(t);
        }
        outputDefined() {
            return this.outputs.every((e => e.outputDefined()));
        }
        serialize() {
            let e;
            e = "linear" === this.interpolation.name ? [ "linear" ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [ "linear" ] : [ "exponential", this.interpolation.base ] : [ "cubic-bezier" ].concat(this.interpolation.controlPoints);
            const t = [ this.operator, e, this.input.serialize() ];
            for (let e = 0; e < this.labels.length; e++) t.push(this.labels[e], this.outputs[e].serialize());
            return t;
        }
    }
    function ki(e, t, n, i) {
        const r = i - n, s = e - n;
        return 0 === r ? 0 : 1 === t ? s / r : (Math.pow(t, s) - 1) / (Math.pow(t, r) - 1);
    }
    var Fi = Ci;
    class Oi {
        constructor(e, t) {
            this.type = e, this.args = t;
        }
        static parse(e, t) {
            if (e.length < 2) return t.error("Expectected at least one argument.");
            let n = null;
            const i = t.expectedType;
            i && "value" !== i.kind && (n = i);
            const r = [];
            for (const i of e.slice(1)) {
                const e = t.parse(i, 1 + r.length, n, void 0, {
                    typeAnnotation: "omit"
                });
                if (!e) return null;
                n = n || e.type, r.push(e);
            }
            const s = i && r.some((e => qt(i, e.type)));
            return new Oi(s ? Bt : n, r);
        }
        evaluate(e) {
            let t, n = null, i = 0;
            for (const r of this.args) {
                if (i++, n = r.evaluate(e), n && n instanceof cn && !n.available && (t || (t = n), 
                n = null, i === this.args.length)) return t;
                if (null !== n) break;
            }
            return n;
        }
        eachChild(e) {
            this.args.forEach(e);
        }
        outputDefined() {
            return this.args.every((e => e.outputDefined()));
        }
        serialize() {
            const e = [ "coalesce" ];
            return this.eachChild((t => {
                e.push(t.serialize());
            })), e;
        }
    }
    var Ri = Oi;
    class Ei {
        constructor(e, t) {
            this.type = t.type, this.bindings = [].concat(e), this.result = t;
        }
        evaluate(e) {
            return this.result.evaluate(e);
        }
        eachChild(e) {
            for (const t of this.bindings) e(t[1]);
            e(this.result);
        }
        static parse(e, t) {
            if (e.length < 4) return t.error(`Expected at least 3 arguments, but found ${e.length - 1} instead.`);
            const n = [];
            for (let i = 1; i < e.length - 1; i += 2) {
                const r = e[i];
                if ("string" != typeof r) return t.error(`Expected string, but found ${typeof r} instead.`, i);
                if (/[^a-zA-Z0-9_]/.test(r)) return t.error("Variable names must contain only alphanumeric characters or '_'.", i);
                const s = t.parse(e[i + 1], i + 1);
                if (!s) return null;
                n.push([ r, s ]);
            }
            const i = t.parse(e[e.length - 1], e.length - 1, t.expectedType, n);
            return i ? new Ei(n, i) : null;
        }
        outputDefined() {
            return this.result.outputDefined();
        }
        serialize() {
            const e = [ "let" ];
            for (const [t, n] of this.bindings) e.push(t, n.serialize());
            return e.push(this.result.serialize()), e;
        }
    }
    var Di = Ei;
    class Li {
        constructor(e, t, n) {
            this.type = e, this.index = t, this.input = n;
        }
        static parse(e, t) {
            if (3 !== e.length) return t.error(`Expected 2 arguments, but found ${e.length - 1} instead.`);
            const n = t.parse(e[1], 1, Lt), i = t.parse(e[2], 2, Wt(t.expectedType || Bt));
            if (!n || !i) return null;
            const r = i.type;
            return new Li(r.itemType, n, i);
        }
        evaluate(e) {
            const t = this.index.evaluate(e), n = this.input.evaluate(e);
            if (t < 0) throw new yn(`Array index out of bounds: ${t} < 0.`);
            if (t >= n.length) throw new yn(`Array index out of bounds: ${t} > ${n.length - 1}.`);
            if (t !== Math.floor(t)) throw new yn(`Array index must be an integer, but found ${t} instead.`);
            return n[t];
        }
        eachChild(e) {
            e(this.index), e(this.input);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            return [ "at", this.index.serialize(), this.input.serialize() ];
        }
    }
    var Hi = Li;
    class zi {
        constructor(e, t) {
            this.type = zt, this.needle = e, this.haystack = t;
        }
        static parse(e, t) {
            if (3 !== e.length) return t.error(`Expected 2 arguments, but found ${e.length - 1} instead.`);
            const n = t.parse(e[1], 1, Bt), i = t.parse(e[2], 2, Bt);
            return n && i ? Zt(n.type, [ zt, Ht, Lt, Dt, Bt ]) ? new zi(n, i) : t.error(`Expected first argument to be of type boolean, string, number or null, but found ${Xt(n.type)} instead`) : null;
        }
        evaluate(e) {
            const t = this.needle.evaluate(e), n = this.haystack.evaluate(e);
            if (null == n) return !1;
            if (!$t(t, [ "boolean", "string", "number", "null" ])) throw new yn(`Expected first argument to be of type boolean, string, number or null, but found ${Xt(dn(t))} instead.`);
            if (!$t(n, [ "string", "array" ])) throw new yn(`Expected second argument to be of type array or string, but found ${Xt(dn(n))} instead.`);
            return n.indexOf(t) >= 0;
        }
        eachChild(e) {
            e(this.needle), e(this.haystack);
        }
        outputDefined() {
            return !0;
        }
        serialize() {
            return [ "in", this.needle.serialize(), this.haystack.serialize() ];
        }
    }
    var Ni = zi;
    class Vi {
        constructor(e, t, n) {
            this.type = Lt, this.needle = e, this.haystack = t, this.fromIndex = n;
        }
        static parse(e, t) {
            if (e.length <= 2 || e.length >= 5) return t.error(`Expected 3 or 4 arguments, but found ${e.length - 1} instead.`);
            const n = t.parse(e[1], 1, Bt), i = t.parse(e[2], 2, Bt);
            if (!n || !i) return null;
            if (!Zt(n.type, [ zt, Ht, Lt, Dt, Bt ])) return t.error(`Expected first argument to be of type boolean, string, number or null, but found ${Xt(n.type)} instead`);
            if (4 === e.length) {
                const r = t.parse(e[3], 3, Lt);
                return r ? new Vi(n, i, r) : null;
            }
            return new Vi(n, i);
        }
        evaluate(e) {
            const t = this.needle.evaluate(e), n = this.haystack.evaluate(e);
            if (!$t(t, [ "boolean", "string", "number", "null" ])) throw new yn(`Expected first argument to be of type boolean, string, number or null, but found ${Xt(dn(t))} instead.`);
            if (!$t(n, [ "string", "array" ])) throw new yn(`Expected second argument to be of type array or string, but found ${Xt(dn(n))} instead.`);
            if (this.fromIndex) {
                const i = this.fromIndex.evaluate(e);
                return n.indexOf(t, i);
            }
            return n.indexOf(t);
        }
        eachChild(e) {
            e(this.needle), e(this.haystack), this.fromIndex && e(this.fromIndex);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            if (null != this.fromIndex && void 0 !== this.fromIndex) {
                const e = this.fromIndex.serialize();
                return [ "index-of", this.needle.serialize(), this.haystack.serialize(), e ];
            }
            return [ "index-of", this.needle.serialize(), this.haystack.serialize() ];
        }
    }
    var Bi = Vi;
    class Ui {
        constructor(e, t, n, i, r, s) {
            this.inputType = e, this.type = t, this.input = n, this.cases = i, this.outputs = r, 
            this.otherwise = s;
        }
        static parse(e, t) {
            if (e.length < 5) return t.error(`Expected at least 4 arguments, but found only ${e.length - 1}.`);
            if (e.length % 2 != 1) return t.error("Expected an even number of arguments.");
            let n, i;
            t.expectedType && "value" !== t.expectedType.kind && (i = t.expectedType);
            const r = {}, s = [];
            for (let o = 2; o < e.length - 1; o += 2) {
                let a = e[o];
                const l = e[o + 1];
                Array.isArray(a) || (a = [ a ]);
                const h = t.concat(o);
                if (0 === a.length) return h.error("Expected at least one branch label.");
                for (const e of a) {
                    if ("number" != typeof e && "string" != typeof e) return h.error("Branch labels must be numbers or strings.");
                    if ("number" == typeof e && Math.abs(e) > Number.MAX_SAFE_INTEGER) return h.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                    if ("number" == typeof e && Math.floor(e) !== e) return h.error("Numeric branch labels must be integer values.");
                    if (n) {
                        if (h.checkSubtype(n, dn(e))) return null;
                    } else n = dn(e);
                    if (void 0 !== r[String(e)]) return h.error("Branch labels must be unique.");
                    r[String(e)] = s.length;
                }
                const c = t.parse(l, o, i);
                if (!c) return null;
                i = i || c.type, s.push(c);
            }
            const o = t.parse(e[1], 1, Bt);
            if (!o) return null;
            const a = t.parse(e[e.length - 1], e.length - 1, i);
            return a ? "value" !== o.type.kind && t.concat(1).checkSubtype(n, o.type) ? null : new Ui(n, i, o, r, s, a) : null;
        }
        evaluate(e) {
            const t = this.input.evaluate(e);
            return (dn(t) === this.inputType && this.outputs[this.cases[t]] || this.otherwise).evaluate(e);
        }
        eachChild(e) {
            e(this.input), this.outputs.forEach(e), e(this.otherwise);
        }
        outputDefined() {
            return this.outputs.every((e => e.outputDefined())) && this.otherwise.outputDefined();
        }
        serialize() {
            const e = [ "match", this.input.serialize() ], t = Object.keys(this.cases).sort(), n = [], i = {};
            for (const e of t) {
                const t = i[this.cases[e]];
                void 0 === t ? (i[this.cases[e]] = n.length, n.push([ this.cases[e], [ e ] ])) : n[t][1].push(e);
            }
            const r = e => "number" === this.inputType.kind ? Number(e) : e;
            for (const [t, i] of n) 1 === i.length ? e.push(r(i[0])) : e.push(i.map(r)), e.push(this.outputs[t].serialize());
            return e.push(this.otherwise.serialize()), e;
        }
    }
    var Gi = Ui;
    class ji {
        constructor(e, t, n) {
            this.type = e, this.branches = t, this.otherwise = n;
        }
        static parse(e, t) {
            if (e.length < 4) return t.error(`Expected at least 3 arguments, but found only ${e.length - 1}.`);
            if (e.length % 2 != 0) return t.error("Expected an odd number of arguments.");
            let n;
            t.expectedType && "value" !== t.expectedType.kind && (n = t.expectedType);
            const i = [];
            for (let r = 1; r < e.length - 1; r += 2) {
                const s = t.parse(e[r], r, zt);
                if (!s) return null;
                const o = t.parse(e[r + 1], r + 1, n);
                if (!o) return null;
                i.push([ s, o ]), n = n || o.type;
            }
            const r = t.parse(e[e.length - 1], e.length - 1, n);
            return r ? new ji(n, i, r) : null;
        }
        evaluate(e) {
            for (const [t, n] of this.branches) if (t.evaluate(e)) return n.evaluate(e);
            return this.otherwise.evaluate(e);
        }
        eachChild(e) {
            for (const [t, n] of this.branches) e(t), e(n);
            e(this.otherwise);
        }
        outputDefined() {
            return this.branches.every((([e, t]) => t.outputDefined())) && this.otherwise.outputDefined();
        }
        serialize() {
            const e = [ "case" ];
            return this.eachChild((t => {
                e.push(t.serialize());
            })), e;
        }
    }
    var Wi = ji;
    class Xi {
        constructor(e, t, n, i) {
            this.type = e, this.input = t, this.beginIndex = n, this.endIndex = i;
        }
        static parse(e, t) {
            if (e.length <= 2 || e.length >= 5) return t.error(`Expected 3 or 4 arguments, but found ${e.length - 1} instead.`);
            const n = t.parse(e[1], 1, Bt), i = t.parse(e[2], 2, Lt);
            if (!n || !i) return null;
            if (!Zt(n.type, [ Wt(Bt), Ht, Bt ])) return t.error(`Expected first argument to be of type array or string, but found ${Xt(n.type)} instead`);
            if (4 === e.length) {
                const r = t.parse(e[3], 3, Lt);
                return r ? new Xi(n.type, n, i, r) : null;
            }
            return new Xi(n.type, n, i);
        }
        evaluate(e) {
            const t = this.input.evaluate(e), n = this.beginIndex.evaluate(e);
            if (!$t(t, [ "string", "array" ])) throw new yn(`Expected first argument to be of type array or string, but found ${Xt(dn(t))} instead.`);
            if (this.endIndex) {
                const i = this.endIndex.evaluate(e);
                return t.slice(n, i);
            }
            return t.slice(n);
        }
        eachChild(e) {
            e(this.input), e(this.beginIndex), this.endIndex && e(this.endIndex);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            if (null != this.endIndex && void 0 !== this.endIndex) {
                const e = this.endIndex.serialize();
                return [ "slice", this.input.serialize(), this.beginIndex.serialize(), e ];
            }
            return [ "slice", this.input.serialize(), this.beginIndex.serialize() ];
        }
    }
    var Yi = Xi;
    function qi(e, t) {
        return "==" === e || "!=" === e ? "boolean" === t.kind || "string" === t.kind || "number" === t.kind || "null" === t.kind || "value" === t.kind : "string" === t.kind || "number" === t.kind || "value" === t.kind;
    }
    function Zi(e, t, n, i) {
        return 0 === i.compare(t, n);
    }
    function $i(e, t, n) {
        const i = "==" !== e && "!=" !== e;
        return class r {
            constructor(e, t, n) {
                this.type = zt, this.lhs = e, this.rhs = t, this.collator = n, this.hasUntypedArgument = "value" === e.type.kind || "value" === t.type.kind;
            }
            static parse(e, t) {
                if (3 !== e.length && 4 !== e.length) return t.error("Expected two or three arguments.");
                const n = e[0];
                let s = t.parse(e[1], 1, Bt);
                if (!s) return null;
                if (!qi(n, s.type)) return t.concat(1).error(`"${n}" comparisons are not supported for type '${Xt(s.type)}'.`);
                let o = t.parse(e[2], 2, Bt);
                if (!o) return null;
                if (!qi(n, o.type)) return t.concat(2).error(`"${n}" comparisons are not supported for type '${Xt(o.type)}'.`);
                if (s.type.kind !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return t.error(`Cannot compare types '${Xt(s.type)}' and '${Xt(o.type)}'.`);
                i && ("value" === s.type.kind && "value" !== o.type.kind ? s = new vn(o.type, [ s ]) : "value" !== s.type.kind && "value" === o.type.kind && (o = new vn(s.type, [ o ])));
                let a = null;
                if (4 === e.length) {
                    if ("string" !== s.type.kind && "string" !== o.type.kind && "value" !== s.type.kind && "value" !== o.type.kind) return t.error("Cannot use collator to compare non-string types.");
                    if (a = t.parse(e[3], 3, Ut), !a) return null;
                }
                return new r(s, o, a);
            }
            evaluate(r) {
                const s = this.lhs.evaluate(r), o = this.rhs.evaluate(r);
                if (i && this.hasUntypedArgument) {
                    const t = dn(s), n = dn(o);
                    if (t.kind !== n.kind || "string" !== t.kind && "number" !== t.kind) throw new yn(`Expected arguments for "${e}" to be (string, string) or (number, number), but found (${t.kind}, ${n.kind}) instead.`);
                }
                if (this.collator && !i && this.hasUntypedArgument) {
                    const e = dn(s), n = dn(o);
                    if ("string" !== e.kind || "string" !== n.kind) return t(r, s, o);
                }
                return this.collator ? n(r, s, o, this.collator.evaluate(r)) : t(r, s, o);
            }
            eachChild(e) {
                e(this.lhs), e(this.rhs), this.collator && e(this.collator);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                const t = [ e ];
                return this.eachChild((e => {
                    t.push(e.serialize());
                })), t;
            }
        };
    }
    const Ji = $i("==", (function(e, t, n) {
        return t === n;
    }), Zi), Ki = $i("!=", (function(e, t, n) {
        return t !== n;
    }), (function(e, t, n, i) {
        return !Zi(0, t, n, i);
    })), Qi = $i("<", (function(e, t, n) {
        return t < n;
    }), (function(e, t, n, i) {
        return i.compare(t, n) < 0;
    })), er = $i(">", (function(e, t, n) {
        return t > n;
    }), (function(e, t, n, i) {
        return i.compare(t, n) > 0;
    })), tr = $i("<=", (function(e, t, n) {
        return t <= n;
    }), (function(e, t, n, i) {
        return i.compare(t, n) <= 0;
    })), nr = $i(">=", (function(e, t, n) {
        return t >= n;
    }), (function(e, t, n, i) {
        return i.compare(t, n) >= 0;
    }));
    class ir {
        constructor(e, t, n, i, r, s) {
            this.type = Ht, this.number = e, this.locale = t, this.currency = n, this.unit = i, 
            this.minFractionDigits = r, this.maxFractionDigits = s;
        }
        static parse(e, t) {
            if (3 !== e.length) return t.error("Expected two arguments.");
            const n = t.parse(e[1], 1, Lt);
            if (!n) return null;
            const i = e[2];
            if ("object" != typeof i || Array.isArray(i)) return t.error("NumberFormat options argument must be an object.");
            let r = null;
            if (i.locale && (r = t.parse(i.locale, 1, Ht), !r)) return null;
            let s = null;
            if (i.currency && (s = t.parse(i.currency, 1, Ht), !s)) return null;
            let o = null;
            if (i.unit && (o = t.parse(i.unit, 1, Ht), !o)) return null;
            let a = null;
            if (i["min-fraction-digits"] && (a = t.parse(i["min-fraction-digits"], 1, Lt), !a)) return null;
            let l = null;
            return i["max-fraction-digits"] && (l = t.parse(i["max-fraction-digits"], 1, Lt), 
            !l) ? null : new ir(n, r, s, o, a, l);
        }
        evaluate(e) {
            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e) : [], {
                style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                currency: this.currency ? this.currency.evaluate(e) : void 0,
                unit: this.unit ? this.unit.evaluate(e) : void 0,
                minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e) : void 0,
                maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e) : void 0
            }).format(this.number.evaluate(e));
        }
        eachChild(e) {
            e(this.number), this.locale && e(this.locale), this.currency && e(this.currency), 
            this.unit && e(this.unit), this.minFractionDigits && e(this.minFractionDigits), 
            this.maxFractionDigits && e(this.maxFractionDigits);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            const e = {};
            return this.locale && (e.locale = this.locale.serialize()), this.currency && (e.currency = this.currency.serialize()), 
            this.unit && (e.unit = this.unit.serialize()), this.minFractionDigits && (e["min-fraction-digits"] = this.minFractionDigits.serialize()), 
            this.maxFractionDigits && (e["max-fraction-digits"] = this.maxFractionDigits.serialize()), 
            [ "number-format", this.number.serialize(), e ];
        }
    }
    class rr {
        constructor(e) {
            this.type = Lt, this.input = e;
        }
        static parse(e, t) {
            if (2 !== e.length) return t.error(`Expected 1 argument, but found ${e.length - 1} instead.`);
            const n = t.parse(e[1], 1);
            return n ? "array" !== n.type.kind && "string" !== n.type.kind && "value" !== n.type.kind ? t.error(`Expected argument of type string or array, but found ${Xt(n.type)} instead.`) : new rr(n) : null;
        }
        evaluate(e) {
            const t = this.input.evaluate(e);
            if ("string" == typeof t) return t.length;
            if (Array.isArray(t)) return t.length;
            throw new yn(`Expected value to be of type string or array, but found ${Xt(dn(t))} instead.`);
        }
        eachChild(e) {
            e(this.input);
        }
        outputDefined() {
            return !1;
        }
        serialize() {
            const e = [ "length" ];
            return this.eachChild((t => {
                e.push(t.serialize());
            })), e;
        }
    }
    const sr = {
        "==": Ji,
        "!=": Ki,
        ">": er,
        "<": Qi,
        ">=": nr,
        "<=": tr,
        array: vn,
        at: Hi,
        boolean: vn,
        case: Wi,
        coalesce: Ri,
        collator: kn,
        format: bn,
        image: An,
        in: Ni,
        "index-of": Bi,
        interpolate: Fi,
        "interpolate-hcl": Fi,
        "interpolate-lab": Fi,
        length: rr,
        let: Di,
        literal: mn,
        match: Gi,
        number: vn,
        "number-format": ir,
        object: vn,
        slice: Yi,
        step: oi,
        string: vn,
        "to-boolean": Sn,
        "to-color": Sn,
        "to-number": Sn,
        "to-string": Sn,
        var: ei,
        within: Zn
    };
    function or(e, [t, n, i, r]) {
        t = t.evaluate(e), n = n.evaluate(e), i = i.evaluate(e);
        const s = r ? r.evaluate(e) : 1, o = un(t, n, i, s);
        if (o) throw new yn(o);
        return new on(t / 255 * s, n / 255 * s, i / 255 * s, s);
    }
    function ar(e, t) {
        return e in t;
    }
    function lr(e, t) {
        const n = t[e];
        return void 0 === n ? null : n;
    }
    function hr(e) {
        return {
            type: e
        };
    }
    Cn.register(sr, {
        error: [ {
            kind: "error"
        }, [ Ht ], (e, [t]) => {
            throw new yn(t.evaluate(e));
        } ],
        typeof: [ Ht, [ Bt ], (e, [t]) => Xt(dn(t.evaluate(e))) ],
        "to-rgba": [ Wt(Lt, 4), [ Nt ], (e, [t]) => t.evaluate(e).toArray() ],
        rgb: [ Nt, [ Lt, Lt, Lt ], or ],
        rgba: [ Nt, [ Lt, Lt, Lt, Lt ], or ],
        has: {
            type: zt,
            overloads: [ [ [ Ht ], (e, [t]) => ar(t.evaluate(e), e.properties()) ], [ [ Ht, Vt ], (e, [t, n]) => ar(t.evaluate(e), n.evaluate(e)) ] ]
        },
        get: {
            type: Bt,
            overloads: [ [ [ Ht ], (e, [t]) => lr(t.evaluate(e), e.properties()) ], [ [ Ht, Vt ], (e, [t, n]) => lr(t.evaluate(e), n.evaluate(e)) ] ]
        },
        "feature-state": [ Bt, [ Ht ], (e, [t]) => lr(t.evaluate(e), e.featureState || {}) ],
        properties: [ Vt, [], e => e.properties() ],
        "geometry-type": [ Ht, [], e => e.geometryType() ],
        id: [ Bt, [], e => e.id() ],
        zoom: [ Lt, [], e => e.globals.zoom ],
        pitch: [ Lt, [], e => e.globals.pitch || 0 ],
        "distance-from-center": [ Lt, [], e => e.distanceFromCenter() ],
        "heatmap-density": [ Lt, [], e => e.globals.heatmapDensity || 0 ],
        "line-progress": [ Lt, [], e => e.globals.lineProgress || 0 ],
        "sky-radial-progress": [ Lt, [], e => e.globals.skyRadialProgress || 0 ],
        accumulated: [ Bt, [], e => void 0 === e.globals.accumulated ? null : e.globals.accumulated ],
        "+": [ Lt, hr(Lt), (e, t) => {
            let n = 0;
            for (const i of t) n += i.evaluate(e);
            return n;
        } ],
        "*": [ Lt, hr(Lt), (e, t) => {
            let n = 1;
            for (const i of t) n *= i.evaluate(e);
            return n;
        } ],
        "-": {
            type: Lt,
            overloads: [ [ [ Lt, Lt ], (e, [t, n]) => t.evaluate(e) - n.evaluate(e) ], [ [ Lt ], (e, [t]) => -t.evaluate(e) ] ]
        },
        "/": [ Lt, [ Lt, Lt ], (e, [t, n]) => t.evaluate(e) / n.evaluate(e) ],
        "%": [ Lt, [ Lt, Lt ], (e, [t, n]) => t.evaluate(e) % n.evaluate(e) ],
        ln2: [ Lt, [], () => Math.LN2 ],
        pi: [ Lt, [], () => Math.PI ],
        e: [ Lt, [], () => Math.E ],
        "^": [ Lt, [ Lt, Lt ], (e, [t, n]) => Math.pow(t.evaluate(e), n.evaluate(e)) ],
        sqrt: [ Lt, [ Lt ], (e, [t]) => Math.sqrt(t.evaluate(e)) ],
        log10: [ Lt, [ Lt ], (e, [t]) => Math.log(t.evaluate(e)) / Math.LN10 ],
        ln: [ Lt, [ Lt ], (e, [t]) => Math.log(t.evaluate(e)) ],
        log2: [ Lt, [ Lt ], (e, [t]) => Math.log(t.evaluate(e)) / Math.LN2 ],
        sin: [ Lt, [ Lt ], (e, [t]) => Math.sin(t.evaluate(e)) ],
        cos: [ Lt, [ Lt ], (e, [t]) => Math.cos(t.evaluate(e)) ],
        tan: [ Lt, [ Lt ], (e, [t]) => Math.tan(t.evaluate(e)) ],
        asin: [ Lt, [ Lt ], (e, [t]) => Math.asin(t.evaluate(e)) ],
        acos: [ Lt, [ Lt ], (e, [t]) => Math.acos(t.evaluate(e)) ],
        atan: [ Lt, [ Lt ], (e, [t]) => Math.atan(t.evaluate(e)) ],
        min: [ Lt, hr(Lt), (e, t) => Math.min(...t.map((t => t.evaluate(e)))) ],
        max: [ Lt, hr(Lt), (e, t) => Math.max(...t.map((t => t.evaluate(e)))) ],
        abs: [ Lt, [ Lt ], (e, [t]) => Math.abs(t.evaluate(e)) ],
        round: [ Lt, [ Lt ], (e, [t]) => {
            const n = t.evaluate(e);
            return n < 0 ? -Math.round(-n) : Math.round(n);
        } ],
        floor: [ Lt, [ Lt ], (e, [t]) => Math.floor(t.evaluate(e)) ],
        ceil: [ Lt, [ Lt ], (e, [t]) => Math.ceil(t.evaluate(e)) ],
        "filter-==": [ zt, [ Ht, Bt ], (e, [t, n]) => e.properties()[t.value] === n.value ],
        "filter-id-==": [ zt, [ Bt ], (e, [t]) => e.id() === t.value ],
        "filter-type-==": [ zt, [ Ht ], (e, [t]) => e.geometryType() === t.value ],
        "filter-<": [ zt, [ Ht, Bt ], (e, [t, n]) => {
            const i = e.properties()[t.value], r = n.value;
            return typeof i == typeof r && i < r;
        } ],
        "filter-id-<": [ zt, [ Bt ], (e, [t]) => {
            const n = e.id(), i = t.value;
            return typeof n == typeof i && n < i;
        } ],
        "filter->": [ zt, [ Ht, Bt ], (e, [t, n]) => {
            const i = e.properties()[t.value], r = n.value;
            return typeof i == typeof r && i > r;
        } ],
        "filter-id->": [ zt, [ Bt ], (e, [t]) => {
            const n = e.id(), i = t.value;
            return typeof n == typeof i && n > i;
        } ],
        "filter-<=": [ zt, [ Ht, Bt ], (e, [t, n]) => {
            const i = e.properties()[t.value], r = n.value;
            return typeof i == typeof r && i <= r;
        } ],
        "filter-id-<=": [ zt, [ Bt ], (e, [t]) => {
            const n = e.id(), i = t.value;
            return typeof n == typeof i && n <= i;
        } ],
        "filter->=": [ zt, [ Ht, Bt ], (e, [t, n]) => {
            const i = e.properties()[t.value], r = n.value;
            return typeof i == typeof r && i >= r;
        } ],
        "filter-id->=": [ zt, [ Bt ], (e, [t]) => {
            const n = e.id(), i = t.value;
            return typeof n == typeof i && n >= i;
        } ],
        "filter-has": [ zt, [ Bt ], (e, [t]) => t.value in e.properties() ],
        "filter-has-id": [ zt, [], e => null !== e.id() && void 0 !== e.id() ],
        "filter-type-in": [ zt, [ Wt(Ht) ], (e, [t]) => t.value.indexOf(e.geometryType()) >= 0 ],
        "filter-id-in": [ zt, [ Wt(Bt) ], (e, [t]) => t.value.indexOf(e.id()) >= 0 ],
        "filter-in-small": [ zt, [ Ht, Wt(Bt) ], (e, [t, n]) => n.value.indexOf(e.properties()[t.value]) >= 0 ],
        "filter-in-large": [ zt, [ Ht, Wt(Bt) ], (e, [t, n]) => function(e, t, n, i) {
            for (;n <= i; ) {
                const r = n + i >> 1;
                if (t[r] === e) return !0;
                t[r] > e ? i = r - 1 : n = r + 1;
            }
            return !1;
        }(e.properties()[t.value], n.value, 0, n.value.length - 1) ],
        all: {
            type: zt,
            overloads: [ [ [ zt, zt ], (e, [t, n]) => t.evaluate(e) && n.evaluate(e) ], [ hr(zt), (e, t) => {
                for (const n of t) if (!n.evaluate(e)) return !1;
                return !0;
            } ] ]
        },
        any: {
            type: zt,
            overloads: [ [ [ zt, zt ], (e, [t, n]) => t.evaluate(e) || n.evaluate(e) ], [ hr(zt), (e, t) => {
                for (const n of t) if (n.evaluate(e)) return !0;
                return !1;
            } ] ]
        },
        "!": [ zt, [ zt ], (e, [t]) => !t.evaluate(e) ],
        "is-supported-script": [ zt, [ Ht ], (e, [t]) => {
            const n = e.globals && e.globals.isSupportedScript;
            return !n || n(t.evaluate(e));
        } ],
        upcase: [ Ht, [ Ht ], (e, [t]) => t.evaluate(e).toUpperCase() ],
        downcase: [ Ht, [ Ht ], (e, [t]) => t.evaluate(e).toLowerCase() ],
        concat: [ Ht, hr(Bt), (e, t) => t.map((t => pn(t.evaluate(e)))).join("") ],
        "resolved-locale": [ Ht, [ Ut ], (e, [t]) => t.evaluate(e).resolvedLocale() ]
    });
    var cr = sr;
    function ur(e) {
        return {
            result: "success",
            value: e
        };
    }
    function fr(e) {
        return {
            result: "error",
            value: e
        };
    }
    function dr(e) {
        return !!e.expression && e.expression.interpolated;
    }
    function pr(e) {
        return e instanceof Number ? "number" : e instanceof String ? "string" : e instanceof Boolean ? "boolean" : Array.isArray(e) ? "array" : null === e ? "null" : typeof e;
    }
    function gr(e) {
        return "object" == typeof e && null !== e && !Array.isArray(e);
    }
    function mr(e) {
        return e;
    }
    function yr(e, t) {
        const n = "color" === t.type, i = e.stops && "object" == typeof e.stops[0][0], r = i || void 0 !== e.property, s = i || !r, o = e.type || (dr(t) ? "exponential" : "interval");
        if (n && ((e = kt({}, e)).stops && (e.stops = e.stops.map((e => [ e[0], on.parse(e[1]) ]))), 
        e.default ? e.default = on.parse(e.default) : e.default = on.parse(t.default)), 
        e.colorSpace && "rgb" !== e.colorSpace && !Ii[e.colorSpace]) throw new Error(`Unknown color space: ${e.colorSpace}`);
        let a, l, h;
        if ("exponential" === o) a = br; else if ("interval" === o) a = vr; else if ("categorical" === o) {
            a = _r, l = Object.create(null);
            for (const t of e.stops) l[t[0]] = t[1];
            h = typeof e.stops[0][0];
        } else {
            if ("identity" !== o) throw new Error(`Unknown function type "${o}"`);
            a = Ar;
        }
        if (i) {
            const n = {}, i = [];
            for (let t = 0; t < e.stops.length; t++) {
                const r = e.stops[t], s = r[0].zoom;
                void 0 === n[s] && (n[s] = {
                    zoom: s,
                    type: e.type,
                    property: e.property,
                    default: e.default,
                    stops: []
                }, i.push(s)), n[s].stops.push([ r[0].value, r[1] ]);
            }
            const r = [];
            for (const e of i) r.push([ n[e].zoom, yr(n[e], t) ]);
            const s = {
                name: "linear"
            };
            return {
                kind: "composite",
                interpolationType: s,
                interpolationFactor: Fi.interpolationFactor.bind(void 0, s),
                zoomStops: r.map((e => e[0])),
                evaluate: ({zoom: n}, i) => br({
                    stops: r,
                    base: e.base
                }, t, n).evaluate(n, i)
            };
        }
        if (s) {
            const n = "exponential" === o ? {
                name: "exponential",
                base: void 0 !== e.base ? e.base : 1
            } : null;
            return {
                kind: "camera",
                interpolationType: n,
                interpolationFactor: Fi.interpolationFactor.bind(void 0, n),
                zoomStops: e.stops.map((e => e[0])),
                evaluate: ({zoom: n}) => a(e, t, n, l, h)
            };
        }
        return {
            kind: "source",
            evaluate(n, i) {
                const r = i && i.properties ? i.properties[e.property] : void 0;
                return void 0 === r ? xr(e.default, t.default) : a(e, t, r, l, h);
            }
        };
    }
    function xr(e, t, n) {
        return void 0 !== e ? e : void 0 !== t ? t : void 0 !== n ? n : void 0;
    }
    function _r(e, t, n, i, r) {
        return xr(typeof n === r ? i[n] : void 0, e.default, t.default);
    }
    function vr(e, t, n) {
        if ("number" !== pr(n)) return xr(e.default, t.default);
        const i = e.stops.length;
        if (1 === i) return e.stops[0][1];
        if (n <= e.stops[0][0]) return e.stops[0][1];
        if (n >= e.stops[i - 1][0]) return e.stops[i - 1][1];
        const r = ri(e.stops.map((e => e[0])), n);
        return e.stops[r][1];
    }
    function br(e, t, n) {
        const i = void 0 !== e.base ? e.base : 1;
        if ("number" !== pr(n)) return xr(e.default, t.default);
        const r = e.stops.length;
        if (1 === r) return e.stops[0][1];
        if (n <= e.stops[0][0]) return e.stops[0][1];
        if (n >= e.stops[r - 1][0]) return e.stops[r - 1][1];
        const s = ri(e.stops.map((e => e[0])), n), o = function(e, t, n, i) {
            const r = i - n, s = e - n;
            return 0 === r ? 0 : 1 === t ? s / r : (Math.pow(t, s) - 1) / (Math.pow(t, r) - 1);
        }(n, i, e.stops[s][0], e.stops[s + 1][0]), a = e.stops[s][1], l = e.stops[s + 1][1];
        let h = ci[t.type] || mr;
        if (e.colorSpace && "rgb" !== e.colorSpace) {
            const t = Ii[e.colorSpace];
            h = (e, n) => t.reverse(t.interpolate(t.forward(e), t.forward(n), o));
        }
        return "function" == typeof a.evaluate ? {
            evaluate(...e) {
                const t = a.evaluate.apply(void 0, e), n = l.evaluate.apply(void 0, e);
                if (void 0 !== t && void 0 !== n) return h(t, n, o);
            }
        } : h(a, l, o);
    }
    function Ar(e, t, n) {
        return "color" === t.type ? n = on.parse(n) : "formatted" === t.type ? n = hn.fromString(n.toString()) : "resolvedImage" === t.type ? n = cn.fromString(n.toString()) : pr(n) === t.type || "enum" === t.type && t.values[n] || (n = void 0), 
        xr(n, e.default, t.default);
    }
    class Tr {
        constructor(e, t) {
            this.expression = e, this._warningHistory = {}, this._evaluator = new Pn, this._defaultValue = t ? function(e) {
                return "color" === e.type && (gr(e.default) || Array.isArray(e.default)) ? new on(0, 0, 0, 0) : "color" === e.type ? on.parse(e.default) || null : void 0 === e.default ? null : e.default;
            }(t) : null, this._enumValues = t && "enum" === t.type ? t.values : null;
        }
        evaluateWithoutErrorHandling(e, t, n, i, r, s, o, a) {
            return this._evaluator.globals = e, this._evaluator.feature = t, this._evaluator.featureState = n, 
            this._evaluator.canonical = i || null, this._evaluator.availableImages = r || null, 
            this._evaluator.formattedSection = s, this._evaluator.featureTileCoord = o || null, 
            this._evaluator.featureDistanceData = a || null, this.expression.evaluate(this._evaluator);
        }
        evaluate(e, t, n, i, r, s, o, a) {
            this._evaluator.globals = e, this._evaluator.feature = t || null, this._evaluator.featureState = n || null, 
            this._evaluator.canonical = i || null, this._evaluator.availableImages = r || null, 
            this._evaluator.formattedSection = s || null, this._evaluator.featureTileCoord = o || null, 
            this._evaluator.featureDistanceData = a || null;
            try {
                const e = this.expression.evaluate(this._evaluator);
                if (null == e || "number" == typeof e && e != e) return this._defaultValue;
                if (this._enumValues && !(e in this._enumValues)) throw new yn(`Expected value to be one of ${Object.keys(this._enumValues).map((e => JSON.stringify(e))).join(", ")}, but found ${JSON.stringify(e)} instead.`);
                return e;
            } catch (e) {
                return this._warningHistory[e.message] || (this._warningHistory[e.message] = !0, 
                "undefined" != typeof console && console.warn(e.message)), this._defaultValue;
            }
        }
    }
    function wr(e) {
        return Array.isArray(e) && e.length > 0 && "string" == typeof e[0] && e[0] in cr;
    }
    function Sr(e, t) {
        const n = new ni(cr, [], t ? function(e) {
            const t = {
                color: Nt,
                string: Ht,
                number: Lt,
                enum: Ht,
                boolean: zt,
                formatted: Gt,
                resolvedImage: jt
            };
            return "array" === e.type ? Wt(t[e.value] || Bt, e.length) : t[e.type];
        }(t) : void 0), i = n.parse(e, void 0, void 0, void 0, t && "string" === t.type ? {
            typeAnnotation: "coerce"
        } : void 0);
        return i ? ur(new Tr(i, t)) : fr(n.errors);
    }
    class Mr {
        constructor(e, t) {
            this.kind = e, this._styleExpression = t, this.isStateDependent = "constant" !== e && !Jn(t.expression);
        }
        evaluateWithoutErrorHandling(e, t, n, i, r, s) {
            return this._styleExpression.evaluateWithoutErrorHandling(e, t, n, i, r, s);
        }
        evaluate(e, t, n, i, r, s) {
            return this._styleExpression.evaluate(e, t, n, i, r, s);
        }
    }
    class Pr {
        constructor(e, t, n, i) {
            this.kind = e, this.zoomStops = n, this._styleExpression = t, this.isStateDependent = "camera" !== e && !Jn(t.expression), 
            this.interpolationType = i;
        }
        evaluateWithoutErrorHandling(e, t, n, i, r, s) {
            return this._styleExpression.evaluateWithoutErrorHandling(e, t, n, i, r, s);
        }
        evaluate(e, t, n, i, r, s) {
            return this._styleExpression.evaluate(e, t, n, i, r, s);
        }
        interpolationFactor(e, t, n) {
            return this.interpolationType ? Fi.interpolationFactor(this.interpolationType, e, t, n) : 0;
        }
    }
    function Ir(e, t) {
        if ("error" === (e = Sr(e, t)).result) return e;
        const n = e.value.expression, i = $n(n);
        if (!i && !function(e) {
            return "data-driven" === e["property-type"];
        }(t)) return fr([ new Ot("", "data expressions not supported") ]);
        const r = Kn(n, [ "zoom", "pitch", "distance-from-center" ]);
        if (!r && !function(e) {
            return !!e.expression && e.expression.parameters.indexOf("zoom") > -1;
        }(t)) return fr([ new Ot("", "zoom expressions not supported") ]);
        const s = kr(n);
        if (!s && !r) return fr([ new Ot("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') ]);
        if (s instanceof Ot) return fr([ s ]);
        if (s instanceof Fi && !dr(t)) return fr([ new Ot("", '"interpolate" expressions cannot be used with this property') ]);
        if (!s) return ur(new Mr(i ? "constant" : "source", e.value));
        const o = s instanceof Fi ? s.interpolation : void 0;
        return ur(new Pr(i ? "camera" : "composite", e.value, s.labels, o));
    }
    class Cr {
        constructor(e, t) {
            this._parameters = e, this._specification = t, kt(this, yr(this._parameters, this._specification));
        }
        static deserialize(e) {
            return new Cr(e._parameters, e._specification);
        }
        static serialize(e) {
            return {
                _parameters: e._parameters,
                _specification: e._specification
            };
        }
    }
    function kr(e) {
        let t = null;
        if (e instanceof Di) t = kr(e.result); else if (e instanceof Ri) {
            for (const n of e.args) if (t = kr(n), t) break;
        } else (e instanceof oi || e instanceof Fi) && e.input instanceof Cn && "zoom" === e.input.name && (t = e);
        return t instanceof Ot || e.eachChild((e => {
            const n = kr(e);
            n instanceof Ot ? t = n : !t && n ? t = new Ot("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : t && n && t !== n && (t = new Ot("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
        })), t;
    }
    function Fr(e) {
        if (Array.isArray(e)) return e.map(Fr);
        if (e instanceof Object && !(e instanceof Number || e instanceof String || e instanceof Boolean)) {
            const t = {};
            for (const n in e) t[n] = Fr(e[n]);
            return t;
        }
        return function(e) {
            return e instanceof Number || e instanceof String || e instanceof Boolean ? e.valueOf() : e;
        }(e);
    }
    function Or(e, t = "fill") {
        if (null == e) return {
            filter: () => !0,
            needGeometry: !1,
            needFeature: !1
        };
        const n = e;
        let i = !0;
        try {
            i = function(e) {
                if (!Dr(e)) return e;
                let t = Fr(e);
                return Er(t), t = Rr(t), t;
            }(n);
        } catch (e) {
            console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(n, null, 2)}\n        `);
        }
        const r = Sr(i, null);
        let s = null;
        if ("error" === r.result) throw new Error(r.value.map((e => `${e.key}: ${e.message}`)).join(", "));
        s = (e, t, n) => r.value.evaluate(e, t, {}, n);
        let o = null, a = null;
        if (i !== n) {
            const e = Sr(n, null);
            if ("error" === e.result) throw new Error(e.value.map((e => `${e.key}: ${e.message}`)).join(", "));
            o = (t, n, i, r, s) => e.value.evaluate(t, n, {}, i, void 0, void 0, r, s), a = !$n(e.value.expression);
        }
        return {
            filter: s,
            dynamicFilter: o || void 0,
            needGeometry: Hr(i),
            needFeature: !!a
        };
    }
    function Rr(e) {
        if (!Array.isArray(e)) return e;
        const t = function(e) {
            if (Lr.has(e[0])) for (let t = 1; t < e.length; t++) if (Dr(e[t])) return !0;
            return e;
        }(e);
        return !0 === t ? t : t.map((e => Rr(e)));
    }
    function Er(e) {
        let t = !1;
        const n = [];
        if ("case" === e[0]) {
            for (let i = 1; i < e.length - 1; i += 2) t = t || Dr(e[i]), n.push(e[i + 1]);
            n.push(e[e.length - 1]);
        } else if ("match" === e[0]) {
            t = t || Dr(e[1]);
            for (let t = 2; t < e.length - 1; t += 2) n.push(e[t + 1]);
            n.push(e[e.length - 1]);
        } else if ("step" === e[0]) {
            t = t || Dr(e[1]);
            for (let t = 1; t < e.length - 1; t += 2) n.push(e[t + 1]);
        }
        t && (e.length = 0, e.push("any", ...n));
        for (let t = 1; t < e.length; t++) Er(e[t]);
    }
    function Dr(e) {
        if (!Array.isArray(e)) return !1;
        if (function(e) {
            return "pitch" === e || "distance-from-center" === e;
        }(e[0])) return !0;
        for (let t = 1; t < e.length; t++) if (Dr(e[t])) return !0;
        return !1;
    }
    const Lr = new Set([ "in", "==", "!=", ">", ">=", "<", "<=", "to-boolean" ]);
    function Hr(e) {
        if (!Array.isArray(e)) return !1;
        if ("within" === e[0]) return !0;
        for (let t = 1; t < e.length; t++) if (Hr(e[t])) return !0;
        return !1;
    }
    const zr = {
        StyleExpression: Tr,
        isExpression: wr,
        isExpressionFilter: function e(t) {
            if (!0 === t || !1 === t) return !0;
            if (!Array.isArray(t) || 0 === t.length) return !1;
            switch (t[0]) {
              case "has":
                return t.length >= 2 && "$id" !== t[1] && "$type" !== t[1];

              case "in":
                return t.length >= 3 && ("string" != typeof t[1] || Array.isArray(t[2]));

              case "!in":
              case "!has":
              case "none":
                return !1;

              case "==":
              case "!=":
              case ">":
              case ">=":
              case "<":
              case "<=":
                return 3 !== t.length || Array.isArray(t[1]) || Array.isArray(t[2]);

              case "any":
              case "all":
                for (const n of t.slice(1)) if (!e(n) && "boolean" != typeof n) return !1;
                return !0;

              default:
                return !0;
            }
        },
        createExpression: Sr,
        createPropertyExpression: Ir,
        normalizePropertyExpression: function(e, t) {
            if (gr(e)) return new Cr(e, t);
            if (wr(e)) {
                const n = Ir(e, t);
                if ("error" === n.result) throw new Error(n.value.map((e => `${e.key}: ${e.message}`)).join(", "));
                return n.value;
            }
            {
                let n = e;
                return "string" == typeof e && "color" === t.type && (n = on.parse(e)), {
                    kind: "constant",
                    evaluate: () => n
                };
            }
        },
        ZoomConstantExpression: Mr,
        ZoomDependentExpression: Pr,
        StylePropertyFunction: Cr
    }, {isExpression: Nr, createExpression: Vr} = zr, Br = {};
    function Ur(e) {
        if (!Array.isArray(e)) return Ur([ e ]);
        const t = [];
        for (let n = 0; n < e.length; n++) {
            let i;
            i = !0 === e[n].filter ? function() {
                return !0;
            } : Gr(e[n].filter), t.push($e({}, e[n], {
                filter: i
            }));
        }
        return t;
    }
    function Gr(e) {
        if (!0 === e) return function() {
            return !0;
        };
        if (e && e.condition) {
            if ("any" === e.type) {
                const t = e.condition, n = [];
                for (let e = 0; e < t.length; e++) n.push(Gr(t[e]));
                return (e, t) => {
                    for (let i = 0; i < n.length; i++) if (n[i](e, t)) return !0;
                    return !1;
                };
            }
            const t = Gr(e.condition);
            if (Je(e.layer)) return t;
            const n = t => t.layer === e.layer;
            return (e, i) => n(e) && t(e, i);
        }
        if (xt(e)) return new Function("f", `var p = (f && f.properties || {}); return ${_t(e)}`);
        {
            let t = Or(e);
            t = t && t.filter;
            const n = (e, n) => (Br.zoom = n, t && t(Br, e));
            return n;
        }
    }
    const jr = {
        type: "number",
        "property-type": "data-driven",
        expression: {
            parameters: [ "zoom", "feature" ]
        }
    };
    function Wr(e, t) {
        jr.type = t || "number";
        const n = Vr(e, jr);
        if ("success" !== n.result) throw new Error(`Invalid maplibre spec expression: ${JSON.stringify(e)} (${n.value})`);
        return n.value;
    }
    function Xr(e) {
        return Nr(e);
    }
    const Yr = {
        lineWidth: 1,
        lineStrokeWidth: 1,
        lineDx: 1,
        lineDy: 1,
        lineOpacity: 1,
        linePatternAnimSpeed: 1,
        markerWidth: 1,
        markerHeight: 1,
        markerDx: 1,
        markerDy: 1,
        markerSpacing: 1,
        markerOpacity: 1,
        markerRotation: 1,
        textWrapWidth: 1,
        textSpacing: 1,
        textSize: 1,
        textHaloRadius: 1,
        textHaloOpacity: 1,
        textDx: 1,
        textDy: 1,
        textOpacity: 1,
        textRotation: 1,
        polygonOpacity: 1
    };
    function qr(e) {
        return Yr[e];
    }
    const Zr = {
        markerPlacement: 1,
        markerFile: 1,
        mergeOnProperty: 1,
        markerTextFit: 1,
        markerType: 1,
        markerHorizontalAlignment: 1,
        markerVerticalAlignment: 1,
        markerRotationAlignment: 1,
        markerPitchAlignment: 1,
        markerFillPatternFile: 1,
        markerLinePatternFile: 1,
        textName: 1,
        textPlacement: 1,
        textFaceName: 1,
        textStyle: 1,
        textHorizontalAlignment: 1,
        textVerticalAlignment: 1,
        textRotationAlignment: 1,
        textPitchAlignment: 1,
        lineJoin: 1,
        lineCap: 1,
        linePatternFile: 1,
        polygonPatternFile: 1
    }, $r = {
        lineDasharray: 1,
        markerLineDasharray: 1,
        uvScale: 1,
        uvOffset: 1
    };
    function Jr(e) {
        return Zr[e] ? "string" : qr(e) ? "number" : $r[e] ? "array" : "color";
    }
    var Kr = Object.freeze({
        __proto__: null,
        compileFilter: Gr,
        compileStyle: function(e = []) {
            return Ur(e = e.map((e => {
                const t = $e({}, e);
                return t.filter && t.filter.value && (t.filter = t.filter.value), t;
            })));
        },
        createExpression: Wr,
        getExpressionType: Jr,
        isExpression: Xr,
        isInterpolated: qr
    });
    const Qr = "undefined" != typeof WorkerGlobalScope && self instanceof WorkerGlobalScope, es = function(e) {
        return class extends e {
            pushIn(...e) {
                const t = e.length;
                for (let n = 0; n < t; n++) this[this.currentIndex++] = e[n];
            }
            fill(e, t, n) {
                super.fill(e, t, n), n > this.currentIndex && (this.currentIndex = n);
            }
            set(e, t) {
                e >= this.currentIndex && (this.currentIndex = e + 1), this[e] = t;
            }
            getLength() {
                return this.currentIndex;
            }
            setLength(e) {
                this.currentIndex = e, super.length < e && (super.length = e);
            }
            trySetLength(e) {
                e > this.currentIndex && this.setLength(e);
            }
            reset() {
                this.currentIndex = 0;
            }
            slice(e, t) {
                const n = super.slice(e, t);
                return n.currentIndex = t - e, n;
            }
        };
    }, ts = es(Array), ns = {
        get: function(e, t) {
            return "length" === t ? e.getLength() : e[t];
        }
    };
    class is extends Array {
        setLength(e) {
            this.length = e, this.currentIndex = e;
        }
        trySetLength(e) {
            this.length = e, this.currentIndex = e;
        }
        getLength() {
            return this.length;
        }
    }
    let rs;
    class ss {
        static createTypedArray(e, t) {
            return H(e, t);
        }
        static getInstance() {
            return rs;
        }
        static ensureCapacity(e, t) {
            if (!e.BYTES_PER_ELEMENT) return e;
            if (e.length >= t) return e;
            const n = new e.constructor(t + Math.ceil(.5 * t)), i = e.getLength();
            for (let t = 0; t < i; t++) n[t] = e[t];
            return n.currentIndex = e.currentIndex, n;
        }
        static getArray(e) {
            let t;
            if (e) {
                const n = es(e), i = 1048576 / n.BYTES_PER_ELEMENT;
                t = new n(i);
            } else t = new ts;
            return t.push = (...e) => {
                t.pushIn(...e);
            }, t;
        }
        static getProxyArray() {
            const e = new ts, t = new Proxy(e, ns);
            return t.push = (...t) => {
                e.pushIn(...t);
            }, t._origin = e, t;
        }
        constructor() {
            this._arrays = [], this._index = 0, this._proxiedArrays = [], this._proxiedIndex = 0, 
            this._typedArrays = {};
        }
        getProxy() {
            if (!Qr) {
                const e = new is;
                return e.currentIndex = 0, e;
            }
            const e = this._proxiedArrays[this._proxiedIndex] = this._proxiedArrays[this._proxiedIndex] || ss.getProxyArray();
            return e.reset(), this._proxiedIndex++, e;
        }
        get(e) {
            if (!Qr) {
                const e = new is;
                return e.currentIndex = 0, e;
            }
            if (e) {
                const t = e.name;
                let n = this._typedArrays[t];
                n || (n = this._typedArrays[t] = {
                    arrays: [],
                    index: 0
                });
                const i = n.index, r = n.arrays[i] = n.arrays[i] || ss.getArray(e);
                return r.reset(), n.index++, r;
            }
            const t = this._arrays[this._index] = this._arrays[this._index] || ss.getArray();
            return t.reset(), this._index++, t;
        }
        reset() {
            this._index = 0, this._proxiedIndex = 0;
            for (const e in this._typedArrays) this._typedArrays[e].index = 0;
        }
    }
    rs = new ss;
    const os = "__fea_idx", as = [], ls = {}, hs = {}, cs = {}, us = [], fs = ss.getInstance();
    let ds = !1;
    const ps = Math.pow(2, 17);
    class gs {
        static isAtlasLoaded(e, t = {}) {
            const {iconAtlas: n} = t;
            return !!(!e || n && n.positions[e]);
        }
        static genFnTypes(e) {
            const t = {};
            for (const n in e) if (Xr(e[n])) {
                const i = (n + "_Fn_0").trim(), r = (n + "Fn").trim(), s = Jr(n);
                t[i] = Wr(e[n], s), t[r] = (e, n) => {
                    let r;
                    ls.zoom = e, hs.properties = n;
                    try {
                        r = t[i].evaluateWithoutErrorHandling(ls, hs, cs, null, us);
                    } catch (e) {
                        return null;
                    }
                    return r;
                };
            } else if (st(e[n])) {
                const i = (n + "_Fn_0").trim(), r = (n + "Fn").trim();
                qr(n) ? (t[i] = re(e[n]), t[r] = (e, n) => {
                    const r = t[i](e, n);
                    return st(r) ? re(r)(e, n) : r;
                }) : (t[i] = se(e[n]), t[r] = (e, n) => {
                    const r = t[i](e, n);
                    return st(r) ? se(r)(e, n) : r;
                });
            }
            return t;
        }
        constructor(e, t, n) {
            this.options = n;
            const i = [];
            this.symbolDef = t, this.symbol = oe(t, (() => (i[0] = n.zoom, i))), this.styledVectors = [], 
            this.properties = {}, this._fnTypes = n.fnTypes || gs.genFnTypes(this.symbolDef), 
            st(this.symbolDef.visible) && (this._visibleFn = re(this.symbolDef.visible)), n.atlas && (this.iconAtlas = n.atlas.iconAtlas, 
            this.glyphAtlas = n.atlas.glyphAtlas), this.maxAltitude = 0, this.features = this._check(e);
        }
        needAltitudeAttribute() {
            const e = Math.max(Math.abs(this.maxPosZ), Math.abs(this.minPosZ));
            return this.options.forceAltitudeAttribute || e >= ps || this.options.positionType === Float32Array;
        }
        getPositionFormat() {
            return this.needAltitudeAttribute() ? [ {
                type: Int16Array,
                width: 2,
                name: "aPosition"
            }, {
                type: Float32Array,
                width: 1,
                name: "aAltitude"
            } ] : [ {
                type: Float32Array,
                width: 3,
                name: "aPosition"
            } ];
        }
        fillPosition(e, t, n, i) {
            if (t < this._minX && (this._minX = t), t > this._maxX && (this._maxX = t), n < this._minY && (this._minY = n), 
            n > this._maxY && (this._maxY = n), this.needAltitudeAttribute()) {
                let r = e.aPosition.currentIndex;
                e.aPosition[r++] = t, e.aPosition[r++] = n, e.aPosition.currentIndex = r, r = e.aAltitude.currentIndex, 
                e.aAltitude[r++] = i, e.aAltitude.currentIndex = r;
            } else {
                pt(as, t, n, i);
                let r = e.aPosition.currentIndex;
                e.aPosition[r++] = as[0], e.aPosition[r++] = as[1], e.aPosition[r++] = as[2], e.aPosition.currentIndex = r;
            }
        }
        _check(e) {
            if (!e.length) return e;
            const t = (os + "").trim();
            let n, i = 0, r = e[i];
            for (;!r.geometry; ) i++, r = e[i];
            if (Array.isArray(r.geometry) && r.properties) {
                let t = r.geometry[0];
                for (;Array.isArray(t); ) t = t[0];
                t && !Je(t.x) && (n = e);
            }
            if (!n) if (n = [], Array.isArray(r.geometry)) for (let t = 0; t < e.length; t++) {
                const i = $e({}, e[t]);
                n.push(z(i));
            } else for (let i = 0; i < e.length; i++) {
                const r = e[i], s = a(r);
                for (let e = 0; e < s.length; e++) {
                    const i = s[e];
                    i[t] = r[t], n.push(i);
                }
            }
            if (this.options.altitudeProperty) for (let e = 0; e < n.length; e++) {
                const t = n[e];
                if (!t || !t.geometry || 1 !== t.type && 4 !== t.type) continue;
                const i = this.getAltitude(t.properties);
                if (i) for (let e = 0; e < t.geometry.length; e++) {
                    const n = t.geometry[e];
                    if (n && n.length) for (let e = 0; e < n.length; e++) n[e].z = (n[e].z || 0) + i;
                }
            }
            if (this.maxPosZ = 0, this.minPosZ = 0, !this.options.forceAltitudeAttribute) {
                const e = "line" === this.symbolDef.textPlacement;
                let t = -1 / 0, i = 1 / 0, r = !1;
                const {textPitchAlignmentFn: s} = this._fnTypes;
                !s && e && "map" === this.symbolDef.textPitchAlignment && (r = !0);
                const o = [];
                for (let a = 0; a < n.length; a++) {
                    const [l, h] = ys(o, n[a] && n[a].geometry);
                    if (h > t && (t = h), l < i && (i = l), e && !r && s && n[a].properties) {
                        const e = s(null, n[a].properties);
                        "map" === e && (r = e);
                    }
                }
                this.hasMapPitchAlign = r, this.maxPosZ = t === -1 / 0 ? 0 : t, this.minPosZ = i === 1 / 0 ? 0 : i;
            }
            const s = this.options.order;
            if (s) {
                const e = [];
                for (let t = 0; t < s.length; t++) s[t] && e.push(Gr(s[t]));
                n = n.sort(((t, n) => {
                    const i = e.length;
                    let r = -1, s = -1;
                    for (let o = 0; o < i && (e[o](t) && (r = o), e[o](n) && (s = o), !(r >= 0 && r < i && s >= 0 && s < i)); o++) ;
                    return r - s;
                }));
            }
            return n;
        }
        load(e = 1) {
            const t = (os + "").trim(), n = "_debug_info".trim(), i = this._fnTypes, r = this.styledVectors;
            this.count = 0;
            const s = this.features;
            if (!s || !s.length) return Promise.resolve(null);
            const o = {}, a = {}, l = {
                zoom: this.options.zoom,
                isVector3D: !!this.options.center,
                defaultMarkerVerticalAlignment: this.options.defaultMarkerVerticalAlignment
            }, h = [], c = oe(this.symbolDef, (() => (h[0] = l.zoom, h)));
            let u = 0, f = s.length;
            const d = this.options.debugIndex;
            try {
                for (;u < f; u++) {
                    const e = s[u];
                    if (!e || !e.geometry) continue;
                    if (Ke(d) && e[n].index !== d) continue;
                    e.properties || (e.properties = {}), e.properties.$layer = e.layer, e.properties.$type = e.type;
                    const h = this.createStyledVector(e, c, i, l, o, a);
                    h && h.feature.geometry && (h.featureIdx = void 0 === e[t] ? u : e[t], this.count++, 
                    r.push(h));
                }
            } catch (e) {
                return Promise.reject(e);
            }
            return this.options.atlas ? Promise.resolve(this.pack(e)) : this.loadAtlas(o, a).then((() => this.pack(e)));
        }
        loadAtlas(e, t) {
            return new Promise(((n, i) => {
                this.fetchAtlas(e, t, ((e, t) => {
                    if (e) i(e); else {
                        if (t) {
                            const {icons: e, glyphs: n} = t;
                            if (e && Object.keys(e).length) {
                                for (const t in e) {
                                    const n = e[t], {width: i, height: r, data: s} = n.data;
                                    n.data = new v({
                                        width: i,
                                        height: r
                                    }, s);
                                }
                                this.iconAtlas = new F(e, {
                                    nonPowerOfTwo: !this.options.isWebGL1
                                });
                            }
                            if (n && Object.keys(n).length) {
                                for (const e in n) {
                                    const t = n[e];
                                    for (const e in t) {
                                        const n = t[e], {width: i, height: r, data: s} = n.bitmap;
                                        n.bitmap = new _({
                                            width: i,
                                            height: r
                                        }, s);
                                    }
                                }
                                this.glyphAtlas = new R(n);
                            }
                        }
                        n({
                            glyphAtlas: this.glyphAtlas,
                            iconAtlas: this.iconAtlas
                        });
                    }
                }));
            }));
        }
        fetchAtlas(e, t, n) {
            Object.keys(e).length > 0 || Object.keys(t).length > 0 ? this.options.requestor(e, t, n) : n();
        }
        pack(e) {
            if (!this.count) return null;
            if (null == e) throw new Error("layout scale is undefined");
            const t = this.createDataPack(this.styledVectors, e);
            if (!t) return null;
            this.properties.minAltitude = this.minPosZ / 100, this.properties.maxAltitude = this.maxPosZ / 100, 
            t.properties = this.properties, this.empty && (t.empty = !0);
            const n = t.buffers;
            delete t.buffers;
            const i = {
                data: t,
                buffers: n
            };
            if (this.iconAtlas) {
                const e = i.data.iconAtlas = ms(this.iconAtlas);
                if (e.glyphMap) for (const t in e.glyphMap) {
                    const i = e.glyphMap[t];
                    n.push(i.data.data.buffer);
                }
                n.push(i.data.iconAtlas.image.data.buffer);
            }
            return this.glyphAtlas && (i.data.glyphAtlas = ms(this.glyphAtlas), n.push(i.data.glyphAtlas.image.data.buffer)), 
            i;
        }
        createStyledVector(e, t, n, i) {
            return new dt(e, t, n, i);
        }
        createDataPack(e, t) {
            if (!e || !e.length) return null;
            this.maxIndex = 0, this.maxPos = 0, this._minX = this._minY = 1 / 0, this._maxX = this._maxY = -1 / 0, 
            this.dynamicAttrs = {};
            const n = this.data = {};
            this._arrayPool = fs, fs.reset();
            let i = this.elements = fs.get();
            const r = this._dataFormat = this.getFormat(Array.isArray(e[0]) ? e[0][0].symbol : e[0].symbol), s = this.needAltitudeAttribute() ? 2 : 3;
            for (let e = 0; e < r.length; e++) n[r[e].name] = fs.get(r[e].type);
            let o = fs.get(), a = 0;
            const l = fs.get();
            let h = 0, c = !1, u = !0;
            const f = new Set;
            for (let i = 0, r = e.length; i < r; i++) {
                if (!e[i].feature.geometry) continue;
                const r = Array.isArray(e[i]) ? e[i][0].feature.id : e[i].feature.id;
                u && (void 0 !== hs.id ? f && (f.has(hs.id) ? u = !1 : f.add(hs.id)) : u = !1), 
                Ke(r) && (Math.abs(r) > h && (h = Math.abs(r)), r < 0 && (c = !0));
                const d = this.data.aPosition.getLength();
                if (Array.isArray(e[i])) for (let n = 0; n < e[i].length; n++) this._placeVector(e[i][n], t); else this._placeVector(e[i], t);
                const p = (n.aPosition.getLength() - d) / s;
                for (let t = 0; t < p; t++) o.push(e[i].featureIdx), Ke(r) && l.push(r);
                a = Math.max(a, e[i].featureIdx);
            }
            if (this.countOutOfAngle > 0 && !ds && (ds = !0, console.warn("text anchor along line is ignored as anchor's line angle is bigger than textMaxAngle.")), 
            this.hasElements() && !i.getLength()) return null;
            o = ss.createTypedArray(o, Float32Array), this.options.positionType ? r[0].type = this.options.positionType : r[0].type = D(this.maxPos);
            const d = this.options.center;
            if (d && (d[0] || d[1])) {
                const e = n.aPosition, t = e.getLength();
                for (let n = 0; n < t; n += s) e[n] -= d[0], e[n + 1] -= d[1];
            }
            const p = function(e, t) {
                const n = {};
                for (let i = 0; i < e.length; i++) {
                    const r = e[i], s = r.type, o = r.name;
                    n[o] = s === Array ? t[o] : H(t[o], s);
                }
                return n;
            }(r, n);
            p.aPickingId = o;
            const g = [];
            for (const e in p) g.push(p[e].buffer);
            const m = E(this.maxIndex);
            i = ss.createTypedArray(i, m), g.push(i.buffer);
            const y = {
                data: p,
                isIdUnique: u,
                is2D: 0 === this.maxPosZ && 0 === this.minPosZ,
                indices: this.hasElements() ? i : null,
                positionSize: s,
                positionBounding: [ this._minX, this._minY, this._maxX, this._maxY ],
                buffers: g,
                symbolIndex: this.symbolDef.index || {
                    index: 0
                },
                dynamicAttributes: this.dynamicAttrs
            };
            if (this._packMarkerPlacement && (y.markerPlacement = this._packMarkerPlacement), 
            this._packTextPlacement && (y.textPlacement = this._packTextPlacement), l.getLength()) {
                const e = c ? D(h) : L(h);
                y.featureIds = ss.createTypedArray(l, e), g.push(y.featureIds.buffer);
            } else y.featureIds = [];
            return y.pickingIdIndiceMap = I(o, y.indices), y;
        }
        _placeVector(e, t) {
            const n = e.feature.properties;
            this._visibleFn && !this._visibleFn(this.options.zoom, n) || this.placeVector(e, t, this.formatWidth);
        }
        addElements(e, t, n) {
            this.maxIndex = Math.max(this.maxIndex, e, t, n);
            let i = this.elements.currentIndex;
            this.elements[i++] = e, this.elements[i++] = t, this.elements[i++] = n, this.elements.currentIndex = i;
        }
        hasElements() {
            return !0;
        }
        getAltitude(e) {
            const {altitudeProperty: t, defaultAltitude: n, altitudeScale: i} = this.options;
            let r = T(e, t, n);
            return i && (r *= i), this.maxAltitude = Math.max(this.maxAltitude, Math.abs(r)), 
            r;
        }
        getIconAtlasMaxValue() {
            const e = this.iconAtlas.positions;
            let t = 0;
            for (const n in e) if (it(e, n)) {
                const {tl: i, displaySize: r} = e[n], s = Math.max(i[0], i[1], r[0] - 1, r[1] - 1);
                s > t && (t = s);
            }
            return t;
        }
        ensureDataCapacity(e, t) {
            const n = this._dataFormat;
            for (let i = 0; i < n.length; i++) {
                const r = this.data[n[i].name];
                if (!r) continue;
                const s = n[i].width * e, o = r.getLength();
                this.data[n[i].name] = ss.ensureCapacity(r, o + s * t);
            }
        }
    }
    function ms(e) {
        let t = e.positions, n = e.image && e.image.format || "alpha";
        if (e instanceof F) {
            t = {};
            for (const n in e.positions) {
                const i = e.positions[n];
                t[n] = {
                    paddedRect: i.paddedRect,
                    pixelRatio: i.pixelRatio,
                    tl: i.tl,
                    br: i.br,
                    displaySize: i.displaySize
                };
            }
            n = "rgba";
        }
        const i = e.image;
        return {
            image: {
                width: i.width,
                height: i.height,
                data: i.data,
                format: n
            },
            glyphMap: e.glyphMap,
            positions: t
        };
    }
    function ys(e, t) {
        if (!t) return 0;
        let n = -1 / 0, i = 1 / 0;
        const r = [];
        if (Array.isArray(t)) for (let e = 0; e < t.length; e++) if (Array.isArray(t[e])) {
            const [s, o] = ys(r, t[e]);
            o > n && (n = o), s < i && (i = s);
        } else {
            const r = Math.abs(t[e].z || 0);
            r > n && (n = r), r < i && (i = r);
        } else {
            const e = Math.abs(t.z || 0);
            e > n && (n = e), e < i && (i = e);
        }
        return e[0] = i, e[1] = n, e;
    }
    const xs = "___fn_in_stops";
    function _s(e, t, n, i) {
        const r = "__fn_textSize".trim();
        let s = e.textSize;
        if (Je(t.textSize)) return [ 16, 16 ];
        e[r] && (s = e[r]);
        const o = [];
        if (tt(s) ? o[0] = s(i, n) : o[0] = s, ie(o[0])) {
            const t = o[0].__fn_key = o[0].__fn_key || JSON.stringify(o[0]);
            e[xs] || (e[xs] = {}), e[xs][t] || (e[xs][t] = re(o[0]));
            const r = e[xs][t];
            o[0] = r(i, n);
        }
        return o[1] = o[0], o;
    }
    function vs(e) {
        const t = e.stops;
        let n = -1 / 0;
        for (let e = 0; e < t.length; e++) {
            let i = t[e][1];
            Qe(t[e][1]) && (i = vs(t[e][1])), i > n && (n = i);
        }
        return n;
    }
    const bs = [ "{", "}" ], As = "";
    function Ts(e) {
        return e || "Open Sans Regular";
    }
    const ws = /\{[\w-]+(?:\|[\w-]+)*\}/g;
    function Ss(e, t) {
        if (!et(e)) return e;
        function n(e) {
            if (!t) return As;
            const n = t[e];
            return Je(n) ? As : Array.isArray(n) ? n.join() : n;
        }
        const [i, r] = bs, s = Ms(e);
        for (let t = 0, o = s.length; t < o; t++) {
            const o = s[t], a = `${i}${o}${r}`;
            if (o.indexOf("|") > 0) {
                const t = o.split("|");
                let i = !1;
                for (let r = 0; r < t.length; r++) {
                    const s = n(t[r]);
                    if (s !== As) {
                        e = Ps(e, a, s), i = !0;
                        break;
                    }
                }
                i || (e = Ps(e, a, As));
            } else e = Ps(e, a, n(o));
        }
        return e;
    }
    function Ms(e) {
        e += As;
        const [t, n] = bs, i = [];
        let r = !1, s = As;
        for (let o = 0, a = e.length; o < a; o++) {
            const a = e[o];
            r || a !== t || (r = !0), a === t && r && (s = As), r && a !== t && a !== n && (s += a), 
            a === n && s && (r = !1, i.push(s), s = As);
        }
        return i;
    }
    function Ps(e, t, n) {
        if (!e) return e;
        if (e.replaceAll) return e.replaceAll(t, n);
        for (;e.indexOf(t) > -1; ) e = e.replace(t, n);
        return e;
    }
    var Is = Object.freeze({
        __proto__: null,
        EMPTY_STRING: As,
        getSDFFont: Ts,
        replaceAll: Ps,
        resolveExpVarNames: function e(t, n) {
            if (2 !== n.length || "get" !== n[0]) for (let i = 0; i < n.length; i++) 2 === n[i].length && "get" === n[i][0] ? t.push(n[i][1]) : Array.isArray(n[i]) && e(t, n[i]); else t.push(n[1]);
        },
        resolveText: Ss,
        resolveText_bak: function(e, t) {
            return et(e) ? e.replace(ws, (function(e) {
                if (!t) return "";
                if ((e = e.substring(1, e.length - 1)).indexOf("|") > 0) {
                    const n = e.split("|");
                    for (let e = 0; e < n.length; e++) {
                        const i = t[n[e]];
                        if (!Je(i)) return i;
                    }
                    return "";
                }
                const n = t[e];
                return Je(n) ? "" : Array.isArray(n) ? n.join() : n;
            })) : e;
        },
        resolveVarNames: function(e) {
            return e.match(ws);
        },
        templateKeys: Ms
    });
    const Cs = {
        "Latin-1 Supplement": e => e >= 128 && e <= 255,
        Arabic: e => e >= 1536 && e <= 1791,
        "Arabic Supplement": e => e >= 1872 && e <= 1919,
        "Arabic Extended-A": e => e >= 2208 && e <= 2303,
        "Hangul Jamo": e => e >= 4352 && e <= 4607,
        "Unified Canadian Aboriginal Syllabics": e => e >= 5120 && e <= 5759,
        Khmer: e => e >= 6016 && e <= 6143,
        "Unified Canadian Aboriginal Syllabics Extended": e => e >= 6320 && e <= 6399,
        "General Punctuation": e => e >= 8192 && e <= 8303,
        "Letterlike Symbols": e => e >= 8448 && e <= 8527,
        "Number Forms": e => e >= 8528 && e <= 8591,
        "Miscellaneous Technical": e => e >= 8960 && e <= 9215,
        "Control Pictures": e => e >= 9216 && e <= 9279,
        "Optical Character Recognition": e => e >= 9280 && e <= 9311,
        "Enclosed Alphanumerics": e => e >= 9312 && e <= 9471,
        "Geometric Shapes": e => e >= 9632 && e <= 9727,
        "Miscellaneous Symbols": e => e >= 9728 && e <= 9983,
        "Miscellaneous Symbols and Arrows": e => e >= 11008 && e <= 11263,
        "CJK Radicals Supplement": e => e >= 11904 && e <= 12031,
        "Kangxi Radicals": e => e >= 12032 && e <= 12255,
        "Ideographic Description Characters": e => e >= 12272 && e <= 12287,
        "CJK Symbols and Punctuation": e => e >= 12288 && e <= 12351,
        Hiragana: e => e >= 12352 && e <= 12447,
        Katakana: e => e >= 12448 && e <= 12543,
        Bopomofo: e => e >= 12544 && e <= 12591,
        "Hangul Compatibility Jamo": e => e >= 12592 && e <= 12687,
        Kanbun: e => e >= 12688 && e <= 12703,
        "Bopomofo Extended": e => e >= 12704 && e <= 12735,
        "CJK Strokes": e => e >= 12736 && e <= 12783,
        "Katakana Phonetic Extensions": e => e >= 12784 && e <= 12799,
        "Enclosed CJK Letters and Months": e => e >= 12800 && e <= 13055,
        "CJK Compatibility": e => e >= 13056 && e <= 13311,
        "CJK Unified Ideographs Extension A": e => e >= 13312 && e <= 19903,
        "Yijing Hexagram Symbols": e => e >= 19904 && e <= 19967,
        "CJK Unified Ideographs": e => e >= 19968 && e <= 40959,
        "Yi Syllables": e => e >= 40960 && e <= 42127,
        "Yi Radicals": e => e >= 42128 && e <= 42191,
        "Hangul Jamo Extended-A": e => e >= 43360 && e <= 43391,
        "Hangul Syllables": e => e >= 44032 && e <= 55215,
        "Hangul Jamo Extended-B": e => e >= 55216 && e <= 55295,
        "Private Use Area": e => e >= 57344 && e <= 63743,
        "CJK Compatibility Ideographs": e => e >= 63744 && e <= 64255,
        "Arabic Presentation Forms-A": e => e >= 64336 && e <= 65023,
        "Vertical Forms": e => e >= 65040 && e <= 65055,
        "CJK Compatibility Forms": e => e >= 65072 && e <= 65103,
        "Small Form Variants": e => e >= 65104 && e <= 65135,
        "Arabic Presentation Forms-B": e => e >= 65136 && e <= 65279,
        "Halfwidth and Fullwidth Forms": e => e >= 65280 && e <= 65519
    };
    function ks(e) {
        return !(Cs.Arabic(e) || Cs["Arabic Supplement"](e) || Cs["Arabic Extended-A"](e) || Cs["Arabic Presentation Forms-A"](e) || Cs["Arabic Presentation Forms-B"](e));
    }
    function Fs(e) {
        return !!(!(e < 11904) && (Cs["Bopomofo Extended"](e) || Cs.Bopomofo(e) || Cs["CJK Compatibility Forms"](e) || Cs["CJK Compatibility Ideographs"](e) || Cs["CJK Compatibility"](e) || Cs["CJK Radicals Supplement"](e) || Cs["CJK Strokes"](e) || Cs["CJK Symbols and Punctuation"](e) || Cs["CJK Unified Ideographs Extension A"](e) || Cs["CJK Unified Ideographs"](e) || Cs["Enclosed CJK Letters and Months"](e) || Cs["Halfwidth and Fullwidth Forms"](e) || Cs.Hiragana(e) || Cs["Ideographic Description Characters"](e) || Cs["Kangxi Radicals"](e) || Cs["Katakana Phonetic Extensions"](e) || Cs.Katakana(e) || Cs["Vertical Forms"](e) || Cs["Yi Radicals"](e) || Cs["Yi Syllables"](e)));
    }
    function Os(e) {
        return !!(746 === e || 747 === e || !(e < 4352) && (Cs["Bopomofo Extended"](e) || Cs.Bopomofo(e) || Cs["CJK Compatibility Forms"](e) && !(e >= 65097 && e <= 65103) || Cs["CJK Compatibility Ideographs"](e) || Cs["CJK Compatibility"](e) || Cs["CJK Radicals Supplement"](e) || Cs["CJK Strokes"](e) || !(!Cs["CJK Symbols and Punctuation"](e) || e >= 12296 && e <= 12305 || e >= 12308 && e <= 12319 || 12336 === e) || Cs["CJK Unified Ideographs Extension A"](e) || Cs["CJK Unified Ideographs"](e) || Cs["Enclosed CJK Letters and Months"](e) || Cs["Hangul Compatibility Jamo"](e) || Cs["Hangul Jamo Extended-A"](e) || Cs["Hangul Jamo Extended-B"](e) || Cs["Hangul Jamo"](e) || Cs["Hangul Syllables"](e) || Cs.Hiragana(e) || Cs["Ideographic Description Characters"](e) || Cs.Kanbun(e) || Cs["Kangxi Radicals"](e) || Cs["Katakana Phonetic Extensions"](e) || Cs.Katakana(e) && 12540 !== e || !(!Cs["Halfwidth and Fullwidth Forms"](e) || 65288 === e || 65289 === e || 65293 === e || e >= 65306 && e <= 65310 || 65339 === e || 65341 === e || 65343 === e || e >= 65371 && e <= 65503 || 65507 === e || e >= 65512 && e <= 65519) || !(!Cs["Small Form Variants"](e) || e >= 65112 && e <= 65118 || e >= 65123 && e <= 65126) || Cs["Unified Canadian Aboriginal Syllabics"](e) || Cs["Unified Canadian Aboriginal Syllabics Extended"](e) || Cs["Vertical Forms"](e) || Cs["Yijing Hexagram Symbols"](e) || Cs["Yi Syllables"](e) || Cs["Yi Radicals"](e)));
    }
    function Rs(e) {
        return !(Os(e) || function(e) {
            return !!(Cs["Latin-1 Supplement"](e) && (167 === e || 169 === e || 174 === e || 177 === e || 188 === e || 189 === e || 190 === e || 215 === e || 247 === e) || Cs["General Punctuation"](e) && (8214 === e || 8224 === e || 8225 === e || 8240 === e || 8241 === e || 8251 === e || 8252 === e || 8258 === e || 8263 === e || 8264 === e || 8265 === e || 8273 === e) || Cs["Letterlike Symbols"](e) || Cs["Number Forms"](e) || Cs["Miscellaneous Technical"](e) && (e >= 8960 && e <= 8967 || e >= 8972 && e <= 8991 || e >= 8996 && e <= 9e3 || 9003 === e || e >= 9085 && e <= 9114 || e >= 9150 && e <= 9165 || 9167 === e || e >= 9169 && e <= 9179 || e >= 9186 && e <= 9215) || Cs["Control Pictures"](e) && 9251 !== e || Cs["Optical Character Recognition"](e) || Cs["Enclosed Alphanumerics"](e) || Cs["Geometric Shapes"](e) || Cs["Miscellaneous Symbols"](e) && !(e >= 9754 && e <= 9759) || Cs["Miscellaneous Symbols and Arrows"](e) && (e >= 11026 && e <= 11055 || e >= 11088 && e <= 11097 || e >= 11192 && e <= 11243) || Cs["CJK Symbols and Punctuation"](e) || Cs.Katakana(e) || Cs["Private Use Area"](e) || Cs["CJK Compatibility Forms"](e) || Cs["Small Form Variants"](e) || Cs["Halfwidth and Fullwidth Forms"](e) || 8734 === e || 8756 === e || 8757 === e || e >= 9984 && e <= 10087 || e >= 10102 && e <= 10131 || 65532 === e || 65533 === e);
        }(e));
    }
    function Es(e) {
        return e >= 1424 && e <= 2303 || Cs["Arabic Presentation Forms-A"](e) || Cs["Arabic Presentation Forms-B"](e);
    }
    const Ds = [ [ 9, 9 ], [ 32, 32 ], [ 5760, 5760 ], [ 8192, 8198 ], [ 8200, 8202 ], [ 8287, 12288 ], [ 6158, 6158 ], [ 8203, 8205 ] ];
    function Ls(e) {
        for (const t of Ds) if (e >= t[0] && e <= t[1]) return !0;
        return !1;
    }
    const Hs = {
        "!": "︕",
        "#": "＃",
        $: "＄",
        "%": "％",
        "&": "＆",
        "(": "︵",
        ")": "︶",
        "*": "＊",
        "+": "＋",
        ",": "︐",
        "-": "︲",
        ".": "・",
        "/": "／",
        ":": "︓",
        ";": "︔",
        "<": "︿",
        "=": "＝",
        ">": "﹀",
        "?": "︖",
        "@": "＠",
        "[": "﹇",
        "\\": "＼",
        "]": "﹈",
        "^": "＾",
        _: "︳",
        "`": "｀",
        "{": "︷",
        "|": "―",
        "}": "︸",
        "~": "～",
        "¢": "￠",
        "£": "￡",
        "¥": "￥",
        "¦": "￤",
        "¬": "￢",
        "¯": "￣",
        "–": "︲",
        "—": "︱",
        "‘": "﹃",
        "’": "﹄",
        "“": "﹁",
        "”": "﹂",
        "…": "︙",
        "‧": "・",
        "₩": "￦",
        "、": "︑",
        "。": "︒",
        "〈": "︿",
        "〉": "﹀",
        "《": "︽",
        "》": "︾",
        "「": "﹁",
        "」": "﹂",
        "『": "﹃",
        "』": "﹄",
        "【": "︻",
        "】": "︼",
        "〔": "︹",
        "〕": "︺",
        "〖": "︗",
        "〗": "︘",
        "！": "︕",
        "（": "︵",
        "）": "︶",
        "，": "︐",
        "－": "︲",
        "．": "・",
        "：": "︓",
        "；": "︔",
        "＜": "︿",
        "＞": "﹀",
        "？": "︖",
        "［": "﹇",
        "］": "﹈",
        "＿": "︳",
        "｛": "︷",
        "｜": "―",
        "｝": "︸",
        "｟": "︵",
        "｠": "︶",
        "｡": "︒",
        "｢": "﹁",
        "｣": "﹂"
    }, zs = 1, Ns = 2;
    function Vs(e, t, n, i, r, s, o, a, l, h) {
        let c = e.trim();
        h === Ns && (c = function(e) {
            let t = "";
            const n = Array.from(e);
            for (let e = 0; e < n.length; e++) {
                const i = n[e + 1].codePointAt(0) || null, r = n[e - 1].codePointAt(0) || null;
                i && Rs(i) && !Hs[n[e + 1]] || r && Rs(r) && !Hs[n[e - 1]] || !Hs[n[e]] ? t += n[e] : t += Hs[n[e]];
            }
            return t;
        }(c));
        const u = [], f = {
            positionedGlyphs: u,
            text: c,
            top: a[1],
            bottom: a[1],
            left: a[0],
            right: a[0],
            writingMode: h
        };
        let d;
        return d = function(e, t) {
            const n = [];
            let i = 0;
            for (let r = 0; r < t.length; r++) {
                const s = t[r];
                n.push(e.substring(i, s)), i = s;
            }
            return i < e.length && n.push(e.substring(i, e.length)), n;
        }(c, function(e, t, n, i) {
            if (!n) return [];
            if (!e) return [];
            const r = [], s = function(e, t, n, i) {
                let r = 0;
                for (let n = 0; n < e.length; n++) {
                    const s = i[e.codePointAt(n)];
                    s && (r += s.metrics.advance + t);
                }
                return r / Math.max(1, Math.ceil(r / n));
            }(e, t, n, i);
            let o = 0;
            for (let n = 0; n < e.length; n++) {
                const a = e.codePointAt(n), l = i[a];
                l && (l && !Bs[a] && (o += l.metrics.advance + t), n < e.length - 1 && (Us[a] || Fs(a)) && r.push(Ws(n + 1, o, s, r, js(a, e.codePointAt(n + 1)), !1)));
            }
            return Xs(Ws(e.length, o, s, r, 0, !0));
        }(c, o, n, t)), function(e, t, n, i, r, s, o, a, l, h) {
            let c = 0, u = 0, f = 0;
            const d = e.positionedGlyphs;
            for (let e = 0; e < n.length; e++) {
                let r = n[e];
                if (r = r.trim(), !r.length) {
                    u -= i;
                    continue;
                }
                const s = d.length;
                for (let e = 0; e < r.length; e++) {
                    const n = r.codePointAt(e), i = t[n];
                    i && (Os(n) && o !== zs ? (32 !== n && d.push({
                        glyph: n,
                        x: c,
                        y: 0,
                        vertical: !0
                    }), c += l + a) : (32 !== n && d.push({
                        glyph: n,
                        x: c,
                        y: u,
                        vertical: !1
                    }), c += i.metrics.advance + a));
                }
                if (d.length !== s) {
                    const e = c - a;
                    f = Math.max(e, f), qs(d, t, s, d.length - 1, .5);
                }
                c = 0, u -= i;
            }
            const {horizontalAlign: p, verticalAlign: g} = Ys(r, void 0);
            !function(e, t, n, i, r, s, o) {
                const a = (.5 - n) * r, l = -(-i * o + .5) * s;
                if (a || l) for (let t = 0; t < e.length; t++) e[t].x += a, e[t].y += l;
            }(d, 0, p, g, f, i, n.length);
            const m = n.length * i;
            e.top += -g * m, e.bottom = e.top + m, e.left += -p * f, e.right = e.left + f;
        }(f, t, d, i, r, 0, h, o, l), !!u.length && f;
    }
    const Bs = {
        9: !0,
        10: !0,
        11: !0,
        12: !0,
        13: !0,
        32: !0
    }, Us = {
        10: !0,
        32: !0,
        38: !0,
        40: !0,
        41: !0,
        43: !0,
        45: !0,
        47: !0,
        173: !0,
        183: !0,
        8203: !0,
        8208: !0,
        8211: !0,
        8231: !0
    };
    function Gs(e, t, n, i) {
        const r = Math.pow(e - t, 2);
        return i ? e < t ? r / 2 : 2 * r : r + Math.abs(n) * n;
    }
    function js(e, t) {
        let n = 0;
        return 10 === e && (n -= 1e4), 40 !== e && 65288 !== e || (n += 50), 41 !== t && 65289 !== t || (n += 50), 
        n;
    }
    function Ws(e, t, n, i, r, s) {
        let o = null, a = Gs(t, n, r, s);
        for (let e = 0; e < i.length; e++) {
            const l = i[e], h = Gs(t - l.x, n, r, s) + l.badness;
            h <= a && (o = l, a = h);
        }
        return {
            index: e,
            x: t,
            priorBreak: o,
            badness: a
        };
    }
    function Xs(e) {
        return e ? Xs(e.priorBreak).concat(e.index) : [];
    }
    function Ys(e, t) {
        let n = .5, i = .5;
        switch (e) {
          case "right":
          case "top-right":
          case "bottom-right":
            n = t ? 1 : 0;
            break;

          case "left":
          case "top-left":
          case "bottom-left":
            n = t ? 0 : 1;
        }
        switch (e) {
          case "bottom":
          case "bottom-right":
          case "bottom-left":
            i = t ? 1 : 0;
            break;

          case "top":
          case "top-right":
          case "top-left":
            i = t ? 0 : 1;
        }
        return {
            horizontalAlign: n,
            verticalAlign: i
        };
    }
    function qs(e, t, n, i, r) {
        const s = t[e[i].glyph];
        if (s) {
            const t = s.metrics.advance, o = (e[i].x + t) * r;
            if (!o) return;
            for (let t = n; t <= i; t++) e[t].x -= o;
        }
    }
    function Zs(e) {
        if (!function(e) {
            for (const t of e) if (Es(t.charCodeAt(0))) return !0;
            return !1;
        }(e)) return e;
        const t = [], n = [], i = [];
        let r = 0, s = 0, o = 1, a = 1;
        for (const l of e) {
            const e = l.codePointAt(0);
            Ls(e) ? (i.push(l), r++) : (o = Es(e) ? -1 : 1, a !== o ? (s = r, n.length && (a > 0 && n.reverse(), 
            t.push(...n)), i.length && (t.splice(s, 0, ...i), i.length = 0), a = o, n.length = 0) : i.length && (n.push(...i), 
            i.length = 0), n.push(l), r++);
        }
        return i.length && n.push(...i), n.length && (a > 0 && n.reverse(), t.push(...n)), 
        t.reverse().join("");
    }
    const $s = /\{ *([\w_]+) *\}/g, Js = {
        ellipse: "middle",
        cross: "middle",
        x: "middle",
        triangle: "middle",
        square: "middle",
        diamond: "middle",
        bar: "top",
        pie: "top",
        pin: "top",
        rectangle: "bottom"
    };
    class Ks {
        constructor(e, t, n, i, r) {
            this.feature = e, this.symbolDef = t, this.symbol = n, this.options = r, this._thisReplacer = this._replacer.bind(this), 
            this._fnTypes = i;
        }
        _replacer(e, t) {
            return this.feature.properties[t] || "";
        }
        getShape(e, t) {
            if (this._shape) return this._shape;
            const {markerTypeFn: n, textHorizontalAlignmentFn: i, textVerticalAlignmentFn: r, markerHorizontalAlignmentFn: s, markerVerticalAlignmentFn: o, textWrapWidthFn: a} = this._fnTypes, l = {}, h = this.symbol, c = this.getIconAndGlyph(), u = this.feature.properties, f = n ? n(null, u) : h.markerType;
            if (c && c.glyph) {
                const {font: e, text: n} = c.glyph;
                if ("" === n) return null;
                const s = 24, o = this.textSize[0] / s, f = 24, d = h.textKeepUpright, p = "map" === h.textRotationAlignment && "line" === h.textPlacement && !h.isIconText, g = t.glyphMap[e], m = Qs(i ? i(null, u) : h.textHorizontalAlignment, r ? r(null, u) : h.textVerticalAlignment), y = 1.2 * f, x = function(e) {
                    for (let t = 0; t < e.length; t++) if (!ks(e.charAt(t).charCodeAt(0))) return !1;
                    return !0;
                }(n), _ = x && h.textLetterSpacing / o || 0, v = [ h.textDx / o || 0, h.textDy / o || 0 ], b = ((a ? a(null, u) : h.textWrapWidth) || 10 * f) / o, A = {};
                A.horizontal = Vs(n, g, b, y, m, 0, _, v, f, zs, this.options.isVector3D), x && p && d && (A.vertical = Vs(n, g, b, y, m, 0, _, v, f, Ns)), 
                l.textShape = A;
            }
            if (c && c.icon) {
                if (!e || !e.positions[c.icon.url]) return null;
                const t = s ? s(null, u) : h.markerHorizontalAlignment;
                let n = o ? o(null, u) : h.markerVerticalAlignment;
                !n && f && (n = Js[f]), n = n || this.options.defaultMarkerVerticalAlignment;
                const i = Qs(t, n), r = function(e, t, n) {
                    let {horizontalAlign: i, verticalAlign: r} = Ys(t, n);
                    n ? i = 1 - i : r = 1 - r;
                    const s = -2048 * i, o = -2048 * r;
                    return {
                        image: e,
                        top: o,
                        bottom: o + 2048,
                        left: s,
                        right: s + 2048
                    };
                }(e.positions[c.icon.url], i, this.options.isVector3D);
                this.iconSize || (this.iconSize = r.image.displaySize), l.iconShape = r;
            }
            return this._shape = l, l;
        }
        getIconAndGlyph() {
            if (this.iconGlyph) return this.iconGlyph;
            const {markerFileFn: e, markerTypeFn: t, markerPathFn: n, markerWidthFn: i, markerHeightFn: r, markerFillFn: s, markerFillPatternFileFn: o, markerFillOpacityFn: a, markerTextFitFn: l, markerTextFitPaddingFn: h, markerLineColorFn: c, markerLineWidthFn: u, markerLineOpacityFn: f, markerLineDasharrayFn: d, markerLinePatternFileFn: p, markerPathWidthFn: g, markerPathHeightFn: m, textNameFn: y, textFaceNameFn: x} = this._fnTypes, {zoom: _} = this.options, v = {}, b = this.symbol, A = this.symbolDef, T = this.feature.properties, w = e ? e(null, T) : b.markerFile, S = t ? t(null, T) : b.markerType, M = w || S || b.markerPath, P = !Je(this.symbolDef.textName);
            let I, C;
            if (M) {
                I = function(e, t, n, i, r, s) {
                    if (Je(t.markerWidth) && Je(t.markerHeight)) return null;
                    const o = "__fn_markerWidth".trim(), a = "__fn_markerHeight".trim();
                    let l = t.markerWidth || 0, h = t.markerHeight || 0;
                    return Qe(l) && ("identity" !== l.type ? l = vs(l) : (l = e.markerWidth, e[o] && (l = e[o](i, n)), 
                    Qe(l) && (l = "identity" === l.type ? r(i, n) : vs(l)))), Qe(h) && ("identity" !== h.type ? h = vs(h) : (h = e.markerHeight, 
                    e[a] && (h = e[a](i, n)), Qe(h) && (h = "identity" === h.type ? s(i, n) : vs(h)))), 
                    [ l, h ];
                }(b, this.symbolDef, T, _, i, r) || [ 0, 0 ];
                let e = b.markerTextFit;
                if (l && (e = l(_, T)), e && A.textName && "none" !== e) {
                    const t = A.textSize;
                    let n = A.textName;
                    ie(n) && (n = re(n)(_, T));
                    const i = Ss(n, T);
                    if (i) {
                        const n = "__fn_textSize".trim(), r = "__fn_textSize_0".trim();
                        ie(t) && !A[n] && (A[r] = re(t), A[n] = (e, t) => {
                            const n = A[r](e, t);
                            return ie(n) ? re(n)(e, t) : n;
                        });
                        const s = _s(A, A, T, _);
                        if ("width" !== e && "both" !== e || (I[0] = s[0] * i.length), "height" !== e && "both" !== e || (I[1] = s[1]), 
                        s[0] && s[1]) {
                            let e = b.markerTextFitPadding || [ 0, 0, 0, 0 ];
                            h && (e = h(_, T)), I[0] += e[1] + e[3], I[1] += e[0] + e[2];
                        }
                    } else I[0] = I[1] = -1;
                }
            }
            if (P && (C = _s(b, this.symbolDef, T, _)), !C && !I) return v;
            if (I && (I[0] = Math.ceil(I[0]), I[1] = Math.ceil(I[1])), C && (C[0] = Math.ceil(C[0]), 
            C[1] = Math.ceil(C[1])), this.iconSize = I, this.textSize = C, M && I[0] >= 0 && I[1] >= 0) {
                let e;
                if (S) {
                    const t = {};
                    if (t.markerType = S, "path" === S && (t.markerPath = n ? n(null, T) : b.markerPath, 
                    t.markerPathWidth = g ? g(null, T) : b.markerPathWidth, t.markerPathHeight = m ? m(null, T) : b.markerPathHeight), 
                    i) {
                        const e = i(null, T);
                        Je(e) || (t.markerWidth = e);
                    } else b.markerWidth >= 0 && (t.markerWidth = b.markerWidth);
                    if (r) {
                        const e = r(null, T);
                        Je(e) || (t.markerHeight = e);
                    } else b.markerHeight >= 0 && (t.markerHeight = b.markerHeight);
                    if (s) {
                        const e = s(null, T);
                        Je(e) || (t.markerFill = e);
                    } else b.markerFill && (t.markerFill = b.markerFill);
                    if (o) {
                        const e = o(null, T);
                        Je(e) || (t.markerFillPatternFile = e);
                    } else b.markerFillPatternFile && (t.markerFillPatternFile = b.markerFillPatternFile);
                    if (a) {
                        const e = a(null, T);
                        Je(e) || (t.markerFillOpacity = e);
                    } else b.markerFillOpacity >= 0 && (t.markerFillOpacity = b.markerFillOpacity);
                    if (c) {
                        const e = c(null, T);
                        Je(e) || (t.markerLineColor = e);
                    } else b.markerLineColor && (t.markerLineColor = b.markerLineColor);
                    if (u) {
                        const e = u(null, T);
                        Je(e) || (t.markerLineWidth = e);
                    } else b.markerLineWidth >= 0 && (t.markerLineWidth = b.markerLineWidth);
                    if (f) {
                        const e = f(null, T);
                        Je(e) || (t.markerLineOpacity = e);
                    } else b.markerLineOpacity >= 0 && (t.markerLineOpacity = b.markerLineOpacity);
                    if (d) {
                        const e = d(null, T);
                        Je(e) || (t.markerLineDasharray = e);
                    } else b.markerLineDasharray && (t.markerLineDasharray = b.markerLineDasharray);
                    if (p) {
                        const e = p(null, T);
                        Je(e) || (t.markerLinePatternFile = e);
                    } else b.markerLinePatternFile && (t.markerLinePatternFile = b.markerLinePatternFile);
                    e = "vector://" + JSON.stringify(t);
                } else e = w ? w.replace($s, this._thisReplacer) : b.markerPath ? function(e, t, n) {
                    if (!e.markerPath) return null;
                    let i = 1;
                    const r = function(e) {
                        const t = {
                            stroke: {
                                stroke: e.markerLineColor,
                                "stroke-width": e.markerLineWidth,
                                "stroke-opacity": e.markerLineOpacity,
                                "stroke-dasharray": null,
                                "stroke-linecap": "butt",
                                "stroke-linejoin": "round"
                            },
                            fill: {
                                fill: e.markerFill,
                                "fill-opacity": e.markerFillOpacity
                            }
                        };
                        return 0 === t.stroke["stroke-width"] && (t.stroke["stroke-opacity"] = 0), t;
                    }(e);
                    Ke(e.markerOpacity) && (i = e.markerOpacity), Ke(e.opacity) && (i *= e.opacity);
                    const s = {};
                    if (r) {
                        for (const e in r.stroke) it(r.stroke, e) && (Je(r.stroke[e]) || (s[e] = r.stroke[e]));
                        for (const e in r.fill) it(r.fill, e) && (Je(r.fill[e]) || (s[e] = r.fill[e]));
                    }
                    const o = Array.isArray(e.markerPath) ? e.markerPath : [ e.markerPath ];
                    let a;
                    const l = [];
                    for (let e = 0; e < o.length; e++) a = et(o[e]) ? {
                        path: o[e]
                    } : o[e], a = $e({}, s, a), a.d = a.path, delete a.path, l.push(a);
                    const h = [ '<svg version="1.1"', 'xmlns="http://www.w3.org/2000/svg"' ];
                    i < 1 && h.push('opacity="' + i + '"'), e.markerPathWidth && e.markerPathHeight && h.push('viewBox="0 0 ' + e.markerPathWidth + " " + e.markerPathHeight + '"'), 
                    h.push('preserveAspectRatio="none"'), t && h.push('width="' + t + '"'), n && h.push('height="' + n + '"'), 
                    h.push("><defs></defs>");
                    for (let e = 0; e < l.length; e++) {
                        let t = "<path";
                        for (const n in l[e]) it(l[e], n) && (t += " " + n + '="' + l[e][n] + '"');
                        t += "></path>", h.push(t);
                    }
                    return h.push("</svg>"), "data:image/svg+xml;base64," + btoa(h.join(" "));
                }(b, I[0], I[1]) : null;
                v.icon = {
                    url: e,
                    iconSize: I,
                    textSize: C
                };
            }
            if (P) {
                const e = y ? y(this.options.zoom, T) : b.textName;
                if (e || 0 === e) {
                    const t = Ts(x ? x(null, T) : b.textFaceName);
                    let n = Ss(e, T);
                    n && n.length && (n = Zs(n), v.glyph = {
                        font: t,
                        text: n
                    });
                }
            }
            return this.iconGlyph = v, v;
        }
    }
    function Qs(e, t) {
        t && "middle" !== t || (t = "center"), e && "middle" !== e || (e = "center");
        let n = "center" !== t ? t : "";
        return n += "center" !== e ? (n.length ? "-" : "") + e : "", n;
    }
    /*!
	 * From mapbox-gl-js
	 * MIT License
	 * https://github.com/mapbox/mapbox-gl-js
	 */    function eo(e, t, n, i, r) {
        const o = [];
        let a;
        for (let l = 0; l < e.length; l++) {
            const h = e[l];
            let c, u = !1;
            for (let e = 0; e < h.length - 1; e++) {
                let l = h[e], f = h[e + 1];
                l.x < t && f.x < t || (l.x < t ? (a = l, l = new s(t, l.y + (f.y - l.y) * ((t - l.x) / (f.x - l.x)))._round(), 
                l.z = a.z + (f.z - a.z) * ((t - a.x) / (f.x - a.x)), u = !0) : f.x < t && (a = f, 
                f = new s(t, l.y + (f.y - l.y) * ((t - l.x) / (f.x - l.x)))._round(), f.z = l.z + (a.z - l.z) * ((t - l.x) / (a.x - l.x)), 
                u = !0), l.y < n && f.y < n || (l.y < n ? (a = l, l = new s(l.x + (f.x - l.x) * ((n - l.y) / (f.y - l.y)), n)._round(), 
                l.z = a.z + (f.z - a.z) * ((n - a.y) / (f.y - a.y)), u = !0) : f.y < n && (a = f, 
                f = new s(l.x + (f.x - l.x) * ((n - l.y) / (f.y - l.y)), n)._round(), f.z = l.z + (a.z - l.z) * ((n - l.y) / (a.y - l.y)), 
                u = !0), l.x >= i && f.x >= i || (l.x >= i ? (a = l, l = new s(i, l.y + (f.y - l.y) * ((i - l.x) / (f.x - l.x)))._round(), 
                l.z = a.z + (f.z - a.z) * ((i - a.x) / (f.x - a.x)), u = !0) : f.x >= i && (a = f, 
                f = new s(i, l.y + (f.y - l.y) * ((i - l.x) / (f.x - l.x)))._round(), f.z = l.z + (a.z - l.z) * ((i - l.x) / (a.x - l.x)), 
                u = !0), l.y >= r && f.y >= r || (l.y >= r ? (a = l, l = new s(l.x + (f.x - l.x) * ((r - l.y) / (f.y - l.y)), r)._round(), 
                l.z = a.z + (f.z - a.z) * ((r - a.y) / (f.y - a.y)), u = !0) : f.y >= r && (a = f, 
                f = new s(l.x + (f.x - l.x) * ((r - l.y) / (f.y - l.y)), r)._round(), f.z = l.z + (a.z - l.z) * ((r - l.y) / (a.y - l.y)), 
                u = !0), c && l.equals(c[c.length - 1]) || (c = [ l ], o.push(c)), u && (c.clipped = !0), 
                c.push(f)))));
            }
        }
        return o;
    }
    class to extends s {
        constructor(e, t, n, i) {
            super(e, t), this.angle = n, void 0 !== i && (this.segment = i);
        }
        clone() {
            return new to(this.x, this.y, this.angle, this.segment);
        }
    }
    /*!
	 * From mapbox-gl-js
	 * MIT License
	 * https://github.com/mapbox/mapbox-gl-js
	 */    function no(e, t, n, i, r) {
        if (void 0 === t.segment) return !0;
        let s = t, o = t.segment + 1, a = 0;
        for (;a > -n / 2; ) {
            if (o--, o < 0) return !1;
            a -= e[o].dist(s), s = e[o];
        }
        a += e[o].dist(e[o + 1]), o++;
        const l = [];
        let h = 0;
        for (;a < n / 2; ) {
            const t = e[o - 1], n = e[o], s = e[o + 1];
            if (!s) return !1;
            let c = t.angleTo(n) - n.angleTo(s);
            for (c = Math.abs((c + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                distance: a,
                angleDelta: c
            }), h += c; a - l[0].distance > i; ) h -= l.shift().angleDelta;
            if (h > r) return !1;
            o++, a += n.dist(s);
        }
        return !0;
    }
    function io(e, t, n, i, r, s, o, a, l, h, c) {
        const u = function(e, t, n) {
            return e ? .6 * t * n : 0;
        }(i, s, o), f = function(e, t) {
            return Math.max(e ? e.right - e.left : 0, 0);
        }(i), d = 0 === e[0].x || e[0].x === l || 0 === e[0].y || e[0].y === l;
        return t - f * o < t / 4 && (t = f * o + t / 4), ro(e, d ? t / 2 * a % t : (f / 2 + 2 * s) * o * a % t, t, u, n, f * o, d, !1, l, h, c);
    }
    function ro(e, t, n, i, r, s, o, a, l, h, c) {
        let u = 0;
        const f = s / 2, d = function(e) {
            let t = 0;
            for (let n = 0; n < e.length - 1; n++) t += e[n].dist(e[n + 1]);
            return t;
        }(e);
        let p = 0, g = t - n, m = [];
        for (let t = 0; t < e.length - 1; t++) {
            const o = e[t], a = e[t + 1], y = o.dist(a), x = a.angleTo(o);
            for (;g + n < p + y; ) {
                g += n;
                const _ = (g - p) / y, v = so(o.x, a.x, _), b = so(o.y, a.y, _), A = so(o.z || 0, a.z || 0, _);
                if (v >= 0 && v < l && b >= 0 && b < l && g - f >= 0 && g + f <= d) {
                    const n = new to(v, b, x, t);
                    n.z = A, h && (n.axis = [ o.y - b, v - o.x ], n.angleR = A === (o.z || 0) ? 0 : Math.atan(.9 * (A - (o.z || 0)) * c / o.dist(n))), 
                    n.line = e, n._round(), !i || no(e, n, s, i, r) ? m.push(n) : i && u++;
                }
            }
            p += y;
        }
        return a || m.length || o || (m = ro(e, p / 2, n, i, r, s, o, !0, l, h, c)), m.countOutOfAngle = u, 
        m;
    }
    function so(e, t, n) {
        return e * (1 - n) + t * n;
    }
    var oo = {
        exports: {}
    };
    oo.exports = function() {
        function e(n, i, r, s, o) {
            for (;s > r; ) {
                if (s - r > 600) {
                    var a = s - r + 1, l = i - r + 1, h = Math.log(a), c = .5 * Math.exp(2 * h / 3), u = .5 * Math.sqrt(h * c * (a - c) / a) * (l - a / 2 < 0 ? -1 : 1);
                    e(n, i, Math.max(r, Math.floor(i - l * c / a + u)), Math.min(s, Math.floor(i + (a - l) * c / a + u)), o);
                }
                var f = n[i], d = r, p = s;
                for (t(n, r, i), o(n[s], f) > 0 && t(n, r, s); d < p; ) {
                    for (t(n, d, p), d++, p--; o(n[d], f) < 0; ) d++;
                    for (;o(n[p], f) > 0; ) p--;
                }
                0 === o(n[r], f) ? t(n, r, p) : t(n, ++p, s), p <= i && (r = p + 1), i <= p && (s = p - 1);
            }
        }
        function t(e, t, n) {
            var i = e[t];
            e[t] = e[n], e[n] = i;
        }
        function n(e, t) {
            return e < t ? -1 : e > t ? 1 : 0;
        }
        return function(t, i, r, s, o) {
            e(t, i, r || 0, s || t.length - 1, o || n);
        };
    }();
    var ao = n(oo.exports);
    function lo(e, t) {
        const n = e.length;
        if (n <= 1) return [ e ];
        const i = [];
        let r, s;
        for (let t = 0; t < n; t++) {
            const n = b(e[t]);
            0 !== n && (e[t].area = Math.abs(n), void 0 === s && (s = n < 0), s === n < 0 ? (r && i.push(r), 
            r = [ e[t] ]) : r.push(e[t]));
        }
        if (r && i.push(r), t > 1) for (let e = 0; e < i.length; e++) i[e].length <= t || (ao(i[e], t, 1, i[e].length - 1, ho), 
        i[e] = i[e].slice(0, t));
        return i;
    }
    function ho(e, t) {
        return t.area - e.area;
    }
    class co {
        constructor(e = [], t = uo) {
            if (this.data = e, this.length = this.data.length, this.compare = t, this.length > 0) for (let e = (this.length >> 1) - 1; e >= 0; e--) this._down(e);
        }
        push(e) {
            this.data.push(e), this.length++, this._up(this.length - 1);
        }
        pop() {
            if (0 === this.length) return;
            const e = this.data[0], t = this.data.pop();
            return this.length--, this.length > 0 && (this.data[0] = t, this._down(0)), e;
        }
        peek() {
            return this.data[0];
        }
        _up(e) {
            const {data: t, compare: n} = this, i = t[e];
            for (;e > 0; ) {
                const r = e - 1 >> 1, s = t[r];
                if (n(i, s) >= 0) break;
                t[e] = s, e = r;
            }
            t[e] = i;
        }
        _down(e) {
            const {data: t, compare: n} = this, i = this.length >> 1, r = t[e];
            for (;e < i; ) {
                let i = 1 + (e << 1), s = t[i];
                const o = i + 1;
                if (o < this.length && n(t[o], s) < 0 && (i = o, s = t[o]), n(s, r) >= 0) break;
                t[e] = s, e = i;
            }
            t[e] = r;
        }
    }
    function uo(e, t) {
        return e < t ? -1 : e > t ? 1 : 0;
    }
    function fo(e, t, n) {
        const i = t.distSqr(n);
        if (0 === i) return e.distSqr(t);
        const r = ((e.x - t.x) * (n.x - t.x) + (e.y - t.y) * (n.y - t.y)) / i;
        return r < 0 ? e.distSqr(t) : r > 1 ? e.distSqr(n) : e.distSqr(n.sub(t)._mult(r)._add(t));
    }
    function po(e, t = 1, n = !1) {
        let i = 1 / 0, r = 1 / 0, o = -1 / 0, a = -1 / 0;
        const l = e[0];
        for (let e = 0; e < l.length; e++) {
            const t = l[e];
            (!e || t.x < i) && (i = t.x), (!e || t.y < r) && (r = t.y), (!e || t.x > o) && (o = t.x), 
            (!e || t.y > a) && (a = t.y);
        }
        const h = o - i, c = a - r, u = Math.min(h, c);
        let f = u / 2;
        const d = new co([], go);
        if (0 === u) return new s(i, r);
        for (let t = i; t < o; t += u) for (let n = r; n < a; n += u) d.push(new mo(t + f, n + f, f, e));
        let p = function(e) {
            let t = 0, n = 0, i = 0;
            const r = e[0];
            for (let e = 0, s = r.length, o = s - 1; e < s; o = e++) {
                const s = r[e], a = r[o], l = s.x * a.y - a.x * s.y;
                n += (s.x + a.x) * l, i += (s.y + a.y) * l, t += 3 * l;
            }
            return new mo(n / t, i / t, 0, e);
        }(e), g = d.length;
        for (;d.length; ) {
            const i = d.pop();
            (i.d > p.d || !p.d) && (p = i, n && console.log("found best %d after %d probes", Math.round(1e4 * i.d) / 1e4, g)), 
            i.max - p.d <= t || (f = i.h / 2, d.push(new mo(i.p.x - f, i.p.y - f, f, e)), d.push(new mo(i.p.x + f, i.p.y - f, f, e)), 
            d.push(new mo(i.p.x - f, i.p.y + f, f, e)), d.push(new mo(i.p.x + f, i.p.y + f, f, e)), 
            g += 4);
        }
        return n && (console.log(`num probes: ${g}`), console.log(`best distance: ${p.d}`)), 
        p.p;
    }
    function go(e, t) {
        return t.max - e.max;
    }
    function mo(e, t, n, i) {
        this.p = new s(e, t), this.h = n, this.d = function(e, t) {
            let n = !1, i = 1 / 0;
            for (let r = 0; r < t.length; r++) {
                const s = t[r];
                for (let t = 0, r = s.length, o = r - 1; t < r; o = t++) {
                    const r = s[t], a = s[o];
                    r.y > e.y != a.y > e.y && e.x < (a.x - r.x) * (e.y - r.y) / (a.y - r.y) + r.x && (n = !n), 
                    i = Math.min(i, fo(e, r, a));
                }
            }
            return (n ? 1 : -1) * Math.sqrt(i);
        }(this.p, i), this.max = this.d + this.h * Math.SQRT2;
    }
    function yo(e, t, n, i, r, s, o, a, l, h) {
        const {feature: c, iconSize: u, textSize: f, symbol: d} = e, p = u || f ? 24 : 0, g = r * (f ? f[0] / p : 1);
        if ("line" === o) {
            const e = [];
            e.countOutOfAngle = 0;
            let r = c.geometry;
            s && (r = eo(c.geometry, 0, 0, s, s));
            for (let o = 0; o < r.length; o++) {
                const c = io(r[o], a, n, d.isIconText ? null : i && i.vertical || i && i.horizontal || i, 0, p, d.isIconText ? 1 : g, 1, s || 1 / 0, l, h);
                if (d.textPlacement && !d.isIconText) for (let e = 0; e < c.length; e++) c[e].startIndex = t.length / 3;
                if (e.push.apply(e, c), d.textPlacement && !d.isIconText) for (let e = 0; e < r[o].length; e++) t.push(r[o][e].x, r[o][e].y, r[o][e].z || 0);
                e.countOutOfAngle += c.countOutOfAngle || 0;
            }
            return e;
        }
        return xo(c, o, s);
    }
    function xo(e, t, n, i, r) {
        const s = [];
        if (3 === e.type) {
            const o = lo(e.geometry, 0);
            for (let e = 0; e < o.length; e++) {
                const a = o[e];
                if ("vertex" === t) for (let e = 0; e < a.length; e++) {
                    const t = a[e];
                    for (let o = 0; o < t.length; o++) S(t[o], n) || (s.push(t[o]), i && (0 === o ? _o(t[o], t[o], t[e + 1], r) : _o(t[o], t[o - 1], t[o], r)));
                } else if ("vertex-first" === t) {
                    const e = a[0];
                    e && e[0] && !S(e[0], n) && (s.push(e[0]), i && _o(e[0], e[0], e[1], r));
                } else if ("vertex-last" === t || "vertex-firstlast" === t) {
                    const e = a[0];
                    if ("vertex-firstlast" === t && e && e[0] && !S(e[0], n) && (s.push(e[0]), i && _o(e[0], e[0], e[1], r)), 
                    e && e[e.length - 1] && !S(e[e.length - 1], n)) {
                        const t = e.length - 1;
                        s.push(e[t]), i && _o(e[t], e[t - 1], e[t], r);
                    }
                } else {
                    const e = po(a, 16);
                    S(e, n) || s.push(e);
                }
            }
        } else if (2 === e.type) for (let o = 0; o < e.geometry.length; o++) {
            const a = e.geometry[o];
            if ("vertex" === t) for (let e = 0; e < a.length; e++) S(a[e], n) || (s.push(a[e]), 
            i && (0 === e ? _o(a[e], a[e], a[e + 1], r) : _o(a[e], a[e - 1], a[e], r))); else if ("vertex-last" === t || "vertex-firstlast" === t) {
                if ("vertex-firstlast" !== t || S(a[0], n) || (s.push(a[0]), i && _o(a[0], a[0], a[1], r)), 
                a && a[a.length - 1] && !S(a[a.length - 1], n)) {
                    const e = a.length - 1;
                    s.push(a[e]), i && _o(a[e], a[e - 1], a[e], r);
                }
            } else S(a[0], n) || (s.push(a[0]), i && _o(a[0], a[0], a[1], r));
        } else if (1 === e.type) for (let t = 0; t < e.geometry.length; t++) {
            const r = e.geometry[t];
            for (let e = 0; e < r.length; e++) {
                const t = r[e];
                S(t, n) || (i && (t.xRotation = 0, t.yRotation = 0, t.zRotation = 0), s.push(t));
            }
        }
        return s;
    }
    function _o(e, t, n, i) {
        if (e.xRotation || e.yRotation || e.zRotation) return e;
        const r = n.x - t.x, s = t.y - n.y, o = (n.z - t.z) * i, a = Math.atan2(s, r);
        e.zRotation = a;
        const l = Math.atan2(o, Math.sqrt(r * r + s * s));
        return e.xyRotation = l, e;
    }
    function vo(e, t) {
        const n = {}, i = {}, r = [];
        let s = 0;
        function o(t) {
            r.push(e[t]), s++;
        }
        function a(e, t, n) {
            const s = i[e];
            return delete i[e], i[t] = s, r[s].geometry[0].pop(), r[s].geometry[0] = r[s].geometry[0].concat(n[0]), 
            s;
        }
        function l(e, t, i) {
            const s = n[t];
            return delete n[t], n[e] = s, r[s].geometry[0].shift(), r[s].geometry[0] = i[0].concat(r[s].geometry[0]), 
            s;
        }
        function h(e, t, n) {
            const i = n ? t[0][t[0].length - 1] : t[0][0];
            return `${e}:${i.x}:${i.y}`;
        }
        for (let c = 0; c < e.length; c++) {
            const u = e[c], f = u.geometry;
            if (!f) continue;
            const d = u.properties[t] ? u.properties[t].toString() : null;
            if (!d) {
                o(c);
                continue;
            }
            const p = h(d, f), g = h(d, f, !0);
            if (p in i && g in n && i[p] !== n[g]) {
                const e = l(p, g, f), t = a(p, g, r[e].geometry);
                delete n[p], delete i[g], i[h(d, r[t].geometry, !0)] = t, r[e].geometry = null;
            } else p in i ? a(p, g, f) : g in n ? l(p, g, f) : (o(c), n[p] = s - 1, i[g] = s - 1);
        }
        return r.filter((e => e.geometry));
    }
    const bo = "__index";
    function Ao(e, t, n, i) {
        const r = (bo + "").trim(), s = function(e, t, n, i) {
            const r = (bo + "").trim(), {mergeOnPropertyFn: s} = n;
            if (!t.mergeOnProperty) return [];
            if (!M(o = t.mergeOnProperty) && ("string" == typeof o || null !== o.constructor && o.constructor === String)) return [ {
                features: e,
                property: t.mergeOnProperty
            } ];
            var o;
            const a = [], l = {}, h = [];
            for (let n = 0; n < e.length; n++) {
                e[n][r] = n;
                const o = e[n].properties = e[n].properties || {};
                o.$layer = e[n].layer, o.$type = e[n].type;
                const c = s ? s(i, o) : t.mergeOnProperty;
                M(c) ? h.push(e[n]) : (void 0 === l[c] && (l[c] = a.length, a.push({
                    features: [],
                    property: c
                })), a[l[c]].features.push(e[n]));
            }
            return h.length && a.push({
                features: h
            }), a;
        }(e, t, n, i);
        if (s.length) {
            const e = [];
            for (let t = 0; t < s.length; t++) s[t].property ? e.push(vo(s[t].features, s[t].property)) : e.push(s[t].features);
            if (1 === e.length) return e[0];
            {
                let t = [];
                for (let n = 0; n < e.length; n++) t = t.concat(e[n]);
                return t.sort(((e, t) => e[r] - t[r])), t;
            }
        }
        return [];
    }
    class To extends gs {
        static needMerge(e, t, n) {
            if (!e) return !1;
            let i = "line" === e.textPlacement || "line" === e.markerPlacement;
            return i || (t.textPlacementFn && (i = "line" === t.textPlacementFn(n)), t.markerPlacementFn && (i = "line" === t.markerPlacementFn(n))), 
            e.mergeOnProperty && i;
        }
        static mergeLineFeatures(e, t, n, i) {
            let r = t.textPlacement, s = t.markerPlacement;
            return n.textPlacementFn && (r = n.textPlacementFn(i)), n.markerPlacementFn && (s = n.markerPlacementFn(i)), 
            "line" !== r && "line" !== s ? e : Ao(e, t, n, i);
        }
        static splitPointSymbol(e, t = 0) {
            const n = [];
            if (Array.isArray(e)) {
                const t = e;
                for (let e = 0; e < t.length; e++) t[e] && n.push(...To.splitPointSymbol(t[e], e));
                return n;
            }
            let i = null, r = null;
            for (const t in e) 0 === t.indexOf("marker") ? (i = i || {}, i[t] = e[t]) : 0 === t.indexOf("text") && (r = r || {}, 
            r[t] = e[t]);
            return i && (i.isIconText = !0, e.mergeOnProperty && (i.mergeOnProperty = e.mergeOnProperty), 
            n.push(i)), r && (i && (r.textPlacement = i.markerPlacement, r.textSpacing = i.markerSpacing, 
            r.isIconText = !0), e.mergeOnProperty && (r.mergeOnProperty = e.mergeOnProperty), 
            n.push(r)), void 0 !== e.visible && (i && (i.visible = e.visible), r && (r.visible = e.visible)), 
            i && (i.markerTextFit && r && (i.text = {}, i.text.textName = r.textName, i.text.textSize = r.textSize), 
            i.index = {
                index: t,
                type: 0
            }), r && (r.index = {
                index: t,
                type: 1
            }), n;
        }
        static isAtlasLoaded(e, t) {
            const {icon: n, glyph: i} = e, {iconAtlas: r, glyphAtlas: s} = t;
            if (n && (!r || !r.positions[n.url])) return !1;
            if (i) {
                if (!s || !s.positions[i.font]) return !1;
                const e = s.positions[i.font], {text: t} = i;
                for (const n of t) if (!e[n.codePointAt(0)]) return !1;
            }
            return !0;
        }
        constructor(e, t, n) {
            super(e, t, n), this._textPlacement = t.textPlacement, this._fnTypes.textPlacementFn && (this._textPlacement = this._fnTypes.textPlacementFn(this.options.zoom));
        }
        createStyledVector(e, t, n, i, r, s) {
            const o = new Ks(e, this.symbolDef, t, n, i), a = o.getIconAndGlyph();
            if (a.icon && !this.options.atlas) {
                const {url: e, iconSize: t} = a.icon;
                r[e] || (r[e] = a.icon.iconSize), r[e][0] < t[0] && (r[e][0] = t[0]), r[e][1] < t[1] && (r[e][1] = t[1]);
            }
            if (a.glyph && !this.options.atlas) {
                const {font: e, text: t} = a.glyph, n = s[e] = s[e] || {};
                for (const e of t) n[e.codePointAt(0)] = 1;
                "line" === this._textPlacement && (s.options = {
                    isCharsCompact: !1
                });
            }
            return this.options.allowEmptyPack || a.icon || a.glyph ? o : null;
        }
        getFormat(e) {
            const t = "text" === this.options.pluginType, n = "line" === this._textPlacement && !e.isIconText, i = this.getPackSDFFormat(e);
            i.push(...this._getTextFnTypeFormats()), n || i.push(...this._getMarkerFnTypeFormats());
            const {markerOpacityFn: r, textOpacityFn: s, markerPitchAlignmentFn: o, textPitchAlignmentFn: a, markerRotationAlignmentFn: l, textRotationAlignmentFn: h, markerRotationFn: c, textRotationFn: u, markerAllowOverlapFn: f, textAllowOverlapFn: d, markerIgnorePlacementFn: p, textIgnorePlacementFn: g} = this._fnTypes;
            return r ? i.push({
                type: Uint8Array,
                width: 2,
                name: "aColorOpacity"
            }) : s && i.push({
                type: Uint8Array,
                width: 1,
                name: "aColorOpacity"
            }), (o || a) && i.push({
                type: Uint8Array,
                width: t ? 1 : 2,
                name: "aPitchAlign"
            }), (l || h) && i.push({
                type: Uint8Array,
                width: t ? 1 : 2,
                name: "aRotationAlign"
            }), (c || u) && i.push({
                type: Uint16Array,
                width: t ? 1 : 2,
                name: "aRotation"
            }), (f || d || p || g) && i.push({
                type: Uint8Array,
                width: 1,
                name: "aOverlap"
            }), i;
        }
        _is3DPitchText() {
            return this.hasMapPitchAlign;
        }
        _getTextFnTypeFormats() {
            const {textFillFn: e, textSizeFn: t, textHaloFillFn: n, textHaloRadiusFn: i, textHaloOpacityFn: r, textDxFn: s, textDyFn: o} = this._fnTypes, a = [];
            return e && a.push({
                type: Uint8Array,
                width: 4,
                name: "aTextFill"
            }), t && a.push({
                type: Uint8Array,
                width: 1,
                name: "aTextSize"
            }), n && a.push({
                type: Uint8Array,
                width: 4,
                name: "aTextHaloFill"
            }), (i || r) && a.push({
                type: Uint8Array,
                width: 2,
                name: "aTextHalo"
            }), s && a.push({
                type: Int8Array,
                width: 1,
                name: "aTextDx"
            }), o && a.push({
                type: Int8Array,
                width: 1,
                name: "aTextDy"
            }), a;
        }
        _getMarkerFnTypeFormats() {
            const {markerWidthFn: e, markerHeightFn: t, markerDxFn: n, markerDyFn: i, textDxFn: r, textDyFn: s} = this._fnTypes, o = [];
            return e && o.push({
                type: this.options.markerWidthType || Uint8Array,
                width: 1,
                name: "aMarkerWidth"
            }), t && o.push({
                type: this.options.markerHeightType || Uint8Array,
                width: 1,
                name: "aMarkerHeight"
            }), (n || r) && o.push({
                type: Int8Array,
                width: 1,
                name: "aMarkerDx"
            }), (i || s) && o.push({
                type: Int8Array,
                width: 1,
                name: "aMarkerDy"
            }), o;
        }
        _prepareFnTypes() {
            this.iconAtlas || (this._fnTypes.markerWidthFn = this._fnTypes.markerHeightFn = this._fnTypes.markerDxFn = this._fnTypes.markerDyFn = this._fnTypes.markerPitchAlignmentFn = this._fnTypes.markerRotationAlignmentFn = this._fnTypes.markerRotationFn = this._fnTypes.markerAllowOverlapFn = this._fnTypes.markerIgnorePlacementFn = this._fnTypes.markerOpacityFn = null), 
            this.glyphAtlas || (this._fnTypes.textFillFn = this._fnTypes.textSizeFn = this._fnTypes.textHaloFillFn = this._fnTypes.textHaloRadiusFn = this._fnTypes.textHaloOpacityFn = this._fnTypes.textDxFn = this._fnTypes.textDyFn = this._fnTypes.textPitchAlignmentFn = this._fnTypes.textRotationAlignmentFn = this._fnTypes.textRotationFn = this._fnTypes.textAllowOverlapFn = this._fnTypes.textIgnorePlacementFn = this._fnTypes.textOpacityFn = null);
        }
        createDataPack() {
            if (!this.iconAtlas && !this.glyphAtlas) {
                if (!this.options.allowEmptyPack) return null;
                this.empty = !0;
            }
            this._prepareFnTypes(), this.countOutOfAngle = 0, this.lineVertex = [];
            const e = super.createDataPack.apply(this, arguments);
            return e ? (e.lineVertex = new Int16Array(this.lineVertex), e.buffers.push(e.lineVertex.buffer), 
            e) : null;
        }
        placeVector(e, t) {
            const n = e.getShape(this.iconAtlas, this.glyphAtlas);
            if (!n) return;
            const {iconShape: i, textShape: r} = n, o = !i || !i.image, a = !r || !r.horizontal && !r.vertical;
            if (!this.options.allowEmptyPack && o && a) return;
            const l = this._getAnchors(e, r || i, t);
            if (this.countOutOfAngle += l.countOutOfAngle || 0, 0 === l.length) return;
            const h = this.data, c = this.needAltitudeAttribute() ? 2 : 3;
            let u = this.data.aPosition.getLength() / c;
            const f = e.symbol, d = e.feature.properties, p = "line" === this._textPlacement && !f.isIconText, g = !a, m = !o, y = g && p && function(e) {
                let t = 0;
                for (let n = 0; n < e.length; n++) if (Os(e.charAt(n).charCodeAt(0))) t = 0; else if (t++, 
                t >= 1) return !1;
                return !0;
            }(e.getIconAndGlyph().glyph.text) ? 1 : 0, {textFillFn: x, textSizeFn: _, textHaloFillFn: v, textHaloRadiusFn: b, textHaloOpacityFn: A, textDxFn: T, textDyFn: I, textPitchAlignmentFn: C, textRotationAlignmentFn: k, textRotationFn: F, textAllowOverlapFn: O, textIgnorePlacementFn: R, textOpacityFn: E, markerWidthFn: D, markerHeightFn: L, markerDxFn: H, markerDyFn: z, markerPitchAlignmentFn: N, markerRotationAlignmentFn: V, markerRotationFn: B, markerAllowOverlapFn: U, markerIgnorePlacementFn: G, markerOpacityFn: j} = this._fnTypes;
            let W, X, Y, q, Z, $ = [ 0, 0, 0, 0 ], J = 14, K = [ 0, 0, 0, 0 ], Q = 0, ee = 0, te = 0, ne = 0, re = 0, se = 0, oe = 0, ae = 0, le = 0, he = 0, ce = 0, ue = 0, fe = 0, de = 0;
            if (g) {
                const t = e.getIconAndGlyph().glyph.font;
                Y = function(e, t, n) {
                    const i = e.positionedGlyphs, r = [];
                    for (let o = 0; o < i.length; o++) {
                        const a = i[o], l = n[a.glyph];
                        if (!l) continue;
                        const h = l.rect;
                        if (!h) continue;
                        const c = 4, u = l.metrics.advance / 2, f = l.metrics.height / 2, d = t ? [ a.x + u, 0 ] : [ 0, 0 ], p = t ? [ 0, a.y - f ] : [ a.x + u, a.y - f ], g = l.metrics.left - c - u + p[0], m = l.metrics.top - c + p[1], y = g + h.w, x = m + h.h, _ = new s(g, m), v = new s(y, m), b = new s(g, x), A = new s(y, x);
                        if (t && a.vertical) {
                            const e = new s(-u, u), t = -Math.PI / 2, n = new s(5, 0);
                            _._rotateAround(t, e)._add(n), v._rotateAround(t, e)._add(n), b._rotateAround(t, e)._add(n), 
                            A._rotateAround(t, e)._add(n);
                        }
                        r.push({
                            tl: _,
                            tr: v,
                            bl: b,
                            br: A,
                            tex: h,
                            writingMode: e.writingMode,
                            glyphOffset: d
                        });
                    }
                    return r;
                }(r.horizontal, p, this.glyphAtlas.positions[t]), x && ($ = x(null, d), ie($) ? this.dynamicAttrs.aTextFill = 1 : $ = ht([], $)), 
                _ && (J = _(this.options.zoom, d), M(J) && (J = 14)), v && (K = v(null, d), ie(K) ? this.dynamicAttrs.aTextHaloFill = 1 : K = ht([], K)), 
                b && (Q = b(null, d)), A && (ee = 255 * A(null, d)), T && (te = T(null, d) || 0), 
                I && (ne = I(null, d) || 0), C && (he = +("map" === C(null, d))), k && (ue = +("map" === k(null, d))), 
                F && (de = P(F(null, d), 0, 360) * Math.PI / 180);
            }
            m && (q = i ? function(e) {
                const t = e.image, n = e.top - 1 / t.pixelRatio, i = e.left - 1 / t.pixelRatio, r = e.bottom + 1 / t.pixelRatio, o = e.right + 1 / t.pixelRatio;
                let a, l, h, c;
                return a = new s(i, n), l = new s(o, n), h = new s(o, r), c = new s(i, r), [ {
                    tl: a,
                    tr: l,
                    bl: c,
                    br: h,
                    tex: {
                        x: t.tl[0],
                        y: t.tl[1],
                        w: t.displaySize[0],
                        h: t.displaySize[1]
                    },
                    writingMode: void 0,
                    glyphOffset: [ 0, 0 ]
                } ];
            }(i) : function() {
                const e = new s(0, 0), t = new s(0, 0), n = new s(0, 0);
                return [ {
                    tl: e,
                    tr: t,
                    bl: new s(0, 0),
                    br: n,
                    tex: {
                        x: 0,
                        y: 0,
                        w: 0,
                        h: 0
                    },
                    writingMode: void 0,
                    glyphOffset: [ 0, 0 ]
                } ];
            }(), D && (re = D(null, d)), M(re) && (re = q[0].tex.w), L && (se = L(null, d)), 
            M(se) && (se = q[0].tex.h), H && (oe = H(null, d)), z && (ae = z(null, d)), N && (le = +("map" === N(null, d))), 
            V && (ce = +("map" === V(null, d))), B && (fe = P(B(null, d), 0, 360) * Math.PI / 180)), 
            ie(J) && (this.dynamicAttrs.aTextSize = 1), (ie(Q) || ie(ee)) && (this.dynamicAttrs.aTextHalo = 1), 
            ie(re) && (this.dynamicAttrs.aMarkerWidth = 1), ie(se) && (this.dynamicAttrs.aMarkerHeight = 1), 
            (ie(oe) || ie(te)) && (this.dynamicAttrs.aDxDy = 1), (ie(ae) || ie(te)) && (this.dynamicAttrs.aDxDy = 1), 
            (ie(le) || ie(he)) && (this.dynamicAttrs.aPitchAlign = 1), (ie(ce) || ie(ue)) && (this.dynamicAttrs.aRotationAlign = 1), 
            (ie(fe) || ie(de)) && (this.dynamicAttrs.aRotation = 1), (U || O) && (U && (W = U(null, d) || 0), 
            !W && O && (W = O(null, d) || 0)), (G || R) && (G && (X = G(null, d) || 0), !X && R && (X = R(null, d) || 0)), 
            j && (Z = 255 * (j(this.options.zoom, d) || 0));
            let pe = 0;
            E && (pe = 255 * (E(this.options.zoom, d) || 0));
            const ge = Y && Y.length || 0;
            this.ensureDataCapacity(4 * (ge + (q && q.length || 0)), l.length);
            const me = this.options.EXTENT, {altitudeScale: ye, altitudeProperty: xe, defaultAltitude: _e} = this.options, {altitude: ve} = w(e.feature, ye, xe, _e), be = this.needAltitudeAttribute(), Ae = (e, t, n, i, r, s, o) => {
                if (!t) return;
                const a = e ? ge : 1;
                for (let l = 0; l < t.length; l++) {
                    const c = t[l], {tl: f, tr: d, bl: g, br: m, tex: x} = c;
                    let _;
                    this._fillPos(h, n, i, r, 10 * f.x, 10 * f.y, x.x, x.y + x.h, e, o), this._fillTextData(h, p, a, c.glyphOffset, s, y, s.axis, s.angleR), 
                    this._fillFnTypeData(h, $, J, K, Q, ee, te, ne, re, se, oe, ae, Z, pe, le, he, ce, ue, fe, de, W, X), 
                    this._fillPos(h, n, i, r, 10 * d.x, 10 * d.y, x.x + x.w, x.y + x.h, e, o), this._fillTextData(h, p, a, c.glyphOffset, s, y, s.axis, s.angleR), 
                    this._fillFnTypeData(h, $, J, K, Q, ee, te, ne, re, se, oe, ae, Z, pe, le, he, ce, ue, fe, de, W, X), 
                    this._fillPos(h, n, i, r, 10 * g.x, 10 * g.y, x.x, x.y, e, o), this._fillTextData(h, p, a, c.glyphOffset, s, y, s.axis, s.angleR), 
                    this._fillFnTypeData(h, $, J, K, Q, ee, te, ne, re, se, oe, ae, Z, pe, le, he, ce, ue, fe, de, W, X), 
                    this._fillPos(h, n, i, r, 10 * m.x, 10 * m.y, x.x + x.w, x.y, e, o), this._fillTextData(h, p, a, c.glyphOffset, s, y, s.axis, s.angleR), 
                    this._fillFnTypeData(h, $, J, K, Q, ee, te, ne, re, se, oe, ae, Z, pe, le, he, ce, ue, fe, de, W, X), 
                    this.addElements(u, u + 1, u + 2), this.addElements(u + 1, u + 2, u + 3), u += 4, 
                    _ = be ? Math.max(Math.abs(n), Math.abs(i)) : Math.max(Math.abs(n), Math.abs(i), Math.abs(r)), 
                    _ > this.maxPos && (this.maxPos = _);
                }
            }, Te = "text" === this.options.pluginType;
            for (let e = 0; e < l.length; e++) {
                const t = l[e], n = t.z || ve || 0;
                if (me !== 1 / 0 && S(t, me)) continue;
                const i = t.x, r = t.y;
                m && Ae(!1, q, i, r, n, t), g && (Te || Ae(!0, Y, i, r, n, t, !0), Ae(!0, Y, i, r, n, t, !1));
            }
        }
        _fillPos(e, t, n, i, r, s, o, a, l, h) {
            this.fillPosition(e, t, n, i);
            let c = e.aShape.currentIndex;
            e.aShape[c++] = r, e.aShape[c++] = s, e.aShape.currentIndex = c, e.aTexCoord ? (c = e.aTexCoord.currentIndex, 
            e.aTexCoord[c++] = o, e.aTexCoord[c++] = a, e.aTexCoord.currentIndex = c) : (c = e.aShape.currentIndex, 
            "text" !== this.options.pluginType ? (e.aShape[c++] = +!!l + (o << 1), e.aShape[c++] = +!!h + (a << 1)) : (e.aShape[c++] = o, 
            e.aShape[c++] = a), e.aShape.currentIndex = c);
        }
        _fillTextData(e, t, n, i, r, s, o, a) {
            let l = e.aCount.currentIndex;
            if (e.aCount[l++] = n, e.aCount.currentIndex = l, t) {
                l = e.aGlyphOffset.currentIndex, e.aGlyphOffset[l++] = i[0], e.aGlyphOffset[l++] = i[1], 
                e.aGlyphOffset.currentIndex = l, this._is3DPitchText() && (l = e.aPitchRotation.currentIndex, 
                e.aPitchRotation[l++] = o[0], e.aPitchRotation[l++] = o[1], e.aPitchRotation[l++] = a, 
                e.aPitchRotation.currentIndex = l);
                const t = r.startIndex;
                l = e.aSegment.currentIndex, e.aSegment[l++] = r.segment + t, e.aSegment[l++] = t, 
                e.aSegment[l++] = r.line.length, e.aSegment.currentIndex = l, l = e.aVertical.currentIndex, 
                e.aVertical[l++] = s, e.aVertical.currentIndex = l;
            }
        }
        _fillFnTypeData(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p, g, m, y, x, _, v, b) {
            const {textFillFn: A, textSizeFn: T, textHaloFillFn: w, textHaloRadiusFn: S, textDxFn: P, textDyFn: I, textPitchAlignmentFn: C, textRotationAlignmentFn: k, textRotationFn: F, textAllowOverlapFn: O, textIgnorePlacementFn: R, textOpacityFn: E, textHaloOpacityFn: D, markerWidthFn: L, markerHeightFn: H, markerDxFn: z, markerDyFn: N, markerPitchAlignmentFn: V, markerRotationAlignmentFn: B, markerRotationFn: U, markerAllowOverlapFn: G, markerIgnorePlacementFn: j, markerOpacityFn: W} = this._fnTypes;
            if (A) {
                let n = e.aTextFill.currentIndex;
                e.aTextFill[n++] = t[0], e.aTextFill[n++] = t[1], e.aTextFill[n++] = t[2], e.aTextFill[n++] = t[3], 
                e.aTextFill.currentIndex = n;
            }
            if (T) {
                let t = e.aTextSize.currentIndex;
                e.aTextSize[t++] = n, e.aTextSize.currentIndex = t;
            }
            if (w) {
                let t = e.aTextHaloFill.currentIndex;
                e.aTextHaloFill[t++] = i[0], e.aTextHaloFill[t++] = i[1], e.aTextHaloFill[t++] = i[2], 
                e.aTextHaloFill[t++] = i[3], e.aTextHaloFill.currentIndex = t;
            }
            if (S || D) {
                let t = e.aTextHalo.currentIndex;
                e.aTextHalo[t++] = r || 0, e.aTextHalo.currentIndex = t, t = e.aTextHalo.currentIndex, 
                e.aTextHalo[t++] = 255 * (M(s) ? 1 : s), e.aTextHalo.currentIndex = t;
            }
            if (P) {
                let t = e.aTextDx.currentIndex;
                e.aTextDx[t++] = o, e.aTextDx.currentIndex = t;
            }
            if (I) {
                let t = e.aTextDy.currentIndex;
                e.aTextDy[t++] = a, e.aTextDy.currentIndex = t;
            }
            if (L) {
                let t = e.aMarkerWidth.currentIndex;
                e.aMarkerWidth[t++] = l, e.aMarkerWidth.currentIndex = t;
            }
            if (H) {
                let t = e.aMarkerHeight.currentIndex;
                e.aMarkerHeight[t++] = h, e.aMarkerHeight.currentIndex = t;
            }
            if (z) {
                let t = e.aMarkerDx.currentIndex;
                e.aMarkerDx[t++] = c, e.aMarkerDx.currentIndex = t;
            }
            if (N) {
                let t = e.aMarkerDy.currentIndex;
                e.aMarkerDy[t++] = u, e.aMarkerDy.currentIndex = t;
            }
            const X = "text" === this.options.pluginType;
            if (!X && (W || E)) {
                W || (f = 255);
                let t = e.aColorOpacity.currentIndex;
                e.aColorOpacity[t++] = f, e.aColorOpacity.currentIndex = t, f = E ? d : 255, t = e.aColorOpacity.currentIndex, 
                e.aColorOpacity[t++] = f, e.aColorOpacity.currentIndex = t;
            }
            if (X && E) {
                let t = e.aColorOpacity.currentIndex;
                e.aColorOpacity[t++] = d, e.aColorOpacity.currentIndex = t;
            }
            if (C || V) if (X) {
                let t = e.aPitchAlign.currentIndex;
                e.aPitchAlign[t++] = g, e.aPitchAlign.currentIndex = t;
            } else {
                let t = e.aPitchAlign.currentIndex;
                e.aPitchAlign[t++] = p, e.aPitchAlign.currentIndex = t, t = e.aPitchAlign.currentIndex, 
                e.aPitchAlign[t++] = g, e.aPitchAlign.currentIndex = t;
            }
            if (B || k) if (X) {
                let t = e.aRotationAlign.currentIndex;
                e.aRotationAlign[t++] = y, e.aRotationAlign.currentIndex = t;
            } else {
                let t = e.aRotationAlign.currentIndex;
                e.aRotationAlign[t++] = m, e.aRotationAlign.currentIndex = t, t = e.aRotationAlign.currentIndex, 
                e.aRotationAlign[t++] = y, e.aRotationAlign.currentIndex = t;
            }
            if (U || F) if (X) {
                let t = e.aRotation.currentIndex;
                e.aRotation[t++] = 9362 * _, e.aRotation.currentIndex = t;
            } else {
                let t = e.aRotation.currentIndex;
                e.aRotation[t++] = 9362 * x, e.aRotation.currentIndex = t, t = e.aRotation.currentIndex, 
                e.aRotation[t++] = 9362 * _, e.aRotation.currentIndex = t;
            }
            const Y = G || O, q = j || R;
            if (Y || q) {
                const t = (Y ? 8 : 0) + 4 * v, n = (q ? 2 : 0) + b;
                let i = e.aOverlap.currentIndex;
                e.aOverlap[i++] = t + n, e.aOverlap.currentIndex = i;
            }
            r > 0 && (this.properties.hasHalo = 1);
        }
        _getAnchors(e, t, n) {
            const {feature: i, symbol: r} = e, s = this._getPlacement(e, r), o = i.properties, {markerSpacingFn: a, textSpacingFn: l, textMaxAngleFn: h} = this._fnTypes, c = ((a ? a(null, o) : r.markerSpacing) || (l ? l(null, o) : r.textSpacing) || 250) * n;
            let u = h ? h(this.options.zoom, o) : r.textMaxAngle;
            M(u) && (u = 80), u *= Math.PI / 180;
            const f = this.options.EXTENT, d = this.options.altitudeToTileScale, p = this._is3DPitchText();
            return yo(e, this.lineVertex, u, t, n, f, s, c, p, d);
        }
        _getPlacement(e, t) {
            let n;
            return n = this._fnTypes.markerPlacementFn ? this._fnTypes.markerPlacementFn(this.options.zoom, e.feature.properties) : t.markerPlacement || this._textPlacement, 
            this._packMarkerPlacement || !t.markerPlacement && !t.isIconText || (this._packMarkerPlacement = n), 
            !this._textPlacement || t.isIconText || this._packTextPlacement || (this._packTextPlacement = n), 
            n;
        }
        getPackSDFFormat(e) {
            if ("line" !== this._textPlacement || e.isIconText) return [ ...this.getPositionFormat(), {
                type: Int16Array,
                width: 4,
                name: "aShape"
            }, {
                type: Uint8Array,
                width: 1,
                name: "aCount"
            } ];
            {
                const e = [ ...this.getPositionFormat(), {
                    type: Int16Array,
                    width: 2,
                    name: "aShape"
                }, {
                    type: Uint16Array,
                    width: 2,
                    name: "aTexCoord"
                }, {
                    type: Uint8Array,
                    width: 1,
                    name: "aCount"
                }, {
                    type: Int16Array,
                    width: 2,
                    name: "aGlyphOffset"
                }, {
                    type: Uint16Array,
                    width: 3,
                    name: "aSegment"
                }, {
                    type: Uint8Array,
                    width: 1,
                    name: "aVertical"
                } ];
                return this._is3DPitchText() && e.push({
                    type: Float32Array,
                    width: 3,
                    name: "aPitchRotation"
                }), e;
            }
        }
    }
    class wo {
        constructor(e) {
            this.x = e.x, this.y = e.y, this.z = e.z || 0;
        }
        clone() {
            return new wo(this);
        }
        _unit() {
            return this._div(this.mag()), this;
        }
        _div(e) {
            return this.x /= e, this.y /= e, this.z /= e, this;
        }
        _perp() {
            var e = this.y;
            return this.y = this.x, this.x = -e, this;
        }
        mag() {
            return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
        }
        add(e) {
            return this.clone()._add(e);
        }
        sub(e) {
            return this.clone()._sub(e);
        }
        _add(e) {
            return this.x += e.x, this.y += e.y, this.z += e.z, this;
        }
        _sub(e) {
            return this.x -= e.x, this.y -= e.y, this.z -= e.z, this;
        }
        equals(e) {
            return this.x === e.x && this.y === e.y && this.z === e.z;
        }
        mult(e) {
            return this.clone()._mult(e);
        }
        _mult(e) {
            return this.x *= e, this.y *= e, this.z *= e, this;
        }
        dist(e) {
            return Math.sqrt(this.distSqr(e));
        }
        distSqr(e) {
            var t = e.x - this.x, n = e.y - this.y, i = e.z - this.z;
            return t * t + n * n + i * i;
        }
        _round() {
            return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), 
            this;
        }
        angleTo(e) {
            return Math.atan2(this.y - e.y, this.x - e.x);
        }
    }
    var So, Mo = "undefined" != typeof Float32Array ? Float32Array : Array;
    function Po(e, t, n, i) {
        return e[0] = t, e[1] = n, e[2] = i, e;
    }
    function Io(e, t) {
        var n = t[0], i = t[1], r = t[2], s = n * n + i * i + r * r;
        return s > 0 && (s = 1 / Math.sqrt(s)), e[0] = t[0] * s, e[1] = t[1] * s, e[2] = t[2] * s, 
        e;
    }
    function Co(e, t, n) {
        var i = t[0], r = t[1], s = t[2], o = n[0], a = n[1], l = n[2];
        return e[0] = r * l - s * a, e[1] = s * o - i * l, e[2] = i * a - r * o, e;
    }
    function ko(e, t, n, i, r) {
        return e[0] = t, e[1] = n, e[2] = i, e[3] = r, e;
    }
    function Fo(e, t, n) {
        return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e;
    }
    function Oo(e, t, n) {
        return e[0] = t, e[1] = n, e;
    }
    Math.hypot || (Math.hypot = function() {
        for (var e = 0, t = arguments.length; t--; ) e += arguments[t] * arguments[t];
        return Math.sqrt(e);
    }), So = new Mo(3), Mo != Float32Array && (So[0] = 0, So[1] = 0, So[2] = 0), function() {
        var e = new Mo(4);
        Mo != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0);
    }();
    !function() {
        var e = new Mo(2);
        Mo != Float32Array && (e[0] = 0, e[1] = 0);
    }();
    const Ro = 63, Eo = Math.cos(Math.PI / 180 * 37.5), Do = Math.pow(2, 16) / 1, Lo = new s, Ho = new s, zo = new s;
    class No extends gs {
        static mergeLineFeatures(e, t, n, i) {
            return Ao(e, t, n, i);
        }
        constructor(e, t, n) {
            super(e, t, n);
            let i = !1;
            const {lineDasharrayFn: r, lineDashColorFn: s} = this._fnTypes;
            this.hasGradient = this.symbol.lineGradientProperty, r && (i = function(e, t, n) {
                for (let i = 0; i < e.length; i++) if (n(t, e[i].properties)) return !0;
                return !1;
            }(e, this.options.zoom, r), i && (this.dasharrayFn = r)), this.hasDasharray = Uo(this.symbol.lineDasharray) || i, 
            this.hasDasharray && s && (this.dashColorFn = s);
        }
        createStyledVector(e, t, n, i, r) {
            const s = new dt(e, t, n, i), o = s.getLineResource();
            return !this.options.atlas && o && (r[o] = [ 0, 0 ]), s;
        }
        getFormat() {
            const {lineWidthFn: e, lineStrokeWidthFn: t, lineStrokeColorFn: n, lineColorFn: i, lineOpacityFn: r, lineDxFn: s, lineDyFn: o, linePatternAnimSpeedFn: a, linePatternGapFn: l} = this._fnTypes, h = [ ...this.getPositionFormat() ];
            if (this.iconAtlas || this.hasDasharray ? h.push({
                type: Int8Array,
                width: 3,
                name: "aExtrude"
            }) : h.push({
                type: Int8Array,
                width: 2,
                name: "aExtrude"
            }), h.push({
                type: this.options.positionType || Uint16Array,
                width: 1,
                name: "aLinesofar"
            }), e && h.push({
                type: Uint8Array,
                width: 1,
                name: "aLineWidth"
            }), t && h.push({
                type: Uint8Array,
                width: 1,
                name: "aLineStrokeWidth"
            }), i && h.push({
                type: Uint8Array,
                width: 4,
                name: "aColor"
            }), n && h.push({
                type: Uint8Array,
                width: 4,
                name: "aStrokeColor"
            }), r && h.push({
                type: Uint8Array,
                width: 1,
                name: "aOpacity"
            }), this.dasharrayFn && h.push({
                type: Uint8Array,
                width: 4,
                name: "aDasharray"
            }), this.dashColorFn && h.push({
                type: Uint8Array,
                width: 4,
                name: "aDashColor"
            }), this.iconAtlas) {
                const e = this.getIconAtlasMaxValue();
                h.push({
                    type: e > 255 ? Uint16Array : Uint8Array,
                    width: 4,
                    name: "aTexInfo"
                });
            }
            return (s || o) && h.push({
                type: Int8Array,
                width: 2,
                name: "aLineDxDy"
            }), (a || l) && h.push({
                type: Int8Array,
                width: 2,
                name: "aLinePattern"
            }), h;
        }
        placeVector(e) {
            const {lineJoinFn: t, lineCapFn: n, lineWidthFn: i, lineHeightFn: r, lineStrokeWidthFn: s, lineStrokeColorFn: o, lineColorFn: a, lineOpacityFn: l, lineDxFn: h, lineDyFn: c, linePatternAnimSpeedFn: u, linePatternGapFn: f} = this._fnTypes, d = this.symbol, p = e.feature, g = p.properties;
            this.elements;
            let m = d.lineJoin || "miter", y = d.lineCap || "butt";
            if (t && (m = t(this.options.zoom, g) || "miter"), n && (y = n(this.options.zoom, g) || "butt"), 
            i) {
                let e = i(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLineWidth = 1, e = 4), Je(e) && (e = 4), this.feaLineWidth = +e;
            } else this.feaLineWidth = +d.lineWidth;
            if (r) {
                let e = r(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLineHeight = 1), Je(e) && (e = this.feaLineWidth), 
                this.feaLineHeight = +e;
            } else this.feaLineHeight = +d.lineHeight || this.feaLineWidth;
            if (s) {
                let e = s(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLineStrokeWidth = 1, e = 0), Je(e) && (e = 0), this.feaLineStrokeWidth = e;
            } else this.feaLineStrokeWidth = d.lineStrokeWidth || 0;
            if (a && (this.feaColor = a(this.options.zoom, g) || [ 255, 255, 255, 255 ], ie(this.feaColor) ? (this.dynamicAttrs.aColor = 1, 
            this.feaColor = [ 0, 0, 0, 0 ]) : this.feaColor = ht([], this.feaColor)), o && (this.feaStrokeColor = o(this.options.zoom, g) || [ 0, 0, 0, 255 ], 
            ie(this.feaStrokeColor) ? (this.dynamicAttrs.aStrokeColor = 1, this.feaStrokeColor = [ 0, 0, 0, 0 ]) : this.feaStrokeColor = ht([], this.feaStrokeColor)), 
            l) {
                let e = l(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aOpacity = 1, e = 1), Je(e) && (e = 1), this.feaOpacity = 255 * e;
            }
            if (this.dasharrayFn) {
                let e = this.dasharrayFn(this.options.zoom, g) || [ 0, 0, 0, 0 ];
                if (ie(e) && (this.dynamicAttrs.aDasharray = 1, e = [ 0, 0, 0, 0 ]), e.length < 4) {
                    const t = e;
                    1 === e.length ? e = [ t[0], t[0], t[0], t[0] ] : 2 === e.length ? e = [ t[0], t[1], t[0], t[1] ] : 3 === e.length && (e = [ t[0], t[1], t[2], t[2] ]);
                }
                this.feaDash = e;
            }
            if (this.dashColorFn) {
                let e = (this.dashColorFn ? this.dashColorFn(this.options.zoom, g) : this.symbol.lineDashColor) || [ 0, 0, 0, 0 ];
                ie(e) && (this.dynamicAttrs.aDashColor = 1, e = [ 0, 0, 0, 0 ]), e = ht([], e), 
                this.feaDashColor = e;
            }
            if (this.iconAtlas) {
                const t = e.getLineResource(), n = this.iconAtlas.iconMap[t];
                if (this.feaTexInfo = this.feaTexInfo || [ 0, 0, 0, 0 ], n) {
                    const {tl: e, displaySize: n} = this.iconAtlas.positions[t];
                    this.feaTexInfo[0] = e[0] + 1, this.feaTexInfo[1] = e[1] + 1, this.feaTexInfo[2] = n[0] - 3, 
                    this.feaTexInfo[3] = n[1] - 3;
                } else this.feaTexInfo[0] = this.feaTexInfo[1] = this.feaTexInfo[2] = this.feaTexInfo[3] = 0;
            }
            if (h) {
                let e = h(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLineDxDy = 1, e = 0), Je(e) && (e = 0), this.feaLineDx = e;
            }
            if (c) {
                let e = c(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLineDxDy = 1, e = 0), Je(e) && (e = 0), this.feaLineDy = e;
            }
            if (u) {
                let e = u(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLinePatternAnimSpeed = 1, e = 0), Je(e) && (e = 0), 
                0 !== e && (this.properties.hasPatternAnim = 1), this.feaPatternAnimSpeed = e;
            }
            if (f) {
                let e = f(this.options.zoom, g);
                ie(e) && (this.dynamicAttrs.aLinePatternGap = 1, e = 0), Je(e) && (e = 0), this.feaLinePatternGap = e;
            }
            const x = this.options.EXTENT;
            let _ = p.geometry;
            if (x !== 1 / 0) {
                _ = [];
                const e = [];
                for (let t = 0; t < p.geometry.length; t++) {
                    e[0] = p.geometry[t];
                    const n = eo(e, -1, -1, x + 1, x + 1);
                    if (3 === p.type && n.length > 1) {
                        const e = n[0], t = n[n.length - 1];
                        Xo(e[0], t[t.length - 1]) && (n[0] = t.concat(e.slice(1)), n.length = n.length - 1);
                    }
                    _.push(...n);
                }
            }
            const v = this.needAltitudeAttribute() ? 2 : 3;
            for (let e = 0; e < _.length; e++) {
                this.offset = this.data.aPosition.getLength() / v;
                const t = _[e];
                this._addLine(t, p, m, y, 2, 1.05);
            }
        }
        _hasPattern() {
            return this.iconAtlas && this.feaTexInfo[2] && this.feaTexInfo[3];
        }
        _addLine(e, t, n, i, r, s) {
            const o = this._hasPattern() || Uo(this.feaDash) || Uo(this.symbol.lineDasharray), a = this.options.isTube;
            a && (e = e.map((e => new wo(e)))), this.overscaling = 1;
            const l = this.options.EXTENT;
            if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.prevVertex = null, 
            this.symbol.lineGradientProperty && t.properties && Ke(t.properties.mapbox_clip_start) && Ke(t.properties.mapbox_clip_end)) {
                this.clipStart = +t.properties.mapbox_clip_start, this.clipEnd = +t.properties.mapbox_clip_end;
                for (let t = 0; t < e.length - 1; t++) this.totalDistance += e[t].dist(e[t + 1]);
                this.updateScaledDistance();
            }
            const h = 3 === t.type && !e.clipped;
            let c = e.length;
            for (;c >= 2 && Xo(e[c - 1], e[c - 2]); ) c--;
            let u = 0;
            for (;u < c - 1 && Xo(e[u], e[u + 1]); ) u++;
            if (c < (h ? 3 : 2)) return;
            "bevel" === n && (r = 1.05);
            const f = this.overscaling <= 16 ? 15 * l / (512 * this.overscaling) : 0, d = {
                vertexLength: 0,
                primitiveLength: 0,
                currentNormal: null
            };
            let p, g, m, y, x;
            this.e1 = this.e2 = -1, h && (p = e[c - 2], x = e[u].sub(p)._unit()._perp()), this.ensureDataCapacity(n, c, 360, 2);
            for (let t = u; t < c; t++) {
                if (m = t === c - 1 ? h ? e[u + 1] : void 0 : e[t + 1], m && Xo(e[t], m)) continue;
                x && (y = x), p && (g = p), p = e[t], m && p.x === m.x && p.y === m.y && (p.x += 1e-4), 
                x = m ? m.sub(p)._unit()._perp() : y, d.dir = g ? p.sub(g)._unit() : m.sub(p)._unit(), 
                y = y || x, d.currentNormal = y;
                let l = y.add(x);
                0 === l.x && 0 === l.y || l._unit();
                const _ = y.x * x.x + y.y * x.y, v = l.x * x.x + l.y * x.y, b = 0 !== v ? 1 / v : 1 / 0, A = 2 * Math.sqrt(2 - 2 * v), T = v < Eo && g && m, w = y.x * x.y - y.y * x.x > 0;
                if (!a && T && t > u) {
                    const e = p.dist(g);
                    if (e > 2 * f) {
                        const t = p.sub(p.sub(g)._mult(f / e)._round());
                        t.z = p.z, this.updateDistance(g, t), this.addCurrentVertex(t, y, 0, 0, d), g = t;
                    }
                }
                const S = g && m;
                d.middleVertex = S;
                let M = S ? n : h ? "butt" : i;
                if (S && "round" === M && (b < s ? M = "miter" : b <= 2 && (M = "fakeround")), "miter" === M && b > r && !a && (M = "bevel"), 
                "bevel" === M && (b > 2 && (M = "flipbevel"), b < r && (M = "miter")), g && this.updateDistance(g, p), 
                "miter" === M) a ? (this.addCurrentVertex(p, y, 0, 0, d), d.dir = m.sub(p)._unit(), 
                this.addCurrentVertex(p, x, 0, 0, d)) : (l._mult(b), this.addCurrentVertex(p, l, 0, 0, d), 
                o && (d.currentNormal = x, d.dir = m.sub(p)._unit(), this.addCurrentVertex(p, l, 0, 0, d))); else if ("flipbevel" === M) {
                    if (b > 100) l = x.mult(-1); else {
                        const e = b * y.add(x).mag() / y.sub(x).mag();
                        l._perp()._mult(e * (w ? -1 : 1));
                    }
                    this.addCurrentVertex(p, l, 0, 0, d), this.addCurrentVertex(p, l.mult(-1), 0, 0, d);
                } else if ("bevel" === M || "fakeround" === M) {
                    const e = -Math.sqrt(b * b - 1), t = w ? e : 0, n = w ? 0 : e;
                    if (g && this.addCurrentVertex(p, y, t, n, d), "fakeround" === M) {
                        const e = Math.round(180 * A / Math.PI / 20);
                        for (let t = 1; t < e; t++) {
                            let n = t / e;
                            if (.5 !== n) {
                                const e = n - .5;
                                n += n * e * (n - 1) * ((1.0904 + _ * (_ * (3.55645 - 1.43519 * _) - 3.2452)) * e * e + (.848013 + _ * (.215638 * _ - 1.06021)));
                            }
                            const i = x.sub(y)._mult(n)._add(y)._unit()._mult(w ? -1 : 1);
                            this.addHalfVertex(p, i.x, i.y, !1, w, 0, d);
                        }
                    }
                    m && (d.currentNormal = x, d.dir = m.sub(p)._unit(), this.addCurrentVertex(p, x, -t, -n, d));
                } else if ("butt" === M) this.addCurrentVertex(p, l, 0, 0, d); else if ("square" === M) {
                    const e = g ? 1 : -1;
                    this.addCurrentVertex(p, l, e, e, d);
                } else "round" === M && (g && (this.addCurrentVertex(p, y, 0, 0, d), this.addCurrentVertex(p, y, 1, 1, d, !0)), 
                m && (this.addCurrentVertex(p, x, -1, -1, d, !0), this.addCurrentVertex(p, x, 0, 0, d)));
                if (!a && T && t < c - 1) {
                    const e = p.dist(m);
                    if (e > 2 * f) {
                        const t = p.add(m.sub(p)._mult(f / e)._round());
                        t.z = p.z, this.updateDistance(p, t), this.addCurrentVertex(t, x, 0, 0, d), p = t;
                    }
                }
            }
        }
        ensureDataCapacity(e, t, n, i) {
            const r = "round" === e ? Math.round(n / 20) - 1 : 0;
            super.ensureDataCapacity((6 + r) * i, t);
        }
        addCurrentVertex(e, t, n, i, r, s = !1) {
            const o = t.x + t.y * n, a = t.y - t.x * n, l = -t.x + t.y * i, h = -t.y - t.x * i;
            let c = 0, u = 0;
            if (r.middleVertex) {
                Lo.x = o, Lo.y = a;
                const e = r.currentNormal;
                if (c = Wo(e, Lo, r.dir), 0 === n && 0 === i) u = -c; else {
                    const t = Ho;
                    t.x = e.x, t.y = e.y, t._mult(-1), zo.x = l, zo.y = h, u = Wo(t, zo, r.dir);
                }
            }
            this.addHalfVertex(e, o, a, s, !1, n, r, c), this.addHalfVertex(e, l, h, s, !0, -i, r, u), 
            this.prevVertex && Xo(e, this.prevVertex) || (this.prevVertex = e), this.distance > Do / 2 && 0 === this.totalDistance && (this.distance = 0, 
            this.updateScaledDistance(), this.addCurrentVertex(e, t, n, i, r, s));
        }
        addHalfVertex({x: e, y: t, z: n}, i, r, s, o, a, l, h) {
            const c = 1 * this.scaledDistance;
            this.fillData(this.data, e, t, n || 0, i, r, s, o, c, h);
            const u = l.vertexLength++;
            this.e1 >= 0 && this.e2 >= 0 && (this.addElements(this.e1, this.e2, u), l.primitiveLength++), 
            o ? this.e2 = u : this.e1 = u;
        }
        fillData(e, t, n, i, r, s, o, a, l, h) {
            const {lineWidthFn: c, lineStrokeWidthFn: u, lineStrokeColorFn: f, lineColorFn: d, lineOpacityFn: p, lineDxFn: g, lineDyFn: m, linePatternAnimSpeedFn: y, linePatternGapFn: x} = this._fnTypes;
            this.fillPosition(e, t, n, i);
            let _ = Ro * r;
            _ = (Math.sign(_) || 1) * ((Math.floor(Math.abs(_)) >> 1 << 1) + +o);
            let v = Ro * s;
            v = (Math.sign(v) || 1) * ((Math.floor(Math.abs(v)) >> 1 << 1) + +a);
            let b = e.aExtrude.currentIndex;
            e.aExtrude[b++] = _, e.aExtrude[b++] = v, (this.iconAtlas || this.hasDasharray) && (e.aExtrude[b++] = Ro * h), 
            e.aExtrude.currentIndex = b, b = e.aLinesofar.currentIndex, e.aLinesofar[b++] = l, 
            e.aLinesofar.currentIndex = b, c && (b = e.aLineWidth.currentIndex, e.aLineWidth[b++] = Math.round(2 * this.feaLineWidth), 
            e.aLineWidth.currentIndex = b), u && (b = e.aLineStrokeWidth.currentIndex, e.aLineStrokeWidth[b++] = Math.round(2 * this.feaLineStrokeWidth), 
            e.aLineStrokeWidth.currentIndex = b), d && (b = e.aColor.currentIndex, e.aColor[b++] = this.feaColor[0], 
            e.aColor[b++] = this.feaColor[1], e.aColor[b++] = this.feaColor[2], e.aColor[b++] = this.feaColor[3], 
            e.aColor.currentIndex = b), f && (b = e.aStrokeColor.currentIndex, e.aStrokeColor[b++] = this.feaStrokeColor[0], 
            e.aStrokeColor[b++] = this.feaStrokeColor[1], e.aStrokeColor[b++] = this.feaStrokeColor[2], 
            e.aStrokeColor[b++] = this.feaStrokeColor[3], e.aStrokeColor.currentIndex = b), 
            p && (b = e.aOpacity.currentIndex, e.aOpacity[b++] = this.feaOpacity, e.aOpacity.currentIndex = b), 
            this.dasharrayFn && (b = e.aDasharray.currentIndex, e.aDasharray[b++] = this.feaDash[0], 
            e.aDasharray[b++] = this.feaDash[1], e.aDasharray[b++] = this.feaDash[2], e.aDasharray[b++] = this.feaDash[3], 
            e.aDasharray.currentIndex = b), this.dashColorFn && (b = e.aDashColor.currentIndex, 
            e.aDashColor[b++] = this.feaDashColor[0], e.aDashColor[b++] = this.feaDashColor[1], 
            e.aDashColor[b++] = this.feaDashColor[2], e.aDashColor[b++] = this.feaDashColor[3], 
            e.aDashColor.currentIndex = b), this.iconAtlas && (b = e.aTexInfo.currentIndex, 
            e.aTexInfo[b++] = this.feaTexInfo[0], e.aTexInfo[b++] = this.feaTexInfo[1], e.aTexInfo[b++] = this.feaTexInfo[2], 
            e.aTexInfo[b++] = this.feaTexInfo[3], e.aTexInfo.currentIndex = b), (g || m) && (b = e.aLineDxDy.currentIndex, 
            e.aLineDxDy[b++] = this.feaLineDx || 0, e.aLineDxDy[b++] = this.feaLineDy || 0, 
            e.aLineDxDy.currentIndex = b), (y || x) && (b = e.aLinePattern.currentIndex, e.aLinePattern[b++] = 127 * (this.feaPatternAnimSpeed || 0), 
            e.aLinePattern[b++] = 10 * (this.feaLinePatternGap || 0), e.aLinePattern.currentIndex = b), 
            this.maxPos = Math.max(this.maxPos, Math.abs(t) + 1, Math.abs(n) + 1);
        }
        addElements(e, t, n) {
            super.addElements(this.offset + e, this.offset + t, this.offset + n);
        }
        _filterPolygonEdges(e) {
            const t = this.options.EXTENT, n = this.elements;
            for (let i = 0; i < n.length; i += 3) if (t === 1 / 0 || !Bo(this.data.aPosition, n[i], n[i + 1], 3, t) && !Bo(this.data.aPosition, n[i + 1], n[i + 2], 3, t)) {
                let t = e.currentIndex;
                e[t++] = n[i], e[t++] = n[i + 1], e[t++] = n[i + 2], e.currentIndex = t;
            }
        }
        _filterLine(e) {
            if (e.length <= 1) return e;
            const t = [], n = this.options.EXTENT;
            let i, r = !0;
            for (i = 0; i < e.length - 1; i++) {
                const s = Vo(e[i], e[i + 1], n);
                s && r || (t.push(e[i]), r = s);
            }
            return r || t.push(e[i]), t;
        }
        updateDistance(e, t) {
            if (this.options.isTube) {
                const n = e.dist(t), i = ot(this.options) * (t.z - e.z);
                this.distance += Math.sqrt(n * n + i * i);
            } else this.distance += e.dist(t);
            this.updateScaledDistance();
        }
        updateScaledDistance() {
            this.scaledDistance = this.totalDistance > 0 ? (this.clipStart + (this.clipEnd - this.clipStart) * this.distance / this.totalDistance) * (Do - 1) : this.distance;
        }
    }
    function Vo(e, t, n) {
        return n !== 1 / 0 && (e.x < 0 && t.x < 0 || e.x > n && t.x > n || e.y < 0 && t.y < 0 || e.y > n && t.y > n);
    }
    function Bo(e, t, n, i, r) {
        if (r === 1 / 0) return !1;
        const s = Math.floor(.5 * e[t * i]), o = Math.floor(.5 * e[t * i + 1]), a = Math.floor(.5 * e[n * i]), l = Math.floor(.5 * e[n * i + 1]);
        return s === a && (s < 0 || s > r) && o !== l || o === l && (o < 0 || o > r) && s !== a;
    }
    function Uo(e) {
        if (!Array.isArray(e)) return !1;
        for (let t = 0; t < e.length; t++) if (e[t]) return !0;
        return !1;
    }
    const Go = [], jo = [];
    function Wo(e, t, n) {
        const i = e.mag(), r = t.mag();
        Oo(Go, n.x, n.y), Oo(jo, t.x, t.y);
        const s = (a = jo, (o = Go)[0] * a[0] + o[1] * a[1]);
        var o, a;
        return -Math.sign(s) * Math.sqrt(r * r - i * i);
    }
    function Xo(e, t) {
        return e.equals(t) && e.z === t.z;
    }
    var Yo = "undefined" != typeof Float32Array ? Float32Array : Array;
    function qo(e, t, n, i) {
        return e[0] = t, e[1] = n, e[2] = i, e;
    }
    var Zo = function(e, t, n) {
        return e[0] = t[0] - n[0], e[1] = t[1] - n[1], e[2] = t[2] - n[2], e;
    };
    !function() {
        var e = new Yo(3);
        Yo != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0);
    }();
    const $o = [], Jo = [], Ko = [], Qo = [], ea = [], ta = [], na = [], ia = [];
    function ra(e, t, n, i, r, s) {
        qo(ea, e[3 * t], e[3 * t + 1], e[3 * t + 2]), qo(ta, e[3 * n], e[3 * n + 1], e[3 * n + 2]), 
        qo(na, e[3 * i], e[3 * i + 1], e[3 * i + 2]);
        const o = Zo(Jo, na, ta), a = Zo(Ko, ea, ta), l = function(e, t, n) {
            var i = t[0], r = t[1], s = t[2], o = n[0], a = n[1], l = n[2];
            return e[0] = r * l - s * a, e[1] = s * o - i * l, e[2] = i * a - r * o, e;
        }(Qo, o, a);
        !function(e, t) {
            var n = t[0], i = t[1], r = t[2], s = n * n + i * i + r * r;
            s > 0 && (s = 1 / Math.sqrt(s), e[0] = t[0] * s, e[1] = t[1] * s, e[2] = t[2] * s);
        }(ia, l), r[3 * t] = r[3 * t] || 0, r[3 * n] = r[3 * n] || 0, r[3 * i] = r[3 * i] || 0, 
        r[3 * t + 1] = r[3 * t + 1] || 0, r[3 * n + 1] = r[3 * n + 1] || 0, r[3 * i + 1] = r[3 * i + 1] || 0, 
        r[3 * t + 2] = r[3 * t + 2] || 0, r[3 * n + 2] = r[3 * n + 2] || 0, r[3 * i + 2] = r[3 * i + 2] || 0, 
        r[3 * t] += ia[0], r[3 * n] += ia[0], r[3 * i] += ia[0], r[3 * t + 1] += ia[1], 
        r[3 * n + 1] += ia[1], r[3 * i + 1] += ia[1], r[3 * t + 2] += ia[2], r[3 * n + 2] += ia[2], 
        r[3 * i + 2] += ia[2], s[t] += 1, s[n] += 1, s[i] += 1;
    }
    const sa = Math.pow(2, 16) / 1, oa = 45 * Math.PI / 100;
    function aa(e, t, n = 2) {
        const i = t && t.length, r = i ? t[0] * n : e.length;
        let s = la(e, 0, r, n, !0);
        const o = [];
        if (!s || s.next === s.prev) return o;
        let a, l, h;
        if (i && (s = function(e, t, n, i) {
            const r = [];
            for (let n = 0, s = t.length; n < s; n++) {
                const o = la(e, t[n] * i, n < s - 1 ? t[n + 1] * i : e.length, i, !1);
                o === o.next && (o.steiner = !0), r.push(_a(o));
            }
            r.sort(ga);
            for (let e = 0; e < r.length; e++) n = ma(r[e], n);
            return n;
        }(e, t, s, n)), e.length > 80 * n) {
            a = 1 / 0, l = 1 / 0;
            let t = -1 / 0, i = -1 / 0;
            for (let s = n; s < r; s += n) {
                const n = e[s], r = e[s + 1];
                n < a && (a = n), r < l && (l = r), n > t && (t = n), r > i && (i = r);
            }
            h = Math.max(t - a, i - l), h = 0 !== h ? 32767 / h : 0;
        }
        return ca(s, o, n, a, l, h, 0), o;
    }
    function la(e, t, n, i, r) {
        let s;
        if (r === function(e, t, n, i) {
            let r = 0;
            for (let s = t, o = n - i; s < n; s += i) r += (e[o] - e[s]) * (e[s + 1] + e[o + 1]), 
            o = s;
            return r;
        }
        /*!
	 * from @turf/bboxClip
	 * https://github.com/Turfjs/turf
	 * MIT LICENSE
	 */ (e, t, n, i) > 0) for (let r = t; r < n; r += i) s = ka(r / i | 0, e[r], e[r + 1], s); else for (let r = n - i; r >= t; r -= i) s = ka(r / i | 0, e[r], e[r + 1], s);
        return s && wa(s, s.next) && (Fa(s), s = s.next), s;
    }
    function ha(e, t) {
        if (!e) return e;
        t || (t = e);
        let n, i = e;
        do {
            if (n = !1, i.steiner || !wa(i, i.next) && 0 !== Ta(i.prev, i, i.next)) i = i.next; else {
                if (Fa(i), i = t = i.prev, i === i.next) break;
                n = !0;
            }
        } while (n || i !== t);
        return t;
    }
    function ca(e, t, n, i, r, s, o) {
        if (!e) return;
        !o && s && function(e, t, n, i) {
            let r = e;
            do {
                0 === r.z && (r.z = xa(r.x, r.y, t, n, i)), r.prevZ = r.prev, r.nextZ = r.next, 
                r = r.next;
            } while (r !== e);
            r.prevZ.nextZ = null, r.prevZ = null, function(e) {
                let t, n = 1;
                do {
                    let i, r = e;
                    e = null;
                    let s = null;
                    for (t = 0; r; ) {
                        t++;
                        let o = r, a = 0;
                        for (let e = 0; e < n && (a++, o = o.nextZ, o); e++) ;
                        let l = n;
                        for (;a > 0 || l > 0 && o; ) 0 !== a && (0 === l || !o || r.z <= o.z) ? (i = r, 
                        r = r.nextZ, a--) : (i = o, o = o.nextZ, l--), s ? s.nextZ = i : e = i, i.prevZ = s, 
                        s = i;
                        r = o;
                    }
                    s.nextZ = null, n *= 2;
                } while (t > 1);
            }(r);
        }(e, i, r, s);
        let a = e;
        for (;e.prev !== e.next; ) {
            const l = e.prev, h = e.next;
            if (s ? fa(e, i, r, s) : ua(e)) t.push(l.i, e.i, h.i), Fa(e), e = h.next, a = h.next; else if ((e = h) === a) {
                o ? 1 === o ? ca(e = da(ha(e), t), t, n, i, r, s, 2) : 2 === o && pa(e, t, n, i, r, s) : ca(ha(e), t, n, i, r, s, 1);
                break;
            }
        }
    }
    function ua(e) {
        const t = e.prev, n = e, i = e.next;
        if (Ta(t, n, i) >= 0) return !1;
        const r = t.x, s = n.x, o = i.x, a = t.y, l = n.y, h = i.y, c = Math.min(r, s, o), u = Math.min(a, l, h), f = Math.max(r, s, o), d = Math.max(a, l, h);
        let p = i.next;
        for (;p !== t; ) {
            if (p.x >= c && p.x <= f && p.y >= u && p.y <= d && ba(r, a, s, l, o, h, p.x, p.y) && Ta(p.prev, p, p.next) >= 0) return !1;
            p = p.next;
        }
        return !0;
    }
    function fa(e, t, n, i) {
        const r = e.prev, s = e, o = e.next;
        if (Ta(r, s, o) >= 0) return !1;
        const a = r.x, l = s.x, h = o.x, c = r.y, u = s.y, f = o.y, d = Math.min(a, l, h), p = Math.min(c, u, f), g = Math.max(a, l, h), m = Math.max(c, u, f), y = xa(d, p, t, n, i), x = xa(g, m, t, n, i);
        let _ = e.prevZ, v = e.nextZ;
        for (;_ && _.z >= y && v && v.z <= x; ) {
            if (_.x >= d && _.x <= g && _.y >= p && _.y <= m && _ !== r && _ !== o && ba(a, c, l, u, h, f, _.x, _.y) && Ta(_.prev, _, _.next) >= 0) return !1;
            if (_ = _.prevZ, v.x >= d && v.x <= g && v.y >= p && v.y <= m && v !== r && v !== o && ba(a, c, l, u, h, f, v.x, v.y) && Ta(v.prev, v, v.next) >= 0) return !1;
            v = v.nextZ;
        }
        for (;_ && _.z >= y; ) {
            if (_.x >= d && _.x <= g && _.y >= p && _.y <= m && _ !== r && _ !== o && ba(a, c, l, u, h, f, _.x, _.y) && Ta(_.prev, _, _.next) >= 0) return !1;
            _ = _.prevZ;
        }
        for (;v && v.z <= x; ) {
            if (v.x >= d && v.x <= g && v.y >= p && v.y <= m && v !== r && v !== o && ba(a, c, l, u, h, f, v.x, v.y) && Ta(v.prev, v, v.next) >= 0) return !1;
            v = v.nextZ;
        }
        return !0;
    }
    function da(e, t) {
        let n = e;
        do {
            const i = n.prev, r = n.next.next;
            !wa(i, r) && Sa(i, n, n.next, r) && Ia(i, r) && Ia(r, i) && (t.push(i.i, n.i, r.i), 
            Fa(n), Fa(n.next), n = e = r), n = n.next;
        } while (n !== e);
        return ha(n);
    }
    function pa(e, t, n, i, r, s) {
        let o = e;
        do {
            let e = o.next.next;
            for (;e !== o.prev; ) {
                if (o.i !== e.i && Aa(o, e)) {
                    let a = Ca(o, e);
                    return o = ha(o, o.next), a = ha(a, a.next), ca(o, t, n, i, r, s, 0), void ca(a, t, n, i, r, s, 0);
                }
                e = e.next;
            }
            o = o.next;
        } while (o !== e);
    }
    function ga(e, t) {
        let n = e.x - t.x;
        return 0 === n && (n = e.y - t.y, 0 === n) && (n = (e.next.y - e.y) / (e.next.x - e.x) - (t.next.y - t.y) / (t.next.x - t.x)), 
        n;
    }
    function ma(e, t) {
        const n = function(e, t) {
            let n = t;
            const i = e.x, r = e.y;
            let s, o = -1 / 0;
            if (wa(e, n)) return n;
            do {
                if (wa(e, n.next)) return n.next;
                if (r <= n.y && r >= n.next.y && n.next.y !== n.y) {
                    const e = n.x + (r - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                    if (e <= i && e > o && (o = e, s = n.x < n.next.x ? n : n.next, e === i)) return s;
                }
                n = n.next;
            } while (n !== t);
            if (!s) return null;
            const a = s, l = s.x, h = s.y;
            let c = 1 / 0;
            n = s;
            do {
                if (i >= n.x && n.x >= l && i !== n.x && va(r < h ? i : o, r, l, h, r < h ? o : i, r, n.x, n.y)) {
                    const t = Math.abs(r - n.y) / (i - n.x);
                    Ia(n, e) && (t < c || t === c && (n.x > s.x || n.x === s.x && ya(s, n))) && (s = n, 
                    c = t);
                }
                n = n.next;
            } while (n !== a);
            return s;
        }(e, t);
        if (!n) return t;
        const i = Ca(n, e);
        return ha(i, i.next), ha(n, n.next);
    }
    function ya(e, t) {
        return Ta(e.prev, e, t.prev) < 0 && Ta(t.next, e, e.next) < 0;
    }
    function xa(e, t, n, i, r) {
        return (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * r | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - i) * r | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
    }
    function _a(e) {
        let t = e, n = e;
        do {
            (t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
        } while (t !== e);
        return n;
    }
    function va(e, t, n, i, r, s, o, a) {
        return (r - o) * (t - a) >= (e - o) * (s - a) && (e - o) * (i - a) >= (n - o) * (t - a) && (n - o) * (s - a) >= (r - o) * (i - a);
    }
    function ba(e, t, n, i, r, s, o, a) {
        return !(e === o && t === a) && va(e, t, n, i, r, s, o, a);
    }
    function Aa(e, t) {
        return e.next.i !== t.i && e.prev.i !== t.i && !function(e, t) {
            let n = e;
            do {
                if (n.i !== e.i && n.next.i !== e.i && n.i !== t.i && n.next.i !== t.i && Sa(n, n.next, e, t)) return !0;
                n = n.next;
            } while (n !== e);
            return !1;
        }(e, t) && (Ia(e, t) && Ia(t, e) && function(e, t) {
            let n = e, i = !1;
            const r = (e.x + t.x) / 2, s = (e.y + t.y) / 2;
            do {
                n.y > s != n.next.y > s && n.next.y !== n.y && r < (n.next.x - n.x) * (s - n.y) / (n.next.y - n.y) + n.x && (i = !i), 
                n = n.next;
            } while (n !== e);
            return i;
        }(e, t) && (Ta(e.prev, e, t.prev) || Ta(e, t.prev, t)) || wa(e, t) && Ta(e.prev, e, e.next) > 0 && Ta(t.prev, t, t.next) > 0);
    }
    function Ta(e, t, n) {
        return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
    }
    function wa(e, t) {
        return e.x === t.x && e.y === t.y;
    }
    function Sa(e, t, n, i) {
        const r = Pa(Ta(e, t, n)), s = Pa(Ta(e, t, i)), o = Pa(Ta(n, i, e)), a = Pa(Ta(n, i, t));
        return r !== s && o !== a || !(0 !== r || !Ma(e, n, t)) || !(0 !== s || !Ma(e, i, t)) || !(0 !== o || !Ma(n, e, i)) || !(0 !== a || !Ma(n, t, i));
    }
    function Ma(e, t, n) {
        return t.x <= Math.max(e.x, n.x) && t.x >= Math.min(e.x, n.x) && t.y <= Math.max(e.y, n.y) && t.y >= Math.min(e.y, n.y);
    }
    function Pa(e) {
        return e > 0 ? 1 : e < 0 ? -1 : 0;
    }
    function Ia(e, t) {
        return Ta(e.prev, e, e.next) < 0 ? Ta(e, t, e.next) >= 0 && Ta(e, e.prev, t) >= 0 : Ta(e, t, e.prev) < 0 || Ta(e, e.next, t) < 0;
    }
    function Ca(e, t) {
        const n = Oa(e.i, e.x, e.y), i = Oa(t.i, t.x, t.y), r = e.next, s = t.prev;
        return e.next = t, t.prev = e, n.next = r, r.prev = n, i.next = n, n.prev = i, s.next = i, 
        i.prev = s, i;
    }
    function ka(e, t, n, i) {
        const r = Oa(e, t, n);
        return i ? (r.next = i.next, r.prev = i, i.next.prev = r, i.next = r) : (r.prev = r, 
        r.next = r), r;
    }
    function Fa(e) {
        e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), 
        e.nextZ && (e.nextZ.prevZ = e.prevZ);
    }
    function Oa(e, t, n) {
        return {
            i: e,
            x: t,
            y: n,
            prev: null,
            next: null,
            z: 0,
            prevZ: null,
            nextZ: null,
            steiner: !1
        };
    }
    const Ra = [], Ea = [];
    function Da(e, t) {
        var n, i, r, o, a, l, h;
        for (i = 1; i <= 8; i *= 2) {
            for (n = [], o = !(Ha(r = e[e.length - 1], t) & i), a = 0; a < e.length; a++) {
                if ((h = !(Ha(l = e[a], t) & i)) !== o) {
                    const e = La(r, l, i, t);
                    void 0 !== l.x ? n.push(new s(e[0], e[1])) : n.push(e);
                }
                h && n.push(l), r = l, o = h;
            }
            if (!(e = n).length) break;
        }
        return n;
    }
    function La(e, t, n, i) {
        return Ra[0] = void 0 === e.x ? e[0] : e.x, Ra[1] = void 0 === e.y ? e[1] : e.y, 
        e = Ra, Ea[0] = void 0 === t.x ? t[0] : t.x, Ea[1] = void 0 === t.y ? t[1] : t.y, 
        t = Ea, 8 & n ? [ e[0] + (t[0] - e[0]) * (i[3] - e[1]) / (t[1] - e[1]), i[3] ] : 4 & n ? [ e[0] + (t[0] - e[0]) * (i[1] - e[1]) / (t[1] - e[1]), i[1] ] : 2 & n ? [ i[2], e[1] + (t[1] - e[1]) * (i[2] - e[0]) / (t[0] - e[0]) ] : 1 & n ? [ i[0], e[1] + (t[1] - e[1]) * (i[0] - e[0]) / (t[0] - e[0]) ] : null;
    }
    function Ha(e, t) {
        Ra[0] = void 0 === e.x ? e[0] : e.x, Ra[1] = void 0 === e.y ? e[1] : e.y;
        var n = 0;
        return (e = Ra)[0] < t[0] ? n |= 1 : e[0] > t[2] && (n |= 2), e[1] < t[1] ? n |= 4 : e[1] > t[3] && (n |= 8), 
        n;
    }
    const za = [ 0, 0, 0, 0 ], Na = -9999999, Va = [ {
        type: Int16Array,
        width: 3,
        name: "aPosition"
    } ];
    class Ba extends No {
        constructor(e, t, n) {
            (t = $e({}, t)).lineJoin = "miter", t.lineCap = "butt", super(e, t, n), this.options.radialSegments % 2 == 1 && this.options.radialSegments--;
        }
        getFormat() {
            const {lineWidthFn: e, lineColorFn: t, lineOpacityFn: n, linePatternAnimSpeedFn: i, linePatternGapFn: r} = this._fnTypes, s = [ ...this.getPositionFormat(), {
                type: Int8Array,
                width: 4,
                name: "aTubeNormal"
            }, {
                type: this.options.positionType || Uint16Array,
                width: 1,
                name: "aLinesofar"
            } ];
            if (this.iconAtlas) {
                s.push({
                    type: Int8Array,
                    width: 1,
                    name: "aNormalDistance"
                });
                const e = this.getIconAtlasMaxValue();
                s.push({
                    type: e > 255 ? Uint16Array : Uint8Array,
                    width: 4,
                    name: "aTexInfo"
                });
            }
            return e && s.push({
                type: Uint16Array,
                width: 1,
                name: "aLineWidth"
            }), t && s.push({
                type: Uint8Array,
                width: 4,
                name: "aColor"
            }), n && s.push({
                type: Uint8Array,
                width: 1,
                name: "aOpacity"
            }), i && s.push({
                type: Int8Array,
                width: 1,
                name: "aLinePatternAnimSpeed"
            }), r && s.push({
                type: Int8Array,
                width: 1,
                name: "aLinePatternGap"
            }), s;
        }
        ensureDataCapacity(e, t, n, i) {
            const r = this.options.radialSegments / 2;
            return super.ensureDataCapacity(e, t, n, i * r);
        }
        addHalfVertex(e, t, n, i, r, s, o, a) {
            const {x: l, y: h, z: c} = e, u = 1 * this.scaledDistance, f = this.options.radialSegments / 2, {x: d, y: p, z: g} = o.dir, m = function(e, t, n, i, r, s, o, a) {
                Po(Ua, n, i, r), Po(Ga, s, o, 0), Co(ja, Ua, Ga), Io(Ga, Ga), Io(ja, ja), Wa[t] || (Wa[t] = []);
                const l = Wa[t];
                for (var h = 0; h < t; h++) {
                    const e = Math.PI * h / t, n = 0, i = 1 - Math.abs(e - n) / (Math.PI / 2);
                    l[h] = l[h] || [], Xa(Ga, ja, l[h], 1, e, i * (a ? -1 : 1));
                }
                return l;
            }(0, f, d, p, g, t, n, r);
            this.prevVertex && this.fillTubeElements(r), this.fillData(this.data, l, h, c || 0, m, r, u, a);
        }
        fillTubeElements(e) {
            const t = this.options.radialSegments / 2, n = this.needAltitudeAttribute() ? 2 : 3, i = this.data.aPosition.getLength() / n;
            for (let n = 0; n < t; n++) {
                const r = n + i, s = n + i - 2 * t;
                let o, a;
                n === t - 1 && e ? (o = n + i - 2 * t + 1, a = n + i - 2 * t - 2 * t + 1) : (o = n + i + 1, 
                a = n + i + 1 - 2 * t), super.addElements(r - this.offset, o - this.offset, s - this.offset), 
                super.addElements(s - this.offset, o - this.offset, a - this.offset);
            }
        }
        fillData(e, t, n, i, r, s, o, a) {
            const {lineWidthFn: l, lineColorFn: h, lineOpacityFn: c, linePatternAnimSpeedFn: u, linePatternGapFn: f} = this._fnTypes, d = r.length;
            for (let s = 0; s < d; s++) {
                this.fillPosition(e, t, n, i), Fo(r[s], r[s], Ro);
                let d = e.aTubeNormal.currentIndex;
                for (let t = 0; t < r[s].length; t++) e.aTubeNormal[d++] = r[s][t];
                if (e.aTubeNormal.currentIndex = d, d = e.aLinesofar.currentIndex, e.aLinesofar[d++] = o, 
                e.aLinesofar.currentIndex = d, this.iconAtlas && (d = e.aNormalDistance.currentIndex, 
                e.aNormalDistance[d++] = Ro * a, e.aNormalDistance.currentIndex = d, d = e.aTexInfo.currentIndex, 
                e.aTexInfo[d++] = this.feaTexInfo[0], e.aTexInfo[d++] = this.feaTexInfo[1], e.aTexInfo[d++] = this.feaTexInfo[2], 
                e.aTexInfo[d++] = this.feaTexInfo[3], e.aTexInfo.currentIndex = d), l) {
                    const t = at(this.options.metric);
                    let n = this.feaLineWidth * t;
                    isNaN(n) && (n = 0), d = e.aLineWidth.currentIndex, e.aLineWidth[d++] = Math.round(n), 
                    e.aLineWidth.currentIndex = d;
                }
                h && (d = e.aColor.currentIndex, e.aColor[d++] = this.feaColor[0], e.aColor[d++] = this.feaColor[1], 
                e.aColor[d++] = this.feaColor[2], e.aColor[d++] = this.feaColor[3], e.aColor.currentIndex = d), 
                c && (d = e.aOpacity.currentIndex, e.aOpacity[d++] = this.feaOpacity, e.aOpacity.currentIndex = d), 
                u && (d = e.aLinePatternAnimSpeed.currentIndex, e.aLinePatternAnimSpeed[d++] = 127 * (this.feaPatternAnimSpeed || 0), 
                e.aLinePatternAnimSpeed.currentIndex = d), f && (d = e.aLinePatternGap.currentIndex, 
                e.aLinePatternGap[d++] = 10 * (this.feaLinePatternGap || 0), e.aLinePatternGap.currentIndex = d);
            }
            this.maxPos = Math.max(this.maxPos, Math.abs(t) + 1, Math.abs(n) + 1);
        }
        createDataPack(e, t) {
            const n = super.createDataPack(e, t);
            return n && (n.is2D = !1), n;
        }
    }
    const Ua = [], Ga = [], ja = [], Wa = {};
    function Xa(e, t, n, i, r, s) {
        return ko(n, i * (Math.cos(r) * e[0] + Math.sin(r) * t[0]), i * (Math.cos(r) * e[1] + Math.sin(r) * t[1]), i * (Math.cos(r) * e[2] + Math.sin(r) * t[2]), s), 
        n;
    }
    const Ya = [], qa = [], Za = [], $a = [], Ja = [];
    function Ka(e, t, n, i, r, s, o, a) {
        Po(qa, n, i, r), Po(Za, s, o, 0), Co($a, qa, Za), Io(Za, Za), Io($a, $a), Oo(Ya, e, t);
        const l = function(e) {
            var t = e[0], n = e[1];
            return Math.hypot(t, n);
        }(Ya) / e, h = Math.atan(t / e);
        let c = Math.PI / 2 + (Math.PI / 2 - h);
        return Ja[0] || (Ja[0] = []), Xa(Za, $a, Ja[0], l, c, a ? 1 : -1), c += 2 * h, Ja[1] || (Ja[1] = []), 
        Xa(Za, $a, Ja[1], l, c, a ? 1 : -1), Ja;
    }
    class Qa {
        constructor(e) {
            this.max = e, this.reset();
        }
        reset() {
            return this.data = {}, this.order = [], this;
        }
        clear() {
            this.reset();
        }
        add(e, t) {
            return this.has(e) ? (this.order.splice(this.order.indexOf(e), 1), this.data[e] = t, 
            this.order.push(e)) : (this.data[e] = t, this.order.push(e), this.order.length > this.max && this.getAndRemove(this.order[0])), 
            this;
        }
        has(e) {
            return e in this.data;
        }
        keys() {
            return this.order;
        }
        getAndRemove(e) {
            if (!this.has(e)) return null;
            const t = this.data[e];
            return delete this.data[e], this.order.splice(this.order.indexOf(e), 1), t;
        }
        get(e) {
            return this.has(e) ? this.data[e] : null;
        }
        remove(e) {
            return this.has(e) ? (delete this.data[e], this.order.splice(this.order.indexOf(e), 1), 
            this) : this;
        }
        setMaxSize(e) {
            for (this.max = e; this.order.length > this.max; ) this.getAndRemove(this.order[0]);
            return this;
        }
    }
    /*!
	 * based on @mapbox/tiny-sdf
	 * https://github.com/mapbox/tiny-sdf
	 * @License BSD 2-Clause
	 */    var el = 1e20;
    function tl(e, t, n, i, r, s, o) {
        this.fontSize = e || 24, this.buffer = void 0 === t ? 3 : t, this.cutoff = i || .25, 
        this.fontFamily = r || "sans-serif", this.fontWeight = s || "normal", this.fontStyle = o || "normal", 
        this.radius = n || 8;
        var a = this.size = this.fontSize + 2 * this.buffer;
        this.canvas = "undefined" == typeof document ? new OffscreenCanvas(a, a) : document.createElement("canvas"), 
        this.canvas.width = this.canvas.height = a, this.ctx = this.canvas.getContext("2d", {
            willReadFrequently: !0
        }), this.ctx.font = this.fontStyle + " " + this.fontWeight + " " + this.fontSize + "px " + this.fontFamily, 
        this.ctx.textBaseline = "middle", this.ctx.fillStyle = "black", this.gridOuter = new Float64Array(a * a), 
        this.gridInner = new Float64Array(a * a), this.f = new Float64Array(a), this.z = new Float64Array(a + 1), 
        this.v = new Uint16Array(a), this.middle = Math.round(a / 2 * (navigator.userAgent.indexOf("Gecko/") >= 0 ? 1.2 : 1));
    }
    function nl(e, t, n, i, r, s) {
        for (var o = 0; o < t; o++) il(e, o, t, n, i, r, s);
        for (var a = 0; a < n; a++) il(e, a * t, 1, t, i, r, s);
    }
    function il(e, t, n, i, r, s, o) {
        var a, l, h, c;
        for (s[0] = 0, o[0] = -el, o[1] = el, a = 0; a < i; a++) r[a] = e[t + a * n];
        for (a = 1, l = 0, h = 0; a < i; a++) {
            do {
                c = s[l], h = (r[a] - r[c] + a * a - c * c) / (a - c) / 2;
            } while (h <= o[l] && --l > -1);
            s[++l] = a, o[l] = h, o[l + 1] = el;
        }
        for (a = 0, l = 0; a < i; a++) {
            for (;o[l + 1] < a; ) l++;
            c = s[l], e[t + a * n] = r[c] + (a - c) * (a - c);
        }
    }
    tl.prototype.draw = function(e, t, n) {
        this.ctx.clearRect(0, 0, this.size, this.size), this.ctx.textBaseline = "top", this.ctx.fillText(e, this.buffer, this.buffer);
        for (var i = this.ctx.getImageData(0, 0, t, n), r = new Uint8ClampedArray(t * n), s = 0; s < t * n; s++) {
            var o = i.data[4 * s + 3] / 255;
            this.gridOuter[s] = 1 === o ? 0 : 0 === o ? el : Math.pow(Math.max(0, .5 - o), 2), 
            this.gridInner[s] = 1 === o ? el : 0 === o ? 0 : Math.pow(Math.max(0, o - .5), 2);
        }
        for (nl(this.gridOuter, t, n, this.f, this.v, this.z), nl(this.gridInner, t, n, this.f, this.v, this.z), 
        s = 0; s < t * n; s++) {
            var a = Math.sqrt(this.gridOuter[s]) - Math.sqrt(this.gridInner[s]);
            r[s] = Math.round(255 - 255 * (a / this.radius + this.cutoff));
        }
        return r;
    };
    var rl = {
        /*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
        read: function(e, t, n, i, r) {
            var s, o, a = 8 * r - i - 1, l = (1 << a) - 1, h = l >> 1, c = -7, u = n ? r - 1 : 0, f = n ? -1 : 1, d = e[t + u];
            for (u += f, s = d & (1 << -c) - 1, d >>= -c, c += a; c > 0; s = 256 * s + e[t + u], 
            u += f, c -= 8) ;
            for (o = s & (1 << -c) - 1, s >>= -c, c += i; c > 0; o = 256 * o + e[t + u], u += f, 
            c -= 8) ;
            if (0 === s) s = 1 - h; else {
                if (s === l) return o ? NaN : 1 / 0 * (d ? -1 : 1);
                o += Math.pow(2, i), s -= h;
            }
            return (d ? -1 : 1) * o * Math.pow(2, s - i);
        },
        write: function(e, t, n, i, r, s) {
            var o, a, l, h = 8 * s - r - 1, c = (1 << h) - 1, u = c >> 1, f = 23 === r ? Math.pow(2, -24) - Math.pow(2, -77) : 0, d = i ? 0 : s - 1, p = i ? 1 : -1, g = t < 0 || 0 === t && 1 / t < 0 ? 1 : 0;
            for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = c) : (o = Math.floor(Math.log(t) / Math.LN2), 
            t * (l = Math.pow(2, -o)) < 1 && (o--, l *= 2), (t += o + u >= 1 ? f / l : f * Math.pow(2, 1 - u)) * l >= 2 && (o++, 
            l /= 2), o + u >= c ? (a = 0, o = c) : o + u >= 1 ? (a = (t * l - 1) * Math.pow(2, r), 
            o += u) : (a = t * Math.pow(2, u - 1) * Math.pow(2, r), o = 0)); r >= 8; e[n + d] = 255 & a, 
            d += p, a /= 256, r -= 8) ;
            for (o = o << r | a, h += r; h > 0; e[n + d] = 255 & o, d += p, o /= 256, h -= 8) ;
            e[n + d - p] |= 128 * g;
        }
    }, sl = al, ol = rl;
    function al(e) {
        this.buf = ArrayBuffer.isView && ArrayBuffer.isView(e) ? e : new Uint8Array(e || 0), 
        this.pos = 0, this.type = 0, this.length = this.buf.length;
    }
    al.Varint = 0, al.Fixed64 = 1, al.Bytes = 2, al.Fixed32 = 5;
    var ll = 4294967296, hl = 1 / ll, cl = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf8");
    function ul(e) {
        return e.type === al.Bytes ? e.readVarint() + e.pos : e.pos + 1;
    }
    function fl(e, t, n) {
        return n ? 4294967296 * t + (e >>> 0) : 4294967296 * (t >>> 0) + (e >>> 0);
    }
    function dl(e, t, n) {
        var i = t <= 16383 ? 1 : t <= 2097151 ? 2 : t <= 268435455 ? 3 : Math.floor(Math.log(t) / (7 * Math.LN2));
        n.realloc(i);
        for (var r = n.pos - 1; r >= e; r--) n.buf[r + i] = n.buf[r];
    }
    function pl(e, t) {
        for (var n = 0; n < e.length; n++) t.writeVarint(e[n]);
    }
    function gl(e, t) {
        for (var n = 0; n < e.length; n++) t.writeSVarint(e[n]);
    }
    function ml(e, t) {
        for (var n = 0; n < e.length; n++) t.writeFloat(e[n]);
    }
    function yl(e, t) {
        for (var n = 0; n < e.length; n++) t.writeDouble(e[n]);
    }
    function xl(e, t) {
        for (var n = 0; n < e.length; n++) t.writeBoolean(e[n]);
    }
    function _l(e, t) {
        for (var n = 0; n < e.length; n++) t.writeFixed32(e[n]);
    }
    function vl(e, t) {
        for (var n = 0; n < e.length; n++) t.writeSFixed32(e[n]);
    }
    function bl(e, t) {
        for (var n = 0; n < e.length; n++) t.writeFixed64(e[n]);
    }
    function Al(e, t) {
        for (var n = 0; n < e.length; n++) t.writeSFixed64(e[n]);
    }
    function Tl(e, t) {
        return (e[t] | e[t + 1] << 8 | e[t + 2] << 16) + 16777216 * e[t + 3];
    }
    function wl(e, t, n) {
        e[n] = t, e[n + 1] = t >>> 8, e[n + 2] = t >>> 16, e[n + 3] = t >>> 24;
    }
    function Sl(e, t) {
        return (e[t] | e[t + 1] << 8 | e[t + 2] << 16) + (e[t + 3] << 24);
    }
    al.prototype = {
        destroy: function() {
            this.buf = null;
        },
        readFields: function(e, t, n) {
            for (n = n || this.length; this.pos < n; ) {
                var i = this.readVarint(), r = i >> 3, s = this.pos;
                this.type = 7 & i, e(r, t, this), this.pos === s && this.skip(i);
            }
            return t;
        },
        readMessage: function(e, t) {
            return this.readFields(e, t, this.readVarint() + this.pos);
        },
        readFixed32: function() {
            var e = Tl(this.buf, this.pos);
            return this.pos += 4, e;
        },
        readSFixed32: function() {
            var e = Sl(this.buf, this.pos);
            return this.pos += 4, e;
        },
        readFixed64: function() {
            var e = Tl(this.buf, this.pos) + Tl(this.buf, this.pos + 4) * ll;
            return this.pos += 8, e;
        },
        readSFixed64: function() {
            var e = Tl(this.buf, this.pos) + Sl(this.buf, this.pos + 4) * ll;
            return this.pos += 8, e;
        },
        readFloat: function() {
            var e = ol.read(this.buf, this.pos, !0, 23, 4);
            return this.pos += 4, e;
        },
        readDouble: function() {
            var e = ol.read(this.buf, this.pos, !0, 52, 8);
            return this.pos += 8, e;
        },
        readVarint: function(e) {
            var t, n, i = this.buf;
            return t = 127 & (n = i[this.pos++]), n < 128 ? t : (t |= (127 & (n = i[this.pos++])) << 7, 
            n < 128 ? t : (t |= (127 & (n = i[this.pos++])) << 14, n < 128 ? t : (t |= (127 & (n = i[this.pos++])) << 21, 
            n < 128 ? t : function(e, t, n) {
                var i, r, s = n.buf;
                if (i = (112 & (r = s[n.pos++])) >> 4, r < 128) return fl(e, i, t);
                if (i |= (127 & (r = s[n.pos++])) << 3, r < 128) return fl(e, i, t);
                if (i |= (127 & (r = s[n.pos++])) << 10, r < 128) return fl(e, i, t);
                if (i |= (127 & (r = s[n.pos++])) << 17, r < 128) return fl(e, i, t);
                if (i |= (127 & (r = s[n.pos++])) << 24, r < 128) return fl(e, i, t);
                if (i |= (1 & (r = s[n.pos++])) << 31, r < 128) return fl(e, i, t);
                throw new Error("Expected varint not more than 10 bytes");
            }(t |= (15 & (n = i[this.pos])) << 28, e, this))));
        },
        readVarint64: function() {
            return this.readVarint(!0);
        },
        readSVarint: function() {
            var e = this.readVarint();
            return e % 2 == 1 ? (e + 1) / -2 : e / 2;
        },
        readBoolean: function() {
            return Boolean(this.readVarint());
        },
        readString: function() {
            var e = this.readVarint() + this.pos, t = this.pos;
            return this.pos = e, e - t >= 12 && cl ? function(e, t, n) {
                return cl.decode(e.subarray(t, n));
            }(this.buf, t, e) : function(e, t, n) {
                for (var i = "", r = t; r < n; ) {
                    var s, o, a, l = e[r], h = null, c = l > 239 ? 4 : l > 223 ? 3 : l > 191 ? 2 : 1;
                    if (r + c > n) break;
                    1 === c ? l < 128 && (h = l) : 2 === c ? 128 == (192 & (s = e[r + 1])) && (h = (31 & l) << 6 | 63 & s) <= 127 && (h = null) : 3 === c ? (s = e[r + 1], 
                    o = e[r + 2], 128 == (192 & s) && 128 == (192 & o) && ((h = (15 & l) << 12 | (63 & s) << 6 | 63 & o) <= 2047 || h >= 55296 && h <= 57343) && (h = null)) : 4 === c && (s = e[r + 1], 
                    o = e[r + 2], a = e[r + 3], 128 == (192 & s) && 128 == (192 & o) && 128 == (192 & a) && ((h = (15 & l) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & a) <= 65535 || h >= 1114112) && (h = null)), 
                    null === h ? (h = 65533, c = 1) : h > 65535 && (h -= 65536, i += String.fromCharCode(h >>> 10 & 1023 | 55296), 
                    h = 56320 | 1023 & h), i += String.fromCharCode(h), r += c;
                }
                return i;
            }(this.buf, t, e);
        },
        readBytes: function() {
            var e = this.readVarint() + this.pos, t = this.buf.subarray(this.pos, e);
            return this.pos = e, t;
        },
        readPackedVarint: function(e, t) {
            if (this.type !== al.Bytes) return e.push(this.readVarint(t));
            var n = ul(this);
            for (e = e || []; this.pos < n; ) e.push(this.readVarint(t));
            return e;
        },
        readPackedSVarint: function(e) {
            if (this.type !== al.Bytes) return e.push(this.readSVarint());
            var t = ul(this);
            for (e = e || []; this.pos < t; ) e.push(this.readSVarint());
            return e;
        },
        readPackedBoolean: function(e) {
            if (this.type !== al.Bytes) return e.push(this.readBoolean());
            var t = ul(this);
            for (e = e || []; this.pos < t; ) e.push(this.readBoolean());
            return e;
        },
        readPackedFloat: function(e) {
            if (this.type !== al.Bytes) return e.push(this.readFloat());
            var t = ul(this);
            for (e = e || []; this.pos < t; ) e.push(this.readFloat());
            return e;
        },
        readPackedDouble: function(e) {
            if (this.type !== al.Bytes) return e.push(this.readDouble());
            var t = ul(this);
            for (e = e || []; this.pos < t; ) e.push(this.readDouble());
            return e;
        },
        readPackedFixed32: function(e) {
            if (this.type !== al.Bytes) return e.push(this.readFixed32());
            var t = ul(this);
            for (e = e || []; this.pos < t; ) e.push(this.readFixed32());
            return e;
        },
        readPackedSFixed32: function(e) {
            if (this.type !== al.Bytes) return e.push(this.readSFixed32());
            var t = ul(this);
            for (e = e || []; this.pos < t; ) e.push(this.readSFixed32());
            return e;
        },
        readPackedFixed64: function(e) {
            if (this.type !== al.Bytes) return e.push(this.readFixed64());
            var t = ul(this);
            for (e = e || []; this.pos < t; ) e.push(this.readFixed64());
            return e;
        },
        readPackedSFixed64: function(e) {
            if (this.type !== al.Bytes) return e.push(this.readSFixed64());
            var t = ul(this);
            for (e = e || []; this.pos < t; ) e.push(this.readSFixed64());
            return e;
        },
        skip: function(e) {
            var t = 7 & e;
            if (t === al.Varint) for (;this.buf[this.pos++] > 127; ) ; else if (t === al.Bytes) this.pos = this.readVarint() + this.pos; else if (t === al.Fixed32) this.pos += 4; else {
                if (t !== al.Fixed64) throw new Error("Unimplemented type: " + t);
                this.pos += 8;
            }
        },
        writeTag: function(e, t) {
            this.writeVarint(e << 3 | t);
        },
        realloc: function(e) {
            for (var t = this.length || 16; t < this.pos + e; ) t *= 2;
            if (t !== this.length) {
                var n = new Uint8Array(t);
                n.set(this.buf), this.buf = n, this.length = t;
            }
        },
        finish: function() {
            return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
        },
        writeFixed32: function(e) {
            this.realloc(4), wl(this.buf, e, this.pos), this.pos += 4;
        },
        writeSFixed32: function(e) {
            this.realloc(4), wl(this.buf, e, this.pos), this.pos += 4;
        },
        writeFixed64: function(e) {
            this.realloc(8), wl(this.buf, -1 & e, this.pos), wl(this.buf, Math.floor(e * hl), this.pos + 4), 
            this.pos += 8;
        },
        writeSFixed64: function(e) {
            this.realloc(8), wl(this.buf, -1 & e, this.pos), wl(this.buf, Math.floor(e * hl), this.pos + 4), 
            this.pos += 8;
        },
        writeVarint: function(e) {
            (e = +e || 0) > 268435455 || e < 0 ? function(e, t) {
                var n, i;
                if (e >= 0 ? (n = e % 4294967296 | 0, i = e / 4294967296 | 0) : (i = ~(-e / 4294967296), 
                4294967295 ^ (n = ~(-e % 4294967296)) ? n = n + 1 | 0 : (n = 0, i = i + 1 | 0)), 
                e >= 0x10000000000000000 || e < -0x10000000000000000) throw new Error("Given varint doesn't fit into 10 bytes");
                t.realloc(10), function(e, t, n) {
                    n.buf[n.pos++] = 127 & e | 128, e >>>= 7, n.buf[n.pos++] = 127 & e | 128, e >>>= 7, 
                    n.buf[n.pos++] = 127 & e | 128, e >>>= 7, n.buf[n.pos++] = 127 & e | 128, e >>>= 7, 
                    n.buf[n.pos] = 127 & e;
                }(n, 0, t), function(e, t) {
                    var n = (7 & e) << 4;
                    t.buf[t.pos++] |= n | ((e >>>= 3) ? 128 : 0), e && (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), 
                    e && (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), e && (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), 
                    e && (t.buf[t.pos++] = 127 & e | ((e >>>= 7) ? 128 : 0), e && (t.buf[t.pos++] = 127 & e)))));
                }(i, t);
            }(e, this) : (this.realloc(4), this.buf[this.pos++] = 127 & e | (e > 127 ? 128 : 0), 
            e <= 127 || (this.buf[this.pos++] = 127 & (e >>>= 7) | (e > 127 ? 128 : 0), e <= 127 || (this.buf[this.pos++] = 127 & (e >>>= 7) | (e > 127 ? 128 : 0), 
            e <= 127 || (this.buf[this.pos++] = e >>> 7 & 127))));
        },
        writeSVarint: function(e) {
            this.writeVarint(e < 0 ? 2 * -e - 1 : 2 * e);
        },
        writeBoolean: function(e) {
            this.writeVarint(Boolean(e));
        },
        writeString: function(e) {
            e = String(e), this.realloc(4 * e.length), this.pos++;
            var t = this.pos;
            this.pos = function(e, t, n) {
                for (var i, r, s = 0; s < t.length; s++) {
                    if ((i = t.charCodeAt(s)) > 55295 && i < 57344) {
                        if (!r) {
                            i > 56319 || s + 1 === t.length ? (e[n++] = 239, e[n++] = 191, e[n++] = 189) : r = i;
                            continue;
                        }
                        if (i < 56320) {
                            e[n++] = 239, e[n++] = 191, e[n++] = 189, r = i;
                            continue;
                        }
                        i = r - 55296 << 10 | i - 56320 | 65536, r = null;
                    } else r && (e[n++] = 239, e[n++] = 191, e[n++] = 189, r = null);
                    i < 128 ? e[n++] = i : (i < 2048 ? e[n++] = i >> 6 | 192 : (i < 65536 ? e[n++] = i >> 12 | 224 : (e[n++] = i >> 18 | 240, 
                    e[n++] = i >> 12 & 63 | 128), e[n++] = i >> 6 & 63 | 128), e[n++] = 63 & i | 128);
                }
                return n;
            }(this.buf, e, this.pos);
            var n = this.pos - t;
            n >= 128 && dl(t, n, this), this.pos = t - 1, this.writeVarint(n), this.pos += n;
        },
        writeFloat: function(e) {
            this.realloc(4), ol.write(this.buf, e, this.pos, !0, 23, 4), this.pos += 4;
        },
        writeDouble: function(e) {
            this.realloc(8), ol.write(this.buf, e, this.pos, !0, 52, 8), this.pos += 8;
        },
        writeBytes: function(e) {
            var t = e.length;
            this.writeVarint(t), this.realloc(t);
            for (var n = 0; n < t; n++) this.buf[this.pos++] = e[n];
        },
        writeRawMessage: function(e, t) {
            this.pos++;
            var n = this.pos;
            e(t, this);
            var i = this.pos - n;
            i >= 128 && dl(n, i, this), this.pos = n - 1, this.writeVarint(i), this.pos += i;
        },
        writeMessage: function(e, t, n) {
            this.writeTag(e, al.Bytes), this.writeRawMessage(t, n);
        },
        writePackedVarint: function(e, t) {
            t.length && this.writeMessage(e, pl, t);
        },
        writePackedSVarint: function(e, t) {
            t.length && this.writeMessage(e, gl, t);
        },
        writePackedBoolean: function(e, t) {
            t.length && this.writeMessage(e, xl, t);
        },
        writePackedFloat: function(e, t) {
            t.length && this.writeMessage(e, ml, t);
        },
        writePackedDouble: function(e, t) {
            t.length && this.writeMessage(e, yl, t);
        },
        writePackedFixed32: function(e, t) {
            t.length && this.writeMessage(e, _l, t);
        },
        writePackedSFixed32: function(e, t) {
            t.length && this.writeMessage(e, vl, t);
        },
        writePackedFixed64: function(e, t) {
            t.length && this.writeMessage(e, bl, t);
        },
        writePackedSFixed64: function(e, t) {
            t.length && this.writeMessage(e, Al, t);
        },
        writeBytesField: function(e, t) {
            this.writeTag(e, al.Bytes), this.writeBytes(t);
        },
        writeFixed32Field: function(e, t) {
            this.writeTag(e, al.Fixed32), this.writeFixed32(t);
        },
        writeSFixed32Field: function(e, t) {
            this.writeTag(e, al.Fixed32), this.writeSFixed32(t);
        },
        writeFixed64Field: function(e, t) {
            this.writeTag(e, al.Fixed64), this.writeFixed64(t);
        },
        writeSFixed64Field: function(e, t) {
            this.writeTag(e, al.Fixed64), this.writeSFixed64(t);
        },
        writeVarintField: function(e, t) {
            this.writeTag(e, al.Varint), this.writeVarint(t);
        },
        writeSVarintField: function(e, t) {
            this.writeTag(e, al.Varint), this.writeSVarint(t);
        },
        writeStringField: function(e, t) {
            this.writeTag(e, al.Bytes), this.writeString(t);
        },
        writeFloatField: function(e, t) {
            this.writeTag(e, al.Fixed32), this.writeFloat(t);
        },
        writeDoubleField: function(e, t) {
            this.writeTag(e, al.Fixed64), this.writeDouble(t);
        },
        writeBooleanField: function(e, t) {
            this.writeVarintField(e, Boolean(t));
        }
    };
    var Ml = n(sl);
    const Pl = 3;
    function Il(e, t, n) {
        1 === e && (t.glyphs = Object.create(null), n.readMessage(Cl, t));
    }
    function Cl(e, t, n) {
        if (3 === e) {
            const e = n.readMessage(kl, {}), i = Pl;
            e.width = e.width || 0, e.height = e.height || 0, e.left = e.left || 0, e.top = e.top || 0, 
            e.advance = e.advance || 0;
            const r = e.width + 2 * i, s = e.height + 2 * i;
            t.glyphs[e.id] = {
                charCode: e.id,
                bitmap: {
                    width: r,
                    height: s,
                    data: new Uint8ClampedArray(e.bitmap || new ArrayBuffer(r * s))
                },
                metrics: {
                    width: e.width,
                    height: e.height,
                    left: 1,
                    top: -2,
                    advance: e.advance
                }
            };
        } else 4 === e ? t.ascender = n.readSVarint() : 5 === e && (t.descender = n.readSVarint());
    }
    function kl(e, t, n) {
        1 === e ? t.id = n.readVarint() : 2 === e ? t.bitmap = n.readBytes() : 3 === e ? t.width = n.readVarint() : 4 === e ? t.height = n.readVarint() : 5 === e ? t.left = n.readSVarint() : 6 === e ? t.top = n.readSVarint() : 7 === e && (t.advance = n.readVarint());
    }
    let Fl = 0;
    function Ol(e) {
        const t = {
            width: e.bitmap.width,
            height: e.bitmap.height,
            data: new Uint8ClampedArray(e.bitmap.data)
        };
        return {
            charCode: e.charCode,
            bitmap: t,
            metrics: $e({}, e.metrics)
        };
    }
    var Rl = Object.freeze({
        __proto__: null,
        calculateSignedArea: b,
        clipPolygon: Da,
        convertGeometry: z,
        convertRTLText: Zs,
        generatePickingIndiceIndex: I,
        getFeaAltitudeAndHeight: w,
        getIndexArrayType: E,
        getPosArrayType: D,
        getUnsignedArrayType: L,
        packPosition: pt,
        unpackPosition: function(e, t, n, i) {
            const r = (Math.sign(t) || 1) * (Math.abs(t) % gt), s = (Math.sign(n) || 1) * (Math.abs(n) % gt), o = Math.floor(Math.abs(t) / gt), a = Math.floor(Math.abs(n) / gt);
            return e[0] = r, e[1] = s, e[2] = Math.sign(i + 1e-5) * (2 * o + a) * mt + i, e;
        }
    });
    const El = {}, Dl = {}, Ll = [];
    var Hl = Object.freeze({
        __proto__: null,
        loadSymbolFnTypes: function e(t, n) {
            if (!t) return null;
            var i = !1;
            if (Array.isArray(t)) {
                var r, s = [];
                for (let o = 0; o < t.length; o++) (r = e(t[o], n)) ? (s.push(r), i = !0) : s.push(t[o]);
                return i ? s : t;
            }
            var o = {
                __fn_types_loaded: !0
            };
            const a = [];
            for (const e in t) it(t, e) && a.push(e);
            const l = function(e) {
                Object.defineProperty(o, e, {
                    get: function() {
                        return this["__fn_" + e] || (this["__fn_" + e] = re(this["_" + e])), this["__fn_" + e].apply(this, n());
                    },
                    set: function(t) {
                        this["_" + e] = t;
                    },
                    configurable: !0,
                    enumerable: !0
                });
            }, h = {}, c = function(e, t) {
                Object.defineProperty(o, e, {
                    get: function() {
                        this["__fn_" + e] || (this["__fn_" + e] = Wr(this["_" + e], t));
                        const i = n()[0];
                        h.zoom = i;
                        try {
                            return this["__fn_" + e].evaluateWithoutErrorHandling(h, El, Dl, null, Ll);
                        } catch (e) {
                            return null;
                        }
                    },
                    set: function(t) {
                        this["_" + e] = t;
                    },
                    configurable: !0,
                    enumerable: !0
                });
            };
            for (let e = 0, n = a.length; e < n; e++) {
                const n = a[e];
                if (ie(t[n])) i = !0, o["_" + n] = t[n], l(n); else if (Xr(t[n])) {
                    i = !0;
                    const e = Jr(n);
                    o["_" + n] = t[n], c(n, e);
                } else o[n] = t[n];
            }
            return i ? o : t;
        }
    });
    const zl = {
        polygonPatternFile: 1,
        markerFile: 1,
        markerPlacement: 1,
        markerSpacing: 1,
        textName: 1,
        textFaceName: 1,
        textPlacement: 1,
        textSpacing: 1,
        lineJoin: 1,
        lineCap: 1,
        linePatternFile: 1
    }, Nl = {
        textHorizontalAlignment: 1,
        textVerticalAlignment: 1,
        textWrapWidth: 1,
        markerHorizontalAlignment: 1,
        markerVerticalAlignment: 1
    }, Vl = {
        lineDasharray: 1,
        topPolygonFill: 1,
        bottomPolygonFill: 1
    };
    Object.assign(Nl, zl), Object.assign(Vl, zl), e.ArrayPool = ss, e.CirclePack = class extends gs {
        getFormat() {
            return Va;
        }
        placeVector(e, t) {
            const n = this._getAnchors(e, t);
            if (0 === n.length) return;
            const i = this.data, r = this.getAltitude(e.feature.properties);
            let s = i.aPosition.getLength() / Va[0].width;
            for (let e = 0; e < n.length; e++) {
                const t = n[e];
                i.aPosition.push(2 * t.x + 0, 2 * t.y + 0, r), i.aPosition.push(2 * t.x + 1, 2 * t.y + 0, r), 
                i.aPosition.push(2 * t.x + 1, 2 * t.y + 1, r), i.aPosition.push(2 * t.x + 0, 2 * t.y + 1, r), 
                this.addElements(s, s + 1, s + 2), this.addElements(s, s + 2, s + 3), s += 4;
                const o = Math.max(Math.abs(2 * t.x + 1), Math.abs(2 * t.y + 1));
                o > this.maxPos && (this.maxPos = o);
            }
        }
        _getAnchors(e, t) {
            const {feature: n, symbol: i} = e, r = this._getPlacement(e, i), s = n.properties, {markerSpacingFn: o} = this._fnTypes, a = ((o ? o(null, s) : i.markerSpacing) || 250) * t;
            return yo(e, null, null, t, this.options.EXTENT, r, a);
        }
        _getPlacement(e, t) {
            return this._fnTypes.markerPlacementFn ? this._fnTypes.markerPlacementFn(this.options.zoom, e.feature.properties) : t.markerPlacement;
        }
    }, e.DEFAULT_TEX_WIDTH = 23.25, e.FilterUtil = Kr, e.FuncTypeUtil = Hl, e.GlyphAtlas = R, 
    e.GlyphRequestor = class {
        constructor(e, t = 15, n, i) {
            this.entries = {}, this._cachedFont = {}, this._cache = new Qa(2048, (function() {})), 
            this._framer = e, this._limit = t, this._isCompactChars = n, this._sdfURL = i;
        }
        getGlyphs(e, t) {
            if (!e || !Object.keys(e).length) return void t(null, {
                glyphs: null
            });
            if (this._isValidSDFURL(this._sdfURL)) return void this._requestRemoteSDF(e, t);
            const n = this.entries, i = e.options;
            let r = !0;
            i && (r = !1 !== i.isCharsCompact), r = r || this._isCompactChars;
            const s = (i, s, a) => {
                let l = 0, h = 0;
                for (const t in e) if ("options" !== t) {
                    n[t] = n[t] || {}, s[t] = s[t] || {};
                    for (const c in e[t]) {
                        if (h++, h <= i) continue;
                        const e = r && !Os(+c), u = t + ":" + c + ":" + e;
                        let f;
                        if (this._cache.has(u) ? f = this._cache.get(u) : (f = this._tinySDF(n[t], t, c, e), 
                        this._cache.add(u, f), l++), f = Ol(f), s[t][c] = f, a.push(f.bitmap.data.buffer), 
                        this._framer && l > this._limit) return void this._framer(o(h, s, a));
                    }
                }
                t(null, {
                    glyphs: s,
                    buffers: a
                });
            };
            function o(e, t, n) {
                return () => {
                    s(e, t, n);
                };
            }
            s(0, {}, []);
        }
        _requestRemoteSDF(e, t) {
            const n = {}, i = [];
            let r = 0, s = !1;
            const o = e => {
                s || (s = !0, t(e, e ? null : {
                    glyphs: n,
                    buffers: i
                }));
            };
            for (const t in e) {
                if ("options" === t) continue;
                n[t] = {};
                const a = this._getFontEntry(t), l = this._groupByRange(e[t]);
                for (const [e, h] of l) {
                    const l = [];
                    for (const e of h) {
                        const t = a.glyphs[e];
                        t && t.bitmap && t.bitmap.data || l.push(e);
                    }
                    if (0 === l.length) for (const e of h) {
                        const r = a.glyphs[e];
                        if (r && r.bitmap && r.bitmap.data) {
                            r.metrics || (r.metrics = {
                                width: 0,
                                height: 0,
                                left: 0,
                                top: 0,
                                advance: 0
                            });
                            const s = Ol(r);
                            n[t][e] = s, i.push(s.bitmap.data.buffer);
                        }
                    } else r++, this._loadGlyphRange(t, e, ((e, a) => {
                        if (!s) if (e) o(e); else {
                            for (const e of h) {
                                const r = a[e];
                                if (!r || !r.bitmap || !r.bitmap.data) continue;
                                r.metrics || (r.metrics = {
                                    width: 0,
                                    height: 0,
                                    left: 0,
                                    top: 0,
                                    advance: 0
                                });
                                const s = Ol(r);
                                n[t][e] = s, i.push(s.bitmap.data.buffer);
                            }
                            0 == --r && o();
                        }
                    }));
                }
            }
            0 === r && o();
        }
        _loadGlyphRange(e, t, n) {
            const i = this._getFontEntry(e);
            if (i.ranges[t]) return void n(null, i.glyphs);
            if (i.requests[t]) return void i.requests[t].push(n);
            i.requests[t] = [ n ];
            const r = `${t}-${t + 255}`;
            let s = this._sdfURL.replace("{fontstack}", e).replace("{stack}", e).replace("{range}", r);
            fetch(s).then((e => {
                if (!e.ok) throw new Error(`HTTP ${e.status}`);
                return e.arrayBuffer();
            })).then((e => {
                const n = new Ml(new Uint8Array(e)).readFields(Il, {});
                i.ascender = n.ascender, i.descender = n.descender;
                for (const e in n.glyphs) i.glyphs[+e] = n.glyphs[e];
                i.ranges[t] = !0, this._flushCallbacks(i, t, null);
            })).catch((e => {
                this._flushCallbacks(i, t, e);
            }));
        }
        _tinySDF(e, t, n, i) {
            const r = t;
            let s = e.tinySDF;
            const o = i ? -1 : 2;
            if (!s) {
                let t = "400";
                /bolder/i.test(r) ? t = "1000" : /bold/i.test(r) ? t = "900" : /medium/i.test(r) ? t = "500" : /light/i.test(r) && (t = "200"), 
                s = e.tinySDF = new tl(24, 2, 8, .25, r, t);
            }
            const a = String.fromCodePoint(n), l = s.ctx.measureText(a), h = Math.round(l.width), c = s.draw(a, h + 4, 28);
            if (Fl < 4) {
                const e = "undefined" != typeof document && document.getElementById("sdf-debug-" + Fl++);
                e && (e.width = h + 4, e.height = s.canvas.height, e.getContext("2d").drawImage(s.canvas, 0, 0));
            }
            return {
                charCode: n,
                bitmap: {
                    width: h + 4,
                    height: 28,
                    data: c
                },
                metrics: {
                    width: h,
                    height: 24,
                    left: 1,
                    top: -2,
                    advance: h + 2 + o
                }
            };
        }
        _getFontEntry(e) {
            return this.entries[e] = this.entries[e] || {
                glyphs: {},
                requests: {},
                ranges: {},
                ascender: void 0,
                descender: void 0,
                tinySDF: null
            };
        }
        _groupByRange(e) {
            const t = new Map;
            for (const n in e) {
                const e = 256 * Math.floor(n / 256);
                (t.get(e) || t.set(e, []).get(e)).push(+n);
            }
            return t;
        }
        _flushCallbacks(e, t, n) {
            const i = e.requests[t];
            delete e.requests[t], i.forEach((t => t(n, e.glyphs)));
        }
        _isValidSDFURL(e) {
            return e && (e.includes("{fontstack}") || e.includes("{stack}")) && e.includes("{range}");
        }
    }, e.INVALID_TEX_COORD = Na, e.IconAtlas = F, e.LRUCache = Qa, e.LineExtrusionPack = class extends No {
        constructor(e, t, n) {
            super(e, t, n), this._hasALineHeight = n.altitudeProperty;
        }
        getFormat() {
            const {lineColorFn: e, lineWidthFn: t} = this._fnTypes, n = [ {
                type: Math.max(Math.abs(this.maxPosZ), Math.abs(this.minPosZ)) >= Math.pow(2, 15) ? Float32Array : Int16Array,
                width: 3,
                name: "aPosition"
            }, {
                type: Uint16Array,
                width: 1,
                name: "aLinesofar"
            }, {
                type: Uint8Array,
                width: 1,
                name: "aUp"
            }, {
                type: Int16Array,
                width: 3,
                name: "aExtrudedPosition"
            }, {
                type: Int8Array,
                width: 2,
                name: "aExtrude"
            } ];
            return e && n.push({
                type: Uint8Array,
                width: 4,
                name: "aColor"
            }), t && n.push({
                type: Uint8Array,
                width: 1,
                name: "aLineWidth"
            }), this._hasALineHeight && n.push({
                type: Float32Array,
                width: 1,
                name: "aLineHeight"
            }), n;
        }
        placeVector(e) {
            const t = e.feature;
            if (this._hasALineHeight) {
                const {altitudeScale: e, altitudeProperty: n, defaultAltitude: i, heightProperty: r, defaultHeight: s, minHeightProperty: o} = this.options, {altitude: a, height: l} = w(t, e, n, i, r, s, o);
                this.feaAltitude = a, this.feaMinHeight = (a - l) / a * 32767, a > this.maxAltitude && (this.maxAltitude = a);
            }
            return super.placeVector(e);
        }
        needAltitudeAttribute() {
            return !1;
        }
        _addLine(e, t, n, i, r, s) {
            const o = this.data.aPosition.getLength() / 3;
            super._addLine(e, t, n, i, r, s);
            const a = this.data.aPosition.getLength() / 3, l = this.data.aPosition.getLength() / 3 - this.offset, h = 3 === t.type, c = !1 !== this.options.side;
            if (!h && l > 0 && c) {
                const e = !1 !== this.options.top ? 1 : 0, t = e + 4;
                let n = this.data.aPosition.getLength() / 3;
                for (const e in this.data) {
                    const t = this.data[e], i = t.getLength() / n;
                    let r = t.currentIndex;
                    for (let e = 0; e < i; e++) t[r++] = t[o * i + 3 * i + e];
                    t.currentIndex = r;
                }
                n = this.data.aPosition.getLength() / 3;
                for (const e in this.data) {
                    const i = this.data[e], r = i.getLength() / n;
                    let s = i.currentIndex;
                    for (let e = 0; e < r; e++) i[s++] = i[o * r + r * t + e];
                    i.currentIndex = s;
                }
                n = this.data.aPosition.getLength() / 3;
                for (const e in this.data) {
                    const i = this.data[e], r = i.getLength() / n;
                    let s = i.currentIndex;
                    for (let e = 0; e < r; e++) i[s++] = i[o * r + r * (t + 3) + e];
                    i.currentIndex = s;
                }
                super.addElements(e + 1, l + 1, l), super.addElements(l, l + 1, l + 2);
                const i = this.data.aPosition.getLength() / 3 - this.offset;
                n = this.data.aPosition.getLength() / 3;
                for (const e in this.data) {
                    const t = this.data[e], i = t.getLength() / n;
                    let r = t.currentIndex;
                    for (let e = 0; e < i; e++) t[r++] = t[a * i - i + e];
                    t.currentIndex = r;
                }
                n = this.data.aPosition.getLength() / 3;
                for (const e in this.data) {
                    const i = this.data[e], r = i.getLength() / n;
                    let s = i.currentIndex;
                    for (let e = 0; e < r; e++) i[s++] = i[a * r - t * r - r + e];
                    i.currentIndex = s;
                }
                n = this.data.aPosition.getLength() / 3;
                for (const e in this.data) {
                    const i = this.data[e], r = i.getLength() / n;
                    let s = i.currentIndex;
                    for (let e = 0; e < r; e++) i[s++] = i[a * r - t * r - 3 * r + e];
                    i.currentIndex = s;
                }
                super.addElements(i, l - 3, i + 1), super.addElements(l - 3, i + 2, i + 1);
            }
        }
        fillData(e, t, n, i, r, s, o, a, l) {
            const h = !1 !== this.options.top, c = !1 !== this.options.side, u = this.options.EXTENT / this.options.tileSize, f = this.feaLineWidth || this.symbol.lineWidth / 2 * u, d = Ro * r, p = Ro * s, g = f * r + t, m = f * s + n;
            this._fillTop(e, t, n, r, s, o, a, l, g, m, d, p), c && (h && this._fillTop(e, t, n, r, s, o, a, l, g, m, d, p), 
            this._fillTop(e, t, n, r, s, o, a, l, g, m, d, p), this._fillBottom(e, t, n, r, s, o, a, l, g, m, d, p), 
            this._fillBottom(e, t, n, r, s, o, a, l, g, m, d, p)), this.maxPos = Math.max(this.maxPos, Math.abs(t), Math.abs(n));
        }
        _fillTop(e, t, n, i, r, s, o, a, l, h, c, u) {
            const {lineColorFn: f, lineWidthFn: d} = this._fnTypes;
            let p = e.aPosition.currentIndex;
            e.aPosition[p++] = t, e.aPosition[p++] = n, e.aPosition[p++] = 32767, e.aPosition.currentIndex = p, 
            p = e.aLinesofar.currentIndex, e.aLinesofar[p++] = a, e.aLinesofar.currentIndex = p, 
            p = e.aUp.currentIndex, e.aUp[p++] = +o, e.aUp.currentIndex = p, p = e.aExtrudedPosition.currentIndex, 
            e.aExtrudedPosition[p++] = l, e.aExtrudedPosition[p++] = h, e.aExtrudedPosition[p++] = 1, 
            e.aExtrudedPosition.currentIndex = p, p = e.aExtrude.currentIndex, e.aExtrude[p++] = c, 
            e.aExtrude[p++] = u, e.aExtrude.push(c, u), f && (p = e.aColor.currentIndex, e.aColor[p++] = this.feaColor[0], 
            e.aColor[p++] = this.feaColor[1], e.aColor[p++] = this.feaColor[2], e.aColor[p++] = this.feaColor[3], 
            e.aColor.currentIndex = p), d && (p = e.aLineWidth.currentIndex, e.aLineWidth[p++] = Math.round(2 * this.feaLineWidth), 
            e.aLineWidth.currentIndex = p), this._hasALineHeight && (p = e.aLineHeight.currentIndex, 
            e.aLineHeight[p++] = this.feaAltitude, e.aLineHeight.currentIndex = p);
        }
        _fillBottom(e, t, n, i, r, s, o, a, l, h, c, u) {
            const {lineColorFn: f, lineWidthFn: d} = this._fnTypes;
            let p = e.aPosition.currentIndex;
            e.aPosition[p++] = t, e.aPosition[p++] = n, e.aPosition[p++] = this.feaMinHeight || 0, 
            e.aPosition.currentIndex = p, p = e.aLinesofar.currentIndex, e.aLinesofar[p++] = a, 
            e.aLinesofar.currentIndex = p, p = e.aUp.currentIndex, e.aUp[p++] = +o, e.aUp.currentIndex = p, 
            p = e.aExtrudedPosition.currentIndex, e.aExtrudedPosition[p++] = l, e.aExtrudedPosition[p++] = h, 
            e.aExtrudedPosition[p++] = 1, e.aExtrudedPosition.currentIndex = p, p = e.aExtrude.currentIndex, 
            e.aExtrude[p++] = c, e.aExtrude[p++] = u, e.aExtrude.push(c, u), f && (p = e.aColor.currentIndex, 
            e.aColor[p++] = this.feaColor[0], e.aColor[p++] = this.feaColor[1], e.aColor[p++] = this.feaColor[2], 
            e.aColor[p++] = this.feaColor[3], e.aColor.currentIndex = p), d && (p = e.aLineWidth.currentIndex, 
            e.aLineWidth[p++] = Math.round(2 * this.feaLineWidth), e.aLineWidth.currentIndex = p), 
            this._hasALineHeight && (p = e.aLineHeight.currentIndex, e.aLineHeight[p++] = this.feaAltitude, 
            e.aLineHeight.currentIndex = p);
        }
        addElements(e, t, n) {
            const i = !1 !== this.options.top, r = !1 !== this.options.side, s = (i ? 1 : 0) + (r ? 4 : 0), o = this.offset;
            if (e *= s, t *= s, n *= s, this.data.aUp[o + n + 4]) {
                if (i && super.addElements(t, e, n), r) {
                    const e = i ? 1 : 0;
                    super.addElements(t + e, n + e, n + e + 2), super.addElements(t + e + 1, n + e + 1 + 2, t + e + 1 + 2);
                }
            } else if (i && super.addElements(e, n, t), r) {
                const t = i ? 1 : 0;
                super.addElements(e + t, e + t + 2, n + t), super.addElements(e + t + 1 + 2, n + t + 1 + 2, n + t + 1);
            }
        }
        createDataPack(e, t) {
            this.maxAltitude = 0;
            const n = super.createDataPack(e, t);
            if (!n) return n;
            const {data: i, indices: r} = n;
            this.getFormat().reduce(((e, t) => (e[t.name] = {
                size: t.width
            }, e)), {}).aPickingId = {
                size: 1
            };
            const {aExtrudedPosition: s, aPosition: o, aLinesofar: a, aUp: l, aExtrude: h, aColor: c, aLineHeight: u, aLineWidth: f} = i, d = {}, p = function(e, t, n) {
                const i = [];
                i.setLength && i.setLength(e.length);
                const r = $o;
                r.length < e.length / 3 && (r.length = e.length / 3), r.fill(0, 0, e.length / 3);
                const s = void 0 === t.length ? t : t.length;
                for (let n = 0; n < s / 3; n++) void 0 === t.length ? ra(e, 3 * n, 3 * n + 1, 3 * n + 2, i, r) : ra(e, t[3 * n], t[3 * n + 1], t[3 * n + 2], i, r);
                for (let e = 0; e < i.length; e += 3) {
                    const t = r[e / 3];
                    0 !== t ? (i[e] /= t, i[e + 1] /= t, i[e + 2] /= t) : (i[e] = 0, i[e + 1] = 0, i[e + 2] = 0);
                }
                return i;
            }(s, r);
            let g, m = !0;
            for (let e = 0; e < p.length; e++) p[e] = -p[e], p[e] % 1 != 0 && (m = !1);
            !1 !== this.options.top && this.symbol.material && function(e) {
                for (const t in e) if (t.indexOf("Texture") >= 0 && e[t]) return !0;
                return !1;
            }(this.symbol.material) && (g = function(e, t, n) {
                const i = [];
                for (let r = 0; r < e.length; r += 3) {
                    const e = t[r / 3];
                    n[r / 3] ? i.push(e / 256, 1) : i.push(e / 256, 0);
                }
                return i;
            }(s, a, l)), d.aPosition = o, g && (d.aTexCoord0 = new Float32Array(g)), d.aNormal = m ? new Int8Array(p) : new Float32Array(p), 
            d.aPickingId = i.aPickingId, d.aExtrude = h, c && (d.aColor = c), f && (d.aLineWidth = f), 
            u && (d.aLineHeight = u);
            const y = [];
            for (const e in d) y.push(d[e].buffer);
            return n.data = d, n.buffers = y, n;
        }
    }, e.LinePack = No, e.NativeLinePack = class extends gs {
        getFormat() {
            return [ ...this.getPositionFormat() ];
        }
        placeVector(e) {
            const t = e.feature, n = 3 === t.type, i = t.geometry, r = this.elements;
            n && (this.elements = this._arrayPool.get());
            const s = this.needAltitudeAttribute() ? 2 : 3;
            for (let e = 0; e < i.length; e++) this.offset = this.data.aPosition.getLength() / s, 
            this._addLine(i[e], t), n && (this._filterPolygonEdges(r), this.elements = this._arrayPool.get());
            n && (this.elements = r);
        }
        _addLine(e, t) {
            const n = 3 === t.type;
            let i = e.length;
            for (;i >= 2 && e[i - 1].equals(e[i - 2]); ) i--;
            let r, s, o, a = 0;
            for (;a < i - 1 && e[a].equals(e[a + 1]); ) a++;
            if (!(i < (n ? 3 : 2))) {
                this.distance = 0, this.vertexLength = 0, this.primitiveLength = 0, this.e1 = this.e2 = this.e3 = -1, 
                n && (r = e[i - 2]);
                for (let t = a; t < i; t++) o = n && t === i - 1 ? e[a + 1] : e[t + 1], o && e[t].equals(o) || (r && (s = r), 
                r = e[t], s && (this.distance += r.dist(s)), this.addCurrentVertex(r, this.distance));
            }
        }
        addCurrentVertex(e, t) {
            const n = this.vertexLength++;
            this.addLineVertex(this.data, e, t), n >= 1 && this.addElements(n - 1, n), t > sa && (this.distance = 0, 
            this.addCurrentVertex(e, this.distance));
        }
        addLineVertex(e, t) {
            const n = this.needAltitudeAttribute();
            this.fillPosition(e, t.x, t.y, t.z || 0), this.maxPos = n ? Math.max(this.maxPos, Math.abs(t.x), Math.abs(t.y)) : Math.max(this.maxPos, Math.abs(t.x), Math.abs(t.y), Math.abs(t.z || 0));
        }
        addElements(e, t) {
            this.maxIndex = Math.max(this.maxIndex, this.offset + e, this.offset + t);
            let n = this.elements.currentIndex;
            this.elements[n++] = this.offset + e, this.elements[n++] = this.offset + t, this.elements.currentIndex = n;
        }
        _filterPolygonEdges(e) {
            const t = this.options.EXTENT, n = this.elements, i = n.getLength();
            for (let r = 0; r < i; r += 2) if (!A(this.data.aPosition, n[r], n[r + 1], 3, t)) {
                let t = e.currentIndex;
                e[t++] = n[r], e[t++] = n[r + 1], e.currentIndex = t;
            }
        }
    }, e.NativePointPack = class extends gs {
        getFormat() {
            const {markerFillFn: e} = this._fnTypes;
            let t;
            return t = "line" === this.symbol.markerRotationAlignment ? [ ...this.getPositionFormat(), {
                type: Float32Array,
                width: 1,
                name: "aXYRotation"
            }, {
                type: Float32Array,
                width: 1,
                name: "aZRotation"
            } ] : [ ...this.getPositionFormat() ], e && t.push({
                type: Uint8Array,
                width: 4,
                name: "aColor"
            }), t;
        }
        placeVector(e) {
            const t = e.feature.properties, {markerFillFn: n} = this._fnTypes;
            let i;
            n && (i = n(this.options.zoom, t) || [ 255, 255, 255, 255 ], ie(i) ? (this.dynamicAttrs.aColor = 1, 
            i = [ 0, 0, 0, 0 ]) : i = ht([], i));
            const r = this.data, s = this.symbol.markerSpacing || 250, o = this.symbol.markerPlacement || "point", a = "line" === this.symbol.markerRotationAlignment, l = this._getAnchors(e, s, o, a), h = this.needAltitudeAttribute();
            for (let e = 0; e < l.length; e++) {
                const t = l[e];
                if (this.fillPosition(this.data, t.x, t.y, t.z), a) {
                    let e = r.aXYRotation.currentIndex;
                    r.aXYRotation[e++] = t.xyRotation || 0, r.aXYRotation.currentIndex = e, e = r.aZRotation.currentIndex, 
                    r.aZRotation[e++] = t.zRotation || 0, r.aZRotation.currentIndex = e;
                }
                if (i) {
                    let e = r.aColor.currentIndex;
                    r.aColor[e++] = i[0], r.aColor[e++] = i[1], r.aColor[e++] = i[2], r.aColor[e++] = i[3], 
                    r.aColor.currentIndex = e;
                }
                let n;
                n = h ? Math.max(Math.abs(t.x), Math.abs(t.y)) : Math.max(Math.abs(t.x), Math.abs(t.y), Math.abs(t.z || 0)), 
                n > this.maxPos && (this.maxPos = n);
            }
        }
        _getAnchors(e, t, n, i) {
            const r = e.feature, s = this.options.EXTENT;
            if ("line" === n) {
                const e = [];
                let n = r.geometry;
                s && (n = eo(r.geometry, 0, 0, s, s));
                for (let i = 0; i < n.length; i++) {
                    const r = io(n[i], t, oa, null, 0, 24, 1, 1, s || 1 / 0);
                    e.push.apply(e, r);
                }
                return e;
            }
            return xo(r, n, s, i, this.options.altitudeToTileScale);
        }
        hasElements() {
            return !1;
        }
    }, e.PackUtil = Rl, e.PointPack = To, e.PolygonPack = class extends gs {
        constructor(...e) {
            super(...e), this.lineElements = [];
        }
        createStyledVector(e, t, n, i, r) {
            const s = new dt(e, t, n, i), o = s.getPolygonResource();
            return !this.options.atlas && o && (r[o] = [ 0, 0 ]), s;
        }
        getFormat() {
            const e = [ ...this.getPositionFormat() ], {polygonFillFn: t, polygonOpacityFn: n, uvScaleFn: i, uvOffsetFn: r, polygonPatternUVFn: s} = this._fnTypes;
            if (this.iconAtlas) {
                const t = this.getIconAtlasMaxValue();
                e.push({
                    type: t > 255 ? Uint16Array : Uint8Array,
                    width: 4,
                    name: "aTexInfo"
                });
            }
            return t && e.push({
                type: Uint8Array,
                width: 4,
                name: "aColor"
            }), n && e.push({
                type: Uint8Array,
                width: 1,
                name: "aOpacity"
            }), i && e.push({
                type: Uint16Array,
                width: 2,
                name: "aUVScale"
            }), r && e.push({
                type: Uint8Array,
                width: 2,
                name: "aUVOffset"
            }), s && e.push({
                type: Float32Array,
                width: 2,
                name: "aTexCoord"
            }), e;
        }
        placeVector(e, t) {
            const n = e.feature, i = n.geometry;
            this._addPolygon(i, n, t);
        }
        _addPolygon(e, t) {
            let n, i, r, s;
            const {polygonFillFn: o, polygonOpacityFn: a, uvScaleFn: l, uvOffsetFn: h, uvOffsetInMeterFn: c, polygonPatternUVFn: u} = this._fnTypes, f = t.properties;
            o && (n = o(this.options.zoom, f) || ko([], 255, 255, 255, 255), ie(n) ? (this.dynamicAttrs.aColor = 1, 
            n = za) : n = ht([], n)), a && (i = a(this.options.zoom, f), ie(i) ? (this.dynamicAttrs.aOpacity = 1, 
            i = 255) : (Je(i) && (i = 1), i *= 255)), l && (r = l(this.options.zoom, f), ie(r) ? (r = [ 255, 255 ], 
            this.dynamicAttrs.aUVScale = 1) : (Je(r) && (r = [ 1, 1 ]), r = [ 255 * r[0], 255 * r[1] ])), 
            h && (c && c(null, f) ? s = [ 0, 0 ] : (s = h(this.options.zoom, f), ie(s) ? (s = [ 0, 0 ], 
            this.dynamicAttrs.aUVOffset = 1) : (Je(s) && (s = [ 0, 0 ]), s = [ 255 * s[0], 255 * s[1] ])));
            const d = !!this.iconAtlas, p = lo(e, 500), g = [ 0, 0 ], m = [ 0, 0 ];
            if (d) {
                const {polygonPatternFileFn: e} = this._fnTypes, t = e ? e(null, f) : this.symbol.polygonPatternFile;
                if (this.iconAtlas.iconMap[t]) {
                    const e = this.iconAtlas.positions[t], n = !C(e.displaySize[0]) || !C(e.displaySize[1]);
                    g[0] = e.tl[0] + (n ? 1 : 0), g[1] = e.tl[1] + (n ? 1 : 0), m[0] = e.displaySize[0] - 1 - (n ? 2 : 0), 
                    m[1] = e.displaySize[1] - 1 - (n ? 2 : 0);
                }
            }
            let y, x = 0;
            u && (y = u(this.options.zoom, f));
            const _ = this.needAltitudeAttribute() ? 2 : 3, v = [ -1, -1, t.extent + 1, t.extent + 1 ], b = this._flattened = this._flattened || this._arrayPool.getProxy(), A = this._holeIndices = this._holeIndices || this._arrayPool.getProxy();
            for (let e = 0; e < p.length; e++) {
                const t = p[e], o = this.data.aPosition.getLength() / _;
                b.setLength(0), A.setLength(0);
                for (let e = 0; e < t.length; e++) {
                    let o = t[e];
                    if (this.options.EXTENT !== 1 / 0 && 0 === this.maxPosZ && 0 === this.minPosZ && (o = Da(o, v)), 
                    0 === o.length) continue;
                    0 !== e && A.push(b.length / 3), this.ensureDataCapacity(o.length);
                    const a = this.data;
                    for (let e = 0; e < o.length; e++) {
                        const t = o[e].x, l = o[e].y, h = o[e].z || 0;
                        if (this.fillPosition(this.data, t, l, h), d) {
                            let e = a.aTexInfo.currentIndex;
                            a.aTexInfo[e++] = g[0], a.aTexInfo[e++] = g[1], a.aTexInfo[e++] = m[0], a.aTexInfo[e++] = m[1], 
                            a.aTexInfo.currentIndex = e;
                        }
                        if (void 0 !== n) {
                            let e = a.aColor.currentIndex;
                            a.aColor[e++] = n[0], a.aColor[e++] = n[1], a.aColor[e++] = n[2], a.aColor[e++] = n[3], 
                            a.aColor.currentIndex = e;
                        }
                        if (void 0 !== i) {
                            let e = a.aOpacity.currentIndex;
                            a.aOpacity[e++] = i, a.aOpacity.currentIndex = e;
                        }
                        if (void 0 !== r) {
                            let e = a.aUVScale.currentIndex;
                            a.aUVScale[e++] = r[0], a.aUVScale[e++] = r[1], a.aUVScale.currentIndex = e;
                        }
                        if (void 0 !== s) {
                            let e = a.aUVOffset.currentIndex;
                            a.aUVOffset[e++] = s[0], a.aUVOffset[e++] = s[1], a.aUVOffset.currentIndex = e;
                        }
                        if (u) {
                            let e = a.aTexCoord.currentIndex;
                            if (y) {
                                const t = Je(y[2 * x]) ? y[0] : y[2 * x], n = Je(y[2 * x] + 1) ? y[1] : y[2 * x + 1];
                                a.aTexCoord[e++] = t, a.aTexCoord[e++] = n;
                            } else a.aTexCoord[e++] = Na, a.aTexCoord[e++] = Na;
                            a.aTexCoord.currentIndex = e, x++;
                        }
                        const c = Math.abs(t), f = Math.abs(l);
                        c > this.maxPos && (this.maxPos = c), f > this.maxPos && (this.maxPos = f), b.push(t, l, h);
                    }
                }
                let a = aa(b, A, 3);
                if (b.length && !a.length) {
                    const e = [];
                    for (let t = 0; t < b.length; t += 3) e[t] = b[t], e[t + 1] = b[t + 2], e[t + 2] = b[t + 1];
                    if (a = aa(e, A, 3), !a.length) {
                        for (let t = 0; t < b.length; t += 3) e[t] = b[t + 1], e[t + 1] = b[t + 2], e[t + 2] = b[t];
                        a = aa(e, A, 3);
                    }
                }
                for (let e = 0; e < a.length; e += 3) this.addElements(o + a[e], o + a[e + 1], o + a[e + 2]);
            }
        }
        ensureDataCapacity(e) {
            super.ensureDataCapacity(1, e);
        }
    }, e.RGBAImage = v, e.RoundTubePack = Ba, e.SYMBOLS_NEED_REBUILD_IN_VECTOR = Vl, 
    e.SYMBOLS_NEED_REBUILD_IN_VT = Nl, e.SquareTubePack = class extends Ba {
        addHalfVertex(e, t, n, i, r, s, o, a) {
            const {x: l, y: h, z: c} = e, u = 1 * this.scaledDistance, {x: f, y: d, z: p} = o.dir, g = Ka(this.feaLineWidth, this.feaLineHeight, f, d, p, t, n, r);
            this.prevVertex && this.fillTubeElements(r), this.fillData(this.data, l, h, c || 0, g, r, u, a);
        }
        ensureDataCapacity(e, t, n, i) {
            return super.ensureDataCapacity(e, t, n, 2 * i);
        }
    }, e.StyleUtil = ft, e.StyledPoint = Ks, e.StyledVector = dt, e.TEXT_MAX_ANGLE = 80, 
    e.TextUtil = Is, e.VectorPack = gs, t().maptalks_vt_packers = e;
}

Y({});

function q() {
    return function() {
        if ("undefined" != typeof globalThis) return globalThis;
        if ("undefined" != typeof self) return self;
        if ("undefined" != typeof window) return window;
        if ("undefined" != typeof global) return global;
        throw new Error("unable to locate global object");
    }().maptalks_vt_packers;
}

var Z = {
    vert: "\nstruct VTPUniforms {\n    minAltitude: f32,\n};\n\n@group(0) @binding($b) var<uniform> vtUniforms: VTPUniforms;\n\n#ifdef HAS_ALTITUDE\n    fn unpackVTPositionOffset(vertexInput: VertexInput, offset: vec3f) -> vec3f {\n        var altitude: f32 = vertexInput.aAltitude;\n        #ifdef HAS_TERRAIN_ALTITUDE\n            // aTerrainAltitude的单位是米，在vt中需要转换为厘米\n            altitude += vertexInput.aTerrainAltitude * 100.0;\n        #endif\n        altitude += vtUniforms.minAltitude * 100.0;\n        return vec3f(vec2f(vertexInput.aPosition.xy) + offset.xy, altitude + offset.z);\n    }\n#else\n    // 16384 is pow(2.0, 14.0)\n    const position_modValue: f32 = 16384.0;\n    const position_delta: f32 = 0.00001;\n\n    fn unpackVTPositionOffset(vertexInput: VertexInput, offset:vec3f) -> vec3f {\n        let aPosition: vec3f = vec3f(vertexInput.aPosition.xyz);\n        let z: f32 = aPosition.z;\n        let pos: vec2f = sign(aPosition.xy + position_delta) * (abs(aPosition.xy) % position_modValue);\n        let highs: vec2f = floor(abs(aPosition.xy) / position_modValue);\n\n        var altitude: f32 = sign(z + position_delta) * (highs.x * 2.0 + highs.y) * pow(2.0, 15.0) + z;\n        #ifdef HAS_TERRAIN_ALTITUDE\n            // aTerrainAltitude的单位是米，在vt中需要转换为厘米\n            altitude += vertexInput.aTerrainAltitude * 100.0;\n        #endif\n        altitude += vtUniforms.minAltitude * 100.0;\n        return vec3f(pos + offset.xy, altitude + offset.z);\n    }\n#endif\n\n    fn unpackVTPosition(vertexInput: VertexInput) -> vec3f {\n        return unpackVTPositionOffset(vertexInput, vec3f(0));\n    }\n",
    attributes: [ {
        defines: [ "HAS_TERRAIN_ALTITUDE" ],
        name: "aTerrainAltitude",
        type: "f32"
    } ]
};

var $ = {
    frag: "\n#define SDF_PX 8.0\n#define DEVICE_PIXEL_RATIO 1.0\n// 0.105 / DEVICE_PIXEL_RATIO\n#define EDGE_GAMMA 0.105 / 1.0\n\nstruct TextRenderShaderUniforms {\n    gammaScale: f32\n}\n\nstruct TextRenderUniforms {\n    textOpacity: f32,\n    isHalo: f32,\n    textHaloBlur: f32,\n    #ifndef HAS_TEXT_HALO_OPACITY\n        textHaloOpacity: f32,\n    #endif\n    #ifndef HAS_TEXT_HALO_RADIUS\n        textHaloRadius: f32,\n    #endif\n    #ifndef HAS_TEXT_FILL\n        textFill: vec4f,\n    #endif\n    #ifndef HAS_TEXT_HALO_FILL\n        textHaloFill: vec4f,\n    #endif\n};\n\n@group(0) @binding($b) var<uniform> textRenderUniforms: TextRenderUniforms;\n@group(0) @binding($b) var<uniform> textRenderShaderUniforms: TextRenderShaderUniforms;\n@group(0) @binding($b) var glyphTex: texture_2d<f32>;\n@group(0) @binding($b) var glyphTexSampler: sampler;\n\n\nfn renderText(input: VertexOutput) -> vec4f {\n    #ifdef HAS_TEXT_FILL\n        var myTextFill = input.vTextFill;\n    #else\n        var myTextFill = textRenderUniforms.textFill;\n    #endif\n    let gammaScale = textRenderShaderUniforms.gammaScale;\n    let fontScale = input.vTextSize / 24.0;\n    var color = myTextFill;\n    var gamma = EDGE_GAMMA / (fontScale * gammaScale);\n    var buff = 185.0 / 256.0; // (256.0 - 64.0) / 256.0\n\n    var isHaloText: bool;\n    #ifdef HAS_HALO_ATTR\n        // text halo in icon\n        isHaloText = input.vHalo > 0.5;\n    #else\n        isHaloText = textRenderUniforms.isHalo == 1.0;\n    #endif\n\n    if (isHaloText) {\n        #ifdef HAS_TEXT_HALO_FILL\n            var haloFill = input.vTextHaloFill;\n        #else\n            var haloFill = textRenderUniforms.textHaloFill;\n        #endif\n\n        #ifdef HAS_TEXT_HALO_RADIUS\n            let haloRadius = input.vTextHalo.x;\n        #else\n            let haloRadius = textRenderUniforms.textHaloRadius;\n        #endif\n\n        if (haloRadius == 0.0) {\n            discard;\n        }\n\n        color = haloFill;\n        gamma = (textRenderUniforms.textHaloBlur * 1.19 / SDF_PX + EDGE_GAMMA) / (fontScale * gammaScale);\n        buff = (6.0 - haloRadius / fontScale) / SDF_PX;\n\n        #ifdef HAS_TEXT_HALO_OPACITY\n            let haloOpacity = input.vTextHalo.y / 255.0;\n        #else\n            let haloOpacity = textRenderUniforms.textHaloOpacity;\n        #endif\n\n        color *= haloOpacity * 1.25;\n    }\n\n    let dist = textureSampleLevel(glyphTex, glyphTexSampler, input.vTexCoord, 0.0).r;\n    let gammaScaled = gamma * input.vGammaScale * 0.7;\n\n    let alpha = clamp(smoothstep(buff - gammaScaled, buff + gammaScaled, dist), 0.0, 1.0);\n    return color * (alpha * textRenderUniforms.textOpacity);\n}\n"
};

let J = 0;

function K() {
    return J++;
}

const Q = "function" == typeof Object.assign;

function ee(e, ...t) {
    if (Q) return Object.assign(e, ...t), e;
    for (let n = 0; n < t.length; n++) {
        const i = t[n];
        for (const t in i) e[t] = i[t];
    }
    return e;
}

function te(e) {
    return !se(e) && ("string" == typeof e || null !== e.constructor && e.constructor === String);
}

function ne(e) {
    return "number" == typeof e && !isNaN(e);
}

function ie(e) {
    return !se(e) && ("function" == typeof e || null !== e.constructor && e.constructor === Function);
}

function re(e) {
    return !Array.isArray(e) && "object" == typeof e && !!e;
}

function se(e) {
    return null == e;
}

function oe(e) {
    for (let t = 1; t < arguments.length; t++) {
        const n = arguments[t];
        if (n) for (let t = 0, i = n.length; t < i; t++) e.push(n[t]);
    }
    return e.length;
}

function ae(e) {
    return k(e) && e.property;
}

function le(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}

function he(e, t) {
    return t.altitudeToPoint(100, e) / 100 / 100;
}

new TextEncoder;

const ce = new TextDecoder;

function ue(e, t, n) {
    if (!e) return;
    if (!t || !n || !Array.isArray(n)) return;
    const i = t, r = i.featuresTypeArray;
    r && r instanceof Uint8Array && (i.featuresFullJSON = function(e) {
        try {
            const t = ce.decode(e);
            return JSON.parse(t);
        } catch (e) {
            console.error("decode Uint8Array to JSON error:", e);
        }
    }(r), delete i.featuresTypeArray);
    const s = i.featuresFullJSON;
    if (s) for (let e = 0, t = (n = n || []).length; e < t; e++) {
        const t = n[e].feature;
        let i = t;
        const r = re(i);
        r && (i = i.id);
        const o = s[i];
        o && r && (t.geometry && t.geometry.coordinates || (t.geometry = o.geometry, t.geometry.isMVTCoordinates = !0, 
        t.geometry.type || (t.geometry.type = o.type)));
    }
}

function fe(e, t, n) {
    for (let i = 0; i < e.length; i++) {
        const r = e[i], s = ee({}, r), {renderPlugin: o} = r, a = ee({}, o);
        a.sceneConfig && !Object.keys(a.sceneConfig).length && delete a.sceneConfig;
        let l = -1;
        for (let e = n.length - 1; e >= 0; e--) if (C(a, n[e])) {
            l = e;
            break;
        }
        l < 0 && (l = n.length, n.push(a)), s.renderPlugin = l, t.push(s);
    }
}

const de = "function" == typeof fetch && "function" == typeof AbortController, pe = {
    jsonp: function(e, t) {
        const n = "_maptalks_jsonp_" + K();
        e.match(/\?/) ? e += "&callback=" + n : e += "?callback=" + n;
        let i = document.createElement("script");
        return i.type = "text/javascript", i.src = e, window[n] = function(e) {
            t(null, e), document.getElementsByTagName("head")[0].removeChild(i), i = null, delete window[n];
        }, document.getElementsByTagName("head")[0].appendChild(i), this;
    },
    get: function(e, t, n) {
        if (ie(t)) {
            const e = n;
            n = t, t = e;
        }
        let i = (t = t || {}).errorLog;
        se(i) && (i = !0), t.method && (t.method = t.method.toUpperCase());
        const r = "POST" === t.method;
        if (de) {
            const r = new AbortController, s = t;
            s.signal = r.signal, s.referrerPolicy = s.referrerPolicy || "origin", s.method = s.method || "GET";
            const o = new Request(e, s);
            return t.returnJSON && o.headers.set("Accept", "application/json"), fetch(o).then((r => {
                const s = this._parseResponse(r, t.returnJSON, t.responseType);
                s.message ? (s.url = e, n(s)) : s.then((e => {
                    "arraybuffer" === t.responseType ? n(null, {
                        data: e,
                        cacheControl: r.headers.get("Cache-Control"),
                        expires: r.headers.get("Expires"),
                        contentType: r.headers.get("Content-Type")
                    }) : n(null, e);
                })).catch((t => {
                    t.code && t.code === DOMException.ABORT_ERR || (i && console.error("Fetch error:", e, t), 
                    n(t));
                }));
            })).catch((t => {
                t.code && t.code === DOMException.ABORT_ERR || (i && console.error("Fetch error:", e, t), 
                n(t));
            })), r;
        }
        {
            const i = pe._getClient(n);
            if (i.open(t.method || "GET", e, !0), t) {
                for (const e in t.headers) i.setRequestHeader(e, t.headers[e]);
                i.withCredentials = "include" === t.credentials, t.responseType && (i.responseType = t.responseType);
            }
            return i.send(r ? t.body : null), i;
        }
    },
    _parseResponse: (e, t, n) => 200 !== e.status ? {
        status: e.status,
        statusText: e.statusText,
        message: `incorrect http request with status code(${e.status}): ${e.statusText}`
    } : "arraybuffer" === n ? e.arrayBuffer() : t ? e.json() : e.text(),
    _wrapCallback: function(e, t) {
        return function() {
            if (4 === e.readyState) if (200 === e.status) if ("arraybuffer" === e.responseType) {
                0 === e.response.byteLength ? t({
                    status: 200,
                    statusText: e.statusText,
                    message: "http status 200 returned without content."
                }) : t(null, {
                    data: e.response,
                    cacheControl: e.getResponseHeader("Cache-Control"),
                    expires: e.getResponseHeader("Expires"),
                    contentType: e.getResponseHeader("Content-Type")
                });
            } else t(null, e.responseText); else t({
                status: e.status,
                statusText: e.statusText,
                message: `incorrect http request with status code(${e.status}): ${e.statusText}`
            });
        };
    },
    _getClient: function(e) {
        let t;
        try {
            t = new XMLHttpRequest;
        } catch (e) {
            try {
                t = new ActiveXObject("Msxml2.XMLHTTP");
            } catch (e) {
                try {
                    t = new ActiveXObject("Microsoft.XMLHTTP");
                } catch (e) {}
            }
        }
        return t.onreadystatechange = pe._wrapCallback(t, e), t;
    },
    getArrayBuffer(e, t, n) {
        if (ie(t)) {
            const e = n;
            n = t, t = e;
        }
        return t || (t = {}), t.responseType = "arraybuffer", pe.get(e, t, n);
    },
    getJSON: function(e, t, n) {
        if (ie(t)) {
            const e = n;
            n = t, t = e;
        }
        const i = function(e, t) {
            const i = "string" == typeof t ? JSON.parse(t) : t || null;
            n(e, i);
        };
        return t && t.jsonp ? pe.jsonp(e, i) : ((t = t || {}).returnJSON = !0, pe.get(e, t, i));
    }
};

class ge {
    constructor(e) {
        this.max = e, this.reset();
    }
    reset() {
        return this.data = {}, this.order = [], this;
    }
    clear() {
        this.reset();
    }
    add(e, t) {
        return this.has(e) ? (this.order.splice(this.order.indexOf(e), 1), this.data[e] = t, 
        this.order.push(e)) : (this.data[e] = t, this.order.push(e), this.order.length > this.max && this.getAndRemove(this.order[0])), 
        this;
    }
    has(e) {
        return e in this.data;
    }
    keys() {
        return this.order;
    }
    getAndRemove(e) {
        if (!this.has(e)) return null;
        const t = this.data[e];
        return delete this.data[e], this.order.splice(this.order.indexOf(e), 1), t;
    }
    get(e) {
        if (!this.has(e)) return null;
        return this.data[e];
    }
    remove(e) {
        return this.has(e) ? (delete this.data[e], this.order.splice(this.order.indexOf(e), 1), 
        this) : this;
    }
    setMaxSize(e) {
        for (this.max = e; this.order.length > this.max; ) this.getAndRemove(this.order[0]);
        return this;
    }
}

class me {
    constructor(e) {
        this.options = e || {}, this._requesting = {}, this._cache = new ge(256, (function() {}));
        const t = document.createElement("canvas");
        this.ctx = t.getContext("2d", {
            willReadFrequently: !0
        });
    }
    getIcons(e, s) {
        if (!e || !Object.keys(e).length) return void s(null, {
            icons: null
        });
        const o = Object.keys(e), a = {}, l = [];
        let h = 0, c = 0;
        const u = this;
        function f(e, t) {
            a[e] = u._getCache(e, t), a[e] && "error" !== a[e] ? l.push(a[e].data.data.buffer) : delete a[e], 
            c++, c === h && s(null, {
                icons: a,
                buffers: l
            });
        }
        function d(e) {
            const t = u._requesting[e.url];
            for (let n = 0; n < t.length; n++) t[n].call(e, e.url, e.size);
            delete u._requesting[e.url];
        }
        function p() {
            const e = u.ctx;
            let t, n;
            try {
                t = this.width, n = this.height, this.size[0] = t, this.size[1] = n, u._ensureMaxSize(null, this.size), 
                t = this.size[0], n = this.size[1];
                const i = e.canvas;
                i.width = t, i.height = n, e.imageSmoothingEnabled = !1, e.drawImage(this, 0, 0, t, n);
                const r = e.getImageData(0, 0, i.width, i.height).data;
                u._addCache(this.url, r, i.width, i.height);
            } catch (e) {
                console.warn(e);
            }
            d(this);
        }
        function g(e) {
            console.warn(`failed loading icon(${this.index}) at "${this.url}"`), console.warn(e), 
            u.options.iconErrorUrl ? this.src = u.options.iconErrorUrl : (u._addCache(this.url), 
            d(this));
        }
        const m = this.options.urlModifier;
        let y, x = !1;
        for (let s = 0; s < o.length; s++) {
            const c = o[s], u = e[c];
            this._ensureMaxSize(c, u);
            const d = this._getCache(c, u);
            if (d && "error" !== d) {
                a[c] = this._getCache(c, u);
                continue;
            }
            if ("error" === d) continue;
            let v, b = c;
            if (0 === c.indexOf("vector://") && (v = JSON.parse(c.substring(9)), "path" === v.markerType && (b = t.getMarkerPathBase64(v, v.markerWidth, v.markerHeight))), 
            b = n(b), 0 === c.indexOf("vector://") && "path" !== v.markerType) {
                y = y || new i([ 0, 0 ]);
                const {markerFill: e, markerLineColor: t} = v;
                e && Array.isArray(e) && (v.markerFill = ye(e)), t && Array.isArray(t) && (v.markerLineColor = ye(t)), 
                delete v.markerHorizontalAlignment, delete v.markerVerticalAlignment, delete v.markerDx, 
                delete v.markerDy, delete v.markerPlacement, delete v.markerFile, v.markerWidth = u[0], 
                v.markerHeight = u[1], y.setSymbol(v);
                const n = y["_getSprite".trim()]();
                if (n) {
                    const e = n.canvas, t = e.width, i = e.height, r = e.getContext("2d", {
                        willReadFrequently: !0
                    }).getImageData(0, 0, t, i).data;
                    a[c] = {
                        data: {
                            data: new Uint8ClampedArray(r),
                            width: t,
                            height: i
                        },
                        url: c
                    }, l.push(a[c].data.data.buffer), this._addCache(c, r, t, i);
                }
            } else {
                if (this._requesting[c]) {
                    x = !0, h++, this._requesting[c].push(f);
                    continue;
                }
                this._requesting[c] = [], this._requesting[c].push(f);
                const e = e => {
                    e.index = s, e.size = u, e.url = c, e.crossOrigin = "Anonymous";
                };
                if ((_ = b) && r.decodeImageInWorker && _ instanceof ImageBitmap) createImageBitmap(b).then((t => {
                    e(t), p.call(t);
                })).catch((e => {
                    g.call({
                        index: s,
                        url: c
                    }, e);
                })); else {
                    const t = new Image;
                    e(t), t.onload = p, t.onerror = g, t.onabort = g, t.src = m && m(b) || b;
                }
                x = !0, h++;
            }
        }
        var _;
        x || s(null, {
            icons: a,
            buffers: l
        });
    }
    _hasCache(e, t, n) {
        const i = this._cache.get(e);
        return i && "error" !== i && i.data.width >= t && i.data.height >= n;
    }
    _addCache(e, t, n, i) {
        this._hasCache(e, n, i) || (t ? this._cache.add(e, {
            data: {
                data: t,
                width: n,
                height: i
            },
            url: e
        }) : this._cache.add(e, "error"));
    }
    _getCache(e, t) {
        if (!this._hasCache(e, t[0], t[1])) return null;
        const n = this._cache.get(e);
        return n ? "error" === n ? n : {
            data: {
                data: new Uint8ClampedArray(n.data.data),
                width: n.data.width,
                height: n.data.height
            },
            url: n.url
        } : null;
    }
    _ensureMaxSize(e, t) {
        if (!t[0] || !t[1]) return;
        const n = this.options.maxSize || 2048;
        let [i, r] = t;
        const s = i / r;
        if (e) {
            const t = this._cache.get(e);
            if (t && "error" !== t) {
                const {width: e, height: n} = t.data;
                e > i && (i = e), n > r && (r = n);
            }
        }
        i > n && (r = n / s, i = n), r > n && (i = n * s, r = n), t[0] = Math.floor(i), 
        t[1] = Math.floor(r);
    }
}

function ye(e) {
    return 3 === e.length && e.push(1), e.reduce(((e, t, n) => e += n < 3 ? 255 * t + "," : t + ")"), "rgba(");
}

const {GlyphRequestor: xe} = q(), _e = [ "GeoJSONVectorTileLayer" ];

class ve extends e.worker.Actor {
    constructor(e, t) {
        super(e);
        const n = t.getMap().id;
        this._layer = t, this._mapId = n, this._workerLayerId = "vt_" + K();
        const i = t.getJSONType();
        this._isDedicated = _e.indexOf(i) >= 0, this._dedicatedVTWorkers = {}, this._iconRequestor = new me({
            iconErrorUrl: t.options.iconErrorUrl,
            maxSize: t.options.maxIconSize,
            urlModifier: e => {
                const n = t.getURLModifier();
                return n && n(e) || e;
            }
        });
        const r = !t.getRenderer().isEnableWorkAround("win-intel-gpu-crash"), s = t.options.sdfURL;
        this._glyphRequestor = new xe((e => {
            t.getMap().getRenderer().callInNextFrame(e);
        }), t.options.glyphSdfLimitPerFrame, r, s);
    }
    initialize(e) {
        e(null);
    }
    addLayer(e) {
        const t = this._layer, n = t.getWorkerOptions() || {}, i = this._workerLayerId, r = t.getJSONType(), s = {
            mapId: this._mapId,
            layerId: i,
            command: "addLayer",
            params: {
                type: r,
                options: JSON.parse(JSON.stringify(n))
            }
        };
        this._isDedicated ? (void 0 === this._dedicatedVTWorkers[i] && (this._dedicatedVTWorkers[i] = this.getDedicatedWorker()), 
        this.send(s, null, e, this._dedicatedVTWorkers[i])) : this.broadcast(s, null, e);
    }
    abortTile(e, t) {
        const n = this._workerLayerId, i = {
            mapId: this._mapId,
            layerId: n,
            command: "abortTile",
            params: {
                url: e
            }
        };
        this._isDedicated ? (void 0 === this._dedicatedVTWorkers[n] && (this._dedicatedVTWorkers[n] = this.getDedicatedWorker()), 
        this.send(i, null, t, this._dedicatedVTWorkers[n])) : this.broadcast(i, null, t);
    }
    removeLayer(e) {
        const t = this._workerLayerId, n = {
            mapId: this._mapId,
            layerId: t,
            command: "removeLayer"
        };
        this._isDedicated ? (void 0 !== this._dedicatedVTWorkers[t] && this.send(n, null, e, this._dedicatedVTWorkers[t]), 
        delete this._dedicatedVTWorkers[t]) : this.broadcast(n, null, e);
    }
    updateStyle(e, t) {
        const n = this._workerLayerId, i = {
            mapId: this._mapId,
            layerId: n,
            command: "updateStyle",
            params: JSON.parse(JSON.stringify(e))
        };
        this._isDedicated ? void 0 !== this._dedicatedVTWorkers[n] && this.send(i, null, t, this._dedicatedVTWorkers[n]) : this.broadcast(i, null, t);
    }
    updateOptions(e, t) {
        const n = this._workerLayerId, i = {
            mapId: this._mapId,
            layerId: n,
            command: "updateOptions",
            params: JSON.parse(JSON.stringify(e))
        };
        this._isDedicated ? void 0 !== this._dedicatedVTWorkers[n] && this.send(i, null, t, this._dedicatedVTWorkers[n]) : this.broadcast(i, null, t);
    }
    loadTile(e, t) {
        const n = ee({}, e);
        n.tileInfo = function(e) {
            const t = {};
            for (const n in e) void 0 !== e[n] && null !== e[n] && (e[n].toJSON ? t[n] = e[n].toJSON() : t[n] = e[n]);
            return t;
        }(e.tileInfo);
        const i = this._workerLayerId, r = {
            mapId: this._mapId,
            layerId: i,
            command: "loadTile",
            params: n
        }, {x: s, y: o} = e.tileInfo, a = (s + o) % this.workers.length, l = [], h = n.tileArrayBuffer;
        h && h instanceof ArrayBuffer && l.push(h), this.send(r, l, t, void 0 === this._dedicatedVTWorkers[i] ? this.workers[a].id : this._dedicatedVTWorkers[i]);
    }
    remove() {
        super.remove(), this._dedicatedVTWorkers = {};
    }
    fetchIconGlyphs({icons: e, glyphs: t}, n) {
        this._glyphRequestor.getGlyphs(t, ((t, i) => {
            if (t) throw t;
            const r = i.buffers || [];
            this._iconRequestor.getIcons(e, ((e, t) => {
                if (e) throw e;
                t.buffers && t.buffers.length && r.push(...t.buffers), n(null, {
                    icons: t.icons,
                    glyphs: i.glyphs
                }, r);
            }));
        }));
    }
    setData(e, t) {
        const n = this._workerLayerId, i = {
            mapId: this._mapId,
            layerId: n,
            command: "setData",
            params: {
                data: e
            }
        };
        this.send(i, null, t, this._dedicatedVTWorkers[n]);
    }
    clearData(e) {
        const t = this._workerLayerId, n = {
            mapId: this._mapId,
            layerId: t,
            command: "clearData"
        };
        this.send(n, null, e, this._dedicatedVTWorkers[t]);
    }
    _getTileKey(e) {
        return e.id;
    }
}

const be = {}, Ae = {
    collision: !0,
    fading: !1,
    fadingDuration: 224,
    fadeInDelay: 600,
    fadeOutDelay: 100,
    uniquePlacement: !1,
    depthFunc: "always"
};

class Te {
    constructor(e, t, n) {
        this._regl = e, this._map = t, this._color = n || [ 0, 1, 0 ];
    }
    draw(e, t, n, i, r) {
        if (!!this._regl.wgpu) return;
        if (this._command || this._init(), !this._data) {
            this._data = this._regl.buffer(we(i));
            const e = i / n;
            this._textData = this._regl.buffer(Se(i, e));
        }
        if (i !== this._extent) {
            const e = i / n;
            this._data(we(i)), this._textData(Se(i, e));
        }
        this._extent = i;
        let s = this._debugInfoCanvas;
        if (!s) {
            const e = this._map.getDevicePixelRatio() > 1 ? 2 : 1;
            s = this._debugInfoCanvas = document.createElement("canvas"), s.width = 512 * e, 
            s.height = 64 * e;
            const t = s.getContext("2d");
            t.font = "36px monospace", t.scale(e, e), this._texture = this._regl.texture({
                width: s.width,
                height: s.height,
                data: s
            });
        }
        const o = s.getContext("2d");
        o.clearRect(0, 0, s.width, s.height), o.fillStyle = `rgba(${this._color.map((e => 255 * e)).join()})`, 
        o.fillText(e, 20, 36), this._texture({
            width: s.width,
            height: s.height,
            data: s
        }), this._command({
            transform: t,
            data: this._data,
            texData: this._texCoordData,
            debugLine: 1,
            primitive: "lines",
            framebuffer: r || null,
            image: this._texture,
            count: 8
        }), this._command({
            transform: t,
            data: this._textData,
            texData: this._texCoordData,
            debugLine: 0,
            primitive: "triangle strip",
            framebuffer: r || null,
            image: this._texture,
            count: 4
        });
    }
    delete() {
        this._texture && (this._texture.destroy(), delete this._texture), this._texCoordData && (this._texCoordData.destroy(), 
        delete this._texCoordData), this._data && (this._data.destroy(), this._textData.destroy(), 
        delete this._data, delete this._textData), this._command && (this._command.destroy(), 
        delete this._command);
    }
    _init() {
        this._texCoordData = this._regl.buffer(new Uint8Array([ 0, 0, 0, 1, 1, 0, 1, 1, 0, 0, 0, 1, 1, 0, 1, 1 ])), 
        this._command = this._regl({
            vert: "\n                attribute vec2 aPosition;\n                attribute vec2 aTexCoord;\n                uniform mat4 transform;\n\n                varying vec2 vTexCoord;\n                void main()\n                {\n                    gl_Position = transform * vec4(aPosition, 0.0, 1.0);\n                    vTexCoord = aTexCoord;\n                }\n            ",
            frag: "\n                precision mediump float;\n                uniform sampler2D uImage;\n                uniform vec3 uColor;\n                uniform float uOpacity;\n                uniform float uDebugLine;\n\n                varying vec2 vTexCoord;\n\n                void main()\n                {\n                    if (uDebugLine == 1.) {\n                        gl_FragColor = vec4(uColor, 1.0) * uOpacity;\n                    } else {\n                        gl_FragColor = texture2D(uImage, vTexCoord) * uOpacity;\n                    }\n                    gl_FragColor *= gl_FragColor.a;\n                }\n            ",
            attributes: {
                aPosition: this._regl.prop("data"),
                aTexCoord: this._regl.prop("texData")
            },
            uniforms: {
                transform: this._regl.prop("transform"),
                uColor: this._color,
                uOpacity: 1,
                uDebugLine: this._regl.prop("debugLine"),
                uImage: this._regl.prop("image")
            },
            count: this._regl.prop("count"),
            primitive: this._regl.prop("primitive"),
            depth: {
                enable: !1,
                mask: !1
            },
            blend: {
                enable: !0,
                func: {
                    src: "one",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            viewport: {
                x: 0,
                y: 0,
                width: () => this._map.getRenderer().canvas.width,
                height: () => this._map.getRenderer().canvas.height
            },
            framebuffer: this._regl.prop("framebuffer")
        });
    }
}

function we(e) {
    return new Uint16Array([ 0, 0, 0, e, 0, e, e, e, e, e, e, 0, e, 0, 0, 0 ]);
}

function Se(e, t) {
    return new Uint16Array([ 0, e - 64 * t, 0, e, 512 * t, e - 64 * t, 512 * t, e ]);
}

const Me = new Uint16Array([ 0, 0, 0, 1, 1, 0, 1, 0, 0, 1, 1, 1 ]), Pe = [];

class Ie {
    constructor(e, t, n) {
        this._regl = e;
        (this._geometry = new g.Geometry({
            aPosition: Me
        }, null, Me.length / 2, {
            positionSize: 2
        })).generateBuffers(e), this._scene = new g.Scene, this._meshes = [], this._counter = 0, 
        this._canvas = t, this._map = n, this._init(e);
    }
    start() {
        this._counter = 0, this._scene.clear();
    }
    add(e, t, n) {
        const i = this._getMesh(n);
        i.setUniform("ref", e), m.set(Pe, t, t, 1);
        const r = i.localTransform;
        y.fromScaling(r, Pe), y.mul(r, n, r), i.setLocalTransform(r), this._scene.addMesh(i);
    }
    render(e) {
        this._renderer.render(this._shader, {
            projViewMatrix: this._map.projViewMatrix
        }, this._scene, e);
    }
    _getMesh() {
        const e = this._counter++;
        return this._meshes[e] || (this._meshes[e] = new g.Mesh(this._geometry)), this._meshes[e];
    }
    _init(e) {
        const t = this._canvas, n = {
            viewport: {
                x: 0,
                y: 0,
                width: () => t.width,
                height: () => t.height
            },
            stencil: {
                enable: !0,
                func: {
                    cmp: "always",
                    ref: (e, t) => t.ref
                },
                op: {
                    fail: "replace",
                    zfail: "replace",
                    zpass: "replace"
                }
            },
            depth: {
                enable: !0,
                func: "always",
                mask: !1
            },
            colorMask: [ !1, !1, !1, !1 ]
        };
        this._shader = new g.MeshShader({
            name: "tile-stencil",
            vert: "\n#define SHADER_NAME TILE_STENCIL_VERT\nattribute vec2 aPosition;\nuniform mat4 projViewModelMatrix;\n\nvoid main()\n{\n    gl_Position = projViewModelMatrix * vec4(aPosition, 0.0, 1.0);\n}\n",
            frag: "\n#define SHADER_NAME TILE_STENCIL_FRAG\nvoid main()\n{\n    gl_FragColor = vec4(1.0, 0.0, 0.0, 0.1);\n}\n",
            wgslVert: "\n@group(0) @binding(0) var<uniform> projViewModelMatrix : mat4x4f;\n@vertex\nfn main(\n    @location(0) aPosition : vec2u\n    ) -> @builtin(position) vec4f {\n    return projViewModelMatrix * vec4f(vec2f(aPosition), 0.0, 1.0);\n}\n",
            wgslFrag: "\n@fragment\nfn main() -> @location(0) vec4f {\n  return vec4(1.0, 0.0, 0.0, 0.1);\n}\n",
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    const n = [];
                    return y.multiply(n, t.projViewMatrix, t.modelMatrix), n;
                }
            } ],
            extraCommandProps: n
        }), this._renderer = new g.Renderer(e);
    }
    remove() {
        this._geometry.dispose();
        for (let e = 0; e < this._meshes.length; e++) this._meshes[e].dispose();
        this._meshes.length = 0, this._shader.dispose();
    }
}

const Ce = "__fea_idx", ke = -999999, Fe = new Float32Array([ -1e12 ])[0], Oe = "maptalks_ombb", Re = (Ce + "").trim();

function Ee(t, n, i, r, s, o) {
    const a = {};
    if (function(e) {
        if (!e) return !1;
        for (const t in e) if (void 0 !== e[t] && null !== e[t]) return !0;
        return !1;
    }(t)) {
        for (let l = 0, h = (n || t).length; l < h; l++) {
            let h = n ? t[n[l]] : t[l];
            const c = h && re(h);
            if (s.getFeature && !se(h)) {
                const e = c ? h.id : h, t = s.getFeature(e);
                if (t) {
                    let e, n;
                    c && (e = h.properties, n = h.customProps), h = t, h.layer = i, De(h, e, n);
                }
            }
            s instanceof e.TileLayer && (h = Ve(h, o));
            a[n ? n[l] : h[Re]] = {
                feature: h,
                symbol: r
            };
        }
    }
    return a;
}

function De(e, t, n) {
    (t || n) && (e.properties = e.properties || {}, ee(e.properties, t || {}, n || {}));
}

const Le = "__original_properties", He = "__external_properties", ze = {
    get: function(e, t) {
        return t in e ? e[t] : e[Le][t] || e[He] && e[He][t];
    },
    has: function(e, t) {
        return t in e || t in e[Le] || e[He] && t in e[He];
    }
}, Ne = {};

function Ve(e, t) {
    const n = e.properties;
    if (n && n[Le]) return e;
    t && (e = ee({}, e)), e.customProps = e.customProps || {};
    const i = e.customProps;
    return i.$layer = e.layer, i.$type = e.type, i[Le] = n || Ne, e.properties = new Proxy(i, ze), 
    e;
}

function Be(e) {
    for (let t = 1; t < arguments.length; t++) {
        const n = arguments[t];
        for (const t in n) e[t] = n[t];
    }
    return e;
}

function Ue(e, t, n) {
    return Math.min(n, Math.max(t, e));
}

function Ge(e, t, n) {
    if (e === n || e === t) return e;
    const i = n - t;
    return ((e - t) % i + i) % i + t;
}

function je(e) {
    return null == e;
}

function We(e) {
    const t = JSON.parse(JSON.stringify(e));
    if (Array.isArray(e)) for (let n = 0; n < e.length; n++) {
        if (!t[n]) continue;
        const {symbol: i} = t[n];
        if (!i) continue;
        const r = e[n].symbol;
        for (const e in r) i[e] || (i[e] = r[e]);
    } else if (e) {
        if (e.style) {
            const n = We(e.style);
            return t.style = n, t;
        }
        if (e.symbol) {
            const n = We(e.symbol);
            return t.symbol = n, t;
        }
        for (const n in e) t[n] || (t[n] = e[n]);
    }
    return t;
}

function Xe(e, t, n, i, r, s) {
    t in e || Object.defineProperty(e, t, {
        enumerable: !0,
        get: function() {
            const e = je(n[i]) || k(n[i]) ? r : n[i];
            return s ? s(e) : e;
        }
    });
}

const Ye = [];

function qe(e) {
    for (let t = 0; t < e.length; t++) Ye[t] = e[t], Ye[t] *= 255;
    return 3 === e.length && (Ye[3] = 255), Ye;
}

function Ze(e, t = 4) {
    return $e.bind(this, e, t);
}

function $e(e, t, n) {
    if (Array.isArray(n)) return 3 === n.length && 4 === t && n.push(1), n;
    if (e && e[n]) return e[n];
    if (void 0 !== n.r && void 0 !== n.g && void 0 !== n.b && void 0 !== n.a) {
        return [ n.r, n.g, n.b, n.a ];
    }
    const i = I(n).unitArray();
    return 3 === i.length && 4 === t && i.push(1), e && (e[n] = i), i;
}

function Je(e, t, n, i) {
    if (e.fill) e.fill(t, n, i); else for (let r = n; r < i; r++) e[r] = t;
}

function Ke(e) {
    return "number" == typeof e && !isNaN(e);
}

function Qe(e) {
    return e && (e.markerFile || e.markerType) && void 0 !== e.textName;
}

function et(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}

function tt(e, t) {
    if (t) {
        let t = e[e.length - 1];
        const n = [ t ];
        for (let i = e.length - 2; i >= 0; i--) e[i] !== t && (n.push(e[i]), t = e[i]);
        return n;
    }
    {
        let t = e[e[0]];
        const n = [ t ];
        for (let i = 1; i < e.length; i++) e[i] !== t && (n.push(e[i]), t = e[i]);
        return n;
    }
}

const nt = new e.Coordinate(0, 0);

function it(e, t, n, i, r) {
    const s = e.distanceToPointAtRes(t, t, i, n, nt);
    return r ? s.y : s.x;
}

const {TileLayerRendererable: rt, LayerAbstractRenderer: st} = e.renderer, {FilterUtil: ot} = q(), at = [], lt = new e.Point(0, 0), ht = [], ct = {
    color: [ 0, 0, 0, 0 ],
    depth: 1,
    stencil: 0
}, ut = e => e.isTerrainSkin(), ft = e => e.isTerrainVector();

class dt extends(x(rt(st))){
    supportRenderMode() {
        return !0;
    }
    constructor(e) {
        super(e), this._workerCacheIndex = 0, this.ready = !1, this._styleCounter = 1, this._requestingMVT = {}, 
        this._plugins = {}, this._featurePlugins = {}, this.init();
    }
    getTileLevelValue(e, t) {
        if (this.isBackTile(e.id)) {
            const n = e.z, i = 5;
            return n - t >= 0 ? t + i - n : i + (t - n);
        }
        return 0;
    }
    getWorkerConnection() {
        return this._workerConn;
    }
    getStyleCounter() {
        return this._styleCounter;
    }
    clearData() {
        this.clear(), this._workerConn ? (this._workersyncing = !0, this._workerConn.clearData((() => {
            this._workersyncing = !1, this._needRetire = !0, this.setToRedraw(), this.layer.fire("cleardata");
        }))) : this.layer.fire("cleardata");
    }
    clear() {
        this.clearTileCaches(), super.clear();
    }
    setStyle(e, t) {
        this._groundPainter && this._groundPainter.update(), this._workerConn ? (this._workerUpdateTimeout && clearTimeout(this._workerUpdateTimeout), 
        this._workersyncing = !0, this._workerUpdateTimeout = setTimeout((() => {
            if (!this.layer) return;
            this._styleCounter++, this._preservePrevTiles();
            const n = e || this.layer._getComputedStyle();
            n.styleCounter = this._styleCounter, this._workerConn.updateStyle(n, (e => {
                if (this._workersyncing = !1, t && (t(), this._groundPainter && this._groundPainter.update()), 
                e) throw new Error(e);
                this._needRetire = !0, this._initPlugins(), this.setToRedraw(), this.layer.fire("refreshstyle");
            }));
        }), 10)) : (t && (t(), this._groundPainter && this._groundPainter.update()), this._initPlugins());
    }
    _preservePrevTiles() {
        if (this._prevTilesInView) for (const e in this._prevTilesInView) {
            const t = this._prevTilesInView[e];
            t && this.deleteTile(t);
        }
        this._prevTilesInView = this.tilesInView;
        const e = this.tileCache;
        for (const t in this._prevTilesInView) {
            const n = this._prevTilesInView[t];
            n && n.info && e.getAndRemove(n.info.id);
        }
        e.reset(), this.tilesInView = {}, this.tilesLoading = {}, this._requestingMVT = {}, 
        this._parentTiles = [], this._childTiles = [], this._tileZoom = void 0;
    }
    updateOptions(e) {
        this._workerConn && this._workerConn.updateOptions(this.layer.getWorkerOptions(), (t => {
            if (t) throw new Error(t);
            e && (e.features || e.pickingGeometry || e.altitudeProperty) && (this.clear(), this._clearPlugin(), 
            this._initPlugins()), this.setToRedraw();
        }));
    }
    updateSceneConfig(e, t, n) {
        const i = 0 === e ? this._getStylePlugins() : this._getFeaturePlugins();
        if (!i || !i[t]) return;
        this._needRetire = !0;
        const r = this.layer._getComputedStyle(), s = this.layer._getTargetStyle(e, r);
        i[t].config = s[t].renderPlugin, i[t].updateSceneConfig({
            sceneConfig: n
        }), this.setToRedraw();
    }
    updateDataConfig(e, t, n, i) {
        const r = 0 === e ? this._getStylePlugins() : this._getFeaturePlugins();
        r && r[t] && (this._needRetire = !0, r[t].updateDataConfig(n, i) ? this.setStyle() : this.setToRedraw());
    }
    updateSymbol(e, t, n) {
        const i = 0 === e ? this._getStylePlugins() : this._getFeaturePlugins();
        if (!i || !i[t]) return !1;
        const r = this.layer._getComputedStyle(), s = this.layer._getTargetStyle(e, r), o = i[t];
        o.style = s[t];
        const a = o.updateSymbol(n, s[t].symbol);
        return !a && yt(n) && this.setStyle(), this.setToRedraw(), a;
    }
    testIfNeedRedraw() {
        const e = this._getFramePlugins();
        for (let t = 0; t < e.length; t++) if (e[t] && e[t].needToRedraw()) return !0;
        return super.testIfNeedRedraw();
    }
    needRetireFrames() {
        if (this._needRetire) return !0;
        const e = this._getFramePlugins();
        for (let t = 0; t < e.length; t++) if (e[t] && e[t].needToRetireFrames()) return !0;
        return !1;
    }
    getCurrentTiles() {
        return this._vtCurrentTiles;
    }
    isAnimating() {
        const e = this.getMap().getRenderer(), t = e.getFrameTimestamp && e.getFrameTimestamp() || e._frameTimestamp;
        if (this._highlightUpdated && (this._highlightFrametime = t, delete this._highlightUpdated), 
        this._highlightFrametime === t) return !0;
        const n = this._getFramePlugins();
        for (let e = 0; e < n.length; e++) if (n[e] && n[e].isAnimating()) return !0;
        return !1;
    }
    needToRefreshTerrainTileOnZooming() {
        const e = this._getFramePlugins();
        for (let t = 0; t < e.length; t++) if (e[t] && e[t].needToRefreshTerrainTileOnZooming()) return !0;
        return !1;
    }
    initContext() {
        super.initContext();
        const {regl: e, device: t, reglGL: n} = this.context, i = e || t;
        this.regl = e, this.gl = n, this.device = t || e;
        const r = {
            colorFormat: !!this.device.wpu ? "bgra8unorm" : "rgba",
            depthStencil: !0,
            width: this.canvas.width,
            height: this.canvas.height
        };
        this.canvas.pickingFBO = this.canvas.pickingFBO || i.framebuffer(r), this.pickingFBO = this.canvas.pickingFBO, 
        this._debugPainter = new Te(i, this.getMap()), this._prepareWorker(), this._groundPainter = new _(i, this.layer), 
        this.layer.fire("contextcreate", {
            regl: e,
            device: t
        });
    }
    _prepareWorker() {
        this._workerConn || (this._workerConn = new ve("@maptalks/vt", this.layer));
        this._workerConn.addLayer(((e, t) => {
            this.layer && (this.ready = !0, this.layer.onWorkerReady(e, t), this.layer.fire("workerready"), 
            this.setToRedraw());
        }));
    }
    _incrWorkerCacheIndex() {
        this._workerCacheIndex++;
    }
    isDrawable() {
        return !0;
    }
    checkResources() {
        return at;
    }
    _drawTiles(e, t, n, i, r) {
        if (super._drawTiles(e, t, n, i, r), this._prevTilesInView) if (Object.keys(this._prevTilesInView).length) for (const e in this._prevTilesInView) {
            const t = this._prevTilesInView[e];
            t && t.info && t.info.id && !this.tileCache.has(t.info.id) && this._drawTile(t.info, t.image, r);
        } else this._deletePrevPlugins(), delete this._prevTilesInView;
    }
    _deletePrevPlugins() {
        const e = this._styleCounter, t = [], n = [];
        for (const n in this._plugins) if (+n !== e) {
            t.push(n);
            this._getStylePlugins(n).forEach((e => {
                e.remove();
            }));
        }
        for (const t in this._featurePlugins) if (+t !== e) {
            n.push(t);
            this._getFeaturePlugins(t).forEach((e => {
                e.remove();
            }));
        }
        for (let e = 0; e < t.length; e++) delete this._plugins[t[e]];
        for (let e = 0; e < n.length; e++) delete this._featurePlugins[n[e]];
    }
    draw(e, t) {
        this._currentTimestamp !== e && (this._needRetire = !1, this._setPluginIndex());
        const n = this.layer;
        if (this.prepareCanvas(), !this.ready || !n.ready) return;
        const {plugins: i, featurePlugins: r} = this._preparePlugins();
        n.isDefaultRender() || i.length || r.length ? (n.options.collision && n.clearCollisionIndex(), 
        this._frameTime = e, this._zScale = this._getCentiMeterScale(this.getMap().getGLRes()), 
        this._parentContext = t || {}, this._startFrame(e), super.draw(e), this._currentTimestamp !== e && this._prepareRender(e), 
        this._endFrame(e), this._currentTimestamp = e) : this.completeRender();
    }
    _preparePlugins() {
        let e = this._plugins[this._styleCounter];
        e || (this._initPlugins(), this._setPluginIndex(), e = this._getStylePlugins());
        return {
            plugins: e,
            featurePlugins: this._getFeaturePlugins()
        };
    }
    _setPluginIndex() {
        this._getFramePlugins().forEach(((e, t) => {
            e && (e.renderIndex = t);
        }));
    }
    _prepareRender() {
        const e = this._getFramePlugins();
        this._pluginOffsets = this._pluginOffsets || [];
        let t = 0;
        for (let n = e.length - 1; n >= 0; n--) {
            const i = e[n];
            i.isVisible() && i.hasMesh() && (this._pluginOffsets[n] = t, i.needPolygonOffset() && t++);
        }
        this._groundPainter.isEnable() && t++, this._polygonOffsetIndex = t;
    }
    getFrameTimestamp() {
        return this._frameTime;
    }
    drawOnInteracting(e, t, n) {
        this.draw(t, n);
    }
    drawOutline(e) {
        (this._outline || this._outlineAll) && (this._outlineAll ? this.paintOutlineAll(e) : this._outline.forEach((t => {
            this[t[0]](e, ...t[1]);
        })));
    }
    getAnalysisMeshes() {
        return this.getShadowMeshes();
    }
    getShadowMeshes() {
        const e = [];
        return this._getAllPlugins().forEach((t => {
            if (!t) return;
            if (!this._isVisible(t)) return;
            const n = t.getShadowMeshes();
            if (Array.isArray(n)) for (let t = 0; t < n.length; t++) e.push(n[t]);
        })), e;
    }
    isForeground(e) {
        return !(!this._vtCurrentTiles || !this._vtCurrentTiles[e.properties.tile.id]);
    }
    _getTileZoomDiff(t) {
        const n = this.layer, i = this.getMap(), r = e.MapStateCache[i.id];
        let s = n._getTileZoom(r ? r.zoom : i.getZoom());
        const o = n.getMinZoom(), a = n.getMaxZoom();
        s = e.Util.clamp(s, o, a);
        return s - t.properties.tile.z;
    }
    isTileNearCamera(e) {
        return this._getTileZoomDiff(e) <= 1;
    }
    isBackTile(e) {
        return !(!this._vtBgTiles || !this._vtBgTiles[e]);
    }
    loadTileQueue(e) {
        this._workersyncing || super.loadTileQueue(e);
    }
    loadTile(t) {
        const {url: n} = t, i = this._requestingMVT[n];
        if (i) i.keys[t.id] || (i.tiles.push(t), i.keys[t.id] = 1); else {
            const i = this.getMap(), r = lt.set(t.extent2d.xmin, t.extent2d.ymax), s = i.pointAtResToCoord(new e.Point(r), t.res), o = [ it(i, 1, s, t.res) / 100, it(i, 1, s, t.res, 1) / 100 ], a = this.getCentimeterToPoint(t.z), l = this.getTileGLScale(t.z);
            if (this._requestingMVT[n] = {
                keys: {},
                tiles: [ t ]
            }, this._requestingMVT[n].keys[t.id] = 1, this.layer._dataExtent && this.layer._getTileBBox) {
                const i = this.layer._getTileBBox(t), r = this.layer._dataExtent.toBBOX(), s = e.BBOXUtil.bboxIntersect;
                if (i && r && !s(i, r)) return this._onReceiveMVTData(n, null, null), {
                    _empty: !0
                };
            }
            const h = this.layer.options.fetchOptions, c = window && window.location.href, u = this.layer.options.altitudePropertyName, f = this.layer.options.disableAltitudeWarning, d = this.layer.options.loadTileErrorLog, p = this.layer.options.loadTileErrorLogIgnoreCodes, g = this.layer.options.loadTileCachMaxSize, m = this.layer.options.loadTileCacheLog, y = {
                tileInfo: {
                    res: t.res,
                    x: t.x,
                    y: t.y,
                    z: t.z,
                    url: vt(t),
                    id: t.id,
                    extent2d: t.extent2d
                },
                glScale: l,
                disableAltitudeWarning: f,
                loadTileErrorLog: d,
                loadTileErrorLogIgnoreCodes: p,
                loadTileCachMaxSize: g,
                loadTileCacheLog: m,
                altitudePropertyName: u,
                zScale: this._zScale,
                centimeterToPoint: o,
                verticalCentimeterToPoint: a,
                fetchOptions: h,
                styleCounter: this._styleCounter,
                referrer: c,
                workerCacheIndex: this._workerCacheIndex,
                command: "loadTile"
            };
            this.loadTileArrayBuffer && ie(this.loadTileArrayBuffer) ? this.loadTileArrayBuffer(y.tileInfo.url, t, ((e, t) => {
                e ? this._onReceiveMVTData(n, e) : t && t instanceof ArrayBuffer ? (y.tileArrayBuffer = t, 
                this._workerConn.loadTile(y, this._onReceiveMVTData.bind(this, n))) : console.error("loadTileArrayBuffer return data is not ArrayBuffer:", t);
            }), y) : this._workerConn.loadTile(y, this._onReceiveMVTData.bind(this, n));
        }
        return {};
    }
    getTileGLScale(e) {
        const t = this.getMap();
        return this.layer.getSpatialReference().getResolution(e) / t.getGLRes();
    }
    getCentimeterToPoint(e) {
        const t = this.getMap();
        return he(this.layer.getSpatialReference().getResolution(e), t);
    }
    getRenderedFeatures() {
        const e = this.tileCache.keys();
        return this._getFeaturesByKeys(e);
    }
    getCurrentRenderedFeatures() {
        const e = this._vtCurrentTiles && Object.keys(this._vtCurrentTiles);
        return this._getFeaturesByKeys(e);
    }
    _getFeaturesByKeys(e) {
        const t = [];
        for (let n = 0; n < e.length; n++) {
            const i = this.tileCache.get(e[n]);
            if (!i || !i.info || !i.image) continue;
            const {info: r, image: s} = i, o = _t(this.layer, s);
            t.push({
                tile: {
                    id: r.id,
                    x: r.x,
                    y: r.y,
                    z: r.z,
                    url: r.url
                },
                current: !!this.tilesInView[r.id],
                features: o
            });
        }
        return t;
    }
    _onReceiveMVTData(e, t, n) {
        if (this.setToRedraw(), !this._requestingMVT[e]) return;
        if (n && n.canceled) return;
        const i = this.layer, r = i.isDefaultRender(), {tiles: s} = this._requestingMVT[e];
        if (delete this._requestingMVT[e], t) {
            if (t.status && (404 === t.status || 204 === t.status)) for (let e = 0; e < s.length; e++) {
                const t = s[e];
                this.onTileError(be, t);
            }
            return;
        }
        if (!n) {
            for (let e = 0; e < s.length; e++) {
                const t = s[e];
                this.consumeTile({
                    _empty: !0
                }, t);
            }
            return;
        }
        if (n.styleCounter !== this._styleCounter) return;
        let o = !1;
        const a = n.features, l = [];
        for (let e = 0; e < n.data.length; e++) {
            const t = n.data[e];
            if (!t || !t.data || !t.styledFeatures.length) continue;
            const {isUpdated: i, layer: r} = this._parseTileData(0, e, t, a, l);
            l.push(r), i && (o = i);
        }
        for (let e = 0; e < n.featureData.length; e++) {
            const t = n.featureData[e];
            t && t.data && t.styledFeatures.length && this._parseTileData(1, e, t, a);
        }
        o && i._compileStyle();
        const h = s[0].z, c = this.layer.getDataSchema(h);
        if (this._updateSchema(c, n.schema), delete n.features, r && n.data.length !== l.length) {
            const e = n.data;
            n.data = [];
            for (let t = 0; t < e.length; t++) e[t] && e[t].features && n.data.push(e[t]);
        }
        const u = i.options.debugTileData;
        n.layers = l;
        for (let e = 0; e < s.length; e++) {
            const t = s[e];
            if (0 === e && u) {
                const {x: e, y: n, z: r} = t;
                (!0 === u || u.x === e && u.y === n && u.z === r) && console.log("tile", {
                    layerId: i.getId(),
                    x: e,
                    y: n,
                    z: r,
                    layers: mt(Object.values(a))
                });
            }
            const r = 0 === e ? n : pt(n);
            for (let e = 0; e < r.data.length; e++) {
                if (!r.data[e]) continue;
                const n = r.data[e].features;
                for (const e in n) {
                    n[e].tile = t;
                }
            }
            t.extent = r.extent, this._receivedTileExtent || (this._receivedTileExtent = t.extent), 
            r.features = Object.values(a), r.styleCounter = n.styleCounter, this.onTileLoad(r, t);
        }
        this.layer.fire("datareceived", {
            url: e
        });
    }
    _parseTileData(e, t, n, i) {
        const {style: r, isUpdated: s} = this._updatePluginIfNecessary(e, t, n.data), o = this.layer, a = o.isDefaultRender(), l = r.symbol, h = Ee(i, n.styledFeatures, t, l, o, !(!o.getData || !o.getData()));
        delete n.styledFeatures, n.features = h;
        let c = n.data;
        return Array.isArray(c) && (c = c[0]), {
            isUpdated: s,
            layer: a ? {
                layer: c.layer,
                type: c.type
            } : null
        };
    }
    _updateSchema(e, t) {
        for (const n in t) {
            e[n] || (e[n] = {
                types: t[n].types,
                properties: {}
            });
            const i = t[n].properties, r = e[n].properties;
            for (const e in i) (!r[e] || r[e] && "object" !== i[e] && "object" === r[e]) && (r[e] = i[e]);
        }
    }
    _updatePluginIfNecessary(e, t, n) {
        Array.isArray(n) && (n = n[0]);
        const i = this.layer;
        let r, s = !1;
        if (i.isDefaultRender() && 0 === e) {
            let e = this._layerPlugins;
            e || (e = this._layerPlugins = {});
            const t = n.layer, i = n.type;
            e[t] || (e[t] = []);
            const o = ("plugin_" + i).trim();
            e[t][o] ? r = e[t][o] : (r = this._getDefaultRenderPlugin(i), r.filter = n.filter, 
            e[t].push(r), e[t][o] = r, s = !0);
        } else {
            const o = i._getComputedStyle(), a = i._getTargetStyle(e, o), l = this._getStylePlugins();
            if (r = a[t], !r.renderPlugin) {
                s = !0;
                const {plugin: e, symbol: i, renderPlugin: o} = this._getDefaultRenderPlugin(n.type);
                l[t] = e, r.symbol = i, r.renderPlugin = o;
            }
        }
        return {
            style: r,
            isUpdated: s
        };
    }
    _getFramePlugins(e) {
        const t = e && e.style;
        let n = this._getStylePlugins(t) || [];
        this.layer.isDefaultRender() && this._layerPlugins && (n = [], e ? e.layers && e.layers.forEach((e => {
            if (!e) return;
            const t = ("plugin_" + e.type).trim();
            n.push(this._layerPlugins[e.layer][t].plugin);
        })) : Object.keys(this._layerPlugins).forEach((e => {
            for (let t = 0; t < this._layerPlugins[e].length; t++) n.push(this._layerPlugins[e][t].plugin);
        })));
        const i = this._getFeaturePlugins(t);
        return i && i.length && (n = n.slice(), oe(n, i)), n;
    }
    _getAllPlugins() {
        if (this.layer.isDefaultRender() && this._layerPlugins) {
            const e = [];
            return Object.keys(this._layerPlugins).forEach((t => {
                for (let n = 0; n < this._layerPlugins[t].length; n++) e.push(this._layerPlugins[t][n].plugin);
            })), e;
        }
        const e = [];
        for (const t in this._plugins) e.push(...this._plugins[t]);
        for (const t in this._featurePlugins) e.push(...this._featurePlugins[t]);
        return e;
    }
    _getStylePlugins(e) {
        return se(e) && (e = this._styleCounter), this._plugins[e] || at;
    }
    _getFeaturePlugins(e) {
        return se(e) && (e = this._styleCounter), this._featurePlugins[e] || at;
    }
    _createTempRenderContext(e, t) {
        const n = this.regl || this.device, i = this.gl, r = {
            regl: n,
            layer: this.layer,
            gl: i,
            isRenderingTerrain: t,
            timestamp: e
        }, s = this._parentContext;
        return s && ee(r, s), r;
    }
    _startFrame(e, t) {
        const n = this._isRenderingTerrain(), i = this.layer.isDefaultRender() && this._layerPlugins, r = this._getAllPlugins(), s = this._createTempRenderContext(e, n);
        s.sceneConfig = null, s.dataConfig = null, s.pluginIndex = null, s.symbol = null;
        for (let e = 0, n = r.length; e < n; e++) {
            const n = r[e], o = e;
            if (!n || t && !t(n)) continue;
            if (!this._isVisible(o)) continue;
            const a = i ? n.defaultSymbol : n.style && n.style.symbol, l = n.config ? n.config.sceneConfig : null, h = n.config ? n.config.dataConfig : null;
            s.symbol = null, s.sceneConfig = null, s.dataConfig = null, s.pluginIndex = null, 
            s.pluginIndex = o, s.symbol = a, s.sceneConfig = l, s.dataConfig = h, n.startFrame(s);
        }
    }
    _endFrame(e) {
        const t = this._parentContext, n = t.renderMode, i = t && t.renderTarget && t.renderTarget.fbo, r = this.getMap().cameraPosition, s = this._getAllPlugins(), o = this._isRenderingTerrain(), a = !t.timestamp || t.isFinalRender, l = this._createTempRenderContext(e, o);
        if (l.sceneConfig = null, l.pluginIndex = null, this.layer.options.collision && !t.isPostProcess) for (let t = 0, i = s.length; t < i; t++) {
            const i = s[t];
            if (!this._isVisible(i) || !i.hasMesh()) continue;
            if (n && "default" !== n && !i.supportRenderMode(n)) continue;
            if (o && !ft(i)) continue;
            const a = this._getPluginContext(i, 0, r, e, l);
            i.prepareRender(a), i.updateCollision(a);
        } else for (let t = 0, i = s.length; t < i; t++) {
            const i = s[t];
            if (!this._isVisible(i) || !i.hasMesh()) continue;
            if (n && "default" !== n && !i.supportRenderMode(n)) continue;
            if (o && !ft(i)) continue;
            const a = this._getPluginContext(i, 0, r, e, l);
            i.prepareRender(a);
        }
        let h = !1;
        if (this._currentTimestamp !== t.timestamp && !o) {
            const t = this.layer.getPolygonOffset() + this.layer.getPolygonOffsetCount(), n = this._getPluginContext(null, t, r, e);
            n.offsetFactor = t, n.offsetUnits = t, this._groundPainter.paint(n);
        }
        for (let t = 0, a = s.length; t < a; t++) {
            const a = s[t], c = t;
            if (!this._isVisitable(a)) continue;
            if (n && "default" !== n && !a.supportRenderMode(n)) continue;
            if (o && !ft(a)) continue;
            this.device.clear({
                stencil: 255,
                framebuffer: i
            });
            const u = this._pluginOffsets[c] || 0, f = this._getPluginContext(a, u, r, e, l);
            a.painter && a.painter.isEnableTileStencil(f) && this._drawTileStencil(i, a.painter);
            const d = a.endFrame(f);
            d && d.redraw && this.setToRedraw(), h = !0;
        }
        h && this.layer.fire("canvasisdirty"), a && this._drawDebug();
    }
    getPolygonOffsetCount() {
        return this._polygonOffsetIndex || 0;
    }
    _drawDebug() {
        if (this.layer.options.debug) {
            const e = this._parentContext, t = [], n = this.getMap().projViewMatrix;
            for (const i in this.tilesInView) {
                const r = this.tilesInView[i].info, s = this.tilesInView[i].image;
                if (s._empty) continue;
                const o = r.transform, a = s.extent, l = e && e.renderTarget;
                if (o && a) {
                    const e = this.getDebugInfo(r.id), i = y.multiply(t, n, o), s = this.layer.getTileSize().width;
                    this._debugPainter.draw(e, i, s, a, l && l.fbo);
                }
            }
        }
    }
    _isVisitable(e) {
        if (!e) return !0;
        const t = this._parentContext, n = this._isVisible(e), i = t && t.states && t.states.includesChanged, r = this._hasMesh(e.painter.scene.getMeshes());
        return !n || !i && !r ? 0 : r ? 2 : 1;
    }
    _getPluginContext(e, t, n, i, r) {
        const s = this._isRenderingTerrain(), o = s && e && ut(e);
        if (r) return r.isRenderingTerrain = s, r.isRenderingTerrainSkin = o, r.polygonOffsetIndex = t, 
        r.cameraPosition = n, r.timestamp = i, r.sceneConfig = null, r.pluginIndex = null, 
        r.sceneConfig = e && e.config.sceneConfig, r.pluginIndex = e && e.renderIndex, r;
        const a = this.regl || this.device, l = this.gl, h = {
            regl: a,
            layer: this.layer,
            gl: l,
            isRenderingTerrain: s,
            isRenderingTerrainSkin: o,
            sceneConfig: e && e.config.sceneConfig,
            pluginIndex: e && e.renderIndex,
            polygonOffsetIndex: t,
            cameraPosition: n,
            timestamp: i
        }, c = this._parentContext;
        return c && ee(h, c), e && e.isTerrainMask() && h.renderTarget && (h.renderTarget = {
            fbo: c.terrainMaskFBO
        }), h;
    }
    _hasMesh(e) {
        if (!e) return !1;
        const t = this._parentContext && this._parentContext.sceneFilter;
        if (!t) return e.length > 0;
        for (let n = 0, i = e.length; n < i; n++) {
            const i = e[n];
            if (t(i) || i.properties.hlBloomMesh && t(i.properties.hlBloomMesh)) return !0;
        }
        return !1;
    }
    _drawTileStencil(e, t) {
        const n = t.isUniqueStencilRefPerTile(), i = this.getCurrentTileZoom();
        let r = this._stencilRenderer;
        r || (r = this._stencilRenderer = new Ie(this.regl || this.device, this.canvas, this.getMap())), 
        r.start();
        const {tiles: s} = this._stencilTiles;
        let {parentTiles: o, childTiles: a} = this._stencilTiles, l = 1;
        a = a.sort(gt);
        for (let e = 0; e < a.length; e++) {
            const t = n ? l : this.getTileLevelValue(a[e].info, i);
            this._addTileStencil(a[e].info, t), l++;
        }
        o = o.sort(gt);
        for (let e = 0; e < o.length; e++) {
            const t = n ? l : this.getTileLevelValue(o[e].info, i);
            this._addTileStencil(o[e].info, t), l++;
        }
        const h = s.sort(gt);
        for (let e = h.length - 1; e >= 0; e--) {
            const t = n ? l : this.getTileLevelValue(h[e].info, i);
            this._addTileStencil(h[e].info, t), l++;
        }
        r.render(e);
    }
    _addTileStencil(e, t) {
        const n = lt.set(e.extent2d.xmin, e.extent2d.ymax), i = e.extent || this._receivedTileExtent || 8192, r = e.transform = e.transform || this.calculateTileMatrix(n, e.z, i);
        e.stencilRef = t, this._stencilRenderer.add(t, i, r);
    }
    onDrawTileStart(e) {
        super.onDrawTileStart(e);
        const {tiles: t, childTiles: n, parentTiles: i} = e;
        this._vtCurrentTiles = {}, this._vtBgTiles = {};
        for (let e = 0; e < t.length; e++) this._vtCurrentTiles[t[e].info.id] = 1;
        for (let e = 0; e < n.length; e++) this._vtBgTiles[n[e].info.id] = 1;
        for (let e = 0; e < i.length; e++) this._vtBgTiles[i[e].info.id] = 1;
        this._stencilTiles = e;
    }
    isEnableTileStencil() {
        if (this.layer.options.altitude) return !1;
        const e = this._getFramePlugins();
        for (let t = 0; t < e.length; t++) if (e[t] && e[t].painter && !e[t].painter.isOnly2D()) return !1;
        return !0;
    }
    setTerrainHelper(e) {
        this._terrainLayer = e;
    }
    getTerrainHelper() {
        return this._terrainLayer;
    }
    drawTileOnTerrain(...e) {
        dt.prototype.drawTile.call(this, ...e);
    }
    createTerrainTexture(e) {
        const t = this.layer.getTileSize().width, n = 2 * t, i = 2 * t, r = e.texture({
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: n,
            height: i
        });
        this._terrainDepthStencil || (this._terrainDepthStencil = e.texture({
            width: n,
            height: i,
            format: "depth stencil"
        }));
        const s = {
            width: n,
            height: i,
            colors: [ r ],
            colorFormat: "rgba",
            ignoreStatusCheck: !0
        };
        s.depthStencil = this._terrainDepthStencil;
        const o = e.framebuffer(s);
        return o.colorTex = r, o;
    }
    deleteTerrainTexture(e) {
        e.destroy(), e.colorTex && (e.colorTex.destroy(), delete e.colorTex);
    }
    renderTerrainSkin(e, t, n) {
        if (!this.ready) return;
        const {plugins: i, featurePlugins: r} = this._preparePlugins();
        if (!this.layer.isDefaultRender() && !i.length && !r.length) return;
        this.isRenderingTerrainSkin = !0;
        const s = this._currentTimestamp, o = this._parentContext, a = this.layer.getTileSize().width, l = e => ut(e) && this.layer.options.awareOfTerrain;
        for (let t = 0; t < n.length; t++) {
            this._startFrame(s, l);
            const i = n[t], r = i.texture;
            this._parentContext = {
                tile: i.tile,
                terrainMaskFBO: i.terrainMaskFBO,
                renderTarget: {
                    fbo: r
                }
            }, ct.framebuffer = r, e.clear(ct), this._parentContext.maskViewport = xt(i.terrainMaskFBO.width / 2), 
            this._parentContext.viewport = xt(a), this._drawTerrainTile(i.tile), this._endTerrainFrame(i);
        }
        this._parentContext = o, this.isRenderingTerrainSkin = !1;
    }
    _drawTerrainTile(e) {
        const {info: t, image: n} = e;
        this.drawTile(t, n, ut);
    }
    _endTerrainFrame(e) {
        const t = this._getAllPlugins(), n = this.getMap().cameraPosition, i = this._currentTimestamp || 0;
        this.layer.options.collision ? t.forEach((e => {
            if (!this._isVisible(e) || !e.hasMesh()) return;
            if (!ut(e) || !this.layer.options.awareOfTerrain) return;
            const t = this._getPluginContext(e, 0, n, i);
            t.isRenderingTerrainSkin = !0, e.prepareRender(t), e.updateCollision(t);
        })) : t.forEach((e => {
            if (!this._isVisible(e) || !e.hasMesh()) return;
            if (!ut(e) || !this.layer.options.awareOfTerrain) return;
            const t = this._getPluginContext(e, 0, n, i);
            t.isRenderingTerrainSkin = !0, e.prepareRender(t);
        })), t.forEach(((t, n) => {
            if (!this._isVisitable(t) || !ut(t)) return;
            const i = e.texture;
            this.device.clear({
                stencil: 255,
                framebuffer: i
            });
            const r = this._pluginOffsets[n] || 0, s = this._getPluginContext(t, r, [ 0, 0, 0 ], this._currentTimestamp);
            s.isRenderingTerrainSkin = !0, t.endFrame(s);
        }));
    }
    drawTile(e, t, n) {
        if (!t.cache) return;
        const i = this._isRenderingTerrain(), r = t.cache, s = lt.set(e.extent2d.xmin, e.extent2d.ymax), o = e.extent || this._receivedTileExtent || 8192, a = e.transform = e.transform || this.calculateTileMatrix(s, e.z, o), l = e.tileTranslationMatrix = e.tileTranslationMatrix || this.calculateTileTranslationMatrix(s, e.z), h = e.terrainTransform = e.terrainTransform || this.calculateTerrainTileMatrix(s, e.z, o), c = this._parentContext, u = [];
        oe(u, t.data), oe(u, t.featureData);
        const f = this._getFramePlugins(t);
        n || !i || this.isRenderingTerrainSkin || (n = ft);
        const d = this.regl || this.device, p = this.gl, g = {
            regl: d,
            layer: this.layer,
            gl: p,
            sceneConfig: null,
            pluginIndex: null,
            tileCache: null,
            tileData: null,
            tileTransform: null,
            tileVectorTransform: a,
            tileTranslationMatrix: l,
            tileExtent: t.extent,
            timestamp: this._frameTime,
            tileInfo: e,
            tileZoom: this._tileZoom,
            bloom: this._parentContext && this._parentContext.bloom,
            isRenderingTerrain: i,
            isRenderingTerrainSkin: null,
            renderTarget: null
        };
        i && c && c.terrainMaskFBO && c.terrainMaskFBO.clearTerrainMask();
        for (let t = 0, s = f.length; t < s; t++) {
            const s = f[t], o = t;
            if (!s || n && !n(s)) continue;
            if (!u[o]) continue;
            if (!r[o]) continue;
            if (r[o].plugin !== s) {
                r[o] && s.deleteTile({
                    pluginIndex: o,
                    regl: this.regl,
                    layer: this.layer,
                    gl: this.gl,
                    tileCache: r[o],
                    tileInfo: e
                });
                continue;
            }
            if (this.drawingParentTiles && !s.painter.shouldDrawParentTile()) continue;
            const l = i && ut(s);
            g.renderTarget = null, g.sceneConfig = s.config.sceneConfig, g.pluginIndex = o, 
            g.tileCache = r[o], g.tileData = u[o], g.tileTransform = l ? h : a, g.isRenderingTerrainSkin = l, 
            l && c && c.renderTarget && (g.renderTarget = c.renderTarget, s.isTerrainMask() && (g.renderTarget = {
                fbo: c.terrainMaskFBO
            }));
            const d = s.paintTile(g);
            !this._needRetire && (d.retire || d.redraw) && s.supportRenderMode("taa") && (this._needRetire = !0), 
            d.redraw && this.setToRedraw();
        }
        t && t.style === this._styleCounter && this._retirePrevTile(e);
    }
    _createOneTile(e, t) {
        if (!t.loadTime || t._empty) return;
        let n = t.cache;
        n || (n = t.cache = {});
        const i = this._isRenderingTerrain(), r = lt.set(e.extent2d.xmin, e.extent2d.ymax), s = e.transform = e.transform || this.calculateTileMatrix(r, e.z, t.extent), o = e.tileTranslationMatrix = e.tileTranslationMatrix || this.calculateTileTranslationMatrix(r, e.z), a = e.terrainTransform = e.terrainTransform || this.calculateTerrainTileMatrix(r, e.z, e.extent), l = [];
        oe(l, t.data), oe(l, t.featureData);
        this._getFramePlugins(t).forEach(((r, h) => {
            if (!r) return;
            if (!l[h]) return;
            const c = i && ut(r), u = this.regl || this.device, f = this.gl;
            n[h] && n[h].plugin === r || (n[h] && r.deleteTile({
                pluginIndex: h,
                regl: this.regl,
                layer: this.layer,
                gl: this.gl,
                tileCache: n[h],
                tileInfo: e
            }), n[h] = {
                plugin: r
            });
            const d = {
                regl: u,
                layer: this.layer,
                gl: f,
                sceneConfig: r.config.sceneConfig,
                pluginIndex: h,
                tileCache: n[h],
                tileData: l[h],
                tileTransform: c ? a : s,
                tileVectorTransform: s,
                isRenderingTerrain: i,
                isRenderingTerrainSkin: c,
                tileTranslationMatrix: o,
                tileExtent: t.extent,
                timestamp: this._frameTime,
                tileInfo: e,
                tileZoom: this._tileZoom
            }, p = r.createTile(d);
            n[h].geometry && (t.data[h] = "geometry created"), !this._needRetire && p.retire && r.supportRenderMode("taa") && (this._needRetire = !0);
        }));
    }
    checkTileInQueue(e) {
        return e.styleCounter === this._styleCounter;
    }
    pick(e, t, n) {
        const i = [];
        if (!this.layer.isVisible()) return i;
        return this._getFramePlugins().forEach((r => {
            if (!r) return;
            if (!1 === (r.painter && r.painter.sceneConfig).picking) return;
            if (!r.isVisible()) return;
            const s = r.pick(e, t, n.tolerance);
            s && (s.type = r.getType(), i.push(s));
        })), i.forEach((e => {
            const t = e.data || {}, n = t.tile;
            if (n) {
                const e = this.tileCache.get(n.id) || {};
                ue(this.layer.options.features, e.image, [ t ]);
            }
        })), i;
    }
    deleteTile(e) {
        if (e) {
            if (e.image && !e.image._empty) {
                delete e.image.featuresTypeArray, delete e.image.featuresFullJSON;
                const t = e.image && e.image.style, n = this._getStylePlugins(t);
                n && n.forEach(((t, n) => {
                    t && t.deleteTile({
                        pluginIndex: n,
                        regl: this.regl,
                        layer: this.layer,
                        gl: this.gl,
                        tileCache: e.image.cache ? e.image.cache[n] : {},
                        tileInfo: e.info,
                        tileData: e.image
                    });
                })), e.image.cache = {};
            }
            e.info && (delete e.info.completeTerrainQuery, delete e.info.terrainQueryStatus), 
            super.deleteTile(e);
        }
    }
    abortTileLoading(e, t) {
        const n = t ? vt(t) : "";
        t && t.url && (this._workerConn && this._workerConn.abortTile(n), delete this._requestingMVT[t.url]), 
        this.loadTileArrayBuffer && ie(this.loadTileArrayBuffer) ? this.loadTileArrayBuffer(n, t, (() => {}), {
            command: "abortTile"
        }) : super.abortTileLoading(e, t);
    }
    resizeCanvas(e) {
        super.resizeCanvas(e);
        const t = this.canvas;
        t && (!this.pickingFBO || this.pickingFBO.width === t.width && this.pickingFBO.height === t.height || (this.pickingFBO.resize(t.width, t.height), 
        this._getFramePlugins().forEach((e => {
            e && e.resize(t.width, t.height);
        }))));
    }
    onRemove() {
        this._stencilRenderer && this._stencilRenderer.remove(), this._workerConn && (this._workerConn.removeLayer((e => {
            if (e) throw e;
        })), this._workerConn.remove(), delete this._workerConn), this.pickingFBO && (this.canvas.pickingFBO || this.pickingFBO.destroy(), 
        delete this.pickingFBO), this._debugPainter && (this._debugPainter.delete(), delete this._debugPainter), 
        this._terrainDepthStencil && (this._terrainDepthStencil.destroy(), delete this._terrainDepthStencil), 
        this._groundPainter && (this._groundPainter.dispose(), delete this._groundPainter), 
        delete this.gl, delete this.regl, super.onRemove && super.onRemove(), this._clearPlugin();
    }
    _clearPlugin() {
        this._getAllPlugins().forEach((e => {
            e.remove();
        })), this.plugins = {};
    }
    hitDetect(e) {
        if (!this.gl || !this.layer.options.hitDetect) return !1;
        const t = this.gl, n = new Uint8Array(4), i = this.canvas.height;
        return t.readPixels(e.x, i - e.y, 1, 1, t.RGBA, t.UNSIGNED_BYTE, n), n[3] > 0;
    }
    _initPlugins() {
        const {style: e, featureStyle: t} = this.layer._getComputedStyle(), n = e.map(((e, t) => {
            const n = e.renderPlugin;
            if (!n) return null;
            if (!n.type) throw new Error("invalid plugin type for style at " + t);
            const i = this._createRenderPlugin(n);
            return i.styleCounter = this._styleCounter, i.style = e, i;
        })), i = [];
        t.forEach(((e, t) => {
            const n = e.renderPlugin;
            if (!n) return null;
            if (!n.type) throw new Error("invalid plugin type for features at " + t);
            const r = this._createRenderPlugin(n);
            return r.style = e, r.styleCounter = this._styleCounter, i.push(r), r;
        }));
        const r = this._styleCounter;
        if (this._plugins[r] = n, this._featurePlugins[r] = i, this.layer.fire("pluginsinited"), 
        this._highlighted && this._highlighted.size || this.layer._highlighted) {
            this.layer._highlighted && this.layer._resumeHighlights();
            this.getMap().getRenderer().callInNextFrame((() => {
                this._getFramePlugins().forEach((e => {
                    e.highlight(this._highlighted);
                }));
            }));
        }
        return n;
    }
    _createRenderPlugin(e) {
        const t = this.layer.constructor.getPlugins()[e.type];
        if (!t) throw new Error(`Plugin for (${e.type}) is not loaded.`);
        const n = new t;
        return n.config = e, n.config.sceneConfig || (n.config.sceneConfig = {}), n;
    }
    _createGLContext(e, t) {
        const n = [ "webgl", "experimental-webgl" ];
        let i = null;
        for (let r = 0; r < n.length; ++r) {
            try {
                i = e.getContext(n[r], t);
            } catch (e) {}
            if (i) break;
        }
        return i;
    }
    _getCentiMeterScale(e) {
        return he(e, this.getMap());
    }
    debugFBO(e, t) {
        const n = document.getElementById(e), i = t.width, r = t.height;
        n.width = i, n.height = r;
        const s = n.getContext("2d"), o = this.regl.read({
            framebuffer: t
        }), a = r / 2 | 0, l = 4 * i;
        for (let e = 0; e < o.length; e++) o[e] *= 255;
        const h = new Uint8Array(4 * i);
        for (let e = 0; e < a; ++e) {
            const t = e * l, n = (r - e - 1) * l;
            h.set(o.subarray(t, t + l)), o.copyWithin(t, n, n + l), o.set(h, n);
        }
        const c = new ImageData(i, r);
        c.data.set(o), s.putImageData(c, 0, 0);
    }
    _getDefaultRenderPlugin(e) {
        let t;
        switch (e) {
          case "native-line":
            t = {
                type: "native-line",
                dataConfig: {
                    type: "native-line",
                    only2D: !0
                }
            };
            break;

          case "native-point":
            t = {
                type: "native-point",
                dataConfig: {
                    type: "native-point",
                    only2D: !0
                }
            };
            break;

          case "fill":
            t = {
                type: "fill",
                dataConfig: {
                    type: "fill",
                    only2D: !0
                },
                sceneConfig: {
                    antialias: !0
                }
            };
            break;

          default:
            t = null;
        }
        const n = function(e) {
            switch (e) {
              case "native-point":
                return {
                    markerFill: "#f00",
                    markerSize: 6,
                    markerOpacity: .5
                };

              case "native-line":
                return {
                    lineColor: "#bbb",
                    lineOpacity: .5
                };

              case "fill":
                return {
                    polygonFill: "#76a6f0",
                    polygonOpacity: .8
                };
            }
            return null;
        }(e), i = this._createRenderPlugin(t);
        return i.defaultSymbol = n, {
            plugin: i,
            symbol: n,
            renderPlugin: t
        };
    }
    _isVisible() {
        return !0;
    }
    isEnableWorkAround(e) {
        return "win-intel-gpu-crash" === e && (this.layer.options.workarounds["win-intel-gpu-crash"] && function(e) {
            const t = e.getExtension("WEBGL_debug_renderer_info");
            if (t && "undefined" != typeof navigator) {
                const n = e.getParameter(t.UNMASKED_RENDERER_WEBGL), i = "Win32" === navigator.platform || "Win64" === navigator.platform;
                if (n && n.toLowerCase().indexOf("intel") >= 0 && i) return !0;
            }
            return !1;
        }(this.gl));
    }
    getZScale() {
        return this._zScale;
    }
    outline(e, t) {
        t && (Array.isArray(t) || (t = [ t ]), this._outline || (this._outline = []), this._outline.push([ "paintOutline", [ e, t ] ]), 
        this.setToRedraw());
    }
    outlineFeatures(e) {
        e && (Array.isArray(e) || (e = [ e ]), this._outline || (this._outline = []), this._outline.push([ "paintOutline", [ null, e ] ]), 
        this.setToRedraw());
    }
    outlineBatch(e) {
        this._outline || (this._outline = []), this._outline.push([ "paintBatchOutline", [ e ] ]), 
        this.setToRedraw();
    }
    outlineAll() {
        this._outlineAll = !0, this.setToRedraw();
    }
    paintOutlineAll(e) {
        const t = this._getFramePlugins();
        for (let n = 0; n < t.length; n++) t[n].outlineAll(e);
    }
    paintOutline(e, t, n) {
        if (!se(t)) {
            const i = t, r = this._getFramePlugins();
            if (!r[i] || r[i].painter && !r[i].painter.isVisible()) return;
            return void r[i].outline(e, n);
        }
        const i = this._getFramePlugins();
        for (let t = 0; t < n.length; t++) {
            const r = n[t];
            for (let t = 0; t < i.length; t++) i[t].style && i[t].style.id === r && i[t].outline(e, [ r ]);
        }
    }
    paintBatchOutline(e, t) {
        const n = this._getFramePlugins();
        !n[t] || n[t].painter && !n[t].painter.isVisible() || n[t].outlineAll(e);
    }
    cancelOutline() {
        delete this._outline, delete this._outlineAll, this.setToRedraw();
    }
    setZIndex() {
        return this.setToRedraw(), this._needRetire = !0, super.setZIndex.apply(this, arguments);
    }
    consumeTile(e, t) {
        if (e && !e._empty) {
            const [n, i] = this._findTileAltitude(e);
            t.minAltitude = n, t.maxAltitude = i;
        }
        if (this._retirePrevTile(t), super.consumeTile(e, t), "transient" === this.layer.options.features && e.data) {
            for (let t = 0; t < e.data.length; t++) {
                if (!e.data[t]) continue;
                const n = e.data[t].features;
                if (n) for (const e in n) {
                    const t = n[e] && n[e].feature;
                    t && (t.fnTypeProps ? t.customProps[Le] = t.fnTypeProps : n[e] = null);
                }
            }
            this.layer.fire("_transientfeature", {
                tileImage: e
            });
        }
        e && e.features && (e.features = []), this._createOneTile(t, e);
    }
    _findTileAltitude(e) {
        const t = e.data;
        let n = -1 / 0, i = 1 / 0;
        for (let e = 0; e < t.length; e++) {
            if (!t[e]) continue;
            const r = t[e].data;
            if (r) for (let e = 0; e < r.length; e++) {
                const t = r[e];
                if (!t || !t.properties) continue;
                const {maxAltitude: s, minAltitude: o} = t.properties;
                s > n && (n = s), o < i && (i = o);
            }
        }
        return ht[0] = i === 1 / 0 ? 0 : i, ht[1] = n === -1 / 0 ? 0 : n, ht;
    }
    onTileError(e, t) {
        this._retirePrevTile(t), super.onTileError(e, t);
    }
    _retirePrevTile(e) {
        const {id: t} = e;
        if (this._prevTilesInView && this._prevTilesInView[t]) {
            const e = this._prevTilesInView[t];
            this.deleteTile(e), delete this._prevTilesInView[t];
        }
    }
    highlight(e) {
        if (this._highlighted || (this._highlighted = new Map), Array.isArray(e)) for (let t = 0; t < e.length; t++) se(e[t].name) && !se(e[t].id) && (e[t] = ee({}, e[t]), 
        e[t].name = e[t].id), this._highlighted.set(e[t].name, e[t]); else se(e.name) && !se(e.id) && ((e = ee({}, e)).name = e.id), 
        this._highlighted.set(e.name, e);
        this._getFramePlugins().forEach((e => {
            e.highlight(this._highlighted);
        })), this._highlightUpdated = !0;
    }
    cancelHighlight(e) {
        if (!this._highlighted) return;
        if (Array.isArray(e)) for (let t = 0; t < e.length; t++) this._highlighted.delete(e[t]); else this._highlighted.delete(e);
        this._getFramePlugins().forEach((e => {
            e.highlight(this._highlighted);
        })), this._highlightUpdated = !0;
    }
    cancelAllHighlight() {
        if (!this._highlighted) return;
        delete this._highlighted;
        this._getFramePlugins().forEach((e => {
            e.cancelAllHighlight();
        })), this._highlightUpdated = !0;
    }
    _getLayerOpacity() {
        const e = this.layer.options.opacity;
        return se(e) ? 1 : e;
    }
    _isRenderingTerrain() {
        return !!this._terrainLayer && this.layer.options.awareOfTerrain;
    }
}

function pt(e) {
    let t;
    Array.isArray(e.data) ? (t = [], oe(t, e.data)) : (t = {}, ee(t, e.data));
    const n = ee({}, e);
    return n.data = t, n;
}

function gt(e, t) {
    return t.info.z - e.info.z;
}

function mt(e) {
    const t = {};
    for (let n = 0; n < e.length; n++) {
        const i = e[n].layer || "default";
        t[i] || (t[i] = []), t[i].push(e[n]);
    }
    return t;
}

function yt(e) {
    if (Array.isArray(e)) {
        const t = e;
        for (let e = 0; e < t.length; e++) if (yt(t[e])) return !0;
    }
    for (const t in e) if (k(e[t]) || ot.isExpression(e[t])) return !0;
    return !1;
}

function xt(e) {
    return {
        x: 0,
        y: 0,
        width: 2 * e,
        height: 2 * e
    };
}

function _t(t, n) {
    if (!n.cache) return [];
    const i = [];
    for (const r in n.cache) {
        const s = n.cache[r];
        if (s.geometry) for (let r = 0; r < s.geometry.length; r++) {
            const o = s.geometry[r] && s.geometry[r].geometry;
            if (o && o.properties && o.properties.features) {
                const r = o.properties.features.empty;
                delete o.properties.features.empty;
                const s = Object.values(o.properties.features);
                void 0 !== r && (o.properties.features.empty = r), ue(t.options.features, n, s), 
                e.Util.pushIn(i, s);
            }
        }
    }
    return i;
}

function vt(t) {
    return e.Util.getAbsoluteURL(t.url);
}

dt.include({
    calculateTileMatrix: function() {
        const e = new Array(3), t = new Array(3), n = new Array(3);
        return function(i, r, s) {
            const o = this.getTileGLScale(r), a = i, l = this.layer.getTileSize().width, h = y.identity([]);
            return y.scale(h, h, m.set(e, o, o, this._zScale)), y.translate(h, h, m.set(t, a.x, a.y, 0)), 
            y.scale(h, h, m.set(n, l / s, -l / s, 1)), h;
        };
    }(),
    calculateTerrainTileMatrix: function() {
        const e = new Array(3);
        return function(t, n, i) {
            const r = y.identity([]), s = i / 2;
            return y.scale(r, r, m.set(e, 1 / s, -1 / s, 0)), y.translate(r, r, m.set(e, -s, -s, 0)), 
            r;
        };
    }(),
    calculateTileTranslationMatrix: function() {
        const e = new Array(3);
        return function(t, n) {
            const i = this.getTileGLScale(n), r = t, s = y.identity([]);
            return y.translate(s, s, m.set(e, r.x * i, r.y * i, 0)), s;
        };
    }()
});

const {PackUtil: bt} = q(), At = new e.Point(0, 0), Tt = new e.Coordinate(0, 0), wt = [ null, 0 ], St = [];

class Mt extends e.TileLayer {
    static loadFrom(e, t) {
        return fetch(e, t || {}).then((e => e.json())).then((e => Mt.fromJSON(e)));
    }
    constructor(e, t) {
        super(e, t), this.isVectorTileLayer = !0, this._schema = {}, this.VERSION = Mt.VERSION;
        const n = t && t.style;
        this.setStyle(n);
    }
    setURLModifier(e) {
        this._urlModifier = e;
        const t = this.getRenderer();
        return t && t.updateOptions(), this;
    }
    getURLModifier() {
        return this._urlModifier;
    }
    onAdd() {
        const e = this.getMap();
        this._prepareOptions();
        const t = this.getSpatialReference().toJSON().projection, n = e.getSpatialReference().toJSON().projection;
        if ((t && t.toLowerCase()) !== (n && n.toLowerCase())) throw new Error(`VectorTileLayer's projection(${t}) must be the same with map(${n}).`);
    }
    setFeatureState(e, t) {
        if (se(e.id)) throw new Error("missing id in first parameter of setFeatureState.");
        this._featureStates || (this._featureStates = {});
        const n = e.layer || "0";
        let i = this._featureStates[n];
        return this._featureStates[n] || (i = this._featureStates[n] = new Map), i.set(e.id, t), 
        this._markFeatureState(), this;
    }
    removeFeatureState(e, t) {
        if (se(e.id)) throw new Error("missing id in first parameter of removeFeatureState.");
        if (!this._featureStates) return this;
        const n = e.layer || "0", i = this._featureStates[n];
        if (!i) return this;
        if (t) {
            const n = i.get(e.id);
            if (re(t)) for (const e in t) delete n[e]; else delete n[t];
            i.set(e.id, n);
        } else i.delete(e.id);
        return this._markFeatureState(), this;
    }
    getFeatureState(e) {
        if (se(e.id)) throw new Error("missing id in first parameter of getFeatureState.");
        if (!this._featureStates) return null;
        const t = e.layer || "0";
        return this._featureStates[t].get(e.id);
    }
    _markFeatureState() {
        const e = this.getRenderer();
        if (!e) return;
        const t = e.getFrameTimestamp();
        this._featureStamp = t;
    }
    _getFeatureStateStamp() {
        return this._featureStamp;
    }
    _isFeatureStateDirty(e) {
        return this._featureStamp && this._featureStamp !== e;
    }
    _prepareOptions() {
        const e = this.options, t = this.getMap().getProjection(), n = "EPSG:4326" === t.code || "EPSG:4490" === t.code, i = "EPSG:3857" === t.code;
        if (!e.spatialReference) {
            512 === this.getTileSize().width && (i ? e.spatialReference = "preset-vt-3857" : n && (e.spatialReference = "preset-vt-4326"));
        }
        e.tileSystem || e.tms || n && (e.tileSystem = [ 1, -1, -180, 90 ]), super._prepareOptions();
    }
    forceReload() {
        const e = this.getRenderer();
        return e && e._incrWorkerCacheIndex(), super.forceReload();
    }
    onWorkerReady() {}
    onConfig(e) {
        const t = this.getRenderer();
        t && t.updateOptions(e);
    }
    getWorkerOptions() {
        const e = this.getMap().getRenderer().isWebGPU(), t = this.getRenderer(), n = this.options;
        return {
            debug: n.debug,
            debugTile: n.debugTile,
            altitudeProperty: n.altitudeProperty,
            tileSize: this.getTileSize().width,
            style: this.isDefaultRender() ? {
                style: [],
                featureStyle: []
            } : this._getComputedStyle(),
            features: n.debugTileData || n.features,
            schema: n.schema,
            pickingGeometry: n.pickingGeometry,
            projectionCode: this.getSpatialReference().getProjection().code,
            workerGlyph: n.workerGlyph && !this.getURLModifier(),
            featureIdProperty: n.featureIdProperty,
            isWebGPU: e,
            isWebGL1: t.gl && t.gl instanceof WebGLRenderingContext
        };
    }
    setStyle(e) {
        if (e && (te(e) || e.url)) {
            const t = e, n = t.lastIndexOf("/"), i = n < 0 ? "." : t.substring(0, n);
            return this.ready = !1, pe.getJSON(e.url ? e.url : e, e.url ? e : {}, ((e, n) => {
                if (e) throw this.setStyle([]), e;
                let r;
                n.style ? (r = n, r.$root || (r.$root = i)) : r = {
                    $root: i,
                    style: n
                }, this.options.style = t, this._setStyle(r);
            })), this;
        }
        return this.options.style = e, this._setStyle(e), this;
    }
    _tilePointToPoint(e, t, n, i) {
        const r = i / this.getTileSize().width;
        return e.set(n.x + t.x / r, n.y - t.y / r);
    }
    queryTilePointTerrain(e, t, n, i, r) {
        const s = this.getRenderer(), o = s && s.getTerrainHelper();
        if (!s || !o) return wt[0] = null, wt[1] = 0, wt;
        const a = this._tilePointToPoint(At, e, n, i);
        return t && o.queryTileTerrainByPointAtRes ? o.queryTileTerrainByPointAtRes(a, r, t.id, t, St) : (wt[0] = null, 
        wt[1] = 0, wt);
    }
    queryTerrainTiles(e) {
        const t = this.getRenderer(), n = t && t.getTerrainHelper();
        return t && n ? n.getTerrainTiles(this, e) : null;
    }
    _setStyle(e) {
        if (e && e.$root) {
            let t = e.$root;
            t && "/" === t[t.length - 1] && (t = t.substring(0, t.length - 1)), this._replacer = function(e) {
                return "{$root}" === e ? t : null;
            };
        }
        this.ready = !0, e = e || [], Array.isArray(e) ? e = {
            style: e
        } : e.renderPlugin && (e = {
            style: [ e ]
        }), e = function(e) {
            if (!e.plugins) return e;
            const {plugins: t, styles: n} = e;
            let {style: i, featureStyle: r} = n;
            i = i || [], r = r || [];
            const s = new Array(i.length);
            for (let e = 0; e < i.length; e++) s[e] = ee({}, i[e]), s[e].renderPlugin = t[i[e].renderPlugin];
            const o = new Array(r.length);
            for (let e = 0; e < r.length; e++) o[e] = ee({}, r[e]), o[e].renderPlugin = t[r[e].renderPlugin];
            const a = {
                style: s,
                featureStyle: o
            };
            return e.$root && (a.$root = e.$root), a;
        }(e = We(e));
        const t = this.getRenderer();
        if (t) {
            const n = this._parseStyle(e);
            t.setStyle(n, (() => {
                this._loadStyle(e);
            }));
        } else this._loadStyle(e);
    }
    _parseStyle(e) {
        const t = e.background || {};
        return {
            originFeatureStyle: e.featureStyle || [],
            featureStyle: kt(e.featureStyle),
            style: e.style || [],
            background: {
                enable: t.enable || !1,
                color: It(t.color) || [ 0, 0, 0, 0 ],
                opacity: Ct(t.opacity, 1),
                patternFile: t.patternFile,
                depthRange: t.depthRange
            }
        };
    }
    _loadStyle(e) {
        const t = this._parseStyle(e);
        this._originFeatureStyle = t.originFeatureStyle, this._featureStyle = t.featureStyle, 
        this._vtStyle = t.style, this._background = t.background, this.validateStyle(), 
        this._replacer && this._parseStylePath(), this._compileStyle(), this.fire("setstyle", {
            style: this.getStyle(),
            computedStyle: this.getComputedStyle()
        });
    }
    getPolygonOffsetCount() {
        const e = this.getRenderer();
        return e ? e.getPolygonOffsetCount() : 0;
    }
    getPolygonOffset() {
        return this._polygonOffset || 0;
    }
    setPolygonOffset(e, t) {
        return this._polygonOffset = e, this._totalPolygonOffset = t, this;
    }
    getTotalPolygonOffset() {
        return this._totalPolygonOffset;
    }
    _convertTileFeatuers(e) {
        for (let t = 0, n = e.length; t < n; t++) {
            const n = e[t];
            if (!n) continue;
            const i = n.features || [];
            this._convertFeatures(i);
        }
        return e;
    }
    _convertFeatures(e) {
        if (!e || !e.length) return;
        const t = this._getTileConfig();
        let n;
        for (let i = 0, r = e.length; i < r; i++) {
            const {feature: r, tile: s} = e[i], o = r.geometry;
            if (!r || !s || !o) continue;
            const {x: a, y: l, res: h, extent: c} = s;
            undefined === a && undefined === l && undefined === h || (n = t.getTilePointNW(a, l, h));
            const u = r.type, f = this._convertGeometry(u, o, n, c, h);
            r.geometry = f;
        }
    }
    getCurrentRenderedFeatures() {
        const e = this.getRenderer();
        if (!e) return [];
        const t = e.getCurrentRenderedFeatures() || [];
        return this._convertTileFeatuers(t);
    }
    getRenderedFeatures() {
        const e = this.getRenderer();
        if (!e) return [];
        const t = e.getRenderedFeatures() || [];
        return this._convertTileFeatuers(t);
    }
    getRenderedFeaturesAsync(t = {}) {
        return new Promise(((n, i) => {
            const r = this.getRenderer();
            if (r) if (e.MicroTask) {
                const i = r.getRenderedFeatures() || [], s = [];
                i.forEach((e => {
                    const t = e.features || [];
                    t.length && oe(s, t);
                }));
                const o = (t = Object.assign({}, {
                    countPerTime: 1e4
                }, t)).countPerTime, a = Math.ceil(s.length / o);
                let l = 1;
                const h = () => {
                    const e = (l - 1) * o, t = l * o, n = s.slice(e, t);
                    this._convertFeatures(n), l++;
                };
                e.MicroTask.runTaskAsync({
                    count: a,
                    run: h
                }).then((() => {
                    n(i);
                }));
            } else n(this.getRenderedFeatures()); else n([]);
        }));
    }
    outlineAll() {
        const e = this.getRenderer();
        return e ? (e.outlineAll(), this) : this;
    }
    outline(e, t) {
        const n = this.getRenderer();
        return n ? (n.outline(e, t), this) : this;
    }
    outlineBatch(e) {
        const t = this.getRenderer();
        return t ? (t.outlineBatch(e), this) : this;
    }
    outlineFeatures(e) {
        const t = this.getRenderer();
        return t ? (t.outlineFeatures(e), this) : this;
    }
    cancelOutline() {
        const e = this.getRenderer();
        return e ? (e.cancelOutline(), this) : this;
    }
    highlight(e) {
        this._validateHighlight(e);
        const t = this.getRenderer();
        return t ? (t.highlight(e), this) : (this._highlighted || (this._highlighted = []), 
        this._highlighted.push(e), this);
    }
    _validateHighlight(e) {
        if (Array.isArray(e)) for (let t = 0; t < e.length; t++) this._validateHighlight(e[t]); else {
            if (e.filter) {
                if (!this.options.features) throw new Error("options.features must be turned on to support filter in highlight");
                if (!e.name) throw new Error("A name is required for highlight with filter");
            }
            if (se(e.filter) && se(e.id)) throw new Error("id or filter must be provided for highlight");
        }
    }
    _resumeHighlights() {
        if (this._highlighted) {
            for (let e = 0; e < this._highlighted.length; e++) this.highlight(this._highlighted[e]);
            delete this._highlighted;
        }
    }
    cancelHighlight(e) {
        const t = this.getRenderer();
        return t ? (t.cancelHighlight(e), this) : this;
    }
    cancelAllHighlight() {
        const e = this.getRenderer();
        return e ? (e.cancelAllHighlight(), this) : this;
    }
    _parseStylePath() {
        e.Util.convertStylePath(this._vtStyle, this._replacer), e.Util.convertStylePath(this._featureStyle, this._replacer);
    }
    updateSceneConfig(e, t) {
        return te(e) && (e = this._getStyleIndex(e)), this._updateSceneConfig(0, e, t);
    }
    updateFeatureSceneConfig(e, t, n) {
        return this._updateSceneConfig(1, e, n, t);
    }
    _updateSceneConfig(e, t, n, i) {
        const r = this._getTargetStyle(e);
        if (!r) return this;
        let s, o = t;
        if (r[t].renderPlugin.sceneConfig || (r[t].renderPlugin.sceneConfig = {}), ee(r[t].renderPlugin.sceneConfig, n), 
        void 0 !== i) {
            Ft(this._originFeatureStyle, t, i), o = this._originFeatureStyle[t].style[i]._renderIdx;
            const e = r[o].renderPlugin;
            e.sceneConfig || (e.sceneConfig = {}), s = e.sceneConfig;
        } else Ot(r, t), s = r[t].renderPlugin.sceneConfig;
        if (ee(s, n), Array.isArray(this.options.style)) {
            const e = this.options.style[t].renderPlugin;
            e.sceneConfig || (e.sceneConfig = {}), ee(e.sceneConfig, n);
        } else {
            const r = this._getTargetStyle(e, this.options.style);
            let s;
            void 0 !== i ? (Ft(r, t, i), s = r[t].style[i].renderPlugin) : (Ot(r, t), s = r[t].renderPlugin), 
            s.sceneConfig || (s.sceneConfig = {}), ee(s.sceneConfig, n);
        }
        const a = this.getRenderer();
        return a && a.updateSceneConfig(e, o, n), 0 === e ? this.fire("updatesceneconfig", {
            index: t,
            sceneConfig: n
        }) : 1 === e && this.fire("updatefeaturesceneconfig", {
            index: t,
            styleIdx: i,
            sceneConfig: n
        }), this;
    }
    updateDataConfig(e, t) {
        return te(e) && (e = this._getStyleIndex(e)), this._updateDataConfig(0, e, t);
    }
    updateFeatureDataConfig(e, t, n) {
        return this._updateDataConfig(1, e, n, t);
    }
    _updateDataConfig(e, t, n, i) {
        const r = this._getTargetStyle(e);
        if (!r) return this;
        let s, o = t;
        void 0 !== i ? (Ft(this._originFeatureStyle, t, i), o = this._originFeatureStyle[t].style[i]._renderIdx, 
        s = r[o].renderPlugin.dataConfig) : (Ot(r, t), s = r[t].renderPlugin.dataConfig);
        const a = ee({}, s);
        if (ee(s, n), Array.isArray(this.options.style)) ee(this.options.style[t].renderPlugin.dataConfig, n); else {
            const r = this._getTargetStyle(e, this.options.style);
            let s;
            void 0 !== i ? (Ft(r, t, i), s = r[t].style[i].renderPlugin) : (Ot(r, t), s = r[t].renderPlugin), 
            s.dataConfig || (s.dataConfig = {}), ee(s.dataConfig, n);
        }
        const l = this.getRenderer();
        return l && l.updateDataConfig(e, o, n, a), 0 === e ? this.fire("updatedataconfig", {
            index: t,
            dataConfig: n
        }) : 1 === e && this.fire("updatefeaturedataconfig", {
            index: t,
            styleIdx: i,
            dataConfig: n
        }), this;
    }
    updateSymbol(e, t) {
        return te(e) && (e = this._getStyleIndex(e)), this._updateSymbol(0, e, t);
    }
    updateFeatureSymbol(e, t, n) {
        return this._updateSymbol(1, e, n, t);
    }
    _updateSymbol(t, n, i, r) {
        const s = this._getTargetStyle(t);
        if (!s) return this;
        let o = n;
        void 0 !== r && (Ft(this._originFeatureStyle, n, r), o = this._originFeatureStyle[n].style[r]._renderIdx);
        const a = s[o];
        if (!a) throw new Error(`No style defined at ${n}`);
        const l = this, h = this._replacer;
        function c(i, s, o) {
            if (!i) return !1;
            h && (i = JSON.parse(JSON.stringify(i)), e.Util.parseSymbolPath(i, h));
            const a = Object.keys(i);
            let c = !1;
            for (let e = 0; e < a.length; e++) {
                const t = a[e];
                if (Pt(s[t]) || Pt(i[t])) {
                    c = !0;
                    break;
                }
            }
            for (const t in i) le(i, t) && (!e.Util.isObject(i[t]) || Array.isArray(i[t]) || k(i[t]) ? s[t] = i[t] : (s[t] || (s[t] = {}), 
            ee(s[t], i[t])));
            let u = l.options.style;
            if (te(u)) return c;
            Array.isArray(u) || (u = l._getTargetStyle(t, l.options.style));
            const f = JSON.parse(JSON.stringify(s));
            return void 0 !== r ? (Ft(u, n, r), void 0 === o ? u[n].style[r].symbol = f : u[n].style[r].symbol[o] = f) : (Ot(u, n), 
            void 0 === o ? u[n].symbol = f : u[n].symbol[o] = f), c;
        }
        const u = this.getRenderer();
        if (!u) return c(), this._compileStyle(), this;
        let f = !1;
        const d = a.symbol;
        if (Array.isArray(i)) for (let e = 0; e < i.length; e++) {
            const t = c(i[e], d[e], e);
            t && (f = t);
        } else c(i, d);
        return this._compileStyle(), f ? u.setStyle() : (f = u.updateSymbol(t, o, i), f && u.setStyle()), 
        0 === t ? this.fire("updatesymbol", {
            index: n,
            symbol: i
        }) : 1 === t && this.fire("updatefeaturesymbol", {
            index: n,
            featureStyleIndex: r,
            symbol: i
        }), this;
    }
    _getTargetStyle(e, t) {
        if (t) {
            return 0 === e ? t.style : t.featureStyle;
        }
        return 0 === e ? this._vtStyle : this._featureStyle;
    }
    isDefaultRender() {
        return !!this._isDefaultRender && this.options.defaultRendering;
    }
    validateStyle() {
        this._isDefaultRender = !1;
        let e = this._vtStyle;
        this.options.style || (this._isDefaultRender = !0, e = this._vtStyle = []), Array.isArray(e) || (e = this._vtStyle = [ e ]);
        for (let t = 0; t < e.length; t++) {
            let n = e[t].filter;
            if (n && n.value && (n = n.value), n || console.warn(`render plugin at ${t} doesn't define filter, its filter will be set to 'default' by default.`), 
            void 0 !== n && "default" !== n && !0 !== n && !Array.isArray(n) && void 0 === n.condition) throw new Error(`Invalid filter at ${t} : ${JSON.stringify(n)}`);
            e[t].symbol || (e[t].symbol = {});
        }
    }
    getStyle() {
        return this.options.style ? JSON.parse(JSON.stringify(this.options.style)) : null;
    }
    _getStyleIndex(e) {
        const t = this._vtStyle;
        if (!t) return -1;
        for (let n = 0; n < t.length; n++) if (t[n].name === e) return n;
        throw new Error(`No style defined with name: ${e}`);
    }
    getGroundConfig() {
        this._backgroundConfig || (this._backgroundConfig = {
            enable: !0,
            renderPlugin: {
                type: "fill",
                sceneConfig: {}
            },
            symbol: {
                polygonFill: [ 0, 0, 0, 0 ],
                polygonOpacity: 1
            }
        });
        const e = this._getComputedStyle().background || {};
        return this._backgroundConfig.enable = e.enable, this._backgroundConfig.symbol.polygonFill = e.color, 
        this._backgroundConfig.symbol.polygonOpacity = e.opacity, this._backgroundConfig.symbol.polygonPatternFile = e.patternFile, 
        this._backgroundConfig.renderPlugin.sceneConfig.depthRange = e.depthRange, this._backgroundConfig;
    }
    getComputedStyle() {
        return JSON.parse(JSON.stringify(this._getComputedStyle()));
    }
    _getComputedStyle() {
        return {
            background: this._background,
            style: this._vtStyle || [],
            featureStyle: this._featureStyle || []
        };
    }
    identify(t, n = {}) {
        const i = this.getMap(), r = this.getRenderer();
        if (!i || !r) return [];
        const s = i.coordToContainerPoint(new e.Coordinate(t));
        return this.identifyAtPoint(s, n);
    }
    identifyAtPoint(e, t = {}) {
        const n = this.getMap(), i = this.getRenderer();
        if (!n || !i) return [];
        const r = n.getDevicePixelRatio();
        let s = i.pick(e.x * r, e.y * r, t);
        return s = this._convertPickedFeature(s), t && t.filter ? s.filter((e => t.filter(e))) : s;
    }
    _convertPickedFeature(e) {
        if (!this.getRenderer()) return e;
        const t = this._getTileConfig(), n = this.getSpatialReference();
        for (let i = 0; i < e.length; i++) {
            let r = e[i];
            if (!r || !r.data || !r.data.tile) continue;
            const {tile: s} = r.data, {x: o, y: a, z: l, extent: h} = s, c = n.getResolution(l), u = t.getTilePointNW(o, a, c), f = r.data.feature && r.data.feature.geometry;
            if (f) {
                r.data = ee({}, r.data), r.data.feature = ee({}, r.data.feature);
                const e = r.data.feature.type;
                r.data.feature.type = "Feature", r.data.feature.geometry = this._convertGeometry(e, f, u, h, c);
            }
        }
        return e;
    }
    _convertGeometry(e, t, n, i, r) {
        if (!t.isMVTCoordinates) return t;
        if (t.type && t.coordinates) return t;
        let s, o;
        if (ne(e) || (e = t.type), 1 === e) t.length <= 1 ? (s = "Point", o = this._convertGeometryCoords(t, n, i, r) || []) : (s = "MultiPoint", 
        o = this._convertGeometryCoords(t, n, i, r)); else if (2 === e) t.length <= 1 ? (s = "LineString", 
        o = this._convertGeometryCoords(t, n, i, r) || []) : (s = "MultiLineString", o = this._convertGeometryCoords(t, n, i, r)); else if (3 === e) {
            o = [];
            let e = [], a = 0;
            for (let s = 0; s < t.length; s++) {
                bt.calculateSignedArea(t[s]) > 0 && (a++, e && e.length && o.push(e), e = []), e.push(this._convertGeometryCoords(t[s], n, i, r));
            }
            e.length && o.push(e), a <= 1 ? (s = "Polygon", o = o[0]) : s = "MultiPolygon";
        }
        return {
            type: s,
            coordinates: o
        };
    }
    _convertGeometryCoords(e, t, n, i) {
        const r = n / this.getTileSize().width, s = this.getMap(), o = e => {
            const n = [];
            re(e) && (e = [ e ]);
            for (let o = 0, a = e.length; o < a; o++) {
                const a = e[o];
                At.x = t.x + a.x / r, At.y = t.y - a.y / r, s.pointAtResToCoord(At, i, Tt), n.push(Tt.toArray());
            }
            return 1 === e.length ? n[0] : n;
        };
        if (re(e)) return o(e);
        const a = e.length;
        if (1 === a) {
            return o(e[0]);
        }
        {
            let t = [];
            for (let n = 0; n < a; n++) t.push(o(e[n]));
            return t;
        }
    }
    getDataSchema(e) {
        return this._schema || (this._schema = {}), se(e) || this._schema[e] || (this._schema[e] = {}), 
        se(e) ? this._schema : this._schema[e];
    }
    onRemove() {
        super.onRemove();
    }
    clearData() {
        const e = this.getRenderer();
        return e && e.clearData(), super.clear();
    }
    static fromJSON(e) {
        return e && "VectorTileLayer" === e.type ? new Mt(e.id, e.options) : null;
    }
    _compileStyle() {}
    static registerPlugin(e) {
        Mt.plugins || (Mt.plugins = {}), Mt.plugins[e.type] = e;
    }
    static getPlugins() {
        return Mt.plugins || {};
    }
    static compressStyleJSON(e) {
        return Array.isArray(e) && e.length ? function(e) {
            Array.isArray(e) && (e = {
                style: e,
                featureStyle: []
            });
            const t = [], n = [], i = [];
            fe(e.style, t, i), fe(e.featureStyle, n, i);
            const r = {
                plugins: i,
                styles: {
                    style: t,
                    featureStyle: n
                }
            };
            return e.$root && (r.$root = e.$root), r;
        }(e) : e;
    }
}

function Pt(e) {
    return !(!e || !e.properties);
}

function It(e) {
    return e ? (Array.isArray(e) || (e = I(e).unitArray()), 3 === e.length && e.push(1), 
    e) : null;
}

function Ct(e, t) {
    return null == e ? t : e;
}

function kt(e) {
    if (!e || !Array.isArray(e)) return [];
    const t = [];
    for (let n = 0; n < e.length; n++) {
        const i = e[n].style;
        if (i && Array.isArray(i) && i.length) for (let r = 0; r < i.length; r++) {
            const s = ee({}, e[n], i[r]);
            i[r]._renderIdx = t.length, delete s.style, t.push(s);
        } else t.push(ee({}, e[n]));
    }
    return t;
}

function Ft(e, t, n) {
    if (!e[t] || !e[t].style || !e[t].style[n]) throw new Error(`No plugin defined at feature style of ${t} - ${n}`);
}

function Ot(e, t) {
    if (!e[t]) throw new Error(`No plugin defined at style of ${t}`);
}

Mt.prototype._getTileZoom = function(t) {
    return t = Math.floor(t), e.TileLayer.prototype._getTileZoom.call(this, t);
}, Mt.registerJSONType("VectorTileLayer"), Mt.mergeOptions({
    urlTemplate: null,
    renderer: "gl",
    altitudeProperty: "altitude",
    forceRenderOnZooming: !0,
    forceRenderOnMoving: !0,
    forceRenderOnRotating: !0,
    tileSize: [ 512, 512 ],
    features: !0,
    schema: !1,
    cascadeTiles: !0,
    collision: !0,
    collisionBuffserSize: 0,
    picking: !0,
    pickingPoint: !0,
    pickingGeometry: !1,
    glyphSdfLimitPerFrame: 15,
    tileLimitPerFrame: 1,
    loadingLimitOnInteracting: 5,
    loadingLimit: 0,
    antialias: !1,
    iconErrorUrl: null,
    collisionFrameLimit: 1.5,
    defaultRendering: !0,
    textGamma: 1,
    maxIconSize: 254,
    workarounds: {
        "win-intel-gpu-crash": !1
    },
    pyramidMode: 1,
    styleScale: 1,
    enableAltitude: !0,
    fadeAnimation: !1,
    debugTileData: !1,
    fetchOptions: null,
    awareOfTerrain: !0,
    altitudeQueryTimeLimitPerFrame: 3,
    workerGlyph: !0,
    featureIdProperty: null,
    currentTilesFirst: !0,
    tileStackStartDepth: 3,
    tileStackDepth: 2,
    altitudePropertyName: null,
    disableAltitudeWarning: !1,
    loadTileErrorLog: !0,
    loadTileErrorLogIgnoreCodes: [ 404, 204 ],
    loadTileCachMaxSize: 0,
    loadTileCacheLog: !0,
    renderBeforeTerrain: !1
}), Mt.registerRenderer("gl", dt), Mt.registerRenderer("gpu", dt), Mt.registerRenderer("canvas", null);

const Rt = new e.Size(1, 1);

class Et extends e.OverlayLayer {
    static registerPainter(e, t) {
        Et.painters || (Et.painters = {}), Et.painters[e] = t;
    }
    static get3DPainterClass(e) {
        return Et.painters[e];
    }
    setURLModifier(e) {
        return this._urlModifier = e, this;
    }
    getURLModifier() {
        return this._urlModifier;
    }
    getEvents() {
        let e;
        return e = super.getEvents ? super.getEvents() : {}, e.spatialreferencechange = this._onSpatialReferenceChange, 
        e;
    }
    onConfig(e) {
        super.onConfig(e);
        const t = this.getRenderer();
        if (t) {
            if (void 0 !== e.enableMarkerBloom) {
                const n = e.enableMarkerBloom;
                t.updateMarkerBloom(n);
            }
            if (void 0 !== e.enableLineBloom) {
                const n = e.enableLineBloom;
                t.updateLineBloom(n);
            }
            if (void 0 !== e.enablePolygonBloom) {
                const n = e.enablePolygonBloom;
                t.updatePolygonBloom(n);
            }
            if (void 0 !== e.enableBloom) {
                const n = e.enableBloom;
                t.updateBloom(n);
            }
        }
    }
    updateSymbol(e, t) {
        if (!this.options.style) throw new Error("can't call update symbol when style is not set");
        const n = Array.isArray(this.options.style) ? this.options.style : this.options.style.style;
        if (!n[e]) throw new Error(`invalid style at ${e}`);
        return ee(n[e].symbol, t), this.setStyle(this.options.style), this;
    }
    getPolygonOffsetCount() {
        return this.isEmpty() || this.options.altitude ? 0 : 1;
    }
    getPolygonOffset() {
        return this.options.altitude ? 0 : this._polygonOffset || 0;
    }
    setPolygonOffset(e, t) {
        return this._polygonOffset = e, this._totalPolygonOffset = t, this;
    }
    getTotalPolygonOffset() {
        return this._totalPolygonOffset;
    }
    identify(t, n = {}) {
        const i = this.getMap(), r = this.getRenderer();
        if (!i || !r) return [];
        const s = i.coordToContainerPoint(new e.Coordinate(t));
        return this.identifyAtPoint(s, n);
    }
    identifyAtPoint(e, t = {}) {
        const n = this.getMap(), i = this.getRenderer();
        if (!n || !i) return [];
        const r = this.getMap().getDevicePixelRatio(), s = i.pick(e.x * r, e.y * r, t);
        return t && t.filter ? s.filter((e => t.filter(e))) : s;
    }
    getComputedStyle() {
        return {
            style: this.getStyle() || []
        };
    }
    outlineAll() {
        const e = this.getRenderer();
        return e ? (e.outlineAll(), this) : this;
    }
    outline(e) {
        if (!Array.isArray(e) || !e.length) return this;
        const t = this.getRenderer();
        return t ? (t.outline(e), this) : this;
    }
    cancelOutline() {
        const e = this.getRenderer();
        return e ? (e.cancelOutline(), this) : this;
    }
    toJSON() {
        const e = {
            type: this.getJSONType(),
            id: this.getId(),
            options: this.config(),
            geometries: []
        }, t = this.getGeometries();
        for (let n = 0, i = t.length; n < i; n++) {
            const i = t[n].toJSON();
            e.geometries.push(i);
        }
        return e;
    }
    getTileSize() {
        return Rt;
    }
    _onSpatialReferenceChange() {
        const e = this.getRenderer();
        e && e._onSpatialReferenceChange();
    }
}

Et.mergeOptions({
    picking: !0,
    pickingPoint: !0,
    renderer: "gl",
    collision: !1,
    collisionBufferSize: 0,
    textGamma: 1,
    geometryEvents: !0,
    styleScale: 1,
    forceRenderOnZooming: !0,
    forceRenderOnMoving: !0,
    forceRenderOnRotating: !0,
    meshRenderOrder: 0,
    enableBloom: !1,
    enablePolygonBloom: !1,
    enableLineBloom: !1,
    enableMarkerBloom: !1,
    enableAltitude: !0,
    workarounds: {
        "win-intel-gpu-crash": !0
    }
});

const Dt = {
    redraw: !1,
    retire: !1
}, Lt = [];

let Ht = 1;

function zt(e, t) {
    const n = L.extend(e, {
        init: function() {
            this._meshCache = {};
        },
        isVisible() {
            return this.painter && this.painter.isVisible();
        },
        supportRenderMode: function(e) {
            return this.painter.supportRenderMode(e);
        },
        hasMesh() {
            return this.painter && this.painter.hasMesh();
        },
        startFrame: function(e) {
            const n = e.layer, i = e.regl, r = e.sceneConfig, s = e.dataConfig, o = e.symbol;
            let a = this.painter;
            if (!a) {
                const l = e.pluginIndex;
                a = this.painter = new t(i, n, o, r, l, s);
            }
            this._meshCache || (this._meshCache = {});
            const l = r.excludes;
            this._excludes ? l !== this._excludes && (this._excludesFunc = l ? D(l) : null, 
            this._excludes = l) : l && (this._excludes = l), a.startFrame(e), this._frameCache = {};
        },
        updateCollision: function(e) {
            const t = this.painter;
            return t && t.isVisible() ? t.updateCollision(e) : null;
        },
        prepareRender: function(e) {
            const t = this.painter;
            return t && t.isVisible() ? t.prepareRender(e) : null;
        },
        endFrame: function(e) {
            const t = this.painter;
            return t && t.isVisible() ? t.render(e) : null;
        },
        getShadowMeshes() {
            const e = this.painter;
            return e && e.getShadowMeshes && e.getShadowMeshes() || Lt;
        },
        createTile: function(e) {
            const {tileCache: t, tileData: n, tileInfo: i} = e;
            let r = !1;
            const s = this.painter;
            if (!s) return {
                retire: r
            };
            const o = this._getMeshKey(e);
            let a = t.geometry;
            if (!a) {
                const o = n.features, l = n.data;
                if (!l || !l.length) return {
                    retire: r
                };
                const h = l;
                for (let e = 0; e < l.length; e++) h[e].tileInfo = i;
                if (this.painter.colorSymbol && !function(e) {
                    if (!e) return !0;
                    for (const t in e) return !1;
                    return !0;
                }(o)) for (let e = 0; e < l.length; e++) {
                    const t = this._generateColorArray(o, l[e].data.aPickingId, l[e].indices, l[e].data.aPosition, l[e].positionSize);
                    l[e].data.aColor = t;
                }
                a = t.geometry = s.createGeometries(h, o);
                for (let t = 0; t < a.length; t++) a[t] && a[t].geometry && (r = !0, a[t].geometry.properties.features = o, 
                this._fillCommonProps(a[t].geometry, e));
            }
            let l = t.meshes;
            if (!l) {
                const {meshes: n, retire: i} = this._createMeshes(a, e);
                r || (r = i), l = n;
                const h = this._getMesh(o);
                h && s.deleteMesh(h), t.meshes = l, this._meshCache[o] = l;
            }
            return {
                retire: r
            };
        },
        _createMeshes(e, t) {
            const {tileInfo: n, tileExtent: i, tileTransform: r, tileTranslationMatrix: s, tileVectorTransform: o, tileZoom: a, sceneConfig: l} = t;
            let h = !1;
            const c = this.painter, u = [ n.extent2d.xmin, n.extent2d.ymax ], f = c.createMeshes(e, r, {
                tileExtent: i,
                tilePoint: u,
                tileZoom: a,
                tileTranslationMatrix: s,
                tileVectorTransform: o
            }, t);
            if (f.length) {
                for (let e = 0; e < f.length; e++) f[e] && (h = !0, this._fillMeshProps(f[e], r, t.timestamp, Ht++, c.isEnableTileStencil()));
                l.animation && (f._animationTime = t.timestamp);
            }
            return {
                meshes: f,
                retire: h
            };
        },
        paintTile: function(e) {
            const {tileCache: t, tileInfo: n, tileZoom: i, sceneConfig: r} = e, s = this.painter;
            if (!s) return Dt;
            let o = t.geometry;
            if (!o) return Dt;
            let a = !1;
            const l = this._getMeshKey(e);
            let h = this._getMesh(l);
            if (!h) {
                const {meshes: t, retire: n} = this._createMeshes(o, e);
                a || (a = n), h = t;
            }
            if (!h.length) return Dt;
            const c = s.getTileLevelValue(n, i);
            for (let e = 0, t = h.length; e < t; e++) {
                const t = h[e];
                t.properties.tile = n, t.properties.level = c;
            }
            let u = !1;
            if (!this._frameCache[l]) {
                let t = null, n = r.animation;
                if (n) {
                    const i = e.sceneConfig.animationDuration || 800, r = (e.timestamp - h._animationTime) / i, s = h[0].properties.createTime;
                    h._animationTime - s < i && r < 1 && (!0 !== n && 1 !== n || (n = "linear"), t = "linear" === n ? r : E(n, r), 
                    u = !0);
                }
                s.addMesh(h, t, e), this._frameCache[l] = 1;
            }
            return {
                redraw: u,
                retire: a
            };
        },
        _fillMeshProps: function(e, t, n, i, r) {
            if (e.properties.tileTransform = t, e.properties.createTime = n, e.properties.meshKey = i, 
            e.needUpdateShadow = !0, r) {
                const t = e.defines || {};
                t.ENABLE_TILE_STENCIL = 1, e.setDefines(t);
            }
            "stencilRef" in e.uniforms || Object.defineProperty(e.uniforms, "stencilRef", {
                enumerable: !0,
                get: function() {
                    return e.properties.tile && void 0 !== e.properties.tile.stencilRef ? e.properties.tile.stencilRef : e.properties.level;
                }
            });
        },
        _fillCommonProps: function(e, t) {
            const {layer: n, tileInfo: i} = t, r = n.getMap(), s = (n.getSpatialReference ? n.getSpatialReference() : r.getSpatialReference()).getResolution(i.z), o = t.tileExtent / n.getTileSize().width;
            e.properties.tile = i, e.properties.tileResolution = s, e.properties.tileRatio = o, 
            e.properties.z = i.z, e.properties.tileExtent = t.tileExtent;
        },
        updateSceneConfig: function(e) {
            const t = this.painter;
            t && t.updateSceneConfig(e.sceneConfig);
        },
        updateDataConfig: function(e, t) {
            const n = this.painter;
            return !n || n.updateDataConfig(e, t);
        },
        updateSymbol: function(e, t) {
            const n = this.painter;
            if (!n) return !1;
            if (n.shouldDeleteMeshOnUpdateSymbol(e)) {
                if (this._meshCache) for (const e in this._meshCache) n.deleteMesh(this._meshCache[e], !0);
                delete this._meshCache, delete this._frameCache;
            }
            return n.updateSymbol(e, t);
        },
        pick: function(e, t, n) {
            return this.painter && this.painter.pick ? this.painter.pick(e, t, n) : null;
        },
        deleteTile: function(e) {
            if (!this._meshCache) return;
            const t = this._getMeshKey(e), n = this._meshCache[t];
            n && this.painter && this.painter.deleteMesh(n), delete this._meshCache[t], this._frameCache && delete this._frameCache[t];
        },
        remove: function() {
            const e = this.painter;
            if (e && this._meshCache) {
                for (const t in this._meshCache) e.deleteMesh(this._meshCache[t]);
                e.delete(), delete this.painter;
            }
            delete this._meshCache, delete this._frameCache;
        },
        resize: function(e, t) {
            const n = this.painter;
            n && n.resize(e, t);
        },
        needToRedraw: function() {
            return !!this.painter && this.painter.needToRedraw();
        },
        needToRetireFrames: function() {
            return !!this.painter && this.painter.needToRetireFrames();
        },
        isAnimating() {
            return !!this.painter && this.painter.isAnimating();
        },
        needToRefreshTerrainTileOnZooming: function() {
            return !!this.painter && this.painter.needToRefreshTerrainTileOnZooming();
        },
        isTerrainSkin: function() {
            return !!this.painter && this.painter.isTerrainSkin();
        },
        isTerrainVector: function() {
            return !!this.painter && this.painter.isTerrainVector();
        },
        isTerrainMask: function() {
            return !!this.painter && this.painter.isTerrainMask();
        },
        _generateColorArray: function(e, t, n, i, r = 3) {
            if (!i || !e || !t.length) return null;
            const s = new Uint8Array(i.length / r * 4);
            let o, a;
            const l = this.painter.colorSymbol, h = {};
            let c;
            for (let n = 0, i = t.length; n < i; n++) {
                const i = t[n];
                if (o = e[i].symbol, a = h[i], !a) if (l) {
                    let t;
                    t = "function" == typeof l ? l(e[i].feature && e[i].feature.properties) : l, t = I(t), 
                    a = h[i] = t.array();
                } else a = h[i] = [ 255, 255, 255 ];
                c = 4 * n, s[c] = a[0], s[c + 1] = a[1], s[c + 2] = a[2], s[c + 3] = 255 * (o[this.painter.opacitySymbol] || 1);
            }
            return s;
        },
        _getMeshKey: function(e) {
            const t = e.tileInfo;
            return t.meshKey || (t.meshKey = Ht++), t.meshKey;
        },
        _getMesh: function(e) {
            return this._meshCache[e];
        },
        _filterElements(e, t) {
            if (Array.isArray(e)) e.forEach(((e, n) => {
                const {features: i} = e.properties;
                this._filterGeoElements(e, t[n], i);
            })); else {
                const {features: n} = e.properties;
                this._filterGeoElements(e, Array.isArray(t) ? t[0] : t, n);
            }
        },
        _filterGeoElements(e, t, n) {
            const i = t.featureIndexes || t.data.featureIndexes;
            if (i) if (this._excludesFunc) {
                const r = t.indices;
                let s = null, o = !1;
                const a = [];
                for (let e = 0; e < r.length; e++) {
                    const t = n[i[r[e]]];
                    null !== s && s === r[e] || (o = this._excludesFunc(t.feature), s = r[e]), o || a.push(r[e]);
                }
                e.setElements(new t.indices.constructor(a));
            } else e.setElements(t.indices);
        },
        outline(e, t) {
            const n = this.painter;
            n && n.outline(e, t);
        },
        outlineAll(e) {
            const t = this.painter;
            t && t.outlineAll(e);
        },
        needPolygonOffset() {
            const e = this.painter;
            return e && e.needPolygonOffset();
        },
        highlight(e) {
            const t = this.painter, n = this.style.name, i = this.renderIndex;
            if (e) {
                const t = [];
                if (e.forEach(((e, r) => {
                    void 0 !== e.plugin && null !== e.plugin && (Array.isArray(e.plugin) ? e.plugin.length && e.plugin.indexOf(n) < 0 && e.plugin.indexOf(i) < 0 && t.push(r) : e.plugin !== n && e.plugin !== i && t.push(r));
                })), t.length) {
                    const n = new Map(e);
                    for (let e = 0; e < t.length; e++) n.delete(t[e]);
                    e = n;
                }
            }
            return t && t.highlight(e);
        },
        cancelAllHighlight() {
            const e = this.painter;
            return e && e.cancelAllHighlight();
        }
    });
    return n;
}

function Nt(e) {
    return !e || (void 0 !== e.empty || (e.empty = function(e) {
        for (const t in e) return !1;
        return !0;
    }(e)), e.empty);
}

const {StyleUtil: Vt} = q(), Bt = "_fn_type_", Ut = "__current_fn_types";

function Gt(e, t, n, i) {
    if (!Nt(e.properties.features)) for (let r = 0; r < n.length; r++) {
        const {symbolName: s} = n[r];
        (e[Ut] = e[Ut] || {})[s] = t[s], jt(e, t, n[r], i);
    }
}

function jt(e, t, n, i) {
    const r = function(e) {
        const t = e.properties;
        let n = t.aPickingId;
        n || (n = t.aPickingId = new e.data.aPickingId.constructor(e.data.aPickingId));
        return n;
    }(e), {attrName: s, symbolName: o, related: a} = n;
    let l = e.data[s];
    return l ? en(t[o]) || function(e, t) {
        if (!Array.isArray(e)) return !1;
        for (let n = 0; n < e.length; n++) if (en(t[e[n]])) return !0;
        return !1;
    }(a, t) ? (en(t[o]) && Wt(e, t, n), l) : (void 0 === n.index && (e.deleteData(s), 
    Xt(e, s)), null) : en(t[o]) && function(e, t) {
        if (e.startsWith("marker") && !t.properties.iconAtlas) return !1;
        if (e.startsWith("text") && !t.properties.glyphAtlas) return !1;
        return !0;
    }(o, e) ? (l = e.data[s] = new n.type(n.width * r.length), function(e, t, n, i, r) {
        const {attrName: s} = i, o = (Bt + s + "Index").trim();
        Wt(t, n, i);
        const a = t.properties[o];
        Jt(t, a, i, r);
    }(l, e, t, n, i), l) : null;
}

function Wt(e, t, n) {
    const {attrName: i, symbolName: r} = n, s = e.properties, o = (Bt + i + "Index").trim(), a = (Bt + i).trim();
    if (s[o] && s[a]) return;
    const l = function(e) {
        if (!e) return $t;
        const t = [];
        for (let n = 0; n < e.length; n++) k(e[n][1]) && !F(e[n][1]).isZoomConstant && t.push(e[n][0]);
        return t;
    }(t[r].stops), h = "identity" === t[r].type && Vt.checkIfIdentityZoomDependent(r, t[r].property, s.features);
    if (!h && !l.length) return void (void 0 === n.index && Xt(e, i));
    const {features: c, aPickingId: u} = s, f = function(e, t, n, i, r) {
        const s = [];
        let o = 0, a = t[0];
        for (let l = 1, h = t.length; l < h; l++) !e[a] || t[l] === a && l !== h - 1 || ((r || Zt(e[a].feature, n, i)) && s.push(o, l === h - 1 ? h : l), 
        a = t[l], o = l);
        return s;
    }(c, u, t[r].property, l, h);
    if (!f.length) return void (void 0 === n.index && Xt(e, i));
    if (s[o] = f, s[a]) return;
    const d = e.data[i];
    s[a] = d.BYTES_PER_ELEMENT ? new d.constructor(d) : new n.type(d.length);
}

function Xt(e, t) {
    const n = e.properties, i = (Bt + t + "Index").trim(), r = (Bt + t).trim();
    delete n[i], delete n[r];
}

function Yt(e, t, n, i, r, s) {
    if (!r) return;
    const o = r.geometry;
    if (!o) return;
    if (Nt(o.properties.features)) return;
    for (let a = 0; a < i.length; a++) {
        const l = i[a], h = l.attrName;
        if (!(qt(o, n, l) || t._isFeatureStateDirty && t._isFeatureStateDirty(r.geometry._featureTimestamp))) {
            const {aPickingId: e} = o.properties;
            if (!e || o._fnDataZoom === s) continue;
            const n = (Bt + h + "Index").trim(), i = o.properties[n];
            if (!i) continue;
            Jt(o, i, l, t);
            continue;
        }
        const c = jt(o, n, l, t), u = l.define;
        if (c) {
            const n = (Bt + h + "Index").trim();
            if (Jt(o, o.properties[n], l, t), t._getFeatureStateStamp && (o._featureTimestamp = t._getFeatureStateStamp()), 
            u) {
                const e = r.defines;
                e[u] = 1, r.setDefines(e);
            }
            o.generateBuffers(e);
        } else if (u) {
            const e = r.defines;
            e[u] && (delete e[u], r.setDefines(e));
        }
    }
    let a = r.defines;
    r.setDefines(a), o._fnDataZoom = s;
}

function qt(e, t, n) {
    const i = t[n.symbolName], r = e[Ut];
    return !!r && (!C(i, r[n.symbolName]) && (r[n.symbolName] = i, !0));
}

function Zt(e, t, n) {
    for (let i = 0; i < n.length; i++) if ("$" === t[0] && e[t.substring(1)] === n[i] || e.properties[t] === n[i]) return !0;
    return !1;
}

const $t = [];

function Jt(e, t, n, i) {
    const {attrName: r, evaluate: s, index: o, width: a} = n, {aPickingId: l, features: h} = e.properties;
    let c;
    if (t) {
        const n = (Bt + r).trim();
        c = e.properties[n];
        const u = a, f = t.length;
        for (let n = 0; n < f; n += 2) {
            const r = t[n], a = t[n + 1];
            let f = h[l[r]];
            f && f.feature && Qt(c, f, s, r, a, u, o, e, i);
        }
    } else {
        if (c = e.data[r], function(e) {
            return Array.isArray(e) || e.constructor === Float32Array || e.constructor === Float64Array || e.constructor === Uint8Array || e.constructor === Int8Array || e.constructor === Uint16Array || e.constructor === Int16Array || e.constructor === Uint32Array || e.constructor === Int32Array || e.constructor === Uint8ClampedArray;
        }(c)) c.dirty = !0; else {
            const t = (Bt + r).trim();
            c = e.properties[t], c || (c = e.properties[t] = new n.type(n.width * l.length), 
            c.dirty = !0);
        }
        const t = c.length / l.length, a = l.length;
        let u = 0;
        for (let n = 0; n < a; n++) {
            if (l[n] === l[u] && n < a - 1) continue;
            let r = h[l[u]];
            r && r.feature && (Qt(c, r, s, u, n === a - 1 ? a : n, t, o, e, i), u = n);
        }
    }
    c.dirty && (e.updateData(r, c), c.dirty = !1);
}

const Kt = {};

function Qt(e, t, n, i, r, s, o, a, l) {
    const h = (t = t.feature).properties || {};
    if (void 0 === h.$layer && (t.properties || (t.properties = h), h.$layer = t.layer, 
    h.$type = t.type), l.getFeatureState && (Kt.layer = t.layer, Kt.id = t.id, t[He] && (t[He] = null), 
    !je(t.id))) {
        const e = l.getFeatureState(Kt);
        t.properties[He] = e;
    }
    const c = n(h, a, e, i * s);
    if (Array.isArray(c)) {
        let t = !1;
        for (let n = 0; n < s; n++) if (e[i * s + n] !== c[n]) {
            t = !0;
            break;
        }
        if (t) {
            for (let t = i * s; t < r * s; t += s) e.set(c, t);
            e.dirty = !0;
        }
    } else if (s > 1) for (let t = i * s; t < r * s; t += s) e[t + o] !== c && (e[t + o] = c, 
    e.dirty = !0); else e[i] !== c && (Je(e, c, i, r), e.dirty = !0);
}

function en(e) {
    return Vt.isFnTypeSymbol(e);
}

function tn(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

var nn = rn;

function rn(e, t) {
    this.x = e, this.y = t;
}

rn.prototype = {
    clone: function() {
        return new rn(this.x, this.y);
    },
    add: function(e) {
        return this.clone()._add(e);
    },
    sub: function(e) {
        return this.clone()._sub(e);
    },
    multByPoint: function(e) {
        return this.clone()._multByPoint(e);
    },
    divByPoint: function(e) {
        return this.clone()._divByPoint(e);
    },
    mult: function(e) {
        return this.clone()._mult(e);
    },
    div: function(e) {
        return this.clone()._div(e);
    },
    rotate: function(e) {
        return this.clone()._rotate(e);
    },
    rotateAround: function(e, t) {
        return this.clone()._rotateAround(e, t);
    },
    matMult: function(e) {
        return this.clone()._matMult(e);
    },
    unit: function() {
        return this.clone()._unit();
    },
    perp: function() {
        return this.clone()._perp();
    },
    round: function() {
        return this.clone()._round();
    },
    mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },
    equals: function(e) {
        return this.x === e.x && this.y === e.y;
    },
    dist: function(e) {
        return Math.sqrt(this.distSqr(e));
    },
    distSqr: function(e) {
        var t = e.x - this.x, n = e.y - this.y;
        return t * t + n * n;
    },
    angle: function() {
        return Math.atan2(this.y, this.x);
    },
    angleTo: function(e) {
        return Math.atan2(this.y - e.y, this.x - e.x);
    },
    angleWith: function(e) {
        return this.angleWithSep(e.x, e.y);
    },
    angleWithSep: function(e, t) {
        return Math.atan2(this.x * t - this.y * e, this.x * e + this.y * t);
    },
    _matMult: function(e) {
        var t = e[0] * this.x + e[1] * this.y, n = e[2] * this.x + e[3] * this.y;
        return this.x = t, this.y = n, this;
    },
    _add: function(e) {
        return this.x += e.x, this.y += e.y, this;
    },
    _sub: function(e) {
        return this.x -= e.x, this.y -= e.y, this;
    },
    _mult: function(e) {
        return this.x *= e, this.y *= e, this;
    },
    _div: function(e) {
        return this.x /= e, this.y /= e, this;
    },
    _multByPoint: function(e) {
        return this.x *= e.x, this.y *= e.y, this;
    },
    _divByPoint: function(e) {
        return this.x /= e.x, this.y /= e.y, this;
    },
    _unit: function() {
        return this._div(this.mag()), this;
    },
    _perp: function() {
        var e = this.y;
        return this.y = this.x, this.x = -e, this;
    },
    _rotate: function(e) {
        var t = Math.cos(e), n = Math.sin(e), i = t * this.x - n * this.y, r = n * this.x + t * this.y;
        return this.x = i, this.y = r, this;
    },
    _rotateAround: function(e, t) {
        var n = Math.cos(e), i = Math.sin(e), r = t.x + n * (this.x - t.x) - i * (this.y - t.y), s = t.y + i * (this.x - t.x) + n * (this.y - t.y);
        return this.x = r, this.y = s, this;
    },
    _round: function() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
}, rn.convert = function(e) {
    return e instanceof rn ? e : Array.isArray(e) ? new rn(e[0], e[1]) : e;
};

var sn = tn(nn);

const on = [];

function an(e, t, n, i, r) {
    return v.set(on, t[0], t[1], t[2], 1), v.transformMat4(on, on, n), e[2] = on[3], 
    v.scale(on, on, 1 / on[3]), e[0] = (on[0] + 1) * i / 2, e[1] = (1 - on[1]) * r / 2, 
    e;
}

const ln = [], hn = [], cn = [];

const un = [ -99999, -99999 ], fn = new e.Point(0, 0), dn = [];

function pn(e, t, n, i, r, s, o, a) {
    const {res: l, extent: h, extent2d: c} = n.properties.tile, {xmin: u, ymax: f} = c, d = u + i.x * r, p = f - i.y * r;
    let g = null;
    if (a) for (let e = 0; e < a.length; e++) if (gn(a[e], d, p, l)) {
        g = a[e];
        break;
    }
    if (!g) return un;
    const y = fn.set(u, f), x = s.queryTilePointTerrain(i, g, y, h, l), _ = null === x[0] ? Fe : x[0];
    if (_) {
        let n = m.set(dn, i.x, i.y, 0);
        return n[2] += 100 * _, n = an(e, n, o, t.width, t.height), n;
    }
    return e[0] = i.x, e[1] = i.y, e;
}

function gn(e, t, n, i) {
    const r = fn.set(t, n)._multi(i / e.res);
    return e.extent2d.contains(r);
}

const {SYMBOLS_NEED_REBUILD_IN_VT: mn, StyleUtil: yn, FuncTypeUtil: xn} = q(), {loginIBLResOnCanvas: _n, logoutIBLResOnCanvas: vn, getIBLResOnCanvas: bn} = g.pbr.PBRUtils, An = "__gl_textures", Tn = [], wn = new e.Point(0, 0), Sn = new e.Point(0, 0), Mn = new Float32Array(1), Pn = [], In = e => 0 === e.properties.level, Cn = e => e.properties.level > 0;

class kn {
    static getBloomSymbol() {
        return [ "bloom" ];
    }
    constructor(e, t, n, i, r, s) {
        this._is2D = !0, this.regl = e, this.layer = t, this.canvas = (e._gl || e.context).canvas, 
        this.sceneConfig = i || {}, this.dataConfig = s || {}, this.pluginIndex = r, this.scene = new g.Scene, 
        this.pickingFBO = t.getRenderer().pickingFBO, this.level0Filter = In, this.levelNFilter = Cn, 
        this.loginTextureCache(), this.symbolDef = Array.isArray(n) ? n.map((e => We(e))) : [ We(n) ], 
        this._compileSymbols(), this.pickingViewport = {
            x: 0,
            y: 0,
            width: () => this.canvas ? this.canvas.width : 1,
            height: () => this.canvas ? this.canvas.height : 1
        }, this.sortByCommandKey = Fn.bind(this), this.colorCache = {}, this._invisibleWhenCreated = this.symbolDef.map((e => !(!e || !1 !== e.visible)));
    }
    isWebGPU() {
        return !this.regl._gl;
    }
    hasMesh() {
        const e = this.scene && this.scene.getMeshes();
        return this.isVisible() && e && !!e.length;
    }
    getMap() {
        return this.layer ? this.layer.getMap() : null;
    }
    getTileLevelValue(e, t) {
        const n = this.layer.getRenderer();
        return n.getTileLevelValue && n.getTileLevelValue(e, t) || 0;
    }
    getAnalysisMeshes() {
        return this.getShadowMeshes ? this.getShadowMeshes() : Pn;
    }
    isVisible() {
        const {minZoom: t, maxZoom: n} = this.sceneConfig || {};
        if (Ke(t) || Ke(n)) {
            const i = this.getMap(), r = e.MapStateCache[i.id], s = r ? r.zoom : i.getZoom();
            if (!je(t) && s < t) return !1;
            if (!je(n) && s > n) return !1;
        }
        const i = this._visibleFn;
        if (i.length) for (let e = 0; e < i.length; e++) if (i[e] && !i[e].isFeatureConstant) return !0;
        const r = this.getSymbols();
        for (let e = 0; e < r.length; e++) {
            const t = r[e].visible;
            if (!1 !== t && 0 !== t) return !0;
        }
        return !1;
    }
    isMeshVisible(t) {
        const n = t && t.properties && t.properties.symbolIndex;
        if (!n) return !1;
        const i = this._visibleFn, r = n.index;
        let s;
        if (i[r]) {
            if (!i[r].isFeatureConstant) return !0;
            {
                const t = this.getMap(), n = e.MapStateCache[t.id], o = n ? n.zoom : t.getZoom();
                s = i[r](o);
            }
        } else s = this.getSymbol(n).visible;
        return !1 !== s && 0 !== s;
    }
    isAnimating() {
        return !1;
    }
    needToRedraw() {
        return this.isAnimating() || this._redraw;
    }
    needToRetireFrames() {
        return this._needRetire;
    }
    needToRefreshTerrainTileOnZooming() {
        return !0;
    }
    isTerrainSkin() {
        return this.layer.options.awareOfTerrain;
    }
    isTerrainMask() {
        return !1;
    }
    isTerrainVector() {
        return !1;
    }
    isShadowIncludeChanged(e) {
        const t = e && e.isRenderingTerrain && this.isTerrainSkin();
        return e && e.states && e.states.includesChanged.shadow || t && this._includeKeys;
    }
    fillIncludes(e, t, n) {
        if (delete this._includeKeys, n && n.isRenderingTerrain && this.isTerrainSkin()) return;
        const i = n && n.includes;
        if (i) {
            let r = "";
            for (const s in i) i[s] && (r += s, n[s].uniformDeclares && t.push(...n[s].uniformDeclares), 
            n[s].defines && Be(e, n[s].defines));
            this._includeKeys = r;
        }
    }
    setIncludeUniformValues(e, t) {
        if (t && t.isRenderingTerrain && this.isTerrainSkin()) return;
        const n = t && t.includes;
        if (n) for (const i in n) n[i] && t[i].renderUniforms && Be(e, t[i].renderUniforms);
    }
    createGeometries(e, t) {
        if (!e.length) return Pn;
        const n = [];
        for (let i = 0; i < e.length; i++) if (e[i]) if (void 0 !== e[i].ref) n[e[i].ref] ? n.push({
            geometry: n[e[i].ref].geometry,
            symbolIndex: e[i].symbolIndex,
            ref: e[i].ref
        }) : n.push(null); else {
            e[i] && !e[i].is2D && (this._is2D = !1);
            const r = this.createGeometry(e[i], t, i);
            if (r && r.geometry) {
                const s = r.geometry.properties, {feaIdToPickingIdMap: o, pickingIdToFeaIdMap: a, hasFeaIds: l} = this._getIdMap(e[i]);
                l && (s.feaIdPickingMap = o, s.feaPickingIdMap = a), s.symbolIndex = r.symbolIndex, 
                s.features = t, s.is2D = e[i].is2D, s.layer = this.layer, s.positionBounding = e[i].positionBounding, 
                this.postCreateGeometry(r, n);
            }
            n.push(r);
        }
        return n;
    }
    isOnly2D() {
        return this._is2D;
    }
    postCreateGeometry() {}
    _getIdMap(e) {
        if (!e) return {};
        if (Array.isArray(e) && !(e = e[0])) return {};
        const t = e.featureIds, n = {}, i = {}, r = t && t.length;
        if (r) for (let r = 0; r < t.length; r++) {
            const s = e.data.aPickingId[r];
            void 0 === n[s] && (n[s] = t[r], i[t[r]] || (i[t[r]] = []), i[t[r]].push(e.data.aPickingId[r]));
        }
        return {
            hasFeaIds: r,
            pickingIdToFeaIdMap: n,
            feaIdToPickingIdMap: i
        };
    }
    createGeometry() {
        throw new Error("not implemented");
    }
    createMeshes(e, t, n, i) {
        const r = this.layer.options.awareOfTerrain, s = [];
        for (let o = 0; o < e.length; o++) {
            if (!e[o]) continue;
            if (r && i && i.isRenderingTerrain && this.isTerrainVector()) {
                const t = e[o], n = t && t.geometry;
                this._updateTerrainAltitude(n, n.data, n.properties, n.positionSize || n.desc.positionSize, i);
            }
            let a = this.createMesh(e[o], t, n, i || {});
            Array.isArray(a) ? (a = a.filter((e => !!e)), s.push(...a)) : a && s.push(a);
        }
        for (let e = 0; e < s.length; e++) {
            const t = s[e], n = t.defines || {};
            n.POSITION_TYPE_3 || (this.appendWGSLPositionType(t, n), t.setDefines(n));
        }
        return s;
    }
    createMesh() {
        throw new Error("not implemented");
    }
    getAltitudeOffsetMatrix() {
        const e = 100 * (this.dataConfig.altitudeOffset || 0), t = y.identity([]);
        return m.set(Tn, 0, 0, e), y.translate(t, t, Tn), t;
    }
    isBloom(e) {
        return !!this.getSymbol(e.properties.symbolIndex).bloom;
    }
    addMesh(e, t, n) {
        const i = n.isRenderingTerrain && this.isTerrainVector(), r = this.getRenderFBO(n);
        e = e.filter((e => this.isMeshVisible(e))), i && (e = e.filter((e => e.geometry && e.geometry.data.aTerrainAltitude || e instanceof g.InstancedMesh && e.instancedData.aTerrainAltitude)));
        const s = void 0 === this.sceneConfig.castShadow || !!this.sceneConfig.castShadow, o = !(!n || !n.bloom);
        for (let t = 0, a = e.length; t < a; t++) {
            const a = e[t], l = this.isBloom(a) && o;
            a.bloom = l, a.castShadow = s;
            let h = !1;
            const c = a.defines || {};
            if (!!c.HAS_BLOOM !== l && (h = !0, l ? c.HAS_BLOOM = 1 : delete c.HAS_BLOOM), i) {
                if (a.geometry.data.aTerrainAltitude) {
                    const e = a.geometry;
                    this._updateTerrainAltitude(e, e.data, e.properties, e.desc.positionSize, n);
                }
                a.geometry.data.aTerrainAltitude && !c.HAS_TERRAIN_ALTITUDE && (c.HAS_TERRAIN_ALTITUDE = 1, 
                h = !0);
            } else c.HAS_TERRAIN_ALTITUDE && (delete c.HAS_TERRAIN_ALTITUDE, h = !0);
            h && a.setDefines(c), r ? a.setUniform("targetFramebuffer", r) : a.uniforms.targetFramebuffer && (a.uniforms.targetFramebuffer = null), 
            this._highlightMesh(a);
        }
        this.scene.addMesh(e);
    }
    updateCollision() {}
    render(e) {
        return this.pluginIndex = e.pluginIndex, this.polygonOffsetIndex = e.polygonOffsetIndex, 
        this.paint(e), {
            redraw: this._redraw,
            drawCount: this._drawCount
        };
    }
    prepareRender(t) {
        if (this._currentTimestamp === t.timestamp) return;
        if (!this.createFnTypeConfig) return;
        const n = this.scene.getMeshes();
        if (!n || !n.length) return;
        const i = t && t.sceneFilter, r = this.getMap(), s = e.MapStateCache[r.id], o = s ? s.zoom : r.getZoom();
        for (let e = 0; e < n.length; e++) {
            if (!n[e] || !n[e].geometry) continue;
            if (i && !i(n[e])) continue;
            const {symbolIndex: r} = n[e].properties, s = this.getSymbolDef(r);
            if (!s) continue;
            this._currentTimestamp = t.timestamp;
            const a = this.getFnTypeConfig(r);
            Yt(this.regl, this.layer, s, a, n[e], o), this.limitMeshDefines(n[e]);
        }
    }
    limitMeshDefines(e) {
        return e;
    }
    paint(e) {
        const t = this.layer.getMap();
        if (!t) return {
            redraw: !1
        };
        this._renderContext = e;
        const n = this.getUniformValues(t, e);
        return this.callShader(n, e), {
            redraw: this._redraw
        };
    }
    setToRedraw(e) {
        e && (this._needRetire = e), this._redraw = !0;
    }
    callShader(e, t) {
        this.callCurrentTileShader(e, t), this.callBackgroundTileShader(e, t);
    }
    callCurrentTileShader(e, t) {
        this.shader && (this.shader.filter = t && t.sceneFilter ? [ this.level0Filter, t.sceneFilter ] : this.level0Filter), 
        this.callRenderer(this.shader, e, t);
    }
    callBackgroundTileShader(e, t) {
        this.shader && (this.shader.filter = t && t.sceneFilter ? [ this.levelNFilter, t.sceneFilter ] : this.levelNFilter), 
        this.scene.getMeshes().sort(On), this.callRenderer(this.shader, e, t);
    }
    callRenderer(e, t, n) {
        const i = this.scene.getMeshes(), r = [];
        for (let e = 0, t = i.length; e < t; e++) {
            const t = i[e];
            t.properties.hlBloomMesh && n && n.bloom && r.push(t.properties.hlBloomMesh), r.push(t);
        }
        this._setLayerUniforms(t), this.scene.setMeshes(r), t.painterContext = n, this._drawCount += this.renderer.render(e, t, this.scene, this.getRenderFBO(n)), 
        this.scene.setMeshes(i);
    }
    _setLayerUniforms(e) {
        const t = this.layer.options.altitude || 0, n = this.layer.getRenderer();
        e.layerOpacity = n._getLayerOpacity(), e.minAltitude = t;
    }
    getRenderFBO(e) {
        return e && e.renderTarget && e.renderTarget.fbo;
    }
    needPolygonOffset() {
        return !1;
    }
    needRebuildOnGometryPropertiesChanged() {
        return !0;
    }
    onFeatureChange() {}
    getPolygonOffset() {
        const e = this.layer;
        return {
            factor: () => e.getPolygonOffset() + (this.polygonOffsetIndex || 0),
            units: () => e.getPolygonOffset() + (this.polygonOffsetIndex || 0)
        };
    }
    getBlendFunc() {
        return {
            src: () => this.sceneConfig.blendSrc || "one",
            dst: () => this.sceneConfig.blendDst || "one minus src alpha"
        };
    }
    pick(e, t, n = 3) {
        if (!this.layer.options.picking || !1 === this.sceneConfig.picking) return null;
        if (!this.pickingFBO || !this.picking) return null;
        const i = this.getMap(), r = this.getUniformValues(i);
        this._setLayerUniforms(r);
        for (let s = 0; s < this.picking.length; s++) {
            const o = this.picking[s];
            o.render(this.scene.getMeshes(), r, !0);
            let a = {};
            o.getRenderedMeshes().length && (a = o.pick(e, t, n, r, {
                viewMatrix: i.viewMatrix,
                projMatrix: i.projMatrix,
                returnPoint: this.layer.options.pickingPoint && !1 !== this.sceneConfig.pickingPoint,
                logDepthBufFC: 2 / (Math.log(i.cameraFar + 1) / Math.LN2)
            }));
            const {meshId: l, pickingId: h, point: c} = a, u = (0 === l || l) && o.getMeshAt(l);
            if (!u || !u.geometry) continue;
            let f = u.geometry.properties;
            f.features || (f = u.properties), c && c.length && (c[0] = Math.round(1e5 * c[0]) / 1e5, 
            c[1] = Math.round(1e5 * c[1]) / 1e5, c[2] = Math.round(1e5 * c[2]) / 1e5);
            const d = {
                data: this._convertProxyFeature(f && f.features && f.features[h]),
                point: c,
                coordinate: a.coordinate,
                plugin: this.pluginIndex
            };
            return je(u.properties.nodeIndex) || (d.data || (d.data = {}), d.data.nodeIndex = u.properties.nodeIndex), 
            d;
        }
        return null;
    }
    _convertProxyFeature(e) {
        const t = e && e.feature;
        if (!t || !t.customProps) return e;
        const n = Be({}, e);
        return n.feature = Be({}, e.feature), delete n.feature.customProps, n.feature.properties = Be({}, t.properties, t.properties[Le], t.properties[He]), 
        delete n.feature.properties[He], delete n.feature.properties[Le], delete n.feature.properties.$layer, 
        delete n.feature.properties.$type, n;
    }
    updateSceneConfig() {}
    updateDataConfig(e) {
        return Be(this.dataConfig, e), !0;
    }
    deleteMesh(e, t) {
        if (e) if (this.scene.removeMesh(e), Array.isArray(e)) for (let n = 0; n < e.length; n++) {
            if (!e[n].isValid()) continue;
            const i = e[n].geometry;
            !t && i && i.dispose(), e[n].material && e[n].material.dispose(), e[n].dispose(), 
            b.deleteHighlightBloomMesh(e[n]);
        } else {
            if (!e.isValid()) return;
            !t && e.geometry && e.geometry.dispose(), e.material && e.material.dispose(), e.dispose(), 
            b.deleteHighlightBloomMesh(e);
        }
    }
    startFrame(e) {
        this._inited || (this.init(e), this._inited = !0), this._currentTimestamp !== e.timestamp && (this._redraw = !1, 
        this._needRetire = !1, this._drawCount = 0), this.scene.clear();
    }
    resize() {}
    delete() {
        if (this.scene.clear(), this.shader && this.shader.dispose(), this.picking) {
            for (let e = 0; e < this.picking.length; e++) this.picking[e].dispose();
            delete this.picking;
        }
        if (this._outlineShaders) {
            for (let e = 0; e < this._outlineShaders.length; e++) this._outlineShaders[e].dispose();
            delete this._outlineShaders;
        }
        delete this._terrainAltitudeCache, this.logoutTextureCache();
    }
    updateSymbol(e, t) {
        Array.isArray(e) || (e = [ e ], t = [ t ]);
        let n = !1;
        for (let i = 0; i < e.length; i++) if (e[i]) {
            const r = this._updateChildSymbol(i, e[i], t[i]);
            r && (n = r);
        }
        return delete this._fnTypeConfigs, this.setToRedraw(!1), n;
    }
    _isNeedRefreshStyle(e, t) {
        for (const n in t) if (et(t, n)) {
            if (yn.isFnTypeSymbol(t[n]) && !this.layer.options.features && (!e[n] || e[n].property !== t[n].property)) return !0;
            if (mn[n] && !C(t[n], e[n])) return !0;
        }
        return !1;
    }
    _updateChildSymbol(t, n, i) {
        if (!this._symbol) return !1;
        const r = this._isNeedRefreshStyle(this.symbolDef[t] || {}, i);
        if (this._invisibleWhenCreated[t] && !1 !== i.visible) return this._invisibleWhenCreated[t] = !1, 
        !0;
        this.symbolDef[t] = We(i);
        const s = this._symbol[t];
        for (const e in s) delete s[e];
        const o = this.getMap(), a = [], l = xn.loadSymbolFnTypes(this.symbolDef[t], (() => {
            const t = e.MapStateCache[o.id], n = t ? t.zoom : o.getZoom();
            return a[0] = n, a;
        }));
        for (const e in l) {
            const t = Object.getOwnPropertyDescriptor(l, e);
            t.get ? Object.defineProperty(s, e, {
                get: t.get,
                set: t.set,
                configurable: !0,
                enumerable: !0
            }) : s[e] = l[e];
        }
        return k(i.visible) && (this._visibleFn[t] = F(i.visible)), r;
    }
    getSymbolDef(e) {
        return this.symbolDef[e.index];
    }
    getSymbols() {
        return this._symbol;
    }
    getSymbol(e) {
        const t = e.index;
        return this._symbol[t];
    }
    _compileSymbols() {
        const t = this.getMap(), n = [], i = () => {
            const i = e.MapStateCache[t.id], r = i ? i.zoom : t.getZoom();
            return n[0] = r, n;
        };
        this._symbol = [], this._visibleFn = [];
        for (let e = 0; e < this.symbolDef.length; e++) this._symbol[e] = xn.loadSymbolFnTypes(Be({}, this.symbolDef[e]), i), 
        this.symbolDef[e] && k(this.symbolDef[e].visible) && (this._visibleFn[e] = F(this.symbolDef[e].visible));
    }
    getFnTypeConfig(e) {
        this._fnTypeConfigs || (this._fnTypeConfigs = []);
        const t = e.index;
        if (!this._fnTypeConfigs[t]) {
            const n = this.getSymbolDef(e), i = this.getMap();
            this._fnTypeConfigs[t] = this.createFnTypeConfig(i, n);
        }
        return this._fnTypeConfigs[t];
    }
    _deleteFnTypeConfigs() {
        delete this._fnTypeConfigs;
    }
    loginTextureCache() {
        const e = (An + "").trim(), t = this.getMap();
        t[e] || (t[e] = {
            count: 0
        }), t[e].count++;
    }
    logoutTextureCache() {
        const e = (An + "").trim(), t = this.getMap(), n = this._myTextures;
        if (n) for (const i in n) et(n, i) && t[e][i] && (t[e][i].count--, t[e][i].count <= 0 && delete t[e][i]);
        t[e].count--, t[e].count <= 0 && (t[e] = {});
    }
    getCachedTexture(e) {
        const t = (An + "").trim(), n = this.getMap()[t][e];
        return n ? n.data : null;
    }
    addCachedTexture(e, t) {
        const n = (An + "").trim(), i = this.getMap();
        let r = i[n][e];
        r ? r.data = t : r = i[n][e] = {
            data: t,
            count: 0
        }, this._myTextures || (this._myTextures = {}), r.data.then || this._myTextures[e] || (r.count++, 
        this._myTextures[e] = 1);
    }
    disposeCachedTexture(e) {
        let t;
        if (t = "string" == typeof e ? e : e.url, !this._myTextures || !this._myTextures[t]) return;
        const n = (An + "").trim();
        delete this._myTextures[t];
        const i = this.getMap();
        i[n][t] && (i[n][t].count--, i[n][t].count <= 0 && delete i[n][t]);
    }
    shouldDeleteMeshOnUpdateSymbol() {
        return !1;
    }
    isEnableTileStencil() {
        return !0;
    }
    isUniqueStencilRefPerTile() {
        return this.isOnly2D();
    }
    supportRenderMode(e) {
        return "taa" === e || "fxaa" === e;
    }
    outline(e, t) {
        const n = {};
        for (let i = 0; i < t.length; i++) je(t[i]) || n[t[i]] || (this._outlineOne(e, t[i]), 
        n[t[i]] = 1);
    }
    _outlineOne(e, t) {
        if (!this.picking) return;
        if (this._outlineScene || (this._outlineScene = new g.Scene), !this._outlineShaders && (this._initOutlineShaders(), 
        !this._outlineShaders)) return void console.warn(`Plugin at ${this.pluginIndex} doesn't support outline.`);
        const n = this.getUniformValues(this.getMap(), this._renderContext);
        this._setLayerUniforms(n);
        const i = this._findMeshesHasFeaId(t);
        if (i.length) for (let r = 0; r < i.length; r++) {
            const s = i[r].geometry.properties.feaIdPickingMap;
            if (s) {
                const o = s[t];
                if (o) {
                    const t = {};
                    this._outlineScene.setMeshes(i[r]);
                    for (let i = 0; i < o.length; i++) {
                        const r = o[i];
                        if (!t[r]) {
                            t[r] = 1, n.highlightPickingId = r;
                            for (let t = 0; t < this._outlineShaders.length; t++) this.renderer.render(this._outlineShaders[t], n, this._outlineScene, e);
                        }
                    }
                }
            }
        }
    }
    _findMeshesHasFeaId(e) {
        const t = [], n = this.scene.getMeshes();
        for (let i = 0; i < n.length; i++) {
            const r = n[i], s = r.geometry.properties.feaIdPickingMap;
            s && void 0 !== s[e] && t.push(r);
        }
        return t;
    }
    outlineAll(e) {
        if (!this.picking) return;
        if (!this._outlineShaders && (this._initOutlineShaders(), !this._outlineShaders)) return void console.warn(`Plugin at ${this.pluginIndex} doesn't support outline.`);
        const t = this.getUniformValues(this.getMap(), this._renderContext);
        this._setLayerUniforms(t), t.highlightPickingId = -1;
        for (let n = 0; n < this._outlineShaders.length; n++) this.renderer.render(this._outlineShaders[n], t, this.scene, e);
    }
    _initOutlineShaders() {
        if (!this.picking) return;
        const e = this.layer.getRenderer().canvas;
        this._outlineShaders = [];
        for (let t = 0; t < this.picking.length; t++) {
            const n = this.picking[t].getPickingVert(), i = this.picking[t].getPickingWGSLVert(), r = {
                PICKING_MODE: 1,
                ENABLE_PICKING: 1,
                HAS_PICKING_ID: 1
            }, s = this.picking[t].getUniformDeclares().slice(0);
            void 0 !== s.uPickingId && (r.HAS_PICKING_ID = 2), this._outlineShaders[t] = new g.MeshShader({
                vert: n,
                frag: "precision highp float;\nuniform float highlightPickingId;\nvarying float vPickingId;\nvoid main() {\n  if(highlightPickingId < .0 || floor(highlightPickingId + .5) == floor(vPickingId + .5)) {\n    gl_FragColor = vec4(1.);\n  } else {\n    discard;\n  }\n}",
                wgslVert: i,
                wgslFrag: A("vt_outline_frag"),
                uniforms: s,
                defines: r,
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: () => e.width,
                        height: () => e.height
                    },
                    depth: {
                        enable: !0,
                        mask: !1,
                        func: "always"
                    },
                    blend: {
                        enable: !0,
                        func: {
                            src: "src alpha",
                            dst: "one minus src alpha"
                        },
                        equation: "add"
                    }
                }
            }), this._outlineShaders[t].filter = this.picking[t].filter;
        }
    }
    hasIBL() {
        const e = this.getMap().getLightManager();
        return !!(e && e.getAmbientResource());
    }
    updateIBLDefines(e) {
        const t = e.shaderDefines;
        let n = !1;
        this.hasIBL() ? t[[ "HAS_IBL_LIGHTING" ]] || (t.HAS_IBL_LIGHTING = 1, n = !0) : t[[ "HAS_IBL_LIGHTING" ]] && (delete t.HAS_IBL_LIGHTING, 
        n = !0), n && (e.shaderDefines = t);
    }
    getIBLRes() {
        const e = this.layer.getRenderer().canvas;
        return bn(e);
    }
    createIBLTextures() {
        const e = this.layer.getRenderer().canvas;
        _n(e, this.regl, this.getMap()), this.setToRedraw(!0), this.layer.fire("iblupdated");
    }
    disposeIBLTextures() {
        const e = this.layer.getRenderer().canvas;
        vn(e, this.getMap());
    }
    evaluateInFnTypeConfig(t, n, i, r, s) {
        let o = this._fnCaches;
        o || (o = this._fnCaches = {});
        const a = function(e) {
            let t = 0;
            const n = e && e.length || 0;
            if (!n) return t;
            let i;
            for (let r = 0; r < n; r++) i = e.codePointAt(r), t = (t << 5) - t + i, t |= 0;
            return t;
        }(JSON.stringify(t));
        let l = o[a];
        l || (l = o[a] = s ? O(t) : F(t));
        const h = e.MapStateCache[i.id];
        return l(h ? h.zoom : i.getZoom(), r);
    }
    highlight(e) {
        this._highlighted = e, this._highlightTimestamp = this.layer.getRenderer().getFrameTimestamp(), 
        this.setToRedraw(!0);
    }
    cancelAllHighlight() {
        this._highlighted = null, this._highlightTimestamp = this.layer.getRenderer().getFrameTimestamp(), 
        this.setToRedraw(!0);
    }
    _prepareFeatureIds(e, t) {
        const {featureIds: n, pickingIdIndiceMap: i} = t;
        e.properties.aFeaIds = n, e.properties.pickingIdIndiceMap = i;
    }
    _highlightMesh(e) {
        if (e && e.properties.isHalo) return;
        const t = e instanceof g.InstancedMesh ? e.properties : e.geometry.properties, {pickingIdIndiceMap: n} = t, i = this._highlighted ? function(e, t, n) {
            const i = e instanceof g.InstancedMesh ? e.properties : e.geometry.properties, {aPickingId: r, feaIdPickingMap: s, features: o} = i, a = new Map, l = n.keys();
            for (const e of l) {
                const i = n.get(e);
                if (i) if (je(i.id)) {
                    if (i.filter && r) {
                        let e = null;
                        for (let n = 0; n < r.length; n++) {
                            r[n] !== e && (e = r[n]);
                            const s = o[e];
                            i.filter(s && s.feature, t) && a.set(e, i);
                        }
                    }
                } else {
                    const e = s[i.id];
                    if (!e || !e.length) continue;
                    for (let t = 0; t < e.length; t++) a.set(e[t], i);
                }
            }
            return a;
        }(e, this.layer, this._highlighted) : null;
        b.highlightMesh(this.regl, e, i, this._highlightTimestamp, n);
    }
    _updateTerrainAltitude(e, t, n, i, r) {
        let s = n.aAnchor;
        if (!s) {
            const {aPosition: e} = t;
            s = n.aAnchor = e.slice(0);
        }
        let o = n.aTerrainAltitude;
        o || (o = n.aTerrainAltitude = new Float32Array(s.length / i), o.fill(Fe)), this._fillTerrainAltitude(o, s, r.tileInfo, 0, o.length - 1), 
        t.aTerrainAltitude ? o.dirty && this._updateATerrainAltitude(e, o) : t.aTerrainAltitude = o, 
        o.dirty = !1;
    }
    _updateATerrainAltitude(e, t) {
        e && e.updateData && e.updateData("aTerrainAltitude", t);
    }
    _fillTerrainAltitude(t, n, i, r, s) {
        const {res: o, extent: a, extent2d: l, id: h} = i, c = this.pluginIndex, u = h + "-" + c;
        if (i.completeTerrainQuery || (i.completeTerrainQuery = []), i.completeTerrainQuery[c]) return;
        if (!i.completeTerrainQuery[c] && this._terrainAltitudeCache && this._terrainAltitudeCache.has(u)) {
            const e = this._terrainAltitudeCache.getAndRemove(u);
            return this._terrainAltitudeCache.add(u, e), t.set(e.altitudeData), i.terrainTileInfos = e.terrainTileInfos, 
            t.dirty = !0, void (i.completeTerrainQuery[c] = !0);
        }
        const f = this.layer, d = f.getMap(), p = f.getRenderer(), g = p && p.getTerrainHelper();
        let m = i.terrainTileInfos;
        m || (m = i.terrainTileInfos = this.layer.queryTerrainTiles(i)), i.terrainQueryStatus || (i.terrainQueryStatus = []);
        let y = !1, x = [];
        for (let e = 0; e < i.terrainTileInfos.length; e++) if (x[e] = +g.isTerrainTileLoaded(i.terrainTileInfos[e].id), 
        x[e] && i.terrainQueryStatus[c] && !i.terrainQueryStatus[c][e]) {
            y = !0;
            break;
        }
        if (!y && i.terrainQueryStatus[c]) return;
        const _ = f.constructor;
        if (d.isInteracting()) {
            const e = p.getFrameTimestamp();
            _.altitudeQueryFrameTimestamp !== e && (_.altitudeQueryFrameTimestamp = e, _.altitudeQueryFrameTime = 0);
            const t = f.options.altitudeQueryTimeLimitPerFrame;
            if (_.altitudeQueryFrameTime > t) return;
        }
        const v = performance.now();
        i.terrainQueryStatus[c] = x;
        const {xmin: b, ymax: A} = l, T = wn.set(b, A), w = this.layer.getTileSize().width / i.extent, S = n.length / t.length;
        let M = t.queryResult;
        M || (M = t.queryResult = new Map);
        let P = !0;
        for (let e = r; e <= s; e++) {
            let i = n[e * S];
            i < 0 ? i = 0 : i > a && (i = a);
            let r = n[e * S + 1];
            r < 0 ? r = 0 : r > a && (r = a);
            const s = i + r * a;
            let l, h, c = M.get(s);
            if (c || 0 === c) t[e] !== c && (t[e] = c, t.dirty = !0); else {
                for (let e = 0; e < m.length; e++) if (gn(m[e], b + w * i, A - w * r, o)) {
                    l = m[e];
                    break;
                }
                l && (g.getRenderer().isTileCached(l.id) || t[e] === Fe) && (Sn.set(i, r), h = this.layer.queryTilePointTerrain(Sn, l, T, a, o)), 
                c = t[e], h && (c = null === h[0] ? Fe : h[0], Mn[0] = c, c = Mn[0]), t[e] !== c && (t[e] = c, 
                t.dirty = !0), h && h[1] ? M.set(s, c) : P = !1;
            }
        }
        _.altitudeQueryFrameTime = (_.altitudeQueryFrameTime || 0) + (performance.now() - v), 
        i.completeTerrainQuery[c] = P, P && (this._terrainAltitudeCache || (this._terrainAltitudeCache = new e.LRUCache(4 * this.layer.options.maxCacheSize)), 
        this._terrainAltitudeCache.add(u, {
            altitudeData: t,
            terrainTileInfos: m
        }));
    }
    shouldDrawParentTile() {
        return !0;
    }
    appendWGSLPositionType(e, t) {
        const n = e.geometry.desc.positionAttribute, i = e.geometry.data[n].array instanceof Float32Array;
        t.POSITION_TYPE_2 = i ? "vec2f" : "vec2i", t.POSITION_TYPE_3 = i ? "vec3f" : "vec4i", 
        i || (t.POSITION_IS_INT = 1);
    }
}

function Fn(e, t) {
    const n = e && e.getCommandKey(this.regl) || "", i = t && t.getCommandKey(this.regl) || "";
    return n.localeCompare(i);
}

function On(e, t) {
    return e.properties.level - t.properties.level;
}

class Rn extends kn {
    createGeometry(e, t) {
        const n = this.layer.options.debugTileData;
        if (n && !je(n.x)) {
            const {x: t, y: i, z: r} = e.tileInfo;
            n.x === t && n.y === i && n.z === r && console.log("glData", {
                layerId: this.layer.getId(),
                x: t,
                y: i,
                z: r,
                glData: e
            });
        }
        if (!e.data) return {
            geometry: null,
            symbolIndex: e.symbolIndex
        };
        e.iconAtlas && e.iconAtlas.image && (e.iconAtlas.image.dataType = e.type, e.iconAtlas.image.type = "icon"), 
        e.glyphAtlas && e.glyphAtlas.image && (e.glyphAtlas.image.type = "glyph");
        const i = Be({}, e.data), r = {
            primitive: this.getPrimitive(),
            positionSize: e.positionSize
        };
        i.aAltitude && (r.altitudeAttribute = "aAltitude");
        const s = new g.Geometry(i, e.indices, 0, r);
        return s.properties = {
            features: t
        }, e.iconAtlas && (s.properties.iconAtlas = e.iconAtlas.image, s.properties.iconPositions = e.iconAtlas.positions), 
        e.glyphAtlas && (s.properties.glyphAtlas = e.glyphAtlas.image), Nt(t) || (s.properties.aFeaIds = e.featureIds, 
        this._prepareFeatureIds(s, e)), e.markerPlacement && (s.properties.markerPlacement = e.markerPlacement), 
        e.textPlacement && (s.properties.textPlacement = e.textPlacement), Be(s.properties, e.properties), 
        {
            geometry: s,
            symbolIndex: e.symbolIndex
        };
    }
    getRayCastData(e, t) {
        const {features: n, aFeaIds: i} = e.geometry.properties;
        if (!n || !i) return null;
        return n[i[t]];
    }
    getPrimitive() {
        return "triangles";
    }
    getRenderFBO(e) {
        return e && e.renderTarget && e.renderTarget.fbo;
    }
    supportRenderMode(e) {
        return "noAa" === e;
    }
    drawDebugAtlas(e) {
        if (document.getElementById("MAPTALKS_ICON_DEBUG")) {
            const t = document.getElementById("MAPTALKS_ICON_DEBUG");
            let n;
            if (t.width = e.width, t.height = e.height, t.style.width = e.width + "px", t.style.height = e.height + "px", 
            "alpha" === e.format) {
                n = new Uint8ClampedArray(4 * e.data.length);
                for (let t = 0; t < e.data.length; t++) n[4 * t + 3] = e.data[t];
            } else n = new Uint8ClampedArray(e.data);
            const i = t.getContext("2d");
            i.imageSmoothingEnabled = !1, i.putImageData(new ImageData(n, e.width, e.height), 0, 0);
        }
    }
}

var En = "#include <gl2_vert>\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nuniform mat4 projViewModelMatrix;\nuniform mat4 positionMatrix;\n#include <fbo_picking_vert>\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n  gl_Position = projViewModelMatrix * positionMatrix * vec4(c, 1.);\n  fbo_picking_setData(gl_Position.w, true);\n}";

function Dn(e, t, n, i) {
    if (i) {
        const e = g.Util.resizeToPowerOfTwo(t.data, t.width, t.height);
        t.data = e;
    }
    const r = t, s = {
        width: r.width,
        height: r.height,
        data: r.data,
        format: r.format,
        mag: "linear",
        min: i ? "linear mipmap linear" : "linear",
        flipY: n,
        premultiplyAlpha: !0
    };
    if ("icon" === t.type) {
        const e = "point" !== t.dataType ? "repeat" : "clamp";
        s.wrapS = e, s.wrapT = e;
    }
    return e.texture(s);
}

const Ln = [ 0, 0 ], Hn = [];

function zn(e) {
    if (!e.properties.iconPositions) return Ln;
    let t, n = 0;
    for (const i in e.properties.iconPositions) if (t = i, n++, n > 1) return Ln;
    if (!t) return Ln;
    const i = e.properties.iconPositions[t], r = i.displaySize[0], s = i.displaySize[1];
    return Hn[0] = r, Hn[1] = s, Hn;
}

function Nn(e) {
    const t = new Set;
    for (const n of e) if (n.includes("&&") || n.includes("||")) {
        const e = Vn(n);
        for (const n of e) t.add(n.trim());
    } else t.add(n);
    return t;
}

function Vn(e) {
    return e.split(/&&|\|\|/).map((e => e.trim()));
}

function Bn(e, t, n, i, r) {
    if (!e.wgpu) return t;
    const s = e.wgpu.limits.maxVertexBuffers;
    let o = 0, a = {};
    for (let e = 0; e < n.length; e++) {
        const i = n[e];
        if (g.WGSLParseDefines.getDefineConditionValue(i, t) && (o++, o + r <= s)) {
            const e = Vn(i);
            for (const n of e) t[n] && (a[n] = t[n]);
        }
    }
    for (const e in t) i.has(e) || (a[e] = t[e]);
    return a;
}

const Un = [ "HAS_ALTITUDE", "ENABLE_COLLISION", "HAS_OFFSET_Z", "HAS_TEXT_SIZE", "HAS_MARKER_WIDTH", "HAS_MARKER_HEIGHT", "HAS_TEXT_FILL", "HAS_MARKER_DX || HAS_MARKER_DY || HAS_TEXT_DX || HAS_TEXT_DY", "HAS_OPACITY", "HAS_MARKER_PITCH_ALIGN || HAS_TEXT_PITCH_ALIGN", "HAS_MARKER_ROTATION_ALIGN || HAS_TEXT_ROTATION_ALIGN", "HAS_MARKER_ROTATION || HAS_TEXT_ROTATION", "HAS_TEXT_HALO_FILL", "HAS_HALO_ATTR || HAS_TEXT_HALO_RADIUS || HAS_TEXT_HALO_OPACITY" ], Gn = Nn(Un);

function jn(e, t) {
    return Bn(e, t, Un, Gn, 3);
}

const Wn = [ "HAS_ALTITUDE", "HAS_COLOR", "HAS_OPACITY", "HAS_LINE_WIDTH", "HAS_PATTERN || HAS_DASHARRAY || HAS_GRADIENT || HAS_TRAIL", "HAS_PATTERN", "HAS_GRADIENT", "HAS_DASHARRAY && HAS_DASHARRAY_ATTR", "HAS_DASHARRAY && HAS_DASHARRAY_COLOR", "HAS_LINE_DX || HAS_LINE_DY", "HAS_STROKE_WIDTH", "HAS_STROKE_COLOR" ], Xn = Nn(Wn);

const Yn = [ "HAS_ALTITUDE", "HAS_COLOR", "HAS_OPACITY", "HAS_PATTERN", "HAS_PATTERN && HAS_PATTERN_WIDTH", "HAS_PATTERN && HAS_PATTERN_ORIGIN", "HAS_PATTERN && HAS_PATTERN_OFFSET", "HAS_PATTERN && HAS_UV_SCALE", "HAS_PATTERN && HAS_UV_OFFSET", "HAS_PATTERN && HAS_TEX_COORD" ], qn = Nn(Yn);

const {INVALID_TEX_COORD: Zn} = q(), $n = y.identity([]), Jn = {
    polygonFill: [ 1, 1, 1, 1 ],
    polygonOpacity: 1,
    uvScale: [ 1, 1 ],
    uvOffset: [ 0, 0 ],
    patternWidth: [ 0, 0 ],
    patternOffset: [ 0, 0 ]
}, Kn = [], Qn = new e.Coordinate(0, 0), ei = new e.Coordinate(0, 0), ti = new e.Coordinate(0, 0), ni = [];

class ii extends Rn {
    static getBloomSymbol() {
        return [ "polygonBloom" ];
    }
    prepareSymbol(e) {
        const t = e.polygonFill;
        Array.isArray(t) && (3 === t.length && t.push(1), e.polygonFill = t.map((e => 255 * e)));
    }
    supportRenderMode(e) {
        return this.sceneConfig.antialias || void 0 === this.sceneConfig.antialias ? "fxaa" === e || "fxaaBeforeTaa" === e : super.supportRenderMode(e);
    }
    isBloom(e) {
        return !!this.getSymbol(e.properties.symbolIndex)[ii.getBloomSymbol()[0]];
    }
    needPolygonOffset() {
        return !0;
    }
    getAnalysisMeshes() {
        if (!this.isVisible()) return Kn;
        return this.scene.getMeshes().filter((e => 0 === e.properties.level));
    }
    createMesh(t, n, i) {
        const r = this.getMap(), {tilePoint: s} = i, {geometry: o, symbolIndex: a, ref: l} = t, h = this.layer instanceof e.TileLayer, c = this.layer.getTileSize().width, u = o.properties.tileExtent / c, f = o.properties.tileResolution, d = r.pointAtResToCoord(Qn.set(s[0], s[1]), f), p = {
            tileExtent: o.properties.tileExtent,
            tileRatio: u
        }, m = this.getSymbol(a), y = this.getSymbolDef(a);
        if (k(y.polygonPatternFileOrigin) && this._preparePatternOrigin(y, t, h ? [ 0, 0 ] : s, f), 
        (k(y.polygonPatternFileWidth) || k(y.polygonPatternFileWidth)) && this._preparePatternWidth(y, t, h ? u : 1, d, f), 
        y.uvOffsetInMeter && k(y.uvOffset) && this._preparePatternOffset(y, t, d, f), Xe(p, "polygonFill", m, "polygonFill", Jn.polygonFill, Ze(this.colorCache)), 
        Xe(p, "polygonOpacity", m, "polygonOpacity", Jn.polygonOpacity), Xe(p, "uvScale", m, "uvScale", Jn.uvScale), 
        void 0 === l) {
            const e = this.getFnTypeConfig(a);
            Gt(o, y, e, this.layer), o.generateBuffers(this.regl);
        }
        const x = o.properties.iconAtlas, _ = 2048;
        if (x && o.data.aTexInfo) {
            const e = [];
            Object.defineProperty(p, "uvOrigin", {
                enumerable: !0,
                get: () => {
                    const t = p.tileScale;
                    if (o.data.aPatternOrigin) return e[0] = s[0] * t % _, e[1] = s[1] * t % _, e;
                    const n = m.polygonPatternFileOrigin;
                    return n ? (Qn.set(n[0], n[1]), r.coordToPointAtRes(Qn, f, ei), T.set(e, s[0] - ei.x, s[1] - ei.y)) : (e[0] = s[0] * t % _, 
                    e[1] = s[1] * t % _, e);
                }
            });
            const t = [];
            Object.defineProperty(p, "patternWidth", {
                enumerable: !0,
                get: () => {
                    if (o.data.aPatternWidth) return Jn.patternWidth;
                    const e = y.polygonPatternFileWidth, n = y.polygonPatternFileHeight;
                    if (!e && !n) return Jn.patternWidth;
                    const [i, r] = this._computePatternWidth(ni, e, n, h ? u : 1, d, f);
                    return T.set(t, i, r);
                }
            }), Object.defineProperty(p, "uvOffset", {
                enumerable: !0,
                get: () => o.data.aPatternOffset || y.uvOffsetInMeter ? Jn.uvOffset : m.uvOffset || Jn.uvOffset
            });
            const n = [];
            Object.defineProperty(p, "patternOffset", {
                enumerable: !0,
                get: () => {
                    if (o.data.aPatternOffset) return Jn.uvOffset;
                    if (!y.uvOffsetInMeter) return Jn.uvOffset;
                    const e = y.uvOffset;
                    if (!e) return Jn.uvOffset;
                    const t = it(r, e[0], d, f), i = it(r, e[1], d, f);
                    return T.set(n, t, i);
                }
            }), Object.defineProperty(p, "tileScale", {
                enumerable: !0,
                get: function() {
                    const e = y.polygonPatternFileWidth, t = y.polygonPatternFileHeight;
                    return e || t ? 1 : o.properties.tileResolution / r.getResolution();
                }
            }), p.polygonPatternFile = Dn(this.regl, x, !1, !1), p.atlasSize = [ x.width, x.height ], 
            this.drawDebugAtlas(x);
        }
        const v = new g.Material(p, Jn), b = new g.Mesh(o, v, {
            castShadow: !1,
            picking: !0
        }), A = {};
        return x && o.data.aTexInfo && (A.HAS_PATTERN = 1), x && o.data.aTexCoord && (A.HAS_TEX_COORD = 1, 
        A.INVALID_TEX_COORD = Zn + ".0"), o.data.aAltitude && (A.HAS_ALTITUDE = 1), o.data.aColor && (A.HAS_COLOR = 1), 
        o.data.aOpacity && (A.HAS_OPACITY = 1), o.data.aUVScale && (A.HAS_UV_SCALE = 1), 
        o.data.aUVOffset && (A.HAS_UV_OFFSET = 1), o.data.aPatternOrigin && (A.HAS_PATTERN_ORIGIN = 1), 
        o.data.aPatternWidth && (A.HAS_PATTERN_WIDTH = 1), o.data.aPatternOffset && (A.HAS_PATTERN_OFFSET = 1), 
        h && (A.IS_VT = 1), b.setDefines(A), b.positionMatrix = this.getAltitudeOffsetMatrix(), 
        b.setLocalTransform(n), b.properties.symbolIndex = a, b;
    }
    _preparePatternWidth(e, t, n, i, r) {
        if (!(t = t && t.geometry)) return;
        const s = t.properties.features;
        if (Nt(s)) return;
        const o = e.polygonPatternFileWidth, a = e.polygonPatternFileHeight, l = F(e.polygonPatternFileOrigin);
        let h, c;
        k(o) && (h = F(o)), k(a) && (c = F(a));
        const {aPickingId: u, aPatternOrigin: f} = t.data, d = u.length, p = new Float32Array(2 * d);
        let g, m, y;
        for (let e = 0, t = u.length; e < t; e++) {
            let t, d;
            if (u[e] === g) {
                p[2 * e] = m, p[2 * e + 1] = y;
                continue;
            }
            const x = s[u[e]];
            if (t = h ? h(null, x.feature.properties) : o, d = c ? c(null, x.feature.properties) : a, 
            g = u[e], t || d) {
                let s = i;
                if (f) {
                    const e = l(null, x.feature.properties);
                    e && (s = ti.set(e[0], e[1]));
                }
                const [o, a] = this._computePatternWidth(ni, t, d, n, s, r);
                m = p[2 * e] = o, y = p[2 * e + 1] = a;
            } else m = p[2 * e] = 0, y = p[2 * e + 1] = 0;
        }
        t.data.aPatternWidth = p;
    }
    _preparePatternOffset(e, t, n, i) {
        if (!(t = t && t.geometry)) return;
        const r = t.properties.features;
        if (Nt(r)) return;
        const s = this.getMap();
        let o = k(e.uvOffsetInMeter) && O(e.uvOffsetInMeter);
        const a = F(e.uvOffset), l = F(e.polygonPatternFileOrigin), {aPickingId: h, aPatternOrigin: c} = t.data, u = h.length, f = new Float32Array(2 * u);
        let d, p, g;
        for (let e = 0, t = h.length; e < t; e++) {
            if (h[e] === d) {
                f[2 * e] = p, f[2 * e + 1] = g;
                continue;
            }
            const t = r[h[e]], u = a(null, t.feature.properties);
            let m = !0;
            if (o && (m = o(null, t.feature.properties)), d = h[e], u && m) {
                let r = n;
                if (c) {
                    const e = l(null, t.feature.properties);
                    e && (r = ti.set(e[0], e[1]));
                }
                const o = it(s, u[0], r, i), a = it(s, u[0], r, i);
                p = f[2 * e] = o, g = f[2 * e + 1] = a;
            } else p = f[2 * e] = 0, g = f[2 * e + 1] = 0;
        }
        t.data.aPatternOffset = f;
    }
    _preparePatternOrigin(e, t, n, i) {
        if (!(t = t && t.geometry)) return;
        const r = t.properties.features;
        if (Nt(r)) return;
        const s = this.getMap(), o = F(e.polygonPatternFileOrigin), a = t.data.aPickingId, l = a.length, h = new Float32Array(2 * l);
        let c, u, f;
        for (let e = 0, t = a.length; e < t; e++) {
            if (a[e] === c) {
                h[2 * e] = u, h[2 * e + 1] = f;
                continue;
            }
            c = a[e];
            const t = o(null, r[c].feature.properties);
            t ? (Qn.set(t[0], t[1]), s.coordToPointAtRes(Qn, i, ei), u = h[2 * e] = ei.x, f = h[2 * e + 1] = ei.y) : (u = h[2 * e] = n[0], 
            f = h[2 * e + 1] = n[1]);
        }
        t.data.aPatternOrigin = h;
    }
    createFnTypeConfig(t, n) {
        const i = O(n.polygonFill), r = F(n.polygonOpacity), s = F(n.uvScale), o = F(n.uvOffset), a = new Uint8Array(1), l = new Uint16Array(2), h = new Uint8Array(2);
        return [ {
            attrName: "aColor",
            symbolName: "polygonFill",
            type: Uint8Array,
            width: 4,
            define: "HAS_COLOR",
            evaluate: (n, r) => {
                const s = e.MapStateCache[t.id], o = s ? s.zoom : t.getZoom();
                let a = i(o, n);
                return k(a) && (a = this.evaluateInFnTypeConfig(a, r, t, n, !0)), Array.isArray(a) || (a = this.colorCache[a] = this.colorCache[a] || I(a).unitArray()), 
                a = qe(a), a;
            }
        }, {
            attrName: "aOpacity",
            symbolName: "polygonOpacity",
            type: Uint8Array,
            width: 1,
            define: "HAS_OPACITY",
            evaluate: (n, i) => {
                const s = e.MapStateCache[t.id], o = s ? s.zoom : t.getZoom();
                let l = r(o, n);
                return k(l) && (l = this.evaluateInFnTypeConfig(l, i, t, n)), a[0] = 255 * l, a[0];
            }
        }, {
            attrName: "aUVScale",
            symbolName: "uvScale",
            type: Uint16Array,
            width: 2,
            define: "HAS_UV_SCALE",
            evaluate: n => {
                const i = e.MapStateCache[t.id], r = i ? i.zoom : t.getZoom(), o = s(r, n);
                return l[0] = 255 * o[0], l[1] = 255 * o[1], l;
            }
        }, {
            attrName: "aUVOffset",
            symbolName: "uvOffset",
            type: Uint8Array,
            width: 2,
            define: "HAS_UV_OFFSET",
            evaluate: n => {
                const i = e.MapStateCache[t.id], r = i ? i.zoom : t.getZoom(), s = o(r, n);
                return h[0] = 255 * s[0], h[1] = 255 * s[1], h;
            }
        } ];
    }
    paint(e) {
        if (this.isShadowIncludeChanged(e)) {
            this.shader.dispose();
            const t = this._getExtraCommandProps();
            this._createShader(e, t);
        }
        super.paint(e);
    }
    isEnableTileStencil(t) {
        const n = "VectorTileLayer" === this.layer.getJSONType(), i = this.layer instanceof e.TileLayer;
        return !!!(t && t.isRenderingTerrain && this.isTerrainSkin()) && (n || i && this.isOnly2D());
    }
    _getExtraCommandProps() {
        const e = this.regl, t = this.canvas, n = {
            x: (e, t) => t.viewport ? t.viewport.x : 0,
            y: (e, t) => t.viewport ? t.viewport.y : 0,
            width: (e, n) => n.viewport ? n.viewport.width : t ? t.width : 1,
            height: (e, n) => n.viewport ? n.viewport.height : t ? t.height : 1
        };
        this.renderer = new g.Renderer(e);
        return {
            viewport: n,
            stencil: {
                enable: (e, t) => t.geometryProperties.is2D && this.isEnableTileStencil(t.painterContext),
                func: {
                    cmp: () => this.isOnly2D() ? "=" : "<=",
                    ref: (e, t) => t.stencilRef
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: () => {
                        const e = "VectorTileLayer" === this.layer.getJSONType(), t = this.isOnly2D();
                        return e && t ? "zero" : "replace";
                    }
                }
            },
            depth: {
                enable: !0,
                range: this.sceneConfig.depthRange || [ 0, 1 ],
                mask: (e, t) => {
                    if (!je(this.sceneConfig.depthMask)) return !!this.sceneConfig.depthMask;
                    if (t.hasSSRGround) return !0;
                    if (t.meshConfig.transparent) return !1;
                    const n = t.polygonOpacity;
                    return !(Ke(n) && n < 1);
                },
                func: this.sceneConfig.depthFunc || "<="
            },
            blend: {
                enable: !0,
                func: this.getBlendFunc(),
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        };
    }
    init(e) {
        const t = this._getExtraCommandProps();
        if (this._createShader(e, t), this.pickingFBO) {
            const e = [], n = this.layer.isVectorTileLayer, i = {
                PICKING_MODE: 1
            };
            this.picking = [ new g.FBORayPicking(this.renderer, {
                name: "fill-picking",
                vert: En,
                wgslVert: A("vt_fill_picking_vert"),
                defines: i,
                uniforms: [ {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(t, n) {
                        return y.multiply(e, n.projViewMatrix, n.modelMatrix), e;
                    }
                } ],
                extraCommandProps: t,
                enableStencil: () => !(!n || !this.isOnly2D())
            }, this.pickingFBO, this.getMap()) ];
        }
    }
    _createShader(e, t) {
        const n = [], i = [ {
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, t) {
                return y.multiply(n, t.projViewMatrix, t.modelMatrix), n;
            }
        } ], r = {};
        this.fillIncludes(r, i, e), this.shader = new g.MeshShader({
            name: "vt-fill",
            vert: "#define SHADER_NAME FILL\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\n#ifdef HAS_COLOR\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#ifdef HAS_OPACITY\nattribute float aOpacity;\nvarying float vOpacity;\n#endif\nuniform mat4 projViewModelMatrix;\nuniform mat4 positionMatrix;\n#ifndef IS_VT\nuniform mat4 modelMatrix;\n#endif\n#ifdef HAS_PATTERN\n#ifdef HAS_TEX_COORD\nattribute vec2 aTexCoord;\n#endif\nattribute vec4 aTexInfo;\nuniform vec2 patternWidth;\nuniform vec2 patternOffset;\nuniform vec2 uvOrigin;\nuniform vec2 uvScale;\n#ifdef IS_VT\nuniform float tileRatio;\nuniform float tileScale;\n#else\nuniform float glScale;\n#endif\n#ifdef HAS_UV_SCALE\nattribute vec2 aUVScale;\nvarying vec2 vUVScale;\n#endif\n#ifdef HAS_UV_OFFSET\nattribute vec2 aUVOffset;\nvarying vec2 vUVOffset;\n#endif\n#ifdef HAS_PATTERN_WIDTH\nattribute vec2 aPatternWidth;\n#endif\n#ifdef HAS_PATTERN_ORIGIN\nattribute vec2 aPatternOrigin;\n#endif\n#ifdef HAS_PATTERN_OFFSET\nattribute vec2 aPatternOffset;\n#endif\nvarying vec2 vTexCoord;\nvarying vec4 vTexInfo;\nvec2 c(vec2 d, vec2 e) {\n  \n#ifdef IS_VT\nfloat f = d.x / e.x;\n  float h = d.y / e.y;\n  return vec2(f, h);\n#else\nfloat i = glScale;\n#ifdef HAS_PATTERN_WIDTH\nfloat j = sign(length(aPatternWidth));\n  i = mix(glScale, 1., j);\n#endif\nvec2 k = uvOrigin;\n#ifdef HAS_PATTERN_ORIGIN\nk = aPatternOrigin;\n#endif\n#ifdef HAS_PATTERN_OFFSET\nvec2 l = aPatternOffset;\n#else\nvec2 l = patternOffset;\n#endif\nk += l;\n  float f = (d.x - k.x) * i / e.x;\n  float h = (d.y - k.y) * i / e.y;\n  return vec2(f, -h);\n#endif\n}\nvec2 m(vec4 n, vec2 o) {\n  \n#ifdef IS_VT\n#ifdef HAS_PATTERN_OFFSET\nvec2 l = aPatternOffset;\n#else\nvec2 l = patternOffset;\n#endif\nvec2 k = uvOrigin + l;\n#ifdef HAS_PATTERN_ORIGIN\nk = k - aPatternOrigin * tileScale;\n#endif\nfloat j = sign(length(patternWidth));\n  vec2 A = mix(o, patternWidth, j);\n#ifdef HAS_PATTERN_WIDTH\nA = aPatternWidth;\n#endif\nvec2 B = k * vec2(1., -1.) / A;\n  return mod(B, 1.) + c(n.xy * tileScale / tileRatio, A);\n#else\nvec2 A = o;\n#ifdef HAS_PATTERN_WIDTH\nfloat j = sign(length(aPatternWidth));\n  A = mix(o, aPatternWidth, j);\n#endif\nvec4 C = modelMatrix * n;\n  return c(C.xy, A);\n#endif\n}\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#include <vt_position_vert>\n#include <highlight_vert>\nvoid main() {\n  vec3 D = unpackVTPosition();\n  vec4 n = vec4(D, 1.);\n  gl_Position = projViewModelMatrix * positionMatrix * n;\n#ifdef HAS_PATTERN\nvec2 o = aTexInfo.zw + 1.;\n  vTexInfo = vec4(aTexInfo.xy, o);\n#ifdef HAS_TEX_COORD\nif(aTexCoord.x == INVALID_TEX_COORD) {\n    vTexCoord = m(n, o);\n  } else {\n    vTexCoord = aTexCoord;\n  }\n#else\nvTexCoord = m(n, o);\n#endif\n#ifdef HAS_UV_SCALE\nvUVScale = aUVScale / 255.;\n#endif\n#ifdef HAS_UV_OFFSET\nvUVOffset = aUVOffset / 255.;\n#endif\n#endif\n#ifdef HAS_COLOR\nvColor = aColor / 255.;\n#endif\nhighlight_setVarying();\n#ifdef HAS_OPACITY\nvOpacity = aOpacity / 255.;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(n);\n#endif\n}",
            frag: "#define SHADER_NAME FILL\nprecision mediump float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#ifdef HAS_PATTERN\n#ifdef HAS_UV_SCALE\nvarying vec2 vUVScale;\n#else\nuniform highp vec2 uvScale;\n#endif\n#ifdef HAS_UV_OFFSET\nvarying vec2 vUVOffset;\n#else\nuniform vec2 uvOffset;\n#endif\n#endif\n#ifdef HAS_PATTERN\nuniform sampler2D polygonPatternFile;\nuniform vec2 atlasSize;\nvarying vec2 vTexCoord;\nvarying vec4 vTexInfo;\nvec2 c() {\n  \n#ifdef HAS_UV_SCALE\nvec2 d = vUVScale;\n#else\nvec2 d = uvScale;\n#endif\n#ifdef HAS_UV_OFFSET\nvec2 e = vUVOffset;\n#else\nvec2 e = uvOffset;\n#endif\nvec2 f = mod(vTexCoord * d + e, 1.);\n  vec2 h = vTexInfo.xy;\n  vec2 i = vTexInfo.zw;\n  return (h + f * i) / atlasSize;\n}\n#endif\n#ifdef HAS_COLOR\nvarying vec4 vColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#include <highlight_frag>\n#ifdef HAS_OPACITY\nvarying float vOpacity;\n#else\nuniform lowp float polygonOpacity;\n#endif\nuniform float layerOpacity;\nuniform float tileExtent;\nvoid main() {\n  \n#ifdef HAS_COLOR\nvec4 j = vColor;\n#else\nvec4 j = polygonFill;\n#endif\n#ifdef HAS_PATTERN\nif(vTexInfo.z * vTexInfo.w > 1.) {\n    vec2 f = c();\n    j = texture2D(polygonPatternFile, f);\n  }\n#endif\n#ifdef HAS_OPACITY\ngl_FragColor = j * vOpacity;\n#else\ngl_FragColor = j * polygonOpacity;\n#endif\ngl_FragColor *= layerOpacity;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat k = shadow_computeShadow();\n  gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, k);\n#endif\ngl_FragColor = highlight_blendColor(gl_FragColor);\n}",
            wgslVert: A("vt_fill_vert"),
            wgslFrag: A("vt_fill_frag"),
            uniforms: i,
            defines: r,
            extraCommandProps: t
        });
    }
    limitMeshDefines(e) {
        let t = e.defines;
        t = function(e, t) {
            return Bn(e, t, Yn, qn, 1);
        }(this.regl, t), e.setDefines(t);
    }
    getUniformValues(e, t) {
        const n = t && t.isRenderingTerrainSkin, i = {
            projViewMatrix: n ? $n : e.projViewMatrix,
            glScale: t && t.isRenderingTerrainSkin ? 1 : 1 / e.getGLScale(),
            viewport: n && t && t.viewport,
            maskViewport: n && t && t.maskViewport,
            hasSSRGround: t && t.hasSSRGround
        };
        return this.setIncludeUniformValues(i, t), i;
    }
    _computePatternWidth(e, t, n, i, r, s) {
        let o, a;
        const l = this.getMap();
        if (t) {
            o = it(l, t, r, s);
        }
        if (n) {
            a = it(l, n, r, s, 1);
        }
        return o = o || a, a = a || o, e[0] = o, e[1] = a, e;
    }
}

var ri = "#define SHADER_NAME LINE\n#define AA_CLIP_LIMIT 2.0\n#define AA_LINE_WIDTH 16.0\n#define DEVICE_PIXEL_RATIO 1.0\n#define ANTIALIASING 1.0 / DEVICE_PIXEL_RATIO / 2.0\n#define EXTRUDE_SCALE 63.0\n#define EXTRUDE_MOD 64.0\n#define MAX_LINE_DISTANCE 65535.0\n#ifdef PICKING_MODE\n#include <gl2_vert>\n#endif\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\n#if defined(HAS_PATTERN) || defined(HAS_DASHARRAY)\nattribute vec3 aExtrude;\n#else\nattribute vec2 aExtrude;\n#endif\n#if defined(HAS_PATTERN) || defined(HAS_DASHARRAY) || defined(HAS_GRADIENT) || defined(HAS_TRAIL)\nattribute float aLinesofar;\nvarying highp float vLinesofar;\n#endif\nuniform float cameraToCenterDistance;\n#if defined(HAS_STROKE_WIDTH)\nattribute float aLineStrokeWidth;\n#else\nuniform float lineStrokeWidth;\n#endif\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform mat4 modelMatrix;\nuniform float tileResolution;\nuniform float resolution;\nuniform float tileRatio;\nuniform float isRenderingTerrain;\n#if defined(HAS_LINE_DX) || defined(HAS_LINE_DY)\nattribute vec2 aLineDxDy;\n#endif\n#ifndef HAS_LINE_DX\nuniform float lineDx;\n#endif\n#ifndef HAS_LINE_DY\nuniform float lineDy;\n#endif\nuniform vec2 canvasSize;\nuniform float layerScale;\nvarying vec2 vNormal;\nvarying vec2 vWidth;\nvarying float vGammaScale;\n#ifndef ENABLE_TILE_STENCIL\nvarying vec2 vPosition;\n#endif\n#ifdef USE_LINE_OFFSET\nattribute vec2 aExtrudeOffset;\n#endif\n#ifdef HAS_LINE_WIDTH\nattribute float aLineWidth;\n#else\nuniform float lineWidth;\n#endif\n#ifndef PICKING_MODE\n#ifndef HAS_GRADIENT\n#ifdef HAS_COLOR\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#ifdef HAS_PATTERN\n#if defined(HAS_PATTERN_ANIM) || defined(HAS_PATTERN_GAP)\nattribute vec2 aLinePattern;\n#endif\n#ifdef HAS_PATTERN_ANIM\nvarying float vLinePatternAnimSpeed;\n#endif\n#ifdef HAS_PATTERN_GAP\nvarying float vLinePatternGap;\n#endif\nattribute vec4 aTexInfo;\nvarying vec4 vTexInfo;\n#endif\n#ifdef HAS_DASHARRAY\n#ifdef HAS_DASHARRAY_ATTR\nattribute vec4 aDasharray;\nvarying vec4 vDasharray;\n#endif\n#ifdef HAS_DASHARRAY_COLOR\nattribute vec4 aDashColor;\nvarying vec4 vDashColor;\n#endif\n#endif\n#endif\n#ifdef HAS_STROKE_COLOR\nattribute vec4 aStrokeColor;\nvarying vec4 vStrokeColor;\n#endif\n#ifdef HAS_OPACITY\nattribute float aOpacity;\nvarying float vOpacity;\n#endif\n#ifdef HAS_GRADIENT\nattribute float aGradIndex;\nvarying float vGradIndex;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#include <highlight_vert>\n#else\n#include <fbo_picking_vert>\n#endif\nvarying vec3 vVertex;\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n  float d = mod(abs(aExtrude.x), 2.);\n  float e = mod(abs(aExtrude.y), 2.);\n  vNormal = vec2(d, e * 2. - 1.);\n  vec4 f = vec4(c, 1.);\n  vec4 h = projViewModelMatrix * positionMatrix * f;\n  if(isRenderingTerrain == 1.) {\n    vVertex = (positionMatrix * f).xyz;\n  } else {\n    vVertex = (modelMatrix * positionMatrix * f).xyz;\n  }\n#ifdef HAS_STROKE_WIDTH\nfloat i = aLineStrokeWidth / 2. * layerScale;\n#else\nfloat i = lineStrokeWidth;\n#endif\n#ifdef HAS_LINE_WIDTH\nfloat j = aLineWidth / 2. * layerScale;\n#else\nfloat j = lineWidth * layerScale;\n#endif\nfloat k = j / 2. + i;\n  float l = sign(i) * j / 2.;\n  float m = l + sign(l) * ANTIALIASING;\n  float n = k + sign(k) * ANTIALIASING;\n#ifdef USE_LINE_OFFSET\nvec2 o = lineOffset * (vNormal.y * (aExtrude.xy - aExtrudeOffset) + aExtrudeOffset);\n  vec2 u = (n * aExtrude.xy + o) / EXTRUDE_SCALE;\n#else\nvec2 v = aExtrude.xy / EXTRUDE_SCALE;\n  vec2 u = n * v;\n#endif\nfloat A = tileResolution / resolution;\n  vec4 B = vec4(c + vec3(u, .0) * tileRatio / A, 1.);\n  gl_Position = projViewModelMatrix * positionMatrix * B;\n#ifdef HAS_LINE_DX\nfloat C = aLineDxDy[0];\n#else\nfloat C = lineDx;\n#endif\n#ifdef HAS_LINE_DY\nfloat D = aLineDxDy[1];\n#else\nfloat D = lineDy;\n#endif\nfloat E = gl_Position.w;\n  gl_Position.xy += vec2(C, D) * 2. / canvasSize * E;\n#ifndef PICKING_MODE\nvWidth = vec2(n, m);\n  if(isRenderingTerrain == 1.) {\n    vGammaScale = 1.;\n  } else {\n    vGammaScale = E / cameraToCenterDistance;\n  }\n#ifndef ENABLE_TILE_STENCIL\nvPosition = c.xy;\n#ifdef USE_LINE_OFFSET\nvPosition += tileRatio * o / EXTRUDE_SCALE;\n#endif\n#endif\n#if defined(HAS_PATTERN) || defined(HAS_DASHARRAY) || defined(HAS_GRADIENT)\n#ifdef HAS_GRADIENT\nvLinesofar = aLinesofar / MAX_LINE_DISTANCE;\n  vGradIndex = aGradIndex;\n#else\nfloat F = aLinesofar - k * aExtrude.z / EXTRUDE_SCALE / A * tileRatio;\n  vLinesofar = F / tileRatio * A;\n#endif\n#endif\n#ifndef HAS_GRADIENT\n#ifdef HAS_COLOR\nvColor = aColor;\n#endif\n#ifdef HAS_DASHARRAY\n#ifdef HAS_DASHARRAY_ATTR\nvDasharray = aDasharray;\n#endif\n#ifdef HAS_DASHARRAY_COLOR\nvDashColor = aDashColor / 255.;\n#endif\n#endif\n#ifdef HAS_PATTERN\nvTexInfo = vec4(aTexInfo.xy, aTexInfo.zw + 1.);\n#ifdef HAS_PATTERN_ANIM\nvLinePatternAnimSpeed = aLinePattern[0] / 127.;\n#endif\n#ifdef HAS_PATTERN_GAP\nvLinePatternGap = aLinePattern[1] / 10.0;\n#endif\n#endif\n#endif\n#ifdef HAS_STROKE_COLOR\nvStrokeColor = aStrokeColor;\n#endif\n#ifdef HAS_OPACITY\nvOpacity = aOpacity / 255.;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(B);\n#endif\nhighlight_setVarying();\n#else\nfbo_picking_setData(E, true);\n#endif\n}";

const si = y.identity([]), oi = [];

class ai extends Rn {
    static getBloomSymbol() {
        return [ "lineBloom" ];
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    prepareSymbol(e) {
        const t = e.lineColor;
        Array.isArray(t) && (3 === t.length && t.push(1), e.lineColor = t.map((e => 255 * e)));
        const n = e.lineStrokeColor;
        Array.isArray(n) && (3 === n.length && n.push(1), e.lineStrokeColor = n.map((e => 255 * e)));
        const i = e.lineDashColor;
        Array.isArray(i) && (3 === i.length && i.push(1), e.lineDashColor = i.map((e => 255 * e)));
    }
    isAnimating() {
        if (this._hasPatternAnim) return !0;
        const e = this.getSymbols(), t = this.sceneConfig.trailAnimation;
        if (t && t.enable) return !0;
        for (let t = 0; t < e.length; t++) if (e[t].linePatternFile && e[t].linePatternAnimSpeed) return !0;
        return !1;
    }
    needToRedraw() {
        return !!super.needToRedraw() || !!this.isAnimating();
    }
    isBloom(e) {
        return !!this.getSymbol(e.properties.symbolIndex)[ai.getBloomSymbol()[0]];
    }
    needPolygonOffset() {
        return !0;
    }
    createMesh(t, n) {
        if (!t.geometry) return null;
        const {geometry: i, symbolIndex: r, ref: s} = t, o = this.getSymbolDef(r);
        if (void 0 === s) {
            Gt(i, o, this.getFnTypeConfig(r), this.layer);
        }
        const a = this.getSymbol(r), l = {
            tileResolution: i.properties.tileResolution,
            tileRatio: i.properties.tileRatio,
            tileExtent: i.properties.tileExtent
        };
        this.setLineUniforms(a, l), Xe(l, "lineColor", a, "lineColor", "#fff", Ze(this.colorCache)), 
        Xe(l, "linePatterGapColor", a, "linePatterGapColor", [ 0, 0, 0, 0 ], Ze(this.colorCache)), 
        Xe(l, "lineStrokeColor", a, "lineStrokeColor", [ 0, 0, 0, 0 ], Ze(this.colorCache)), 
        Xe(l, "lineDasharray", a, "lineDasharray", [ 0, 0, 0, 0 ], (e => {
            let t;
            if (e && e.length) {
                const n = e;
                1 === e.length ? t = [ n[0], n[0], n[0], n[0] ] : 2 === e.length ? t = [ n[0], n[1], n[0], n[1] ] : 3 === e.length ? t = [ n[0], n[1], n[2], n[2] ] : 4 === e.length ? t = e : e.length > 4 && (t = e.slice(0, 4));
            }
            return t || [ 0, 0, 0, 0 ];
        })), Xe(l, "lineDashColor", a, "lineDashColor", [ 0, 0, 0, 0 ], Ze(this.colorCache));
        const h = i.properties.iconAtlas, c = this.layer instanceof e.TileLayer;
        h && (l.linePatternFile = Dn(this.regl, h, !1, !1), l.atlasSize = h ? [ h.width, h.height ] : [ 0, 0 ], 
        l.flipY = c ? -1 : 1, this.drawDebugAtlas(h)), void 0 === s && i.generateBuffers(this.regl);
        const u = new g.Material(l), f = new g.Mesh(i, u, {
            castShadow: !1,
            picking: !0
        });
        f.setLocalTransform(n), f.positionMatrix = this.getAltitudeOffsetMatrix();
        const d = {};
        return h && (d.HAS_PATTERN = 1), f.properties.symbolIndex = r, this._prepareDashDefines(f, d), 
        i.data.aColor && (d.HAS_COLOR = 1), i.data.aStrokeColor && (d.HAS_STROKE_COLOR = 1), 
        this.setMeshDefines(d, i, o), i.data.aAltitude && (d.HAS_ALTITUDE = 1), f.setDefines(d), 
        f;
    }
    addMesh(...e) {
        this._hasPatternAnim = null;
        let t = e[0];
        Array.isArray(t) || (t = [ t ]);
        for (let e = 0; e < t.length; e++) this._prepareMesh(t[e]);
        super.addMesh(...e);
    }
    _prepareMesh(e) {
        if (!e.geometry.aLineWidth && e.material.get("lineWidth") <= 0 || !e.geometry.aOpacity && e.material.get("lineOpacity") <= 0) return;
        const t = e.defines;
        this._prepareDashDefines(e, t), e.setDefines(t), e.geometry.properties.hasPatternAnim && (this._hasPatternAnim = 1);
    }
    _prepareDashDefines(e, t) {
        const n = e.geometry, i = this.getSymbol(e.properties.symbolIndex);
        n.data.aDasharray || Array.isArray(i.lineDasharray) && i.lineDasharray.reduce(((e, t) => e + t), 0) > 0 ? (t.HAS_DASHARRAY = 1, 
        n.data.aDasharray && (t.HAS_DASHARRAY_ATTR = 1), n.data.aDashColor && (t.HAS_DASHARRAY_COLOR = 1)) : t.HAS_DASHARRAY && delete t.HAS_DASHARRAY;
    }
    setLineUniforms(e, t) {
        Xe(t, "lineWidth", e, "lineWidth", 2), Xe(t, "lineOpacity", e, "lineOpacity", 1), 
        Xe(t, "lineStrokeWidth", e, "lineStrokeWidth", 0), Xe(t, "lineBlur", e, "lineBlur", .7), 
        Xe(t, "lineOffset", e, "lineOffset", 0), Xe(t, "lineDx", e, "lineDx", 0), Xe(t, "lineDy", e, "lineDy", 0), 
        Xe(t, "linePatternAnimSpeed", e, "linePatternAnimSpeed", 0), Xe(t, "linePatternGap", e, "linePatternGap", 0);
    }
    setMeshDefines(e, t, n) {
        t.data.aOpacity && (e.HAS_OPACITY = 1), t.data.aLineWidth && (e.HAS_LINE_WIDTH = 1), 
        t.data.aLineStrokeWidth && (e.HAS_STROKE_WIDTH = 1), en(n.lineDx) && (e.HAS_LINE_DX = 1), 
        en(n.lineDy) && (e.HAS_LINE_DY = 1), en(n.linePatternAnimSpeed) && (e.HAS_PATTERN_ANIM = 1), 
        en(n.linePatternGap) && (e.HAS_PATTERN_GAP = 1);
    }
    paint(e) {
        this.isShadowIncludeChanged(e) && (this.shader.dispose(), this.createShader(e)), 
        super.paint(e);
    }
    createFnTypeConfig(t, n) {
        const i = O(n.lineColor), r = O(n.aLinePatternAnimSpeed), s = O(n.aLinePatternGap), o = this.createShapeFnTypeConfigs(t, n), a = new Int8Array(2);
        return [ {
            attrName: "aColor",
            symbolName: "lineColor",
            type: Uint8Array,
            width: 4,
            define: "HAS_COLOR",
            evaluate: (n, r) => {
                const s = e.MapStateCache[t.id], o = s ? s.zoom : t.getZoom();
                let a = i(o, n);
                return k(a) && (a = this.evaluateInFnTypeConfig(a, r, t, n, !0)), Array.isArray(a) || (a = this.colorCache[a] = this.colorCache[a] || I(a).unitArray()), 
                a = qe(a), a;
            }
        }, {
            attrName: "aLinePattern",
            symbolName: "linePatternAnimSpeed",
            type: Int8Array,
            width: 2,
            related: [ "linePatternGap" ],
            define: "HAS_LINE_PATTERN",
            evaluate: (n, i, s, o) => {
                const l = e.MapStateCache[t.id], h = l ? l.zoom : t.getZoom();
                let c = r(h, n);
                return je(c) && (c = 0), 0 !== c && (i.properties.hasPatternAnim = 1), a[0] = c / 127, 
                a[1] = s[o + 1], a;
            }
        }, {
            attrName: "aLinePattern",
            symbolName: "linePatternGap",
            type: Int8Array,
            width: 2,
            related: [ "linePatternAnimSpeed" ],
            define: "HAS_LINE_PATTERN",
            evaluate: (n, i, r, o) => {
                const l = e.MapStateCache[t.id], h = l ? l.zoom : t.getZoom();
                let c = s(h, n);
                return je(c) && (c = 0), a[1] = 10 * c, a[0] = r[o], a;
            }
        } ].concat(o);
    }
    createShapeFnTypeConfigs(t, n) {
        const i = F(n.lineWidth), r = F(n.lineOpacity), s = F(n.lineStrokeWidth), o = F(n.lineDx), a = F(n.lineDy), l = new Uint16Array(1), h = new Int8Array(1);
        return [ {
            attrName: "aLineWidth",
            symbolName: "lineWidth",
            type: Uint8Array,
            width: 1,
            define: "HAS_LINE_WIDTH",
            evaluate: (n, r) => {
                const s = e.MapStateCache[t.id], o = s ? s.zoom : t.getZoom();
                let a = i(o, n);
                return k(a) && (a = this.evaluateInFnTypeConfig(a, r, t, n)), l[0] = Math.round(2 * a), 
                l[0];
            }
        }, {
            attrName: "aLineStrokeWidth",
            symbolName: "lineStrokeWidth",
            type: Uint8Array,
            width: 1,
            define: "HAS_STROKE_WIDTH",
            evaluate: n => {
                const i = e.MapStateCache[t.id], r = i ? i.zoom : t.getZoom(), o = s(r, n);
                return l[0] = Math.round(2 * o), l[0];
            }
        }, {
            attrName: "aLineDxDy",
            symbolName: "lineDx",
            type: Int8Array,
            width: 2,
            index: 0,
            define: "HAS_LINE_DX",
            evaluate: n => {
                const i = e.MapStateCache[t.id], r = i ? i.zoom : t.getZoom(), s = o(r, n);
                return h[0] = s, h[0];
            }
        }, {
            attrName: "aLineDxDy",
            symbolName: "lineDy",
            type: Int8Array,
            width: 2,
            index: 1,
            define: "HAS_LINE_DY",
            evaluate: n => {
                const i = e.MapStateCache[t.id], r = i ? i.zoom : t.getZoom(), s = a(r, n);
                return h[0] = s, h[0];
            }
        }, {
            attrName: "aOpacity",
            symbolName: "lineOpacity",
            type: Uint8Array,
            width: 1,
            define: "HAS_OPACITY",
            evaluate: (n, i) => {
                const s = e.MapStateCache[t.id], o = s ? s.zoom : t.getZoom();
                let a = r(o, n);
                return k(a) && (a = this.evaluateInFnTypeConfig(a, i, t, n)), l[0] = 255 * a, l[0];
            }
        } ];
    }
    updateSceneConfig(e) {
        e.trailAnimation && this.createShader(this._context);
    }
    init(t) {
        const n = this.regl;
        if (this.renderer = new g.Renderer(n), this.createShader(t), this.pickingFBO) {
            const t = this.layer instanceof e.TileLayer, n = {
                PICKING_MODE: 1
            };
            n.LINESOFAR_TYPE = t ? "u32" : "f32", this.picking = [ new g.FBORayPicking(this.renderer, {
                name: "line-picking",
                vert: ri,
                wgslVert: A("vt_line_vert"),
                defines: n,
                uniforms: [ {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(e, t) {
                        const n = [];
                        return y.multiply(n, t.projViewMatrix, t.modelMatrix), n;
                    }
                } ],
                extraCommandProps: this.getExtraCommandProps()
            }, this.pickingFBO, this.getMap()) ];
        }
    }
    createShader(e) {
        this._context = e;
        const t = [], n = {};
        this.fillIncludes(n, t, e), this.sceneConfig.trailAnimation && this.sceneConfig.trailAnimation.enable && (n.HAS_TRAIL = 1);
        const i = [];
        t.push({
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, t) {
                return y.multiply(i, t.projViewMatrix, t.modelMatrix), i;
            }
        });
        const r = this.layer.isVectorTileLayer;
        n.LINESOFAR_TYPE = r ? "u32" : "f32", this.shader = new g.MeshShader({
            name: "vt-line",
            vert: ri,
            frag: "#define SHADER_NAME LINE\n#define DEVICE_PIXEL_RATIO 1.0\nprecision highp float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\nuniform lowp float blendSrcIsOne;\nuniform lowp float lineBlur;\nuniform float isRenderingTerrain;\n#ifdef HAS_COLOR\nvarying vec4 vColor;\n#else\nuniform lowp vec4 lineColor;\n#endif\n#include <highlight_frag>\n#ifdef HAS_STROKE_COLOR\nvarying vec4 vStrokeColor;\n#else\nuniform lowp vec4 lineStrokeColor;\n#endif\n#ifdef HAS_OPACITY\nvarying float vOpacity;\n#else\nuniform lowp float lineOpacity;\n#endif\nuniform float layerOpacity;\n#ifdef HAS_PATTERN\nuniform sampler2D linePatternFile;\nuniform vec2 atlasSize;\nuniform float flipY;\n#ifdef HAS_PATTERN_ANIM\nvarying float vLinePatternAnimSpeed;\n#else\nuniform float linePatternAnimSpeed;\n#endif\n#ifdef HAS_PATTERN_GAP\nvarying float vLinePatternGap;\n#else\nuniform float linePatternGap;\n#endif\nuniform vec4 linePatterGapColor;\nvarying vec4 vTexInfo;\nvec2 c(vec2 d) {\n  vec2 e = mod(d, 1.);\n  vec2 f = vTexInfo.xy;\n  vec2 h = vTexInfo.zw;\n  return (f + e * h) / atlasSize;\n}\n#endif\nvarying vec2 vNormal;\nvarying vec2 vWidth;\nvarying float vGammaScale;\n#ifndef ENABLE_TILE_STENCIL\nvarying vec2 vPosition;\n#endif\nuniform float tileExtent;\n#ifdef HAS_DASHARRAY\n#ifdef HAS_DASHARRAY_ATTR\nvarying vec4 vDasharray;\n#else\nuniform vec4 lineDasharray;\n#endif\n#ifdef HAS_DASHARRAY_COLOR\nvarying vec4 vDashColor;\n#else\nuniform vec4 lineDashColor;\n#endif\n#endif\n#if defined(HAS_PATTERN) || defined(HAS_DASHARRAY) || defined(HAS_GRADIENT) || defined(HAS_TRAIL)\nvarying highp float vLinesofar;\n#endif\n#ifdef HAS_TRAIL\nuniform float trailSpeed;\nuniform float trailLength;\nuniform float trailCircle;\n#endif\n#if defined(HAS_TRAIL) || defined(HAS_PATTERN)\nuniform float currentTime;\n#endif\nfloat i(float j, float k) {\n  float l = k / 2.;\n  float m = abs(j - l);\n  float n = (.1 + 1. / DEVICE_PIXEL_RATIO) * vGammaScale;\n  return clamp(min(m + n, l - m) / n, .0, 1.);\n}\nvarying vec3 vVertex;\nuniform vec3 cameraPosition;\nuniform float cameraToCenterDistance;\nuniform float fogFactor;\nvoid main() {\n  \n#ifndef ENABLE_TILE_STENCIL\nfloat o = sign(tileExtent - min(tileExtent, abs(vPosition.x))) * sign(1. + sign(vPosition.x)) * sign(tileExtent - min(tileExtent, abs(vPosition.y))) * sign(1. + sign(vPosition.y));\n  if(o == .0) {\n    discard;\n  }\n#endif\n#if defined(HAS_PATTERN) || defined(HAS_DASHARRAY) || defined(HAS_GRADIENT) || defined(HAS_TRAIL)\nfloat u = vLinesofar;\n#endif\nfloat v = length(vNormal) * vWidth.s;\n#ifdef HAS_PATTERN\nvec2 h = vTexInfo.zw;\n  float A = sign(h.x * h.y);\n  float B = mix(lineBlur, .0, A);\n#else\nfloat B = lineBlur;\n#endif\nfloat n = (B + 1. / DEVICE_PIXEL_RATIO) * vGammaScale;\n  float C = clamp(min(v - (vWidth.t - n), vWidth.s - v) / n, .0, 1.);\n  if(lineBlur == .0) {\n    C = 1.;\n  }\n#ifdef HAS_COLOR\nvec4 D = vColor / 255.;\n#else\nvec4 D = lineColor;\n#endif\n#ifdef HAS_PATTERN\nif(A == 1.) {\n    \n#ifdef HAS_PATTERN_GAP\nfloat E = vLinePatternGap;\n#else\nfloat E = linePatternGap;\n#endif\n#ifdef HAS_PATTERN_ANIM\nfloat F = vLinePatternAnimSpeed;\n#else\nfloat F = linePatternAnimSpeed;\n#endif\nfloat G = h.x * vWidth.s * 2. / h.y;\n    float H = G * (1. + E);\n    u += mod(currentTime * -F * .2, H);\n    float I = mod(u / H, 1.);\n    float J = mod((flipY * vNormal.y + 1.) / 2., 1.);\n    vec4 K = texture2D(linePatternFile, c(vec2(I * (1. + E), J)));\n    float L = clamp(sign(1. / (1. + E) - I) + .000001, .0, 1.);\n    K = mix(linePatterGapColor, K, L);\n    D *= K;\n  }\n#endif\n#ifdef HAS_DASHARRAY\n#ifdef HAS_DASHARRAY_ATTR\nvec4 M = vDasharray;\n#else\nvec4 M = lineDasharray;\n#endif\n#ifdef HAS_DASHARRAY_COLOR\nvec4 N = vDashColor;\n#else\nvec4 N = lineDashColor;\n#endif\nfloat k = M[0] + M[1] + M[2] + M[3];\n  float j = mod(u, k);\n  float O = max(sign(M[0] - j), .0);\n  float P = j - M[0] - M[1];\n  float Q = max(sign(P), .0) * max(sign(M[2] - P), .0);\n  float R = O + Q;\n  float S = i(j, M[0]);\n  float T = i(P, M[2]);\n  float U = S * O + T * Q;\n  D = D * (1. - U) + N * U;\n#endif\n#ifdef HAS_STROKE_COLOR\nvec4 V = vStrokeColor / 255.;\n#else\nvec4 V = lineStrokeColor;\n#endif\nV = mix(D, V, sign(vWidth.t));\n  D = V * C + max(sign(vWidth.t - v), .0) * D * (1. - C);\n#ifdef HAS_TRAIL\nfloat W = mod(u - currentTime * trailSpeed * .1, trailCircle);\n  float X = W < trailLength ? mix(.0, 1., W / trailLength) : .0;\n  D *= X;\n#endif\n#ifdef HAS_OPACITY\nfloat Y = vOpacity;\n#else\nfloat Y = lineOpacity;\n#endif\ngl_FragColor = D * Y * layerOpacity;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat Z = shadow_computeShadow();\n  gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, Z);\n#endif\nfloat ba;\n  if(isRenderingTerrain == 1.) {\n    ba = 1.;\n  } else {\n    ba = clamp(cameraToCenterDistance * 1.5 / distance(vVertex, cameraPosition), .0, 1.);\n  }\n  gl_FragColor *= ba;\n  gl_FragColor = highlight_blendColor(gl_FragColor);\n  if(fogFactor > .0) {\n    vec3 bb = vec3(vVertex[0] - cameraPosition[0], vVertex[1] - cameraPosition[1], vVertex[2] - cameraPosition[2]);\n    float bc = length(bb);\n    float bd = clamp(1. - (bc * 1.2) / fogFactor, .0, 1.);\n    gl_FragColor *= bd;\n  }\n}",
            wgslVert: A("vt_line_vert"),
            wgslFrag: A("vt_line_frag"),
            uniforms: t,
            defines: n,
            extraCommandProps: this.getExtraCommandProps(e)
        });
    }
    isEnableTileStencil(e) {
        return !!!(e && e.isRenderingTerrain && this.isTerrainSkin());
    }
    getExtraCommandProps() {
        const e = this.canvas;
        return {
            viewport: {
                x: (e, t) => t.viewport ? t.viewport.x : 0,
                y: (e, t) => t.viewport ? t.viewport.y : 0,
                width: (t, n) => n.viewport ? n.viewport.width : e ? e.width : 1,
                height: (t, n) => n.viewport ? n.viewport.height : e ? e.height : 1
            },
            stencil: {
                enable: (e, t) => this.isEnableTileStencil(t.painterContext),
                func: {
                    cmp: () => "<=",
                    ref: (e, t) => t.stencilRef
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            depth: {
                enable: !0,
                range: this.sceneConfig.depthRange || [ 0, 1 ],
                mask: this.sceneConfig.depthMask || !1,
                func: this.sceneConfig.depthFunc || "<="
            },
            blend: {
                enable: !0,
                func: this.getBlendFunc(),
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        };
    }
    limitMeshDefines(e) {
        let t = e.defines;
        t = function(e, t) {
            return Bn(e, t, Wn, Xn, 2);
        }(this.regl, t), e.setDefines(t);
    }
    getUniformValues(e, t) {
        const n = t && t.isRenderingTerrainSkin, i = this.layer.getTileSize().width, r = n ? si : e.projViewMatrix, s = e.viewMatrix, o = e.cameraToCenterDistance, a = e.getResolution(), l = T.set(oi, e.width, e.height);
        n && T.set(l, i, i);
        const h = this.getBlendFunc().src(), c = this.sceneConfig.trailAnimation || {}, u = {
            layerScale: this.layer.options.styleScale || 1,
            projViewMatrix: r,
            viewMatrix: s,
            cameraToCenterDistance: o,
            resolution: a,
            canvasSize: l,
            trailSpeed: c.speed || 1,
            trailLength: c.trailLength || 500,
            trailCircle: c.trailCircle || 1e3,
            currentTime: this.layer.getRenderer().getFrameTimestamp() || 0,
            blendSrcIsOne: +!(1 !== h && "one" !== h),
            cameraPosition: e.cameraPosition,
            viewport: n && t && t.viewport,
            isRenderingTerrain: +!!n,
            fogFactor: this.layer.options.fogFactor || 0
        };
        return this.setIncludeUniformValues(u, t), u;
    }
}

const li = {
    markerFile: {
        type: "identity",
        default: null,
        property: "_symbol_markerFile"
    },
    markerWidth: {
        type: "identity",
        default: null,
        property: "_symbol_markerWidth"
    },
    markerHeight: {
        type: "identity",
        default: null,
        property: "_symbol_markerHeight"
    },
    markerPathWidth: {
        type: "identity",
        default: 20,
        property: "_symbol_markerPathWidth"
    },
    markerPathHeight: {
        type: "identity",
        default: 20,
        property: "_symbol_markerPathHeight"
    },
    markerDx: {
        type: "identity",
        default: null,
        property: "_symbol_markerDx"
    },
    markerDy: {
        type: "identity",
        default: null,
        property: "_symbol_markerDy"
    },
    markerType: {
        type: "identity",
        default: null,
        property: "_symbol_markerType"
    },
    markerPath: {
        type: "identity",
        default: null,
        property: "_symbol_markerPath"
    },
    markerFill: {
        type: "identity",
        default: null,
        property: "_symbol_markerFill"
    },
    markerFillPatternFile: {
        type: "identity",
        default: null,
        property: "_symbol_markerFillPatternFile"
    },
    markerFillOpacity: {
        type: "identity",
        default: null,
        property: "_symbol_markerFillOpacity"
    },
    markerLineColor: {
        type: "identity",
        default: null,
        property: "_symbol_markerLineColor"
    },
    markerLineWidth: {
        type: "identity",
        default: null,
        property: "_symbol_markerLineWidth"
    },
    markerLineOpacity: {
        type: "identity",
        default: null,
        property: "_symbol_markerLineOpacity"
    },
    markerLineDasharray: {
        type: "identity",
        default: null,
        property: "_symbol_markerLineDasharray"
    },
    markerLinePatternFile: {
        type: "identity",
        default: null,
        property: "_symbol_markerLinePatternFile"
    },
    markerVerticalAlignment: {
        type: "identity",
        default: null,
        property: "_symbol_markerVerticalAlignment"
    },
    markerHorizontalAlignment: {
        type: "identity",
        default: "middle",
        property: "_symbol_markerHorizontalAlignment"
    },
    markerOpacity: {
        type: "identity",
        default: 1,
        property: "_symbol_markerOpacity"
    },
    markerPitchAlignment: {
        type: "identity",
        default: "viewport",
        property: "_symbol_markerPitchAlignment"
    },
    markerRotationAlignment: {
        type: "identity",
        default: "viewport",
        property: "_symbol_markerRotationAlignment"
    },
    markerRotation: {
        type: "identity",
        default: 0,
        property: "_symbol_markerRotation"
    },
    markerAllowOverlap: {
        type: "identity",
        default: 0,
        property: "_symbol_markerAllowOverlap"
    },
    markerIgnorePlacement: {
        type: "identity",
        default: 0,
        property: "_symbol_markerIgnorePlacement"
    },
    markerTextFit: {
        type: "identity",
        default: null,
        property: "_symbol_markerTextFit"
    },
    markerSpacing: {
        type: "identity",
        default: 250,
        property: "_symbol_markerSpacing"
    },
    markerTextFitPadding: {
        type: "identity",
        default: null,
        property: "_symbol_markerTextFitPadding"
    },
    markerPlacement: {
        type: "identity",
        default: "point",
        property: "_symbol_markerPlacement"
    }
}, hi = {
    textName: {
        type: "identity",
        default: null,
        property: "_symbol_textName"
    },
    textFaceName: {
        type: "identity",
        default: null,
        property: "_symbol_textFaceName"
    },
    textWrapWidth: {
        type: "identity",
        default: null,
        property: "_symbol_textWrapWidth"
    },
    textHorizontalAlignment: {
        type: "identity",
        default: null,
        property: "_symbol_textHorizontalAlignment"
    },
    textVerticalAlignment: {
        type: "identity",
        default: null,
        property: "_symbol_textVerticalAlignment"
    },
    textFill: {
        type: "identity",
        default: null,
        property: "_symbol_textFill"
    },
    textSize: {
        type: "identity",
        default: null,
        property: "_symbol_textSize"
    },
    textHaloRadius: {
        type: "identity",
        default: null,
        property: "_symbol_textHaloRadius"
    },
    textHaloFill: {
        type: "identity",
        default: null,
        property: "_symbol_textHaloFill"
    },
    textHaloOpacity: {
        type: "identity",
        default: 255,
        property: "_symbol_textHaloOpacity"
    },
    textDx: {
        type: "identity",
        default: 0,
        property: "_symbol_textDx"
    },
    textDy: {
        type: "identity",
        default: 0,
        property: "_symbol_textDy"
    },
    textOpacity: {
        type: "identity",
        default: 1,
        property: "_symbol_textOpacity"
    },
    textPitchAlignment: {
        type: "identity",
        default: "viewport",
        property: "_symbol_textPitchAlignment"
    },
    textRotationAlignment: {
        type: "identity",
        default: "viewport",
        property: "_symbol_textRotationAlignment"
    },
    textRotation: {
        type: "identity",
        default: 0,
        property: "_symbol_textRotation"
    },
    textAllowOverlap: {
        type: "identity",
        default: 0,
        property: "_symbol_textAllowOverlap"
    },
    textIgnorePlacement: {
        type: "identity",
        default: 0,
        property: "_symbol_textIgnorePlacement"
    },
    textSpacing: {
        type: "identity",
        default: 250,
        property: "_symbol_textSpacing"
    },
    textPlacement: {
        type: "identity",
        default: "point",
        property: "_symbol_textPlacement"
    }
}, ci = {
    lineWidth: {
        type: "identity",
        default: 2,
        property: "_symbol_lineWidth"
    },
    lineStrokeWidth: {
        type: "identity",
        default: 0,
        property: "_symbol_lineStrokeWidth"
    },
    lineColor: {
        type: "identity",
        default: [ 1, 1, 1, 1 ],
        property: "_symbol_lineColor"
    },
    lineStrokeColor: {
        type: "identity",
        default: [ 0, 0, 0, 0 ],
        property: "_symbol_lineStrokeColor"
    },
    lineDx: {
        type: "identity",
        default: 0,
        property: "_symbol_lineDx"
    },
    lineDy: {
        type: "identity",
        default: 0,
        property: "_symbol_lineDy"
    },
    linePatternFile: {
        type: "identity",
        default: null,
        property: "_symbol_linePatternFile"
    },
    linePatternAnimSpeed: {
        type: "identity",
        default: 0,
        property: "_symbol_linePatternAnimSpeed"
    },
    linePatternGap: {
        type: "identity",
        default: 0,
        property: "_symbol_linePatternGap"
    },
    lineOpacity: {
        type: "identity",
        default: 1,
        property: "_symbol_lineOpacity"
    },
    lineJoin: {
        type: "identity",
        default: null,
        property: "_symbol_lineJoin"
    },
    lineCap: {
        type: "identity",
        default: null,
        property: "_symbol_lineCap"
    },
    lineDasharray: {
        type: "identity",
        default: null,
        property: "_symbol_lineDasharray"
    },
    lineDashColor: {
        type: "identity",
        default: null,
        property: "_symbol_lineDashColor"
    }
}, ui = "_line_gradient_property", {PackUtil: fi} = q(), di = new e.Point(0, 0), pi = "_vector3dlayer_id", gi = (ui + "").trim();

function mi(t, n, i) {
    let r = !se(n.visible), s = !se(n.opacity), o = n;
    (r || s) && (o = e.MapboxUtil.loadGeoSymbol(n, i)), Object.defineProperty(t, "getVisible", {
        get: function() {
            if (!r && !s) {
                return i.options.visible;
            }
            if (!i.isVisible()) return !1;
            const e = o.visible;
            return !1 !== e && 0 !== e;
        }
    });
}

function yi(t, n, i) {
    const r = (Ce + "").trim(), s = t.getMap(), o = s.getGLRes();
    let a = t.getCoordinates();
    const l = [], h = [];
    let c = 1;
    if (t instanceof e.Marker || t instanceof e.MultiPoint) {
        t instanceof e.Marker && (a = [ a ]);
        for (let e = 0; e < a.length; e++) s.coordToPointAtRes(a[e], o, di), l.push([ di.x, di.y, a[e].z || 0 ]), 
        h.push([ a[e].x, a[e].y ]);
    } else if (t instanceof e.LineString || t instanceof e.MultiLineString) {
        c = 2, t instanceof e.LineString && (a = [ a ]);
        for (let e = 0; e < a.length; e++) {
            l[e] = [], h[e] = [];
            for (let t = 0; t < a[e].length; t++) s.coordToPointAtRes(a[e][t], o, di), l[e].push([ di.x, di.y, a[e][t].z || 0 ]), 
            h[e].push([ a[e][t].x, a[e][t].y ]);
        }
    } else if (t instanceof e.Polygon || t instanceof e.MultiPolygon) {
        c = 3, t instanceof e.Circle || t instanceof e.Rectangle || t instanceof e.Ellipse || t instanceof e.Sector ? a = [ [ t.getShell() ] ] : t instanceof e.Polygon && (a = [ a ]);
        let n = 0;
        for (let e = 0; e < a.length; e++) {
            let t = !1;
            for (let i = 0; i < a[e].length; i++) {
                if (l[n] = [], h[n] = [], t) for (let t = a[e][i].length - 1; t >= 0; t--) s.coordToPointAtRes(a[e][i][t], o, di), 
                l[n].push([ di.x, di.y, a[e][i][t].z || 0 ]), h[n].push([ a[e][i][t].x, a[e][i][t].y ]); else for (let t = 0; t < a[e][i].length; t++) s.coordToPointAtRes(a[e][i][t], o, di), 
                l[n].push([ di.x, di.y, a[e][i][t].z || 0 ]), h[n].push([ a[e][i][t].x, a[e][i][t].y ]);
                0 === i && (t = fi.calculateSignedArea(l[n]) < 0, t && (l[n] = l[n].reverse(), h[n] = h[n].reverse())), 
                n++;
            }
        }
    }
    const u = t.getProperties() ? Object.assign({}, t.getProperties()) : {}, f = t._getInternalSymbol() || function(t) {
        if (t instanceof e.Marker || t instanceof e.MultiPoint) return {
            markerType: "ellipse",
            markerWidth: 8,
            markerHeight: 0,
            markerFill: "#000"
        };
        if (t instanceof e.LineString || t instanceof e.MultiLineString) return {
            lineColor: "#000",
            lineWidth: 1
        };
        if (t instanceof e.Polygon || t instanceof e.MultiPolygon) return {
            polygonFill: "#fff",
            lineColor: "#000",
            lineWidth: 1
        };
    }(t), d = i ? Array.isArray(i) ? i[0].id : i.id : n.id++;
    if (Array.isArray(f) && f.length) {
        const e = [], s = f.length;
        for (let o = 0; o < s; o++) {
            const a = o === s - 1 ? u : ee({}, u), p = xi(f[o], a);
            for (const e in f[o]) if (le(f[o], e)) {
                a[("_symbol_" + e).trim()] = f[o][e];
            }
            p && (f[o].lineGradientProperty = p);
            const g = i && i[o] ? i[o][r] : n.pickingId++, m = {
                type: c,
                id: d,
                properties: a,
                visible: t.isVisible(),
                geometry: l,
                coordinates: h,
                extent: 1 / 0
            };
            mi(m, f[o], t), m[r] = g, e.push(m);
        }
        return e;
    }
    if (f) {
        const e = xi(f, u);
        for (const e in f) if (le(f, e)) {
            u[("_symbol_" + e).trim()] = f[e];
        }
        e && (f.lineGradientProperty = e);
    }
    const p = i ? i.id : n.pickingId++, g = {
        type: c,
        id: d,
        properties: u,
        visible: t.isVisible(),
        geometry: l,
        coordinates: h,
        extent: 1 / 0
    };
    return mi(g, f, t), g[r] = p, g;
}

function xi(e, t) {
    const n = e.lineGradientProperty;
    return n && (t[gi] = t[n], t.mapbox_clip_start = 0, t.mapbox_clip_end = 1, delete t[n]), 
    n;
}

class _i extends ai {
    postCreateGeometry(e) {
        this.generateGradProperties(e);
    }
    startFrame(...e) {
        super.startFrame(...e), this._updateMeshGradient();
    }
    _updateMeshGradient() {
        if (this._changedMeshes) {
            for (let e = 0; e < this._changedMeshes.length; e++) {
                if (!this._changedMeshes[e] || !this._changedMeshes[e].isValid()) continue;
                const {geometry: t, material: n} = this._changedMeshes[e], {symbolIndex: i} = t.properties;
                this.generateGradProperties({
                    geometry: t,
                    symbolIndex: i
                });
                const r = this._genGradientTexture(t.properties.gradients), s = n.get("lineGradientTexture");
                s && s.destroy(), t.generateBuffers(this.regl), n.set("lineGradientTexture", r), 
                n.set("lineGradientTextureHeight", r.height);
            }
            delete this._changedMeshes;
        }
    }
    onFeatureChange(e, t) {
        this._changedMeshes || (this._changedMeshes = []);
        for (let n = 0; n < t.length; n++) {
            if (!t[n] || !t[n].isValid()) continue;
            const i = t[n].geometry, {features: r} = i.properties;
            if (!r) continue;
            const s = e && e[pi];
            r[s] && (r[s].feature.properties[ui] = e.properties[ui], this._changedMeshes.push(t[n]), 
            this.setToRedraw());
        }
    }
    needRebuildOnGometryPropertiesChanged() {
        return !1;
    }
    generateGradProperties(e) {
        const {symbolIndex: t, geometry: n} = e, {features: i} = n.properties, r = this.getSymbol(t).lineGradientProperty, s = n.properties.aPickingId || n.data.aPickingId, o = new Uint8Array(s.length), a = [], l = new Map;
        function h(e) {
            let t = e && e[r];
            Array.isArray(t) || (t = [ 0, "black", 1, "black" ]);
            let n, i = t.join();
            return l.has(i) ? n = l.get(i) : (n = a.length, l.set(i, n), a.push(t)), n;
        }
        let c = s[0], u = i[c].feature.properties, f = h(u);
        for (let e = 1; e < s.length; e++) s[e] !== c && (c = s[e], u = i[c].feature.properties, 
        f = h(u)), o[e] = f;
        if (n.data.aGradIndex) {
            const e = n.data.aGradIndex;
            e && e.buffer && e.buffer.destroy && e.buffer.destroy();
        }
        n.data.aGradIndex = o, n.properties.gradients = a;
    }
    createMesh(e, t) {
        const {geometry: n, symbolIndex: i, ref: r} = e, s = this.getSymbolDef(i);
        if (void 0 === r) {
            Gt(n, s, this.getFnTypeConfig(i), this.layer);
        }
        const o = {
            tileResolution: n.properties.tileResolution,
            tileRatio: n.properties.tileRatio,
            tileExtent: n.properties.tileExtent
        }, a = this.getSymbol(i);
        this.setLineUniforms(a, o);
        const l = this._genGradientTexture(n.properties.gradients);
        o.lineGradientTexture = l, o.lineGradientTextureHeight = l.height, void 0 === r && n.generateBuffers(this.regl);
        const h = new g.Material(o), c = new g.Mesh(n, h, {
            castShadow: !1,
            picking: !0
        });
        c.setLocalTransform(t);
        const u = {
            HAS_GRADIENT: 1
        };
        return n.data.aAltitude && (u.HAS_ALTITUDE = 1), this.setMeshDefines(u, n, s), c.setDefines(u), 
        c.properties.symbolIndex = i, c;
    }
    _genGradientTexture(e) {
        const t = 2 * e.length;
        return this.regl.texture({
            width: 256,
            height: t,
            data: vi(e),
            format: "rgba",
            mag: "linear",
            min: "linear",
            flipY: !1
        });
    }
    createFnTypeConfig(e, t) {
        return this.createShapeFnTypeConfigs(e, t);
    }
    createShader(t) {
        this._context = t;
        const n = [], i = {};
        this.fillIncludes(i, n, t), this.sceneConfig.trailAnimation && this.sceneConfig.trailAnimation.enable && (i.HAS_TRAIL = 1);
        const r = this.layer instanceof e.TileLayer;
        i.LINESOFAR_TYPE = r ? "u32" : "f32";
        const s = [];
        n.push({
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, t) {
                return y.multiply(s, t.projViewMatrix, t.modelMatrix), s;
            }
        }), this.shader = new g.MeshShader({
            name: "line-gradient",
            vert: ri,
            frag: "#define SHADER_NAME LINE_GRADIENT\n#define DEVICE_PIXEL_RATIO 1.0\n#define MAX_LINE_COUNT 128.0\nprecision mediump float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#ifdef HAS_OPACITY\nvarying float vOpacity;\n#else\nuniform lowp float lineOpacity;\n#endif\nuniform float layerOpacity;\nuniform lowp float lineBlur;\nuniform float lineGradientTextureHeight;\nuniform float tileExtent;\nuniform sampler2D lineGradientTexture;\nvarying vec2 vNormal;\nvarying vec2 vWidth;\nvarying float vGammaScale;\nvarying highp float vLinesofar;\nvarying float vGradIndex;\n#ifndef ENABLE_TILE_STENCIL\nvarying vec2 vPosition;\n#endif\n#ifdef HAS_TRAIL\nuniform float trailSpeed;\nuniform float trailLength;\nuniform float trailCircle;\nuniform float currentTime;\n#endif\n#include <highlight_frag>\nvoid main() {\n  \n#ifndef ENABLE_TILE_STENCIL\nfloat c = sign(tileExtent - min(tileExtent, abs(vPosition.x))) * sign(1. + sign(vPosition.x)) * sign(tileExtent - min(tileExtent, abs(vPosition.y))) * sign(1. + sign(vPosition.y));\n  if(c == .0) {\n    discard;\n  }\n#endif\nfloat d = length(vNormal) * vWidth.s;\n  float e = (lineBlur + 1. / DEVICE_PIXEL_RATIO) * vGammaScale;\n  float f = clamp(min(d - (vWidth.t - e), vWidth.s - d) / e, .0, 1.);\n  float h = vLinesofar;\n  vec4 i = texture2D(lineGradientTexture, vec2(h, (vGradIndex * 2. + .5) / lineGradientTextureHeight)) * f;\n  i *= max(sign(MAX_LINE_COUNT - vGradIndex), .0);\n#ifdef HAS_TRAIL\nfloat j = mod(h - currentTime * trailSpeed * .1, trailCircle);\n  float k = j < trailLength ? mix(.0, 1., j / trailLength) : .0;\n  i *= k;\n#endif\n#ifdef HAS_OPACITY\nfloat l = vOpacity;\n#else\nfloat l = lineOpacity;\n#endif\ngl_FragColor = i * l * layerOpacity;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat m = shadow_computeShadow();\n  gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, m);\n#endif\ngl_FragColor = highlight_blendColor(gl_FragColor);\n}",
            wgslVert: A("vt_line_vert"),
            wgslFrag: A("vt_line_gradient_frag"),
            uniforms: n,
            defines: i,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
}

function vi(e) {
    e.length > 2048 && console.warn(`Gradients count is (${e.length}), it may be slow to render.`);
    const t = document.createElement("canvas"), n = t.getContext("2d");
    t.width = 256, t.height = 2 * e.length;
    for (let t = 0; t < e.length; t++) {
        const i = e[t], r = n.createLinearGradient(0, 0, 256, 0);
        for (let e = 0; e < i.length; e += 2) r.addColorStop(+i[e], i[e + 1]);
        n.fillStyle = r;
        const s = t % 256;
        n.fillRect(0, 2 * s, 256, 2 * s + 2);
    }
    return n.canvas;
}

class bi {
    constructor(e) {
        this._meshes = e || [], this.properties = {};
    }
    set meshes(e) {
        this._meshes = e;
    }
    get meshes() {
        return this._meshes;
    }
}

const Ai = 224, Ti = 600, wi = 100, Si = new Uint8Array(1), Mi = [], Pi = {
    collides: 0,
    boxes: []
}, Ii = [], Ci = [];

class ki extends Rn {
    createGeometry(...t) {
        const n = super.createGeometry(...t);
        if (!n || !n.geometry) return n;
        const {geometry: i} = n, r = t[0];
        i.properties.collideIds = r.featureIds && r.featureIds.length && r.isIdUnique ? r.featureIds : r.data.aPickingId;
        const s = this.layer instanceof e.TileLayer;
        return i.properties.uniqueCollideIds = tt(i.properties.collideIds, !s), n;
    }
    supportRenderMode(e) {
        const t = this.sceneConfig.renderToPointRenderTarget;
        return t || void 0 === t ? "point" === e : "fxaa" === e || "fxaaAfterTaa" === e;
    }
    addMesh(e, t, n) {
        if (e && !this.isEnableCollision()) {
            let t = e;
            Array.isArray(t) || (Ii[0] = e, t = Ii);
            for (let e = 0; e < t.length; e++) {
                const n = t[e].defines;
                delete n.ENABLE_COLLISION, t[e].setDefines(n);
                const {elements: i, visElemts: r} = t[e].geometry.properties;
                r && void 0 !== r.count && r.count !== i.length && (t[e].geometry.setElements(i), 
                r.count = i.length);
            }
        }
        return super.addMesh(e, t, n);
    }
    startMeshCollision(e) {
        const {meshKey: t} = e.properties, {renderer: n} = this._cachedInstances, i = n.isForeground(e instanceof bi ? e.meshes[0] : e);
        if (e.properties.isForeground = i, e instanceof bi && e.meshes.length) for (let t = 0; t < e.meshes.length; t++) e.meshes[t].properties.isForeground = i;
        this._startTime = performance.now(), this._canProceed = this._canProceedCollision(), 
        this._meshCollisionStale = this._isCachedCollisionStale(t);
    }
    endMeshCollision(t) {
        const n = this._collisionContext.tags[t];
        if (this._canProceed && n && this._meshCollisionStale) {
            const t = this.getMap();
            this._anchorCoord0 || (this._anchorCoord0 = new e.Coordinate(0, 0), this._anchorCoord1 = new e.Coordinate(0, 0));
            const i = e.MapStateCache[t.id];
            n.anchor0 = t.containerPointToCoord(this._containerAnchor0, this._anchorCoord0), 
            n.anchor1 = t.containerPointToCoord(this._containerAnchor1, this._anchorCoord1), 
            n.anchor0.z = i ? i.zoom : t.getZoom(), n.anchor0.width = t.width, n.anchor0.height = t.height, 
            n.anchor0.pitch = i ? i.pitch : t.getPitch();
        }
        this.getMap().collisionFrameTime += performance.now() - this._startTime;
    }
    _isCachedCollisionStale(t) {
        const n = this.getMap(), i = e.MapStateCache[n.id], r = i ? i.zoom : n.getZoom(), s = i ? i.pitch : n.getPitch(), [o, a] = this._getMeshAnchor(t);
        return !o || !a || o.z !== r || o.width !== n.width || o.height !== n.height || o.pitch !== s || o.distanceTo(this._containerAnchor0) > 3 || a.distanceTo(this._containerAnchor1) > 3;
    }
    _startCollision() {
        const t = this.getMap();
        this._coordCache = {}, this._containerAnchor0 = new e.Point(t.width / 3, t.height / 2), 
        this._containerAnchor1 = new e.Point(2 * t.width / 3, t.height / 2), delete this._canProceed, 
        this._collisionContext || (this._collisionContext = {
            tags: {}
        });
        const n = e.MapStateCache[t.id];
        this._cachedInstances = {
            layer: this.layer,
            renderer: this.layer.getRenderer(),
            frameTimestamp: this.layer.getRenderer().getFrameTimestamp(),
            map: t,
            zoom: n ? n.zoom : t.getZoom(),
            collisionTags: this._collisionContext.tags,
            isEnableUniquePlacement: this.isEnableUniquePlacement()
        };
    }
    _endCollision() {}
    _getCachedCollision(e, t) {
        const n = this._collisionContext;
        return n.tags[e] && n.tags[e][t];
    }
    _setCollisionCache(e, t, n) {
        const i = this._collisionContext;
        i.tags[e] = i.tags[e] || [], i.tags[e][t] = n;
    }
    _canProceedCollision() {
        const e = this.getMap();
        if (!e.isInteracting()) return !0;
        const t = this.layer.options.collisionFrameLimit;
        return e.collisionFrameTime <= t;
    }
    _getMeshAnchor(e) {
        const t = "__meshAnchorKey".trim(), n = this._collisionContext.tags[e];
        if (n && n.anchor0) {
            const {anchor0: e, anchor1: i} = n, r = e[t] = e[t] || e.x + "," + e.y, s = i[t] = i[t] || i.x + "," + i.y;
            let o = this._coordCache[r], a = this._coordCache[s];
            if (!o || !a) {
                const t = this.getMap();
                o = this._coordCache[r] = t.coordToContainerPoint(e), a = this._coordCache[s] = t.coordToContainerPoint(i);
            }
            return o.z = e.z, Mi[0] = o, Mi[1] = a, o.width = e.width, o.height = e.height, 
            Mi;
        }
        return Mi[0] = Mi[1] = null, Mi;
    }
    updateBoxCollisionFading(e, t, n, i, r) {
        const {layer: s, renderer: o, zoom: a, collisionTags: l, isEnableUniquePlacement: h} = this._cachedInstances, {meshKey: c, isForeground: u} = t.properties;
        if (h && this._isReplacedPlacement(c, r)) return !1;
        const f = n.length;
        let d = l[c] && l[c][r];
        const p = d, g = this._zooming && d;
        if (!(g && 0 !== d.collides) && e) {
            const e = g && 0 === d.collides;
            if (this._canProceed || e) if ((this._meshCollisionStale || d && d.z !== a) && (d = null), 
            d) {
                if (d.boxes && d.boxes.length) {
                    const {boxes: e, isAllowOverlap: t} = d;
                    let n = 0;
                    if (!t) {
                        let t = 0;
                        for (let i = 0; i < e.length; i++) if (!n) {
                            const r = this.isCollides(e[i]);
                            if (-1 === r) t++; else if (1 === r) {
                                n = 1;
                                break;
                            }
                        }
                        t === e.length && (n = -1);
                    }
                    d.collides = n;
                }
            } else {
                d = p || {
                    collides: 0,
                    boxes: []
                }, d.boxes.length = 0, d.z = a;
                let e = 0;
                for (let t = 0; t < f; t++) {
                    const {mesh: s, allElements: o, boxCount: a, start: l, end: h} = n[t], c = this._isBoxVisible(s, o, a, l, h, i, r);
                    c.isAllowOverlap && (d.isAllowOverlap = 1), 0 === e && (e = c.collides), c.boxes && d.boxes.push(...c.boxes);
                }
                d.collides = e, this._setCollisionCache(c, r, d);
            }
        }
        let m = e && d && 0 === d.collides, y = 1, x = !1;
        if (this.sceneConfig.fading) {
            const e = this._getBoxTimestamps(t);
            if (this._zoomingOut) e[r] = m ? 1 : -1; else if (u && delete t._fadeOutStartTime, 
            y = this._getBoxFading(u, m, e, r), u ? (y > 0 && (m = !0), x = this.isBoxFading(t, r), 
            x && this.setToRedraw()) : m || (this._markFadingCollided(e, r), y = 0), m) {
                const n = t._fadeOutStartTime;
                if (n && 1 === y && e[r] > 0) {
                    let {fadeOutDelay: e, fadingDuration: t} = this.sceneConfig;
                    je(t) && (t = Ai), je(e) && (e = wi);
                    const i = Ue(1 - (o.getFrameTimestamp() - n - e) / t, 0, 1);
                    y *= i, i > 0 && this.setToRedraw();
                }
            }
        }
        if (d && s.options.debugCollision && this.addCollisionDebugBox(d.boxes, d.collides ? 0 : 1), 
        m || x) {
            const {mesh: e, start: t} = n[0], i = this.getSymbol(e.properties.symbolIndex);
            !this._isIgnorePlacement(i, e, t) && d && d.boxes && this._fillCollisionIndex(d.boxes, e);
        }
        if (m) {
            const e = Si[0] = 255 * y;
            for (let t = 0; t < f; t++) {
                const {mesh: i, allElements: r, start: s, boxStart: o, end: a, boxIndex: l} = n[t], h = void 0 === o ? s : o;
                this.setCollisionOpacity(i, r, e, h, a, l);
            }
        }
        return m && y > 0;
    }
    isMeshIterable() {
        return !0;
    }
    setCollisionOpacity(e, t, n, i, r) {
        const s = t[i], o = t[r - 1];
        this._updateOpacityData(e, n, s, o);
    }
    _updateOpacityData(e, t, n, i) {
        const {aOpacity: r} = e.geometry.properties;
        if (!r) return;
        const s = n;
        if (r[s] !== t) {
            const e = i;
            for (let n = s; n <= e; n++) r[n] = t;
            r.dirty = !0;
        }
    }
    isBoxFading(e, t) {
        const {frameTimestamp: n} = this._cachedInstances;
        let i = this.sceneConfig.fadingDuration;
        je(i) && (i = Ai);
        return n - Math.abs(this._getBoxTimestamps(e)[t]) < i;
    }
    _isBoxVisible(e, t, n, i, r, s, o) {
        const a = this.getSymbol(e.properties.symbolIndex), l = this._isIgnorePlacement(a, e, t[i]), h = this._isAllowOverlap(a, e, t[i]);
        if (!this.isEnableCollision() || l && h) return Pi;
        const c = this.isBoxCollides(e, t, n, i, r, s, o);
        return h && (c.collides = 0, c.isAllowOverlap = 1), c;
    }
    _isIgnorePlacement(e, t, n) {
        if (!this.isEnableCollision()) return !0;
        const i = t.geometry.properties.aOverlap;
        if (!i) return 1 == +e[this.propIgnorePlacement];
        const r = i[n], s = r % 8;
        return r < 2 ? 1 == +e[this.propIgnorePlacement] : s % 2;
    }
    _isAllowOverlap(e, t, n) {
        if (!this.isEnableCollision()) return !0;
        const i = t.geometry.properties.aOverlap;
        if (!i) return 1 == +e[this.propAllowOverlap];
        const r = i[n], s = r >> 2;
        return r < 2 ? 1 == +e[this.propAllowOverlap] : s % 2;
    }
    _fillCollisionIndex(e) {
        if (Array.isArray(e[0])) for (let t = 0; t < e.length; t++) this.insertCollisionBox(e[t]); else this.insertCollisionBox(e);
    }
    _getBoxFading(e, t, n, i) {
        let {fadingDuration: r, fadeInDelay: s, fadeOutDelay: o} = this.sceneConfig;
        je(r) && (r = Ai), je(s) && (s = Ti), je(o) && (o = wi);
        const {frameTimestamp: a} = this._cachedInstances;
        let l = n[i], h = t ? 1 : 0;
        if (!l) return t && e && (n[i] = a + s), 0;
        if (a < Math.abs(l) && (!t && l > 0 || t && l < 0)) {
            const e = a - r;
            n[i] = l = t ? e : -e;
        }
        return a - Math.abs(l) < r ? h = l > 0 ? (a - l) / r : 1 - (a + l) / r : t ? (l < 0 && (n[i] = l = a + s), 
        h = (a - l) / r) : (l > 0 && (n[i] = l = -(a + o)), h = 1 - (a + l) / r), (h < 0 || h > 1) && (h = Ue(h, 0, 1)), 
        h;
    }
    _getBoxTimestamps(e) {
        this._boxTimestamps || (this._boxTimestamps = {});
        const {meshKey: t} = e.properties;
        if (!this._boxTimestamps[t]) {
            const {frameTimestamp: e} = this._cachedInstances;
            this._boxTimestamps[t] = {
                timestamp: e
            };
        }
        return this._boxTimestamps[t];
    }
    _refreshTimeStamps(e) {
        if (!this._prevTimestamp) return void (this._prevTimestamp = e);
        const t = this.scene.getMeshes();
        if (t && t.length) {
            for (let n = 0; n < t.length; n++) {
                const i = this._getBoxTimestamps(t[n]);
                i.timestamp < this._prevTimestamp ? delete t[n]._fading_timestamps : i.timestamp = e;
            }
            this._prevTimestamp = e;
        }
    }
    _markFadingCollided(e, t) {
        if (!e) return;
        const {frameTimestamp: n} = this._cachedInstances;
        let {fadingDuration: i} = this.sceneConfig;
        je(i) && (i = Ai), e[t] = -(n - i - 1);
    }
    deleteMesh(e, t) {
        if (e) {
            if (Array.isArray(e)) for (let t = 0; t < e.length; t++) {
                const n = e[t].properties.meshKey;
                this._collisionContext && delete this._collisionContext.tags[n], this._boxTimestamps && delete this._boxTimestamps[n];
            } else {
                const t = e.properties.meshKey;
                this._collisionContext && delete this._collisionContext.tags[t], this._boxTimestamps && delete this._boxTimestamps[t];
            }
            super.deleteMesh(e, t);
        }
    }
    delete(e) {
        this._collisionMesh && (this._collisionMesh.geometry.dispose(), this._collisionShader.dispose(), 
        this._collisionMesh.dispose(), delete this._collisionMesh, delete this._collisionShader, 
        delete this._collisionRenderer), delete this._collisionContext, super.delete(e);
    }
    isCollides(t) {
        const n = this.layer, i = n.getMap(), r = e.MapStateCache[i.id], s = r ? r.devicePixelRatio : i.getDevicePixelRatio();
        if (v.scale(Ci, t, 1 / s), i.isOffscreen(Ci)) return -1;
        const o = n.getCollisionIndex(), a = this.sceneConfig.collisionBufferSize || n.options.collisionBufferSize || 0;
        return a && (t = Ei(Ci, t, a)), +o.collides(t);
    }
    insertCollisionBox(e) {
        const t = this.layer, n = t.getCollisionIndex(), i = this.sceneConfig.collisionBufferSize || t.options.collisionBufferSize || 0;
        let r = e;
        i && (r = e._buffered = e._buffered || [], e = Ei(r, e, i)), n.insertBox(r);
    }
    addCollisionDebugBox(e, t) {
        if (e && e.length) if (Array.isArray(e[0])) for (let n = 0; n < e.length; n++) {
            const i = e[n];
            this._addCollisionBox(i, t);
        } else this._addCollisionBox(e, t);
    }
    _addCollisionBox(t, n) {
        if (!t) return;
        const i = this._collisionBoxes = this._collisionBoxes || {
            aPosition: [],
            aVisible: [],
            indices: []
        }, r = this.sceneConfig.collisionBufferSize || this.layer.options.collisionBufferSize || 0;
        r && (t = Ei(Ci, t, r));
        const s = this.getMap(), o = e.MapStateCache[s.id], a = o ? o.devicePixelRatio : s.getDevicePixelRatio();
        if (v.scale(Ci, t, 1 / a), s.isOffscreen(Ci)) return;
        const l = i.aPosition.length / 2;
        i.aPosition.push(t[0], t[1], t[2], t[1], t[2], t[3], t[0], t[3]), i.aVisible.push(n, n, n, n), 
        i.indices.push(l, l + 1, l + 1, l + 2, l + 2, l + 3, l + 3, l);
    }
    updateCollision(e) {
        super.updateCollision(e), this._startCollision(), this._prepareZoomEndMeshes(), 
        this._zoomEndMeshes && this._zoomEndMeshes.length && (this._updateZoomMeshesLevel(), 
        this._zoomEndMeshes && (this.setToRedraw(), this.scene.addMesh(this._zoomEndMeshes)));
        (this.getMap().isZooming() || this._zoomEndMeshes && this._zoomEndMeshes.length) && (this._updateUniquePlacements(), 
        this._mergeUniquePlacements(this.scene.getMeshes()));
    }
    paint(e) {
        const t = super.paint(e);
        return this._renderCollisionBox(e), !1 === this._canProceed && this.setToRedraw(), 
        t;
    }
    shouldIgnoreBackground() {
        return !this.getMap().isZooming() && !this._zoomEndMeshes;
    }
    _prepareZoomEndMeshes() {
        const e = this.getMap(), t = e.isZooming();
        if (!t && this._zooming) {
            const e = this.layer.getRenderer();
            this._zoomEndMeshes = this.scene.getMeshes().filter((t => !e.isForeground(t) && !t.properties.isLinePlacement));
        } else t && !this._zooming && (this._preRes = e.getResolution());
        if (t) this._clearTimeout && (clearTimeout(this._clearTimeout), delete this._zoomingOut, 
        delete this._clearTimeout), this._zoomingOut = this._preRes && e.getResolution() > this._preRes; else if (this._zooming && !this._clearTimeout) {
            let {fadeOutDelay: e, fadingDuration: t} = this.sceneConfig;
            je(e) && (e = wi), je(t) && (t = Ai), this._clearTimeout = setTimeout((() => {
                delete this._zoomingOut, delete this._clearTimeout;
            }), e + t + 1);
        }
        this._zooming = t;
    }
    _renderCollisionBox(e) {
        if (!this._collisionBoxes || !this.layer.options.debugCollision) return;
        this._collisionRenderer || this._initCollisionShader();
        const {aPosition: t, aVisible: n, indices: i} = this._collisionBoxes;
        if (!this._collisionMesh) {
            const e = new g.Geometry({
                aPosition: [],
                aVisible: []
            }, [], 0, {
                positionSize: 2,
                primitive: "lines"
            });
            this._collisionMesh = new g.Mesh(e), this._collisionScene = new g.Scene, this._collisionScene.addMesh(this._collisionMesh);
        }
        const r = this._collisionMesh.geometry;
        r.updateData("aPosition", new Float32Array(t)), r.updateData("aVisible", new Float32Array(n)), 
        r.setElements(i), r.generateBuffers(this.regl), this._collisionRenderer.render(this._collisionShader, {
            size: [ this.canvas.width, this.canvas.height ]
        }, this._collisionScene, this.getRenderFBO(e)), delete this._collisionBoxes;
    }
    _initCollisionShader() {
        const e = this.regl;
        this._collisionRenderer = new g.Renderer(e);
        const t = this.canvas, n = {
            x: 0,
            y: 0,
            width: () => t ? t.width : 1,
            height: () => t ? t.height : 1
        };
        this._collisionShader = new g.MeshShader({
            vert: "attribute vec2 aPosition;\nattribute float aVisible;\nuniform vec2 size;\nvarying vec4 vColor;\nvoid main() {\n  vec2 c = (aPosition / size - .5) * 2. * vec2(1., -1.);\n  gl_Position = vec4(c, .0, 1.);\n  vColor = mix(vec4(1., .0, .0, 1.5) * .5, vec4(.0, 1., .0, 1.) * .4, aVisible);\n}",
            frag: "precision mediump float;\nvarying vec4 vColor;\nvoid main() {\n  gl_FragColor = vec4(vColor.rgb, .5);\n}",
            wgslVert: A("vt_collision_vert"),
            wgslFrag: A("vt_collision_frag"),
            uniforms: [ "size" ],
            extraCommandProps: {
                viewport: n,
                depth: {
                    enable: !1
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "src alpha",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        });
    }
    _updateZoomMeshesLevel() {
        let {fadeOutDelay: e, fadingDuration: t} = this.sceneConfig;
        je(e) && (e = wi), je(t) && (t = Ai);
        const n = this.layer.getRenderer(), i = n.getCurrentTileZoom(), r = n.getFrameTimestamp(), s = [];
        for (let o = 0; o < this._zoomEndMeshes.length; o++) {
            const a = this._zoomEndMeshes[o], l = a.properties.tile;
            !a._fadeOutStartTime && n.isBackTile(l.id) && (a._fadeOutStartTime = r);
            const h = l.z - i > 0 ? 2 * (l.z - i) - 1 : 2 * (i - l.z);
            a.properties.level = h, n.isForeground(a) || a._fadeOutStartTime && r - a._fadeOutStartTime > e + t ? delete a._fadeOutStartTime : s.push(a);
        }
        delete this._zoomEndMeshes, s.length && (this._zoomEndMeshes = s);
    }
    isEnableCollision() {
        return this.layer.options.collision && !!this.sceneConfig.collision;
    }
    isEnableUniquePlacement() {
        return this.isEnableCollision() && this.sceneConfig.uniquePlacement;
    }
    isMeshUniquePlaced(e) {
        return this.isMeshIterable(e);
    }
    _updateUniquePlacements() {
        if (!this.isEnableUniquePlacement()) return;
        const e = this.scene.getMeshes(), t = (e, t, n, i) => {
            const {start: r, end: s} = t[0], o = e.geometry.properties, a = o.elements;
            let l = o.uniquePlacements;
            if (l || (l = o.uniquePlacements = []), void 0 === l[i]) {
                const t = this.getUniqueEntryKey(e, a[r], i);
                l[i] = t ? {
                    key: t,
                    index: i,
                    start: a[r],
                    end: a[s - 1]
                } : null;
            }
        };
        for (let n = 0; n < e.length; n++) {
            const i = e[n];
            this.isMeshUniquePlaced(i) && this.forEachBox(i, t);
        }
    }
    _mergeUniquePlacements(t) {
        if (!this.isEnableUniquePlacement()) return;
        const n = this.getMap(), i = e.MapStateCache[n.id], r = i ? i.zoom : n.getZoom();
        let s = !this._mergedMeshes || this._mergedMehesZoom !== r;
        if (!s) for (let e = 0; e < t.length; e++) if (!this._mergedMeshes[t[e].properties.meshKey]) {
            s = !0;
            break;
        }
        if (!s) return;
        this._mergedMehesZoom = r, this._replacedPlacements = {}, this._mergedMeshes = {}, 
        t = t.sort(Ri);
        const o = this.getMap().getGLScale(), a = {};
        for (let e = 0; e < t.length; e++) {
            const n = t[e];
            if (!n.geometry) continue;
            const {meshKey: i} = n.properties;
            this._mergedMeshes[i] = 1;
            const {uniquePlacements: r} = n.geometry.properties;
            if (r) for (let e = 0; e < r.length; e++) {
                if (!r[e]) continue;
                const {key: t, index: i} = r[e], s = this._getBoxTimestamps(n), l = Oi(t, o), h = a[l];
                if (h) {
                    const e = h.length, t = h[e - 3].properties.meshKey, r = h[e - 2], o = h[e - 1];
                    this._replacedPlacements[t] = this._replacedPlacements[t] || {}, this._replacedPlacements[t][o] = 1, 
                    this._updatePlacementStamps(s, i, r, o), h.push(n, s, i);
                } else a[l] = [ n, s, i ];
            }
        }
        for (const e in a) {
            const t = a[e];
            if (t.length <= 6) continue;
            const n = t.length, i = t[n - 2][t[n - 1]];
            if (t[1][t[2]] !== i) for (let e = 0; e < n - 6; e += 3) {
                t[e + 1][t[e + 2]] = i;
            }
        }
    }
    _updatePlacementStamps(e, t, n, i) {
        if (void 0 !== n[i]) if (void 0 === e[t]) e[t] = n[i]; else {
            let r = e[t];
            Math.abs(n[i]) > Math.abs(r) ? e[t] = n[i] : n[i] = e[t];
        } else void 0 !== e[t] && (n[i] = e[t]);
    }
    _isReplacedPlacement(e, t) {
        return this._replacedPlacements && this._replacedPlacements[e] && this._replacedPlacements[e][t];
    }
    _getCollideBoxes(e, t) {
        const {symbolIndex: n} = e.properties, i = n.type || 0;
        let r = e.properties._collidesBoxes;
        r || (r = e.properties._collidesBoxes = []);
        let s = r[n.index];
        s || (s = e.properties._collidesBoxes = []), s[i] || (s[i] = []), s = s[i];
        const o = t / 6;
        if (!s[o]) {
            const e = [];
            s[o] = {
                boxes: e,
                collision: {
                    boxes: e
                }
            };
        }
        return s[o];
    }
    _getMeshBoxes(e) {
        let t = this._MeshBoxes;
        if (t || (t = this._MeshBoxes = []), !t[e]) {
            t[e] = [];
            for (let n = 0; n < e; n++) t[e][n] = {};
        }
        return t[e];
    }
    _isHalo0(e) {
        if (!e || !e.geometry) return !0;
        const t = en(this.getSymbolDef(e.geometry.properties.symbolIndex).textHaloRadius);
        if (!e.geometry.properties.glyphAtlas || !e.material.get("isHalo") || t && e.geometry.properties.hasHalo) return !1;
        if (t && !e.geometry.properties.hasHalo) return !0;
        return !this.getSymbol(e.geometry.properties.symbolIndex).textHaloRadius;
    }
}

const Fi = 10;

function Oi(e, t) {
    return Math.round(e[0] / t / Fi) * Math.round(e[1] / t / Fi) * (e[2] ? Math.round(e[2] / Fi) : 1) + "-" + e[3];
}

function Ri(e, t) {
    const n = t.properties.level - e.properties.level;
    return 0 === n ? e.properties.meshKey - t.properties.meshKey : n;
}

function Ei(e, t, n) {
    return e[0] = t[0] - n, e[1] = t[1] - n, e[2] = t[2] + n, e[3] = t[3] + n, e;
}

var Di = "#include <gl2_vert>\n#define SHADER_NAME MARKER\n#define RAD 0.0174532925\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nattribute vec4 aShape;\n#ifdef ENABLE_COLLISION\nattribute float aOpacity;\n#endif\n#ifdef HAS_OPACITY\nattribute vec2 aColorOpacity;\n#endif\n#ifdef HAS_TEXT_SIZE\nattribute float aTextSize;\n#else\nuniform float textSize;\n#endif\n#if defined(HAS_TEXT_DX) || defined(HAS_TEXT_DY) || defined(HAS_MARKER_DX) || defined(HAS_MARKER_DY)\nattribute vec4 aDxDy;\n#endif\n#ifndef HAS_MARKER_DX\nuniform float markerDx;\n#endif\n#ifndef HAS_MARKER_DY\nuniform float markerDy;\n#endif\n#ifndef HAS_TEXT_DX\nuniform float textDx;\n#endif\n#ifndef HAS_TEXT_DY\nuniform float textDy;\n#endif\n#ifdef HAS_MARKER_WIDTH\nattribute float aMarkerWidth;\n#else\nuniform float markerWidth;\n#endif\n#ifdef HAS_MARKER_HEIGHT\nattribute float aMarkerHeight;\n#else\nuniform float markerHeight;\n#endif\n#if defined(HAS_MARKER_PITCH_ALIGN) || defined(HAS_TEXT_PITCH_ALIGN)\nattribute vec2 aPitchAlign;\n#endif\n#ifndef HAS_MARKER_PITCH_ALIGN\nuniform float markerPitchWithMap;\n#endif\n#ifndef HAS_TEXT_PITCH_ALIGN\nuniform float textPitchWithMap;\n#endif\n#if defined(HAS_MARKER_ROTATION_ALIGN) || defined(HAS_TEXT_ROTATION_ALIGN)\nattribute vec2 aRotationAlign;\n#endif\n#ifndef HAS_MARKER_ROTATION_ALIGN\nuniform float markerRotateWithMap;\n#endif\n#ifndef HAS_TEXT_ROTATION_ALIGN\nuniform float textRotateWithMap;\n#endif\nuniform float flipY;\n#if defined(HAS_MARKER_ROTATION) || defined(HAS_TEXT_ROTATION)\nattribute vec2 aRotation;\n#endif\n#ifndef HAS_MARKER_ROTATION\nuniform float markerRotation;\n#endif\n#ifndef HAS_TEXT_ROTATION\nuniform float textRotation;\n#endif\n#ifdef HAS_PAD_OFFSET\nattribute vec2 aPadOffset;\n#endif\nuniform float cameraToCenterDistance;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float textPerspectiveRatio;\nuniform float markerPerspectiveRatio;\nuniform float glyphSize;\nuniform vec2 iconSize;\nuniform vec2 canvasSize;\nuniform vec2 iconTexSize;\nuniform vec2 glyphTexSize;\nuniform float mapPitch;\nuniform float mapRotation;\nuniform float zoomScale;\nuniform float tileRatio;\nuniform float layerScale;\nuniform float isRenderingTerrain;\n#include <vt_position_vert>\nvarying float vIsText;\n#ifndef PICKING_MODE\nvarying vec2 vTexCoord;\nvarying float vOpacity;\nvarying float vGammaScale;\nvarying float vTextSize;\nvarying float vHalo;\n#ifdef HAS_TEXT_FILL\nattribute vec4 aTextFill;\nvarying vec4 vTextFill;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nattribute vec4 aTextHaloFill;\nvarying vec4 vTextHaloFill;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nattribute vec2 aTextHalo;\nvarying vec2 vTextHalo;\n#endif\n#include <highlight_vert>\n#else\n#include <fbo_picking_vert>\n#endif\nvoid main() {\n  vec3 c = unpackVTPosition();\n#ifdef HAS_TEXT_SIZE\nfloat d = aTextSize * layerScale;\n#else\nfloat d = textSize * layerScale;\n#endif\n#ifdef HAS_TEXT_DX\nfloat e = aDxDy.z;\n#else\nfloat e = textDx;\n#endif\n#ifdef HAS_TEXT_DY\nfloat f = aDxDy.w;\n#else\nfloat f = textDy;\n#endif\n#ifdef HAS_MARKER_WIDTH\nfloat h = aMarkerWidth;\n#else\nfloat h = markerWidth;\n#endif\n#ifdef HAS_MARKER_HEIGHT\nfloat i = aMarkerHeight;\n#else\nfloat i = markerHeight;\n#endif\n#ifdef HAS_MARKER_DX\nfloat j = aDxDy.x;\n#else\nfloat j = markerDx;\n#endif\n#ifdef HAS_MARKER_DY\nfloat k = aDxDy.y;\n#else\nfloat k = markerDy;\n#endif\nfloat l = mod(aShape.z, 2.);\n  float m;\n  if(l > .5) {\n    \n#ifdef HAS_TEXT_PITCH_ALIGN\nm = aPitchAlign.y;\n#else\nm = textPitchWithMap;\n#endif\n  } else {\n    \n#ifdef HAS_MARKER_PITCH_ALIGN\nm = aPitchAlign.x;\n#else\nm = markerPitchWithMap;\n#endif\n  }\n  float n;\n  if(l > .5) {\n    \n#ifdef HAS_TEXT_ROTATION_ALIGN\nn = aRotationAlign.y;\n#else\nn = textRotateWithMap;\n#endif\n  } else {\n    \n#ifdef HAS_MARKER_ROTATION_ALIGN\nn = aRotationAlign.x;\n#else\nn = markerRotateWithMap;\n#endif\n  }\n  gl_Position = projViewModelMatrix * positionMatrix * vec4(c, 1.);\n  float o = gl_Position.w;\n  float u;\n  if(isRenderingTerrain == 1. && m == 1.) {\n    u = 1.;\n  } else {\n    float v = (1. - cameraToCenterDistance / o) * markerPerspectiveRatio;\n    u = clamp(.5 + .5 * (1. - v), .0, 4.);\n  }\n  float A;\n  if(l > .5) {\n    \n#ifdef HAS_TEXT_ROTATION\nA = -aRotation.y / 9362. - mapRotation * n;\n#else\nA = -textRotation - mapRotation * n;\n#endif\n  } else {\n    \n#ifdef HAS_MARKER_ROTATION\nA = -aRotation.x / 9362. - mapRotation * n;\n#else\nA = -markerRotation - mapRotation * n;\n#endif\n  }\n  if(m == 1.) {\n    \n#ifdef REVERSE_MAP_ROTATION_ON_PITCH\nA += mapRotation;\n#else\nif(l > .5) {\n      A -= mapRotation;\n    } else {\n      A += mapRotation;\n    }\n#endif\n  }\n  float B = sin(A);\n  float C = cos(A);\n  mat2 D = mat2(C, -1. * B, B, C);\n  vec2 E = (aShape.xy / 10.0);\n  if(m == 1. && flipY == .0) {\n    E *= vec2(1., -1.);\n  }\n  vIsText = l;\n  if(l > .5) {\n    E = E / glyphSize * d;\n  } else {\n    \n#ifdef HAS_PAD_OFFSET\nfloat F = aPadOffset.x - 1.;\n    float G = aPadOffset.y;\n#else\nfloat F = .0;\n    float G = .0;\n#endif\nE = (E / iconSize * vec2(h, i) + vec2(F, G)) * layerScale;\n  }\n  E = D * E;\n  float H;\n  if(isRenderingTerrain == 1.) {\n    H = 1.;\n  } else {\n    H = o / cameraToCenterDistance;\n  }\n  if(m == .0) {\n    vec2 I = E * 2. / canvasSize;\n    gl_Position.xy += I * u * o;\n  } else if(l > .5) {\n    float J;\n    if(isRenderingTerrain == 1.) {\n      J = tileRatio / zoomScale;\n    } else {\n      J = tileRatio / zoomScale * H * u;\n    }\n    vec2 I = E;\n    gl_Position = projViewModelMatrix * positionMatrix * vec4(c + vec3(I, .0) * J, 1.);\n  } else {\n    vec2 I = E;\n    gl_Position = projViewModelMatrix * positionMatrix * vec4(c + vec3(I, .0) * tileRatio / zoomScale * H * u, 1.);\n  }\n  if(l > .5) {\n    gl_Position.xy += vec2(e, -f) * 2. / canvasSize * o;\n  } else {\n    gl_Position.xy += vec2(j, -k) * 2. / canvasSize * o;\n  }\n#ifndef PICKING_MODE\nif(m == .0) {\n    vGammaScale = mix(1., H, textPerspectiveRatio);\n  } else {\n    vGammaScale = H + mapPitch / 4.;\n  }\n  vGammaScale = clamp(vGammaScale, .0, 1.);\n  vec2 K = floor(aShape.zw / 2.);\n  if(l > .5) {\n    vTexCoord = K / glyphTexSize;\n  } else {\n    vTexCoord = K / iconTexSize;\n  }\n  vHalo = mod(aShape.w, 2.);\n  vTextSize = d;\n#ifdef ENABLE_COLLISION\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\n#ifdef HAS_OPACITY\nif(l > .5) {\n    vOpacity *= aColorOpacity.y / 255.;\n  } else {\n    vOpacity *= aColorOpacity.x / 255.;\n  }\n#endif\n#ifdef HAS_TEXT_FILL\nvTextFill = aTextFill / 255.;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nvTextHaloFill = aTextHaloFill / 255.;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nvTextHalo = aTextHalo;\n#endif\nhighlight_setVarying();\n#else\n#ifdef ENABLE_COLLISION\nbool L = aOpacity == 255.;\n#else\nbool L = true;\n#endif\nfbo_picking_setData(gl_Position.w, L);\n#endif\n}";

const Li = [], Hi = [], zi = [], Ni = [], Vi = [], Bi = [];

function Ui(e, t, n, i, r, s, o, a, l, h, c, u, f, d) {
    const {tileRatio: p, tileResolution: g} = l, y = p / (g / h.getResolution()) * (c / h.cameraToCenterDistance) * u;
    T.scale(n, n, y), T.scale(i, i, y), T.scale(r, r, y), T.scale(s, s, y), m.set(Li, n[0], n[1], f ? n[2] / d : 0), 
    m.set(Hi, i[0], i[1], f ? i[2] / d : 0), m.set(zi, r[0], r[1], f ? r[2] / d : 0), 
    m.set(Ni, s[0], s[1], f ? s[2] / d : 0), m.add(Li, Li, t), m.add(Hi, Hi, t), m.add(zi, zi, t), 
    m.add(Ni, Ni, t), an(n, Li, o, h.width, h.height), an(i, Hi, o, h.width, h.height), 
    an(r, zi, o, h.width, h.height), an(s, Ni, o, h.width, h.height), T.set(Vi, Math.min(n[0], i[0], r[0], s[0]), Math.min(n[1], i[1], r[1], s[1])), 
    T.set(Bi, Math.max(n[0], i[0], r[0], s[0]), Math.max(n[1], i[1], r[1], s[1])), v.set(e, Vi[0] + a[0], Vi[1] + a[1], Bi[0] + a[0], Bi[1] + a[1]);
}

function Gi(e, t, n, i, r, s, o, a) {
    1 !== a && (T.scale(n, n, a), T.scale(i, i, a), T.scale(r, r, a), T.scale(s, s, a)), 
    T.set(Vi, Math.min(n[0], i[0], r[0], s[0]), Math.min(n[1], i[1], r[1], s[1])), T.set(Bi, Math.max(n[0], i[0], r[0], s[0]), Math.max(n[1], i[1], r[1], s[1])), 
    v.set(e, t[0] + Vi[0] + o[0], t[1] + Vi[1] - o[1], t[0] + Bi[0] + o[0], t[1] + Bi[1] - o[1]);
}

function ji(e, t, n, i, r) {
    t -= n * i, 1 === r && (t += n);
    const s = Math.sin(t), o = Math.cos(t);
    return w.set(e, o, -s, s, o);
}

const Wi = 15, Xi = 15, Yi = 2048, qi = 24, Zi = .01, $i = [], Ji = [], Ki = [], Qi = [], er = [], tr = [], nr = [], ir = [], rr = [ 1, -1 ], sr = [ 1, 1 ];

function or(e, t, n, i, r) {
    const o = s[r.id], a = t.material.uniforms, l = r.cameraToCenterDistance, h = t.geometry.properties, c = this.getSymbol(h.symbolIndex), u = t.geometry.desc.positionSize, f = h.aAnchor, d = m.set($i, f[n * u], f[n * u + 1], 2 === u ? 0 : f[n * u + 2]), {aTerrainAltitude: p} = h;
    if (p) {
        const e = 100 * p[2 * n];
        e && (d[2] += e);
    }
    let g = an(Ji, d, i, r.width, r.height);
    const y = g[2];
    let x = 1;
    if (a.markerPerspectiveRatio) {
        x = Ue(.5 + .5 * (1 - (1 - l / y) * a.markerPerspectiveRatio), 0, 4);
    }
    const {aShape: _, aMarkerDx: v, aMarkerDy: b, aMarkerWidth: A, aMarkerHeight: w, aPitchAlign: S, aRotationAlign: M, aRotation: P} = h, I = v ? v[n] : c.markerDx, C = b ? b[n] : c.markerDy, k = S ? S[2 * n] : a.markerPitchWithMap, F = M ? M[2 * n] : a.markerRotateWithMap, O = T.set(ir, I || 0, -(C || 0));
    let R = T.set(Qi, _[2 * n] / 10, _[2 * n + 1] / 10), E = T.set(er, _[2 * n + 2] / 10, _[2 * n + 3] / 10), D = T.set(tr, _[2 * n + 4] / 10, _[2 * n + 5] / 10), L = T.set(nr, _[2 * n + 6] / 10, _[2 * n + 7] / 10);
    0 === a.flipY && 1 === k && (T.multiply(R, R, rr), T.multiply(E, E, rr), T.multiply(D, D, rr), 
    T.multiply(L, L, rr));
    const [H, z] = zn(t.geometry);
    let N = A ? A[n] : c.markerWidth;
    je(N) && (N = H || Wi);
    let V = w ? w[n] : c.markerHeight;
    je(V) && (V = z || Xi);
    const B = T.set(sr, N / Yi, V / Yi);
    let U;
    T.mul(R, R, B), T.mul(E, E, B), T.mul(D, D, B), T.mul(L, L, B), U = P ? P[2 * n] / 9362 : -(c.markerRotation || 0) * Math.PI / 180;
    const G = -U, j = (o ? o.bearing : r.geBearing()) * Math.PI / 180;
    if (j * F || G) {
        const e = ji(Ki, G, j, F, k);
        R = T.transformMat2(R, R, e), E = T.transformMat2(E, E, e), D = T.transformMat2(D, D, e), 
        L = T.transformMat2(L, L, e);
    }
    1 === k ? Ui(e, d, R, E, D, L, i, O, a, r, y, x) : (T.multiply(R, R, rr), T.multiply(E, E, rr), 
    T.multiply(D, D, rr), T.multiply(L, L, rr), Gi(e, g, R, E, D, L, O, x));
    const W = o ? o.devicePixelRatio : r.getDevicePixelRatio();
    return 1 !== W && (e[0] *= W, e[1] *= W, e[2] *= W, e[3] *= W), e;
}

const {PackUtil: ar} = q(), lr = 1, hr = [], cr = [], ur = [], fr = [], dr = [], pr = [], gr = [ 1, -1 ];

function mr(e, t, n, i, r, o, a, l, h) {
    const c = i.material.uniforms, u = h.cameraToCenterDistance, f = i.geometry.properties, d = this.getSymbol(f.symbolIndex), p = "line" === d.textPlacement && !Qe(d), g = s[h.id], y = qi, x = n[2];
    let _ = 1;
    if (c.textPerspectiveRatio) {
        _ = Ue(.5 + .5 * (1 - (1 - u / x) * c.textPerspectiveRatio), 0, 4);
    }
    const {aTextDx: v, aTextDy: b, aPitchAlign: A, aRotationAlign: w, aRotation: S, aType: M, aDxDy: P} = i.geometry.properties;
    let I, C, k;
    P ? (I = P[4 * a + 2], C = P[4 * a + 3]) : (I = v ? v[a] : d.textDx, C = b ? b[a] : d.textDy), 
    A && (k = M ? A[2 * a + 1] : A[a]);
    const F = A ? k : c.textPitchWithMap;
    let O;
    w && (O = M ? w[2 * a + 1] : w[a]);
    const R = w ? O : c.textRotateWithMap, E = T.set(pr, I || 0, -(C || 0));
    if (p) {
        const {aOffset: i, aShape: r} = f, s = i.length !== r.length;
        let o, u, d, p;
        if (s ? (o = m.set(cr, i[3 * a] / 10, i[3 * a + 1] / 10, i[3 * a + 2] / 10), u = m.set(ur, i[3 * a + 3] / 10, i[3 * a + 4] / 10, i[3 * a + 5] / 10), 
        d = m.set(fr, i[3 * a + 6] / 10, i[3 * a + 7] / 10, i[3 * a + 8] / 10), p = m.set(dr, i[3 * a + 9] / 10, i[3 * a + 10] / 10, i[3 * a + 11] / 10)) : (o = T.set(cr, i[2 * a] / 10, i[2 * a + 1] / 10), 
        u = T.set(ur, i[2 * a + 2] / 10, i[2 * a + 3] / 10), d = T.set(fr, i[2 * a + 4] / 10, i[2 * a + 5] / 10), 
        p = T.set(dr, i[2 * a + 6] / 10, i[2 * a + 7] / 10)), 1 === F) {
            const n = he(g ? g.resolution : h.getResolution(), h);
            Ui(e, t, o, u, d, p, l, E, c, h, x, _, s, n);
        } else T.multiply(o, o, gr), T.multiply(u, u, gr), T.multiply(d, d, gr), T.multiply(p, p, gr), 
        Gi(e, n, o, u, d, p, E, _);
    } else {
        const {aShape: i} = f;
        let s, o = T.set(cr, i[2 * a] / 10, -i[2 * a + 1] / 10), u = T.set(ur, i[2 * a + 2] / 10, -i[2 * a + 3] / 10), m = T.set(fr, i[2 * a + 4] / 10, -i[2 * a + 5] / 10), v = T.set(dr, i[2 * a + 6] / 10, -i[2 * a + 7] / 10);
        0 === c.flipY && 1 === F && (T.multiply(o, o, gr), T.multiply(u, u, gr), T.multiply(m, m, gr), 
        T.multiply(v, v, gr)), s = S ? M && S.length > M.length ? S[2 * a + 1] / 9362 : S[a] / 9362 : (d.textRotation || 0) * Math.PI / 180;
        const b = p ? 0 : (g ? g.bearing : h.getBearing()) * Math.PI / 180;
        if (s || b) {
            const e = ji(hr, s, b, R, F);
            o = T.transformMat2(o, o, e), u = T.transformMat2(u, u, e), m = T.transformMat2(m, m, e), 
            v = T.transformMat2(v, v, e);
        }
        const A = r / y;
        T.scale(o, o, A), T.scale(u, u, A), T.scale(m, m, A), T.scale(v, v, A), 1 === F ? Ui(e, t, o, u, m, v, l, E, c, h, x, _) : Gi(e, n, o, u, m, v, E, _);
    }
    o = o || 0, e[0] -= o + lr, e[1] -= o + lr, e[2] += o + lr, e[3] += o + lr;
    const D = g ? g.devicePixelRatio : h.getDevicePixelRatio();
    return 1 !== D && (e[0] *= D, e[1] *= D, e[2] *= D, e[3] *= D), e;
}

function yr(e, t, n) {
    const i = t.geometry.desc.positionSize, {aAnchor: r, aAltitude: s, aTerrainAltitude: o} = t.geometry.properties, a = n * i;
    if (s ? m.set(e, r[a], r[a + 1], s[n]) : 3 === i ? ar.unpackPosition(e, r[a], r[a + 1], r[a + 2]) : m.set(e, r[a], r[a + 1], 0), 
    o) {
        const t = 100 * o[2 * n];
        t && (e[2] += t);
    }
    return e;
}

const xr = {
    textFill: [ 0, 0, 0, 1 ],
    textOpacity: 1,
    textPitchAlignment: 0,
    textRotationAlignment: 0,
    textHaloRadius: 0,
    textHaloFill: [ 1, 1, 1, 1 ],
    textHaloBlur: 0,
    textHaloOpacity: 1,
    textPerspectiveRatio: 0,
    textSize: 14,
    textDx: 0,
    textDy: 0,
    textRotation: 0
};

function _r(e, t, n, i, r, s, o, a, l) {
    const h = [];
    if (t.isDisposed() || 0 === t.data.aPosition.length) return h;
    const c = t.properties.glyphAtlas;
    if (!c) return h;
    if (0 === i.textSize || 0 === i.textOpacity) return h;
    br.call(this, t, i, s, o, a, l);
    const u = Ar.call(this, {}, e, t, r);
    let f = !1;
    r.textOpacity < 1 && (f = !0), t.properties.memorySize = t.getMemorySize(), t.generateBuffers(e, {
        excludeElementsInVAO: !0
    });
    const d = new g.Material(u, xr), p = new g.Mesh(t, d, {
        disableVAO: !0,
        transparent: f,
        castShadow: !1,
        picking: !0
    });
    if (p.setLocalTransform(n), p.setUniform("alphaTest", Zi), u.isHalo && (p.properties.isHalo = !0), 
    o && p.setDefines({
        ENABLE_COLLISION: 1
    }), h.push(p), u.isHalo) {
        const e = vr.call(this, t, r, u.glyphTex, c, o, n);
        e.properties.haloMesh = p, h.push(e);
    }
    return h.forEach((e => {
        const n = e.defines || {};
        Tr.call(this, n, e), e.setDefines(n), e.properties.symbolIndex = t.properties.symbolIndex;
    })), h;
}

function vr(e, t, n, i, r, s) {
    let o = !1;
    t.textOpacity < 1 && (o = !0);
    const a = {
        flipY: 0,
        tileResolution: e.properties.tileResolution,
        tileRatio: e.properties.tileRatio,
        glyphTex: n,
        glyphTexSize: [ i.width, i.height ],
        isHalo: 0
    };
    Sr(e, a, t);
    const l = new g.Material(a, xr), h = new g.Mesh(e, l, {
        disableVAO: !0,
        transparent: o,
        castShadow: !1,
        picking: !0
    });
    return h.setUniform("alphaTest", Zi), Object.defineProperty(h.properties, "textSize", {
        enumerable: !0,
        get: function() {
            return a.textSize;
        }
    }), r && h.setDefines({
        ENABLE_COLLISION: 1
    }), h.setLocalTransform(s), h;
}

function br(e, t, n, i, r, s) {
    Gt(e, t, n, this.layer);
    const o = e.properties;
    if (!o.textInitialized) {
        wr.call(this, e, i || s, r), o.textInitialized = !0;
        const {aTextSize: t, aTextDx: n, aTextDy: a, aPitchAlign: l, aRotationAlign: h, aRotation: c, aOverlap: u, aAltitude: f} = e.data;
        if (t) {
            const e = (Bt + "aTextSize").trim();
            o.aTextSize = o[e] || new t.constructor(t);
        }
        if (n) {
            const e = (Bt + "aTextDx").trim();
            o.aTextDx = o[e] || new n.constructor(n);
        }
        if (a) {
            const e = (Bt + "aTextDy").trim();
            o.aTextDy = o[e] || new a.constructor(a);
        }
        if (l) {
            const e = (Bt + "aPitchAlign").trim();
            o.aPitchAlign = o[e] || new l.constructor(l);
        }
        if (h) {
            const e = (Bt + "aRotationAlign").trim();
            o.aRotationAlign = o[e] || new h.constructor(h);
        }
        if (c) {
            const e = (Bt + "aRotation").trim();
            o.aRotation = o[e] || new c.constructor(c);
        }
        if (u) {
            const e = (Bt + "aOverlap").trim();
            o.aOverlap = o[e] || new u.constructor(u);
        }
        if (f) {
            const e = (Bt + "aAltitude").trim();
            o.aAltitude = o[e] || new f.constructor(f);
        }
    }
}

function Ar(e, t, n, i) {
    const r = n.properties.glyphAtlas, s = r && Dn(t, r, !1) || t.texture(2);
    return Be(e = e || {}, {
        flipY: 0,
        tileResolution: n.properties.tileResolution,
        tileRatio: n.properties.tileRatio,
        glyphTex: s,
        glyphTexSize: [ s && s.width || 0, s && s.height || 0 ]
    }), Sr(n, e, i), e;
}

function Tr(e, t) {
    const n = t.geometry;
    n.data.aTextFill && (e.HAS_TEXT_FILL = 1), n.data.aTextSize && (e.HAS_TEXT_SIZE = 1), 
    n.data.aColorOpacity && (e.HAS_OPACITY = 1), n.data.aTextHaloFill && t.material.uniforms.isHalo && (e.HAS_TEXT_HALO_FILL = 1);
    const i = this.getSymbolDef(n.properties.symbolIndex);
    en(i.textHaloRadius) && t.material.uniforms.isHalo && (e.HAS_TEXT_HALO_RADIUS = 1), 
    en(i.textHaloOpacity) && t.material.uniforms.isHalo && (e.HAS_TEXT_HALO_OPACITY = 1), 
    en(i.textDx) && (e.HAS_TEXT_DX = 1), en(i.textDy) && (e.HAS_TEXT_DY = 1), n.data.aPitchAlign && (e.HAS_PITCH_ALIGN = 1), 
    en(i.textRotationAlignment) && (e.HAS_TEXT_ROTATION_ALIGN = 1), n.data.aRotation && (e.HAS_TEXT_ROTATION = 1), 
    n.data.aAltitude && (e.HAS_ALTITUDE = 1), n.properties.aOffset && n.properties.aShape && n.properties.aOffset.length !== n.properties.aShape.length && (e.HAS_OFFSET_Z = 1);
}

function wr(e, t, n) {
    const i = e.properties, r = this.getSymbol(i.symbolIndex), s = "line" === i.textPlacement && !Qe(r), {aPosition: o, aShape: a} = e.data, l = o.length / e.desc.positionSize;
    if (i.vertexCount = l, i.aPickingId = e.data.aPickingId, i.aCount || (i.aCount = e.data.aCount, 
    delete e.data.aCount), t || s) {
        let e = a;
        if (a.length === 4 * l) {
            e = new a.constructor(2 * l);
            for (let t = 0; t < l; t++) e[2 * t] = a[4 * t], e[2 * t + 1] = a[4 * t + 1];
        }
        i.aAnchor = o, i.aShape = e;
    }
    if (i.visElemts || (i.elements = e.elements, i.visElemts = new e.elements.constructor(e.elements.length)), 
    s) {
        const {aVertical: t, aSegment: n, aGlyphOffset: r, aPitchRotation: s} = e.data, o = !!s;
        i.aGlyphOffset = r, i.aPitchRotation = s, i.aSegment = n, i.aVertical = t, delete e.data.aSegment, 
        delete e.data.aVertical, delete e.data.aGlyphOffset, delete e.data.aPitchRotation;
        const a = l * (o ? 3 : 2);
        e.data.aOffset = {
            usage: "dynamic",
            data: new Int16Array(a)
        }, i.aOffset = new Int16Array(a);
    }
    if (t) {
        e.data.aOpacity = {
            usage: "dynamic",
            data: new Uint8Array(l)
        }, i.aOpacity = new Uint8Array(l), n && (i.aOpacity.fill(255, 0), e.data.aOpacity.data.fill(255, 0));
        const {aTextHalo: t} = e.data;
        if (t && !i.aTextHalo) {
            const e = (Bt + "aTextHalo").trim();
            i.aTextHalo = i[e] || new t.constructor(t);
        }
    }
}

function Sr(e, t, n) {
    void 0 === t.isHalo && (t.isHalo = 1), Xe(t, "textOpacity", n, "textOpacity", xr.textOpacity), 
    Xe(t, "textFill", n, "textFill", xr.textFill, Ze()), Xe(t, "textHaloFill", n, "textHaloFill", xr.textHaloFill, Ze()), 
    Xe(t, "textHaloBlur", n, "textHaloBlur", xr.textHaloBlur), Xe(t, "textHaloRadius", n, "textHaloRadius", xr.textHaloRadius), 
    Xe(t, "textHaloOpacity", n, "textHaloOpacity", xr.textHaloOpacity), Xe(t, "textPerspectiveRatio", n, "textPerspectiveRatio", xr.textPerspectiveRatio, (t => "line" === e.properties.textPlacement ? 1 : t)), 
    Xe(t, "textRotateWithMap", n, "textRotationAlignment", xr.textRotationAlignment, (e => +("map" === e))), 
    Xe(t, "textPitchWithMap", n, "textPitchAlignment", xr.textPitchAlignment, (e => +("map" === e))), 
    Xe(t, "textSize", n, "textSize", xr.textSize), Xe(t, "textDx", n, "textDx", xr.textDx), 
    Xe(t, "textDy", n, "textDy", xr.textDy), Xe(t, "textRotation", n, "textRotation", xr.textRotation, (e => e * Math.PI / 180));
}

function Mr(e) {
    const t = [];
    return {
        uniforms: [ {
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, n) {
                return y.multiply(t, n.projViewMatrix, n.modelMatrix);
            }
        }, {
            name: "zoomScale",
            type: "function",
            fn: function(e, t) {
                return t.tileResolution / t.resolution;
            }
        } ],
        extraCommandProps: {
            viewport: {
                x: 0,
                y: 0,
                width: () => e ? e.width : 1,
                height: () => e ? e.height : 1
            },
            stencil: {
                enable: !0,
                mask: 255,
                func: {
                    cmp: "<=",
                    ref: (e, t) => t.stencilRef,
                    mask: 255
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            blend: {
                enable: !0,
                func: this.getBlendFunc(),
                equation: "add"
            },
            depth: {
                enable: !0,
                range: () => this.sceneConfig.depthRange || [ 0, 1 ],
                func: () => this.sceneConfig.depthFunc || "always",
                mask: !1
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        }
    };
}

function Pr(e, t) {
    const n = F(t.textFill), i = F(t.textSize), r = F(t.textHaloFill), o = F(t.textHaloRadius), a = F(t.textHaloOpacity), l = F(t.textDx), h = F(t.textDy), c = F(t.textOpacity), u = O(t.textPitchAlignment), f = O(t.textRotationAlignment), d = F(t.textRotation), p = O(t.textAllowOverlapFn), g = O(t.textIgnorePlacement), m = {}, y = new Int16Array(1), x = new Uint16Array(1);
    return [ {
        attrName: "aTextFill",
        symbolName: "textFill",
        define: "HAS_TEXT_FILL",
        type: Uint8Array,
        width: 4,
        evaluate: (t, i) => {
            const r = s[e.id], o = r ? r.zoom : e.getZoom();
            let a = n(o, t);
            return k(a) && (a = this.evaluateInFnTypeConfig(a, i, e, t, !0)), Array.isArray(a) || (a = m[a] = m[a] || I(a).unitArray()), 
            a = qe(a), a;
        }
    }, {
        attrName: "aTextSize",
        symbolName: "textSize",
        define: "HAS_TEXT_SIZE",
        type: Uint8Array,
        width: 1,
        evaluate: (t, n) => {
            const r = s[e.id], o = r ? r.zoom : e.getZoom();
            let a = i(o, t) || xr.textSize;
            return k(a) && (a = this.evaluateInFnTypeConfig(a, n, e, t)), y[0] = a, y[0];
        }
    }, {
        attrName: "aTextHaloFill",
        symbolName: "textHaloFill",
        define: "HAS_TEXT_HALO_FILL",
        type: Uint8Array,
        width: 4,
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom();
            let o = r(i, t);
            return Array.isArray(o) || (o = m[o] = m[o] || I(o).unitArray()), o = qe(o), o;
        }
    }, {
        attrName: "aTextHalo",
        symbolName: "textHaloRadius",
        define: "HAS_TEXT_HALO_RADIUS",
        type: Uint8Array,
        index: 0,
        width: 2,
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom(), r = o(i, t);
            return y[0] = r, y[0];
        }
    }, {
        attrName: "aTextHalo",
        symbolName: "textHaloOpacity",
        define: "HAS_TEXT_HALO_OPACITY",
        type: Uint8Array,
        index: 1,
        width: 2,
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom(), r = a(i, t);
            return y[0] = 255 * r, y[0];
        }
    }, {
        attrName: "aTextDx",
        symbolName: "textDx",
        define: "HAS_TEXT_DX",
        type: Uint8Array,
        width: 1,
        evaluate: (t, n) => {
            const i = s[e.id], r = i ? i.zoom : e.getZoom();
            let o = l(r, t);
            return k(o) && (o = this.evaluateInFnTypeConfig(o, n, e, t)), y[0] = o, y[0];
        }
    }, {
        attrName: "aTextDy",
        symbolName: "textDy",
        define: "HAS_TEXT_DY",
        type: Uint8Array,
        width: 1,
        evaluate: (t, n) => {
            const i = s[e.id], r = i ? i.zoom : e.getZoom();
            let o = h(r, t);
            return k(o) && (o = this.evaluateInFnTypeConfig(o, n, e, t)), y[0] = o, y[0];
        }
    }, {
        attrName: "aColorOpacity",
        symbolName: "textOpacity",
        define: "HAS_OPACITY",
        type: Uint8Array,
        width: 1,
        evaluate: (t, n) => {
            const i = s[e.id], r = i ? i.zoom : e.getZoom();
            let o = c(r, t);
            return k(o) && (o = this.evaluateInFnTypeConfig(o, n, e, t)), y[0] = 255 * o, y[0];
        }
    }, {
        attrName: "aPitchAlign",
        symbolName: "textPitchAlignment",
        type: Uint8Array,
        width: 1,
        define: "HAS_PITCH_ALIGN",
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom();
            return +("map" === u(i, t));
        }
    }, {
        attrName: "aRotationAlign",
        symbolName: "textRotationAlignment",
        type: Uint8Array,
        width: 1,
        define: "HAS_ROTATION_ALIGN",
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom();
            return +("map" === f(i, t));
        }
    }, {
        attrName: "aRotation",
        symbolName: "textRotation",
        type: Uint16Array,
        width: 1,
        define: "HAS_TEXT_ROTATION",
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom(), r = Ge(d(i, t), 0, 360) * Math.PI / 180;
            return x[0] = 9362 * r, x[0];
        }
    }, {
        attrName: "aOverlap",
        symbolName: "textAllowOverlap",
        type: Uint8Array,
        width: 1,
        evaluate: n => {
            const i = s[e.id], r = i ? i.zoom : e.getZoom();
            let o = p(r, n) || 0, a = (g ? g(r, n) : t.textIgnorePlacement) || 0;
            return o = 1 << 3 + 4 * o, a = (g ? 2 : 0) + a, o + a;
        }
    }, {
        attrName: "aOverlap",
        symbolName: "textIgnorePlacement",
        type: Uint8Array,
        width: 1,
        evaluate: n => {
            const i = s[e.id], r = i ? i.zoom : e.getZoom();
            let o = (p ? p(r, n) : t.textAllowOverlap) || 0, a = g(r, n) || 0;
            return o = (p ? 8 : 0) + 4 * o, a = 1 << 1 + a, o + a;
        }
    } ];
}

const Ir = [], Cr = [], kr = [], Fr = [];

function Or(e, t, n, i, r, s, o) {
    e = 1 === e ? 1 : 0;
    const a = this.getMap(), l = t.geometry.properties, h = this.getSymbol(l.symbolIndex), c = "line" === l.textPlacement && !Qe(h), {aTextSize: u, aTextHalo: f, aShape: d} = l;
    let p = u ? u[n[r]] : h.textSize;
    null == p && (p = xr.textSize);
    const g = f ? f[2 * n[r]] : t.properties.textHaloRadius, m = yr(kr, t, n[r]), {aProjectedAnchor: y} = t.geometry.properties;
    let x = Fr;
    const _ = 3 * n[r];
    y && y[_] !== ke ? (Fr[0] = y[_], Fr[1] = y[_ + 1], Fr[2] = y[_ + 2]) : x = an(Fr, m, o, a.width, a.height);
    const v = i, {boxes: b, collision: A} = this._getCollideBoxes(t, r);
    let T = 0;
    if (c || 1 === t.material.uniforms.textRotateWithMap || h.textRotation) {
        let i = 0;
        for (let s = r; s < r + 6 * v; s += 6) {
            const r = b[T] = b[T] || [];
            T++;
            const l = mr.call(this, r, m, x, t, p, g, n[s], o, a);
            if (!e) {
                const t = this.isCollides(l);
                1 === t ? e = 1 : -1 === t && i++;
            }
        }
        i === v && (e = -1);
    } else {
        let i = n[r], l = d[2 * i + 1];
        for (let h = r; h < s; h += 6) {
            const r = d[2 * n[h] + 1];
            if (l !== r || h === s - 6) {
                const c = n[h === s - 6 ? h : h - 6], u = mr.call(this, Ir, m, x, t, p, g, i, o, a), f = mr.call(this, Cr, m, x, t, p, g, c, o, a), d = b[T] = b[T] || [];
                T++, d[0] = Math.min(u[0], f[0]), d[1] = Math.min(u[1], f[1]), d[2] = Math.max(u[2], f[2]), 
                d[3] = Math.max(u[3], f[3]), i = n[h], l = r, !e && this.isCollides(d) && (e = 1);
            }
        }
    }
    return A.collides = e, A;
}

function Rr(e, t) {
    const n = function(e, t) {
        const {aPickingId: n, features: i} = e.geometry.properties, r = n[t], s = i && i[r] && i[r].feature;
        return s && s.label;
    }(e, t);
    return n ? function(e, t, n) {
        if (!n) return null;
        const i = e.localTransform, r = yr(Er, e, t);
        v.set(Dr, r[0], r[1], r[2], 1);
        const s = v.transformMat4(Dr, Dr, i);
        let o = 0;
        for (const e of n) o += e.codePointAt(0);
        return [ Math.floor(s[0]), Math.floor(s[1]), Math.floor(s[2]), o ];
    }(e, t, n) : null;
}

const Er = [], Dr = [];

const Lr = 6, Hr = 4, zr = new Uint16Array(1), Nr = new Int8Array(1);

function Vr(e, t, n, i, r, s, o, a, l) {
    if (t.isDisposed() || 0 === t.data.aPosition.length) return null;
    const h = !!t.properties.iconAtlas, c = !!t.properties.glyphAtlas;
    if (!h && !c && !t.properties.isEmpty) return null;
    //!geometry.properties.aShape 以避免重复创建collision数据
        if (!t.properties.aShape) {
        const {aPosition: e, aShape: n} = t.data, i = t.data.aPosition.length / t.desc.positionSize, r = new Uint8Array(i);
        a && r.fill(255, 0), t.data.aOpacity = {
            usage: "dynamic",
            data: r
        }, t.properties.aOpacity = new Uint8Array(i), a && t.properties.aOpacity.fill(255, 0), 
        t.properties.aAnchor = e;
        const s = n.length / 4, o = new n.constructor(2 * s);
        for (let e = 0; e < s; e++) o[2 * e] = n[4 * e], o[2 * e + 1] = n[4 * e + 1];
        t.properties.aShape = o;
    }
    t.properties.visElemts || (t.properties.elements = t.elements, t.properties.visElemts = new t.elements.constructor(t.elements.length)), 
    c && br.call(this, t, i, s.text, o, a, l), t.properties.memorySize = t.getMemorySize(), 
    t.generateBuffers(e, {
        excludeElementsInVAO: !0
    });
    const u = {
        flipY: 0,
        tileResolution: t.properties.tileResolution,
        tileRatio: t.properties.tileRatio
    };
    Ur.call(this, u, e, t, r), Ar.call(this, u, e, t, r), u.isHalo = 0;
    const f = [], d = {
        disableVAO: !0,
        transparent: !0,
        castShadow: !1,
        picking: !0
    };
    let p;
    if (c) {
        const e = Be({}, u);
        e.isHalo = 1;
        const i = new g.Material(e);
        p = new g.Mesh(t, i, d), p.properties.isHalo = 1, p.setUniform("alphaTest", Zi), 
        p.setLocalTransform(n);
    }
    const m = new g.Material(u), y = new g.Mesh(t, m, d);
    let x = {
        HAS_HALO_ATTR: 1
    };
    if (o && (x.ENABLE_COLLISION = 1), Gr.call(this, t, x), p) {
        const e = Be({}, x);
        Tr.call(this, x, p), p.setDefines(e);
    }
    return c && Tr.call(this, x, y), x = jn(e, x), y.setDefines(x), y.setUniform("alphaTest", Zi), 
    y.setLocalTransform(n), y.properties.symbolIndex = t.properties.symbolIndex, f.push(y), 
    f;
}

function Br(e) {
    const {aMarkerDx: t, aMarkerDy: n, aTextDx: i, aTextDy: r} = e.data, s = i || r || t || n;
    if (s) {
        const o = new s.constructor(4 * s.length);
        for (let e = 0; e < o.length; e += 4) {
            const s = e / 4;
            t && (o[e] = t[s]), n && (o[e + 1] = n[s]), i && (o[e + 2] = i[s]), r && (o[e + 3] = r[s]);
        }
        e.data.aDxDy = o, e.properties.aDxDy = o.slice(), t && (e.properties.aMarkerDx = t), 
        n && (e.properties.aMarkerDy = n), i && (e.properties.aTextDx = i), r && (e.properties.aTextDy = r);
    }
}

function Ur(e, t, n, i) {
    const [r, s] = zn(n);
    Xe(e, "markerOpacity", i, "markerOpacity", 1), Xe(e, "markerPerspectiveRatio", i, "markerPerspectiveRatio", i.markerTextFit ? 0 : 1), 
    Xe(e, "markerWidth", i, "markerWidth", r || Wi), Xe(e, "markerHeight", i, "markerHeight", s || Xi), 
    Xe(e, "markerDx", i, "markerDx", 0), Xe(e, "markerDy", i, "markerDy", 0), Xe(e, "markerRotation", i, "markerRotation", 0, (e => e * Math.PI / 180)), 
    Xe(e, "markerPitchWithMap", i, "markerPitchAlignment", 0, (e => "map" === e ? 1 : 0)), 
    Xe(e, "markerRotateWithMap", i, "markerRotationAlignment", 0, (e => "map" === e ? 1 : 0));
    const o = n.properties.iconAtlas;
    e.iconTex = o ? Dn(t, o, !1) : t.texture(2), e.iconTexSize = o ? [ o.width, o.height ] : [ 0, 0 ];
}

function Gr(e, t) {
    e.data.aAltitude && (t.HAS_ALTITUDE = 1), e.data.aMarkerWidth && (t.HAS_MARKER_WIDTH = 1), 
    e.data.aMarkerHeight && (t.HAS_MARKER_HEIGHT = 1), e.data.aColorOpacity && (t.HAS_OPACITY = 1);
    const n = this.getSymbolDef(e.properties.symbolIndex);
    en(n.markerDx) && (t.HAS_MARKER_DX = 1), en(n.markerDy) && (t.HAS_MARKER_DY = 1), 
    en(n.textDx) && (t.HAS_TEXT_DX = 1), en(n.textDy) && (t.HAS_TEXT_DY = 1), en(n.markerPitchAlignment) && (t.HAS_MARKER_PITCH_ALIGN = 1), 
    en(n.textPitchAlignment) && (t.HAS_TEXT_PITCH_ALIGN = 1), en(n.markerRotationAlignment) && (t.HAS_MARKER_ROTATION_ALIGN = 1), 
    en(n.textRotationAlignment) && (t.HAS_TEXT_ROTATION_ALIGN = 1), en(n.markerRotation) && (t.HAS_MARKER_ROTATION = 1), 
    en(n.textRotation) && (t.HAS_TEXT_ROTATION = 1), e.data.aPadOffset && (t.HAS_PAD_OFFSET = 1);
}

function jr(e, t, n, i) {
    Gt(e, t, n, i), function(e) {
        const {aMarkerWidth: t, aMarkerHeight: n, aMarkerDx: i, aMarkerDy: r, aPitchAlign: s, aRotationAlign: o, aRotation: a, aOverlap: l} = e.data;
        if (t) {
            const n = (Bt + "aMarkerWidth").trim();
            e.properties.aMarkerWidth = e.properties[n] || new t.constructor(t);
        }
        if (n) {
            const t = (Bt + "aMarkerHeight").trim();
            e.properties.aMarkerHeight = e.properties[t] || new n.constructor(n);
        }
        if (i) {
            const t = (Bt + "aMarkerDx").trim();
            e.properties.aMarkerDx = e.properties[t] || new i.constructor(i);
        }
        if (r) {
            const t = (Bt + "aMarkerDy").trim();
            e.properties.aMarkerDy = e.properties[t] || new r.constructor(r);
        }
        if (s) {
            const t = (Bt + "aPitchAlign").trim();
            e.properties.aPitchAlign = e.properties[t] || new s.constructor(s);
        }
        if (o) {
            const t = (Bt + "aRotationAlign").trim();
            e.properties.aRotationAlign = e.properties[t] || new o.constructor(o);
        }
        if (a) {
            const t = (Bt + "aRotation").trim();
            e.properties.aRotation = e.properties[t] || new a.constructor(a);
        }
        if (l) {
            const t = (Bt + "aOverlap").trim();
            e.properties.aOverlap = e.properties[t] || new l.constructor(l);
        }
    }(e);
}

function Wr(e, t) {
    const n = F(t.markerWidth), i = F(t.markerHeight), r = F(t.markerDx), o = F(t.markerDy), a = F(t.markerOpacity), l = F(t.markerTextFit), h = O(t.markerPitchAlignment), c = O(t.textPitchAlignment), u = O(t.markerRotationAlignment), f = O(t.textRotationAlignment), d = F(t.markerRotation), p = F(t.textRotation), g = O(t.markerAllowOverlapFn), m = O(t.markerIgnorePlacement), y = F(t.textOpacity), x = F(t.textDx), _ = F(t.textDy), v = new Int16Array(1), b = new Uint16Array(1);
    return [ {
        attrName: "aMarkerWidth",
        symbolName: "markerWidth",
        type: Uint16Array,
        width: 1,
        define: "HAS_MARKER_WIDTH",
        evaluate: (i, r, o, a) => {
            const h = s[e.id], c = h ? h.zoom : e.getZoom(), u = o[a], f = t.markerTextFit, d = l ? l(c, i) : f;
            if ("both" === d || "width" === d) return u;
            let p = n(c, i);
            return k(p) && (p = this.evaluateInFnTypeConfig(p, r, e, i)), v[0] = p, v[0];
        }
    }, {
        attrName: "aMarkerHeight",
        symbolName: "markerHeight",
        type: Uint16Array,
        width: 1,
        define: "HAS_MARKER_HEIGHT",
        evaluate: (n, r, o, a) => {
            const h = s[e.id], c = h ? h.zoom : e.getZoom(), u = o[a], f = t.markerTextFit, d = l ? l(c, n) : f;
            if ("both" === d || "height" === d) return u;
            let p = i(c, n);
            return k(p) && (p = this.evaluateInFnTypeConfig(p, r, e, n)), v[0] = p, v[0];
        }
    }, {
        attrName: "aDxDy",
        symbolName: "markerDx",
        type: Int8Array,
        width: 4,
        index: 0,
        define: "HAS_MARKER_DX",
        evaluate: (t, n, i, o) => {
            const a = s[e.id], l = a ? a.zoom : e.getZoom();
            let h = r(l, t);
            k(h) && (h = this.evaluateInFnTypeConfig(h, n, e, t));
            const {aMarkerDx: c} = n.properties;
            return c && (c[o / 4] = h), v[0] = h, v[0];
        }
    }, {
        attrName: "aDxDy",
        symbolName: "markerDy",
        type: Int8Array,
        width: 4,
        index: 1,
        define: "HAS_MARKER_DY",
        evaluate: (t, n, i, r) => {
            const a = s[e.id], l = a ? a.zoom : e.getZoom();
            let h = o(l, t);
            k(h) && (h = this.evaluateInFnTypeConfig(h, n, e, t));
            const {aMarkerDy: c} = n.properties;
            return c && (c[Math.floor(r / 4)] = h), v[0] = h, v[0];
        }
    }, {
        attrName: "aDxDy",
        symbolName: "textDx",
        type: Int8Array,
        width: 4,
        index: 2,
        define: "HAS_TEXT_DX",
        evaluate: (t, n, i, r) => {
            const o = s[e.id], a = o ? o.zoom : e.getZoom();
            let l = x(a, t);
            k(l) && (l = this.evaluateInFnTypeConfig(l, n, e, t));
            const {aTextDx: h} = n.properties;
            return h && (h[Math.floor(r / 4)] = l), v[0] = l, v[0];
        }
    }, {
        attrName: "aDxDy",
        symbolName: "textDy",
        type: Int8Array,
        width: 4,
        index: 3,
        define: "HAS_TEXT_DY",
        evaluate: (t, n, i, r) => {
            const o = s[e.id], a = o ? o.zoom : e.getZoom();
            let l = _(a, t);
            k(l) && (l = this.evaluateInFnTypeConfig(l, n, e, t));
            const {aTextDy: h} = n.properties;
            return h && (h[Math.floor(r / 4)] = l), v[0] = l, v[0];
        }
    }, {
        attrName: "aColorOpacity",
        symbolName: "markerOpacity",
        type: Uint8Array,
        width: 2,
        index: 0,
        define: "HAS_OPACITY",
        evaluate: (t, n) => {
            let i = 1;
            if (a) {
                const r = s[e.id], o = r ? r.zoom : e.getZoom();
                i = a(o, t), k(i) && (i = this.evaluateInFnTypeConfig(i, n, e, t));
            }
            return v[0] = 255 * i, v[0];
        }
    }, {
        attrName: "aColorOpacity",
        symbolName: "textOpacity",
        type: Uint8Array,
        width: 2,
        index: 1,
        define: "HAS_OPACITY",
        evaluate: (t, n) => {
            let i = 1;
            if (y) {
                const r = s[e.id], o = r ? r.zoom : e.getZoom();
                i = y(o, t), k(i) && (i = this.evaluateInFnTypeConfig(i, n, e, t));
            }
            return v[0] = 255 * i, v[0];
        }
    }, {
        attrName: "aPitchAlign",
        symbolName: "markerPitchAlignment",
        type: Uint8Array,
        width: 2,
        index: 0,
        define: "HAS_PITCH_ALIGN",
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom();
            return +("map" === h(i, t));
        }
    }, {
        attrName: "aPitchAlign",
        symbolName: "textPitchAlignment",
        type: Uint8Array,
        width: 2,
        index: 1,
        define: "HAS_PITCH_ALIGN",
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom();
            return +("map" === c(i, t));
        }
    }, {
        attrName: "aRotationAlign",
        symbolName: "markerRotationAlignment",
        type: Uint8Array,
        width: 2,
        index: 0,
        define: "HAS_MARKER_ROTATION_ALIGN",
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom();
            return +("map" === u(i, t));
        }
    }, {
        attrName: "aRotationAlign",
        symbolName: "textRotationAlignment",
        type: Uint8Array,
        width: 2,
        index: 1,
        define: "HAS_TEXT_ROTATION_ALIGN",
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom();
            return +("map" === f(i, t));
        }
    }, {
        attrName: "aRotation",
        symbolName: "markerRotation",
        type: Uint16Array,
        width: 2,
        index: 0,
        define: "HAS_MARKER_ROTATION",
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom(), r = Ge(d(i, t), 0, 360) * Math.PI / 180;
            return b[0] = 9362 * r, b[0];
        }
    }, {
        attrName: "aRotation",
        symbolName: "textRotation",
        type: Uint16Array,
        width: 2,
        index: 1,
        define: "HAS_TEXT_ROTATION",
        evaluate: t => {
            const n = s[e.id], i = n ? n.zoom : e.getZoom(), r = Ge(p(i, t), 0, 360) * Math.PI / 180;
            return b[0] = 9362 * r, b[0];
        }
    }, {
        attrName: "aOverlap",
        symbolName: "markerAllowOverlap",
        type: Uint8Array,
        width: 1,
        evaluate: n => {
            const i = s[e.id], r = i ? i.zoom : e.getZoom();
            let o = g(r, n) || 0, a = (m ? m(r, n) : t.markerIgnorePlacement) || 0;
            return o = 1 << 3 + 4 * o, a = (m ? 2 : 0) + a, o + a;
        }
    }, {
        attrName: "aOverlap",
        symbolName: "markerIgnorePlacement",
        type: Uint8Array,
        width: 1,
        evaluate: n => {
            const i = s[e.id], r = i ? i.zoom : e.getZoom();
            let o = (g ? g(r, n) : t.markerAllowOverlap) || 0, a = m(r, n) || 0;
            return o = (g ? 8 : 0) + 4 * o, a = 2 + a, o + a;
        }
    } ];
}

function Xr(e, t, n) {
    if (!t || !n || "none" === n) return;
    const {iconAtlas: i, glyphAtlas: r} = t.properties;
    if (!i || !r) return;
    !function(e) {
        if (e.properties.iconElements) return;
        const t = [], n = [], i = e.elements, r = e.properties.aType;
        for (let e = 0; e < i.length; e++) {
            const s = i[e];
            0 === r[s] ? t.push(s) : n.push(s);
        }
        e.properties.iconElements = new i.constructor(t), e.properties.textElements = new i.constructor(n);
    }(t);
    const s = function(e, t) {
        let n = e.properties.textFitFn;
        k(t) && (n = e.properties.textFitFn = O(t));
        const i = "none" !== t, r = [], s = e.properties.iconElements, o = e.data.aPickingId, a = e.properties.textElements, l = e.data.aPickingId, h = e.properties.aCount, c = e.properties.features;
        let u, f = a[0];
        u = {
            pickingId: l[f],
            start: 0,
            end: h[f] * Lr
        };
        let d = !1, p = !1, g = 0;
        const m = new Set;
        for (let e = 0; e < s.length; e += Lr) {
            const f = o[s[e]];
            if (!d && u) for (;u.pickingId < f && u.end < a.length; ) {
                const e = u.end, t = a[e];
                u.start = e, u.end = e + h[t] * Lr, u.pickingId = l[t];
            }
            if (!d && u && u.pickingId < f && (d = !0, !i)) {
                if (!p) return [];
                for (let t = e; t < s.length; t += Lr) r[g++] = [ -1, -1 ];
                return r;
            }
            const y = c[f] && c[f].feature, x = y && y.properties || {}, _ = n ? n(null, x) : t;
            if (u && f === u.pickingId) {
                r[g++] = [ u.start, u.end ];
                const e = u.end, t = a[e];
                u.start = e, u.end = e + h[t] * Lr, u.pickingId = l[t], p = !0;
            } else if (_ && "none" !== _) for (let t = e; t < e + Lr; t++) m.add(t); else r[g++] = [ -1, -1 ];
        }
        if (m.size) if (m.size === s.length) e.setElements([]); else {
            const t = [];
            for (let e = 0; e < s.length; e++) m.has(e) || t.push(s[e]);
            e.setElements(new s.constructor(t));
        }
        if (!p) return [];
        return r;
    }(t, n);
    if (!t.getElements().length) return;
    if (!s.length) return;
    t.properties.labelIndex = s;
    if (s.length && n && "none" !== n) {
        const n = function(e) {
            const t = [], n = e.properties.labelIndex, {aShape: i} = e.data;
            let r = !1;
            for (let s = 0; s < n.length; s++) {
                const [o, a] = n[s];
                if (-1 === o) t.push(0, 0, 0, 0); else {
                    r = !0;
                    let n = 1 / 0, s = 1 / 0, l = -1 / 0, h = -1 / 0;
                    const c = e.properties.textElements;
                    for (let e = o; e < a; e++) {
                        const t = c[e], r = i[4 * t], o = i[4 * t + 1];
                        r < n && (n = r), r > l && (l = r), o < s && (s = o), o > h && (h = o);
                    }
                    t.push(n, s, l, h);
                }
            }
            if (!r) return [];
            return t;
        }(t);
        n.length && (t.properties.labelShape = n, Yr.call(this, e, t));
    }
}

function Yr(e, t) {
    const n = this.getSymbolDef(t.properties.symbolIndex), i = n.markerTextFit, r = t.properties;
    let s = "both" === i || "width" === i, o = "both" === i || "height" === i;
    if (k(n.markerTextFit)) {
        let e = t.properties.textFitFn;
        e || (e = t.properties.textFitFn = F(n.markerTextFit));
        const {features: i} = t.properties, a = t.properties.iconElements, {aPickingId: l} = t.data, h = [], c = [];
        let u = !0;
        for (let t = 0; t < a.length; t += Lr) {
            const n = i[l[a[t]]], r = (n && n.feature || {}).properties || {};
            let s = e(null, r);
            if (k(s)) {
                s = (r.textFitFn = r.textFitFn || F(s))(null, r);
            }
            "both" === s ? (h.push(t / Lr), c.push(t / Lr)) : "width" === s ? (u = !1, h.push(t / Lr)) : "height" === s && (u = !1, 
            c.push(t / Lr));
        }
        u ? (r.fitIcons = h, s = !0, o = !0) : (h.length && (r.fitWidthIcons = h, s = !0), 
        c.length && (r.fitHeightIcons = c, o = !0));
    }
    r.aPickingId || (r.aPickingId = new t.data.aPickingId.constructor(t.data.aPickingId));
    const {aMarkerWidth: a, aMarkerHeight: l, aPickingId: h} = r, c = h.length;
    if (s) if (a) {
        const e = t.data.aMarkerWidth;
        t.data.aMarkerWidth = new Uint16Array(e), r.aMarkerWidth = new Uint16Array(e);
        const n = (Bt + "aMarkerWidth").trim();
        r[n] && (r[n] = r.aMarkerWidth);
    } else {
        const e = this.getSymbol(t.properties.symbolIndex).markerWidth || 0;
        r.aMarkerWidth = new Uint16Array(c), r.aMarkerWidth.fill(e), e && (r.aMarkerWidth.dirty = !0), 
        t.data.aMarkerWidth = new Uint16Array(c);
    }
    if (o) if (l) {
        const e = t.data.aMarkerHeight;
        t.data.aMarkerHeight = new Uint16Array(e), r.aMarkerHeight = new Uint16Array(e);
        const n = (Bt + "aMarkerHeight").trim();
        r[n] && (r[n] = r.aMarkerHeight);
    } else {
        const e = this.getSymbol(t.properties.symbolIndex).markerHeight || 0;
        r.aMarkerHeight = new Uint16Array(c), r.aMarkerHeight.fill(e), e && (r.aMarkerHeight.dirty = !0), 
        t.data.aMarkerHeight = new Uint16Array(c);
    }
    const u = this.getSymbolDef(t.properties.symbolIndex), f = F(u.textSize);
    Zr.call(this, e, t), (!k(u.textSize) || f.isZoomConstant && f.isFeatureConstant) && (r.isFitConstant = !0);
}

const qr = [ 0, 0, 0, 0 ];

function Zr(e, t) {
    const n = t.properties;
    if (!n.glyphAtlas || !n.textElements || !n.textElements.length) return;
    const i = t.properties;
    if (i.isFitConstant || !i.labelShape || !i.labelShape.length) return;
    const r = this.getSymbolDef(t.properties.symbolIndex), o = r.textSize;
    let a;
    k(o) && (a = n._textSizeFn ? n._textSizeFn : n._textSizeFn = F(o));
    const l = r.markerTextFitPadding || qr;
    let h;
    k(l) && (h = i._paddingFn ? i._paddingFn : i._paddingFn = O(l));
    const c = s[e.id], u = c ? c.zoom : e.getZoom(), {fitIcons: f, fitWidthIcons: d, fitHeightIcons: p} = i, {aMarkerWidth: g, aMarkerHeight: m, labelShape: y} = i, x = t.properties.iconElements, {features: _, aPickingId: v} = i, b = (e, t, n, r) => {
        const s = y[4 * t], c = y[4 * t + 1], f = y[4 * t + 2], d = y[4 * t + 3];
        if (!(s || c || f || d)) return;
        const p = v[e], x = _[p] && _[p].feature, b = x && x.properties || {};
        let A = a ? a(u, b) : o;
        if (k(A)) {
            A = (b.textSizeFn = b.textSizeFn || F(A))(u, b);
        }
        A /= qi;
        let T, w = h && h(u, b) || l;
        if (k(w)) {
            w = (b.fitPaddingFn = b.fitPaddingFn || O(w))(u, b);
        }
        if (w = w || qr, w[0] === w[2] && w[1] === w[3] || (T = i.aPadOffset, T || (T = i.aPadOffset = new Int16Array(2 * g.length))), 
        g && n) {
            const t = Math.abs((f - s) / 10 * A) + (w[1] + w[3] || 0);
            if (zr[0] = t, g[e] !== zr[0] && (Je(g, zr[0], e, e + Hr), g.dirty = !0), T) {
                const t = (w[1] + w[3]) / 2 - w[3];
                if (Nr[0] = t, T[2 * e] !== Nr[0]) {
                    for (let n = e; n < e + Hr; n++) T[2 * n] = t;
                    T.dirty = !0;
                }
            }
        }
        if (m && r) {
            const t = Math.abs((d - c) / 10 * A) + (w[0] + w[2] || 0);
            if (zr[0] = t, m[e] !== zr[0] && (Je(m, zr[0], e, e + Hr), m.dirty = !0), T) {
                const t = w[0] - (w[0] + w[2]) / 2;
                if (Nr[0] = t, T[2 * e + 1] !== Nr[0]) {
                    for (let n = e; n < e + Hr; n++) T[2 * n + 1] = t;
                    T.dirty = !0;
                }
            }
        }
    };
    if (f || d || p) {
        if (f) for (let e = 0; e < f.length; e++) {
            const t = f[e];
            b(x[t * Lr], t, !0, !0);
        } else if (d || p) {
            if (d) for (let e = 0; e < d.length; e++) {
                const t = d[e];
                b(x[t * Lr], t, !0, !1);
            }
            if (p) for (let e = 0; e < p.length; e++) {
                const t = p[e];
                b(x[t * Lr], t, !1, !0);
            }
        }
    } else for (let e = 0; e < x.length; e += Lr) {
        const t = e / Lr;
        b(x[e], t, !0, !0);
    }
    const {aPadOffset: A} = i;
    A && (t.data.aPadOffset = A, t.isBufferGenerated() && t.generateBuffers(this.regl, {
        excludeElementsInVAO: !0
    }));
}

const {FilterUtil: $r} = q(), Jr = [], Kr = {
    collides: -1
}, Qr = [ Yi, Yi ], es = y.identity([]), ts = [];

class ns extends ki {
    static getBloomSymbol() {
        return [ "markerBloom", "textBloom" ];
    }
    constructor(e, t, n, i, r, s) {
        super(e, t, n, i, r, s), this.propAllowOverlap = "markerAllowOverlap", this.propIgnorePlacement = "markerIgnorePlacement", 
        this._fnTypeConfigs = {}, this.isLabelCollides = Or.bind(this), this._meshesToCheck = [];
    }
    needToRefreshTerrainTileOnZooming() {
        for (let e = 0; e < this.symbolDef.length; e++) {
            const t = this.symbolDef[e].markerPitchAlignment;
            if ("map" === t || k(t) || $r.isExpression(t)) return !0;
        }
        return !1;
    }
    isTerrainVector() {
        return this.layer.options.awareOfTerrain && !this.needToRefreshTerrainTileOnZooming();
    }
    isTerrainSkin() {
        return super.isTerrainSkin() && this.needToRefreshTerrainTileOnZooming();
    }
    setShaderDefines(e) {
        this._shaderDefines = e;
    }
    createFnTypeConfig(e, t) {
        const n = Wr.call(this, e, t), i = Pr.call(this, e, t);
        for (let e = i.length - 1; e >= 0; e--) {
            const t = i[e].attrName;
            "aTextDx" !== t && "aTextDy" !== t && "aPitchAlign" !== t && "aRotation" !== t && "aRotationAlign" !== t && "aColorOpacity" !== t && "aOverlap" !== t || i.splice(e, 1);
        }
        const r = n.concat(i);
        return r.text = i, r.icon = n, r;
    }
    startFrame(...e) {
        return this._meshesToCheck.length = 0, super.startFrame(...e);
    }
    createGeometry(e, t) {
        return e && e.empty && (e.data = {
            aPosition: new Uint8Array(e.data.aPosition),
            aPickingId: e.data.aPickingId
        }), super.createGeometry(e, t);
    }
    postCreateGeometry(e) {
        const {geometry: t, symbolIndex: n} = e, i = this.getSymbolDef(n), r = this.getFnTypeConfig(n), {iconAtlas: s, glyphAtlas: o} = t.properties;
        if (s || o) {
            if (this._prepareRequiredProps(t), s && (this.drawDebugAtlas(s), jr(t, i, r.icon, this.layer)), 
            o) {
                const e = i.markerTextFit;
                if (e) {
                    const n = this.getMap();
                    Xr.call(this, n, t, e);
                }
            }
        } else t.properties.isEmpty = !0;
    }
    _prepareRequiredProps(e) {
        const {aCount: t, aShape: n} = e.data;
        e.properties.aCount = t, delete e.data.aCount;
        const i = n.length / 4, r = new Uint8Array(i), s = new Uint8Array(i);
        for (let e = 0; e < i; e++) r[e] = n[4 * e + 2] % 2, s[e] = n[4 * e + 3] % 2;
        e.properties.aType = r, e.properties.aHalo = s, Br.call(this, e);
    }
    prepareCollideIndex(e) {
        const {collideIds: t, elements: n, aCount: i, aType: r} = e.properties;
        if (!t) return;
        const s = {};
        if (!n) return void (e.properties.collideBoxIndex = s);
        let o = 0, a = n[0], l = 0, h = t[a], c = r[0], u = 1;
        i && (u = i[n[l]]);
        for (let e = 0; e <= n.length; e += Lr) if (a = n[e], t[a] !== h || c !== r[a] || e === n.length) {
            s[h] || (s[h] = []);
            const f = e;
            let d = l;
            1 === c && (d = l + (f - l) / 2), s[h].push([ d, f, (f - d) / (u * Lr), o++, l ]), 
            h = t[a], c = r[a], l = e, i && (u = i[n[l]]);
        }
        e.properties.collideBoxIndex = s;
    }
    createMesh(e, t) {
        const n = this.isEnableCollision(), i = this.layer, {geometry: r, symbolIndex: s} = e;
        r.properties.symbolIndex = s;
        const o = this.getSymbolDef(s), a = this.getSymbol(s), l = this.getFnTypeConfig(s), h = [], c = this.isEnableUniquePlacement(), u = Vr.call(this, this.regl, r, t, o, a, l, i.options.collision, !n, c);
        if (u.length) {
            const e = this.getAltitudeOffsetMatrix();
            u[0].positionMatrix = e, u[1] && (u[1].positionMatrix = e), h.push(...u);
        }
        return "line" === r.properties.markerPlacement && (this._rebuildCollideIds(r), h.forEach((e => e.properties.isLinePlacement = !0))), 
        this.prepareCollideIndex(r), h;
    }
    _rebuildCollideIds(t) {
        const n = this.layer instanceof e.TileLayer, {collideIds: i, glyphAtlas: r, iconAtlas: s} = t.properties, o = new Uint16Array(i.length), a = !!r;
        if (!!s) {
            const {collideIds: e, aType: i} = t.properties;
            if (r) {
                let t = 0, n = i[0], r = 0;
                for (let s = 1; s < e.length; s++) 0 === i[s] && 1 === n && (o.fill(t++, r, s), 
                r = s), n = i[s];
                r < e.length && o.fill(t++, r, e.length);
            } else {
                let t = 0;
                for (let n = 0; n < e.length; n += Hr) o.fill(t++, n, n + Hr);
            }
            t.properties.collideIds = o, t.properties.uniqueCollideIds = tt(o, !n);
        } else if (a) {
            const {collideIds: e, aCount: i} = t.properties;
            if (!i) return;
            let r = 0, s = i[0];
            for (let t = 0; t < e.length; ) {
                const n = t + s * Hr;
                e.fill(r++, t, n), t += s * Hr, n < e.length && (s = i[n]);
            }
            t.properties.uniqueCollideIds = tt(e, !n);
        }
    }
    addMesh(t) {
        if (this.isEnableCollision() && t.length > 0) {
            const e = new bi(t);
            e.properties.uniqueCollideIds = t[0].geometry.properties.uniqueCollideIds, e.properties.meshKey = t[0].properties.meshKey, 
            e.properties.level = t[0].properties.level, this._meshesToCheck.push(e);
        }
        for (let e = 0; e < t.length; e++) {
            if (!this.isMeshIterable(t[e])) continue;
            const n = t[e].geometry, {symbolIndex: i} = n.properties;
            Qe(this.getSymbolDef(i)) && Zr.call(this, this.getMap(), n);
        }
        const n = this.getMap(), i = e.MapStateCache[n.id], r = i ? i.zoom : n.getZoom();
        for (let e = 0; e < t.length; e++) {
            if (!this.isMeshIterable(t[e])) continue;
            const n = t[e].geometry, {symbolIndex: i} = n.properties, s = this.getSymbolDef(i), o = this.getFnTypeConfig(i);
            Yt(this.regl, this.layer, s, o, t[e], r);
            const {aMarkerWidth: a, aMarkerHeight: l, aPadOffset: h} = n.properties;
            a && a.dirty && (n.updateData("aMarkerWidth", a), a.dirty = !1), l && l.dirty && (n.updateData("aMarkerHeight", l), 
            l.dirty = !1), h && h.dirty && (n.updateData("aPadOffset", h), h.dirty = !1);
        }
        super.addMesh(...arguments);
    }
    limitMeshDefines(e) {
        let t = e.defines;
        t = jn(this.regl, t), e.setDefines(t);
    }
    updateCollision(e) {
        if (!this.isEnableCollision()) return;
        super.updateCollision(e);
        const t = this.scene.getMeshes();
        t && t.length ? (this._updateIconCollision(e.timestamp), this._meshesToCheck = [], 
        this._endCollision()) : this._endCollision();
    }
    isMeshIterable(e) {
        return e && e.geometry && !e.geometry.properties.isEmpty && e.material && this.isMeshVisible(e) && !(this.shouldIgnoreBackground() && !this.layer.getRenderer().isForeground(e));
    }
    _updateIconCollision() {
        if (!this.isEnableCollision()) return;
        let e = this._meshesToCheck;
        e && e.length && this._updateIconAndText(e);
    }
    _updateBox(e, t, n, i) {
        return this.updateBoxCollisionFading(!0, e, t, n, i);
    }
    isEnableUniquePlacement() {
        return this.isEnableCollision() && !0 === this.sceneConfig.uniquePlacement;
    }
    _updateIconAndText(e) {
        const t = this.layer.getRenderer();
        e = e.sort(is);
        for (let n = 0; n < e.length; n++) {
            const i = e[n];
            if (!i || !i.meshes.length) continue;
            let r = !1;
            if (1 === i.meshes.length) r = this.isMeshIterable(i.meshes[0]); else for (let e = 0; e < i.meshes.length; e++) if (this.isMeshIterable(i.meshes[e])) {
                r = !0;
                break;
            }
            if (!r) continue;
            const s = t.isForeground(i.meshes[0]);
            if (this.shouldIgnoreBackground() && !s) continue;
            const o = i.properties.meshKey;
            this.startMeshCollision(i), this._startCheckMesh(i), this.forEachBox(i, this._updateBox), 
            this._endCheckMesh(i), this.endMeshCollision(o);
            for (let e = 0; e < i.meshes.length; e++) this._updateOpacity(i.meshes[e]);
        }
    }
    _updateOpacity(e) {
        const t = e && e.geometry && e.geometry.properties.aOpacity;
        t && t.dirty && (e.geometry.updateData("aOpacity", t), t.dirty = !1);
    }
    forEachBox(e, t) {
        const n = e.properties.uniqueCollideIds;
        if (!n) return;
        const i = {
            boxIndex: 0
        }, r = n.length;
        for (let s = 0; s < r; s++) this._iterateMeshBox(e, n[s], t, i);
    }
    _iterateMeshBox(e, t, n, i) {
        const r = this.getMap(), {collideBoxIndex: s} = e.meshes[0].geometry.properties, o = s && s[t];
        if (!o || !o.length) return !1;
        const a = y.multiply(Jr, r.projViewMatrix, e.meshes[0].localTransform);
        let l, h = !1;
        const c = e.meshes;
        let u = 0;
        for (let e = 0; e < c.length; e++) {
            if (!this.isMeshIterable(c[e])) continue;
            const {collideBoxIndex: n} = c[e].geometry.properties, i = n[t];
            i && (u += i.length);
        }
        if (!u) return !1;
        l = this._getMeshBoxes(u);
        let f = 0;
        for (let e = 0; e < c.length; e++) {
            const n = c[e];
            if (!this.isMeshIterable(n)) continue;
            h = !0;
            const i = n.geometry.properties, {elements: r, aCount: s, collideBoxIndex: o} = i, a = o[t];
            if (a) for (let e = 0; e < a.length; e++) {
                const [t, o, h] = a[e];
                let c = 1;
                s && (c = s[r[t]]);
                const u = t + 0 * c * Lr;
                l[f].mesh = n, l[f].start = u, l[f].end = o, l[f].boxStart = a[e][4], l[f].boxCount = i.glyphAtlas ? c : h, 
                l[f].allElements = r, f++;
            }
        }
        if (!h) return !1;
        return n.call(this, e, l, a, i.boxIndex++) && this._markerVisible(e, t), !0;
    }
    _startCheckMesh(e) {
        const t = e.meshes;
        for (let e = 0; e < t.length; e++) {
            const n = t[e], i = n && n.geometry;
            i && (i.properties.visElemts.count = 0);
        }
    }
    _markerVisible(e, t) {
        const n = e.meshes;
        for (let e = 0; e < n.length; e++) {
            const i = n[e], r = i && i.geometry;
            if (!r || r.properties.isEmpty) continue;
            const {collideBoxIndex: s, elements: o, visElemts: a} = r.properties, l = s[t];
            if (l && l.length) for (let e = 0; e < l.length; e++) {
                const t = l[e][4], n = l[e][1];
                let i = a.count;
                for (let e = t; e < n; e++) a[i++] = o[e];
                a.count = i;
            }
        }
    }
    _endCheckMesh(e) {
        const t = e.meshes;
        for (let e = 0; e < t.length; e++) {
            const n = t[e], i = n && n.geometry;
            if (!i) continue;
            const {visElemts: r} = i.properties;
            i.setElements(r, r.count);
        }
    }
    isBoxCollides(e, t, n, i, r, s) {
        if (this._isTextGeo(e, t, i)) return Or.call(this, 0, e, t, n, i, r, s);
        if (e.geometry.properties.isEmpty) return Kr;
        const {aTerrainAltitude: o} = e.geometry.properties;
        if (o) {
            if (o[2 * t[i]] === Fe) return Kr;
        }
        const a = this.getMap(), {boxes: l, collision: h} = this._getCollideBoxes(e, i);
        let c = 0, u = 0, f = 0;
        for (let n = i; n < r; n += Lr) {
            const i = l[f] = l[f] || [];
            f++;
            const r = or.call(this, i, e, t[n], s, a);
            if (!c) {
                const e = this.isCollides(r);
                1 === e ? c = 1 : -1 === e && u++;
            }
        }
        return u === n && (c = -1), h.collides = c, h;
    }
    deleteMesh(e, t) {
        e && (e instanceof bi && (e = e.meshes), t && (Array.isArray(e) ? e.forEach((e => {
            e && e.material && delete e.material.uniforms.iconTex;
        })) : e.material && delete e.material.uniforms.iconTex), super.deleteMesh(e, t));
    }
    isBloom(e) {
        const t = e && e.material && !je(e.material.get("markerOpacity")), n = this.getSymbol(e.properties.symbolIndex);
        return !!(t ? n.markerBloom : n.textBloom);
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    init() {
        const e = this.regl, t = this.canvas;
        this.renderer = new g.Renderer(e);
        const n = {
            viewport: {
                x: (e, t) => t.viewport ? t.viewport.x : 0,
                y: (e, t) => t.viewport ? t.viewport.y : 0,
                width: (e, n) => n.viewport ? n.viewport.width : t ? t.width : 1,
                height: (e, n) => n.viewport ? n.viewport.height : t ? t.height : 1
            },
            stencil: {
                enable: !0,
                func: {
                    cmp: "<=",
                    ref: (e, t) => t.stencilRef
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            blend: {
                enable: !0,
                func: this.getBlendFunc(),
                equation: "add"
            },
            depth: {
                enable: !0,
                range: () => this.sceneConfig.depthRange || [ 0, 1 ],
                func: () => this.sceneConfig.depthFunc || "always",
                mask: !!je(this.sceneConfig.depthMask) || this.sceneConfig.depthMask
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        }, i = this._shaderDefines || {};
        if (i.HAS_HIGHLIGHT_COLOR_POINT = 1, this.shader = new g.MeshShader({
            name: "marker",
            vert: Di,
            frag: "#define SHADER_NAME MARKER\nprecision mediump float;\n#include <gl2_frag>\nuniform float alphaTest;\nuniform sampler2D iconTex;\nuniform lowp float markerOpacity;\nuniform lowp float blendSrcIsOne;\nuniform float layerOpacity;\n#include <highlight_frag>\nvarying vec2 vTexCoord;\nvarying float vOpacity;\nvarying float vIsText;\nvarying float vHalo;\n#include <text_render_frag>\nvoid main() {\n  vec4 c;\n  if(vIsText > .5) {\n    c = renderText(vTexCoord);\n  } else {\n    c = texture2D(iconTex, vTexCoord) * markerOpacity;\n  }\n  c = c * vOpacity * layerOpacity;\n  if(c.a < .05) {\n    discard;\n  }\n  glFragColor = c;\n  if(glFragColor.a < alphaTest) {\n    discard;\n  }\n  glFragColor = highlight_blendColor(glFragColor);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            wgslVert: A("vt_marker_vert"),
            wgslFrag: A("vt_marker_frag"),
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    return y.multiply([], t.projViewMatrix, t.modelMatrix);
                }
            }, {
                name: "zoomScale",
                type: "function",
                fn: function(e, t) {
                    return t.tileResolution / t.resolution;
                }
            } ],
            extraCommandProps: n,
            defines: i
        }), this.shader.version = 300, this.pickingFBO) {
            const e = Be({}, i);
            e.PICKING_MODE = 1;
            const t = new g.FBORayPicking(this.renderer, {
                name: "marker-picking",
                vert: Di,
                wgslVert: A("vt_marker_vert"),
                defines: e,
                uniforms: [ {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(e, t) {
                        return y.multiply([], t.projViewMatrix, t.modelMatrix);
                    }
                }, {
                    name: "zoomScale",
                    type: "function",
                    fn: function(e, t) {
                        return t.tileResolution / t.resolution;
                    }
                } ],
                extraCommandProps: n
            }, this.pickingFBO, this.getMap());
            this.picking = [ t ];
        }
    }
    getUniformValues(t, n) {
        const i = n && n.isRenderingTerrainSkin, r = this.layer.getTileSize().width, s = i ? es : t.projViewMatrix, o = t.cameraToCenterDistance, a = T.set(ts, t.width, t.height);
        i && T.set(a, r, r);
        const l = this.getBlendFunc(), h = e.Util.isFunction(l.src) ? l.src() : l.src, c = e.MapStateCache[t.id], u = c ? c.pitch : t.getPitch(), f = c ? c.bearing : t.getBearing(), d = c ? c.resolution : t.getResolution();
        return {
            layerScale: this.layer.options.styleScale || 1,
            mapPitch: u * Math.PI / 180,
            mapRotation: f * Math.PI / 180,
            projViewMatrix: s,
            cameraToCenterDistance: o,
            canvasSize: a,
            iconSize: Qr,
            resolution: d,
            glyphSize: qi,
            gammaScale: 1,
            blendSrcIsOne: +!("one" !== h && 1 !== h),
            viewport: i && n && n.viewport,
            isRenderingTerrain: +!!i
        };
    }
    getUniqueEntryKey(e, t) {
        if (!this._isTextGeo(e.geometry)) return null;
        const {elements: n} = e.geometry.properties;
        return Rr(e, n[t]);
    }
    _isTextGeo(e, t, n) {
        const {aType: i} = e.geometry.properties;
        return 1 === i[t[n]];
    }
}

function is(e, t) {
    return e.properties.level - t.properties.level || e.properties.meshKey - t.properties.meshKey;
}

const rs = [], ss = [], os = [];

function as(e, t, n, i, r, s, o, a, l, h, c, u, f) {
    const {aGlyphOffset: d, aSegment: p, aTextDx: g, aTextDy: y, symbolIndex: x} = t.geometry.properties, _ = this.getSymbol(x), v = g ? g[r] : _.textDx, b = y ? y[r] : _.textDy, A = T.set(os, v || 0, b || 0), w = T.set(rs, d[2 * r], d[2 * r + 1]), S = m.set(ss, p[3 * r], p[3 * r + 1], p[3 * r + 2]), M = function(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p, g, m, y) {
        p || (p = i);
        const x = t.geometry.properties.line, _ = s[0] * u, v = f ? _ - o : _ + o;
        let b = v > 0 ? 1 : -1, A = 0;
        f && (b *= -1, A = Math.PI), b < 0 && (A += Math.PI);
        const T = h + c, w = Math.abs(v);
        let S = b > 0 ? l : l + 1, M = sn.convert(i), P = sn.convert(i), I = sn.convert(r), C = sn.convert(r), k = 0, F = 0;
        for (;k + F <= w; ) {
            if (S += b, S < h || S >= T) return null;
            P.x = M.x, P.y = M.y, C.x = I.x, C.y = I.y, M.x = n[3 * S], M.y = n[3 * S + 1], 
            I.x = x[3 * S], I.y = x[3 * S + 1], k += F, F = P.dist(M) / d;
        }
        const O = (w - k) / F, R = g && g.getRenderer(), E = R && R.getTerrainHelper(), D = t.properties.tile.terrainTileInfos;
        if (!y && E) {
            const {extent: n} = t.properties.tile, i = g.getTileSize().width / n, r = g.getMap();
            let s = I.sub(C).mult(O)._add(C);
            M = pn(ln, r, t, I, i, g, m, D), P = pn(hn, r, t, C, i, g, m, D), s = pn(cn, r, t, s, i, g, m, D);
            const o = A + Math.atan2(M[1] - P[1], M[0] - P[0]);
            return e[0] = (s[0] - p[0]) / d, e[1] = (s[1] - p[1]) / d, e[2] = o, e;
        }
        const L = M.sub(P), H = L.mult(O)._add(P);
        H._add(L._unit()._perp()._mult(a * b));
        const z = A + Math.atan2(M.y - P.y, M.x - P.x);
        return e[0] = (H.x - i[0]) / d, e[1] = (H.y - i[1]) / d, e[2] = z, e;
    }(e, t, i, s, o, w, A[0], A[1], S[0], S[1], S[2], n / 24, l, a, h, c, u, f);
    return M;
}

const ls = [], hs = [];

function cs(e, t, n, i, r, s, o, a, l, h, c, u, f) {
    const {aVertical: d} = n.geometry.properties, p = d[s];
    let g = as.call(this, ls, n, i, r, s, a, l, h, !1);
    if (!g) return null;
    if (m.copy(e, g), g = as.call(this, hs, n, i, r, o, a, l, h, !1), f = Math.PI * f / 180, 
    !g) return null;
    let y, x, _ = Math.abs(g[2] - e[2]);
    if (_ > Math.PI && (_ = 2 * Math.PI - _), _ > f) return null;
    if (m.copy(t, g), u && (T.transformMat2(ls, ls, u), T.transformMat2(hs, hs, u)), 
    p) {
        const e = Math.abs(hs[1] - ls[1]), t = Math.abs(hs[0] - ls[0]) * c;
        x = ls[0] > hs[0] ? 1 : 0, e > t ? (y = 1, x = ls[1] < hs[1] ? 0 : 1) : y = 0;
    } else y = 0, x = ls[0] > hs[0] ? 1 : 0;
    return 2 * x + y;
}

var us = "#define SHADER_NAME TEXT_VERT\n#define RAD 0.0174532925\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nattribute vec4 aShape;\n#ifdef ENABLE_COLLISION\nattribute float aOpacity;\n#endif\n#ifdef HAS_OPACITY\nattribute float aColorOpacity;\n#endif\n#ifdef HAS_TEXT_SIZE\nattribute float aTextSize;\n#else\nuniform float textSize;\n#endif\n#ifdef HAS_TEXT_DX\nattribute float aTextDx;\n#else\nuniform float textDx;\n#endif\n#ifdef HAS_TEXT_DY\nattribute float aTextDy;\n#else\nuniform float textDy;\n#endif\n#if defined(HAS_PITCH_ALIGN)\nattribute float aPitchAlign;\n#else\nuniform float textPitchWithMap;\n#endif\n#if defined(HAS_TEXT_ROTATION_ALIGN)\nattribute float aRotationAlign;\n#else\nuniform float textRotateWithMap;\n#endif\nuniform float flipY;\n#if defined(HAS_TEXT_ROTATION)\nattribute float aRotation;\n#else\nuniform float textRotation;\n#endif\nuniform float cameraToCenterDistance;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float textPerspectiveRatio;\nuniform vec2 glyphTexSize;\nuniform vec2 canvasSize;\nuniform float glyphSize;\nuniform float mapPitch;\nuniform float mapRotation;\nuniform float zoomScale;\nuniform float tileRatio;\nuniform float layerScale;\nuniform float isRenderingTerrain;\n#ifndef PICKING_MODE\nvarying vec2 vTexCoord;\nvarying float vGammaScale;\nvarying float vTextSize;\nvarying float vOpacity;\n#ifdef HAS_TEXT_FILL\nattribute vec4 aTextFill;\nvarying vec4 vTextFill;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nattribute vec4 aTextHaloFill;\nvarying vec4 vTextHaloFill;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nattribute vec2 aTextHalo;\nvarying vec2 vTextHalo;\n#endif\n#include <highlight_vert>\n#else\n#include <fbo_picking_vert>\n#endif\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n#ifdef HAS_TEXT_SIZE\nfloat d = aTextSize * layerScale;\n#else\nfloat d = textSize * layerScale;\n#endif\n#ifdef HAS_TEXT_DX\nfloat e = aTextDx;\n#else\nfloat e = textDx;\n#endif\n#ifdef HAS_TEXT_DY\nfloat f = aTextDy;\n#else\nfloat f = textDy;\n#endif\n#if defined(HAS_PITCH_ALIGN)\nfloat h = aPitchAlign;\n#else\nfloat h = textPitchWithMap;\n#endif\n#if defined(HAS_ROTATION_ALIGN)\nfloat i = aRotationAlign;\n#else\nfloat i = textRotateWithMap;\n#endif\ngl_Position = projViewModelMatrix * positionMatrix * vec4(c, 1.);\n  float j = gl_Position.w;\n  float k;\n  if(isRenderingTerrain == 1. && h == 1.) {\n    k = 1.;\n  } else {\n    float l = (1. - cameraToCenterDistance / j) * textPerspectiveRatio;\n    k = clamp(.5 + .5 * (1. - l), .0, 4.);\n  }\n#ifdef HAS_TEXT_ROTATION\nfloat m = -aRotation / 9362. - mapRotation * i;\n#else\nfloat m = -textRotation - mapRotation * i;\n#endif\nif(h == 1.) {\n    \n#ifdef REVERSE_MAP_ROTATION_ON_PITCH\nm += mapRotation;\n#else\nm -= mapRotation;\n#endif\n  }\n  float n = sin(m);\n  float o = cos(m);\n  mat2 u = mat2(o, -1. * n, n, o);\n  vec2 v = aShape.xy / 10.0;\n  if(h == 1. && flipY == .0) {\n    v = v * vec2(1., -1.);\n  }\n  vec2 A = aShape.zw;\n  v = u * (v / glyphSize * d);\n  float B;\n  if(isRenderingTerrain == 1.) {\n    B = 1.;\n  } else {\n    B = j / cameraToCenterDistance;\n  }\n  if(h == .0) {\n    vec2 C = v * 2. / canvasSize;\n    gl_Position.xy += C * k * j;\n  } else {\n    float D;\n    if(isRenderingTerrain == 1.) {\n      D = tileRatio / zoomScale;\n    } else {\n      D = tileRatio / zoomScale * B * k;\n    }\n    vec2 C = v;\n    gl_Position = projViewModelMatrix * positionMatrix * vec4(c + vec3(C, .0) * D, 1.);\n  }\n  gl_Position.xy += vec2(e, -f) * 2. / canvasSize * j;\n#ifndef PICKING_MODE\nif(h == .0) {\n    vGammaScale = mix(1., B, textPerspectiveRatio);\n  } else {\n    vGammaScale = B + mapPitch / 4.;\n  }\n  vTexCoord = A / glyphTexSize;\n  vGammaScale = clamp(vGammaScale, .0, 1.);\n  vTextSize = d;\n#ifdef ENABLE_COLLISION\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\n#ifdef HAS_OPACITY\nvOpacity *= aColorOpacity / 255.;\n#endif\n#ifdef HAS_TEXT_FILL\nvTextFill = aTextFill / 255.;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nvTextHaloFill = aTextHaloFill / 255.;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nvTextHalo = aTextHalo;\n#endif\nhighlight_setVarying();\n#else\n#ifdef ENABLE_COLLISION\nbool E = aOpacity == 255.;\n#else\nbool E = true;\n#endif\nfbo_picking_setData(gl_Position.w, E);\n#endif\n}", fs = "#define SHADER_NAME TEXT_LINE\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nattribute vec2 aTexCoord;\n#ifdef HAS_OFFSET_Z\nattribute vec3 aOffset;\nuniform float altitudeScale;\n#else\nattribute vec2 aOffset;\n#endif\n#ifdef ENABLE_COLLISION\nattribute float aOpacity;\n#endif\n#ifdef HAS_OPACITY\nattribute float aColorOpacity;\n#endif\n#ifdef HAS_TEXT_SIZE\nattribute float aTextSize;\n#else\nuniform float textSize;\n#endif\n#ifdef HAS_TEXT_DX\nattribute float aTextDx;\n#else\nuniform float textDx;\n#endif\n#ifdef HAS_TEXT_DY\nattribute float aTextDy;\n#else\nuniform float textDy;\n#endif\n#if defined(HAS_PITCH_ALIGN)\nattribute float aPitchAlign;\n#else\nuniform float textPitchWithMap;\n#endif\nuniform float zoomScale;\nuniform float cameraToCenterDistance;\nuniform mat4 projViewModelMatrix;\nuniform float textPerspectiveRatio;\nuniform float mapPitch;\nuniform vec2 glyphTexSize;\nuniform vec2 canvasSize;\nuniform float tileRatio;\nuniform float layerScale;\nuniform float isRenderingTerrain;\nuniform float textPitchFilter;\n#ifndef PICKING_MODE\nvarying vec2 vTexCoord;\nvarying float vGammaScale;\nvarying float vTextSize;\nvarying float vOpacity;\n#ifdef HAS_TEXT_FILL\nattribute vec4 aTextFill;\nvarying vec4 vTextFill;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nattribute vec4 aTextHaloFill;\nvarying vec4 vTextHaloFill;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nattribute vec2 aTextHalo;\nvarying vec2 vTextHalo;\n#endif\n#include <highlight_vert>\n#else\n#include <fbo_picking_vert>\n#endif\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n#ifdef HAS_TEXT_DX\nfloat d = aTextDx;\n#else\nfloat d = textDx;\n#endif\n#ifdef HAS_TEXT_DY\nfloat e = aTextDy;\n#else\nfloat e = textDy;\n#endif\n#ifdef HAS_TEXT_SIZE\nfloat f = aTextSize * layerScale;\n#else\nfloat f = textSize * layerScale;\n#endif\n#ifdef HAS_PITCH_ALIGN\nfloat h = aPitchAlign;\n#else\nfloat h = textPitchWithMap;\n#endif\ngl_Position = projViewModelMatrix * vec4(c, 1.);\n  float i = gl_Position.w;\n  float j = i / cameraToCenterDistance;\n  float k;\n  if(isRenderingTerrain == 1.) {\n    k = 1.;\n  } else {\n    float l = (1. - cameraToCenterDistance / i) * textPerspectiveRatio;\n    k = clamp(.5 + .5 * (1. - l), .0, 4.);\n  }\n#ifdef HAS_OFFSET_Z\nvec3 m = aOffset / 10.0;\n  m[2] /= altitudeScale;\n#else\nvec3 m = vec3(aOffset / 10.0, .0);\n#endif\nvec2 n = aTexCoord;\n  if(h == 1.) {\n    float o;\n    if(isRenderingTerrain == 1.) {\n      o = tileRatio;\n    } else {\n      o = tileRatio / zoomScale * j * k;\n    }\n    m.xy *= o;\n    gl_Position = projViewModelMatrix * vec4(c + m, 1.);\n  } else {\n    gl_Position.xy += m.xy * 2. / canvasSize * k * i;\n  }\n  gl_Position.xy += vec2(d, -e) * 2. / canvasSize * i;\n  if(textPitchFilter > .0) {\n    if(textPitchFilter == 1. && h == .0 || textPitchFilter == 2. && h == 1.) {\n      gl_Position = vec4(-9999., -9999., .0, 1.);\n    }\n  }\n#ifndef PICKING_MODE\nif(h == 1.) {\n    vGammaScale = j + mapPitch / 4.;\n  } else {\n    vGammaScale = mix(1., j, textPerspectiveRatio);\n  }\n  vGammaScale = clamp(vGammaScale, .0, 1.);\n  vTexCoord = n / glyphTexSize;\n  vTextSize = f;\n#ifdef ENABLE_COLLISION\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\n#ifdef HAS_OPACITY\nvOpacity *= aColorOpacity / 255.;\n#endif\n#ifdef HAS_TEXT_FILL\nvTextFill = aTextFill / 255.;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\nvTextHaloFill = aTextHaloFill / 255.;\n#endif\n#if defined(HAS_TEXT_HALO_RADIUS) || defined(HAS_TEXT_HALO_OPACITY)\nvTextHalo = aTextHalo;\n#endif\nhighlight_setVarying();\n#else\n#ifdef ENABLE_COLLISION\nbool u = aOpacity == 255.;\n#else\nbool u = true;\n#endif\nfbo_picking_setData(gl_Position.w, u);\n#endif\n}", ds = "#define SHADER_NAME TEXT_FRAG\nprecision mediump float;\nuniform float layerOpacity;\nvarying vec2 vTexCoord;\nvarying float vOpacity;\nuniform float alphaTest;\n#include <text_render_frag>\n#include <highlight_frag>\nvoid main() {\n  gl_FragColor = renderText(vTexCoord) * vOpacity * layerOpacity;\n  if(gl_FragColor.a < alphaTest) {\n    discard;\n  }\n  gl_FragColor = highlight_blendColor(gl_FragColor);\n}";

const {TextUtil: ps, PackUtil: gs, FilterUtil: ms, TEXT_MAX_ANGLE: ys} = q(), xs = function(e) {
    const t = this.layer.getRenderer();
    return !this._isHalo0(e) && t.isTileNearCamera(e) && "line" !== e.geometry.properties.textPlacement;
}, _s = function(e) {
    const t = this.layer.getRenderer();
    return !this._isHalo0(e) && !t.isForeground(e) && "line" !== e.geometry.properties.textPlacement;
}, vs = function(e) {
    const t = this.layer.getRenderer();
    return !this._isHalo0(e) && t.isTileNearCamera(e) && "line" === e.geometry.properties.textPlacement;
}, bs = function(e) {
    const t = this.layer.getRenderer(), n = e.properties.tile.z, i = t.getCurrentTileZoom();
    return !this._isHalo0(e) && !t.isForeground(e) && "line" === e.geometry.properties.textPlacement && n < i;
}, As = [ 0, 0, 3 ], Ts = [], ws = [], Ss = [], Ms = [], Ps = [], Is = [], Cs = [], ks = [], Fs = [ 1, -1 ], Os = new Int16Array(3), Rs = [], Es = [], Ds = [], Ls = [], Hs = [], zs = [], Ns = [], Vs = {}, Bs = {}, Us = {}, Gs = [], js = [], Ws = y.identity([]), Xs = [];

class Ys extends ki {
    static getBloomSymbol() {
        return [ "textBloom" ];
    }
    constructor(e, t, n, i, r, s) {
        super(e, t, n, i, r, s), this.propAllowOverlap = "textAllowOverlap", this.propIgnorePlacement = "textIgnorePlacement", 
        this.colorCache = {}, this._filter0 = xs.bind(this), this._filter1 = _s.bind(this), 
        this._lineFilter0 = vs.bind(this), this._lineFilter1 = bs.bind(this), this.isLabelCollides = Or.bind(this), 
        this._genTextNames();
    }
    prepareRender(...e) {
        super.prepareRender(...e);
        const t = this.scene.getMeshes();
        if (t && t.length) for (let e = 0; e < t.length; e++) {
            if (t[e].properties.isHalo) continue;
            const {haloMesh: n} = t[e].properties;
            n.dirtyDefines && t[e].setDefines(n.defines);
        }
    }
    updateSymbol(...e) {
        this._tagTerrainVector = void 0, this._tagTerrainSkin = void 0;
        const t = super.updateSymbol(...e);
        return this._genTextNames(), t;
    }
    isTerrainVector() {
        if (!super.isTerrainSkin()) return !1;
        if (void 0 !== this._tagTerrainVector) return this._tagTerrainVector;
        for (let e = 0; e < this.symbolDef.length; e++) {
            if ("map" !== this.symbolDef[e].textPitchAlignment) return this._tagTerrainVector = !0, 
            !0;
        }
        return this._tagTerrainVector = !1, !1;
    }
    isTerrainSkin() {
        if (!super.isTerrainSkin()) return !1;
        if (void 0 !== this._tagTerrainSkin) return this._tagTerrainSkin;
        for (let e = 0; e < this.symbolDef.length; e++) {
            const t = this.symbolDef[e].textPitchAlignment;
            if ("map" === t || k(t) || ms.isExpression(t)) return this._tagTerrainSkin = !0, 
            !0;
        }
        return this._tagTerrainSkin = !1, !1;
    }
    _genTextNames() {
        this._textNameFn = [];
        for (let e = 0; e < this.symbolDef.length; e++) {
            const t = this.symbolDef[e];
            if (ms.isExpression(t.textName)) {
                const n = ms.createExpression(t.textName, "string");
                this._textNameFn[e] = (e, t) => {
                    let i;
                    Vs.zoom = e, Bs.properties = t;
                    try {
                        i = n.evaluateWithoutErrorHandling(Vs, Bs, Us, null, Gs);
                    } catch (e) {
                        i = null;
                    }
                    return i;
                };
            } else k(t.textName) && (this._textNameFn[e] = F(t.textName));
        }
    }
    shouldDeleteMeshOnUpdateSymbol(e) {
        if (!Array.isArray(e)) return (0 === e.textHaloRadius || 0 === this.symbolDef[0].textHaloRadius) && e.textHaloRadius !== this.symbolDef[0].textHaloRadius;
        for (let t = 0; t < e.length; t++) if (e[t] && (0 === e[t].textHaloRadius || 0 === this.symbolDef[t].textHaloRadius) && e[t].textHaloRadius !== this.symbolDef[t].textHaloRadius) return !0;
        return !1;
    }
    createFnTypeConfig(e, t) {
        return Pr(e, t);
    }
    isBloom(e) {
        return !!this.getSymbol(e.properties.symbolIndex)[Ys.getBloomSymbol()[0]];
    }
    createGeometry(e, t, n) {
        const i = e;
        if (!i.glyphAtlas) return null;
        const r = super.createGeometry(i, t);
        if (!r || !r.geometry) return null;
        const {geometry: s} = r;
        return s.properties.glyphAtlas && this.drawDebugAtlas(s.properties.glyphAtlas), 
        s && i.lineVertex && (s.properties.line = i.lineVertex, s.properties.line.id = n), 
        r;
    }
    createMesh(e, t, {tileVectorTransform: n}) {
        const i = this.isEnableCollision(), r = this.isEnableUniquePlacement(), {geometry: s, symbolIndex: o} = e;
        s.properties.symbolIndex = o;
        const a = this.getSymbol(o), l = this.getSymbolDef(o), h = this.getFnTypeConfig(o), c = _r.call(this, this.regl, s, t, l, a, h, this.layer.options.collision, !i, r);
        if (c.length) {
            "line" === s.properties.textPlacement ? this._hasLineText = !0 : this._hasNormalText = !0;
        }
        return c.forEach((e => {
            e.positionMatrix = this.getAltitudeOffsetMatrix(), e.properties.tileVectorTransform = n;
        })), c;
    }
    updateCollision(e) {
        super.updateCollision(e);
        const t = this.scene.getMeshes();
        t && t.length ? (this._projectedLinesCache = {}, this._updateLabels(e.timestamp), 
        this._endCollision()) : this._endCollision();
    }
    callCurrentTileShader(e, t) {
        this.shader.filter = t.sceneFilter ? [ this._filter0, t.sceneFilter ] : this._filter0, 
        this.callRenderer(this.shader, e, t), this._shaderAlongLine.filter = t.sceneFilter ? [ this._lineFilter0, t.sceneFilter ] : this._lineFilter0, 
        this.callRenderer(this._shaderAlongLine, e, t);
    }
    callBackgroundTileShader(e, t) {
        this.shader.filter = t.sceneFilter ? [ this._filter1, t.sceneFilter ] : this._filter1, 
        this.callRenderer(this.shader, e, t), this._shaderAlongLine.filter = t.sceneFilter ? [ this._lineFilter1, t.sceneFilter ] : this._lineFilter1, 
        this.callRenderer(this._shaderAlongLine, e, t);
    }
    callRenderer(e, t, n) {
        n && n.isRenderingTerrain && k(this.symbolDef.textPitchAlignment) && (n.isRenderingTerrainSkin ? t.textPitchFilter = 1 : t.textPitchFilter = 2), 
        super.callRenderer(e, t, n);
    }
    _updateLabels() {
        let e = this.scene.getMeshes();
        if (!e || !e.length) return;
        const t = this.getMap(), n = s[t.id], i = -(n ? n.bearing : t.getBearing()) * Math.PI / 180, r = w.fromRotation(Ss, i), o = (e, t, n, i) => {
            const {start: r, end: s, mesh: o, allElements: a} = t[0];
            if (this.updateBoxCollisionFading(!0, o, t, n, i)) {
                let t = e.count;
                for (let n = r; n < s; n++) e[t++] = a[n];
                e.count = t;
            }
        }, a = this.isEnableCollision(), l = this.layer.getRenderer();
        e = e.sort(Zs);
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (!this.isMeshIterable(n)) continue;
            if (!l.isTileNearCamera(n)) {
                const {visElemts: e} = n.geometry.properties;
                e && (e.count = 0), n.geometry.setElements(e, 0);
                continue;
            }
            const i = n.geometry, s = this.getSymbol(n.properties.symbolIndex);
            n.properties.textHaloRadius = je(s.textHaloRadius) ? xr.textHaloRadius : s.textHaloRadius;
            const h = n.properties.meshKey;
            if ("line" === i.properties.textPlacement) {
                if (!i.properties.line) continue;
                a && this.startMeshCollision(n), this._updateLineLabel(n, r);
                const {aOffset: e, aOpacity: t} = i.properties;
                e.dirty && (i.updateData("aOffset", e), e.dirty = !1), t && t.dirty && (i.updateData("aOpacity", t), 
                t.dirty = !1), a && this.endMeshCollision(h);
            } else if (a) {
                this.startMeshCollision(n);
                const {elements: e, aOpacity: t, visElemts: r} = i.properties;
                r.count = 0, this.forEachBox(n, ((e, t, n, i, s) => {
                    o(r, t, n, i);
                })), t && t.dirty && i.updateData("aOpacity", t);
                const s = r.count === e.length && i.count === e.length, a = !r.count && !i.count;
                s || a || i.setElements(r, r.count), this.endMeshCollision(h);
            }
        }
    }
    isMeshIterable(e) {
        return e.isValid() && e.material && !e.material.get("isHalo") && !(this.shouldIgnoreBackground() && !this.layer.getRenderer().isForeground(e));
    }
    isMeshUniquePlaced(e) {
        if (!this.isMeshIterable(e)) return !1;
        return "line" !== this.getSymbol(e.properties.symbolIndex).textPlacement;
    }
    getUniqueEntryKey(e, t) {
        return Rr(e, t);
    }
    _updateLineLabel(e, t) {
        const n = this.getMap(), i = e.geometry, r = i.properties;
        let o = r.line;
        if (!o) return;
        const a = s[n.id], l = a ? a.pitch : n.getPitch(), h = a ? a.bearing : n.getBearing(), {lineTextPitch: c, lineTextBearing: u} = e.properties, f = 1 === e.material.uniforms.textPitchWithMap, d = r.elements;
        if (!f) {
            const t = y.multiply(Ts, n.projViewMatrix, e.localTransform), i = o.id + "-" + t.join();
            let s;
            this._projectedLinesCache[i] ? o = this._projectedLinesCache[i] : (s = r.projectedLine = r.projectedLine || new Array(o.length), 
            o = this._projectLine(s, o, t, n.width, n.height), this._projectedLinesCache[i] = s);
        }
        const p = this.isEnableCollision(), g = i.properties.visElemts = i.properties.visElemts || new d.constructor(d.length), m = i.properties.visCache = i.properties.visCache || [];
        p && (g.count = 0);
        const x = void 0 === c || !n.isInteracting() || Math.abs(l - c) > 2 || Math.abs(h - u) > 2;
        x && (this._meshCollisionStale = !0), this.forEachBox(e, ((e, n, i, r) => {
            const {start: s, end: a} = n[0];
            let l = m[r];
            if ((void 0 === l || x) && (l = this._updateLabelAttributes(e, d, s, a, o, i, f ? t : null, r)), 
            m[r] = l, p && (l = this.updateBoxCollisionFading(l, e, n, i, r), l)) {
                let e = g.count;
                for (let t = s; t < a; t++) g[e++] = d[t];
                g.count = e;
            }
        })), x && (e.properties.lineTextPitch = l, e.properties.lineTextBearing = h);
        const _ = e.geometry.properties.aAltitude;
        _ && _.dirty && (i.updateData("aAltitude", _), _.dirty = !1), !p || g.count === d.length && i.count === g.count || i.setElements(g, g.count);
    }
    _projectLine(e, t, n, i, r) {
        const s = function(e, t, n, i, r) {
            for (let s = 0; s < t.length; s += 3) v.set(on, t[s], t[s + 1], t[s + 2], 1), an(on, on, n, i, r), 
            e[s] = on[0], e[s + 1] = on[1], e[s + 2] = t[s + 2];
            return e;
        }(e, t, n, i, r);
        return s;
    }
    forEachBox(e, t) {
        const n = this.getMap(), i = y.multiply(Ts, n.projViewMatrix, e.properties.tileVectorTransform), {collideIds: r, aCount: s, features: o, elements: a} = e.geometry.properties;
        if (!r) return;
        const l = this.isEnableUniquePlacement(), h = this._getMeshBoxes(1);
        h[0].allElements = a, h[0].mesh = e;
        let c = 0, u = a[0], f = 0, d = r[u];
        for (let n = 0; n <= a.length; n += 6) if (u = a[n], r[u] !== d || n === a.length) {
            const p = o[d] && o[d].feature;
            if (l && this.isMeshUniquePlaced(e) && p && !p.label) {
                const t = p.properties || {}, {symbolIndex: n} = e.properties, i = n && this._textNameFn[n.index] ? this._textNameFn[n.index](e.properties.z, t) : this.getSymbol(e.properties.symbolIndex).textName, r = ps.resolveText(i, t);
                p.label = r;
            }
            const g = n, m = s[a[f]];
            for (let n = f; n < g; n += 6 * m) h[0].start = n, h[0].end = n + 6 * m, h[0].boxCount = m, 
            t.call(this, e, h, i, c++);
            d = r[u], f = n;
        }
    }
    _updateLabelAttributes(e, t, n, i, r, o, a) {
        const l = this.layer.getRenderer(), h = e.material.uniforms, c = 1 === h.textPitchWithMap, u = !c && l.getTerrainHelper && l.getTerrainHelper(), f = this.isEnableCollision(), d = this.getMap(), p = e.geometry, g = p.desc.positionSize, {aShape: x, aOffset: _, aAnchor: b, aAltitude: A, aPitchRotation: w} = p.properties;
        let {aProjectedAnchor: M} = p.properties;
        M || (M = p.properties.aProjectedAnchor = new Array(b.length / g * 3));
        const P = p.properties.aTextSize, I = !a, C = t[n], k = C * g;
        let F;
        F = p.data.aAltitude ? m.set(Ms, b[k], b[k + 1], A[C]) : gs.unpackPosition(Ms, b[k], b[k + 1], b[k + 2]);
        const O = an(Ps, F, o, d.width, d.height), R = p.properties.aTerrainAltitude;
        let E;
        if (R) {
            const e = R[C];
            if (e === Fe) return M[3 * C] = ke, M[3 * C + 1] = ke, M[3 * C + 2] = ke, !1;
            e ? (E = m.set(js, ...F), E[2] = 100 * e, E = an(E, E, o, d.width, d.height)) : E = O;
        } else E = O;
        const D = s[d.id], L = D ? D.devicePixelRatio : d.getdevicePixelRatio();
        if (v.scale(Xs, E, 1 / L), d.isOffscreen(Xs)) return f || qs(_, t, n, i), M[3 * C] = ke, 
        M[3 * C + 1] = ke, M[3 * C + 2] = ke, !1;
        I && (F = O), M[3 * C] = E[0], M[3 * C + 1] = E[1], M[3 * C + 2] = E[2];
        const H = I ? 1 : p.properties.tileExtent / this.layer.getTileSize().width;
        let z = !0;
        const N = t[n], V = t[i - 1], B = P ? P[N] : e.properties.textSize, U = this._updateNormal(e, B, r, N, V, F, Ms, H, a);
        if (null === U) return qs(_, t, n, i), !1;
        const G = V - N <= 3, j = Math.floor(U / 2), W = U % 2;
        for (let s = n; s < i; s += 6) {
            const a = t[s];
            let l;
            if (l = j || s !== n || G || u ? j || s !== i - 6 || G || u ? as.call(this, ws, e, B, r, a, F, Ms, H, j, E, this.layer, o, c) : Ns : zs, 
            !l) {
                z = !1, f || qs(_, t, n, i);
                break;
            }
            let d = l[2];
            W && (d -= Math.PI / 2);
            const p = ji(Is, d, 0, h.textRotateWithMap, h.textPitchWithMap), g = _.length > x.length;
            let v;
            if (g) {
                m.set(Ls, w[3 * a], w[3 * a + 1], 0);
                const e = m.normalize(Ls, Ls), t = -w[3 * a + 2];
                if (t) {
                    const n = S.setAxisAngle(Rs, e, t);
                    y.fromTranslation(Es, As), y.fromQuat(Ds, n), v = y.multiply(Ds, Ds, Es);
                }
            }
            for (let e = 0; e < 4; e++) {
                const t = 2 * (a + e);
                T.set(Cs, x[t] / 10, x[t + 1] / 10), T.scale(Cs, Cs, B / 24), T.transformMat2(Cs, Cs, p), 
                c ? (T.multiply(Cs, Cs, Fs), T.add(ks, Cs, l), g && (ks[2] = 0, v && m.transformMat4(ks, ks, v))) : (T.multiply(ks, l, Fs), 
                T.add(ks, Cs, ks)), Os[0] = 10 * ks[0], Os[1] = 10 * ks[1], g && (Os[2] = 10 * ks[2]);
                const n = (g ? 3 : 2) * (a + e);
                (_[n] !== Os[0] || _[n + 1] !== Os[1] || g && _[n + 2] !== Os[2]) && (_.dirty = !0, 
                _[n] = Os[0], _[n + 1] = Os[1], g && (_[n + 2] = Os[2]));
            }
        }
        return z;
    }
    _updateNormal(e, t, n, i, r, s, o, a, l) {
        const h = r - i <= 3, c = this.getMap(), u = this.getSymbol(e.geometry.properties.symbolIndex);
        return h ? 0 : cs.call(this, zs, Ns, e, t, n, i, r, s, o, a, c.width / c.height, l, u.textMaxAngle || ys);
    }
    isBoxCollides(e, t, n, i, r, s) {
        return this.isLabelCollides(0, e, t, n, i, r, s);
    }
    deleteMesh(e, t) {
        e && (t && (Array.isArray(e) ? e.forEach((e => {
            e && e.material && delete e.material.uniforms.texture;
        })) : e.material && delete e.material.uniforms.texture), super.deleteMesh(e, t));
    }
    delete() {
        super.delete(), this._shaderAlongLine.dispose(), delete this._projectedLinesCache, 
        this._linePicking && this._linePicking.dispose();
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    isEnableTileStencil() {
        return !this.layer.getRenderer().isEnableWorkAround("win-intel-gpu-crash");
    }
    init() {
        const e = this.regl;
        this.renderer = new g.Renderer(e);
        const {uniforms: t, extraCommandProps: n} = Mr.call(this, this.canvas, this.sceneConfig), i = this.canvas, r = {
            x: (e, t) => t.viewport ? t.viewport.x : 0,
            y: (e, t) => t.viewport ? t.viewport.y : 0,
            width: (e, t) => t.viewport ? t.viewport.width : i ? i.width : 1,
            height: (e, t) => t.viewport ? t.viewport.height : i ? i.height : 1
        };
        n.viewport = r;
        const s = {
            HAS_HIGHLIGHT_COLOR_POINT: 1
        };
        this.shader = new g.MeshShader({
            name: "text",
            vert: us,
            frag: ds,
            wgslVert: A("vt_text_vert"),
            wgslFrag: A("vt_text_frag"),
            uniforms: t,
            defines: s,
            extraCommandProps: n
        });
        let o = n;
        if (this.layer.getRenderer().isEnableWorkAround("win-intel-gpu-crash") && (o = Be({}, n), 
        o.stencil = Be({}, n.stencil), o.stencil.enable = !0, o.stencil.func.cmp = "<", 
        o.stencil.func.ref = (e, t) => 2 * t.level + (t.isHalo || 0) + 1), this._shaderAlongLine = new g.MeshShader({
            name: "text-along-line",
            vert: fs,
            frag: ds,
            wgslVert: A("vt_text_line_vert"),
            wgslFrag: A("vt_text_frag"),
            uniforms: t,
            extraCommandProps: o,
            defines: s
        }), this.pickingFBO) {
            const e = Be({
                PICKING_MODE: 1
            }, s), n = new g.FBORayPicking(this.renderer, {
                name: "text-picking",
                vert: us,
                wgslVert: A("vt_text_vert"),
                defines: e,
                uniforms: t,
                extraCommandProps: {
                    viewport: this.pickingViewport
                }
            }, this.pickingFBO, this.getMap());
            n.filter = e => {
                const t = e.properties.symbolIndex;
                return "line" !== this.getSymbol(t).textPlacement;
            };
            const i = new g.FBORayPicking(this.renderer, {
                name: "line-text-picking",
                vert: fs,
                wgslVert: A("vt_text_line_vert"),
                uniforms: t,
                defines: e,
                extraCommandProps: {
                    viewport: this.pickingViewport
                }
            }, this.pickingFBO, this.getMap());
            i.filter = e => "line" === e.geometry.properties.textPlacement, this.picking = [ n, i ];
        }
    }
    getUniformValues(e, t) {
        const n = t && t.isRenderingTerrainSkin, i = this.layer.getTileSize().width, r = n ? Ws : e.projViewMatrix, o = e.cameraToCenterDistance, a = T.set(Hs, e.width, e.height);
        n && T.set(a, i, i);
        const l = he(e.getResolution(), e), h = s[e.id], c = h ? h.pitch : e.getPitch(), u = h ? h.bearing : e.getBearing(), f = h ? h.resolution : e.getResolution();
        return {
            layerScale: this.layer.options.styleScale || 1,
            mapPitch: c * Math.PI / 180,
            mapRotation: u * Math.PI / 180,
            projViewMatrix: r,
            viewMatrix: e.viewMatrix,
            cameraToCenterDistance: o,
            canvasSize: a,
            glyphSize: qi,
            gammaScale: 1 * (this.layer.options.textGamma || 1),
            resolution: f,
            altitudeScale: l,
            viewport: n && t && t.viewport,
            textPitchFilter: 0,
            isRenderingTerrain: +!!n
        };
    }
}

function qs(e, t, n, i) {
    for (let r = n; r < i; r += 6) {
        const n = t[r];
        for (let t = 0; t < 4; t++) {
            const i = 3 * (n + t);
            (e[i] || e[i + 1] || e[i + 2]) && (e.dirty = !0, e[i] = 0, e[i + 1] = 0, e[i + 2] = 0);
        }
    }
}

function Zs(e, t) {
    const n = e.properties.level - t.properties.level;
    return 0 === n ? e.properties.meshKey - t.properties.meshKey : n;
}

var $s = "#define SHADER_NAME NATIVE_POINT\n#include <gl2_vert>\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\n#ifdef HAS_COLOR\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float markerSize;\n#ifdef PICKING_MODE\n#include <fbo_picking_vert>\n#endif\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n  gl_Position = projViewModelMatrix * positionMatrix * vec4(c, 1.);\n  gl_PointSize = markerSize;\n#ifdef HAS_COLOR\nvColor = aColor / 255.;\n#endif\n#ifdef PICKING_MODE\nfbo_picking_setData(gl_Position.w, true);\n#endif\n}";

const Js = {
    markerFill: [ 0, 0, 0 ],
    markerOpacity: 1,
    markerSize: 10
};

class Ks extends Rn {
    getPrimitive() {
        return this.isWebGPU() ? "triangles" : "points";
    }
    isTerrainSkin() {
        return !1;
    }
    isTerrainVector() {
        return this.layer.options.awareOfTerrain;
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    createMesh(e, t) {
        const {geometry: n, symbolIndex: i, ref: r} = e, s = this.getSymbol(i);
        if (void 0 === r) {
            Gt(n, this.getSymbolDef(i), this.getFnTypeConfig(i), this.layer), this.isWebGPU() || n.generateBuffers(this.regl);
        }
        const o = {};
        Xe(o, "markerOpacity", s, "markerOpacity", 1), Xe(o, "markerSize", s, "markerSize", 10), 
        Xe(o, "markerFill", s, "markerFill", "#000", Ze(this.colorCache, 3));
        const a = new g.Material(o, Js);
        a.createDefines = () => "square" !== s.markerType ? {
            USE_CIRCLE: 1
        } : null, a.appendDefines = e => ("square" !== s.markerType && (e.USE_CIRCLE = 1), 
        e);
        const l = {
            castShadow: !1,
            picking: !0
        };
        let h;
        if (this.isWebGPU()) {
            const {aPosition: e, aAltitude: t, aColor: i, aPickingId: r, aTerrainAltitude: s} = n.data, o = new Int16Array([ -1, -1, 1, -1, -1, 1, -1, 1, 1, -1, 1, 1 ]), c = new g.Geometry({
                pointPosition: o
            }, 6, 0, {
                positionSize: 2,
                positionAttribute: "pointPosition"
            });
            Be(c.properties, n.properties), c.generateBuffers(this.regl);
            const u = {
                instancePosition: e,
                instanceAltitude: t,
                aColor: i,
                aPickingId: r
            };
            s && (u.aTerrainAltitude = s), h = new g.InstancedMesh(u, n.getVertexCount(), c, a, l), 
            h.generateInstancedBuffers(this.regl);
        } else h = new g.Mesh(n, a, l);
        const c = {};
        return h.geometry.data.aAltitude && (c.HAS_ALTITUDE = 1), n.data.aColor && (c.HAS_COLOR = 1), 
        h.setDefines(c), h.positionMatrix = this.getAltitudeOffsetMatrix(), h.setLocalTransform(t), 
        h.properties.symbolIndex = i, h;
    }
    createFnTypeConfig(e, t) {
        const n = O(t.markerFill);
        return [ {
            attrName: "aColor",
            symbolName: "markerFill",
            type: Uint8Array,
            width: 4,
            define: "HAS_COLOR",
            evaluate: (t, i) => {
                const r = s[e.id], o = r ? r.zoom : e.getZoom();
                let a = n(o, t);
                return k(a) && (a = this.evaluateInFnTypeConfig(a, i, e, t, !0)), Array.isArray(a) || (a = this.colorCache[a] = this.colorCache[a] || I(a).unitArray()), 
                a = qe(a), a;
            }
        } ];
    }
    init() {
        const e = this.regl;
        this.renderer = new g.Renderer(e);
        const t = {
            x: 0,
            y: 0,
            width: () => this.canvas ? this.canvas.width : 1,
            height: () => this.canvas ? this.canvas.height : 1
        }, n = [], i = {
            name: "vt-native-point",
            vert: $s,
            frag: "#define SHADER_NAME NATIVE_POINT\nprecision mediump float;\n#include <gl2_frag>\n#ifdef USE_CIRCLE\n#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#define STANDARD_DERIVATIVES_ENABLED 1\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define STANDARD_DERIVATIVES_ENABLED 1\n#endif\n#endif\n#ifdef HAS_COLOR\nvarying vec4 vColor;\n#else\nuniform vec3 markerFill;\n#endif\nuniform float markerOpacity;\nuniform float layerOpacity;\nvoid main() {\n  float c = 1.;\n#ifdef USE_CIRCLE\nfloat r = .0, d = .0;\n  vec2 e = 2. * gl_PointCoord - 1.;\n  r = dot(e, e);\n  if(r > 1.) {\n    discard;\n  }\n#ifdef STANDARD_DERIVATIVES_ENABLED\nd = fwidth(r);\n  c = 1. - smoothstep(1. - d, 1. + d, r);\n#endif\n#endif\n#ifdef HAS_COLOR\nvec4 f = vColor;\n#else\nvec4 f = vec4(markerFill, 1.);\n#endif\nglFragColor = f * markerOpacity * c * layerOpacity;\n  if(glFragColor.a <= .01) {\n    discard;\n  }\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            wgslVert: A("vt_native_point_vert"),
            wgslFrag: A("vt_native_point_frag"),
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    return y.multiply(n, t.projViewMatrix, t.modelMatrix), n;
                }
            } ],
            defines: null,
            extraCommandProps: {
                viewport: t,
                depth: {
                    enable: !0,
                    range: this.sceneConfig.depthRange || [ 0, 1 ],
                    func: this.sceneConfig.depthFunc || "always"
                },
                blend: {
                    enable: !0,
                    func: this.getBlendFunc(),
                    equation: "add"
                }
            }
        };
        if (this.shader = new g.MeshShader(i), this.shader.version = 300, this.pickingFBO) {
            const e = [];
            this.picking = [ new g.FBORayPicking(this.renderer, {
                vert: $s,
                wgslVert: A("vt_native_point_vert"),
                uniforms: [ {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(t, n) {
                        return y.multiply(e, n.projViewMatrix, n.modelMatrix), e;
                    }
                } ],
                defines: {
                    PICKING_MODE: 1
                },
                extraCommandProps: {
                    viewport: this.pickingViewport
                }
            }, this.pickingFBO, this.getMap()) ];
        }
    }
    getUniformValues(e) {
        return {
            projViewMatrix: e.projViewMatrix,
            resolution: [ this.canvas.width, this.canvas.height ]
        };
    }
}

var Qs = "#define SHADER_NAME NATIVE_LINE\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nuniform mat4 projViewModelMatrix;\nuniform mat4 positionMatrix;\n#ifndef PICKING_MODE\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#else\n#include <fbo_picking_vert>\n#endif\n#include <vt_position_vert>\nvoid main() {\n  vec3 c = unpackVTPosition();\n  gl_Position = projViewModelMatrix * positionMatrix * vec4(c, 1.);\n#ifndef PICKING_MODE\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#endif\n#else\nfbo_picking_setData(gl_Position.w, true);\n#endif\n}";

const eo = y.identity([]);

class to extends Rn {
    constructor(e, t, n, i, r, o) {
        if (super(e, t, n, i, r, o), this.primitive = "lines", k(this.symbolDef.lineColor)) {
            const e = t.getMap(), n = O(this.symbolDef.lineColor);
            this.colorSymbol = t => {
                const i = s[e.id], r = i ? i.zoom : e.getZoom();
                return n(r, t);
            };
        }
    }
    needPolygonOffset() {
        return !0;
    }
    createMesh(e, t) {
        const {geometry: n, symbolIndex: i, ref: r} = e, s = this.getSymbol(i), o = this.getMeshUniforms(n, s);
        void 0 === r && n.generateBuffers(this.regl);
        const a = new g.Material(o), l = new g.Mesh(n, a, {
            castShadow: !1,
            picking: !0
        });
        l.setLocalTransform(t), l.properties.symbolIndex = i;
        const h = {};
        return l.geometry.data.aAltitude && (h.HAS_ALTITUDE = 1), l.setDefines(h), l;
    }
    getMeshUniforms(e, t) {
        const n = {};
        return Xe(n, "lineColor", t, "lineColor", "#000", Ze(this.colorCache)), Xe(n, "lineOpacity", t, "lineOpacity", 1), 
        n;
    }
    isEnableTileStencil(e) {
        return !!!(e && e.isRenderingTerrain && this.isTerrainSkin());
    }
    init() {
        const e = this.regl;
        this.renderer = new g.Renderer(e);
        const t = this.canvas, n = {
            x: (e, t) => t.viewport ? t.viewport.x : 0,
            y: (e, t) => t.viewport ? t.viewport.y : 0,
            width: (e, n) => n.viewport ? n.viewport.width : t ? t.width : 1,
            height: (e, n) => n.viewport ? n.viewport.height : t ? t.height : 1
        }, i = [ {
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, t) {
                const n = [];
                return y.multiply(n, t.projViewMatrix, t.modelMatrix), n;
            }
        } ], r = this.sceneConfig.depthRange, s = {
            name: "vt-native-line",
            vert: Qs,
            frag: "#define SHADER_NAME NATIVE_LINE\nprecision mediump float;\nuniform float lineOpacity;\nuniform vec4 lineColor;\nuniform float layerOpacity;\n#if defined(HAS_COLOR)\nvarying vec4 vColor;\n#endif\nvoid main() {\n  gl_FragColor = lineColor * lineOpacity;\n#if defined(HAS_COLOR)\ngl_FragColor *= vColor;\n#endif\ngl_FragColor *= layerOpacity;\n}",
            wgslVert: A("vt_native_line_vert"),
            wgslFrag: A("vt_native_line_frag"),
            uniforms: i,
            defines: null,
            extraCommandProps: {
                viewport: n,
                stencil: {
                    enable: (e, t) => this.isEnableTileStencil(t.painterContext),
                    func: {
                        cmp: () => this.isOnly2D() ? "=" : "<=",
                        ref: (e, t) => t.stencilRef
                    },
                    op: {
                        fail: "keep",
                        zfail: "keep",
                        zpass: "replace"
                    }
                },
                depth: {
                    enable: !0,
                    range: r || [ 0, 1 ],
                    func: this.sceneConfig.depthFunc || "<="
                },
                blend: {
                    enable: !0,
                    func: this.getBlendFunc(),
                    equation: "add"
                },
                polygonOffset: {
                    enable: !0,
                    offset: this.getPolygonOffset()
                }
            }
        };
        this.shader = new g.MeshShader(s), this.pickingFBO && (this.picking = [ new g.FBORayPicking(this.renderer, {
            name: "vt-native-line-picking",
            wgslVert: A("vt_native_line_vert"),
            vert: Qs,
            uniforms: i,
            defines: {
                PICKING_MODE: 1
            },
            extraCommandProps: {
                viewport: this.pickingViewport
            }
        }, this.pickingFBO, this.getMap()) ]);
    }
    getUniformValues(e, t) {
        const n = t && t.isRenderingTerrainSkin;
        return {
            projViewMatrix: n ? eo : e.projViewMatrix,
            viewport: n && t && t.viewport
        };
    }
    getPrimitive() {
        return "lines";
    }
}

const {DEFAULT_TEX_WIDTH: no} = q(), io = [ 1, 1, 1 ], ro = [ 1, 1, 1, 1 ], so = [ 0, 0 ], oo = [ 1, 1 ], ao = [], lo = new e.Coordinate(0, 0), ho = new e.Coordinate(0, 0), co = [], uo = [];

class fo extends kn {
    isEnableTileStencil() {
        return !1;
    }
    supportRenderMode(e) {
        return this.isAnimating() ? "fxaa" === e || "fxaaAfterTaa" === e : "taa" === e || "fxaa" === e;
    }
    isTerrainSkin() {
        return !1;
    }
    isTerrainVector() {
        return this.layer.options.awareOfTerrain;
    }
    isAnimating() {
        return !1;
    }
    createMesh(t, n, {tilePoint: i}) {
        if (!this.material) return this.setToRedraw(), null;
        const {geometry: r, symbolIndex: s} = t, o = this.layer instanceof e.TileLayer, a = new g.Mesh(r, this.material);
        if (this.sceneConfig.animation) {
            io[2] = .01;
            const e = [];
            y.fromScaling(e, io), y.multiply(e, n, e), n = e;
        }
        const l = this.getSymbolDef(s), h = this.getFnTypeConfig(s);
        Gt(r, l, h, this.layer);
        const c = this.getShader(), u = c.getGeometryDefines ? c.getGeometryDefines(r) : {}, f = this.getSymbol(s), d = Ze(this.colorCache);
        if (r.data.aExtrude) {
            u.IS_LINE_EXTRUSION = 1;
            const {tileResolution: e, tileRatio: t} = r.properties, n = this.getMap();
            Object.defineProperty(a.uniforms, "linePixelScale", {
                enumerable: !0,
                get: function() {
                    return t * n.getResolution() / e;
                }
            }), Xe(a.uniforms, "lineWidth", f, "lineWidth", 4), Xe(a.uniforms, "lineOpacity", f, "lineOpacity", 1), 
            Xe(a.uniforms, "lineColor", f, "lineColor", "#fff", d), Object.defineProperty(a.uniforms, "lineHeight", {
                enumerable: !0,
                get: () => {
                    const e = this.dataConfig.defaultAltitude * (this.dataConfig.altitudeScale || 1);
                    return Ke(e) ? e : 0;
                }
            });
        } else {
            Xe(a.uniforms, "polygonFill", f, "polygonFill", ro, d), Xe(a.uniforms, "polygonOpacity", f, "polygonOpacity", 1);
            const e = [];
            Object.defineProperty(a.uniforms, "vertexColorsOfType", {
                enumerable: !0,
                get: () => {
                    const t = d(f.bottomPolygonFill || ro), n = d(f.topPolygonFill || ro);
                    e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[4] = n[0], e[5] = n[1], e[6] = n[2], 
                    e[7] = n[3];
                    const i = a.geometry.properties.vertexColors;
                    if (i) {
                        let t = 8;
                        e.length = 8 + i.length;
                        for (let n = 0; n < i.length; n++) e[t++] = i[n][0], e[t++] = i[n][1], e[t++] = i[n][2], 
                        e[t++] = i[n][3];
                    }
                    return e;
                }
            });
        }
        if (r.data.aColor && (u.HAS_COLOR = 1), r.data.aOpacity && (u.HAS_OPACITY = 1), 
        r.data.aLineWidth && (u.HAS_LINE_WIDTH = 1), r.data.aLineHeight && (u.HAS_LINE_HEIGHT = 1), 
        r.data.aTerrainAltitude && (u.HAS_TERRAIN_ALTITUDE = 1), r.data.aVertexColorType) {
            const e = a.geometry.properties.vertexColors;
            let t = 2;
            e && (t += e.length), u.VERTEX_TYPES_COUNT = t;
        }
        if (r.data.aOpacity) {
            const e = r.data.aOpacity;
            for (let t = 0; t < e.length; t++) if (e[t] < 255) {
                r.properties.hasAlpha = !0;
                break;
            }
        }
        u.HAS_MIN_ALTITUDE = 1, u.HAS_LAYER_OPACITY = 1, r.generateBuffers(this.regl), a.setDefines(u), 
        a.setPositionMatrix(this.getAltitudeOffsetMatrix()), a.setLocalTransform(n), (r.properties.maxAltitude <= 0 || a.properties.level >= 3) && (a.castShadow = !1), 
        a.setUniform("maxAltitude", a.geometry.properties.maxAltitude), Object.defineProperty(a.uniforms, "minAltitude", {
            enumerable: !0,
            get: () => this.layer.options.altitude || 0
        });
        const {tileResolution: p} = r.properties, m = this.getMap(), x = this.layer.getRenderer(), _ = m.pointAtResToCoord(new e.Point(i), p), v = function(e, t, n, i, r) {
            return e.pointAtResToDistance(t, 0, i, n);
        }(m, 1, _, p), b = [];
        Object.defineProperty(a.uniforms, "uvOrigin", {
            enumerable: !0,
            get: () => this._computeUVOffset(b, s, i, p, v, o)
        }), a.setUniform("uvOffset", [ 0, 0 ]), Object.defineProperty(a.uniforms, "hasAlpha", {
            enumerable: !0,
            get: () => {
                const e = this.getSymbol(s);
                return r.properties.hasAlpha || e.polygonOpacity < 1 || e.lineOpacity < 1 || a.material && (a.material.uniforms.baseColorTexture || a.material.uniforms.emissiveTexture);
            }
        });
        const A = this.layer.getMap().getMaxNativeZoom();
        return Object.defineProperty(a.uniforms, "stencilRef", {
            enumerable: !0,
            get: () => x.isForeground(a) ? 0 : A - a.properties.tile.z
        }), a.properties.symbolIndex = s, a;
    }
    _computeUVOffset(e, t, n, i, r, s) {
        if (1 === this.dataConfig.topUVMode) return e[0] = 0, e[1] = 0, e;
        const o = this.getMap(), a = this.getSymbol(t).material;
        let l = n;
        !this.dataConfig.side && a && a.textureOrigin && (lo.set(a.textureOrigin[0], a.textureOrigin[1]), 
        o.coordToPointAtRes(lo, i, ho), l = T.set(co, n[0] - ho.x, n[1] - ho.y));
        const h = !!a && a.uvOffsetInMeter;
        let c = a && a.uvOffset || so;
        const u = this.getUVOffsetAnim();
        u && (c = this.getUVOffset(u));
        const f = a && a.uvScale || oo;
        let d = this.dataConfig.side ? 0 : l[0], p = this.dataConfig.side ? 0 : l[1];
        const g = a && a.textureWidth || no, m = g * f[1] / f[0];
        h && (d += c[0] / r, p += c[1] / r);
        const y = h ? 0 : c[0], x = h ? 0 : c[1], _ = T.set(e, d * r * f[0] / g + y, p * r * f[1] / m + x);
        return s || (_[1] *= -1), _;
    }
    callShader(e, t) {
        const n = this.sceneConfig.cullFace;
        this.sceneConfig.cullFace = "front", this.callBackgroundTileShader(e, t), void 0 === n ? delete this.sceneConfig.cullFace : this.sceneConfig.cullFace = n, 
        super.callShader(e, t);
    }
    getShadowMeshes() {
        if (!this.isVisible()) return ao;
        this.shadowCount = this.scene.getMeshes().length;
        const e = this.scene.getMeshes().filter((e => 0 === e.properties.level));
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            n.material !== this.material && n.setMaterial(this.material);
        }
        return e;
    }
    getUVOffsetAnim() {
        const e = this.getSymbols()[0];
        return e.material && e.material.uvOffsetAnim;
    }
    getUVOffset(e) {
        const t = this.getSymbols()[0], n = t.material && t.material.uvOffset || so, i = !!t.material && t.material.uvOffsetInMeter, r = performance.now() / 1e3, s = T.set(uo, n[0], n[1]);
        return s[0] = r * e[0], s[1] = r * e[0], i || (s[0] %= 1, s[1] %= 1), s;
    }
    needPolygonOffset() {
        return this._needPolygonOffset;
    }
    startFrame(...e) {
        return this._needPolygonOffset = !1, super.startFrame(...e);
    }
    addMesh(e, t) {
        for (let n = 0, i = e.length; n < i; n++) this._prepareMesh(e[n], t);
        super.addMesh(...arguments);
    }
    _prepareMesh(e, t) {
        if (null !== t) {
            const n = e.localTransform;
            0 === t && (t = .01), io[2] = t, y.fromScaling(n, io), y.multiply(n, e.properties.tileTransform, n), 
            e.setLocalTransform(n);
        } else e.setLocalTransform(e.properties.tileTransform);
        e.material !== this.material && e.setMaterial(this.material), e.geometry.properties.maxAltitude <= 0 && (this._needPolygonOffset = !0), 
        this.getSymbol(e.properties.symbolIndex).ssr ? e.ssr = 1 : e.ssr = 0;
    }
    deleteMaterial() {
        this.material && (this.material.dispose(), delete this.material);
    }
    deleteMesh(e, t) {
        if (e) if (this.scene.removeMesh(e), Array.isArray(e)) for (let n = 0; n < e.length; n++) t || (e[n].geometry.dispose(), 
        delete e[n].geometry.properties.layer), e[n].dispose(); else t || (e.geometry.dispose(), 
        delete e.geometry.properties.layer), e.dispose();
    }
    updateDataConfig(e, t) {
        return !("line-extrusion" === this.dataConfig.type && !e.altitudeProperty && !t.altitudeProperty);
    }
    createFnTypeConfig(t, n) {
        const i = O(n.polygonFill || n.lineColor), r = F(n.polygonOpacity || n.lineOpacity), s = F(n.lineWidth), o = new Uint8Array(1), a = new Uint16Array(1), l = n.polygonFill ? "polygonFill" : n.lineColor ? "lineColor" : "polygonFill", h = n.polygonOpacity ? "polygonOpacity" : n.lineOpacity ? "lineOpacity" : "polygonOpacity";
        return [ {
            attrName: "aColor",
            type: Uint8Array,
            width: 4,
            symbolName: l,
            define: "HAS_COLOR",
            evaluate: (n, r) => {
                const s = e.MapStateCache[t.id], o = s ? s.zoom : t.getZoom();
                let a = i(o, n);
                return k(a) && (a = this.evaluateInFnTypeConfig(a, r, t, n, !0)), Array.isArray(a) || (a = this.colorCache[a] = this.colorCache[a] || I(a).unitArray()), 
                a = qe(a), a;
            }
        }, {
            attrName: "aOpacity",
            type: Uint8Array,
            width: 1,
            symbolName: h,
            evaluate: (n, i) => {
                const s = e.MapStateCache[t.id], a = s ? s.zoom : t.getZoom();
                let l = r(a, n);
                return k(l) && (l = this.evaluateInFnTypeConfig(l, i, t, n, !1)), o[0] = 255 * l, 
                o[0] < 255 && (i.properties.hasAlpha = !0), o[0];
            }
        }, {
            attrName: "aLineWidth",
            type: Uint8Array,
            width: 1,
            symbolName: "lineWidth",
            define: "HAS_LINE_WIDTH",
            evaluate: n => {
                const i = e.MapStateCache[t.id], r = i ? i.zoom : t.getZoom(), o = s(r, n);
                return a[0] = Math.round(2 * o), a[0];
            }
        } ];
    }
    updateSymbol(e, t) {
        let n = !1;
        e && e.material && (n = function(e, t) {
            for (const n in t) if (go[n] && t[n] !== e[n] && (!e[n] || !t[n])) return !0;
            return !1;
        }(this.symbolDef[0].material || {}, e.material));
        const i = super.updateSymbol(e, t);
        return e && e.material && this._updateMaterial(e.material), n || i;
    }
    _isNeedRefreshStyle(e, t) {
        return po(e) !== po(t);
    }
}

function po(e) {
    if (!e || !e.material) return !1;
    for (const t in e.material) if (t.indexOf("Texture") > 0 && e.material[t]) return !0;
    return !1;
}

const go = {
    normalTexture: 1,
    bumpTexture: 1
};

const mo = g.ShaderLib.get("mesh_picking_vert"), yo = g.WgslShaderLib.get("mesh_picking").vert;

class xo extends fo {
    createGeometry(e) {
        const t = e.data, n = this.getSymbols()[0];
        if (n.material && n.material.extrusionOpacity) {
            const e = new Uint8Array(t.aPosition.length / 3);
            for (let n = 0; n < t.aPosition.length; n += 3) t.aPosition[n + 2] > 0 ? e[n / 3] = 0 : e[n / 3] = 1;
            t.aExtrusionOpacity = e;
        }
        const i = new g.Geometry(t, e.indices);
        return Be(i.properties, e.properties), this._prepareFeatureIds(i, e), {
            geometry: i,
            symbolIndex: {
                index: 0
            }
        };
    }
    updateSceneConfig(e) {
        let t;
        if (this.sceneConfig.cullFace !== e.cullFace && (t = !0), Be(this.sceneConfig, e), 
        t) {
            const e = this.getShaderConfig();
            this.shader.dispose(), this.shader = new g.PhongShader(e);
        }
        this.setToRedraw();
    }
    getShader() {
        return this.shader;
    }
    delete(e) {
        this.getMap().off("updatelights", this._updateLights, this), super.delete(e), this.material.dispose();
    }
    init() {
        this.getMap().on("updatelights", this._updateLights, this);
        const e = this.regl;
        this.renderer = new g.Renderer(e);
        const t = this.getShaderConfig();
        this.shader = new g.PhongShader(t), this._updateMaterial();
        const n = {
            vert: this.getPickingVert(),
            wgslVert: this.getPickingWGSLVert(),
            uniforms: [ "projViewMatrix", "modelMatrix", "positionMatrix", {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    return y.multiply([], t.projViewMatrix, t.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: this.pickingViewport
            }
        };
        this.picking = [ new g.FBORayPicking(this.renderer, n, this.layer.getRenderer().pickingFBO, this.getMap()) ];
    }
    _updateLights() {
        this.setToRedraw();
    }
    getShaderConfig() {
        const e = this.canvas, t = {
            x: 0,
            y: 0,
            width: () => e ? e.width : 1,
            height: () => e ? e.height : 1
        };
        return {
            extraCommandProps: {
                cull: {
                    enable: () => void 0 === this.sceneConfig.cullFace || !!this.sceneConfig.cullFace,
                    face: () => {
                        let e = this.sceneConfig.cullFace;
                        return !0 === e && (e = "back"), e || "back";
                    }
                },
                stencil: {
                    enable: !0,
                    func: {
                        cmp: "<=",
                        ref: (e, t) => t.level
                    },
                    op: {
                        fail: "keep",
                        zfail: "keep",
                        zpass: "replace"
                    }
                },
                depth: {
                    enable: !0,
                    range: this.sceneConfig.depthRange || [ 0, 1 ],
                    func: this.sceneConfig.depthFunc || "<="
                },
                blend: {
                    enable: !0,
                    func: this.getBlendFunc(),
                    equation: "add"
                },
                viewport: t,
                polygonOffset: {
                    enable: !0,
                    offset: this.getPolygonOffset()
                }
            }
        };
    }
    _updateMaterial() {
        this.material && this.material.dispose();
        const t = this.layer instanceof e.TileLayer, n = this.getSymbols()[0].material, i = {};
        for (const e in n) et(n, e) && (i[e] = n[e], "uvRotation" === e && (i[e] = i[e] * Math.PI / 180, 
        t || (i[e] *= -1)));
        this.material = new g.PhongMaterial(i);
    }
    getUniformValues(e, t) {
        const n = e.viewMatrix, i = e.projMatrix, r = e.cameraPosition, s = this._getLightUniformValues(), o = Be({
            viewMatrix: n,
            projMatrix: i,
            cameraPosition: r,
            projViewMatrix: e.projViewMatrix
        }, s);
        t && t.jitter ? o.halton = t.jitter : o.halton = [ 0, 0 ];
        const a = this.layer.getRenderer().canvas;
        return o.outSize = [ a.width, a.height ], o;
    }
    getPickingVert() {
        return mo;
    }
    getPickingWGSLVert() {
        return yo;
    }
    _getLightUniformValues() {
        const e = this.getMap().getLightManager(), t = e && e.getAmbientLight() || {}, n = e && e.getDirectionalLight() || {};
        return {
            ambientColor: t.color || [ .2, .2, .2 ],
            light0_diffuse: [ ...n.color || [ .1, .1, .1 ], 1 ],
            lightSpecular: n.specular || [ .8, .8, .8 ],
            light0_viewDirection: n.direction || [ 1, 1, -1 ]
        };
    }
}

const _o = [ 1, 1, 1 ];

class vo extends kn {
    createGeometry(e) {
        const {data: t, indices: n} = e, i = new g.Geometry(t, n, 0, {
            primitive: "lines"
        });
        return i.generateBuffers(this.regl), {
            geometry: i,
            symbolIndex: {
                index: 0
            }
        };
    }
    createMesh(e, t) {
        const {geometry: n} = e, i = new g.Mesh(n);
        if (i.castShadow = !1, this.sceneConfig.animation) {
            _o[2] = .01;
            const e = [];
            y.fromScaling(e, _o), y.multiply(e, t, e), t = e;
        }
        return i.setLocalTransform(t), i.properties.symbolIndex = {
            index: 0
        }, i;
    }
    addMesh(e, t) {
        if (!e.length) return this;
        let n;
        null !== t ? (0 === t && (t = .01), n = e[0].localTransform, _o[2] = t, y.fromScaling(n, _o), 
        y.multiply(n, e[0].properties.tileTransform, n)) : n = e[0].properties.tileTransform;
        for (let t = 0; t < e.length; t++) e[t].setLocalTransform(n);
        return this.scene.addMesh(e), this;
    }
    init() {
        const e = this.regl;
        this.scene = new g.Scene, this.renderer = new g.Renderer(e);
        const t = {
            x: 0,
            y: 0,
            width: () => this.canvas ? this.canvas.width : 1,
            height: () => this.canvas ? this.canvas.height : 1
        }, n = {
            vert: "\n    attribute vec3 aPosition;\n    attribute vec4 aColor;\n\n    uniform mat4 projViewModelMatrix;\n    uniform vec2 outSize;\n\n    varying vec4 vColor;\n\n    void main()\n    {\n        gl_Position = projViewModelMatrix * vec4(aPosition, 1.0);\n        vColor = aColor / 255.0;\n    }\n",
            frag: "\n    #ifdef GL_ES\n        precision lowp float;\n    #endif\n\n    uniform float opacity;\n\n    varying vec4 vColor;\n\n    void main()\n    {\n        gl_FragColor = vColor * opacity;\n    }\n",
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    const n = [];
                    return y.multiply(n, t.projViewMatrix, t.modelMatrix), n;
                }
            } ],
            extraCommandProps: {
                stencil: {
                    enable: !0,
                    func: {
                        cmp: "<=",
                        ref: (e, t) => t.level
                    },
                    op: {
                        fail: "keep",
                        zfail: "keep",
                        zpass: "replace"
                    }
                },
                blend: {
                    enable: !0,
                    func: this.getBlendFunc(),
                    equation: "add"
                },
                viewport: t
            }
        };
        this.shader = new g.MeshShader(n);
    }
    getUniformValues(e) {
        const t = this.sceneConfig.opacity || .3, n = this.layer.getRenderer().canvas;
        return {
            projViewMatrix: e.projViewMatrix,
            outSize: [ n.width, n.height ],
            opacity: t
        };
    }
}

const bo = g.ShaderLib.get("mesh_picking_vert"), Ao = g.WgslShaderLib.get("mesh_picking").vert, {getPBRUniforms: To} = g.pbr.PBRUtils;

class wo extends fo {
    constructor(...e) {
        super(...e), this._loader = new g.ResourceLoader(null, this.layer.getURLModifier());
    }
    supportRenderMode(e) {
        return this.getSymbols()[0].ssr ? "fxaa" === e || "fxaaAfterTaa" === e : super.supportRenderMode(e);
    }
    isAnimating() {
        const e = this._getUVOffsetAnim();
        if (e && (e[0] || e[1])) return !0;
    }
    needToRedraw() {
        const e = this._getUVOffsetAnim();
        return !(!e || !e[0] && !e[1]) || super.needToRedraw();
    }
    _getUVOffsetAnim() {
        const e = this.getSymbols()[0];
        return e.material && e.material.uvOffsetAnim;
    }
    createGeometry(e) {
        if (!e.data || !e.data.aPosition || !e.data.aPosition.length) return null;
        const t = {
            uv0Attribute: "aTexCoord0"
        };
        e.data.aAltitude && (t.altitudeAttribute = "aAltitude");
        const n = new g.Geometry(e.data, e.indices, 0, t);
        return Be(n.properties, e.properties), e.vertexColors && (n.properties.vertexColors = e.vertexColors), 
        this.material.uniforms.normalTexture && !n.data[n.desc.tangentAttribute] && n.data[n.desc.uv0Attribute] && (n.data[n.desc.normalAttribute] || n.createNormal(), 
        n.createTangent()), this._prepareFeatureIds(n, e), {
            geometry: n,
            symbolIndex: {
                index: 0
            }
        };
    }
    paint(e) {
        const t = !!e.shadow;
        e.states && e.states.includesChanged && (this.shader.dispose(), delete this.shader, 
        this._updateDepthShader.dispose(), delete this._updateDepthShader, this._createShader(e));
        let n = !!e.ssr && this.getSymbols()[0].ssr;
        const i = this.shader, r = i.shaderDefines;
        if (n) {
            const t = Be({}, r, e.ssr.defines);
            i.shaderDefines = t;
        }
        if (e.onlyUpdateDepthInTaa && (this.shader = this._updateDepthShader, !n && this._previousSSR && (this.shader = i, 
        this.setToRedraw(!0))), this.updateIBLDefines(i), super.paint(e), void 0 !== this.shadowCount && t) {
            const e = this.scene.getMeshes().length;
            this.shadowCount !== e && this.setToRedraw();
        }
        this.shader = i, n && (i.shaderDefines = r), delete this.shadowCount, this._previousSSR = n;
    }
    updateSceneConfig(e) {
        Be(this.sceneConfig, e), this.setToRedraw();
    }
    delete() {
        super.delete(), this.disposeIBLTextures(), this.material.dispose(), this._updateDepthShader && (this._updateDepthShader.dispose(), 
        delete this._updateDepthShader);
    }
    init(e) {
        this.getMap().on("updatelights", this._onUpdatelights, this), this.createIBLTextures(), 
        this._context = this._context || e;
        const t = this.regl;
        this.renderer = new g.Renderer(t), this._bindedOnTextureLoad = this._onTextureLoad.bind(this), 
        this._bindDisposeCachedTexture = this.disposeCachedTexture.bind(this), this._bindOnMaterialComplete = this._onMaterialComplete.bind(this), 
        this._updateMaterial(), this._createShader(e);
        const n = {
            vert: bo,
            wgslVert: Ao,
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: (e, t) => y.multiply([], t.projViewMatrix, t.modelMatrix)
            } ],
            extraCommandProps: {
                viewport: this.pickingViewport,
                depth: {
                    enable: !0,
                    range: this.sceneConfig.depthRange || [ 0, 1 ],
                    func: this.sceneConfig.depthFunc || "<=",
                    mask: !!je(this.sceneConfig.depthMask) || this.sceneConfig.depthMask
                }
            }
        };
        this.picking = [ new g.FBORayPicking(this.renderer, n, this.layer.getRenderer().pickingFBO, this.getMap()) ];
    }
    _createShader(e) {
        const t = {
            x: 0,
            y: 0,
            width: () => this.canvas ? this.canvas.width : 1,
            height: () => this.canvas ? this.canvas.height : 1
        }, n = {}, i = [];
        i.push(...g.SsrPass.getUniformDeclares()), this.fillIncludes(n, i, e);
        const r = {
            cull: {
                enable: (e, t) => !(t.geometryProperties.hasNegativeHeight || void 0 !== this.sceneConfig.cullFace && !this.sceneConfig.cullFace),
                face: () => this.sceneConfig.cullFace || "back"
            },
            viewport: t,
            depth: {
                enable: !0,
                range: this.sceneConfig.depthRange || [ 0, 1 ],
                func: this.sceneConfig.depthFunc || "<="
            },
            blend: {
                enable: (e, t) => void 0 === t.hasAlpha || !!t.hasAlpha,
                func: this.getBlendFunc(),
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        }, s = {
            uniforms: i,
            defines: this._getDefines(n),
            extraCommandProps: r
        };
        this.shader = new g.pbr.StandardShader(s), s.frag = "\n            precision mediump float;\n            #include <gl2_frag>\n            void main() {\n                glFragColor = vec4(0.0);\n                #if __VERSION__ == 100\n                    gl_FragColor = glFragColor;\n                #endif\n            }\n        ", 
        s.wgslFrag = "\n            fn main() -> @location(0) vec4f {\n                return vec4f(0);\n            }\n        ", 
        this._updateDepthShader = new g.pbr.StandardShader(s);
    }
    _onTextureLoad({resources: e}) {
        for (let t = 0; t < e.length; t++) this.addCachedTexture(e[t].url, e[t].data);
        this.setToRedraw(!0);
    }
    _onMaterialComplete() {
        this.setToRedraw(!0);
    }
    _updateMaterial(t) {
        if (t) {
            const e = this.getSymbols()[0].material;
            e && Be(e, t);
        }
        const n = this.layer instanceof e.TileLayer, i = this.dataConfig, r = t || this.getSymbols()[0].material, s = {};
        let o = !1;
        for (const e in r) if (et(r, e)) if (e.indexOf("Texture") > 0) {
            let t = r[e];
            if (!t) {
                s[e] = void 0;
                continue;
            }
            const n = "string" == typeof t ? t : t.url, a = this.getCachedTexture(n);
            a ? a.then ? n === t ? t = {
                promise: a,
                wrap: "repeat"
            } : t.promise = a : n === t ? t = {
                data: a,
                wrap: "repeat"
            } : t.data = a : n === t && (t = {
                url: n,
                wrap: "repeat"
            }), t.flipY = !i.upsideUpTexture, t.min = "linear mipmap linear", t.mag = "linear", 
            s[e] = new g.Texture2D(t, this._loader), s[e].once("complete", this._bindedOnTextureLoad), 
            s[e].once("disposed", this._bindDisposeCachedTexture), s[e].promise && this.addCachedTexture(n, s[e].promise), 
            o = !0;
        } else s[e] = r[e], "uvRotation" === e && (s[e] = Math.PI * s[e] / 180, n || (s[e] *= -1));
        if (void 0 === s.alphaTest && this.getMaterialClazz && (s.alphaTest = .05), this.material) {
            for (let e in s) this.material.set(e, s[e]);
            this.setToRedraw(!0);
        } else this.material = new g.pbr.StandardMaterial(s), this.material.once("complete", this._bindOnMaterialComplete);
        o || this._onMaterialComplete();
    }
    getShader() {
        return this.shader;
    }
    getUniformValues(e, t) {
        const {iblTexes: n, dfgLUT: i} = this.getIBLRes(), r = To(e, n, i, t && t.ssr, t && t.jitter);
        return this.setIncludeUniformValues(r, t), r;
    }
    _getDefines(e) {
        return this.hasIBL() ? e.HAS_IBL_LIGHTING = 1 : delete e.HAS_IBL_LIGHTING, e;
    }
    _onUpdatelights() {
        if (!this.shader) return;
        const e = this.shader.shaderDefines;
        this._getDefines(e), this.shader.shaderDefines = e;
    }
}

var So = "#include <gl2_vert>\n#define EXTRUDE_SCALE 63.0\n#define EXTRUDE_MOD 64.0\n#define MAX_LINE_DISTANCE 65535.0\nuniform mat4 projViewModelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 centiMeterToLocal;\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nattribute vec4 aTubeNormal;\n#ifdef HAS_LINE_WIDTH\nattribute float aLineWidth;\n#else\nuniform float lineWidth;\n#endif\n#include <vt_position_vert>\n#ifdef PICKING_MODE\n#include <fbo_picking_vert>\n#else\nuniform mat4 modelViewMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelMatrix;\n#if defined(HAS_PATTERN)\nuniform float resolution;\nuniform float tileResolution;\nuniform float tileRatio;\nattribute float aLinesofar;\nvarying highp float vLinesofar;\nattribute vec4 aTexInfo;\nvarying vec4 vTexInfo;\nvarying float vNormalY;\nvarying float vPatternHeight;\nattribute float aNormalDistance;\n#if defined(HAS_PATTERN_ANIM)\nattribute float aLinePatternAnimSpeed;\nvarying float vLinePatternAnimSpeed;\n#endif\n#if defined(HAS_PATTERN_GAP)\nattribute float aLinePatternGap;\nvarying float vLinePatternGap;\n#endif\n#endif\n#ifdef HAS_COLOR\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#ifdef HAS_OPACITY\nattribute float aOpacity;\n#endif\nvarying float vOpacity;\nvarying vec3 vModelNormal;\nvarying vec4 vViewVertex;\nvarying vec3 vModelVertex;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#include <highlight_vert>\nvoid main() {\n  \n#ifdef HAS_LINE_WIDTH\nfloat c = aLineWidth;\n#else\nfloat c = lineWidth;\n#endif\nfloat d = c / 2.;\n  vec3 e = aTubeNormal.xyz / EXTRUDE_SCALE;\n  vec3 f = unpackVTPosition();\n  vec4 h = vec4(f, 1.);\n  h.xy += e.xy * d * centiMeterToLocal;\n  h.z += e.z * d;\n  gl_Position = projViewModelMatrix * h;\n#ifdef PICKING_MODE\nfbo_picking_setData(gl_Position.w, true);\n#else\nvViewVertex = modelViewMatrix * h;\n  vec3 i = normalize(e);\n  vModelNormal = modelNormalMatrix * i;\n  vModelVertex = (modelMatrix * h).xyz;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(h);\n#endif\n#ifdef HAS_COLOR\nvColor = aColor / 255.;\n#endif\n#ifdef HAS_OPACITY\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\n#ifdef HAS_PATTERN\nfloat j = tileResolution / resolution;\n  float k = aLinesofar - d * centiMeterToLocal.y * aNormalDistance / EXTRUDE_SCALE;\n  vLinesofar = k / tileRatio * j;\n  vTexInfo = vec4(aTexInfo.xy, aTexInfo.zw + 1.);\n  vPatternHeight = c * centiMeterToLocal.x / tileRatio * j;\n  vNormalY = aTubeNormal.w / EXTRUDE_SCALE;\n#if defined(HAS_PATTERN_ANIM)\nvLinePatternAnimSpeed = aLinePatternAnimSpeed / 127.;\n#endif\n#if defined(HAS_PATTERN_GAP)\nvLinePatternGap = aLinePatternGap / 10.0;\n#endif\n#endif\nhighlight_setVarying();\n#endif\n}";

const {StyleUtil: Mo} = q(), {getPBRUniforms: Po} = g.pbr.PBRUtils;

class Io extends Rn {
    needToRedraw() {
        return super.needToRedraw() || this.isAnimating();
    }
    isTerrainSkin() {
        return !1;
    }
    isTerrainVector() {
        return !0;
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    supportRenderMode(e) {
        return this.isAnimating() ? "fxaa" === e || "fxaaAfterTaa" === e : "taa" === e || "fxaa" === e;
    }
    isAnimating() {
        if (this._hasPatternAnim) return !0;
        const e = this.getSymbols();
        for (let t = 0; t < e.length; t++) if (e[t].linePatternFile && e[t].linePatternAnimSpeed) return !0;
        return !1;
    }
    isBloom(e) {
        return !!this.getSymbol(e.properties.symbolIndex).lineBloom;
    }
    createMesh(t, n) {
        if (!t.geometry) return null;
        const i = this.getMap(), {geometry: r, symbolIndex: s, ref: o} = t, a = this.getSymbolDef(s);
        if (void 0 === o) {
            Gt(r, a, this.getFnTypeConfig(s), this.layer);
        }
        const l = this.getSymbol(s), {tileResolution: h, tileRatio: c} = r.properties, u = {
            tileResolution: h,
            tileRatio: c
        };
        Xe(u, "lineColor", l, "lineColor", "#fff", Ze(this.colorCache)), Xe(u, "linePatternGapColor", l, "linePatternGapColor", [ 1, 1, 1, 1 ], Ze(this.colorCache)), 
        Xe(u, "lineWidth", l, "lineWidth", 2, (e => Mo.getTubeSizeScale(this.dataConfig.metric) * e)), 
        Xe(u, "lineOpacity", l, "lineOpacity", 1), Xe(u, "linePatternAnimSpeed", l, "linePatternAnimSpeed", 0), 
        Xe(u, "linePatternGap", l, "linePatternGap", 0), Xe(u, "metallicFactor", l, "metallicFactor", 0), 
        Xe(u, "roughnessFactor", l, "roughnessFactor", .4), Xe(u, "emissiveFactor", l, "emissiveFactor", [ 0, 0, 0 ]), 
        Xe(u, "uvScale", l, "uvScale", [ 1, 1 ]);
        const f = r.properties.iconAtlas, d = this.layer instanceof e.TileLayer;
        f && (u.linePatternFile = Dn(this.regl, f, !1), u.atlasSize = f ? [ f.width, f.height ] : [ 0, 0 ], 
        u.flipY = d ? -1 : 1, this.drawDebugAtlas(f)), void 0 === o && r.generateBuffers(this.regl), 
        u.alphaTest = -1;
        const p = new g.pbr.StandardMaterial(u), m = new g.Mesh(r, p, {
            castShadow: !1,
            picking: !0
        }), y = i.distanceToPointAtRes(100, 100, r.properties.tileResolution)._multi(c / 1e4).toArray();
        m.setUniform("centiMeterToLocal", y);
        const x = i.getResolution(i.getMaxNativeZoom());
        m.setUniform("animSpeedScale", h / x), m.setLocalTransform(n);
        const _ = {
            IS_LINE_EXTRUSION: 1,
            HAS_LAYER_OPACITY: 1
        };
        return "square-tube" === this.dataConfig.type && (_.IS_SQUARE_TUBE = 1), f && (_.HAS_PATTERN = 1), 
        m.properties.symbolIndex = s, r.data.aColor && (_.HAS_COLOR = 1), this.setMeshDefines(_, r, a), 
        r.data.aAltitude && (_.HAS_ALTITUDE = 1), m.setDefines(_), m;
    }
    setMeshDefines(e, t, n) {
        t.data.aOpacity && (e.HAS_OPACITY = 1), t.data.aLineWidth && (e.HAS_LINE_WIDTH = 1), 
        en(n.linePatternAnimSpeed) && (e.HAS_PATTERN_ANIM = 1), en(n.linePatternGap) && (e.HAS_PATTERN_GAP = 1);
    }
    paint(e) {
        e.states && e.states.includesChanged.shadow && (this.shader.dispose(), this.createShader(e)), 
        super.paint(e);
    }
    init(e) {
        this.getMap().on("updatelights", this._onUpdatelights, this), this.createIBLTextures();
        const t = this.regl;
        if (this.renderer = new g.Renderer(t), this.createShader(e), this.pickingFBO) {
            const e = [], t = [], n = [];
            this.picking = [ new g.FBORayPicking(this.renderer, {
                vert: So,
                wgslVert: A("vt_tube_vert"),
                defines: {
                    PICKING_MODE: 1
                },
                uniforms: [ {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(t, n) {
                        return y.multiply(e, n.projViewMatrix, n.modelMatrix), e;
                    }
                }, {
                    name: "modelNormalMatrix",
                    type: "function",
                    fn: (e, n) => M.fromMat4(t, n.modelMatrix)
                }, {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: function(e, t) {
                        return y.multiply(n, t.viewMatrix, t.modelMatrix);
                    }
                } ],
                extraCommandProps: this.getExtraCommandProps()
            }, this.pickingFBO, this.getMap()) ];
        }
    }
    createShader(e) {
        this._context = e;
        const t = [], n = {};
        this.fillIncludes(n, t, e);
        const i = [];
        t.push({
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, t) {
                return y.multiply(i, t.projViewMatrix, t.modelMatrix), i;
            }
        }), this.shader = new g.pbr.StandardShader({
            name: "vt-tube",
            vert: So,
            wgslVert: A("vt_tube_vert"),
            uniforms: t,
            defines: this._getDefines(n),
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    getExtraCommandProps() {
        const e = this.canvas, t = {
            x: 0,
            y: 0,
            width: () => e ? e.width : 1,
            height: () => e ? e.height : 1
        }, n = this.sceneConfig.depthRange;
        return {
            viewport: t,
            stencil: {
                enable: !0,
                func: {
                    cmp: () => "<=",
                    ref: (e, t) => t.level
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            cull: {
                enable: () => !!this.sceneConfig.cullFace,
                face: this.sceneConfig.cullFace || "back"
            },
            depth: {
                enable: !0,
                range: n || [ 0, 1 ],
                mask: this.sceneConfig.depthMask || !0,
                func: this.sceneConfig.depthFunc || "<="
            },
            blend: {
                enable: !0,
                func: this.getBlendFunc(),
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: this.getPolygonOffset()
            }
        };
    }
    getUniformValues(e, t) {
        const {iblTexes: n, dfgLUT: i} = this.getIBLRes(), r = Po(e, n, i, null, t && t.jitter), s = e.projViewMatrix, o = e.viewMatrix;
        return r.projViewMatrix = s, r.viewMatrix = o, r.resolution = e.getResolution(), 
        r.currentTime = this.layer.getRenderer().getFrameTimestamp() || 0, this.setIncludeUniformValues(r, t), 
        r;
    }
    createFnTypeConfig(t, n) {
        const i = O(n.lineColor), r = O(n.aLinePatternAnimSpeed), s = O(n.aLinePatternGap), o = this.createShapeFnTypeConfigs(t, n), a = new Int8Array(2);
        return [ {
            attrName: "aColor",
            symbolName: "lineColor",
            type: Uint8Array,
            width: 4,
            define: "HAS_COLOR",
            evaluate: (n, r) => {
                const s = e.MapStateCache[t.id], o = s ? s.zoom : t.getZoom();
                let a = i(o, n);
                return k(a) && (a = this.evaluateInFnTypeConfig(a, r, t, n, !0)), Array.isArray(a) || (a = this.colorCache[a] = this.colorCache[a] || I(a).unitArray()), 
                a = qe(a), a;
            }
        }, {
            attrName: "aLinePattern",
            symbolName: "linePatternAnimSpeed",
            type: Int8Array,
            width: 2,
            related: [ "linePatternGap" ],
            define: "HAS_LINE_PATTERN",
            evaluate: (n, i, s, o) => {
                const l = e.MapStateCache[t.id], h = l ? l.zoom : t.getZoom();
                let c = r(h, n);
                return je(c) && (c = 0), 0 !== c && (i.properties.hasPatternAnim = 1), a[0] = c / 127, 
                a[1] = s[o + 1], a;
            }
        }, {
            attrName: "aLinePattern",
            symbolName: "linePatternGap",
            type: Int8Array,
            width: 2,
            related: [ "linePatternAnimSpeed" ],
            define: "HAS_LINE_PATTERN",
            evaluate: (n, i, r, o) => {
                const l = e.MapStateCache[t.id], h = l ? l.zoom : t.getZoom();
                let c = s(h, n);
                return je(c) && (c = 0), a[1] = 10 * c, a[0] = r[o], a;
            }
        } ].concat(o);
    }
    createShapeFnTypeConfigs(t, n) {
        const i = F(n.lineWidth), r = F(n.lineOpacity), s = new Uint16Array(1);
        return [ {
            attrName: "aLineWidth",
            symbolName: "lineWidth",
            type: Uint8Array,
            width: 1,
            define: "HAS_LINE_WIDTH",
            evaluate: (n, r) => {
                const o = e.MapStateCache[t.id], a = o ? o.zoom : t.getZoom();
                let l = i(a, n);
                return k(l) && (l = this.evaluateInFnTypeConfig(l, r, t, n)), s[0] = Math.round(2 * l), 
                s[0];
            }
        }, {
            attrName: "aOpacity",
            symbolName: "lineOpacity",
            type: Uint8Array,
            width: 1,
            define: "HAS_OPACITY",
            evaluate: (n, i) => {
                const o = e.MapStateCache[t.id], a = o ? o.zoom : t.getZoom();
                let l = r(a, n);
                return k(l) && (l = this.evaluateInFnTypeConfig(l, i, t, n)), s[0] = 255 * l, s[0];
            }
        } ];
    }
    _getDefines(e) {
        return this.hasIBL() ? e.HAS_IBL_LIGHTING = 1 : delete e.HAS_IBL_LIGHTING, e;
    }
    _onUpdatelights() {
        if (!this.shader) return;
        const e = this.shader.shaderDefines;
        this._getDefines(e), this.shader.shaderDefines = e;
    }
    delete() {
        super.delete(), this.disposeIBLTextures(), this.shader && (this.shader.dispose(), 
        delete this.shader);
    }
}

const Co = g.ShaderLib.get("mesh_picking_vert"), ko = g.WgslShaderLib.get("mesh_picking").vert, {PackUtil: Fo} = q(), Oo = [], Ro = [], Eo = [], Do = [], Lo = [], Ho = [], zo = [], No = [ 0, 0, 0 ], Vo = [ 0, 0, 0 ], Bo = [ 1, 1, 1 ], Uo = [], Go = [ 1, 1, 1, 1 ], jo = [], Wo = [ 1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1 ], Xo = e => class extends e {
    constructor(e, t, n, i, r, s) {
        super(e, t, n, i, r, s), this._ready = !1;
        const o = i.fetchOptions || {};
        o.referrer = window && window.location.href, this._gltfManager = e.gltfManager = e.gltfManager || new g.GLTFManager(e, {
            fetchOptions: o,
            urlModifier: e => {
                const n = t.getURLModifier();
                return n && n(e) || e;
            }
        }), this._initTRSFuncType(), this._initGLTF();
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    isAnimating() {
        const e = this.getSymbols();
        for (let t = 0; t < e.length; t++) {
            if (e[t] && this._gltfPack[t] && this._isSkinAnimating(t)) return !0;
        }
        return !1;
    }
    createGeometry(e, t) {
        const {data: n, positionSize: i} = e;
        return {
            geometry: {
                properties: Be({}, e.properties),
                data: n,
                positionSize: i,
                features: t
            },
            symbolIndex: e.symbolIndex
        };
    }
    getFnTypeConfig() {
        return Uo;
    }
    createMesh(e, t, {tileTranslationMatrix: n, tileExtent: i, tilePoint: r}, {timestamp: s}) {
        if (!this._ready) return null;
        const o = this.getMap(), {geometry: a} = e, {positionSize: l, features: h} = a;
        if (!a.data.aPosition || 0 === a.data.aPosition.length) return null;
        "native-line" === this.dataConfig.type && this._arrangeAlongLine(0, a, r, h);
        const {aPosition: c} = a.data;
        let u = c.length / l;
        const f = {
            instance_vectorA: new Float32Array(4 * u),
            instance_vectorB: new Float32Array(4 * u),
            instance_vectorC: new Float32Array(4 * u),
            aPickingId: []
        }, d = this._updateInstanceData(f, n, i, a.properties.z, a.data, l, h);
        a.data.aTerrainAltitude && (f.aTerrainAltitude = a.data.aTerrainAltitude);
        const p = {}, x = f.aPickingId, _ = function(e) {
            const t = new Map;
            for (let n = 0; n < e.length; n++) {
                const i = e[n];
                let r = t.get(i);
                r || (r = [], t.set(i, r)), r.push(n);
            }
            return t;
        }(x);
        for (const e in f) p[e] = {
            buffer: this.regl.buffer({
                dimension: f[e].length / u,
                data: f[e]
            }),
            divisor: 1
        };
        const v = this._hasFuncType(), b = this._getMeterScale(), A = y.identity([]);
        y.scale(A, A, [ b, b, b ]);
        const T = [], w = this.getSymbols();
        for (let e = 0; e < w.length; e++) {
            const t = w[e], i = this._gltfMeshInfos[e];
            if (!i) continue;
            const r = this._gltfPack[e][0], {fixSizeOnZoom: l} = t;
            let h = y.identity([]);
            v || (h = this._getSymbolTRSMatrix(h), h = y.multiply([], A, h));
            let c = 0;
            i.forEach((e => {
                const {geometry: n, nodeMatrix: i} = e;
                y.multiply(jo, Wo, i);
                let r = y.multiply(jo, h, jo);
                v && (r = y.multiply(jo, A, jo));
                const s = n.boundingBox.copy();
                s.transform(r);
                const o = this._calAnchorTranslation(s, t);
                Math.abs(o) > Math.abs(c) && (c = o);
            }));
            const b = [ 0, 0, c ], S = i.map(((i, v) => {
                const {geometry: A, materialInfo: T, morphWeights: w, extraInfo: S, nodeIndex: M} = i;
                t.alphaTest && (T.alphaTest = t.alphaTest);
                const P = new (this.getMaterialClazz(T))(T), C = {}, k = new g.InstancedMesh(p, u, A, P, {
                    transparent: !1,
                    picking: !0
                });
                if (r.hasSkinAnimation()) {
                    const t = this._updateAnimation(k, e, 0)[M];
                    k.setUniform("jointTexture", t.jointTexture), k.setUniform("jointTextureSize", t.jointTextureSize), 
                    k.setUniform("numJoints", t.numJoints), k.setUniform("skinAnimation", +this._isSkinAnimating(e)), 
                    k.properties.startTime = s, C.HAS_SKIN = 1;
                }
                w && (k.setUniform("morphWeights", w), C.HAS_MORPH = 1);
                let F = t.markerOpacity;
                F || 0 === F || (F = 1);
                let O = t.markerFill;
                if (O && te(O) && O.startsWith("rgba")) {
                    F *= I(O).alpha();
                }
                k.setUniform("hasAlpha", S.alphaMode && "BLEND" === S.alphaMode.toUpperCase() || F < 1), 
                Xe(k.uniforms, "polygonFill", t, "markerFill", Go, Ze(this.colorCache)), Xe(k.uniforms, "polygonOpacity", t, "markerOpacity", 1);
                const R = [];
                k.setPositionMatrix((() => {
                    const t = this._getMeshNodeMatrix(e, v, M);
                    y.multiply(R, Wo, t), y.multiply(R, h, R);
                    const n = y.identity(jo);
                    if (0 !== c && (y.fromTranslation(n, b), y.multiply(R, n, R)), Ke(l)) {
                        const e = o.getGLScale() / o.getGLScale(l);
                        return m.set(Oo, e, e, e), y.fromScaling(n, Oo), y.multiply(n, n, R);
                    }
                    return R;
                }));
                const E = this.layer.getRenderer().getZScale(), D = [], L = [];
                return k.setLocalTransform((() => {
                    const e = this.layer.options.altitude || 0;
                    return m.copy(L, d), L[2] += 100 * e * E, y.translate(D, n, L), D;
                })), A.generateBuffers(this.regl, {
                    excludeElementsInVAO: !0
                }), f.instance_color && (C.HAS_INSTANCE_COLOR = 1), f.aTerrainAltitude && (C.HAS_INSTANCE_TERRAIN_ALTITUDE = 1, 
                k.setUniform("terrainAltitudeScale", 100 * this.layer.getRenderer().getZScale())), 
                C.HAS_LAYER_OPACITY = 1, Be(k.properties, a.properties), k.properties.aPickingId = x, 
                k.properties.nodeIndex = M, k.properties.pickingIdIndiceMap = _, k.setDefines(C), 
                k.properties.symbolIndex = {
                    index: e
                }, k;
            }));
            T.push(...S);
        }
        return T.insContext = {
            instanceData: f,
            tileTranslationMatrix: n,
            tileExtent: i,
            aPosition: c,
            positionSize: l
        }, T;
    }
    _arrangeAlongLine(e, t, n) {
        const {tileExtent: i, z: r} = t.properties, {data: s, positionSize: a} = t;
        let l = this._calGLTFScale(e);
        const h = this._getMeterScale();
        l = m.scale([], l, h);
        const c = {
            gapLength: this.dataConfig.gapLength || 0,
            direction: this.dataConfig.direction || 0,
            scaleVertex: !0
        }, u = this._gltfPack[0][0], {aPosition: f, aAltitude: d, aPickingId: p} = s, g = new o(0, 0, 0), y = new o(0, 0, 0), x = [], _ = d ? [] : x, v = [], b = [], A = [], T = [], w = [], S = [], M = this.layer.getTileSize().width / i * this.layer.getRenderer().getTileGLScale(r), P = this.layer.getRenderer().getZScale();
        let I = p[0];
        const C = [];
        for (let e = 0; e < f.length - a; e += a) {
            const t = p[e / a + 1];
            if (t !== I) {
                I = t;
                continue;
            }
            d ? m.set(w, f[e], f[e + 1], d[e / a]) : Fo.unpackPosition(w, f[e], f[e + 1], f[e + 2]);
            const [i, r, s] = w;
            let o = e + a;
            d ? m.set(S, f[o], f[o + 1], d[o / a]) : Fo.unpackPosition(S, f[o], f[o + 1], f[o + 2]);
            const [h, k, F] = S, O = p[e / a], R = g.set(i * M, r * M, s * P), E = y.set(h * M, k * M, F * P), D = R.distanceTo(E);
            this._getSymbolRotationScaleMatrix(C, n, p, e / a);
            const L = u.arrangeAlongLine(R, E, D, l, 1, C, c);
            for (let e = 0; e < L.length; e++) {
                const t = L[e];
                g.set(i, r, s), y.set(h, k, F);
                const n = Yo(g, y, t.t);
                x.push(n.x, n.y), _.push(n.z), v.push(O), b.push(-t.rotationZ * Math.PI / 180), 
                A.push(t.rotationXY * Math.PI / 180), T.push(...t.scale);
            }
        }
        t.data = {
            aPosition: new f.constructor(x),
            aPickingId: new p.constructor(v),
            aZRotation: b,
            aXYRotation: A,
            aScaleXYZ: T
        }, d && (t.data.aAltitude = new d.constructor(_));
    }
    _calGLTFScale(e) {
        const t = this.getSymbols()[e], n = [ 1, 1, 1 ], i = t.modelHeight;
        if (i) {
            this._gltfPack[e][0].calModelHeightScale(n, i);
        }
        return m.set(Lo, t.scaleX || 1, t.scaleY || 1, t.scaleZ || 1), m.multiply(n, n, Lo);
    }
    _getMeshNodeMatrix(e, t, n) {
        const i = e, r = this._gltfMeshInfos[i][t];
        return this._isSkinAnimating(e) && this._nodeMatrixMap && this._nodeMatrixMap[n] || r.nodeMatrix;
    }
    _updateAnimation(e, t, n) {
        if (!this._gltfPack) return;
        const i = this._gltfPack[t][0];
        this._skinMap || (this._skinMap = {}), this._nodeMatrixMap = {}, this._skinMap[e.uuid] || (this._skinMap[e.uuid] = {});
        const r = this.getSymbols()[t], s = this._gltfJSON[t], {loop: o, speed: a, animationName: l} = r, h = l || s.animations[0].name;
        return i.updateAnimation(n, o || !1, a || 1, h, e.properties.startTime || 0, this._nodeMatrixMap, this._skinMap[e.uuid]), 
        this._skinMap[e.uuid];
    }
    _calAnchorTranslation(e, t) {
        const n = t.anchorZ || "center";
        let i = 0;
        const r = e.max[2] - e.min[2];
        return "bottom" === n ? i = r / 2 : "top" === n && (i = -r / 2), i;
    }
    addMesh(e, t, n) {
        if (!e) return null;
        if (e[0].properties.level > 2) return null;
        const i = n.timestamp;
        for (let t = 0; t < e.length; t++) {
            if (!e[t] || !e[t].geometry) continue;
            e[t].instancedData.aTerrainAltitude && this._updateTerrainAltitude(e[t], e[t].instancedData, e[t].properties, 3, n);
            const r = e[t].properties.symbolIndex.index, s = this._isSkinAnimating(r);
            s && this._updateAnimation(e[t], r, i), e[t].setUniform("skinAnimation", +s), this._highlightMesh(e[t]);
        }
        return this.scene.addMesh(e), this;
    }
    _updateATerrainAltitude(e, t) {
        e && e.updateInstancedData && e.updateInstancedData("aTerrainAltitude", t);
    }
    prepareRender(e) {
        const t = this.getSymbols();
        let n = !1;
        for (let e = 0; e < t.length; e++) {
            if (!t[e] || !this._gltfPack[e]) continue;
            if (this._isSkinAnimating(e) && this._gltfPack[e] && !n) {
                n = !0;
                break;
            }
        }
        n && this.setToRedraw(!0), super.prepareRender(e);
    }
    getShadowMeshes() {
        if (!this.isVisible()) return Uo;
        this.shadowCount = this.scene.getMeshes().length;
        return this.scene.getMeshes().filter((e => 0 === e.properties.level));
    }
    _isSkinAnimating(e) {
        const t = this.getSymbols()[e];
        return !!(t && t.animation && this._gltfPack[e] && this._gltfPack[e][0] && this._gltfPack[e][0].hasSkinAnimation());
    }
    _updateInstanceData(e, t, n, i, r, s, o) {
        function a(t, n, i, r) {
            e[t][4 * n] = i[r], e[t][4 * n + 1] = i[r + 4], e[t][4 * n + 2] = i[r + 8], e[t][4 * n + 3] = i[r + 12];
        }
        const {aPosition: l, aPickingId: h, aXYRotation: c, aZRotation: u, aAltitude: f, aScaleXYZ: d} = r, p = l.length / s, g = this.layer.getTileSize().width / n * this.layer.getRenderer().getTileGLScale(i), x = this.layer.getRenderer().getZScale(), _ = 100 * (this.dataConfig.altitudeOffset || 0);
        let v = 1 / 0, b = 1 / 0, A = 1 / 0, T = -1 / 0, w = -1 / 0, S = -1 / 0;
        const M = [], P = [];
        for (let e = 0; e < p; e++) {
            f ? m.set(P, l[e * s], l[e * s + 1], f[e]) : Fo.unpackPosition(P, l[e * s], l[e * s + 1], l[e * s + 2]);
            const t = m.set(M, P[0] * g, -P[1] * g, (P[2] + _) * x);
            t[0] < v && (v = t[0]), t[0] > T && (T = t[0]), t[1] < b && (b = t[1]), t[1] > w && (w = t[1]), 
            t[2] < A && (A = t[2]), t[2] > S && (S = t[2]);
        }
        const I = (v + T) / 2, C = (b + w) / 2, k = (A + S) / 2, F = [], O = this._hasFuncType(), R = [ 0, 0, 1 ], E = [ 0, 0, 0 ];
        for (let t = 0; t < p; t++) {
            f ? m.set(P, l[t * s], l[t * s + 1], f[t]) : Fo.unpackPosition(P, l[t * s], l[t * s + 1], l[t * s + 2]);
            const n = P[0], i = P[1], r = m.set(M, n * g - I, -i * g - C, (P[2] + _) * x - k), p = m.set(Lo, 1, 1, 1);
            d && (m.set(p, d[3 * t], d[3 * t + 1], d[3 * t + 2]), y.fromScaling(Ho, p));
            const v = c && c[t] || 0, b = u && u[t] || 0;
            if (v || b) {
                y.fromRotation(F, b, R);
                const e = m.set(Oo, Math.cos(b), Math.sin(b), 0), t = m.rotateZ(e, e, E, 90 * Math.PI / 180);
                y.rotate(F, F, v, t), d && y.multiply(F, F, Ho);
                const n = y.fromTranslation(jo, r);
                y.multiply(F, n, F);
            } else y.fromTranslation(F, r), d && y.multiply(F, F, Ho);
            if (O) {
                let e = this._getSymbolTRSMatrix(jo, o, h, t);
                const n = this._getMeterScale(), i = y.identity([]);
                y.scale(i, i, [ n, n, n ]), e = y.multiply([], i, e), y.multiply(F, F, e);
            }
            a("instance_vectorA", t, F, 0), a("instance_vectorB", t, F, 1), a("instance_vectorC", t, F, 2), 
            e.aPickingId[t] = h[t];
        }
        return m.set(M, I, C, k), M;
    }
    _getMeterScale() {
        if (!this._meterScale) {
            const e = this.getMap();
            this._meterScale = 100 * he(e.getGLRes(), e);
        }
        return this._meterScale;
    }
    _getSymbolRotationScaleMatrix(e, t, n, i) {
        return this._getSymbolTRSMatrix(e, t, n, i, !0);
    }
    _getSymbolTRSMatrix(e, t, n, i, r) {
        const o = this.getMap(), a = this.symbolDef[0], l = this._getMeterScale();
        let h = a.translationX || 0, c = a.translationY || 0, u = a.translationZ || 0;
        r && (h = c = u = 0);
        let f = a.rotationX || 0, d = a.rotationY || 0, p = a.rotationZ || 0, g = a.scaleX || 1, y = a.scaleY || 1, x = a.scaleZ || 1;
        const _ = n && n[i], v = t && t[_], b = s[o.id], A = b ? b.zoom : o.getZoom(), T = v && v.feature && v.feature.properties, w = this._getModelHeightScale(A, T);
        r || (this._txFn && (h = this._txFn(A, T)), this._tyFn && (c = this._tyFn(A, T)), 
        this._tzFn && (u = this._tzFn(A, T)));
        const S = m.set(Ro, h * l, c * l, u * l);
        this._rxFn && (f = this._rxFn(A, T)), this._ryFn && (d = this._ryFn(A, T)), this._rzFn && (p = this._rzFn(A, T));
        const M = m.set(Eo, f, d, p);
        this._sxFn && (g = this._sxFn(A, T)), this._syFn && (y = this._syFn(A, T)), this._szFn && (x = this._szFn(A, T));
        const P = m.set(Do, g * w, y * w, x * w);
        return this._getGLTFMatrix(e, S, M, P);
    }
    _getModelHeightScale(e, t) {
        const n = this.symbolDef[0];
        let i = this._modelHeightFn ? this._modelHeightFn(e, t) : n.modelHeight;
        if (se(i)) return 1;
        const r = this._gltfBBox[0];
        return i / Math.abs(r.max[1] - r.min[1]);
    }
    getShaderConfig() {
        const e = super.getShaderConfig();
        return e.positionAttribute = "POSITION", e.normalAttribute = "NORMAL", e;
    }
    init(e) {
        super.init(e), this._initGLTF();
    }
    _initTRSFuncType() {
        const e = this.symbolDef[0];
        k(e.modelHeight) && (this._modelHeightFn = F(e.modelHeight)), k(e.translationX) && (this._txFn = F(e.translationX)), 
        k(e.translationY) && (this._tyFn = F(e.translationY)), k(e.translationZ) && (this._tzFn = F(e.translationZ)), 
        k(e.rotationX) && (this._rxFn = F(e.rotationX)), k(e.rotationY) && (this._ryFn = F(e.rotationY)), 
        k(e.rotationZ) && (this._rzFn = F(e.rotationZ)), k(e.scaleX) && (this._sxFn = F(e.scaleX)), 
        k(e.scaleY) && (this._syFn = F(e.scaleY)), k(e.scaleZ) && (this._szFn = F(e.scaleZ));
    }
    _hasFuncType() {
        return !!(this._modelHeightFn && !this._modelHeightFn.isFeatureConstant || this._txFn && !this._txFn.isFeatureConstant || this._tyFn && !this._tyFn.isFeatureConstant || this._tzFn && !this._tzFn.isFeatureConstant || this._rxFn && !this._rxFn.isFeatureConstant || this._ryFn && !this._ryFn.isFeatureConstant || this._rzFn && !this._rzFn.isFeatureConstant || this._sxFn && !this._sxFn.isFeatureConstant || this._syFn && !this._syFn.isFeatureConstant || this._szFn && !this._szFn.isFeatureConstant);
    }
    _initGLTF() {
        if (this._gltfPack) return;
        this._gltfPack = [], this._gltfJSON = [], this._gltfBBox = [], this._gltfMeshInfos = [];
        const e = this.getSymbols();
        this._loaded = 0;
        for (let t = 0; t < e.length; t++) {
            const n = e[t].url || "pyramid";
            this._gltfManager.loginGLTF(n);
            const i = this._gltfManager.getGLTF(n);
            if (i.then) i.then((n => {
                if (!n.gltfPack) return this._loaded++, void (this._loaded >= e.length && (this._ready = !0, 
                this.setToRedraw(!0)));
                const {gltfPack: i, json: r, bbox: s} = n;
                this._gltfPack[t] = [ i ], this._gltfMeshInfos[t] = i.getMeshesInfo(), this._gltfJSON[t] = r, 
                this._gltfBBox[t] = s, this._loaded++, this._loaded >= e.length && (this._ready = !0), 
                this.setToRedraw(!0);
            })); else {
                const {gltfPack: e, json: n, bbox: r} = i;
                e && (this._gltfPack[t] = [ e ], this._gltfMeshInfos[t] = e.getMeshesInfo(), this._gltfJSON[t] = n, 
                this._gltfBBox[t] = r, this._loaded++);
            }
        }
        this._loaded >= e.length && (this._ready = !0);
    }
    getPickingVert() {
        return Co;
    }
    getPickingWGSLVert() {
        return ko;
    }
    deleteMesh(e) {
        if (e) {
            this.scene.removeMesh(e);
            for (let t = 0; t < e.length; t++) {
                const n = this._skinMap && this._skinMap[e[t].uuid];
                if (n) {
                    for (const e in n) n[e].jointTexture && n[e].jointTexture.destroy();
                    delete this._skinMap[e[t].uuid];
                }
                e[t].disposeInstancedData(), e[t].dispose();
            }
        }
    }
    delete() {
        super.delete();
        const e = this.getSymbols();
        for (let t = 0; t < e.length; t++) {
            const n = e[t].url || "pyramid";
            this._gltfManager.logoutGLTF(n);
        }
        if (this._skinMap) {
            for (const e in this._skinMap) {
                const t = this._skinMap[e];
                for (const e in t) t[e].jointTexture && t[e].jointTexture.destroy();
            }
            delete this._skinMap;
        }
        delete this._nodeMatrixMap;
    }
    _getGLTFMatrix(e, t, n, i) {
        const r = m.set(Oo, ...t || No), s = n || Vo, o = i || Bo, a = S.fromEuler(zo, s[0], s[1], s[2]);
        return y.fromRotationTranslationScale(e, a, r, o);
    }
    shouldDrawParentTile() {
        return !1;
    }
};

function Yo(e, t, n) {
    const i = qo(e.x, t.x, n), r = qo(e.y, t.y, n), s = qo(e.z || 0, t.z || 0, n);
    return new e.constructor(i, r, s);
}

function qo(e, t, n) {
    return e + n * (t - e);
}

class Zo extends(Xo(xo)){
    getMaterialClazz(e) {
        return e.diffuseFactor ? g.PhongSpecularGlossinessMaterial : g.PhongMaterial;
    }
}

class $o extends(Xo(wo)){
    getMaterialClazz(e) {
        return e.specularGlossinessTexture || e.diffuseTexture ? g.pbr.StandardSpecularGlossinessMaterial : g.pbr.StandardMaterial;
    }
}

const {getPBRUniforms: Jo} = g.pbr.PBRUtils, Ko = {
    color: [ 2.0303, 2.028, 2.028 ],
    direction: [ 0, -.2717, -1 ]
}, Qo = .3737, ea = {
    index: 0
}, ta = [ 0, 0, 0 ], na = [ 2, 2 ];

class ia extends Rn {
    supportRenderMode(e) {
        return "fxaa" === e || "fxaaBeforeTaa" === e;
    }
    needPolygonOffset() {
        return !0;
    }
    isTerrainSkin() {
        return !1;
    }
    isTerrainVector() {
        return !0;
    }
    needToRedraw() {
        if (super.needToRedraw()) return !0;
        return this.getSymbol(ea).animation;
    }
    createMesh(e, t) {
        const {geometry: n} = e;
        n.generateBuffers(this.regl);
        const i = new g.Mesh(n, null, {
            castShadow: !1,
            picking: !0
        });
        return i.properties.symbolIndex = ea, i.setLocalTransform(t), i;
    }
    callShader(e, t) {
        super.callShader(e, t), this.transformWater();
        const n = this._getWaterUniform(this.getMap(), t);
        this._drawCount += this.renderer.render(this._waterShader, n, this._waterScene, this.getRenderFBO(t));
    }
    addMesh(e, t) {
        this._prepareMesh(e, t), super.addMesh(...arguments);
    }
    _prepareMesh(e) {
        const t = this.getSymbol(ea).ssr;
        for (let n = 0; n < e.length; n++) e[n].ssr = t ? 1 : 0;
    }
    paint(e) {
        e.states && e.states.includesChanged && (this.shader.dispose(), this._waterShader.dispose(), 
        this._createShader(e));
        const t = !!e.ssr && this.getSymbol(ea).ssr, n = this._waterShader, i = n.shaderDefines;
        if (t) {
            const t = Be({}, i, e.ssr.defines);
            n.shaderDefines = t;
        }
        this.updateIBLDefines(n), this._water.ssr = t ? 1 : 0, super.paint(e), t && (n.shaderDefines = i);
    }
    isEnableTileStencil() {
        return !1;
    }
    init(e) {
        this.createIBLTextures();
        const t = this.regl;
        this.renderer = new g.Renderer(t), this.createGround(), this._createShader(e), this.pickingFBO && (this.picking = [ new g.FBORayPicking(this.renderer, {
            vert: En,
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    const n = [];
                    return y.multiply(n, t.projViewMatrix, t.modelMatrix), n;
                }
            } ],
            extraCommandProps: {
                viewport: this.pickingViewport
            }
        }, this.pickingFBO, this.getMap()) ]), this._loadTextures();
    }
    _loadTextures() {
        const e = this.regl;
        this._emptyTex || (this._emptyTex = e.texture(2));
        const t = this.layer.getURLModifier(), n = this.getSymbol({
            index: 0
        }), i = n.texWaveNormal, r = this.getCachedTexture(i), s = this;
        if (r) this._normalTex || (r.isLoading ? setTimeout((() => {
            this.shader && this._loadTextures();
        }), 20) : this._normalTex = this._createTex(e, r)); else {
            const n = new Image;
            n.isLoading = !0, n.onload = function() {
                delete this.isLoading, s._normalTex = s._createTex(e, this), s.setToRedraw();
            }, n.onerror = () => {
                console.error("invalid water wave normal texture:" + i);
            }, this.addCachedTexture(i, n), n.src = t && t(i) || i;
        }
        const o = n.texWavePerturbation, a = this.getCachedTexture(o);
        if (a) this._pertTex || (a.isLoading ? setTimeout((() => {
            this._loadTextures(), this.shader;
        }), 20) : this._pertTex = this._createTex(e, a)); else {
            const n = new Image;
            n.isLoading = !0, n.onload = function() {
                delete this.isLoading, s._pertTex = s._createTex(e, this), s.setToRedraw();
            }, n.onerror = () => {
                console.error("invalid water wave perturbation texture:" + o);
            }, this.addCachedTexture(o, n), n.src = t && t(o) || o;
        }
    }
    _createTex(e, t) {
        return this._emptyTex ? e.texture({
            width: t.width,
            height: t.height,
            mag: "linear",
            min: "linear mipmap linear",
            wrapS: "repeat",
            wrapT: "repeat",
            flipY: !0,
            data: t
        }) : null;
    }
    _createShader(e) {
        const t = this.canvas, n = [], i = [ {
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, t) {
                const n = [];
                return y.multiply(n, t.projViewMatrix, t.modelMatrix), n;
            }
        }, {
            name: "modelViewNormalMatrix",
            type: "function",
            fn: (e, t) => {
                const n = y.multiply([], t.viewMatrix, t.modelMatrix), i = y.invert(n, n), r = y.transpose(i, i);
                return M.fromMat4([], r);
            }
        }, {
            name: "modelViewMatrix",
            type: "function",
            fn: (e, t) => y.multiply([], t.viewMatrix, t.modelMatrix)
        }, {
            name: "environmentTransform",
            type: "function",
            fn: (e, t) => {
                const i = t.environmentOrientation || 0;
                return M.fromRotation(n, Math.PI * i / 180);
            }
        } ], r = {
            TIME_NOISE_TEXTURE_REPEAT: Qo
        };
        this.fillIncludes(r, i, e);
        const s = {
            x: 0,
            y: 0,
            width: () => t ? t.width : 1,
            height: () => t ? t.height : 1
        }, o = this.sceneConfig.depthRange;
        this.shader = new g.MeshShader({
            vert: "\n                attribute vec3 aPosition;\n\n                uniform mat4 projViewModelMatrix;\n                uniform float minAltitude;\n\n                void main() {\n                    vec3 position = aPosition;\n                    position.z += minAltitude * 100.0;\n                    gl_Position = projViewModelMatrix * vec4(position, 1.);\n                }\n            ",
            frag: "\n    #define SHADER_NAME WATER_STENCIL\n    precision mediump float;\n    void main() {\n        gl_FragColor = vec4(1.0, 0.0, 0.0, 1.0);\n    }\n",
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    const n = [];
                    return y.multiply(n, t.projViewMatrix, t.modelMatrix), n;
                }
            } ],
            extraCommandProps: {
                viewport: s,
                colorMask: [ !1, !1, !1, !1 ],
                stencil: {
                    enable: !0,
                    func: {
                        cmp: "<=",
                        ref: 254
                    },
                    op: {
                        fail: "keep",
                        zfail: "keep",
                        zpass: "replace"
                    }
                },
                depth: {
                    enable: !0,
                    range: o || [ 0, 1 ],
                    func: this.sceneConfig.depthFunc || "<="
                },
                polygonOffset: {
                    enable: !0,
                    offset: this.getPolygonOffset()
                }
            }
        });
        const a = {
            viewport: s,
            stencil: {
                enable: !0,
                func: {
                    cmp: "==",
                    ref: 254
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            depth: {
                enable: !1
            }
        };
        i.push(...g.SsrPass.getUniformDeclares()), this._waterShader = new g.MeshShader({
            vert: "#define SHADER_NAME WATER\nuniform mat4 modelMatrix;\nuniform mat4 projViewModelMatrix;\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nuniform vec2 uvOffset;\nuniform vec2 noiseUvOffset;\nuniform vec2 uvScale;\nvarying vec2 vUv;\nvarying vec2 vNoiseUv;\nvarying vec3 vPos;\nvarying mat3 vTbnMatrix;\n#ifdef HAS_SSR\nuniform mat4 modelViewMatrix;\nvarying vec4 vViewVertex;\n#endif\n#include <highlight_vert>\nmat3 c(in vec3 d) {\n  vec3 t = normalize(cross(d, vec3(.0, 1., .0)));\n  vec3 e = normalize(cross(d, t));\n  return mat3(t, e, d);\n}\n#if defined(HAS_SHADOWING)\n#include <vsm_shadow_vert>\n#endif\nconst vec3 f = vec3(0., 0., 1.);\nvoid main(void) {\n  vec4 h = vec4(aPosition, 1.);\n  vec4 i = modelMatrix * h;\n  vPos = i.xyz;\n  vTbnMatrix = c(f);\n  gl_Position = projViewModelMatrix * h;\n  vUv = aTexCoord * uvScale + uvOffset;\n  vNoiseUv = aTexCoord * uvScale * TIME_NOISE_TEXTURE_REPEAT + noiseUvOffset;\n#ifdef HAS_SSR\nvec4 j = modelViewMatrix * h;\n  vViewVertex = j;\n#endif\n#if defined(HAS_SHADOWING)\nshadow_computeShadowPars(h);\n#endif\nhighlight_setVarying();\n}",
            frag: "#define SHADER_NAME WATER\nprecision highp float;\nprecision highp sampler2D;\n#include <hsv_frag>\nuniform vec3 hsv;\nuniform float contrast;\nuniform float layerOpacity;\n#if defined(HAS_SHADOWING)\n#include <vsm_shadow_frag>\n#endif\n#include <highlight_frag>\n#if defined(HAS_IBL_LIGHTING)\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform sampler2D brdfLUT;\nuniform mat3 environmentTransform;\nuniform vec3 diffuseSPH[9];\nvec3 c(const in vec3 d) {\n  vec3 e = environmentTransform * d;\n  float x = e.x;\n  float y = e.y;\n  float z = e.z;\n  vec3 f = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    f = hsv_apply(f, hdrHSV);\n  }\n  return max(f, vec3(.0));\n}\nvec3 h(const in vec3 i, const in float j, const in float k, const in float l) {\n  vec4 rgba = texture2D(brdfLUT, vec2(k, j));\n  float b = (rgba[3] * 65280.0 + rgba[2] * 255.);\n  float a = (rgba[1] * 65280.0 + rgba[0] * 255.);\n  const float m = 1. / 65535.;\n  return (i * a + b * l) * m;\n}\n#else\nuniform vec3 ambientColor;\n#endif\nstruct PBRShadingWater {\n  float NdotL;\n  float NdotV;\n  float NdotH;\n  float VdotH;\n  float LdotH;\n  float VdotN;\n};\nvec3 o(const in vec4 u, const in float v) {\n  if(v <= .0)\n    return u.rgb;\n  return v * u.rgb * u.a;\n}\n#ifdef HAS_SSR\nvarying vec4 vViewVertex;\nuniform mat3 modelViewNormalMatrix;\nuniform sampler2D TextureDepth;\nuniform highp vec2 outSize;\nuniform float ssrFactor;\nuniform float ssrQuality;\nuniform sampler2D TextureReflected;\nuniform highp mat4 projMatrix;\nuniform mat4 invProjMatrix;\nuniform vec4 outputFovInfo[2];\nuniform mat4 reprojViewProjMatrix;\nuniform vec2 cameraNearFar;\nfloat A(const in vec4 B) {\n  return B.r + B.g / 255.;\n}\nfloat C(const in vec2 D, const in float E) {\n  vec3 F = vec3(.06711056, .00583715, 52.9829189);\n  return fract(F.z * fract(dot(D.xy + E * vec2(47., 17.) * .695, F.xy))) * .5;\n}\nvec3 G(const in float H, const in float I, const in vec2 J) {\n  float K = min(I - .01, H);\n  float L = floor(K);\n  float M = min(I, L + 1.);\n  float N = pow(2., M);\n  vec2 O = 2. * N / J;\n  if(K - L > .5)\n    N *= 2.;\n  return vec3(O, N);\n}\nvec2 P(const in vec2 Q, const in vec3 R) {\n  vec2 S = max(R.xy, min(1. - R.xy, Q));\n  return vec2(2. * S.x, R.z - 1. - S.y) / R.z;\n}\nvec3 T(const in mat4 U, const in vec3 V) {\n  vec4 W = U * vec4(V, 1.);\n  return vec3(.5 + .5 * W.xy / W.w, W.w);\n}\nvec3 X(const in float Y, const in vec2 S) {\n  return texture2D(TextureReflected, S).rgb;\n}\nfloat Z(float ba) {\n  highp mat4 U = projMatrix;\n  highp float z = ba * 2. - 1.;\n  return -U[3].z / (z + U[2].z);\n}\nfloat bb(const vec2 S) {\n  float ba = A(texture2D(TextureDepth, S));\n  return ba;\n}\nvec3 bc(const in float E, const in vec3 bd, const in vec3 be, const in vec3 bf, const in vec3 bg, const in float bh) {\n  vec2 bi;\n  bi.x = C(gl_FragCoord.yx, E);\n  bi.y = fract(bi.x * 52.9829189);\n  bi.y = mix(bi.y, 1., .7);\n  float bj = 2. * 3.14159 * bi.x;\n  float bk = pow(max(bi.y, .000001), bh / (2. - bh));\n  float bl = sqrt(1. - bk * bk);\n  vec3 bm = vec3(bl * cos(bj), bl * sin(bj), bk);\n  bm = bm.x * bd + bm.y * be + bm.z * bf;\n  return normalize((2. * dot(bg, bm)) * bm - bg);\n}\nfloat bn(const in float E) {\n  return (C(gl_FragCoord.xy, E) - .5);\n}\nvec3 bo(const in vec3 bp, const in float bq, const in vec3 br) {\n  vec3 bs = T(projMatrix, vViewVertex.xyz + br * bq);\n  bs.z = 1. / bs.z;\n  bs -= bp;\n  float bt = min(1., .99 * (1. - bp.x) / max(1e-5, bs.x));\n  float bu = min(1., .99 * (1. - bp.y) / max(1e-5, bs.y));\n  float bv = min(1., .99 * bp.x / max(1e-5, -bs.x));\n  float bw = min(1., .99 * bp.y / max(1e-5, -bs.y));\n  return bs * min(bt, bu) * min(bv, bw);\n}\nfloat bx(const in vec3 bp, const in vec3 bs, inout float by, inout float bz) {\n  float bA = (bz + by) * .5;\n  vec3 bB = bp + bs * bA;\n  float z = bb(bB.xy);\n  float ba = Z(z);\n  float bC = -1. / bB.z;\n  by = ba > bC ? by : bA;\n  bz = ba > bC ? bA : bz;\n  return bA;\n}\nvec4 bD(const in vec3 bp, const in float bq, in float bE, const in vec3 br, const in float j, const in float E) {\n  const int bF = 20;\n  float bG = 1. / float(bF);\n  bE *= bG;\n  vec3 bs = bo(bp, bq, br);\n  float bH = bG;\n  vec3 bI = vec3(.0, bH, 1.);\n  vec3 bB;\n  float z, ba, bC, bJ, bK, bL;\n  bool bM;\n  float bN = 1.;\n  float bA;\n  for(int bO = 0; bO < bF; bO++) {\n    bB = bp + bs * bI.y;\n    z = bb(bB.xy);\n    ba = Z(z);\n    bC = -1. / bB.z;\n    bJ = bC - ba;\n    bJ *= clamp(sign(abs(bJ) - bq * bG * bG), .0, 1.);\n    bM = abs(bJ + bE) < bE;\n    bK = clamp(bI.x / (bI.x - bJ), .0, 1.);\n    bL = bM ? bI.y + bK * bG - bG : 1.;\n    bI.z = min(bI.z, bL);\n    bI.x = bJ;\n    if(bM) {\n      float by = bI.y - bG;\n      float bz = bI.y;\n      bA = bx(bp, bs, by, bz);\n      bA = bx(bp, bs, by, bz);\n      bA = bx(bp, bs, by, bz);\n      bN = bA;\n      break;\n    }\n    bI.y += bG;\n  }\n  return vec4(bp + bs * bN, 1. - bN);\n}\nvec3 bP(in vec4 bQ, const in float bR, const in vec3 bS, const in vec3 bT, const in float j) {\n  vec4 bU = mix(outputFovInfo[0], outputFovInfo[1], bQ.x);\n  bQ.xyz = vec3(mix(bU.xy, bU.zw, bQ.y), 1.) * -1. / bQ.z;\n  bQ.xyz = (reprojViewProjMatrix * vec4(bQ.xyz, 1.)).xyw;\n  bQ.xy /= bQ.z;\n  float bV = clamp(6. - 6. * max(abs(bQ.x), abs(bQ.y)), .0, 1.);\n  bQ.xy = .5 + .5 * bQ.xy;\n  return vec3(bQ.xy, 1.);\n}\nvec3 ssr(const in vec3 bS, const in vec3 bT, const in float j, const in vec3 d, const in vec3 bg) {\n  float bW = .0;\n  vec4 f = vec4(.0);\n  float bh = j * j;\n  bh = bh * bh;\n  vec3 bX = abs(d.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 bd = normalize(cross(bX, d));\n  vec3 be = cross(d, bd);\n  float bR = ssrFactor * clamp(-4. * dot(bg, d) + 3.8, .0, 1.);\n  bR *= clamp(4.7 - j * 5., .0, 1.);\n  vec3 bp = T(projMatrix, vViewVertex.xyz);\n  bp.z = 1. / bp.z;\n  vec3 br = bc(bW, bd, be, d, bg, bh);\n  float bq = mix(cameraNearFar.y + vViewVertex.z, -vViewVertex.z - cameraNearFar.x, br.z * .5 + .5);\n  float bE = .5 * bq;\n  vec4 bQ;\n  if(dot(br, d) > .001 && bR > .0) {\n    bQ = bD(bp, bq, bE, br, j, bW);\n    if(bQ.w > .0)\n      return bP(bQ, bR, bS, bT, j);\n    \n  }\n  return vec3(.0);\n}\n#endif\nconst vec3 bY = vec3(0., 0., 1.);\nuniform mat4 viewMatrix;\nuniform sampler2D normalTexture;\nuniform sampler2D heightTexture;\nuniform vec4 waveParams;\nuniform vec2 waterDir;\nuniform vec4 waterBaseColor;\nuniform vec3 lightDirection;\nuniform vec3 lightColor;\nuniform vec3 camPos;\nuniform float timeElapsed;\nvarying vec2 vUv;\nvarying vec2 vNoiseUv;\nvarying vec3 vPos;\nvarying mat3 vTbnMatrix;\nfloat bZ(vec3 e, float ca) {\n  float cb = max(.015, ca);\n  return max((e.x + e.y) * .3303545 / cb + .3303545, .0);\n}\nconst vec2 cc = vec2(6. / 25., 5. / 24.);\nvec2 cd(sampler2D ce, vec2 S) {\n  return 2. * texture2D(ce, S).rg - 1.;\n}\nfloat cf(vec2 S) {\n  return texture2D(heightTexture, S).b;\n}\nvec3 cg(sampler2D ce, vec2 S) {\n  return 2. * texture2D(ce, S).rgb - 1.;\n}\nfloat ch(vec2 S, float ci) {\n  return fract(ci);\n}\nfloat cj(vec2 S, float ci) {\n  float ck = ch(S, ci);\n  return 1. - abs(1. - 2. * ck);\n}\nvec3 cl(sampler2D cm, vec2 S, float ci, float cn) {\n  float co = waveParams[2];\n  float cp = waveParams[3];\n  vec2 cq = cd(cm, S) * co;\n  float ck = ch(S, ci + cn);\n  float cr = cj(S, ci + cn);\n  vec2 f = S;\n  f -= cq * (ck + cp);\n  f += cn;\n  f += (ci - ck) * cc;\n  return vec3(f, cr);\n}\nconst float cs = 7.77;\nvec3 ct(sampler2D cu, sampler2D cv, vec2 cw, vec2 cx, float ci) {\n  float ca = waveParams[0];\n  vec2 cy = ci * -cx;\n  float cz = cf(vNoiseUv) * cs;\n  vec3 cA = cl(cv, cw + cy, ci + cz, .0);\n  vec3 cB = cl(cv, cw + cy, ci + cz, .5);\n  vec3 cC = cg(cu, cA.xy) * cA.z;\n  vec3 cD = cg(cu, cB.xy) * cB.z;\n  vec3 cE = normalize(cC + cD);\n  cE.xy *= ca;\n  cE.z = sqrt(1. - dot(cE.xy, cE.xy));\n  return cE;\n}\nvec4 cF(vec2 cw, float cG) {\n  float cH = waveParams[1];\n  vec3 d = ct(normalTexture, heightTexture, cw * cH, waterDir, cG);\n  float cI = bZ(d, waveParams[0]);\n  return vec4(d, cI);\n}\nconst float cJ = 3.141592653589793;\nconst float cK = 1. / cJ;\nconst float cL = .3183098861837907;\nconst float cM = 1.570796326794897;\nconst float cN = .4;\nfloat cO = 2.2;\nvec3 cP(float cQ, vec3 cR, float l) {\n  return cR + (l - cR) * pow(1. - cQ, 5.);\n}\nfloat cS(float cT, float j) {\n  float cU = j * j;\n  float cV = cT * cT;\n  float cW = pow((cV * (cU - 1.) + 1.), cO) * cJ;\n  return cU / cW;\n}\nfloat cX(float cY) {\n  return .25 / (cY * cY);\n}\nvec3 cZ(const vec3 x) {\n  return (x * (2.51 * x + .03)) / (x * (2.43 * x + .59) + .14);\n}\nconst float da = 2.2;\nconst float db = .4545454545;\nvec4 dc(vec4 u) {\n  return vec4(pow(u.rgb, vec3(db)), u.w);\n}\nvec3 dd(vec3 u) {\n  return pow(u, vec3(da));\n}\nconst vec3 de = vec3(.02, 1., 5.);\nconst vec2 df = vec2(.02, .1);\nconst float j = .06;\nconst float dg = 1.7;\nconst vec3 dh = vec3(0, .6, .9);\nconst vec3 di = vec3(.72, .92, 1.);\nconst float dj = .65;\nconst float dk = 300000.0;\nconst float dl = 500000.0;\nconst float dm = .775;\nconst float dn = .8;\nPBRShadingWater dp;\nvec3 dq(in PBRShadingWater dr, float j, vec3 ds, float dt) {\n  vec3 du = cP(dr.VdotH, ds, dt);\n  float dv = cS(dr.NdotH, j);\n  float dw = cX(dr.LdotH);\n  float dx = mix(j + .045, j + .385, 1. - dr.VdotH);\n  float dy = 1.2;\n  float dz = cS(dr.NdotH, dx) * dy;\n  return ((dv + dz) * dw) * du;\n}\nvec3 dA(float dg, float dB, vec3 dh, float dC) {\n  return dg * (.075 * dh * pow(dB, 4.) + 50. * pow(dB, 23.)) * dC;\n}\nvec3 dD(in float bk, in vec3 dE, in vec3 dF) {\n  float dG = pow((1. - bk), de[2]);\n  return mix(dF, dE, dG);\n}\nvec3 dH(in vec3 e, in vec3 dI, in float dJ, in float j) {\n  \n#ifdef HAS_IBL_LIGHTING\nvec3 dK = reflect(-dI, e);\n  vec3 dL = textureCube(prefilterMap, environmentTransform * dK).rgb;\n  float dM = clamp(1. + dot(dK, e), .0, 1.);\n  dL *= dM * dM;\n  vec3 i = dL;\n  vec3 dN = c(e);\n  float l = clamp(50.0 * waterBaseColor.g, .0, 1.);\n  vec3 dO = h(waterBaseColor.rgb, j, dot(e, dI), l);\n  return i * dO + dN;\n#else\nvec3 dP = dd(di);\n  vec3 dQ = dd(dh);\n  vec3 di = dD(dJ, dP, dQ);\n  return di;\n#endif\n}\nvec3 dR(in vec3 e, in vec3 dI, in vec3 dS, vec3 u, in vec3 dT, in vec3 dU, in float dV, float dW, vec3 dX) {\n  float dY = 0.;\n  vec3 dZ = dd(u);\n  vec3 bm = normalize(dS + dI);\n  dp.NdotL = clamp(dot(e, dS), .0, 1.);\n  dp.NdotV = clamp(dot(e, dI), .001, 1.);\n  dp.VdotN = clamp(dot(dI, e), .001, 1.);\n  dp.NdotH = clamp(dot(e, bm), .0, 1.);\n  dp.VdotH = clamp(dot(dI, bm), .0, 1.);\n  dp.LdotH = clamp(dot(dS, bm), .0, 1.);\n  float dJ = max(dot(dU, dI), .0);\n  vec3 di = dH(e, dI, dJ, j);\n  float ea = max(dot(dU, dS), .0);\n  float eb = .1 + ea * .9;\n  di *= eb;\n  float ec = clamp(dV, .8, 1.);\n  vec3 ed = cP(dp.VdotN, vec3(de[0]), de[1]);\n  vec3 ee = ed * di * ec;\n  vec3 ef = dZ * mix(di, ea * dT * cK, 2. / 3.) * ec;\n  vec3 i = vec3(.0);\n  if(dJ > .0 && ea > .0) {\n    vec3 eg = dq(dp, j, vec3(df[0]), df[1]);\n    vec3 eh = dT * cK * dV;\n    i = dp.NdotL * eh * eg;\n  }\n  vec3 cI = vec3(.0);\n  if(dJ > .0) {\n    cI = dA(dg, dW, dh, eb);\n  }\n  vec3 ei = vec3(.0);\n#ifdef HAS_SSR\nfloat ej = smoothstep(dl, dk, -dX.z);\n  mat4 ek = viewMatrix;\n  vec4 el = vec4(dX.xyz, 1.);\n  vec3 em = normalize(el.xyz);\n  vec4 en = ek * vec4(e, .0);\n  vec3 eo = normalize(en.xyz);\n  vec4 ep = ek * vec4(dU, .0);\n  float eq = pow(max(dot(-em, ep.xyz), .0), cN);\n  vec3 er = mix(ep.xyz, eo, eq);\n  vec3 es = ssr(vec3(.0), vec3(1.), j, normalize(er), -normalize(vViewVertex.xyz));\n  if(es.z > .0) {\n    vec2 et = smoothstep(.3, .6, abs(vec2(.5) - es.xy));\n    dY = dm * clamp(1. - 1.3 * et.y, .0, 1.) * ej;\n    vec3 eu = X(.0, es.xy);\n    ei = dd(eu) * dY * ed.y * dj;\n  }\n#endif\nfloat ev = mix(dn, dn * .5, dY);\n  return cZ((1. - dY) * ee + ei + ef * ev + i + cI);\n}\nvoid main() {\n  vec3 dU = bY;\n  vec4 ew = cF(vUv, timeElapsed);\n  vec3 e = normalize(vTbnMatrix * ew.xyz);\n  vec3 dI = -normalize(vPos - camPos);\n  vec3 dS = normalize(-lightDirection);\n#if defined(HAS_SHADOWING)\nfloat dV = shadow_computeShadow();\n#else\nfloat dV = 1.;\n#endif\nvec4 ex = viewMatrix * vec4(vPos, 1.);\n  vec4 ey = vec4(dR(e, dI, dS, waterBaseColor.rgb, lightColor, dU, dV, ew.w, ex.xyz), waterBaseColor.a);\n  gl_FragColor = dc(ey);\n  if(contrast != 1.) {\n    gl_FragColor = contrastMatrix(contrast) * gl_FragColor;\n  }\n  if(length(hsv) > .0) {\n    gl_FragColor = hsv_apply(gl_FragColor, hsv);\n  }\n  gl_FragColor = highlight_blendColor(gl_FragColor) * layerOpacity;\n}",
            defines: r,
            uniforms: i,
            extraCommandProps: a
        });
    }
    getUniformValues(e) {
        return {
            projViewMatrix: e.projViewMatrix,
            minAltitude: this.layer.options.altitude || 0
        };
    }
    _getWaterUniform(e, t) {
        const {iblTexes: n, dfgLUT: i} = this.getIBLRes(), r = Jo(e, n, i, t && t.ssr, t && t.jitter), s = e.getLightManager();
        let o = s && s.getDirectionalLight() || {};
        const a = s && s.getAmbientLight() || {}, l = this.getSymbol(ea), h = this._waterDir = this._waterDir || [], c = this._waveParams = this._waveParams || [];
        v.set(c, .09, l.uvScale || 3, .03, -.5);
        Be(r, {
            ambientColor: a.color || [ .2, .2, .2 ],
            viewMatrix: e.viewMatrix,
            lightDirection: o.direction || Ko.direction,
            lightColor: o.color || Ko.color,
            camPos: e.cameraPosition,
            timeElapsed: l.animation ? (this.layer.getRenderer().getFrameTimestamp() || 0) / (1 / (l.waterSpeed || 1) * 1e4) : 0,
            normalTexture: this._normalTex || this._emptyTex,
            heightTexture: this._pertTex || this._emptyTex,
            waveParams: c,
            waterDir: ra(h, l.waterDirection || 0),
            waterBaseColor: l.waterBaseColor || [ .1451, .2588, .4863, 1 ],
            contrast: l.contrast || 1,
            hsv: l.hsv || ta
        });
        const u = this.layer.getRenderer();
        return r.layerOpacity = u._getLayerOpacity(), this.setIncludeUniformValues(r, t), 
        t && t.ssr && t.ssr.renderUniforms && Be(r, t.ssr.renderUniforms), r;
    }
    delete() {
        super.delete(), this._emptyTex && (this._emptyTex.destroy(), delete this._emptyTex), 
        this._normalTex && this._normalTex.destroy(), this._pertTex && this._pertTex.destroy(), 
        this.shader && (this.shader.dispose(), delete this.shader), this._waterShader && this._waterShader.dispose(), 
        this._water && (this._water.geometry.dispose(), this._water.material && this._water.material.dispose(), 
        this._water.dispose(), delete this._water), this.disposeIBLTextures();
    }
    createGround() {
        const e = new g.Plane;
        e.data.aTexCoord = new Uint8Array([ 0, 1, 1, 1, 0, 0, 1, 0 ]), e.generateBuffers(this.renderer.device), 
        this._water = new g.Mesh(e, null, {
            castShadow: !1
        }), this._waterScene = new g.Scene([ this._water ]);
    }
    transformWater() {
        const e = this.getMap(), t = _.getGroundTransform(this._water.localTransform, e);
        this._water.setLocalTransform(t);
        const n = e._get2DExtentAtRes(e.getGLRes()), i = n.getWidth(), r = n.getHeight(), s = e.cameraLookAt, o = s[0] - i, a = s[1] + r, l = o / na[0], h = a / na[1], c = l % 1, u = h % 1, f = l * Qo % 1, d = h * Qo % 1, p = i / na[0] * 2, g = r / na[1] * 2;
        this._water.setUniform("uvOffset", [ c, u ]), this._water.setUniform("noiseUvOffset", [ f, d ]), 
        this._water.setUniform("uvScale", [ p, -g ]);
    }
}

function ra(e, t) {
    var n;
    return n = t, t = Math.PI * n / 180, e[0] = Math.sin(t), e[1] = Math.cos(t), e;
}

var sa = "#define SHADER_NAME BILL_BOARD\n#include <gl2_vert>\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nattribute vec2 aExtrude;\nattribute vec2 aTexCoord;\nattribute vec4 aQuat;\nvarying vec2 vTexCoord;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float extrudeScale;\n#ifdef PICKING_MODE\n#include <fbo_picking_vert>\n#endif\n#include <vt_position_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nmat4 c(vec4 q) {\n  float x = q.x, y = q.y, z = q.z, w = q.w;\n  float d = x * x, e = y * y, f = z * z;\n  float xy = x * y, xz = x * z, yz = y * z;\n  float wx = w * x, wy = w * y, wz = w * z;\n  return mat4(1. - 2. * (e + f), 2. * (xy + wz), 2. * (xz - wy), .0, 2. * (xy - wz), 1. - 2. * (d + f), 2. * (yz + wx), .0, 2. * (xz + wy), 2. * (yz - wx), 1. - 2. * (d + e), .0, .0, .0, .0, 1.);\n}\nvoid main() {\n  vec4 h = vec4(aExtrude.x * extrudeScale, .0, aExtrude.y, 1.);\n  mat4 i = c(aQuat);\n  vec3 j = (i * h).xyz;\n  vec3 k = unpackVTPosition(j);\n  vTexCoord = aTexCoord;\n  gl_Position = projViewModelMatrix * positionMatrix * vec4(k, 1.);\n#ifdef PICKING_MODE\nfbo_picking_setData(gl_Position.w, true);\n#elif defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(vec4(k, 1.));\n#endif\n}";

function oa(e, t, n) {
    n = n || {}, this.w = e || 64, this.h = t || 64, this.autoResize = !!n.autoResize, 
    this.shelves = [], this.freebins = [], this.stats = {}, this.bins = {}, this.maxId = 0;
}

function aa(e, t, n) {
    this.x = 0, this.y = e, this.w = this.free = t, this.h = n;
}

function la(e, t, n, i, r, s, o) {
    this.id = e, this.x = t, this.y = n, this.w = i, this.h = r, this.maxw = s || i, 
    this.maxh = o || r, this.refcount = 0;
}

/*!
 * Codes from mapbox-gl-js
 * github.com/mapbox/mapbox-gl-js
 * MIT License
 */ function ha(e, {width: t, height: n}, i, r) {
    if (r) {
        if (r.length !== t * n * i) throw new RangeError("mismatched image size");
    } else r = new Uint8Array(t * n * i);
    return e.width = t, e.height = n, e.data = r, e;
}

function ca(e, t, n, i, r, s) {
    if (0 === r.width || 0 === r.height) return t;
    if (r.width > e.width || r.height > e.height || n.x > e.width - r.width || n.y > e.height - r.height) throw new RangeError("out of range source coordinates for image copy");
    if (r.width > t.width || r.height > t.height || i.x > t.width - r.width || i.y > t.height - r.height) throw new RangeError("out of range destination coordinates for image copy");
    const o = e.data, a = t.data;
    if (o === a) return t;
    for (let l = 0; l < r.height; l++) {
        const h = ((n.y + l) * e.width + n.x) * s, c = ((i.y + l) * t.width + i.x) * s;
        for (let e = 0; e < r.width * s; e++) a[c + e] = o[h + e];
    }
    return t;
}

oa.prototype.pack = function(e, t) {
    e = [].concat(e), t = t || {};
    for (var n, i, r, s, o = [], a = 0; a < e.length; a++) if (n = e[a].w || e[a].width, 
    i = e[a].h || e[a].height, r = e[a].id, n && i) {
        if (!(s = this.packOne(n, i, r))) continue;
        t.inPlace && (e[a].x = s.x, e[a].y = s.y, e[a].id = s.id), o.push(s);
    }
    return this.shrink(), o;
}, oa.prototype.packOne = function(e, t, n) {
    var i, r, s, o, a, l, h, c, u = {
        freebin: -1,
        shelf: -1,
        waste: 1 / 0
    }, f = 0;
    if ("string" == typeof n || "number" == typeof n) {
        if (i = this.getBin(n)) return this.ref(i), i;
        "number" == typeof n && (this.maxId = Math.max(n, this.maxId));
    } else n = ++this.maxId;
    for (o = 0; o < this.freebins.length; o++) {
        if (t === (i = this.freebins[o]).maxh && e === i.maxw) return this.allocFreebin(o, e, t, n);
        t > i.maxh || e > i.maxw || t <= i.maxh && e <= i.maxw && (s = i.maxw * i.maxh - e * t) < u.waste && (u.waste = s, 
        u.freebin = o);
    }
    for (o = 0; o < this.shelves.length; o++) if (f += (r = this.shelves[o]).h, !(e > r.free)) {
        if (t === r.h) return this.allocShelf(o, e, t, n);
        t > r.h || t < r.h && (s = (r.h - t) * e) < u.waste && (u.freebin = -1, u.waste = s, 
        u.shelf = o);
    }
    return -1 !== u.freebin ? this.allocFreebin(u.freebin, e, t, n) : -1 !== u.shelf ? this.allocShelf(u.shelf, e, t, n) : t <= this.h - f && e <= this.w ? (r = new aa(f, this.w, t), 
    this.allocShelf(this.shelves.push(r) - 1, e, t, n)) : this.autoResize ? (a = l = this.h, 
    ((h = c = this.w) <= a || e > h) && (c = 2 * Math.max(e, h)), (a < h || t > a) && (l = 2 * Math.max(t, a)), 
    this.resize(c, l), this.packOne(e, t, n)) : null;
}, oa.prototype.allocFreebin = function(e, t, n, i) {
    var r = this.freebins.splice(e, 1)[0];
    return r.id = i, r.w = t, r.h = n, r.refcount = 0, this.bins[i] = r, this.ref(r), 
    r;
}, oa.prototype.allocShelf = function(e, t, n, i) {
    var r = this.shelves[e].alloc(t, n, i);
    return this.bins[i] = r, this.ref(r), r;
}, oa.prototype.shrink = function() {
    if (this.shelves.length > 0) {
        for (var e = 0, t = 0, n = 0; n < this.shelves.length; n++) {
            var i = this.shelves[n];
            t += i.h, e = Math.max(i.w - i.free, e);
        }
        this.resize(e, t);
    }
}, oa.prototype.getBin = function(e) {
    return this.bins[e];
}, oa.prototype.ref = function(e) {
    if (1 == ++e.refcount) {
        var t = e.h;
        this.stats[t] = 1 + (0 | this.stats[t]);
    }
    return e.refcount;
}, oa.prototype.unref = function(e) {
    return 0 === e.refcount ? 0 : (0 == --e.refcount && (this.stats[e.h]--, delete this.bins[e.id], 
    this.freebins.push(e)), e.refcount);
}, oa.prototype.clear = function() {
    this.shelves = [], this.freebins = [], this.stats = {}, this.bins = {}, this.maxId = 0;
}, oa.prototype.resize = function(e, t) {
    this.w = e, this.h = t;
    for (var n = 0; n < this.shelves.length; n++) this.shelves[n].resize(e);
    return !0;
}, aa.prototype.alloc = function(e, t, n) {
    if (e > this.free || t > this.h) return null;
    var i = this.x;
    return this.x += e, this.free -= e, new la(n, i, this.y, e, t, e, this.h);
}, aa.prototype.resize = function(e) {
    return this.free += e - this.w, this.w = e, !0;
};

class ua {
    constructor(e, t) {
        ha(this, e, 4, t);
    }
    resize(e) {
        !function(e, {width: t, height: n}, i) {
            if (t === e.width && n === e.height) return;
            const r = ha({}, {
                width: t,
                height: n
            }, i);
            ca(e, r, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(e.width, t),
                height: Math.min(e.height, n)
            }, i), e.width = t, e.height = n, e.data = r.data;
        }(this, e, 4);
    }
    clone() {
        return new ua({
            width: this.width,
            height: this.height
        }, new Uint8Array(this.data));
    }
    static copy(e, t, n, i, r) {
        ca(e, t, n, i, r, 4);
    }
}

const fa = new e.Point(0, 0), da = [], pa = [];

let ga;

class ma extends Rn {
    constructor(...e) {
        super(...e), this._ready = !0;
        const t = this.getSymbolDef({
            index: 0
        }), n = te(t && t.source);
        if (this._ready = !n, k(t.width) ? this._widthFn = F(t.width) : this._width = t.width, 
        k(t.height) ? this._heightFn = F(t.height) : this._height = t.height, k(t.rotationX) ? this._rotationXFn = F(t.rotationX) : this._rotationX = t.rotationX, 
        k(t.rotationY) ? this._rotationYFn = F(t.rotationY) : this._rotationY = t.rotationY, 
        k(t.rotationZ) ? this._rotationZFn = F(t.rotationZ) : this._rotationZ = t.rotationZ, 
        n) {
            const e = this._image = new Image;
            e.onload = () => {
                this._ready = !0;
            }, e.src = t.source;
        }
    }
    needToRedraw() {
        const e = this.getSymbolDef({
            index: 0
        });
        if (!e || !ie(e.source)) return super.needToRedraw();
        const t = this.layer.getRenderer().getCurrentTiles();
        if (!t || Nt(t)) return super.needToRedraw();
        return this._checkIfSourceUpdated() || super.needToRedraw();
    }
    _checkIfSourceUpdated() {
        let e = !1;
        const t = this.layer.getRenderer(), n = t.getCurrentTiles(), i = this.getSymbolDef({
            index: 0
        }).source, r = t.tileCache, s = [];
        for (const t in n) {
            const n = r.get(t);
            if (!(n && n.image && n.image.cache && n.image.cache[0])) continue;
            let {geometry: o} = n.image.cache[0];
            if (!o || !o[0] || !o[0].geometry) continue;
            if (o = o[0].geometry.properties.billGeometry, !o) continue;
            const {oldPickingId: a, contextCache: l, textureCache: h, features: c, billTexture: u} = o.properties;
            if (!a || !a.length) continue;
            let f = !1, d = !1;
            const p = a.length;
            for (let t = 0; t < p; t++) {
                const n = a[t], r = l[n] = l[n] || {}, o = c[n] && c[n].feature;
                if (!o) continue;
                const u = h[n];
                let p = 0, g = 0;
                u && (p = u.width, g = u.height);
                let m, y = i(r, o.properties);
                y.redraw ? (f = e = !0, m = h[n] = y.data, p === m.width && g === m.height || (d = !0)) : m = h[n], 
                s.push({
                    id: n,
                    w: m.width,
                    h: m.height
                });
            }
            if (f) {
                const e = d ? o.properties.aTexCoord : null, t = this._fillFnTextureData(e, o, s), n = {
                    width: t.width,
                    height: t.height,
                    data: t.data,
                    format: t.format,
                    mag: "linear",
                    min: "linear",
                    flipY: !1,
                    premultiplyAlpha: !0
                };
                u.update ? u.update(n) : u(n), d && o.updateData("aTexCoord", o.properties.aTexCoord);
            }
        }
        return e;
    }
    isTerrainSkin() {
        return !1;
    }
    isTerrainVector() {
        return this.layer.options.awareOfTerrain;
    }
    isUniqueStencilRefPerTile() {
        return !1;
    }
    createMesh(e, t, {tilePoint: n}) {
        if (!this._ready) return null;
        let {geometry: i} = e;
        const {features: r, tileResolution: s, tileRatio: o} = i.properties;
        if (!i.data.aPosition || 0 === i.data.aPosition.length) return null;
        const a = this._createBillboard(i, i.desc.positionSize, r);
        a.generateBuffers(this.regl), i.properties.billGeometry = a;
        const l = new g.Material({
            billTexture: a.properties.billTexture
        }), h = new g.Mesh(a, l, {
            castShadow: !1,
            picking: !0
        }), c = this.getMap();
        fa.set(n[0], n[1]);
        const u = c.altitudeToPoint(1, s) * o;
        h.setUniform("extrudeScale", u / 100);
        const f = [];
        h.setFunctionUniform("textureSize", (() => {
            const e = a.properties.billTexture;
            return f[0] = e.width, f[1] = e.height, f;
        }));
        const d = {};
        return h.geometry.data.aAltitude && (d.HAS_ALTITUDE = 1), h.setDefines(d), h.positionMatrix = this.getAltitudeOffsetMatrix(), 
        h.setLocalTransform(t), h.properties.symbolIndex = {
            index: 0
        }, h;
    }
    _createBillboard(e, t, n) {
        const i = e.properties.z, {aPosition: r, aPickingId: s} = e.data, o = e.properties;
        o.oldPickingId = s;
        const a = o.contextCache = [], l = o.textureCache = [], h = s.length, c = 6 * h, u = new r.constructor(c * t), f = new Int16Array(2 * c), d = new Float32Array(4 * c), p = new s.constructor(c), m = this.getSymbolDef({
            index: 0
        }).source, y = [];
        for (let e = 0; e < h; e++) {
            const n = r.subarray(e * t, (e + 1) * t), i = s[e];
            u.set(n, 6 * e * t), u.set(n, (6 * e + 1) * t), u.set(n, (6 * e + 2) * t), u.set(n, (6 * e + 3) * t), 
            u.set(n, (6 * e + 4) * t), u.set(n, (6 * e + 5) * t), p[6 * e] = i, p[6 * e + 1] = i, 
            p[6 * e + 2] = i, p[6 * e + 3] = i, p[6 * e + 4] = i, p[6 * e + 5] = i;
        }
        const x = ie(m);
        for (let e = 0; e < h; e++) {
            const t = s[e], r = n[t];
            let o;
            if (x) {
                o = m(a[t] = a[t] || {}, r && r.feature && r.feature.properties).data, l[t] = o, 
                y.push({
                    id: t,
                    w: o.width,
                    h: o.height
                });
            } else o = this._image;
            this._fillExtrude(f, e, r, i), this._fillQuat(d, e, r, i);
        }
        const _ = new Int16Array(2 * c);
        if (y.length) {
            const t = this._fillFnTextureData(_, e, y);
            o.billTexture = Dn(this.regl, t, !1, !1);
        } else {
            const e = {
                x: 0,
                y: 0,
                w: this._image.width,
                h: this._image.height
            };
            for (let t = 0; t < h; t++) this._fillTexCoord(_, t, e, 1);
            const t = this._image;
            o.billTexture = this.regl.texture({
                width: t.width,
                height: t.height,
                data: t
            });
        }
        const v = 6 * h < 65536 ? Uint16Array : Uint32Array;
        const b = [];
        for (let e = 0; e < h; e++) {
            const t = 6 * e;
            b.push(t, t + 1, t + 2), b.push(t + 3, t + 4, t + 5);
        }
        const A = {
            aPosition: u,
            aPickingId: p,
            aExtrude: f,
            aQuat: d,
            aTexCoord: _
        }, {feaPickingIdMap: T, aFeaIds: w} = e.properties, S = new w.constructor(c);
        for (let e = 0; e < p.length; e++) S[e] = T[p[e]];
        o.aFeaIds = S, o.aTexCoord = _;
        const M = new g.Geometry(A, new v(b), 0, {
            positionSize: t
        });
        return M.properties = e.properties, M;
    }
    _fillQuat(e, t, n, i) {
        let r = this._rotationX || 0, s = this._rotationY || 0, o = this._rotationZ || 0;
        const a = n && n.feature && n.feature.properties;
        this._rotationXFn && (r = this._rotationXFn(i, a)), this._rotationYFn && (s = this._rotationYFn(i, a)), 
        this._rotationZFn && (o = this._rotationZFn(i, a)), S.fromEuler(pa, r, s, -o);
        const l = 6 * t;
        for (let t = 0; t < 6; t++) e.set(pa, 4 * (l + t));
    }
    _fillExtrude(e, t, n, i) {
        let r = this._width || 0, s = this._height || 0;
        const o = n && n.feature && n.feature.properties;
        this._widthFn && (r = this._widthFn(i, o)), this._heightFn && (s = this._heightFn(i, o));
        const a = r / 2 * 100, l = s / 2 * 100;
        da[0] = -a, da[1] = -l;
        const h = 12 * t;
        e.set(da, h), da[0] = a, da[1] = l, e.set(da, h + 2), da[0] = -a, da[1] = l, e.set(da, h + 4), 
        da[0] = -a, da[1] = -l, e.set(da, h + 6), da[0] = a, da[1] = -l, e.set(da, h + 8), 
        da[0] = a, da[1] = l, e.set(da, h + 10);
    }
    _fillFnTextureData(e, t, n) {
        const i = t.properties, {textureCache: r, oldPickingId: s} = i, o = s.length, a = new oa(0, 0, {
            autoResize: !0
        }), l = (ga || (ga = document.createElement("canvas")), ga), h = l.getContext("2d");
        a.pack(n, {
            inPlace: !0
        });
        const c = this.sceneConfig.textureLimit || 1024;
        let u = 1;
        a.w * a.h > c * c && (u = Math.sqrt(c * c / (a.w * a.h)), a.resize(Math.floor(a.w * u), Math.floor(a.h * u)));
        const f = new ua({
            width: a.w,
            height: a.h
        });
        for (let t = 0; t < o; t++) {
            const i = n[t];
            e && this._fillTexCoord(e, t, i, u);
            const s = r[i.id];
            if (!s) continue;
            const o = Math.floor(i.w * u), a = Math.floor(i.h * u);
            l.width = o, l.height = a, h.drawImage(s, 0, 0, o, a);
            const c = h.getImageData(0, 0, o, a);
            ua.copy(c, f, {
                x: 0,
                y: 0
            }, {
                x: Math.floor(i.x * u),
                y: Math.floor(i.y * u)
            }, {
                width: o,
                height: a
            });
        }
        return f.format = "rgba", f;
    }
    _fillTexCoord(e, t, n, i) {
        const {x: r, y: s, w: o, h: a} = n, l = Math.floor(r * i), h = Math.floor((r + o) * i), c = Math.floor(s * i), u = Math.floor((s + a) * i), f = 12 * t;
        da[0] = l, da[1] = u, e.set(da, f), da[0] = h, da[1] = c, e.set(da, f + 2), da[0] = l, 
        da[1] = c, e.set(da, f + 4), da[0] = l, da[1] = u, e.set(da, f + 6), da[0] = h, 
        da[1] = u, e.set(da, f + 8), da[0] = h, da[1] = c, e.set(da, f + 10);
    }
    init() {
        const e = this.regl;
        this.renderer = new g.Renderer(e);
        const t = {
            x: 0,
            y: 0,
            width: () => this.canvas ? this.canvas.width : 1,
            height: () => this.canvas ? this.canvas.height : 1
        }, n = [], i = {
            vert: sa,
            frag: "#define SHADER_NAME BILL_BOARD\nprecision mediump float;\n#include <gl2_frag>\nuniform sampler2D billTexture;\nuniform vec2 textureSize;\nvarying vec2 vTexCoord;\nvoid main() {\n  glFragColor = texture2D(billTexture, vTexCoord / textureSize);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat c = shadow_computeShadow();\n  glFragColor.rgb = shadow_blend(glFragColor.rgb, c);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            wgslVert: A("vt_billboard_vert"),
            wgslFrag: A("vt_billboard_frag"),
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    return y.multiply(n, t.projViewMatrix, t.modelMatrix), n;
                }
            } ],
            defines: null,
            extraCommandProps: {
                viewport: t,
                depth: {
                    enable: !0,
                    range: this.sceneConfig.depthRange || [ 0, 1 ],
                    func: this.sceneConfig.depthFunc || "<="
                },
                blend: {
                    enable: !0,
                    func: this.getBlendFunc(),
                    equation: "add"
                },
                cull: {
                    enable: !1
                }
            }
        };
        if (this.shader = new g.MeshShader(i), this.shader.version = 300, this.pickingFBO) {
            const e = [];
            this.picking = [ new g.FBORayPicking(this.renderer, {
                vert: sa,
                wgslVert: A("vt_billboard_vert"),
                uniforms: [ {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: function(t, n) {
                        return y.multiply(e, n.projViewMatrix, n.modelMatrix), e;
                    }
                } ],
                defines: {
                    PICKING_MODE: 1
                },
                extraCommandProps: {
                    viewport: this.pickingViewport,
                    depth: {
                        enable: !0,
                        range: this.sceneConfig.depthRange || [ 0, 1 ],
                        func: this.sceneConfig.depthFunc || "<="
                    },
                    cull: {
                        enable: !1
                    }
                }
            }, this.pickingFBO, this.getMap()) ];
        }
    }
    getUniformValues(e) {
        return {
            projViewMatrix: e.projViewMatrix
        };
    }
    deleteMesh(e, t) {
        if (Array.isArray(e)) for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (n.geometry) {
                const e = n.geometry.properties;
                e.textureCache && (delete e.billTexture, delete e.textureCache, delete e.contextCache);
            }
        } else if (e.geometry) {
            const t = e.geometry.properties;
            t.textureCache && (delete t.billTexture, delete t.textureCache, delete t.contextCache);
        }
        return super.deleteMesh(e, t);
    }
}

const ya = y.identity([]), xa = {};

class _a extends Rn {
    isEnableTileStencil() {
        return !1;
    }
    isTerrainMask() {
        return this.layer.options.awareOfTerrain;
    }
    needPolygonOffset() {
        return !1;
    }
    createMesh(e, t) {
        const {geometry: n, symbolIndex: i} = e;
        n.generateBuffers(this.regl);
        const r = new g.Material({}, xa), s = new g.Mesh(n, r, {
            castShadow: !1,
            picking: !1
        });
        s.positionMatrix = this.getAltitudeOffsetMatrix(), s.setLocalTransform(t), s.properties.symbolIndex = i;
        const o = {};
        return n.data.aAltitude && (o.HAS_ALTITUDE = 1), s.setDefines(o), s;
    }
    init(e) {
        const t = this.regl, n = this.canvas, i = {
            x: (e, t) => t.viewport ? t.viewport.x : 0,
            y: (e, t) => t.viewport ? t.viewport.y : 0,
            width: (e, t) => t.viewport ? t.viewport.width : n ? n.width : 1,
            height: (e, t) => t.viewport ? t.viewport.height : n ? n.height : 1
        };
        this.renderer = new g.Renderer(t);
        const r = {
            viewport: i,
            depth: {
                enable: !0,
                func: ">="
            }
        };
        this._createShader(e, r);
    }
    _createShader(e, t) {
        const n = [], i = [ {
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, t) {
                return y.multiply(n, t.projViewMatrix, t.modelMatrix), n;
            }
        } ];
        this.shader = new g.MeshShader({
            name: "vt-terrain-flat-mask",
            vert: "#define SHADER_NAME VT_HEIGHT_MASK_VERT\n#include <gl2_vert>\n#ifdef HAS_ALTITUDE\nattribute vec2 aPosition;\nattribute float aAltitude;\n#else\nattribute vec3 aPosition;\n#endif\nuniform mat4 projViewModelMatrix;\nuniform mat4 positionMatrix;\n#include <vt_position_vert>\nvarying float vAltitude;\nvoid main() {\n  vec3 c = unpackVTPosition();\n  vec4 d = positionMatrix * vec4(c, 1.);\n  vAltitude = d.z / 100.0;\n  d.z = .0;\n  gl_Position = projViewModelMatrix * d;\n}",
            frag: "#define SHADER_NAME VT_HEIGHT_MASK_FRAG\nprecision highp float;\n#include <gl2_frag>\nvarying float vAltitude;\n#include <common_pack_float>\nvoid main() {\n  glFragColor = encodeFloat32(vAltitude);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            wgslVert: A("vt_flat_mask_vert"),
            wgslFrag: A("vt_flat_mask_frag"),
            uniforms: i,
            extraCommandProps: t
        });
    }
    getUniformValues(e, t) {
        return {
            projViewMatrix: ya,
            viewport: t && t.maskViewport
        };
    }
}

const va = zt("fill", ii);

va.registerAt(Mt);

const ba = zt("line", ai);

ba.registerAt(Mt);

const Aa = zt("line-gradient", _i);

Aa.registerAt(Mt);

const Ta = zt("icon", ns);

Ta.registerAt(Mt);

const wa = zt("text", Ys);

wa.registerAt(Mt);

const Sa = zt("native-line", to);

Sa.registerAt(Mt);

zt("native-point", Ks).registerAt(Mt);

const Ma = zt("phong", xo);

Ma.registerAt(Mt);

const Pa = zt("wireframe", vo);

Pa.registerAt(Mt);

const Ia = zt("lit", wo);

Ia.registerAt(Mt);

const Ca = zt("tube", Io);

Ca.registerAt(Mt);

const ka = zt("gltf-phong", Zo);

ka.registerAt(Mt);

const Fa = zt("gltf-lit", $o);

Fa.registerAt(Mt);

const Oa = zt("heatmap", class extends Rn {
    createFnTypeConfig(e, t) {
        const n = F(t.heatmapWeight), i = new Int16Array(1);
        return [ {
            attrName: "aWeight",
            symbolName: "heatmapWeight",
            type: Int16Array,
            width: 1,
            define: "HAS_HEAT_WEIGHT",
            evaluate: t => {
                const r = s[e.id], o = r ? r.zoom : e.getZoom(), a = n(o, t);
                return i[0] = 255 * a, i[0];
            }
        } ];
    }
    createMesh(e, t) {
        const {geometry: n, symbolIndex: i, ref: r} = e;
        if (void 0 === r) {
            Gt(n, this.getSymbolDef(i), this.getFnTypeConfig(i), this.layer);
        }
        const s = this.getSymbol(i), o = {
            tileRatio: n.properties.tileRatio,
            dataResolution: n.properties.tileResolution
        };
        Xe(o, "heatmapIntensity", s, "heatmapIntensity", 1), Xe(o, "heatmapRadius", s, "heatmapRadius", 6), 
        Xe(o, "heatmapWeight", s, "heatmapWeight", 1), Xe(o, "heatmapOpacity", s, "heatmapOpacity", 1), 
        n.generateBuffers(this.regl);
        const a = new g.Material(o), l = new g.Mesh(n, a, {
            transparent: !0,
            castShadow: !1,
            picking: !0
        }), h = {};
        return n.data.aWeight && (h.HAS_HEAT_WEIGHT = 1), l.setDefines(h), l.setLocalTransform(t), 
        l.properties.symbolIndex = i, l;
    }
    callRenderer(e, t, n) {
        const i = this.getRenderFBO(n);
        this._drawCount += this._process.render(this.scene, t, i);
    }
    getUniformValues(e) {
        const t = this.getSymbol({
            index: 0
        }), {projViewMatrix: n} = e;
        return {
            glScale: 1 / e.getGLScale(),
            resolution: e.getResolution(),
            projViewMatrix: n,
            heatmapOpacity: t.heatmapOpacity
        };
    }
    getHeatmapMeshes() {
        return this.scene.getMeshes();
    }
    delete() {
        super.delete(...arguments), this._process.dispose(), delete this._process;
    }
    init() {
        const e = this.regl;
        this.renderer = new g.Renderer(e);
        const t = this.getPolygonOffset(), n = this.getSymbols()[0];
        this._process = new P(this.regl, this.sceneConfig, this.layer, n.heatmapColor, null, t);
    }
});

Oa.registerAt(Mt);

const Ra = zt("water", ia);

Ra.registerAt(Mt);

const Ea = zt("billboard", ma);

Ea.registerAt(Mt);

const Da = zt("terrain-flat-mask", _a);

Da.registerAt(Mt), Et.registerPainter("lit", wo), Et.registerPainter("icon", ns), 
Et.registerPainter("fill", ii), Et.registerPainter("line", ai), Et.registerPainter("line-gradient", _i), 
Et.registerPainter("water", ia), Et.registerPainter("tube", Io), Et.registerPainter("billboard", ma);

class La extends Mt {
    getTileUrl(e, t, n) {
        const i = this.getMap().getResolution(n);
        return super.getTileUrl(e, t, function(e) {
            return 19 - Math.log(e / Ha) / Math.LN2;
        }(i));
    }
    static fromJSON(e) {
        return e && "MapboxVectorTileLayer" === e.type ? new La(e.id, e.options) : null;
    }
}

La.registerJSONType("MapboxVectorTileLayer");

const Ha = 12756274 * Math.PI / (256 * Math.pow(2, 20));

class za extends Mt {
    constructor(e, t) {
        (t = t || {}).spatialReference = null, super(e, t), this._idMaps = new Map, this.setData(t.data);
    }
    _prepareOptions() {
        const e = this.getMap(), t = e.getMaxNativeZoom(), n = e.getProjection(), i = "EPSG:4326" === n.code || "EPSG:4490" === n.code;
        var r;
        i && (this.options.tileSystem = [ 1, -1, -180, 90 ]), this.options.spatialReference = i ? function(e, t) {
            return {
                projection: t,
                fullExtent: {
                    top: 90,
                    left: -180,
                    bottom: -90,
                    right: 180
                },
                resolutions: function() {
                    const t = [];
                    for (let n = 0; n <= e + 1; n++) t[n] = 90 / (128 * Math.pow(2, n));
                    return t;
                }()
            };
        }(t, n.code) : (r = t, {
            projection: "EPSG:3857",
            resolutions: function() {
                const e = [], t = 6378137 * Math.PI;
                for (let n = 0; n <= r + 1; n++) e[n] = t / (256 * Math.pow(2, n));
                return e;
            }(),
            fullExtent: {
                top: 6378137 * Math.PI,
                left: -6378137 * Math.PI,
                bottom: -6378137 * Math.PI,
                right: 6378137 * Math.PI
            }
        });
    }
    getWorkerOptions() {
        const e = super.getWorkerOptions();
        let t = this.options.data;
        return te(t) || t && t.url ? (t.url && (t = JSON.parse(JSON.stringify(t))), t = Va(t, this.getURLModifier())) : t = this.features, 
        e.data = t, e.tileBuffer = this.options.tileBuffer, e.extent = this.options.extent, 
        e.hasAltitude = this.options.enableAltitude, e.simplifyTolerance = this.options.simplifyTolerance, 
        e.projection = this.getSpatialReference().getProjection().code, e.generateOMBB = this.options.generateOMBB, 
        e.convertFn = this.options.convertFn ? this.options.convertFn + "" : null, e;
    }
    setData(e) {
        if (this.options.data = e, e && (te(e) || e.url)) {
            return !!this.getRenderer() && this._updateWorker(), this;
        }
        return this._setData(e), this._updateWorker(), this;
    }
    _setData(e) {
        if (this.options.convertFn) {
            e = new Function("data", this.options.convertFn + "\nreturn convert(data)")(e);
        }
        return this.features = e, this._generateIdMap(), this;
    }
    _updateWorker() {
        const e = this.getRenderer();
        if (e) {
            const t = e.getWorkerConnection();
            if (t) {
                let n = this.options.data;
                te(n) || n && n.url ? (n.url && (n = JSON.parse(JSON.stringify(n))), n = Va(n, this.getURLModifier())) : n = this.features, 
                clearTimeout(this._updateTimeout), t.setData(n, ((t, n) => {
                    e.clear(), this.onWorkerReady(null, n), e.setToRedraw(), this._updateTimeout = setTimeout((() => {
                        e.setToRedraw();
                    }), 500);
                }));
            }
        }
    }
    getExtent() {
        return this._dataExtent;
    }
    onWorkerReady(e, t) {
        e ? this.fire("dataerror", {
            error: e
        }) : (t && (t.extent && this._setExtent(t.extent), t.idMap && (this._idMaps = t.idMap)), 
        this.fire("dataload", {
            extent: t && t.extent
        }));
    }
    _setExtent(t) {
        this._dataExtent = new e.Extent(...t);
    }
    _fetchData(e, t) {
        te(e) ? pe.getJSON(e, t) : pe.getJSON(e.url, e, t);
    }
    getData() {
        return this.features || null;
    }
    getTileUrl(e, t, n) {
        return this.getId() + "," + e + "," + t + "," + n;
    }
    getFeature(e) {
        return this._idMaps ? this._idMaps.get(e) : null;
    }
    static fromJSON(e) {
        return e && "GeoJSONVectorTileLayer" === e.type ? new za(e.id, e.options) : null;
    }
    getGeometryById(e) {
        return this.getFeature(e);
    }
    _generateIdMap() {
        if (!this.features) return;
        if (this.features = JSON.parse(JSON.stringify(this.features)), !this.features) return;
        let e = 0;
        this._idMaps.clear();
        const t = this.options.featureIdProperty, n = this.features, i = n.features || n.data || n;
        if (Array.isArray(i)) for (let n = 0, r = i.length; n < r; n++) {
            const r = i[n];
            if (r) {
                if (ne(r.id) || (r.id = e++), r.properties = r.properties || {}, t) {
                    let e = t;
                    re(t) && (e = t[r.layer || "0"]), r.id = r.properties[e];
                }
                this._idMaps.set(r.id, r);
            }
        }
    }
}

function Na(e) {
    let t = document.createElement("a");
    return t.href = e, e = t.href, t = null, e;
}

function Va(e, t) {
    return e.url ? e.url = t ? t(e.url) : Na(e.url) : e = t ? t(e) : Na(e), e;
}

za.registerJSONType("GeoJSONVectorTileLayer"), za.mergeOptions({
    features: !0,
    tileBuffer: 64,
    extent: 8192,
    pyramidMode: 1,
    simplifyTolerance: 3,
    tileStackDepth: 0,
    generateOMBB: !0
});

const {LayerAbstractRenderer: Ba} = e.renderer, {SYMBOLS_NEED_REBUILD_IN_VECTOR: Ua, GlyphRequestor: Ga, PointPack: ja, LinePack: Wa, StyledPoint: Xa, VectorPack: Ya, StyledVector: qa} = q();

let Za = !1, $a = 1;

const Ja = "_symbol_".trim(), Ka = (Ce + "").trim();

let Qa = new Float32Array(1);

const el = [], tl = [];

class nl extends(x(Ba)){
    constructor(...e) {
        super(...e), this.features = {}, this.featuresArray = [], this.featuresChanged = !1, 
        this._geometries = {}, this._counter = 0, this._allFeatures = {}, this._featureMapping = {}, 
        this._markerFeatures = {}, this._textFeatures = {}, this._lineFeatures = {}, this._dirtyAll = !0, 
        this._kidGen = {
            id: 0,
            pickingId: 0
        }, this._dirtyTargetsInCurrentFrame = {};
    }
    setURLModifier(e) {
        this._urlModifier = e;
    }
    getURLModifier() {
        return this._urlModifier;
    }
    needToRedraw() {
        const e = super.needToRedraw();
        return e || (this.painter && this.painter.needToRedraw() || this._markerPainter && this._markerPainter.needToRedraw() || this._linePainter && this._linePainter.needToRedraw());
    }
    getAnalysisMeshes() {
        return this.painter && this.painter.getAnalysisMeshes() || el;
    }
    getRayCastData() {
        return null;
    }
    _checkFeaturesVisibleChange() {
        this.featuresChanged && (this.featuresArray = Object.values(this.features), this.featuresChanged = !1);
        const e = this.featuresArray;
        if (!e) return this;
        for (let t = 0, n = e.length; t < n; t++) {
            let n = e[t];
            if (n && (Array.isArray(n) || (tl[0] = n, n = tl), n.length)) for (let e = 0; e < n.length; e++) {
                const t = n[e];
                if (!t) continue;
                const i = t.getVisible;
                i !== t._visible && (t._visible = i, this._showHideUpdated = !0);
            }
        }
        return this;
    }
    draw(e, t) {
        this._frameTime = e;
        const n = this.layer;
        this.prepareCanvas(), this._zScale = this._getCentiMeterScale(this.getMap().getGLRes()), 
        this._parentContext = t || {};
        const i = this._parentContext.renderMode, r = this._preparePaintContext();
        if (this._startFrame(r, i), this._dirtyAll) this.buildMesh(), this._buildMarkerMesh(), 
        this._buildLineMesh(), this._dirtyTargetsInCurrentFrame = {}, this._dirtyGeo = !1, 
        this._dirtyAll = !1, this._dirtyLine = !1; else if (this._dirtyGeo) {
            const e = this.atlas, t = this._markerAtlas, n = this._lineAtlas;
            delete this.atlas, delete this._markerAtlas, delete this._lineAtlas, this.buildMesh(e), 
            this._buildMarkerMesh(t), this._buildLineMesh(n), this._dirtyGeo = !1, this._dirtyLine = !1;
        } else if (this._dirtyLine) {
            const e = this._lineAtlas;
            delete this._lineAtlas, this._buildLineMesh(e), this._dirtyLine = !1;
        }
        if (!this.meshes && !this._markerMeshes && !this._lineMeshes) return void this.completeRender();
        this._checkFeaturesVisibleChange(), this._showHideUpdated && (this._updateMeshVisible(), 
        this._showHideUpdated = !1), this._updateDirtyTargets();
        const s = !i || "default" === i;
        let o = 0;
        0 === this.layer.options.meshRenderOrder && this._renderMeshes(r, o, i);
        let a = 0;
        if (this._lineMeshes && (s || this._linePainter.supportRenderMode(i))) {
            this._linePainter.startFrame(r), this._linePainter.addMesh(this._lineMeshes, null, {
                bloom: this._parentContext.bloom
            }), this._linePainter.prepareRender(r);
            const e = r.polygonOffsetIndex || 0;
            o = this.meshes && this.meshes.length ? o - 1 : o, r.polygonOffsetIndex = (r.polygonOffsetIndex || 0) + o, 
            a = this._linePainter.render(r).drawCount, r.polygonOffsetIndex = e;
        }
        if (1 === this.layer.options.meshRenderOrder && this._renderMeshes(r, a ? o - 1 : o, i), 
        this._markerMeshes && (s || this._markerPainter.supportRenderMode(i))) {
            const t = !this._parentContext.timestamp || this._parentContext.isFinalRender, i = !this._collisionTimestamp || this._collisionTimestamp !== e;
            n.options.collision && i && n.clearCollisionIndex();
            const s = this.layer.options.sceneConfig;
            this._markerPainter.sceneConfig.collision = !s || (!!se(s.collision) || s.collision), 
            this._markerPainter.startFrame(r), this._markerPainter.addMesh(this._markerMeshes, null, {
                bloom: this._parentContext.bloom
            }), this._markerPainter.prepareRender(r), n.options.collision && i && (this._markerPainter.updateCollision(r), 
            t && (this._collisionTimestamp = e)), this._markerPainter.render(r);
        }
        (s || t && t.isFinalRender) && (this.completeRender(), this.layer.fire("canvasisdirty"));
    }
    _startFrame(e, t) {
        const n = !t || "default" === t;
        this.painter && (n || this.painter.supportRenderMode(t)) && this.painter.startFrame(e);
    }
    _renderMeshes(e, t, n) {
        const i = !n || "default" === n;
        if (this.painter && this.meshes && (i || this.painter.supportRenderMode(n))) {
            this.painter.addMesh(this.meshes, null, {
                bloom: e && e.bloom
            }), this.painter.prepareRender(e), e.polygonOffsetIndex = (e.polygonOffsetIndex || 0) + t;
            return this.painter.render(e);
        }
        return {
            redraw: !1,
            drawCount: 0
        };
    }
    supportRenderMode() {
        return !0;
    }
    isForeground() {
        return !0;
    }
    _preparePaintContext() {
        const e = {
            regl: this.regl,
            layer: this.layer,
            symbol: this._layerSymbol,
            gl: this.gl,
            sceneConfig: this.layer.options.sceneConfig,
            pluginIndex: 0,
            cameraPosition: this.getMap().cameraPosition,
            timestamp: this.getFrameTimestamp()
        };
        return this._parentContext && ee(e, this._parentContext), e;
    }
    drawOnInteracting(e, t, n) {
        this.draw(t, n);
    }
    getFrameTimestamp() {
        return this._frameTime;
    }
    _getFeaturesToRender(e, t) {
        (e = e || t) === t && (t = null);
        const n = [], i = [ 0, 0, 0, 0 ];
        this.layer._sortGeometries();
        const r = this.layer.getGeometries();
        for (let s = 0; s < r.length; s++) {
            const o = r[s][pi];
            if (!this.features[o]) continue;
            const a = this.features[o];
            if (Array.isArray(a)) for (let r = 0; r < a.length; r++) {
                const s = a[r], o = s[Ka];
                (!e || e[o] || t && (!t || t[o])) && (s.visible || (this._showHideUpdated = !0), 
                this._addCoordsToCenter(s.geometry, i, s.coordinates), n.push(s));
            } else {
                a.visible || (this._showHideUpdated = !0);
                const r = a[Ka];
                if (e && !e[r] && (!t || t && !t[r])) continue;
                this._addCoordsToCenter(a.geometry, i, a.coordinates), n.push(a);
            }
        }
        if (n.length || (this.meshes && this.painter && (this.painter.deleteMesh(this.meshes), 
        delete this.meshes), this._markerMeshes && (this._markerPainter.deleteMesh(this._markerMeshes), 
        delete this._markerMeshes), this._lineMeshes && (this._linePainter.deleteMesh(this._lineMeshes), 
        delete this._lineMeshes)), i[3] && (i[0] /= i[3], i[1] /= i[3]), isNaN(i[0]) || isNaN(i[1])) throw new Error(`invalid geometry coordinates for ${this.layer.getJSONType()}`);
        return {
            features: n,
            center: i
        };
    }
    buildMesh() {}
    createVectorPacks(e, t, n, i, r, s) {
        if (!e || !i || !i.length) return Promise.resolve(null);
        const o = this._getPackOptions(r, s);
        o.requestor = this.requestor;
        return new t(i, n, o).load();
    }
    createMesh(e, t, n, i, r, s) {
        return this.createVectorPacks(e, t, n, i, r, s).then((o => this._createMesh(o, e, t, n, i, r, s)));
    }
    _createMesh(e, t, n, i, r, s, o) {
        if (!e) return null;
        const a = t.createGeometries([ e.data ], Ee(r, null, 0, i, this.layer));
        for (let e = 0; e < a.length; e++) a[e] && this._fillCommonProps(a[e].geometry);
        const l = y.identity([]);
        y.translate(l, l, m.set([], o[0], o[1], 0)), y.scale(l, l, m.set([], 1, 1, this._zScale));
        const h = t.createMeshes(a, l, {
            tilePoint: [ o[0], o[1] ]
        });
        for (let e = 0; e < h.length; e++) {
            const t = h[e];
            t.properties.level = 0, t.properties.tileTransform = l;
            const n = t.defines;
            n.ENABLE_TILE_STENCIL = 1, t.setDefines(n), t.properties.meshKey = this.layer.getId();
        }
        return {
            meshes: h,
            atlas: {
                iconAtlas: e.data.iconAtlas
            }
        };
    }
    _addCoordsToCenter(e, t, n) {
        for (let i = 0; i < e.length; i++) if (Array.isArray(e[i][0])) for (let r = 0; r < e[i].length; r++) if (Array.isArray(e[i][r][0])) for (let s = 0; s < e[i][r].length; s++) isNaN(+e[i][r][s][0]) || isNaN(+e[i][r][s][1]) || this._addCoord(t, e[i][r][s][0], e[i][r][s][1], e[i][r][s][2], 1, n[i][r][s]); else isNaN(+e[i][r][0]) || isNaN(+e[i][r][1]) || this._addCoord(t, e[i][r][0], e[i][r][1], e[i][r][2], 1, n[i][r]); else isNaN(+e[i][0]) || isNaN(+e[i][1]) || this._addCoord(t, e[i][0], e[i][1], e[i][2], 1, n[i]);
    }
    _addCoord(e, t, n, i, r, s) {
        const o = this.getMap().getProjection().isSphere();
        let a = !1;
        (s[0] > 180 || s[0] < -180) && o && !Za && (a = !0, Za = !0, console.warn(`Layer(${this.layer.getId()}) has invalid longitude value: ${s[0]}`)), 
        (s[1] > 90 || s[1] < -90) && o && !Za && (a = !0, Za = !0, console.warn(`Layer(${this.layer.getId()}) has invalid latitude value: ${s[1]}`)), 
        a || (e[0] += t, e[1] += n, e[2] += i || 0, e[3] += r);
    }
    _fillCommonProps(e) {
        const t = this.getMap().getGLRes(), n = e.properties;
        n.tileResolution = t, n.tileRatio = 1, n.z = 1, n.tileExtent = 1, n.elements = e.elements, 
        n.aPickingId = e.data.aPickingId;
    }
    _isEnableWorkAround(e) {
        return "win-intel-gpu-crash" === e && (this.gl && this.layer.options.workarounds["win-intel-gpu-crash"] && rl(this.gl));
    }
    prepareRequestors() {
        if (this._iconRequestor) return;
        const e = this.layer;
        this._iconRequestor = new me({
            iconErrorUrl: e.options.iconErrorUrl,
            urlModifier: t => {
                const n = e.getURLModifier();
                return n && n(t) || t;
            }
        });
        const t = !this._isEnableWorkAround("win-intel-gpu-crash"), n = e.options.sdfURL;
        this._glyphRequestor = new Ga((t => {
            e.getMap().getRenderer().callInNextFrame(t);
        }), e.options.glyphSdfLimitPerFrame, t, n), this.requestor = this._fetchPattern.bind(this), 
        this._markerRequestor = this._fetchIconGlyphs.bind(this);
    }
    _fetchPattern(e, t, n) {
        const i = [];
        this._iconRequestor.getIcons(e, ((e, t) => {
            if (e) throw e;
            t.buffers && i.push(...t.buffers), n(null, {
                icons: t.icons
            }, i);
        }));
    }
    _fetchIconGlyphs(e, t, n) {
        this._glyphRequestor.getGlyphs(t, ((t, i) => {
            if (t) throw t;
            const r = i.buffers || [];
            this._iconRequestor.getIcons(e, ((e, t) => {
                if (e) throw e;
                t.buffers && t.buffers.length && r.push(...t.buffers), n(null, {
                    icons: t.icons,
                    glyphs: i.glyphs
                }, r);
            }));
        }));
    }
    _buildMarkerMesh(e) {
        const t = Object.keys(this._markerFeatures), n = Object.keys(this._textFeatures);
        if (!t.length && !n.length) return void (this._markerMeshes && (this._markerPainter.deleteMesh(this._markerMeshes), 
        delete this._markerMeshes));
        const {features: i, center: r} = this._getFeaturesToRender(this._markerFeatures, this._textFeatures), s = [], o = [];
        for (let e = 0; e < i.length; e++) {
            const t = i[e][Ka];
            this._markerFeatures[t] && s.push(i[e]), this._textFeatures[t] && o.push(i[e]);
        }
        if (!s.length && !o.length) return void (this._markerMeshes && (this._markerPainter.deleteMesh(this._markerMeshes), 
        delete this._markerMeshes));
        const a = this._showHideUpdated;
        this._markerCenter = r;
        const l = this._createPointPacks(s, o, e, r);
        this._markerAtlas = {};
        const h = [], c = [];
        this._isCreatingMarkerMesh = !0, Promise.all(l).then((e => {
            if (this._markerMeshes && (this._markerPainter.deleteMesh(this._markerMeshes), delete this._markerMeshes), 
            !e || !e.length) return void this.setToRedraw();
            const t = this._markerPainter.createGeometries(e.map((e => (e && e.data && (e.data.isIdUnique = !0), 
            e && e.data))), this._allFeatures);
            for (let n = 0; n < t.length; n++) this._fillCommonProps(t[n].geometry, e[n] && e[n].data);
            const n = e[0] && e[0].data.iconAtlas, i = e[0] && e[0].data.glyphAtlas || e[1] && e[1].data.glyphAtlas;
            n && (this._markerAtlas.iconAtlas = n), i && (this._markerAtlas.glyphAtlas = i);
            const s = y.identity([]);
            y.translate(s, s, m.set(c, r[0], r[1], 0)), y.scale(s, s, m.set(h, 1, 1, this._zScale));
            const o = this._markerPainter.createMeshes(t, s);
            for (let e = 0; e < o.length; e++) o[e].geometry.properties.originElements = o[e].geometry.properties.elements.slice(), 
            o[e].properties.level = 0, o[e].material.set("flipY", 1), o[e].properties.meshKey = $a++;
            this._markerMeshes = o, a && (this._showHideUpdated = !0), this._isCreatingMarkerMesh = !1, 
            this.setToRedraw(), this.layer.fire("buildmarkermesh");
        }));
    }
    _updateMeshVisible() {
        if (this._markerMeshes && (this._updateVisElements(this._markerMeshes[0], this._markerFeatures), 
        this._updateVisElements(this._markerMeshes[1], this._textFeatures), this._markerMeshes[0] && this._markerPainter.prepareCollideIndex(this._markerMeshes[0].geometry), 
        this._markerMeshes[1] && this._markerPainter.prepareCollideIndex(this._markerMeshes[1].geometry)), 
        this._lineMeshes) for (let e = 0; e < this._lineMeshes.length; e++) this._updateVisElements(this._lineMeshes[e], this._lineFeatures);
        if (this.meshes) for (let e = 0; e < this.meshes.length; e++) this._updateVisElements(this.meshes[e], this._allFeatures);
    }
    _updateVisElements(e, t) {
        if (!e) return;
        const {aPickingId: n, originElements: i} = e.geometry.properties, r = [];
        for (let e = 0; e < i.length; e++) {
            const s = n[i[e]];
            t[s] && t[s].feature.getVisible && r.push(i[e]);
        }
        const s = e.geometry.properties.elements = new i.constructor(r);
        e.geometry.setElements(s);
    }
    _getPackOptions(t, n) {
        const i = this.getMap(), r = e.MapStateCache[i.id];
        return {
            zoom: r ? r.zoom : i.getZoom(),
            EXTENT: 1 / 0,
            atlas: t,
            center: n,
            positionType: Float32Array,
            isWebGL1: this.gl && this.gl instanceof WebGLRenderingContext
        };
    }
    _createPointPacks(e, t, n, i) {
        const r = this._getPackOptions(n, i);
        return r.defaultAltitude = 0, r.forceAltitudeAttribute = !0, r.requestor = this._markerRequestor, 
        r.markerWidthType = Uint16Array, r.markerHeightType = Uint16Array, r.defaultMarkerVerticalAlignment = "top", 
        r.allowEmptyPack = 1, [ this._markerSymbol ].map(((n, i) => new ja(0 === i ? e : t, n, r).load()));
    }
    updateMesh() {}
    _updateMarkerMesh(t) {
        const n = this.getMap(), i = e.MapStateCache[n.id], r = i ? i.zoom : n.getZoom(), s = t._getInternalSymbol(), o = {
            zoom: r,
            isVector3D: !0,
            defaultMarkerVerticalAlignment: "top"
        }, a = this._convertGeo(t);
        if (!this._markerMeshes) return !1;
        let l = this.features[a];
        Array.isArray(l) || (l = [ l ]);
        const h = [], c = [], u = [];
        let f, d;
        f = Array.isArray(s) ? s.map((e => e ? R(e, (() => (h[0] = r, h))) : e)) : R(s, (() => (h[0] = r, 
        h))), d = Array.isArray(s) ? s.map((e => e ? Ya.genFnTypes(e) : e)) : Ya.genFnTypes(s);
        for (let e = 0; e < l.length; e++) {
            if (!l[e]) continue;
            const t = Array.isArray(s) ? s[e] : s, n = Array.isArray(f) ? f[e] : f, i = Array.isArray(d) ? d[e] : d, r = new Xa(l, t, n, i, o).getIconAndGlyph();
            if (!this._markerAtlas || !ja.isAtlasLoaded(r, this._markerAtlas)) return this.markRebuild(), 
            this.setToRedraw(), !1;
        }
        for (let e = 0; e < l.length; e++) {
            const t = l[e][Ka];
            this._markerFeatures[t] && c.push(l[e]), this._textFeatures[t] && u.push(l[e]);
        }
        const p = l[0].id, g = this._createPointPacks(c, u, this._markerAtlas, this._markerCenter), m = this._markerMeshes;
        return Promise.all(g).then((e => {
            for (let t = 0; t < e.length; t++) {
                if (!e[t]) continue;
                e[t].data && (e[t].data.isIdUnique = !0);
                const n = m[t], i = n.geometry.properties.aFeaIds.indexOf(p);
                if (i < 0) continue;
                const r = e[t].data.featureIds.length, s = e[t].data.dynamicAttributes;
                for (const o in e[t].data.data) {
                    if ("aPickingId" === o) continue;
                    if (s[o]) continue;
                    const a = e[t].data.data[o];
                    a && n.geometry.updateSubData(o, a, i * a.length / r);
                }
            }
            this.setToRedraw();
        })), !0;
    }
    _updateLineMesh(e) {
        return this._updateMesh(e, this._lineMeshes, this._lineAtlas, this._lineCenter, this._linePainter, Wa, ci, this._groupLineFeas);
    }
    _updateMesh(t, n, i, r, s, o, a, l) {
        if (!n) return !1;
        if (!i) return this.markRebuild(), this.setToRedraw(), !1;
        const h = t._getInternalSymbol(), c = this.getMap(), u = e.MapStateCache[c.id], f = {
            zoom: u ? u.zoom : c.getZoom()
        }, d = t[pi];
        let p = this.features[d];
        Array.isArray(p) || (p = [ p ]);
        const g = [];
        for (let e = 0; e < p.length; e++) {
            const t = p[e];
            if (!t) continue;
            const n = Array.isArray(h) ? h[e] : h, r = Ya.genFnTypes(n), s = new qa(p, n, r, f), a = o === Wa ? s.getLineResource() : s.getPolygonResource();
            if (!Ya.isAtlasLoaded(a, i[e])) return this.markRebuild(), this.setToRedraw(), !1;
            g.push(t);
        }
        const m = p[0].id, y = l.call(this, g);
        for (let e = 0; e < y.length; e++) if (y[e].length) {
            const t = n.filter((t => t.feaGroupIndex === e));
            if (!t.length) return this.markRebuild(), this.setToRedraw(), !1;
            if (t[0].geometry.properties.aFeaIds.indexOf(m) < 0) return this.markRebuild(), 
            this.setToRedraw(), !1;
        }
        const x = ee({}, a), _ = y.map((e => this.createVectorPacks(s, o, x, e, i[0], r)));
        return Promise.all(_).then((e => {
            for (let t = 0; t < e.length; t++) {
                let i;
                if (Array.isArray(n)) {
                    for (let e = 0; e < n.length; e++) if (n[e].feaGroupIndex === t) {
                        i = n[e];
                        break;
                    }
                } else i = n;
                i && this._updateMeshData(i, m, e[t]);
            }
        })), !0;
    }
    _updateMeshData(e, t, n) {
        const i = e.geometry.properties.aFeaIds, r = i.indexOf(t);
        if (!(r < 0)) {
            if (n) {
                const t = n.data.dynamicAttributes, i = n.data.featureIds.length, s = n.data.data;
                for (const n in s) if (!t[n] && le(s, n) && s[n]) {
                    const t = s[n];
                    e.geometry.updateSubData(n, t, r * t.length / i);
                }
            } else {
                let n = r + 1;
                for (;i[n] === t; ) n++;
                const s = n - r, o = e.geometry.desc.positionSize;
                Qa.length !== 3 * s && (Qa = new Float32Array(s * o), Qa.fill(-1 / 0, 0)), e.geometry.updateSubData(e.geometry.desc.positionAttribute, Qa, r * o);
            }
            this.layer.fire("updatemesh"), this.setToRedraw();
        }
    }
    _buildLineMesh(e) {
        if (!Object.keys(this._lineFeatures).length) return void (this._lineMeshes && (this._linePainter.deleteMesh(this._lineMeshes), 
        delete this._lineMeshes));
        const {features: t, center: n} = this._getFeaturesToRender(this._lineFeatures);
        if (!t.length) return;
        const i = this._showHideUpdated;
        this._lineCenter = n;
        const r = this._groupLineFeas(t), s = ee({}, ci), o = r.map(((t, i) => this.createMesh(this._linePainter, Wa, s, t, e && e[i], n)));
        this._isCreatingLineMesh = !0, Promise.all(o).then((e => {
            this._lineMeshes && this._linePainter.deleteMesh(this._lineMeshes);
            const t = [], n = [];
            for (let i = 0; i < e.length; i++) {
                const r = e[i] && e[i].meshes;
                if (r) {
                    for (let e = 0; e < r.length; e++) {
                        const n = r[e];
                        n.feaGroupIndex = i, t.push(n), n.geometry.properties.originElements = n.geometry.properties.elements.slice();
                    }
                    n[i] = e[i].atlas;
                }
            }
            this._lineMeshes = t, this._lineAtlas = n, i && (this._showHideUpdated = i), this._isCreatingLineMesh = !1, 
            this.setToRedraw(), this.layer.fire("buildlinemesh");
        }));
    }
    _groupLineFeas(e) {
        const t = (Ja + "lineDasharray").trim(), n = (Ja + "linePatternFile").trim(), i = [], r = [], s = [];
        for (let o = 0; o < e.length; o++) {
            const a = e[o], l = a.properties && a.properties[t];
            l && cl(l) ? s.push(a) : a.properties && a.properties[n] ? r.push(a) : i.push(a);
        }
        return [ i, r, s ];
    }
    markRebuildGeometry() {
        this._dirtyGeo = !0, this.setToRedraw();
    }
    markRebuild() {
        this._dirtyAll = !0, this.setToRedraw();
    }
    _convertGeometries(e) {
        const t = this.layer.getId();
        for (let n = 0; n < e.length; n++) {
            const i = e[n];
            let r = !1;
            for (let e = 0; e < this.GeometryTypes.length; e++) if (i instanceof this.GeometryTypes[e]) {
                r = !0;
                break;
            }
            if (!r) throw new Error(`${i.getJSONType()} can't be added to ${this.layer.getJSONType()}(id:${t}).`);
            this._convertGeo(i);
        }
    }
    _convertGeo(e) {
        void 0 === e[pi] && (e[pi] = this._counter++);
        const t = e[pi];
        this.features[t] && this._removeFeatures(t), this.features[t] = yi(e, this._kidGen, this.features[t]), 
        this.featuresChanged = !0;
        const n = this.features[t];
        return this._refreshFeatures(n, t), this._geometries[t] = e, t;
    }
    _refreshFeatures(e, t) {
        if (!e) return;
        const n = Array.isArray(e) ? e[0].id : e.id;
        if (this._featureMapping[n] = e, Array.isArray(e)) for (let n = 0; n < e.length; n++) {
            const i = e[n][Ka];
            if (e[n][pi] = t, this._allFeatures[i] = {
                feature: e[n]
            }, this._allFeatures[i][pi] = t, !this.needCheckPointLineSymbols()) continue;
            const r = {
                feature: e[n]
            };
            (sl(e[n]) || ol(e[n])) && (this._markerFeatures[i] = r), ol(e[n]) && (this._textFeatures[i] = r), 
            hl(e[n]) && (this._lineFeatures[i] = r);
        } else {
            e[pi] = t;
            const n = {
                feature: e
            }, i = e[Ka];
            if (this._allFeatures[i] = n, !this.needCheckPointLineSymbols()) return;
            (sl(e) || ol(e)) && (this._markerFeatures[i] = n), ol(e) && (this._textFeatures[i] = n), 
            hl(e) && (this._lineFeatures[i] = n);
        }
    }
    needCheckPointLineSymbols() {
        return !0;
    }
    _removeFeatures(e) {
        const t = this.features[e];
        if (t) if (Array.isArray(t)) for (let e = 0; e < t.length; e++) {
            const n = t[e][Ka], i = t[e].id;
            delete this._featureMapping[i], delete this._allFeatures[n], delete this._markerFeatures[n], 
            delete this._textFeatures[n], delete this._lineFeatures[n];
        } else {
            const e = t[Ka], n = t.id;
            delete this._featureMapping[n], delete this._allFeatures[e], delete this._markerFeatures[e], 
            delete this._textFeatures[e], delete this._lineFeatures[e];
        }
    }
    _removeAllFeatures() {
        this._featureMapping = {}, this._allFeatures = {}, this._markerFeatures = {}, this._textFeatures = {}, 
        this._lineFeatures = {};
    }
    pick(e, t, n) {
        const i = [];
        if (!this.layer.isVisible()) return i;
        return [ this.painter, this._markerPainter, this._linePainter ].forEach((r => {
            if (!r) return;
            const s = r.pick(e, t, n.tolerance);
            if (s && s.data && s.data.feature) {
                const e = s.data.feature, t = this._geometries[e[pi]];
                n && n.includeInternals ? i.push(t) : (s.geometry = t, delete s.plugin, delete s.data, 
                delete s.point, i.push(s));
            }
        })), i;
    }
    _getFeaKeyId(e) {
        const t = e[pi], n = this.features[t];
        return Array.isArray(n) ? n[0][Ka] : n[Ka];
    }
    _updateDirtyTargets() {
        let e = !1;
        for (const t in this._dirtyTargetsInCurrentFrame) {
            const n = this._dirtyTargetsInCurrentFrame[t], i = this._getFeaKeyId(n);
            if (!this._isCreatingMarkerMesh && (this._markerFeatures[i] || this._textFeatures[i])) {
                const t = this._updateMarkerMesh(n);
                e = e || t;
            }
            if (!this._isCreatingLineMesh && this._lineFeatures[i]) {
                const t = this._updateLineMesh(n);
                e = e || t;
            }
            if (!this._isCreatingMesh) {
                const t = this.updateMesh(n);
                e = e || t;
            }
        }
        this._dirtyTargetsInCurrentFrame = {}, e && (il(this), this.layer.fire("partialupdate"));
    }
    _convertAndRebuild(e) {
        this._convertGeo(e), this.markRebuild(), il(this);
    }
    onGeometryAdd(e) {
        if (this.setToRedraw(), this.canvas && e && e.length) {
            for (let t = 0; t < e.length; t++) {
                const n = e[t];
                n && delete n[pi];
            }
            this._convertGeometries(e), this.markRebuild(), il(this);
        }
    }
    onGeometryRemove(e) {
        if (e && e.length) {
            for (let t = 0; t < e.length; t++) {
                const n = e[t], i = n[pi];
                void 0 !== i && (delete n[pi], delete this._geometries[i], this._removeFeatures(i), 
                delete this.features[i], this.featuresChanged = !0);
            }
            this.markRebuild(), il(this), this.layer.fire("removegeo", {
                type: "removegeo",
                target: this,
                geometries: e
            });
        }
    }
    onGeometrySymbolChange(e) {
        const t = e.target._getParent() || e.target, n = t[pi];
        if (void 0 === n) return;
        let i = e.properties;
        if (Array.isArray(i)) {
            const e = {};
            for (let t = 0; t < i.length; t++) i[t] && ee(e, i[t]);
            i = e;
        } else if (i && void 0 !== i[0]) {
            const e = {};
            for (const t in i) i[t] && ee(e, i[t]);
            i = e;
        }
        for (const e in i) if (le(i, e) && Ua[e]) return void this._convertAndRebuild(t);
        const r = t._getInternalSymbol(), s = this.features[n];
        if (this._convertGeo(t), s) if (function(e, t) {
            return Array.isArray(e) ? !!Array.isArray(t) && e.length === t.length : !Array.isArray(t);
        }(r, s)) {
            if (Array.isArray(r)) for (let e = 0; e < r.length; e++) {
                if (!ul(r[e], s[e])) return void this._convertAndRebuild(t);
            } else if (!ul(r, s)) return void this._convertAndRebuild(t);
            this.onGeometryPositionChange(e);
        } else this._convertAndRebuild(t); else this._convertAndRebuild(t);
    }
    onGeometryShapeChange(e) {
        const t = e.target._getParent() || e.target;
        void 0 !== t[pi] && (this._convertGeometries([ t ]), this.markRebuildGeometry(), 
        il(this));
    }
    onGeometryPositionChange(e) {
        const t = e.target._getParent() || e.target, n = t[pi];
        void 0 !== n && (this._convertGeometries([ t ]), this._dirtyTargetsInCurrentFrame[n] = t, 
        il(this));
    }
    onGeometryZIndexChange(e) {
        void 0 !== (e.target._getParent() || e.target)[pi] && this.markRebuild();
    }
    onGeometryShow(e) {
        void 0 !== (e.target._getParent() || e.target)[pi] && this._onShowHide(e);
    }
    onGeometryHide(e) {
        void 0 !== (e.target._getParent() || e.target)[pi] && this._onShowHide(e);
    }
    _onShowHide(e) {
        const t = e.target._getParent() || e.target, n = t[pi], i = this.features[n];
        if (i) {
            const e = t.isVisible();
            if (Array.isArray(i)) {
                if (e === i[0].visible) return;
                for (let t = 0; t < i.length; t++) i[t].visible = e;
            } else {
                if (e === i.visible) return;
                i.visible = e;
            }
            this._markShowHide(), il(this);
        }
    }
    _markShowHide() {
        this._showHideUpdated = !0;
    }
    onGeometryPropertiesChange(e) {
        const t = e.target._getParent() || e.target, n = t[pi];
        void 0 !== n && this.features[n] && (this.features[n] = yi(t, this._kidGen), this._refreshFeatures(this.features[n], n), 
        this._markerMeshes && this._markerMeshes.length && this._markerPainter.needRebuildOnGometryPropertiesChanged() || this._lineMeshes && this._lineMeshes.length && this._linePainter.needRebuildOnGometryPropertiesChanged() || this.meshes && this.meshes.length && this.painter.needRebuildOnGometryPropertiesChanged() ? this.markRebuild() : this.meshes && this.painter.onFeatureChange(this.features[n], this.meshes), 
        il(this));
    }
    initContext() {
        super.initContext();
        const {regl: e, device: t, reglGL: n} = this.context, i = e || t;
        this.regl = e, this.gl = n, this.device = t || e;
        const r = {
            colorFormat: !!this.device.wpu ? "bgra8unorm" : "rgba",
            depthStencil: !0,
            width: this.canvas.width,
            height: this.canvas.height
        };
        this.canvas.pickingFBO = this.canvas.pickingFBO || i.framebuffer(r), this.pickingFBO = this.canvas.pickingFBO, 
        this.prepareRequestors(), this._initPainters();
    }
    _initPainters() {
        this.painter = this.createPainter();
        const e = Et.get3DPainterClass("icon");
        let t = e.getBloomSymbol();
        const n = ee({}, li, hi);
        n.markerPerspectiveRatio = this.layer.options.markerPerspectiveRatio || 0, this._defineSymbolBloom(n, t, "enableMarkerBloom"), 
        this._markerSymbol = n;
        const i = ee({}, Ae, this.layer.options.sceneConfig || {});
        this._markerPainter = new e(this.regl || this.device, this.layer, n, i, 0), this._markerPainter.setShaderDefines({
            REVERSE_MAP_ROTATION_ON_PITCH: 1
        });
        const r = Et.get3DPainterClass("line"), s = ee({}, ci);
        t = r.getBloomSymbol(), this._defineSymbolBloom(s, t, "enableLineBloom"), this._lineSymbol = s;
        const o = ee({}, this.layer.options.sceneConfig || {});
        void 0 === o.depthMask && (o.depthMask = !0), this._linePainter = new r(this.regl || this.device, this.layer, s, o, 0), 
        this.rebuildGeometries();
    }
    rebuildGeometries() {
        this._removeAllFeatures();
        const e = this.getCurrentNeedRenderGeos();
        e && e.length && this.onGeometryAdd(e), this.markRebuild();
    }
    getCurrentNeedRenderGeos() {
        return this.layer.getGeometries();
    }
    _defineSymbolBloom(e, t, n) {
        let i = this.layer.options.enableBloom;
        !i && n && (i = this.layer.options[n]);
        for (let n = 0; n < t.length; n++) e[t[n]] = i;
    }
    updateBloom(e) {
        this.updateMarkerBloom(e), this.updateLineBloom(e), this.updatePolygonBloom(e);
    }
    updateMarkerBloom(e) {
        this._markerPainter && this._updatePainterBloom(this._markerPainter, this._markerSymbol, e);
    }
    updateLineBloom(e) {
        this._linePainter && this._updatePainterBloom(this._linePainter, this._lineSymbol, e);
    }
    updatePolygonBloom(e) {
        this.painter && this._updatePainterBloom(this.painter, this.painterSymbol, e);
    }
    _updatePainterBloom(e, t, n) {
        const i = e.constructor.getBloomSymbol().reduce(((e, i) => (e[i] = n, t[i] = n, 
        e)), {});
        e.updateSymbol(i, t);
    }
    createPainter() {}
    resizeCanvas(e) {
        super.resizeCanvas(e);
        const t = this.canvas;
        t && (!this.pickingFBO || this.pickingFBO.width === t.width && this.pickingFBO.height === t.height || this.pickingFBO.resize(t.width, t.height), 
        this.painter && this.painter.resize(t.width, t.height));
    }
    onRemove() {
        super.onRemove(), this.painter && (this.painter.delete(), delete this.painter), 
        this._markerPainter && (this._markerPainter.delete(), delete this._markerPainter), 
        this._linePainter && (this._linePainter.delete(), delete this._linePainter);
    }
    drawOutline(e) {
        if (this._outlineAll && (this.painter && this.painter.outlineAll(e), this._markerPainter.outlineAll(e), 
        this._linePainter.outlineAll(e)), this._outlineFeatures) for (let t = 0; t < this._outlineFeatures.length; t++) this.painter && this.painter.outline(e, this._outlineFeatures[t]), 
        this._markerPainter.outline(e, this._outlineFeatures[t]), this._linePainter.outline(e, this._outlineFeatures[t]);
    }
    outlineAll() {
        this._outlineAll = !0, this.setToRedraw();
    }
    outline(e) {
        this._outlineFeatures || (this._outlineFeatures = []);
        const t = [];
        for (let n = 0; n < e.length; n++) {
            const i = this.layer.getGeometryById(e[n]);
            if (i) {
                const e = this.features[i[pi]];
                if (Array.isArray(e)) for (let n = 0; n < e.length; n++) t.push(e[n].id); else t.push(e.id);
            }
        }
        this._outlineFeatures.push(t), this.setToRedraw();
    }
    cancelOutline() {
        delete this._outlineAll, delete this._outlineFeatures, this.setToRedraw();
    }
    isEnableWorkAround(e) {
        return "win-intel-gpu-crash" === e && (this.layer.options.workarounds["win-intel-gpu-crash"] && rl(this.gl));
    }
    _getCentiMeterScale(e) {
        return he(e, this.getMap());
    }
    _onSpatialReferenceChange() {
        const e = this.layer.getGeometries();
        e && this._convertGeometries(e), this.markRebuild();
    }
    _getLayerOpacity() {
        const e = this.layer.options.opacity;
        return se(e) ? 1 : e;
    }
}

function il(e) {
    e.setToRedraw();
}

function rl(e) {
    const t = e.getExtension("WEBGL_debug_renderer_info");
    if (t && "undefined" != typeof navigator) {
        const n = e.getParameter(t.UNMASKED_RENDERER_WEBGL), i = "Win32" === navigator.platform || "Win64" === navigator.platform;
        if (n && n.toLowerCase().indexOf("intel") >= 0 && i) return !0;
    }
    return !1;
}

function sl({properties: e}) {
    const t = (Ja + "markerFile").trim(), n = (Ja + "markerType").trim();
    return e[t] || e[n];
}

function ol({properties: e}) {
    return e[(Ja + "textName").trim()];
}

const al = (Ja + "lineWidth").trim(), ll = (ui + "").trim();

function hl(e) {
    return 2 === e.type && !e.properties[ll] || 3 === e.type && void 0 !== e.properties[al];
}

function cl(e) {
    if (!Array.isArray(e)) return 0;
    let t = 0;
    for (let n = 0; n < e.length; n++) t += e[n];
    return t;
}

function ul(e, t) {
    if (Object.keys(e).sort().join() !== Object.keys(t.properties || {}).filter((e => 0 === e.indexOf(Ja))).map((e => e.substring(Ja.length))).sort().join()) return !1;
    for (const n in e) if (le(e, n)) {
        const i = (Ja + n).trim();
        if (k(e[n]) !== k(t.properties[i])) return !1;
    }
    return !0;
}

function fl(t, n, i) {
    if (!t || t.type !== n) return null;
    const r = new i(t.id, t.options), s = t.geometries, o = [];
    for (let t = 0; t < s.length; t++) {
        const n = e.Geometry.fromJSON(s[t]);
        n && o.push(n);
    }
    return r.addGeometry(o), r;
}

class dl extends Et {
    static fromJSON(e) {
        return fl(e, "PointLayer", dl);
    }
    constructor(...e) {
        super(...e), this.options.sceneConfig || (this.options.sceneConfig = ee({}, Ae));
    }
    getPolygonOffsetCount() {
        return 0;
    }
    getPolygonOffset() {
        return 0;
    }
}

dl.mergeOptions({
    glyphSdfLimitPerFrame: 15,
    iconErrorUrl: null,
    workarounds: {
        "win-intel-gpu-crash": !0
    },
    collision: !1,
    collisionFrameLimit: 1
}), dl.registerJSONType("PointLayer"), dl.registerRenderer("canvas", null);

class pl extends nl {
    constructor(...t) {
        super(...t), this.GeometryTypes = [ e.Marker, e.MultiPoint ];
    }
    onGeometryAdd(e) {
        e && (Array.isArray(e) ? e.forEach((e => {
            e.options.maxMarkerWidth = e.options.maxMarkerHeight = 255;
        })) : e.options.maxMarkerWidth = e.options.maxMarkerHeight = 255, super.onGeometryAdd(e));
    }
}

dl.registerRenderer("gl", pl), dl.registerRenderer("gpu", pl);

const {LinePack: gl} = q();

class ml extends Et {
    static fromJSON(e) {
        return fl(e, "LineStringLayer", ml);
    }
}

ml.mergeOptions({
    meshRenderOrder: 1
}), ml.registerJSONType("LineStringLayer");

const yl = (ui + "").trim();

class xl extends nl {
    constructor(...t) {
        super(...t), this.GeometryTypes = [ e.LineString, e.MultiLineString ];
    }
    createPainter() {
        const e = Et.get3DPainterClass("line-gradient");
        this.painterSymbol = ee({}, {
            lineGradientProperty: yl
        }, ci), this._defineSymbolBloom(this.painterSymbol, e.getBloomSymbol(), "enableLineBloom");
        const t = ee({}, this.layer.options.sceneConfig || {});
        void 0 === t.depthMask && (t.depthMask = !0);
        return new e(this.device || this.regl, this.layer, this.painterSymbol, t, 0);
    }
    buildMesh() {
        let {features: e, center: t} = this._getFeaturesToRender();
        if (e = e.filter((e => !!e.properties[yl])), !e.length) return;
        const n = this._showHideUpdated;
        this._meshCenter = t;
        const i = ee({}, this.painterSymbol), r = this.createMesh(this.painter, gl, i, e, null, t);
        this._isCreatingMesh = !0, r.then((e => {
            this.meshes && this.painter.deleteMesh(this.meshes);
            const t = [], i = e && e.meshes;
            if (i) {
                t.push(...i);
                for (let e = 0; e < i.length; e++) i[e].feaGroupIndex = 0, i[e].geometry.properties.originElements = i[e].geometry.properties.elements.slice();
            }
            this.meshes = t, n && (this._showHideUpdated = n), this._isCreatingMesh = !1, this.setToRedraw();
        }));
    }
}

ml.registerRenderer("gl", xl), ml.registerRenderer("gpu", xl), ml.registerRenderer("canvas", null);

const {PolygonPack: _l} = q();

class vl extends Et {
    static fromJSON(e) {
        return fl(e, "PolygonLayer", vl);
    }
}

vl.registerJSONType("PolygonLayer");

const bl = {
    polygonFill: {
        type: "identity",
        default: [ 1, 1, 1, 1 ],
        property: "_symbol_polygonFill"
    },
    polygonPatternFile: {
        type: "identity",
        default: void 0,
        property: "_symbol_polygonPatternFile"
    },
    polygonOpacity: {
        type: "identity",
        default: 1,
        property: "_symbol_polygonOpacity"
    },
    uvScale: {
        type: "identity",
        default: [ 1, 1 ],
        property: "_symbol_uvScale"
    },
    uvOffset: {
        type: "identity",
        default: [ 0, 0 ],
        property: "_symbol_uvOffset"
    },
    uvOffsetInMeter: {
        type: "identity",
        default: !1,
        property: "_symbol_uvOffsetInMeter"
    },
    polygonPatternFileWidth: {
        type: "identity",
        default: void 0,
        property: "_symbol_polygonPatternFileWidth"
    },
    polygonPatternFileHeight: {
        type: "identity",
        default: void 0,
        property: "_symbol_polygonPatternFileHeight"
    },
    polygonPatternFileOrigin: {
        type: "identity",
        default: void 0,
        property: "_symbol_polygonPatternFileOrigin"
    },
    polygonPatternUV: {
        type: "identity",
        default: void 0,
        property: "_symbol_polygonPatternUV"
    }
};

class Al extends nl {
    constructor() {
        super(...arguments), this.GeometryTypes = [ e.Polygon, e.MultiPolygon ];
    }
    getPolygonOffsetCount() {
        return this.options.altitude > 0 ? 0 : 2;
    }
    buildMesh(e) {
        const {features: t, center: n} = this._getFeaturesToRender();
        if (!t.length) return;
        const i = this._showHideUpdated;
        this._meshCenter = n;
        const r = this._groupPolygonFeatures(t), s = ee({}, bl), o = r.map(((t, i) => this.createMesh(this.painter, _l, s, t, e && e[i], n)));
        this._isCreatingMesh = !0, Promise.all(o).then((e => {
            this.meshes && this.painter.deleteMesh(this.meshes), e = function(e) {
                const t = [];
                for (let n = 0; n < e.length; n++) Array.isArray(e[n]) ? t.push(...e[n]) : t.push(e[n]);
                return t;
            }(e);
            const t = [], n = [];
            for (let i = 0; i < e.length; i++) {
                const r = e[i] && e[i].meshes;
                if (r) {
                    t.push(...r);
                    for (let e = 0; e < r.length; e++) r[e].feaGroupIndex = i, r[e].geometry.properties.originElements = r[e].geometry.properties.elements.slice(), 
                    1 === i && (r[e].transparent = !0);
                    n[i] = e[i].atlas;
                }
            }
            this.meshes = t, this.atlas = n, i && (this._showHideUpdated = i), this._isCreatingMesh = !1, 
            this.setToRedraw(), this.layer.fire("buildmesh");
        }));
    }
    getRayCastData(e, t) {
        const n = this.painter.getRayCastData(e, t);
        if (!n || !n.feature) return null;
        const i = n.feature[pi];
        return this._geometries[i];
    }
    _groupPolygonFeatures(e) {
        const t = [], n = [];
        for (let i = 0; i < e.length; i++) {
            const r = e[i];
            r.properties && r.properties._symbol_polygonOpacity < 1 ? n.push(r) : t.push(r);
        }
        return [ t, n ];
    }
    createPainter() {
        const e = Et.get3DPainterClass("fill"), t = this.painterSymbol = ee({}, bl);
        this._defineSymbolBloom(t, e.getBloomSymbol(), "enablePolygonBloom");
        return new e(this.regl || this.device, this.layer, t, this.layer.options.sceneConfig, 0);
    }
    updateMesh(e) {
        return this._updateMesh(e, this.meshes, this.atlas, this._meshCenter, this.painter, _l, bl, this._groupPolygonFeatures);
    }
}

function Tl(e, t, n, i, r, s, o) {
    const a = n && Array.isArray(n[0]);
    for (let s = 0, l = n.length; s < l; s++) {
        e[t] = (a ? n[s][0] : n[s].x) * i, e[t + 1] = (a ? n[s][1] : n[s].y) * i, o !== Float32Array && (e[t] = Math.round(e[t]), 
        e[t + 1] = Math.round(e[t + 1]));
        let l = r || 0;
        Array.isArray(r) && (l = r[s]), l = l ? Math.round(i * l) : 0, e[t + 2] = l, t += 3;
    }
    return e.trySetLength && e.trySetLength(t), t;
}

function wl(e, t, n, i) {
    const r = e[3 * t], s = e[3 * t + 1], o = e[3 * n], a = e[3 * n + 1];
    return r === o && (r < 0 || r > i) || s === a && (s < 0 || s > i);
}

vl.registerRenderer("gl", Al), vl.registerRenderer("gpu", Al), vl.registerRenderer("canvas", null);

const Sl = Math.PI / 180, Ml = 6378137 * Math.PI / 180, Pl = 85.0511287798;

function Il(e, t, n) {
    return function(e, t) {
        const n = Pl, i = t[0], r = Math.max(Math.min(n, t[1]), -n);
        let s;
        s = 0 === r ? 0 : Math.log(Math.tan((90 + r) * Sl / 2)) / Sl;
        return e[0] = i * Ml, e[1] = s * Ml, e;
    }(e, t);
}

function Cl(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p) {
    0 === e ? function(e, t, n, i, r, s, o, a, l, h) {
        const c = 1 / (100 * s[0]), u = 1 / (100 * s[1]), f = h && h[0] || 0, d = h && h[1] || 0, p = [ 0, 0 ];
        for (let r = e; r < t; r += 3) {
            const e = r / 3 * 2, t = i[r] - f, s = i[r + 1] - d;
            n[e] = p[0] + t / o * c / a, n[e + 1] = p[1] - s / o * u / l;
        }
    }(t, n, i, r, 0, o, a, l, h, p) : 1 === e && function(e, t, n, i, r, s, o, a, l, h, c) {
        if (!e) return;
        let u, f, d, p;
        0 === e[4] ? (u = e[0], f = e[1], d = e[2], p = e[3]) : (u = e[1], f = e[2], d = e[3], 
        p = e[0]);
        const g = H.distance(u, f), m = H.distance(f, d), y = [], x = [], _ = [];
        for (let e = t; e < n; e += 3) {
            const t = e / 3 * 2, n = (s.x / l + r[e] / o) * a, d = s.y / l * a + (c ? r[e + 1] : -r[e + 1]) / o * a;
            H.set(y, n, d), "EPSG:4326" !== h && "EPSG:4490" !== h || Il(y, y), kl(x, y, u, f), 
            kl(_, y, p, u), i[t] = H.distance(u, x) / g, i[t + 1] = H.distance(u, _) / m;
        }
    }(c, t, n, i, r, s, a, u, f, d, !!p);
}

function kl(e, t, n, i) {
    const r = n[0] - i[0], s = n[1] - i[1];
    let o = (t[0] - n[0]) * (n[0] - i[0]) + (t[1] - n[1]) * (n[1] - i[1]);
    return o /= r * r + s * s, e[0] = n[0] + o * r, e[1] = n[1] + o * s, e;
}

function Fl(e, t, n, i, r) {
    const s = 3 * t[n - 1], o = 3 * t[n - 1] + 1, a = e[s], l = e[o];
    return h = i, c = r, u = a, f = l, Math.sqrt((u - h) * (u - h) + (f - c) * (f - c));
    var h, c, u, f;
}

const {PackUtil: Ol, ArrayPool: Rl} = q();

function El(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p, g, m) {
    const y = t.getLength(), x = r / 3;
    for (let n = 2, i = y; n < i; n += 3) e[r + n - 2] = t[n - 2], e[r + n - 1] = t[n - 1], 
    e[r + n - 0] = t[n] - o;
    r += y;
    for (let n = 2, i = y; n < i; n += 3) e[r + n - 2] = t[n - 2], e[r + n - 1] = t[n - 1], 
    e[r + n - 0] = t[n] - a;
    r += y, e.trySetLength(r + y), e.copyWithin(r, r - 2 * y, r - y), r += y, e.trySetLength(r + y), 
    e.copyWithin(r, r - 2 * y, r - y), r += y, (n = n || []).push(y / 3);
    const _ = n.getLength();
    for (let t = 0; t < _; t++) {
        Dl(x + (n[t - 1] || 0), x + n[t], e, y / 3, l, i, h, c, u, f, s, d, p, g, m);
    }
    return r;
}

function Dl(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p) {
    const g = s.getLength();
    let m, y;
    for (let o = e, a = t; o < a - 1; o++) if (m = o, y = o + 1, r === 1 / 0 || !wl(n, m, y, r)) if ((o - e) % 2 == 1 && (m += 2 * i, 
    y += 2 * i), p) {
        let e = s.currentIndex;
        s[e++] = m + i, s[e++] = y, s[e++] = m, s[e++] = y + i, s[e++] = y, s[e++] = m + i, 
        s.currentIndex = e;
    } else {
        let e = s.currentIndex;
        s[e++] = m + i, s[e++] = m, s[e++] = y, s[e++] = y, s[e++] = y + i, s[e++] = m + i, 
        s.currentIndex = e;
    }
    o && function(e, t, n, i, r, s, o, a, l, h, c, u) {
        let f, d = 0, p = 0, g = 0, m = 0;
        const y = u ? [ 1, 3, 4 ] : [ 2, 3, 4 ];
        for (let u = s.getLength() - 1; u >= o; u--) {
            const o = s[u], x = 3 * o + 1, _ = 3 * o + 2, v = r[3 * o], b = r[x], A = r[_];
            d || p || (d = Math.max(r[_], r[3 * s[u - 3] + 2]), p = Math.min(r[_], r[3 * s[u - 3] + 2]), 
            f = d - p);
            let T = g;
            const w = u % 6;
            0 === e ? (5 === w && (m = Fl(r, s, u, v, b)), T = w === y[0] || w === y[1] || w === y[2] ? g : g + m) : 1 === e && (w === y[0] || w === y[1] || w === y[2] ? T = 0 : 5 === w ? (m = Fl(r, s, u, v, b), 
            T = m) : T = m);
            const S = T / h * (1 / (100 * c)) / a;
            let M;
            M = 1 === t ? A === d ? 1 : 0 : "bottom" === n ? A === d ? f / 100 / l : 0 : A === d ? 0 : -f / 100 / l, 
            i[2 * o] = S, i[2 * o + 1] = M, 0 === w && (g += m);
        }
    }(a, l, h, c, n, s, g, u[0], u[1], f, d, p);
}

function Ll(e) {
    const t = [ e[0] ];
    let n = e[0];
    for (let i = 1; i < e.length; i++) Array.isArray(e[i]) ? e[i][0] === n[0] && e[i][1] === n[1] && e[i][2] === n[2] || t.push(e[i]) : e[i].x === n.x && e[i].y === n.y && e[i].z === n.z || t.push(e[i]), 
    n = e[i];
    return t;
}

const {StyleUtil: Hl, PackUtil: zl, ArrayPool: Nl} = q(), Vl = Nl.getInstance();

function Bl(e, t, n, i, r, s, o, a, l, h, c, u, f, d, p, g) {
    void 0 === t.top && (t.top = !0), void 0 === t.side && (t.side = !0), Vl.reset();
    const {altitudeScale: m, altitudeProperty: y, defaultAltitude: x, heightProperty: _, minHeightProperty: v, defaultHeight: b, tangent: A, uv: T, topUVMode: w, sideUVMode: S, sideVerticalUVMode: M, top: P, side: I, textureYOrigin: C, topThickness: R} = t, E = !!g, D = function(e, t, {altitudeScale: n, altitudeProperty: i, defaultAltitude: r, heightProperty: s, minHeightProperty: o, defaultHeight: a}, {center: l, side: h, top: c, topThickness: u, uvOrigin: f, uv: d, uvSize: p, topUVMode: g, sideUVMode: m, sideVerticalUVMode: y, textureYOrigin: x, tileRatio: _, centimeterToPoint: v, verticalCentimeterToPoint: b, positionType: A, res: T, glScale: w, projectionCode: S}, M, P) {
        let I = t / e[0].extent;
        t === 1 / 0 && (I = 1);
        const C = t === 1 / 0, k = P.get(), F = P.get(), O = P.get(), R = P.getProxy(), E = P.get(), D = P.get(), L = P.get(), H = !!d, z = !!c, N = !!h, B = H ? P.get() : null;
        function U(e, n, i, r, s, o) {
            let a = n;
            if (z) {
                const h = V(R, i, 3);
                if (0 === h.length) return n;
                let c = R.getLength(), d = E.currentIndex;
                for (let e = 0; e < c; e++) E[d++] = R[e];
                if (E.currentIndex = d, n += R.getLength(), o) for (let t = 2, n = h.length; t < n; t += 3) h[t] += e / 3, 
                h[t - 1] += e / 3, h[t - 2] += e / 3; else {
                    let t;
                    for (let n = 2, i = h.length; n < i; n += 3) t = h[n - 1], h[n - 1] = h[n] + e / 3, 
                    h[n] = t + e / 3, h[n - 2] += e / 3;
                }
                c = h.length, d = D.currentIndex;
                for (let e = 0; e < c; e++) D[d++] = h[e];
                D.currentIndex = d, H && Cl(g || 0, e, n, B, E, f, v, _, p[0], p[1], s, T, w, S, l), 
                u > 0 && !N && (n = El(E, R, i, D, n, B, 0, u, t, H, m || 0, y || 0, x, p, _, b, r < 0 ? !o : o)), 
                L.setLength(n / 3), L.fill(1, a / 3, n / 3);
            }
            if (N) {
                z && (u = 0), a = n, n = El(E, R, i, D, n, B, u, r, t, H, m || 0, y || 0, x, p, _, b, r < 0 ? !o : o), 
                L.setLength(n / 3);
                const e = R.getLength() / 3;
                L.fill(1, a / 3, a / 3 + e), L.fill(0, a / 3 + e, a / 3 + 2 * e), L.fill(1, a / 3 + 2 * e, a / 3 + 3 * e), 
                L.fill(0, a / 3 + 3 * e, n / 3);
            }
            return n;
        }
        let G = -1 / 0, j = 1 / 0, W = 0;
        const X = [ -1, -1, t + 1, t + 1 ];
        let Y = 0, q = e.length;
        ne(M) && (Y = M, q = M + 1);
        let Z = 0, $ = !1;
        const J = P.getProxy();
        let K, Q = !1;
        for (;Y < q; Y++) {
            const l = e[Y], h = l.id;
            ne(h) && (Math.abs(h) > Z && (Z = Math.abs(h)), h < 0 && ($ = !0));
            const c = l.geometry, u = l.properties[Oe];
            let f = Array.isArray(u && u[0] && u[0][0]) ? u[0] : u;
            const {altitude: d, height: p} = Ol.getFeaAltitudeAndHeight(l, n, i, r, s, a, o);
            p < 0 ? (Q = !0, j = Math.min(d, j), G = Math.max(d - p, G)) : (G = Math.max(d, G), 
            j = Math.min(d - p, j));
            const g = E.getLength();
            let m = 0, y = W;
            J.setLength(0), R.setLength(0);
            const x = Ol.calculateSignedArea(c[0]) < 0;
            for (let e = 0, n = c.length; e < n; e++) {
                let i = c[e];
                x && (i = i.reverse()), i = Ll(i);
                const r = Ol.calculateSignedArea(i) < 0;
                if (!r && e > 0 && (m++, f = u && u[m], W = U(y, W, J, p * I, f, C), R.setLength(0), 
                J.setLength(0), y = W), t !== 1 / 0 && (i = Ol.clipPolygon(i, X)), !i.length) {
                    e === n - 1 && (W = U(y, W, J, p * I, f, C));
                    continue;
                }
                const s = i.length;
                if (Array.isArray(i[0]) ? i[0][0] === i[s - 1][0] && i[0][1] === i[s - 1][1] || i.push([ i[0][0], i[0][1] ]) : i[0].x === i[s - 1].x && i[0].y === i[s - 1].y || i.push(i[0]), 
                r) {
                    let e = J.currentIndex;
                    J[e++] = R.getLength() / 3, J.currentIndex = e;
                }
                Tl(R, R.getLength(), i, I, d, 0, A), e === n - 1 && (W = U(y, W, J, p * I, f, C));
            }
            const _ = E.getLength() - g, v = (Ce + "").trim();
            for (let e = 0; e < _ / 3; e++) {
                let e = F.currentIndex;
                F[e++] = void 0 === l[v] ? Y : l[v], F.currentIndex = e, e = k.currentIndex, k[e++] = Y, 
                k.currentIndex = e, ne(h) && (e = O.currentIndex, O[e++] = h, O.currentIndex = e);
            }
        }
        K = l ? Float32Array : Ol.getUnsignedArrayType(F.getLength() ? F[F.getLength() - 1] : 0);
        const ee = {
            hasNegativeHeight: Q,
            maxAltitude: G === -1 / 0 ? 0 : G,
            minAltitude: j === 1 / 0 ? 0 : j,
            vertices: E,
            verticeTypes: L,
            indices: D,
            pickingIds: Rl.createTypedArray(F, K),
            featureIndexes: k
        };
        if (O.getLength()) {
            const e = $ ? Ol.getPosArrayType(Z) : Ol.getUnsignedArrayType(Z);
            ee.featureIds = Rl.createTypedArray(O, e);
        } else ee.featureIds = [];
        return B && (B.setLength(E.getLength() / 3 * 2), ee.uvs = B), ee;
    }(e, n, {
        altitudeScale: m,
        altitudeProperty: y,
        defaultAltitude: x || 0,
        heightProperty: _,
        minHeightProperty: v,
        defaultHeight: b || 0
    }, {
        center: g,
        top: P,
        side: I,
        topThickness: 10 * R || 0,
        uv: T || A,
        uvSize: [ r, r ],
        uvOrigin: i,
        topUVMode: w,
        sideUVMode: S,
        sideVerticalUVMode: M,
        textureYOrigin: C,
        tileRatio: a,
        centimeterToPoint: l,
        verticalCentimeterToPoint: h,
        positionType: p,
        res: s,
        glScale: o,
        projectionCode: f
    }, d, Vl), L = [], H = D.vertices.getLength() / 3, j = zl.getIndexArrayType(H), W = Nl.createTypedArray(D.indices, j);
    delete D.indices, L.push(W.buffer, D.pickingIds.buffer);
    const X = Math.max(Math.abs(D.maxAltitude), Math.abs(D.minAltitude)), Y = p || zl.getPosArrayType(Math.max(512, X));
    D.vertices = Nl.createTypedArray(D.vertices, Y);
    const q = A ? Vl.getProxy() : new Float32Array(3 * H);
    q.setLength && q.setLength(3 * H);
    const Z = B(D.vertices, W, q);
    let $ = !0;
    const J = Z.getLength ? Z.getLength() : Z.length;
    for (let e = 0; e < J; e++) {
        E || (Z[e] = -Z[e]);
        const t = Z[e] % 1;
        1 - Math.abs(t) > 1e-6 ? $ = !1 : 0 !== t && (Z[e] = Math.round(Z[e]));
    }
    if (D.normals = Z, A) {
        let e = Vl.get();
        e.setLength(4 * H), e = U(D.vertices, D.normals, D.uvs, W, e), e = function(e, t) {
            const n = t.getLength(), i = new Float32Array(n), r = [], s = [], o = [];
            for (let a = 0; a < n; a += 4) {
                const n = a / 4 * 3;
                z.set(s, e[n] || 0, e[n + 1] || 0, e[n + 2] || 0), N.set(r, t[a] || 0, t[a + 1] || 0, t[a + 2] || 0, t[a + 3] || 0), 
                G(o, s, r), N.copy(i.subarray(a, a + 4), o);
            }
            return i;
        }(D.normals, e), D.tangents = e, L.push(e.buffer), delete D.normals;
    }
    if (D.normals && ($ && (D.normals = Nl.createTypedArray(D.normals, Int8Array)), 
    L.push(D.normals.buffer)), D.uvs) {
        const e = D.uvs;
        D.uvs = Nl.createTypedArray(e, Float32Array), L.push(D.uvs.buffer);
    }
    if (g) {
        const e = D.vertices, t = e.length;
        for (let n = 0; n < t; n += 3) e[n] -= g[0], e[n + 1] -= g[1];
    }
    const K = function(e, t, n, i) {
        const r = {}, s = {}, o = i.getLength();
        if (ae(t.polygonFill)) {
            let a = O(t.polygonFill);
            const l = new Uint8Array(4 * o);
            l.fill(255);
            for (let t = 0; t < o; t++) {
                const s = e[i[t]], o = s.properties || {};
                o.$layer = s.layer, o.$type = s.type;
                let h = a(n, o);
                k(h) && (r.aColor = 1, a = O(h), h = a(n, o)), delete o.$layer, delete o.$type, 
                Hl.normalizeColor(Ul, h), l[4 * t] = Ul[0], l[4 * t + 1] = Ul[1], l[4 * t + 2] = Ul[2], 
                l[4 * t + 3] = Ul[3];
            }
            s.aColor = l;
        }
        if (ae(t.polygonOpacity)) {
            let a = F(t.polygonOpacity);
            const l = new Uint8Array(o);
            l.fill(255);
            for (let t = 0; t < o; t++) {
                const s = e[i[t]], o = s.properties || {};
                o.$layer = s.layer, o.$type = s.type;
                let h = a(n, o);
                k(h) && (r.aOpacity = 1, a = O(h), h = a(n, o)), delete o.$layer, delete o.$type, 
                l[t] = 255 * h;
            }
            s.aOpacity = l;
        }
        return s.dynamicAttributes = r, s;
    }(e, c, u, D.featureIndexes), Q = function(e, t, n, i, r) {
        const s = [ [], [] ], o = ae(i.topPolygonFill), a = ae(i.bottomPolygonFill), l = [ 255, 255, 255, 255 ], h = t.getLength();
        if (o || a) {
            let c = o && O(i.topPolygonFill), u = a && O(i.bottomPolygonFill), f = null, d = null, p = null, g = null;
            for (let i = 0; i < h; i++) {
                if (1 === e[i] && !o || 0 === e[i] && !a) continue;
                const h = 1 === e[i];
                if (h && t[i] === f) {
                    e[i] = p;
                    continue;
                }
                if (!h && t[i] === d) {
                    e[i] = g;
                    continue;
                }
                const m = n[t[i]], y = m.properties || {};
                y.$layer = m.layer, y.$type = m.type;
                let x = h ? c : u, _ = x(r, y);
                k(_) && (x = O(_), _ = x(r, y)), delete y.$layer, delete y.$type, Hl.normalizeColor(Ul, _), 
                N.divide(Ul, Ul, l);
                let v = Gl(s, Ul);
                v < 0 && (v = s.length, s.push(N.copy([], Ul))), e[i] = v, h ? (f = t[i], p = v) : (d = t[i], 
                g = v);
            }
        }
        return s.slice(2);
    }(D.verticeTypes, D.featureIndexes, e, c, u), ee = {
        data: {
            data: {
                aVertexColorType: Q.length <= 252 ? Nl.createTypedArray(D.verticeTypes, Uint8Array) : Nl.createTypedArray(D.verticeTypes, Uint16Array),
                aPosition: D.vertices,
                aNormal: D.normals,
                aTexCoord0: D.uvs,
                aTangent: D.tangents,
                aPickingId: D.pickingIds
            },
            indices: W,
            properties: {
                maxAltitude: D.maxAltitude / 100,
                minAltitude: D.minAltitude / 100,
                hasNegativeHeight: D.hasNegativeHeight
            },
            dynamicAttributes: K.dynamicAttributes,
            vertexColors: Q
        },
        buffers: L
    };
    return D.featureIds.length ? (ee.data.featureIds = D.featureIds, L.push(ee.data.featureIds.buffer)) : ee.data.featureIds = [], 
    K.aColor && (ee.data.data.aColor = K.aColor, ee.buffers.push(K.aColor.buffer)), 
    K.aOpacity && (ee.data.data.aOpacity = K.aOpacity, ee.buffers.push(K.aOpacity.buffer)), 
    ee.buffers.push(ee.data.data.aPosition.buffer), ee.data.pickingIdIndiceMap = zl.generatePickingIndiceIndex(ee.data.data.aPickingId, ee.data.indices), 
    ee;
}

const Ul = [];

function Gl(e, t) {
    for (let n = 0; n < e.length; n++) if (N.exactEquals(t, e[n])) return n;
    return -1;
}

q();

class jl {
    constructor(e = [], t = Wl) {
        if (this.data = e, this.length = this.data.length, this.compare = t, this.length > 0) for (let e = (this.length >> 1) - 1; e >= 0; e--) this._down(e);
    }
    push(e) {
        this.data.push(e), this.length++, this._up(this.length - 1);
    }
    pop() {
        if (0 === this.length) return;
        const e = this.data[0], t = this.data.pop();
        return this.length--, this.length > 0 && (this.data[0] = t, this._down(0)), e;
    }
    peek() {
        return this.data[0];
    }
    _up(e) {
        const {data: t, compare: n} = this, i = t[e];
        for (;e > 0; ) {
            const r = e - 1 >> 1, s = t[r];
            if (n(i, s) >= 0) break;
            t[e] = s, e = r;
        }
        t[e] = i;
    }
    _down(e) {
        const {data: t, compare: n} = this, i = this.length >> 1, r = t[e];
        for (;e < i; ) {
            let i = 1 + (e << 1), s = t[i];
            const o = i + 1;
            if (o < this.length && n(t[o], s) < 0 && (i = o, s = t[o]), n(s, r) >= 0) break;
            t[e] = s, e = i;
        }
        t[e] = r;
    }
}

function Wl(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}

var Xl = {
    exports: {}
}, Yl = function(e, t, n, i) {
    var r = e[0], s = e[1], o = !1;
    void 0 === n && (n = 0), void 0 === i && (i = t.length);
    for (var a = (i - n) / 2, l = 0, h = a - 1; l < a; h = l++) {
        var c = t[n + 2 * l + 0], u = t[n + 2 * l + 1], f = t[n + 2 * h + 0], d = t[n + 2 * h + 1];
        u > s != d > s && r < (f - c) * (s - u) / (d - u) + c && (o = !o);
    }
    return o;
}, ql = function(e, t, n, i) {
    var r = e[0], s = e[1], o = !1;
    void 0 === n && (n = 0), void 0 === i && (i = t.length);
    for (var a = i - n, l = 0, h = a - 1; l < a; h = l++) {
        var c = t[l + n][0], u = t[l + n][1], f = t[h + n][0], d = t[h + n][1];
        u > s != d > s && r < (f - c) * (s - u) / (d - u) + c && (o = !o);
    }
    return o;
};

Xl.exports = function(e, t, n, i) {
    return t.length > 0 && Array.isArray(t[0]) ? ql(e, t, n, i) : Yl(e, t, n, i);
};

var Zl = Xl.exports.nested = ql;

Xl.exports.flat = Yl;

const $l = 11102230246251565e-32, Jl = 134217729, Kl = (3 + 8 * $l) * $l;

function Ql(e, t, n, i, r) {
    let s, o, a, l, h = t[0], c = i[0], u = 0, f = 0;
    c > h == c > -h ? (s = h, h = t[++u]) : (s = c, c = i[++f]);
    let d = 0;
    if (u < e && f < n) for (c > h == c > -h ? (o = h + s, a = s - (o - h), h = t[++u]) : (o = c + s, 
    a = s - (o - c), c = i[++f]), s = o, 0 !== a && (r[d++] = a); u < e && f < n; ) c > h == c > -h ? (o = s + h, 
    l = o - s, a = s - (o - l) + (h - l), h = t[++u]) : (o = s + c, l = o - s, a = s - (o - l) + (c - l), 
    c = i[++f]), s = o, 0 !== a && (r[d++] = a);
    for (;u < e; ) o = s + h, l = o - s, a = s - (o - l) + (h - l), h = t[++u], s = o, 
    0 !== a && (r[d++] = a);
    for (;f < n; ) o = s + c, l = o - s, a = s - (o - l) + (c - l), c = i[++f], s = o, 
    0 !== a && (r[d++] = a);
    return 0 === s && 0 !== d || (r[d++] = s), d;
}

function eh(e) {
    return new Float64Array(e);
}

const th = 33306690738754716e-32, nh = 22204460492503146e-32, ih = 11093356479670487e-47, rh = eh(4), sh = eh(8), oh = eh(12), ah = eh(16), lh = eh(4);

function hh(e, t, n, i, r, s) {
    const o = (t - s) * (n - r), a = (e - r) * (i - s), l = o - a;
    if (0 === o || 0 === a || o > 0 != a > 0) return l;
    const h = Math.abs(o + a);
    return Math.abs(l) >= th * h ? l : -function(e, t, n, i, r, s, o) {
        let a, l, h, c, u, f, d, p, g, m, y, x, _, v, b, A, T, w;
        const S = e - r, M = n - r, P = t - s, I = i - s;
        v = S * I, f = Jl * S, d = f - (f - S), p = S - d, f = Jl * I, g = f - (f - I), 
        m = I - g, b = p * m - (v - d * g - p * g - d * m), A = P * M, f = Jl * P, d = f - (f - P), 
        p = P - d, f = Jl * M, g = f - (f - M), m = M - g, T = p * m - (A - d * g - p * g - d * m), 
        y = b - T, u = b - y, rh[0] = b - (y + u) + (u - T), x = v + y, u = x - v, _ = v - (x - u) + (y - u), 
        y = _ - A, u = _ - y, rh[1] = _ - (y + u) + (u - A), w = x + y, u = w - x, rh[2] = x - (w - u) + (y - u), 
        rh[3] = w;
        let C = function(e, t) {
            let n = t[0];
            for (let i = 1; i < e; i++) n += t[i];
            return n;
        }(4, rh), k = nh * o;
        if (C >= k || -C >= k) return C;
        if (u = e - S, a = e - (S + u) + (u - r), u = n - M, h = n - (M + u) + (u - r), 
        u = t - P, l = t - (P + u) + (u - s), u = i - I, c = i - (I + u) + (u - s), 0 === a && 0 === l && 0 === h && 0 === c) return C;
        if (k = ih * o + Kl * Math.abs(C), C += S * c + I * a - (P * h + M * l), C >= k || -C >= k) return C;
        v = a * I, f = Jl * a, d = f - (f - a), p = a - d, f = Jl * I, g = f - (f - I), 
        m = I - g, b = p * m - (v - d * g - p * g - d * m), A = l * M, f = Jl * l, d = f - (f - l), 
        p = l - d, f = Jl * M, g = f - (f - M), m = M - g, T = p * m - (A - d * g - p * g - d * m), 
        y = b - T, u = b - y, lh[0] = b - (y + u) + (u - T), x = v + y, u = x - v, _ = v - (x - u) + (y - u), 
        y = _ - A, u = _ - y, lh[1] = _ - (y + u) + (u - A), w = x + y, u = w - x, lh[2] = x - (w - u) + (y - u), 
        lh[3] = w;
        const F = Ql(4, rh, 4, lh, sh);
        v = S * c, f = Jl * S, d = f - (f - S), p = S - d, f = Jl * c, g = f - (f - c), 
        m = c - g, b = p * m - (v - d * g - p * g - d * m), A = P * h, f = Jl * P, d = f - (f - P), 
        p = P - d, f = Jl * h, g = f - (f - h), m = h - g, T = p * m - (A - d * g - p * g - d * m), 
        y = b - T, u = b - y, lh[0] = b - (y + u) + (u - T), x = v + y, u = x - v, _ = v - (x - u) + (y - u), 
        y = _ - A, u = _ - y, lh[1] = _ - (y + u) + (u - A), w = x + y, u = w - x, lh[2] = x - (w - u) + (y - u), 
        lh[3] = w;
        const O = Ql(F, sh, 4, lh, oh);
        v = a * c, f = Jl * a, d = f - (f - a), p = a - d, f = Jl * c, g = f - (f - c), 
        m = c - g, b = p * m - (v - d * g - p * g - d * m), A = l * h, f = Jl * l, d = f - (f - l), 
        p = l - d, f = Jl * h, g = f - (f - h), m = h - g, T = p * m - (A - d * g - p * g - d * m), 
        y = b - T, u = b - y, lh[0] = b - (y + u) + (u - T), x = v + y, u = x - v, _ = v - (x - u) + (y - u), 
        y = _ - A, u = _ - y, lh[1] = _ - (y + u) + (u - A), w = x + y, u = w - x, lh[2] = x - (w - u) + (y - u), 
        lh[3] = w;
        const R = Ql(O, oh, 4, lh, ah);
        return ah[R - 1];
    }(e, t, n, i, r, s, h);
}

function ch(e, t, n) {
    t = Math.max(0, void 0 === t ? 2 : t), n = n || 0;
    var i = function(e) {
        for (var t = e[0], n = e[0], i = e[0], r = e[0], s = 0; s < e.length; s++) {
            var o = e[s];
            o[0] < t[0] && (t = o), o[0] > i[0] && (i = o), o[1] < n[1] && (n = o), o[1] > r[1] && (r = o);
        }
        var a = [ t, n, i, r ], l = a.slice();
        for (s = 0; s < e.length; s++) Zl(e[s], a) || l.push(e[s]);
        return function(e) {
            e.sort(Ah);
            for (var t = [], n = 0; n < e.length; n++) {
                for (;t.length >= 2 && mh(t[t.length - 2], t[t.length - 1], e[n]) <= 0; ) t.pop();
                t.push(e[n]);
            }
            for (var i = [], r = e.length - 1; r >= 0; r--) {
                for (;i.length >= 2 && mh(i[i.length - 2], i[i.length - 1], e[r]) <= 0; ) i.pop();
                i.push(e[r]);
            }
            return i.pop(), t.pop(), t.concat(i);
        }(l);
    }(e), r = new j(16);
    r.toBBox = function(e) {
        return {
            minX: e[0],
            minY: e[1],
            maxX: e[0],
            maxY: e[1]
        };
    }, r.compareMinX = function(e, t) {
        return e[0] - t[0];
    }, r.compareMinY = function(e, t) {
        return e[1] - t[1];
    }, r.load(e);
    for (var s, o = [], a = 0; a < i.length; a++) {
        var l = i[a];
        r.remove(l), s = xh(l, s), o.push(s);
    }
    var h = new j(16);
    for (a = 0; a < o.length; a++) h.insert(yh(o[a]));
    for (var c = t * t, u = n * n; o.length; ) {
        var f = o.shift(), d = f.p, p = f.next.p, g = _h(d, p);
        if (!(g < u)) {
            var m = g / c;
            (l = uh(r, f.prev.p, d, p, f.next.next.p, m, h)) && Math.min(_h(l, d), _h(l, p)) <= m && (o.push(f), 
            o.push(xh(l, f)), r.remove(l), h.remove(f), h.insert(yh(f)), h.insert(yh(f.next)));
        }
    }
    f = s;
    var y = [];
    do {
        y.push(f.p), f = f.next;
    } while (f !== s);
    return y.push(f.p), y;
}

function uh(e, t, n, i, r, s, o) {
    for (var a = new jl([], fh), l = e.data; l; ) {
        for (var h = 0; h < l.children.length; h++) {
            var c = l.children[h], u = l.leaf ? vh(c, n, i) : dh(n, i, c);
            u > s || a.push({
                node: c,
                dist: u
            });
        }
        for (;a.length && !a.peek().node.children; ) {
            var f = a.pop(), d = f.node, p = vh(d, t, n), g = vh(d, i, r);
            if (f.dist < p && f.dist < g && gh(n, d, o) && gh(i, d, o)) return d;
        }
        (l = a.pop()) && (l = l.node);
    }
    return null;
}

function fh(e, t) {
    return e.dist - t.dist;
}

function dh(e, t, n) {
    if (ph(e, n) || ph(t, n)) return 0;
    var i = bh(e[0], e[1], t[0], t[1], n.minX, n.minY, n.maxX, n.minY);
    if (0 === i) return 0;
    var r = bh(e[0], e[1], t[0], t[1], n.minX, n.minY, n.minX, n.maxY);
    if (0 === r) return 0;
    var s = bh(e[0], e[1], t[0], t[1], n.maxX, n.minY, n.maxX, n.maxY);
    if (0 === s) return 0;
    var o = bh(e[0], e[1], t[0], t[1], n.minX, n.maxY, n.maxX, n.maxY);
    return 0 === o ? 0 : Math.min(i, r, s, o);
}

function ph(e, t) {
    return e[0] >= t.minX && e[0] <= t.maxX && e[1] >= t.minY && e[1] <= t.maxY;
}

function gh(e, t, n) {
    for (var i, r, s, o, a = Math.min(e[0], t[0]), l = Math.min(e[1], t[1]), h = Math.max(e[0], t[0]), c = Math.max(e[1], t[1]), u = n.search({
        minX: a,
        minY: l,
        maxX: h,
        maxY: c
    }), f = 0; f < u.length; f++) if (i = u[f].p, r = u[f].next.p, s = e, i !== (o = t) && r !== s && mh(i, r, s) > 0 != mh(i, r, o) > 0 && mh(s, o, i) > 0 != mh(s, o, r) > 0) return !1;
    return !0;
}

function mh(e, t, n) {
    return hh(e[0], e[1], t[0], t[1], n[0], n[1]);
}

function yh(e) {
    var t = e.p, n = e.next.p;
    return e.minX = Math.min(t[0], n[0]), e.minY = Math.min(t[1], n[1]), e.maxX = Math.max(t[0], n[0]), 
    e.maxY = Math.max(t[1], n[1]), e;
}

function xh(e, t) {
    var n = {
        p: e,
        prev: null,
        next: null,
        minX: 0,
        minY: 0,
        maxX: 0,
        maxY: 0
    };
    return t ? (n.next = t.next, n.prev = t, t.next.prev = n, t.next = n) : (n.prev = n, 
    n.next = n), n;
}

function _h(e, t) {
    var n = e[0] - t[0], i = e[1] - t[1];
    return n * n + i * i;
}

function vh(e, t, n) {
    var i = t[0], r = t[1], s = n[0] - i, o = n[1] - r;
    if (0 !== s || 0 !== o) {
        var a = ((e[0] - i) * s + (e[1] - r) * o) / (s * s + o * o);
        a > 1 ? (i = n[0], r = n[1]) : a > 0 && (i += s * a, r += o * a);
    }
    return (s = e[0] - i) * s + (o = e[1] - r) * o;
}

function bh(e, t, n, i, r, s, o, a) {
    var l, h, c, u, f = n - e, d = i - t, p = o - r, g = a - s, m = e - r, y = t - s, x = f * f + d * d, _ = f * p + d * g, v = p * p + g * g, b = f * m + d * y, A = p * m + g * y, T = x * v - _ * _, w = T, S = T;
    0 === T ? (h = 0, w = 1, u = A, S = v) : (u = x * A - _ * b, (h = _ * A - v * b) < 0 ? (h = 0, 
    u = A, S = v) : h > w && (h = w, u = A + _, S = v)), u < 0 ? (u = 0, -b < 0 ? h = 0 : -b > x ? h = w : (h = -b, 
    w = x)) : u > S && (u = S, -b + _ < 0 ? h = 0 : -b + _ > x ? h = w : (h = -b + _, 
    w = x));
    var M = (1 - (c = 0 === u ? 0 : u / S)) * r + c * o - ((1 - (l = 0 === h ? 0 : h / w)) * e + l * n), P = (1 - c) * s + c * a - ((1 - l) * t + l * i);
    return M * M + P * P;
}

function Ah(e, t) {
    return e[0] === t[0] ? e[1] - t[1] : e[0] - t[0];
}

const {PackUtil: Th} = q();

class wh {
    constructor(e, t) {
        this.x = e, this.y = t;
    }
    clone() {
        return new wh(this.x, this.y);
    }
    normalize() {
        const e = this.length();
        this.x /= e, this.y /= e;
    }
    negate() {
        this.x = -this.x, this.y = -this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    diff(e) {
        return new wh(this.x - e.x, this.y - e.y);
    }
    distance(e) {
        const t = this.x - e.x, n = this.y - e.y;
        return Math.sqrt(t * t + n * n);
    }
    dot(e) {
        return this.x * e.x + this.y * e.y;
    }
    equals(e) {
        return this.x === e.x && this.y === e.y;
    }
    orthogonal() {
        return new wh(this.y, -this.x);
    }
}

function Sh(e, t, n, i) {
    const r = t.x * i.y - t.y * i.x, s = n.x - e.x, o = n.y - e.y, a = (s * i.y - o * i.x) / r;
    return new wh(e.x + a * t.x, e.y + a * t.y);
}

const Mh = [], Ph = [];

function Ih(e) {
    if (ne(e[0] && e[0].x)) {
        const t = [];
        let n = 0;
        for (let i = 0; i < e.length; i++) Ph[n] ? (Ph[n][0] = e[i].x, Ph[n][1] = e[i].y) : Ph[n] = [ e[i].x, e[i].y ], 
        t.push(Ph[n]), n++;
        e = t;
    }
    try {
        const t = ch(e, 1 / 0);
        let n = [ 1 / 0, 1 / 0 ], i = [ -1 / 0, -1 / 0 ];
        for (let e = 0; e < t.length; e++) t[e][0] < n[0] && (n[0] = t[e][0]), t[e][0] > i[0] && (i[0] = t[e][0]), 
        t[e][1] < n[1] && (n[1] = t[e][1]), t[e][1] > i[1] && (i[1] = t[e][1]);
        const r = [];
        let s = [], o = 0;
        for (let e = 0; e < t.length; e++) e === t.length - 1 && t[e][0] === t[0][0] && t[e][1] === t[0][1] || (Il(r, t[e]), 
        Mh[o] ? (Mh[o].x = r[0], Mh[o].y = r[1]) : Mh[o] = new wh(r[0], r[1]), s.push(Mh[o]), 
        o++);
        Th.calculateSignedArea(s) < 0 && (s = s.reverse());
        const a = function(e) {
            let t, n = Number.MAX_VALUE;
            const i = function(e, i, r, s, o, a, l, h) {
                var c = Sh(e, i, o, a), u = Sh(r, s, o, a), f = Sh(l, h, e, i), d = Sh(l, h, r, s), p = c.distance(u) * c.distance(f);
                0 !== p && p < n && (t = [ c, f, d, u ], n = p);
            };
            var r = [];
            for (let t = 0; t < e.length; t++) r.push(e[(t + 1) % e.length].diff(e[t])), r[t].normalize();
            var s, o, a, l, h = new wh(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY), c = new wh(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
            for (let t = 0; t < e.length; t++) {
                var u = e[t];
                u.x < h.x && (h.x = u.x, s = t), u.x > c.x && (c.x = u.x, o = t), u.y < h.y && (h.y = u.y, 
                l = t), u.y > c.y && (c.y = u.y, a = t);
            }
            var f = new wh(0, -1), d = new wh(0, 1), p = new wh(-1, 0), g = new wh(1, 0);
            for (let t = 0; t < e.length; t++) {
                var m = [ Math.acos(f.dot(r[s])), Math.acos(d.dot(r[o])), Math.acos(p.dot(r[a])), Math.acos(g.dot(r[l])) ];
                switch (m.indexOf(Math.min.apply(Math, m))) {
                  case 0:
                    (d = (f = r[s].clone()).clone()).negate(), (g = (p = f.orthogonal()).clone()).negate(), 
                    s = (s + 1) % e.length;
                    break;

                  case 1:
                    (f = (d = r[o].clone()).clone()).negate(), (g = (p = f.orthogonal()).clone()).negate(), 
                    o = (o + 1) % e.length;
                    break;

                  case 2:
                    (g = (p = r[a].clone()).clone()).negate(), (d = (f = g.orthogonal()).clone()).negate(), 
                    a = (a + 1) % e.length;
                    break;

                  case 3:
                    (p = (g = r[l].clone()).clone()).negate(), (d = (f = g.orthogonal()).clone()).negate(), 
                    l = (l + 1) % e.length;
                }
                i(e[s], f, e[o], d, e[a], p, e[l], g);
            }
            return t;
        }(s);
        if (!a || 4 !== a.length) return null;
        const l = a[0].distance(a[1]), h = a[1].distance(a[2]), c = a.map((e => [ e.x, e.y ]));
        return c.push(+(h > l)), c;
    } catch (e) {
        return null;
    }
}

const Ch = [], {DEFAULT_TEX_WIDTH: kh} = q();

class Fh extends Et {
    static fromJSON(e) {
        return fl(e, "ExtrudePolygonLayer", Fh);
    }
    getPolygonOffsetCount() {
        return 0;
    }
    getPolygonOffset() {
        return 0;
    }
    onConfig(e) {
        const t = this.getRenderer();
        return t && t.onConfig(e), super.onConfig(e);
    }
    updateMaterial(e) {
        this.options.material || (this.options.material = {}), e ? ee(this.options.material, e) : this.options.material = null;
        const t = this.getRenderer();
        return t && t.updateMaterial(e), this;
    }
    updateSideMaterial(e) {
        let t = !1;
        this.options.sideMaterial || (this.options.sideMaterial = {}, t = !0), e ? ee(this.options.sideMaterial, e) : this.options.sideMaterial = null;
        const n = this.getRenderer();
        return n && (t && n._deleteSideMaterial(), n.updateSideMaterial(e)), this;
    }
    updateDataConfig(e) {
        if (!e) return this;
        this.options.dataConfig || (this.options.dataConfig = {});
        const t = JSON.parse(JSON.stringify(this.options.dataConfig));
        ee(this.options.dataConfig, e);
        const n = this.getRenderer();
        return n && n.updateDataConfig(e, t), this;
    }
}

Fh.registerJSONType("ExtrudePolygonLayer"), Fh.mergeOptions({
    cullFace: !1,
    castShadow: !0
});

const Oh = {
    polygonFill: {
        type: "identity",
        default: [ 1, 1, 1, 1 ],
        property: "_symbol_polygonFill"
    },
    polygonOpacity: {
        type: "identity",
        default: 1,
        property: "_symbol_polygonOpacity"
    },
    topPolygonFill: {
        type: "identity",
        default: [ 1, 1, 1, 1 ],
        property: "_symbol_topPolygonFill"
    },
    bottomPolygonFill: {
        type: "identity",
        default: [ 1, 1, 1, 1 ],
        property: "_symbol_bottomPolygonFill"
    }
}, Rh = {
    altitudeProperty: "height",
    minHeightProperty: "min_height",
    defaultAltitude: 20
}, Eh = e => 1 === e.properties.top;

class Dh extends Al {
    constructor(...e) {
        super(...e), this.GeometryTypes = [ a, l ];
    }
    _groupPolygonFeatures(e) {
        return [ e ];
    }
    onConfig(e) {
        this.painter && (se(e.cullFace) || this.painter.updateSceneConfig({
            cullFace: e.cullFace
        }));
    }
    updateMaterial(e) {
        this.painter && (this.painter._updateMaterial(e), this.layer.options.sideMaterial || this.sidePainter._updateMaterial(e), 
        this.setToRedraw());
    }
    _deleteSideMaterial() {
        this.sidePainter && this.sidePainter.deleteMaterial();
    }
    updateSideMaterial(e) {
        this.sidePainter && (e ? this.sidePainter._updateMaterial(e) : (this.sidePainter.deleteMaterial(), 
        this.sidePainter._updateMaterial(this.layer.options.material)), this.setToRedraw());
    }
    updateDataConfig(e, t) {
        this.painter && (this.painter.updateDataConfig(e, t), this.markRebuild());
    }
    updateBloom(e) {
        super.updateBloom(e), this.sidePainter && this._updatePainterBloom(this.sidePainter, this.sidePainterSymbol, e);
    }
    needCheckPointLineSymbols() {
        return !1;
    }
    draw(e, t) {
        return super.draw(e, t);
    }
    createPainter() {
        const e = Et.get3DPainterClass("lit");
        this.painterSymbol = ee({}, Oh), this.sidePainterSymbol = ee({}, Oh), this._defineSymbolBloom(this.painterSymbol, e.getBloomSymbol(), "enablePolygonBloom");
        const t = this.layer, n = ee({}, Rh, t.options.dataConfig || {});
        t.options.material && (this.painterSymbol.material = t.options.material), t.options.sideMaterial ? this.sidePainterSymbol.material = t.options.sideMaterial : this.sidePainterSymbol.material = t.options.material;
        const i = {
            cullFace: t.options.cullFace
        };
        Object.defineProperty(i, "castShadow", {
            enumerable: !0,
            get: () => t.options.castShadow
        }), Object.defineProperty(i, "depthMask", {
            enumerable: !0,
            get: () => t.options.depthMask
        });
        const r = ee({}, n);
        r.upsideUpTexture = !0;
        const s = new e(this.device, t, this.painterSymbol, i, 0, r);
        return this.sidePainter = new e(this.device, t, this.sidePainterSymbol, i, 0, n), 
        s;
    }
    _startFrame(...e) {
        super._startFrame(...e);
        const t = this.painter;
        this.painter = this.sidePainter, super._startFrame(...e), this.painter = t;
    }
    _renderMeshes(...e) {
        const t = e[0], n = t.sceneFilter;
        t.sceneFilter = e => (!n || n(e)) && Eh(e);
        const i = super._renderMeshes(...e);
        t.sceneFilter = e => (!n || n(e)) && Eh(e);
        const r = this.painter;
        this.painter = this.sidePainter;
        const s = t.sceneFilter = e => (!n || n(e)) && (e => 1 === e.properties.side)(e);
        return super._renderMeshes(...e), this.painter = r, t.sceneFilter = n, {
            redraw: i.redraw || s.redraw,
            drawCount: (i.drawCount || 0) + (s.drawCount || 0)
        };
    }
    createMesh(e, t, n, i, r, s) {
        const o = [];
        this._extrudeCenter = s;
        const a = this._createPackData(i, n, !0, !1), l = this._createPackData(i, n, !1, !0);
        if (a) {
            const r = this._createMesh(a, e, t, n, i, null, s);
            r.meshes[0].properties.top = 1, o.push(r);
        }
        if (l) {
            const r = this._createMesh(l, e, t, n, i, null, s);
            r.meshes[0].properties.side = 1, o.push(r);
        }
        return o;
    }
    _createPackData(e, t, n, i) {
        const r = this.getMap();
        t = Oh;
        const a = this._extrudeCenter, l = 1 / 0, c = s[r.id], u = c ? c.zoom : r.getZoom(), f = new h(0, 0), d = new o(0, 0), p = ee({}, Rh, this.layer.options.dataConfig);
        if (p.uv = !0, p.top && (p.top = n), p.side && (p.side = i), !1 === p.top && !1 === p.side) return null;
        if (!e.length) return null;
        const g = r.getGLRes(), m = r.getProjection().code, y = n ? this.painterSymbol && this.painterSymbol.material : this.sidePainterSymbol && this.sidePainterSymbol.material, x = y && y.textureWidth || kh, _ = [ it(r, 1, d, g) / 100, it(r, 1, d, g, 1) / 100 ];
        return Bl(e, p, l, f, x, r.getGLRes(), 1, 1, _, this._zScale, t, u, m, undefined, Float32Array, a);
    }
    updateMesh(e) {
        const t = e[pi];
        let n = this.features[t];
        if (!n || !this.meshes) return;
        const i = this._createPackData([ n ], this.painterSymbol, !0, !1);
        let r = 0;
        i && i.data && this._updateMeshData(this.meshes[r++], n.id, i);
        const s = this._createPackData([ n ], this.painterSymbol, !1, !0);
        s && s.data && this._updateMeshData(this.meshes[r++], n.id, s);
    }
    _convertGeo(e) {
        if (e.getProperties() || e.setProperties({}), !e.getProperties()[Oe]) {
            let t = e.getCoordinates();
            if (e instanceof l) {
                const n = [];
                for (let e = 0; e < t.length; e++) {
                    const i = t[e] && t[e][0];
                    n[e] = Ih(i);
                }
                e.getProperties()[Oe] = n;
            } else {
                (function(e) {
                    return !!e && (e instanceof c || e instanceof u || e instanceof f || e instanceof d);
                })(e) && (Ch[0] = e.getShell(), t = Ch);
                const n = Ih(t[0]);
                e.getProperties()[Oe] = n;
            }
        }
        return super._convertGeo(e);
    }
    resizeCanvas(e) {
        super.resizeCanvas(e), this.sidePainter && this.sidePainter.resize(this.canvas.width, this.canvas.height);
    }
    onRemove() {
        super.onRemove(), this.sidePainter && (this.sidePainter.delete(), delete this.sidePainter);
    }
    drawOutline(e) {
        if (super.drawOutline(e), this._outlineAll && this.sidePainter && this.sidePainter.outlineAll(e), 
        this._outlineFeatures) for (let t = 0; t < this._outlineFeatures.length; t++) this.sidePainter && this.sidePainter.outline(e, this._outlineFeatures[t]);
    }
    getShadowMeshes() {
        return this.painter ? this.painter.getShadowMeshes() : [];
    }
}

Fh.registerRenderer("gl", Dh), Fh.registerRenderer("gpu", Dh), Fh.registerRenderer("canvas", null), 
e.DrawToolLayer.setLayerClass(dl, ml, vl);

const {PackUtil: Lh, FilterUtil: Hh, SYMBOLS_NEED_REBUILD_IN_VT: zh, SYMBOLS_NEED_REBUILD_IN_VECTOR: Nh} = q();

g.ShaderLib.register("vt_position_vert", "#ifdef HAS_TERRAIN_ALTITUDE\n    attribute float aTerrainAltitude;\n#endif\nuniform float minAltitude;\nvec3 unpackVTPosition(vec2 aPosition, float aAltitude) {\n    float altitude = aAltitude;\n    #ifdef HAS_TERRAIN_ALTITUDE\n        altitude += aTerrainAltitude * 100.0;\n    #endif\n    altitude += minAltitude * 100.0;\n    return vec3(aPosition, altitude);\n}\n#ifdef HAS_ALTITUDE\n    vec3 unpackVTPosition(vec3 offset) {\n        return unpackVTPosition(aPosition + offset.xy, aAltitude + offset.z);\n    }\n    vec3 unpackVTPosition() {\n        return unpackVTPosition(aPosition, aAltitude);\n    }\n#else\n    float position_modValue = 16384.0;\n    float position_delta = 0.00001;\n    vec3 unpackVTPosition(vec3 offset) {\n        float z = aPosition.z;\n        vec2 pos = sign(aPosition.xy + position_delta) * mod(abs(aPosition.xy), position_modValue);\n        vec2 highs = floor(abs(aPosition.xy) / position_modValue);\n        float altitude = sign(z + position_delta) * (highs.x * 2.0 + highs.y) * pow(2.0, 15.0) + z;\n        return unpackVTPosition(pos + offset.xy, altitude + offset.z);\n    }\n    vec3 unpackVTPosition() {\n        return unpackVTPosition(vec3(0.0));\n    }\n#endif"), 
g.ShaderLib.register("text_render_frag", "#define SDF_PX 8.0\n#define DEVICE_PIXEL_RATIO 1.0\n#define EDGE_GAMMA 0.105 / DEVICE_PIXEL_RATIO\nuniform sampler2D glyphTex;\nuniform float textOpacity;\nuniform highp float gammaScale;\nuniform float isHalo;\nuniform highp float textHaloBlur;\n#if defined(HAS_TEXT_HALO_OPACITY) || defined(HAS_TEXT_HALO_RADIUS)\n    varying vec2 vTextHalo;\n#endif\n#ifndef HAS_TEXT_HALO_OPACITY\n    uniform float textHaloOpacity;\n#endif\n#ifndef HAS_TEXT_HALO_RADIUS\n    uniform highp float textHaloRadius;\n#endif\nvarying float vTextSize;\nvarying float vGammaScale;\n#ifdef HAS_TEXT_FILL\n    varying vec4 vTextFill;\n#else\n    uniform vec4 textFill;\n#endif\n#ifdef HAS_TEXT_HALO_FILL\n    varying vec4 vTextHaloFill;\n#else\n    uniform vec4 textHaloFill;\n#endif\nvec4 renderText(vec2 texCoord) {\n    #ifdef HAS_TEXT_FILL\n        vec4 myTextFill = vTextFill;\n    #else\n        vec4 myTextFill = textFill;\n    #endif\n    float fontScale = vTextSize / 24.0;\n    vec4 color = myTextFill;\n    highp float gamma = EDGE_GAMMA / (fontScale * gammaScale);\n    lowp float buff = 185.0 / 256.0;    bool isHaloText;\n    #ifdef HAS_HALO_ATTR\n        isHaloText = vHalo > 0.5;\n    #else\n        isHaloText = isHalo == 1.0;\n    #endif\n    if (isHaloText) {\n        #ifdef HAS_TEXT_HALO_FILL\n            vec4 haloFill = vTextHaloFill;\n        #else\n            vec4 haloFill = textHaloFill;\n        #endif\n        #ifdef HAS_TEXT_HALO_RADIUS\n            float haloRadius = vTextHalo.x;\n        #else\n            float haloRadius = textHaloRadius;\n        #endif\n        if (haloRadius == 0.0) {\n            discard;\n        }\n        color = haloFill;\n        gamma = (textHaloBlur * 1.19 / SDF_PX + EDGE_GAMMA) / (fontScale * gammaScale);\n        buff = (6.0 - haloRadius / fontScale) / SDF_PX;\n        #ifdef HAS_TEXT_HALO_OPACITY\n            float haloOpacity = vTextHalo.y / 255.0;\n        #else\n            float haloOpacity = textHaloOpacity;\n        #endif\n        color *= haloOpacity * 1.25;\n    }\n    float dist = texture2D(glyphTex, texCoord).a;\n    highp float gammaScaled = gamma * vGammaScale * 0.7;\n    float alpha = clamp(smoothstep(buff - gammaScaled, buff + gammaScaled, dist), 0.0, 1.0);\n    return color * (alpha * textOpacity);\n}"), 
g.WgslShaderLib.register("vt_position", Z), g.WgslShaderLib.register("text_render", $);

p.mat4.create();

const Vh = function(e, t) {
    const n = e.toString(), i = n.indexOf("{") + 1, r = n.substring(0, i);
    let s = `${r}\n    (` + t.toString() + ")({});\n";
    return s += "\n" + n.substring(r.length), s;
}(X, Y);

if (p.transcoders) {
    const t = e.Map.VERSION;
    if (t.indexOf("1.0.0-beta") >= 0 || t.indexOf("1.0.0-alpha") >= 0) {
        const t = p.transcoders.inject(Vh);
        e.registerWorkerAdapter("@maptalks/vt", t);
    } else e.registerWorkerAdapter("@maptalks/vt", (function() {
        return p.transcoders.inject(Vh);
    }));
} else e.registerWorkerAdapter("@maptalks/vt", Vh);

export { ma as BillBoardPainter, Ea as BillBoardPlugin, Fh as ExtrudePolygonLayer, ii as FillPainter, va as FillPlugin, Hh as FilterUtil, ka as GLTFPhongPlugin, Fa as GLTFStandardPlugin, za as GeoJSONVectorTileLayer, Oa as HeatmapPlugin, ns as IconPainter, Ta as IconPlugin, Aa as LineGradientPlugin, ai as LinePainter, ba as LinePlugin, ml as LineStringLayer, Ia as LitPlugin, La as MapboxVectorTileLayer, to as NativeLinePainter, Sa as NativeLinePlugin, Ks as NativePointPainter, Lh as PackUtil, xo as PhongPainter, Ma as PhongPlugin, dl as PointLayer, pl as PointLayerRenderer, vl as PolygonLayer, Nh as SYMBOLS_NEED_REBUILD_IN_VECTOR, zh as SYMBOLS_NEED_REBUILD_IN_VT, _a as TerrainFlatMaskPainter, Da as TerrainFlatMaskPlugin, Ys as TextPainter, wa as TextPlugin, Ca as TubePlugin, Et as Vector3DLayer, Mt as VectorTileLayer, dt as VectorTileLayerRenderer, Ra as WaterPlugin, vo as WireframePainter, Pa as WireframePlugin, q as getVectorPacker };

"undefined" != typeof console && console.log("@maptalks/vt v0.124.4");
//# sourceMappingURL=maptalks.vt.es.js.map
